/* eslint-disable no-loop-func */
import React from 'react';
import './App.css';
//import { create, all } from 'mathjs'

//import LineData from './Colas.json';
import RhymeChainData from './RhymeChains.json'
import VerbStemData from './AbbrHebrewStems.json';
import VerbFormData from './AbbrVerbForms.json';
import LexicalGroupData from './LexicalGroups.json';
import RhymeGroupData from './RhymeGroups.json';
import LexemeData from './Lexemes.json';
import HebrewCharsData from './HebrewChars.json';
import SpecialGraphsData from './SpecialGraphs.json';
import ToolsData from './Tools.json';
import ThingsToFindData from './ThingsToFind.json';
import SectionBreaksData from './SectionBreaks.json';
import DiscourseUnitsData from './DiscourseUnits.json';
import LineRelationshipsData from './LineRelationships.json';
// import LexemeAlphIDToLexemeTextData from './LexemeAlphIDToLexemeText.json';
import FigurativeSpeechTypesData from './FigurativeSpeechTypes.json';
import FiguresData from './Figures.json';

//import RootOccurrencesData from './RootOccurrences.json'
// import EnglishVersionOnlyForDevData from './EnglishVersion.json'

// import SemanticLinksData from './SemanticLinks.json';
// import SemanticNodesData from './SemanticNodes.json';

import LensesData from './Lenses.json';
import CustomSearchAdditionalOptionsData from './CustomSearchAdditionalOptions.json';

import RepetitionLinkGroupCategoriesData from './RepetitionLinkGroupCategories.json';
import RepetitionLinkGroupCategoryGroupsData from './RepetitionLinkGroupCategoryGroups.json';
//import RepetitionLinkGroupData from './RepetitionLinkGroups.json';

import SemanticRolesData from './SemanticRoles.json';
import MainSemanticDomainsData from './MainSemanticDomains.json';
import SDBHSemanticDomainsData from './SDBHSemanticDomains.json';
import CompositeSemanticDomainsData from './CompositeSemanticDomains.json';
import SemanticRelationshipGroupsData from './SemanticRelationshipGroups.json';

import SemanticOutlinesData from './SemanticOutlines.json';

import TagAttributesData from './TagAttributes.json'
import ThematicStatementsData from './ThematicStatements.json';
import ThematicStatementIDsByVerseData from './ThematicStatementIDsByVerse.json'

import TagVariablesData from './TagVariables.json';
import TagTemplatesData from './TagTemplates.json';

import BookNamesData from './BookNames.json'
import MaxChaptersByBookData from './MaxChaptersByBook.json'

import ListOfChaptersEachRootOccursInData from './ListOfChaptersEachRootOccursIn.json'
import ListOfChaptersEachThematicStatementOccursInData from './ListOfChaptersEachThematicStatementOccursIn.json'

// import ClausesData from './Clauses.json'

// import SimScoreData from './UniqueGlosses.json'

import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
//import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
//import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import { display } from '@material-ui/system';
import Button from '@material-ui/core/Button';
import { sizing } from '@material-ui/system';
import Slider from '@material-ui/core/Slider';
import Input from '@material-ui/core/Input';
import Switch from '@material-ui/core/Switch';
import Chip from '@material-ui/core/Chip';
import Popover from '@material-ui/core/Popover';
import Modal from '@material-ui/core/Modal';
// import TreeView from "@material-ui/lab/TreeView";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import TreeItem from "@material-ui/lab/TreeItem";

//import Typography from '@material-ui/core/Typography';

//import { Chart } from 'react-charts'
//import { DataSet, Network } from 'vis';
import { DataSet, Network} from 'vis-network/standalone/esm/vis-network';

// import { DataSet } from 'vis-data';
// import { Network } from 'vis-network';

import {XYPlot, XAxis, YAxis, HorizontalGridLines, VerticalGridLines, VerticalRectSeries, VerticalBarSeries, LineMarkSeries, MarkSeries, Hint, Crosshair, LineSeries, DiscreteColorLegend, HeatmapSeries} from 'react-vis';
import 'react-vis/dist/style.css';
import { RectSeries } from 'react-vis/dist';
import { EventAvailableRounded } from '@material-ui/icons';
import { version } from 'react-dom';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

//import LineTo from 'react-lineto';

//import NativeSelect from '@material-ui/core/NativeSelect';
//https://www.jointjs.com/opensource#Download-JointJS

//https://github.com/jerairrest/react-chartjs-2
//https://d3js.org/

//https://www.npmjs.com/package/react-sigma
//https://www.npmjs.com/package/react-lineto
//https://github.com/pierpo/react-archer
//const math = create(all)

class NumberRange
{
	Begin;
	End;

	constructor( _Begin, _End)
	{
		this.Begin = _Begin;
		this.End = _End;
	}

	Length()
	{
		return this.End - this.Begin + 1;
	}

	IndexInRange(nIndexToCheck)
	{
		return nIndexToCheck >= this.Begin && nIndexToCheck <= this.End;
	}
}

class Chapter extends React.Component {
  constructor(props) {
	super(props);

	this.svgBoxRef = React.createRef();
	this.divHeaderRef = React.createRef();
	this.networkDivRef = React.createRef();
	this.network = {};

    this.notesTextRef = React.createRef()

    // this.stringSimilarity = require("string-similarity")

	//this.dictGraphDataByGraphUniqueName = new Map();

	this.colorsForStems = { "q":"Blue", "Q":"Blue", "p":"Purple", "P":"Purple", "N":"Brown", 
		"h":"Green", "H":"GreenYellow", "t":"Orange" };
	this.colorsForForms = { "p":"Blue", "i":"Orange", "c":"Brown", "a":"Brown", "r":"hsl(43, 80%, 40%)", "s":"hsl(43, 80%, 40%)",
		"w":"Red", "q":"Red", "v":"Green", "j":"Green", "h":"Green"};

    this.colorsForCases = {'nominative': 'Blue', 'dative': 'Purple', 'accusative': 'Brown', 'genitive': 'Green', 'vocative': 'DarkCyan'}
    this.colorsForTenses = {'present': 'Blue', 'aorist': 'Green', 'perfect': 'Maroon', 'future': 'DarkCyan', 'imperfect': 'Purple'}
    this.colorsForVoices = {'middle': 'Green', 'middlepassive': 'Brown', 'active': 'Blue', 'passive': 'Purple'}
    this.colorsForMoods = {'imperative':"Maroon", 'participle': 'Purple', 'subjunctive': 'Green', 'infinitive': 'Brown', 'indicative': 'Blue'}


	this.colorsForPhraseFunctions = {"Pred": "Blue", "PreO": "Blue", "Subj": "Red", "Objc": "Green", 
		"Cmpl": "Purple", "P": "DarkCyan", "V": "Blue", "S": "Red", "O": "Green", "PP": "Purple", "ADV": "Maroon", "O2": "hsl(43, 80%, 40%)", "OC": "GreenYellow"};

	this.colorsForGender = { "m":"Blue", "f":"Red", "n":"Green", "c":"Gray", "b":"Gray" };
	this.colorsForNumber = { "s":"Blue", "p":"Red", "d": "Green", undefined: "Gray" };

	this.colorsForPGN = { "1ms":"Blue", "2ms":"Red", "3ms":"Brown", "1mp":"Orange", "2mp":"DarkCyan", 
		"3mp":"Green", "1fs":"Blue", "2fs":"Fuchsia", "3fs":"hsl(43, 80%, 40%)", "1fp":"Maroon",
		"2fp":"Indigo", "3fp":"DarkMagenta"};

    this.colorsForPN = {"1s":"Blue", "2s":"Fuchsia", "3s":"Maroon", "1p":"Indigo", "2p":"DarkCyan", "3p":"Green"}
        
	this.colorsForSuffixType = { "n":"Red", "h":"Blue", "d": "Green"};

	this.colorsForPhraseFunctionOrder = { "SOV":"Blue", "SVO":"CornflowerBlue", "VSO":"Green", 
		"VOS":"Red", "OVS":"Fuchsia", "OSV":"Orange", "S":"Maroon", "V":"Indigo", "O":"Black", 
		"VS":"DarkGray", "SV":"DarkCyan", "VO":"Brown", "OV":"hsl(43, 80%, 40%)", "None":"LightGray"};

	this.colorsForWordType = {N: "Red", V: "Blue", A: "Green", P: "hsl(43, 80%, 40%)", T: "Orange", D: "DarkMagenta", R: "CornflowerBlue"};
	this.colorsForPreposition = {b: "Red", k: "Purple", l: "Blue", m: "Green", et: "Orange", al: "CornflowerBlue", el: "Indigo"};

	this.colorsForFigures = {"1":"Green", "2":"Green", "3": "Red", "4": "Red", "5": "Red", "6": "Red"};
	
	this.descsForGenderAbbr = [{"Desc":"Masculine", "Abbr":"m"}, {"Desc":"Feminine", "Abbr":"f"}, {"Desc":"Common", "Abbr":"c"}, {"Desc":"Both", "Abbr":"b"}];
	this.descsForNumberAbbr = [{"Desc":"Singular", "Abbr":"s"}, {"Desc":"Plural", "Abbr":"p"}, {"Desc":"Dual", "Abbr":"d"}, {"Desc":"Undefined", "Abbr":undefined}];
    this.descsForWordType = {N: "Noun", V: "Verb", A: "Adjective", P: "Pronoun", T: "Particle", D: "Adverb", R: "Preposition"};

	this.descsForSuffixType = [{"Desc":"He", "Abbr":"h"}, {"Desc":"Nun", "Abbr":"n"}, {"Desc":"Directional", "Abbr":"d"}, {"Desc":"Possessive", "Abbr":"p"}]

    this.colorsForConstructState = {"a":"Red", "c":"Blue"}
    this.descsForConstructState = [{"Desc":"Construct", "Abbr":"c"}, {"Desc":"Absolute", "Abbr":"a"}]

	this.colorsForPGroups = {"0":"Red", "1":"Blue", "2": "hsl(43, 80%, 40%)", "3": "Green", "4": "DarkMagenta", "5": "Orange", 
		"6": "Maroon", "7":"GreenYellow", "8":"Indigo", "9": "DarkCyan", "10":"CornflowerBlue"};

	this.listLinkGroupColors =
	[ "Blue", "Red", "Fuchsia", "Green", "DarkMagenta", "DarkOrange", "Maroon", "CornflowerBlue", "Indigo", "Salmon",  
	"Brown", "hsl(43, 80%, 40%)", "Black", "Crimson", "Olive"];

	this.distinguishingColors =
	[ "Blue", "Red", "Green", "Orange", "Brown", "Gray",
	"hsl(43, 80%, 40%)", "Fuchsia", "Maroon",
	"Indigo", "DarkCyan", "DarkGray", "DarkMagenta"];

    this.listBegadkefat = ['\u05db', '\u05ea', '\u05d1', '\u05da', '\u05e3', '\u05e4', '\u05d2', '\u05d3']

    this.listRarityFactorsForRhymeForHebrew = [{'Chars': ['ע'], 'Factor': 0.03}, {'Chars': ['ד'], 'Factor': 0.13}, {'Chars': ['ח'], 'Factor': 0.17}, 
        {'Chars': ['ף', 'פ'], 'Factor': 0.25}, {'Chars': ['ק'], 'Factor': 0.26}, {'Chars': ['ץ', 'צ'], 'Factor': 0.27}, 
        {'Chars': ['ג'], 'Factor': 0.32}, {'Chars': ['ז'], 'Factor': 0.32}, {'Chars': ['ס'], 'Factor': 0.34}, {'Chars': ['ט'], 'Factor': 0.35}]

    this.listRarityFactorsForRhymeForGreek = [{'Chars': ['μ', 'Μ'], 'Factor': 0.03}, {'Chars': ['λ', 'Λ'], 'Factor': 0.05}, {'Chars': ['δ', 'Δ'], 'Factor': 0.13}, 
        {'Chars': ['γ', 'Γ'], 'Factor': 0.15}, {'Chars': ['θ', 'Θ'], 'Factor': 0.16}, 
        {'Chars': ['χ', 'Χ'], 'Factor': 0.24}, {'Chars': ['φ', 'Φ'], 'Factor': 0.25}, 
        {'Chars': ['β', 'Β'], 'Factor': 0.26}, {'Chars': ['ξ', 'Ξ'], 'Factor': 0.28}, {'Chars': ['ζ', 'Ζ'], 'Factor': 0.29}, 
        {'Chars': ['ψ', 'Ψ'], 'Factor': 0.3}]

    this.listConsonantGroupsForHebrew = [{'Name': 'א', 'ListChars': ['א']}, {'Name': 'ב', 'ListChars': ['ב']}, {'Name': 'ג', 'ListChars': ['ג']}, {'Name': 'ד', 'ListChars': ['ד']}, 
        {'Name': 'ה', 'ListChars': ['ה']}, {'Name': 'ו', 'ListChars': ['ו']}, {'Name': 'ז', 'ListChars': ['ז']}, {'Name': 'ח', 'ListChars': ['ח']}, 
        {'Name': 'ט', 'ListChars': ['ט']}, {'Name': 'י', 'ListChars': ['י']}, {'Name': 'כ', 'ListChars': ['כ', 'ך']}, {'Name': 'ל', 'ListChars': ['ל']}, 
        {'Name': 'מ', 'ListChars': ['מ', 'ם']}, {'Name': 'נ', 'ListChars': ['נ', 'ן']}, {'Name': 'ס', 'ListChars': ['ס']}, {'Name': 'ע', 'ListChars': ['ע']}, 
        {'Name': 'פ', 'ListChars': ['פ', 'ף']}, {'Name': 'צ', 'ListChars': ['צ', 'ץ']}, {'Name': 'ק', 'ListChars': ['ק']}, {'Name': 'ר', 'ListChars': ['ר']}, 
        {'Name': 'ש', 'ListChars': ['ש']}, {'Name': 'ת', 'ListChars': ['ת']}]

    this.listConsonantGroupsForGreek = [{'Name': 'ν', 'ListChars': ['ν', 'Ν']}, {'Name': 'β', 'ListChars': ['β', 'Β']}, 
        {'Name': 'γ', 'ListChars': ['γ', 'Γ']}, {'Name': 'δ', 'ListChars': ['δ', 'Δ']}, 
        {'Name': 'ζ', 'ListChars': ['ζ', 'Ζ']}, {'Name': 'θ', 'ListChars': ['θ', 'Θ']}, 
        {'Name': 'κ', 'ListChars': ['κ', 'Κ']}, {'Name': 'λ', 'ListChars': ['λ', 'Λ']}, {'Name': 'μ', 'ListChars': ['μ', 'Μ']}, {'Name': 'ξ', 'ListChars': ['ξ', 'Ξ']}, 
        {'Name': 'π', 'ListChars': ['π', 'Π']}, 
        {'Name': 'ρ', 'ListChars': ['ρ', 'Ῥ', 'Ρ', 'ῥ']}, {'Name': 'σ', 'ListChars': ['σ', 'ς', 'Σ']}, 
        {'Name': 'τ', 'ListChars': ['τ', 'Τ']}, {'Name': 'φ', 'ListChars': ['φ', 'Φ']}, 
        {'Name': 'χ', 'ListChars': ['χ', 'Χ']}, {'Name': 'ψ', 'ListChars': ['ψ', 'Ψ']}]

    this.listVowelGroupsForHebrew = [{ID: 2, Chars: ["ַ", "ָ"]}, {ID: 3, Chars: ["ֵ", "ֶ"]}, 
        {ID: 4, Chars: ["ִ"]}, {ID: 5, Chars: ["ֹ", "ֺ"]}, {ID: 6, Chars: ["ֻ", "וּ"]}] //{ID: 1, Chars: ["ְ"]}, //(sheva)

    this.listVowelGroupsForGreek = [
        {ID: 1, Chars: ['α', 'ἀ', 'ἁ', 'ἂ', 'ἃ', 'ἄ', 'ἅ', 'ἆ', 'ά', 'ᾄ', 'ὰ', 'ᾳ', 'ᾴ', 'ᾶ', 'ᾷ', 'Α', 'Ἀ', 'Ἁ', 'Ἃ', 'Ἄ', 'Ἅ', 'Ἆ']}, 
        {ID: 2, Chars: ['ε', 'ἐ', 'ὲ', 'έ', 'ἑ', 'ἓ', 'ἔ', 'ἕ', 'Ε', 'Ἐ', 'Ἑ', 'Ἓ', 'Ἔ', 'Ἕ', 'η', 'ή', 'ἠ', 'ἡ', 'ἢ', 'ἣ', 'ἤ', 'ἥ', 'ἦ', 'ἧ', 'ὴ', 'ῃ', 'ῄ', 'ῆ', 'ῇ', 'ᾐ', 'ᾑ', 'ᾔ', 'ᾖ', 'ᾗ', 'Η', 'Ἠ', 'Ἢ', 'Ἤ', 'Ἥ', 'Ἦ']}, 
        {ID: 3, Chars: ['ι', 'ί', 'ἰ', 'ἱ', 'ἳ', 'ἴ', 'ἵ', 'ἶ', 'ἷ', 'ὶ', 'ϊ', 'ῒ', 'ῖ', 'Ἰ', 'Ἱ', 'Ἴ', 'Ἵ', 'ΐ']}, 
        {ID: 4, Chars: ['ο', 'ό', 'ὀ', 'ὁ', 'ὂ', 'ὃ', 'ὄ', 'ὅ', 'ὸ', 'Ο', 'Ὀ', 'Ὁ', 'Ὃ', 'Ὄ', 'Ὅ', 'ω', 'ώ', 'ὠ', 'ὡ', 'ὢ', 'ὤ', 'ὥ', 'ὦ', 'ὧ', 'ὼ', 'ᾠ', 'ᾧ', 'ῳ', 'ῴ', 'ῶ', 'ῷ', 'Ω', 'Ὡ', 'Ὤ', 'Ὥ', 'Ὦ', 'Ὧ']}, 
        {ID: 5, Chars: ['υ', 'ϋ', 'ύ', 'ὐ', 'ὑ', 'ὒ', 'ὓ', 'ὔ', 'ὕ', 'ὖ', 'ὗ', 'ὺ', 'ῢ', 'ΰ', 'ῦ', 'Υ', 'Ὑ', 'Ὕ', 'Ὗ']}]

    //the 0.4 list at the end is for the visual similarity
    this.listSoundSimilarityGroupsForHebrew =[{Chars:["ח","כ"], SimilarityPercent: 0.9}, 
        {Chars:["כ","ק"], SimilarityPercent: 0.9},
        {Chars:["ח","ק"], SimilarityPercent: 0.8},
        {Chars:["א","ע"], SimilarityPercent: 0.5}, 
        {Chars:["ש","ס"], SimilarityPercent: 0.8}, 
        {Chars:["ש","ז","ס","צ"], SimilarityPercent: 0.5}, 
        {Chars:["מ","נ"], SimilarityPercent: 0.4}, 
        {Chars:["ג","כ"], SimilarityPercent: 0.6},
        {Chars:["ב","פ"], SimilarityPercent: 0.6},  
        {Chars:["ר","ל"], SimilarityPercent: 0.3}, 
        {Chars:["ת","ט"], SimilarityPercent: 0.9},
        {Chars:["ד", "ר"], SimilarityPercent: 0.2},
        {Chars:["ז", "נ"], SimilarityPercent: 0.2},
        {Chars:["מ", "ס"], SimilarityPercent: 0.2},
        {Chars:["מ", "ט"], SimilarityPercent: 0.2},
        {Chars:["ב", "כ"], SimilarityPercent: 0.2},
        {Chars:["ה", "ח"], SimilarityPercent: 0.8},
        {Chars:["", ""], SimilarityPercent: 0.2}]

    //{"Chars":['', ''], "SimilarityPercent": 0.}
    this.listSoundSimilarityGroupsForGreek = [{Chars:['φ', 'β'], SimilarityPercent: 0.4}, 
        {Chars:['π', 'β'], SimilarityPercent: 0.6}, 
        {Chars:['φ', 'π'], SimilarityPercent: 0.4}, 
        {Chars:['τ', 'δ'], SimilarityPercent: 0.6}, 
        {Chars:['τ', 'θ'], SimilarityPercent: 0.6}, 
        {Chars:['δ', 'θ'], SimilarityPercent: 0.4}, 
        {Chars:['σ', 'ζ'], SimilarityPercent: 0.6}, 
        {Chars:['σ', 'ψ'], SimilarityPercent: 0.5}, 
        {Chars:['ψ', 'ζ'], SimilarityPercent: 0.5}, 
        {Chars:['σ', 'ξ'], SimilarityPercent: 0.5}, 
        {Chars:['κ', 'γ'], SimilarityPercent: 0.6}, 
        {Chars:['κ', 'χ'], SimilarityPercent: 0.6},  
        {Chars:['κ', 'ξ'], SimilarityPercent: 0.5},  
        {Chars:['χ', 'ξ'], SimilarityPercent: 0.4}, 
        {Chars:['λ', 'ρ'], SimilarityPercent: 0.3}, 
        {Chars:['μ', 'ν'], SimilarityPercent: 0.4}]

    this.listBSGs = [{'ID': 0, 'GroupName': 'measurement'}, {'ID': 1, 'GroupName': 'existence'}, {'ID': 2, 'GroupName': 'knowledge'}, {'ID': 3, 'GroupName': 'other emotions'}, {'ID': 4, 'GroupName': 'trust'}, {'ID': 5, 'GroupName': 'love'}, {'ID': 6, 'GroupName': 'status'}, {'ID': 7, 'GroupName': 'gods'}, {'ID': 8, 'GroupName': 'wellbeing'}, {'ID': 9, 'GroupName': 'badbeing'}, {'ID': 10, 'GroupName': 'relationship'}, {'ID': 11, 'GroupName': 'creation'}, {'ID': 12, 'GroupName': 'law'}, {'ID': 13, 'GroupName': 'worship'}, {'ID': 14, 'GroupName': 'leader'}, {'ID': 15, 
    'GroupName': 'habitation'}, {'ID': 16, 'GroupName': 'living_thing'}, {'ID': 17, 'GroupName': 'body'}, {'ID': 18, 'GroupName': 'communication'}]

    this.listGlossStopwords = [',', '.', '?', '!', "'", ':', ';', '"', '”', '’', '’', '»', '“', '‘', '-', 'mark of the accusative',
        'i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 
        'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 
        'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 
        'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 
        'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 
        'of', 'at', 'by', 'for', 'with', 'about', 'between', 'into', 'through', 
        //'during', 'before', 'after', 'above', 'below', 
        'to', 'from', 'in', 'out', 'on',
        'own', 'same', 'so', 'than', 'too', 's', 't',  'don', "don't", 'should', "should've",
        'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 
        'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 
        'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

    // this.dictTagOptionIndexByKey = {'0': 0,'1': 1,'2': 2,'3': 3,'4': 4,'5': 5,'6': 6,'7': 7,'8': 8,'9': 9, 
    // 'a': 10,'b': 11,'d': 12,'e': 13,'g': 14,'h': 15,'j': 16,'k': 17,'l': 18,'o': 19,'p': 20,'q': 21,'r': 22,
    // 's': 23,'t': 24,'u': 25,'v': 26,'x': 27,'y': 28,'z': 29,'{': 30,'|': 31,'}': 32,'~': 33}

    // this.dictTagOptionIndexByKeyReverse = {'0': '0','1': '1','2': '2','3': '3','4': '4','5': '5','6': '6','7': '7','8': '8','9': '9',
    // '10': 'a','11': 'b','12': 'd','13': 'e','14': 'g','15': 'h','16': 'j','17': 'k','18': 'l','19': 'o','20': 'p','21': 'q','22': 'r',
    // '23': 's','24': 't','25': 'u','26': 'v','27': 'x','28': 'y','29': 'z','30': '{','31': '|','32': '}','33': '~'}

    // i "much/greatly/intensely", f "forever", m "must/should/necessary/command",  -"continually"
    //this.dictSearchAndTagAttributeNameByID = {'n': 'negative', '-': 'continually', 'w': 'wish', 'i': 'much/intensely', 'f': 'forever', 'm': 'must/should/command'}

    this.listRhymeChains = []
    this.listRepetitionLinkGroupCategories = [];
    this.listRepetitionLinkGroupCategoryGroups = [];
    this.listMainSemanticDomains = [];
    this.listSDBH = [];
    this.listCompositeSemanticDomains = [];
    this.listSemanticRelationshipGroups = [];
    this.listSemanticOutlines = [];
	this.listTagVariables = [];
	this.listTagTemplates = [];
	this.listCorrespondencesForChapter = [];
	this.listSemanticRoles = [];
	this.listUserAddedSemanticNodes = [];
	this.listCustomSearchAdditionalOptions = [];
	
    this.listThematicStatements = []
    this.listThematicStatementIDsByVerse = []

    this.listTagAttributes = []
    this.dictTagAttributesByID = new Map()
    this.dictTagAttributesByShortcut = new Map()

    this.listBSBTextByVerse = []
    this.dictBSBTextByVerseByID = new Map()
    this.dictBSBTextSortOrderByVerseByID = new Map()
    this.listSemanticGroupsForSearchAndTag = []
    
	//this.listAllTextWords = [];
	this.listTextWordsForChapter = [];
    this.listSyllablesForChapter = []
	this.listTextWordsForAllChapters = [];
    this.dictTextForAllOTWords = new Map()
    this.textWordsByChapter = []
    this.listLinesForAllChapters = []
	this.dictLinesByChapter = new Map();
	this.listClauses = [];
	this.listClausesForAllChapters = [];
	this.listRepetitionGroups = [];
	this.listRepetitionGroupClusters = [];
	this.listRepetitionGroupClusterGroups = []
    this.listLevel4Groups = []
	this.listWordLinkGroups = [];
	this.listLineLinkGroups = [];
	this.listTranslationsImported = [];

    this.listAllVersesForEnglishVersionOnlyForDev = []
    this.listVersesForEnglishVersionOnlyForDevForCurrentBook = []

    //this.listRootOccurrencesData = []
    
	this.listVerseBeginNumbersAndWords = [];
	this.listVerseEndIndexes = [];
	this.listSentenceEndIndexes = [];
	this.listPhraseEndIndexes = [];
	this.listHebrewVerbStems = [];
	this.listHebrewVerbForms = [];
	this.listRhymeGroups = [];
	this.listLexicalGroups = [];
	this.listHebrewChars = [];
	this.listLexemes = [];
	this.listThingsToFind = [];	
	this.listSpecialGraphs = [];	
	this.listTools = [];	
	this.listSectionBreaks = [];
	this.listLineRelationships = [];
	// this.listLexemeAlphIDToLexemeText = [];
	this.listFigurativeSpeechTypes = [];
	this.listSemanticLinks = [];
	this.listSemanticLinkTypes = [];

    this.dictBookNamesByIndex = new Map();
    this.listMaxChaptersByBook = [];

    //this.listClauseData = []
    
	this.nColaSplitToolID = "1";
	this.nColaMergeToolID = "2";
	this.nColaIndentToolID = "11";
	this.nColaUnindentToolID = "12";
	this.nParallelPartToolID = "4";
	this.nLineRelationshipsToolID = "13";
	this.nMarkComparisonsToolID = "5";
	this.nMarkFigurativeLanguageToolID = "9";
	this.nMarkEllipsesToolID = "8";
	this.nMarkCorrespondencesWithinLineGroupsToolID = "10";
	this.nWordLinkToolID = "14";
	this.nLineLinkToolID = "15";
    this.nRepetitionLinkGroupToolID = "20";
	this.nSemanticRolesToolID = "21";
	this.nSemanticCategoryToolID = "22";
    this.nThematicStatementsToolID = "30"
    this.nSearchAndTagToolID = "32"
    this.nSearchTaggedDataToolID = "34"
    this.nLinkTranslationToolID = "40"
    this.nMainWordInTranslationLinkGroupsToolID = "41"
    this.nMainPrepositionWordInTranslationLinkGroupsToolID = "42"
    this.nMainSuffixWordInTranslationLinkGroupsToolID = "43"

	this.nSpecialGraphIDForNetwork = "19";
	this.blnColorChartLegendStickyHover = false;
	this.nSpacesPerLineIndent = 5;
    this.nYPixelsBetweenTreeNodes = 25;

	this.blnIsIOSSafari = false;
	
	this.blnDevView = false;
	this.blnPopulateAllChaptersAtLoad = false;
	this.blnSemanticLinksDebugView = false;
	this.listForSemanticDebugging = [];

    this.listSimScoreDataForChapter = [];
    this.listRootCooccurrenceDataForChapter = []
    this.listAllSimilarityPairsForChapter = []
    this.listAllSimilarityLinePairsForChapter = []
    this.listAllSimilarityStanzaPairsForChapter = []

    this.listAllSimilaritiesByWordComparedToHoveredWord = []

    this.regexTakeOutGlossSeparator = /\^/g;

    this.blnChapterIsHebrew = true

    this.sNewTagBeingTyped = ''
    this.nStartNumberForTagSearchAndSelect = 5

    this.listMaybeAttributeWords = ['if', 'no', 'not', 'never', 'forever', 'ever', 'because', 'that', 'so', 'always', 'continually', 
            'like', 'when', 'then', 'after', 'before', 'until', 'for', 'must', 'should', 'necessary', 'need', 'therefore', 'much', 'greatly', 
            'since', 'how', 'all', 'every', 'everyone', 'everything', 'everywhere', 'may', 'maybe', 'perhaps', 'possibly', 'could',
            'able', 'unable', 'can', 'cannot', "can't", "according", "instead", "but", 'although', 'nevertheless', 'yet', 'with', 'nothing', 
            'stop', 'cease', 'end']

    this.listBasicMaybeAttributeWords = ['no', 'not', 'never', 'forever', 'ever', 'nothing', 'cannot', "can't"]
            
    this.canvasRef = React.createRef()
    this.listDevelopmentDiagramBoundingBoxesForLines = []
    this.listDevelopmentDiagramBoundingBoxesForColorKey = []
    this.listDevelopmentDiagramLink1 = null
    this.nDevelopmentDiagramLineIndexBeingEdited = -1
    this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = -1
    this.blnClearDevelopmentDiagramRepetitionGroup = false
    this.nXOffsetForDevelopmentDiagram = 25
    this.nYOffsetForDevelopmentDiagram = 70
    this.listViewsToHideLensesForInDiagramMode = ['sound', 'lexical']

    this.blnPopulateBSBTextByVerse = false
    this.blnPopulateAllRepetitionGroups = false

    this.dictListOfChaptersEachRootOccursIn = new Map()
    this.dictListOfChaptersEachThematicStatementOccursIn = new Map()

    this.nTranslationWordIndexDraggedFrom = -1

    this.listTopSoundGroupsWordsSyllableIndexesAndColors = []
    this.listAllSoundGroupsForSoundGroupByUnitHeatmap = []
    this.listTopGroupsWordsAndColors = []
    this.listAllGroupsWords = []

    this.dictLinksPerWord = new Map()
    this.dictClosestDistanceFromLastWordInSameLinkGroupsPerWord = new Map()
    this.listWordsStartingLinkGroups = []
    
    this.blnShowSuperscriptionCheckbox = true
    this.blnAutomaticallySetGroupLinesByWhenChapterChanges = true //this should probably usually be set to true

    this.nTaskPopoverWidth = 400
    this.nTaskPopoverHeight = 45

    this.taskPopoverPosition = {
        top: 30, // window.innerHeight / 2 - this.nTaskPopoverHeight,
        left: window.innerWidth / 2 - this.nTaskPopoverWidth / 2,
    }

	this.state = {
		dictRefs: new Map(),		

		nCurrentBook: 19,
        listCurrentChapters: [1],
        blnMultipleChaptersSelected: false,

        blnBoldAccentedSyllables: true,
        blnShowAccentOnLastSyllable: false,

        blnEachRepetitionGroupShouldHaveRepeatedRoots: false,
        
        listOurTranslationLines: [],
        sFromNotesBox: '',
        sFromRepetitionLinkGroupNotesBox: '',

        sSelectedView: "composite", //all, composite, sound, lexical, semantic
		sViewBy: 'Development', //'Development', //'Line', //'Verse', //'Line', //'SemanticTree', //'Line', //Clause
		
        listDevelopmentDiagramBoxes: [],
        listDevelopmentDiagramBoxGroups: [],
        listDevelopmentDiagramBoxesBeingMoved: [],
        listDevelopmentDiagramLines: [],
        listDevelopmentDiagramLinkGroups: [], //{Chapter: "1", LineIndex1: 1, WordIndex1: 1, LineIndex2: 2, WordIndex2: 1}],
        listDevelopmentDiagramLinkGroupLengths: [],
        listDevelopmentRepetitionGroupsByChapter: [],
        listDevelopmentRepetitionDescsForGroupsByChapter: [],
        nDevelopmentDiagramColorKeyGroupIDBeingEdited: -1,
        nDevelopmentDiagramColorKeyGroupIDBeingHovered: -1,
        blnColorLinesByDevelopmentRepetitionGroup: false,
        blnLookForReverseSoundSequencesInDiagram: false, 
        dictMainWordInTranslationLinkGroupsByTextIndex: new Map(), 
        dictMainPrepositionWordInTranslationLinkGroupsByTextIndex: new Map(), 
        dictMainSuffixWordInTranslationLinkGroupsByTextIndex: new Map(),

        nYDistanceBetweenLines: 15,
        blnShowAlignmentAndSizeControls: false,
        nLeftTextAlignmentOffset: 0,
        nLeftChartAlignmentOffset: 0,
        nChartWidthOffset: 0,
        blnShowChartYAxis: false,
        blnShowLineChartWhenSoundGroupLensIsEnabled: false,

        oHoveredObjectForSoundGroupByUnitChart: null,
        blnHoveredObjectForSoundGroupByUnitChartIsStickied: false,

        blnConnectionsPresentationMode: false,
        blnColorIndividualSyllablesForRepetitionLinkGroups: false,
        sDefaultNoHoveredModeForDevelopmentDiagram: 'nolinks', //'onelineperlinkgroup', //'unittounit', 'onelineperlinkgroup'
        nMinDevelopmentDiagramLinkGroupLengthToShow: 2,
        nMaxDevelopmentDiagramLinkGroupLengthToShow: 10000,
        nMaxDevelopmentDiagramLinesAwayFromHoveredToShowForSound: 4,
        nMaxLinesAwayForDefaultNoHoveredMode: 1,
        oLensToColorTextBy: null,
        blnShowLinksForLensThatIsColoredBy: true,
        sModeForShowOnlyLinksAtLineEdges: 'modeisoff',

        oDevelopmentDiagramHoveredObject: null,
        blnAddingLinksToDevelopmentDiagramEnabled: false,
        sDevelopmentDiagramLanguage: "translation",
        oDevelopmentDiagramBoxGroupSelectedToCompareWith: null,
        sShowLinksFromHoveredWhat: 'word',  //line, group, word
        sWhichUnitToCompareWith: 'alllinksfromhovered', 
        sShowInternalLinkGroups: 'both', //externalonly, internalonly, both

        nIndexOfSemanticGroupShowing: 0,
        blnEditingSemanticGroups: false,
        nTopNThresholdForGroupByUnitHeatmap: 2,
        sGroupLinesByForGroupByUnitHeatmap: 'Line',
        blnExcludeSuperscriptionFromLenses: true,

        nRepetitionGroupIndexInChapterForCurrentConnectionsGroup: -1,
        sCommentForCurrentConnectionsGroup: '',
        sDefaultCommentForCurrentConnectionsGroup: '',
        listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroup: [],
        blnConnectionIsContrastForCurrentConnectionsGroup: false,
        blnConnectionsPresentationCommentEditMode: true,

        sGroupLinesBy: 'StartsCluster', //repetitiongroup
        sGroupLinesByForLens: 'Line', //'StartsRepetitionGroup', 'Line'
        sIntraOrInterUnitsLensScope: 'both',

        blnShowSubunitBreaksInDevelopmentDiagram: true,

        // listLinkGroupTypesToShowForCompositeView: [
        //     {Abbr: 'Sem', Help: 'Show semantic links', Value: 'semantic', Sticky: true, Enabled: false}, 
        //     {Abbr: 'P', Help: 'Show links for attached prepositions', Value: 'prepositions', Sticky: true, Enabled: false}, 
        //     {Abbr: 'Sfx', Help: 'Show links for suffixes', Value: 'suffixes', Sticky: true, Enabled: false},
        //     {Abbr: 'Snd', Help: 'Show sound links', Value: 'sound', Sticky: false, Enabled: false},
        //     {Abbr: 'Rhy', Help: 'Color syllables/words by how many syllables are between the primary stressed syllables on either side of it', Value: 'rhythm', Sticky: true, Enabled: false}],

        listCurrentSearchAndTagMatchResults: [],
        listThematicStatementsSelectedForSearch: [],
        nMaxDistanceInVersesBetweenMultipleTagsSearched: 0,
        listSemanticGroupsForSearchAndTagSelectedForTagging: [],
        listTagsForMatchesInSemanticGroups: [],
        listTagInventory: [],
        nCurrentTagIDForSearchAndTag: -1,
        nSearchAndTagResultsCurrentBatchIndex: 0,
        nSearchAndTagResultsBatchSize: 8,
        listSearchAndTagMatchIndexesWithContext: [],
        nCurrentlyHoveredSearchAndTagMatchIndex: -1,
        nTagIndexBeingEditedForCurrentSearchAndTag: 0,
        nSearchAndTagVerseContextVersesBeforeAndAfter: 4,
        sSearchAndTagInventoryFilter: '',
        blnAddTagBoxHasFocus: false,
        blnEditTagBoxHasFocus: false,
        blnShowTagEditingControls: false,
        sTagEditingControlsDescFilter: '',
        listTagsSelectedForSearch: [],
        blnHighlightMaybeAttributeWordsInSearchAndTag: false,
        blnHighlightBasicMaybeAttributeWordsInSearchAndTag: false,
        sSearchAndTagMatchFilterByLemma: '',
        blnCurrentlyHoveredSearchAndTagMatchIndexInOriginalText: false,
        blnNewTagInputIsVisible: false,
        blnOnlyUseTagInventoryForCurrentSemanticGroup: false,
        listSelectedSemanticGroupsForTagInventory: [],
        nTagShortcutBatchNumber: 0,
        nTagShortcutBatchSize: 5,
        nMaxCurrentTypingMatchesForResultsToBeShown: 50,
        blnEnableTaggingWholeBatchPage: true,

        blnShowTranslationEditBox: false,
        blnTranslationEditBoxHasFocus: false,
        blnEditThemeNameHasFocus: false,
        blnTaskSearchAutocompleteHasFocus: false,

        nSemanticChainsLensCurrentBatch: 0,
        nSemanticChainsLensBatchSize: 1000,

        // sSearchAndTagText: '',
        // nMaxDistanceInVersesBetweenMultipleSearchAndTagsSearched: 0,

		listDiscourseUnits: [],
		listUnitSimilaritiesToCurrentUnit: [],	  
		blnShowWordSimilarity: false,
		blnShowLineSimilarity: false,
		sLinkReportObjectType: "",
		sLinkReportConstraint: "",
		nMinSimilarityScore: 0,
		nMaxSimilarityScore: 0,
		nSimilarityScoreRange: 0,    
		nMaxWhitenessForSimilarityHighlightingNoMatch: 92,
		nMaxWhitenessForSimilarityHighlightingMatch: 80,
		nRangeOfWhitenessForSimilarityHighlighting: 75,  //min whiteness = 80 - 65
		nUnitSimilarityTopPercentOfComparisonsToKeep: 1.0,
        
        nHeatMapXInterval: 0.01,
        nHeatMapXMaxWordDistanceThreshold: 1,

		listLines: [],
		listPropositions: [],
		listWordLinkGroups: [],
        listLineLinkGroups: [],
        listWordLinkPairs: [],
		listFigures: [],
        listWordsOverride: [],
        listRepetitionLinkGroups: [],
		listTranslations: [],
		
		listWordTags: [],
		currentWordTag: undefined,
		currentWordTagIsSticky: false,

		blnDragWordsInSamePhraseTogether: false,
		//nCurrentPGroupForMarking: undefined,
		sHintText: '',
		hintLocation: {},
		sGraphUniqueNameCurrentlyShowingHint: '',

        oForWordDotChartPopup: {},
        hintLocationForWordDotChart: {},
        sWordDotChartUniqueNameCurrentlyShowingHint: '',

        blnSemanticChainChartPopupIsVisible: false, 
        nCurrentSeriesIDForSemanticChainChartPopup: -1,
        hintLocationForSemanticChainChart: {}, 
        sSemanticChainChartPopupText: '', 

        listWordGroupsForLensesByChapter: [],

        // blnRestrictTextToRepetitionGroupsWithOutlinedWords: false,
        listLockedLinesToShow: [],

        blnShowLineCharts: false,
        blnShowWordDotChart: false,
        blnShowUnitRelationshipCharts: false,
        blnSortLineChartsBy: 'AxisText', //ClosenessToRange, NumberOfOccurrences
        sVerseRangesToHighlight: '',
        blnRestrictTextToVerseRangesToHighlight: false,
        sVerticalBreakLinesToShowInLineCharts: 'somegroups', //'verses',
        blnBinAndSortWordGroupsForLineCharts: false,
        blnShowGlossesInChartPopup: false,
        blnShowGapsInBarChartBetweenSubunits: true,
        blnFilterSoundGroupsByUnitBySameSoundInConsecutiveLineGroups: true,

        blnShowBSBInHoverInfo: false,
        blnListOfChaptersEachRootOccursInInHoverInfo: false,

        blnPatternLineChartPopupIsVisible: false,
        sForPatternLineChartPopup: '',
        oCurrentGroupIDForPatternLineChartPopup: undefined,
        hintLocationForPatternLineChart: {},

        blnRepeatedRootLineChartPopupIsVisible: false,
        oCurrentGroupIDForRepeatedRootLineChartPopup: undefined,
        hintLocationForRepeatedRootLineChart: {},
        sForRepeatedRootLineChartPopup: '',
        
        blnLetterLineChartPopupIsVisible: false,
        hintLocationForLetterLineChart: {},
        sForLetterLineChartPopup: '',
        oCurrentGroupIDForLetterLineChartPopup: undefined,
        
        blnCadenceChartPopupIsVisible: false,
        hintLocationForCadenceChart: {},
        sCadenceChartPopup: '',
        listShowVerseDivisionsInBarChart: false,
        blnShowAverageLineInBarChart: false,
        
		listQueries: [],	
		sQueryGroupCooccurrenceRequirement: "",
		sGraphCode: undefined,
        sColorBy: "", //
        sWordLinkToolType: "?",
		nSelectedToolID: "0", // "0", //"20", //"0", //"32", // "32", //"0",
		nSelectedSpecialGraphID: null, //"19", //null,

		blnOptionsPopoverIsOpen: false,
		anchorForOptionsPopover: null,
		blnHintPopoverIsOpen: false,
		anchorForWordHintPopover: null,

        blnTaskPopoverIsOpen: false,
        
		anchorForCorrespondenceCategorySelectionPopover: null,
		blnCorrespondenceCategorySelectionPopoverIsOpen: false,
		
        blnAboutPopoverIsOpen: false,
        anchorForAboutPopover: null,

		blnShowHint: true,
		// blnBreakAfterRepetitionGroupEnd: true,
		blnShowSVGLineLinks: false,
		blnShowVerseNumbers: true,
		blnShowTranslation: true,
		blnShowSyllableCounts: false,
		blnShowPGroupOrder: true,
        blnShowLineCheckboxes: false,
        
        blnShowHebrew: true,
        blnShowInterlinear: false,
        blnShowOurTranslation: true,
        blnShowEnglishVersion: false,
        blnShowBSB: true,
        blnShowTransliteration: false,
        blnShowThematicStatementsInline: false,

        blnDoChainFilter: true,
        nChainCutoffValue: 2,
        blnShowRepetitionLinkGroupLengthsDuringEditing: false,
        
        blnSyllableRhymeOnlyWhenBothAtWordBeginningOrEnd: true,
        sLocationRestrictionForSyllableRhyme: 'all', //'accented', 'mostfrequent',
        blnOnlyLookAtPreviousSyllablesForRhyme: false,

		blnFigurativeLanguageCheckboxes: true,
		blnShowLineRelationships: false,
		blnShowCorrelationStats: false,
		blnStickyHeader: true,
		blnGlobalDistributionForQueries: false,
		blnShowRepetitionLinkGroupCommentBox: false,
		blnShowSemanticSearchAutocomplete: false,

        blnShowDataDownloadButtons: false,

        blnHideEverything: false,

		nSelectedFigurativeSpeechTypeID: 0,

		listGraphDataAndSettings: [],		
		listGraphTextIndicesToHighlight: [],
		listColorChartData: [],

		blnShowNetwork: false,
		networkMode: "semanticnode",
		listNetworkConnectionsToShow: ["syn", "sameparticipant"], //["sem", "syn", "phon", "pgrp"],
		blnTranslateNetworkNodes: true,
		sNetworkDivHeight: "500px", //"1000px",
		listSemanticNodesForNetworkGraph: undefined,
		nMinSameConsonantsForNetworkPhonoLink: 4,
		nMaxLinkDistanceForNetworkSemanticLink: 2,
		sSDBHDomainTypeForNetwork: "c",

        //sSimilarityCalculationsToUse: '',
        blnShiftDown: false,
        blnControlDown: false,
        blnAltDown: false,
        blnZDown: false,
        blnSDown: false,
        blnADown: false,
        blnDDown: false,
        blnWDown: false,
		listWordsDraggedFrom: undefined,
        listWordsHoveredWhileDragging: undefined,

        nCurrentRepetitionLinkGroupCategory: undefined,
        //currentRepetitionLinkGroup: undefined,
        listCurrentRepetitionLinkGroups: undefined,
        nCurrentRepetitionLinkGroupSelectedIndex: 0,
        currentRepetitionLinkGroupIsSticky: false,
        lineClickedOnForRepetitionGroupLink: undefined,
        nCurrentLinkGroupType: 20, //5, //12, //2, //10, //1,
        blnSyllableModeForRepetitionLinkGroupTool: false,
        blnConnectionIsContrast: false,
        blnConnectionIsAttachedPreposition: false,
        blnConnectionIsPronominalSuffix: false,
		nCurrentLinkGroupTagID: undefined,
		listCorrespondenceCategoriesToShowInLens: undefined,

        currentWordForHoverLens: undefined,
        listCurrentStickiedWordsForHoverLens: [],
        listWordGroupsForCurrentHoverTypeLens: [],

        currentSyllableForHoverLens: undefined,
        listCurrentStickiedSyllablesForHoverLens: [],
        
        listSelectedWordGroupsInLineChart: [],

        listWordGroupsForEnabledLenses: [],
        listLenses: [],
        listRecentLenses: [],
        nMaxRecentLensesToShow: 5,

        blnBreakLinkGroupsIntoChains: false,
        blnDoNotColorFirstWordInChain: false,
        nMaxLinesApartForChains: 1,

        sLensHoverCombineMode: 'any',
        sAllButOneTheSameConstraint: 'contiguous',
        blnShowLenses: true,
        nLensVisibilityGroupShowing: 0,
        nLensVisibilityGroupSize: 20,
		blnColorCorrespondenceLensByMainType: false,

        blnBreakLinesByWordsMatchingLenses: false,

        nPatternLensWordGroupsToShowColorsForIndex: 0,

        listLineIndexesBeingEditedForOurTranslation: [],

        listAllSimilarityScoreThreshold: 2,
        
		listSelectedOptionsForSemanticSearch: [],
		listSemanticRolesToShowInSemanticRoleMode: [],

        blnShowGeneralTags: false,
        semanticOutlineNodes: [],
        listTags: [],
        currentHoveredSubtag: undefined,
		listSubtagsCurrentlyBeingAssociatedToWords: [],
		listWordsPossiblyMappingToCurrentSubtags: [],
        blnTreeModeForTags: true,
        listTagTrees: [],
        listTagRelationships: [],
		listSemanticOutlineVariables: [],
		listSemanticStatementTemplates: [],

		listSemanticNodes: [],
        blnColorByItemIsSticky: false,
        blnEllipsisMode: false,

        blnShowGlossesInsteadOfTranslation: true,
        
        blnTextUnitSideBySideMode: false,
        blnSubunitBreaksInSideBySideMode: true,

        nMaxTextIndexDistanceForRhymeMaximumAmountCalcs: 7,

		listInfoShow: '',
        listInfoShowTextIsEnglish: false,

		sDomInfoForWord: '',
		hoveredWordRect: null,
		isLoading: false,
		error: null,
	};
  }

  componentDidMount() {
	this.setState({ isLoading: true });

	if(window.location.pathname.includes("devmode")) this.blnDevView = true;
	if(window.location.hostname.includes("localhost"))
    {
        if(this.blnPopulateBSBTextByVerse && window.location.hostname.includes("localhost"))
        {
            fetch("BSBTextByVerse.json")
            .then(res => res.json())
            .then(data => 
            {
                var listPunctuationWithNoSpaceBefore = [",", ".", "?", "!", "'", ":", ";", "\u{201d}", "‘", "»", "\u{2019}"]
                var listPunctuationWithNoSpaceAfter = ["\u{201c}", "\u{201b}"]
                
                this.listBSBTextByVerse = data.Verses
                this.listBSBTextByVerse.forEach(o => {
                    o.VerseRef = o.Book + ' ' + o.Chapter + ':' + o.Verse
                    o.SpaceAfterWord = o.Words.map((sw,nw,arrw) => nw === arrw.length - 1 ? false : 
                        listPunctuationWithNoSpaceAfter.includes(sw) ? false : 
                        !listPunctuationWithNoSpaceBefore.includes(arrw[nw+1]))
                })

                this.dictBSBTextByVerseByID = new Map()
                for(var o of this.listBSBTextByVerse)
                    this.dictBSBTextByVerseByID.set(o.ID, o)

                this.dictBSBTextSortOrderByVerseByID = new Map()
                for(const [o, n] of this.listBSBTextByVerse.entries())
                    this.dictBSBTextSortOrderByVerseByID.set(o.SortID, n)

                fetch("SemanticGroupsForSearchAndTag.json")
                .then(res => res.json())
                .then(data => 
                {
                    this.listSemanticGroupsForSearchAndTag = data.SemanticGroups

                    //{"ID": 63, "Desc": ""}
                    //{SemanticGroupID: 1, TagList: [63]}
                    
                    var listLocallyStoredMatchTags = this.LoadMatchTags()

                    //this is if necessaryfor modifying the structure while keeping the current data
                    //listLocallyStoredMatchTags.forEach(matchtag => matchtag.Tags.forEach(t => t.Attributes = []))
                    //{"SemanticGroupID":4,"MatchID":"Genesis_1_22_22","Tags":[{"ID":1,"Attributes":["n","b"]},{"ID":1,"Attributes":["-"]}
                    //{"SemanticGroupID":4,"MatchID":"Genesis_1s_22_22","Tags":[{"ID":1,"Attributes":[]},{"ID":1,"Attributes":[]}
                    //console.log(listLocallyStoredMatchTags.filter(o => o.SemanticGroupID === 4 && o.MatchID === 'Genesis_1_22_22'))

                    var listLocallyStoredTagInventory = this.LoadTagInventory()
                    
                    //listLocallyStoredTagInventory.forEach(o => o.ID = o.NewID)
                    //this.SaveTagInventory(listLocallyStoredTagInventory)

                    //console.log(listLocallyStoredTagInventory)
                    //localStorage.setItem("listTagInventoryBySemanticGroupID", null)

                    // {"SemanticGroupID":52,"TagList":[{"ID":1,"Desc":"trusting/believing in God","Shortcut":"1"}
                    //{"NewID": 1, "OldID":1, "SemanticGroupID":52, "Desc":"trusting/believing in God","Shortcut":"1"}

                    // var testChange = .flatMap(o => 
                    //     o.TagList.flatMap(t => ({NewID: 0, OldID: t.ID, SemanticGroupID: o.SemanticGroupID, Desc: t.Desc, Shortcut: t.Shortcut}))
                    // )
                    // testChange.forEach((o,n) => o.NewID = n + 1)

                    // listLocallyStoredMatchTags.forEach(matchtag => matchtag.Tags.forEach(t => {
                    //     var nOldID = t.OldID

                    //     if(nOldID === 0)
                    //     {}
                    //     else
                    //     {
                    //         var matched = listLocallyStoredTagInventory.find(tc => 
                    //             tc.SemanticGroupID === matchtag.SemanticGroupID && tc.OldID === nOldID)

                    //         if(matched === undefined)
                    //         {
                    //             console.log(matchtag, nOldID)
                    //         }
                    //         else
                    //         {
                    //             t.OldID = nOldID
                    //             t.ID = matched.NewID
                    //         }
                    //     }
                    // }))

                    // console.log(listLocallyStoredMatchTags.filter(matchtag => matchtag.Tags.some(t =>
                    //     listLocallyStoredTagInventory.find(tc => tc.SemanticGroupID === matchtag.SemanticGroupID && tc.OldID === t.OldID) === undefined
                    // )))

                    var listTaggedMatchObjectsForNewSemanticGroups = []
                    for(const g of this.listSemanticGroupsForSearchAndTag)
                    {
                        for(const m of g.Matches)
                        {
                            if(!listLocallyStoredMatchTags.some(o => o.SemanticGroupID === g.ID && o.MatchID === m.ID))
                            {
                                listTaggedMatchObjectsForNewSemanticGroups.push({SemanticGroupID: g.ID, MatchID: m.ID, Tags: [{ID: 0, Attributes: []}]})   
                            }
                        }
                    }

                    this.setState({listTagInventory: listLocallyStoredTagInventory})
                    this.setState({listTagsForMatchesInSemanticGroups: listLocallyStoredMatchTags.concat(listTaggedMatchObjectsForNewSemanticGroups)})


                    //console.log(listTaggedMatchObjectsForNewSemanticGroups)
                    //this.listSearchDataForWholeBible = data.DataByVerse

                    // var listPunctuationWithNoSpaceBefore = [",", ".", "?", "!", "'", ":", ";", "\u{201d}", "‘", "»", "\u{2019}"]
                    // var listPunctuationWithNoSpaceAfter = ["\u{201c}", "\u{201b}"]
                    // var listPunctuationWithSpacesOnBothSides = ["-", "\u{2014}"]

                    // this.listSearchDataForWholeBible.forEach(o => {
                    //     o.BookAndChapter = o.VerseRef.split(':')[0]
                    //     o.Text = '' //o.Words.join(' ')

                    //     var blnPreviousWordWasPunctuationWithNoSpaceAfter = false
                    //     for (var nWordIndex = 0; nWordIndex < o.Words.length; nWordIndex++)
                    //     {
                    //         var sWordToAdd = ''
                    //         var word = o.Words[nWordIndex]
                    //         var blnIsPunctuationWithNoSpaceAfter = listPunctuationWithNoSpaceAfter.includes(word)
                    //         if(blnIsPunctuationWithNoSpaceAfter || listPunctuationWithNoSpaceBefore.includes(word) || listPunctuationWithSpacesOnBothSides.includes(word))
                    //         {
                    //             sWordToAdd = (nWordIndex == 0 || !blnIsPunctuationWithNoSpaceAfter ? "" : " ") + word
                    //             blnPreviousWordWasPunctuationWithNoSpaceAfter = blnIsPunctuationWithNoSpaceAfter
                    //         }
                    //         else
                    //         {
                    //             sWordToAdd = (nWordIndex == 0 || blnPreviousWordWasPunctuationWithNoSpaceAfter ? "" : " ") + word
                    //             blnPreviousWordWasPunctuationWithNoSpaceAfter = false
                    //         }
                            
                    //         //sWordToAdd.foregroundColor = listWordIndicesToHighlight.includes(nWordIndex) ? .red : .white
                    //         o.Text += sWordToAdd
                    //     }
                    // })
                })
            })
        }

        //this.blnPopulateAllChaptersAtLoad = true;
    }

	var userAgent = navigator.userAgent;
	//this.blnIsIOSSafari = userAgent.indexOf("Safari") > -1;
	this.isIOSSafari = /iPhone|iPad|iPod/.test(userAgent) && /AppleWebKit.*Safari\//i.test(userAgent) && userAgent.indexOf('Chrome') === -1
    
    var RhymeChainDataObjects = RhymeChainData
	var VerbStemDataObjects = VerbStemData;
	var VerbFormDataObjects = VerbFormData;
	var LexicalGroupDataObjects = LexicalGroupData;
	var RhymeGroupDataObjects = RhymeGroupData;
	var LexemeDataObjects = LexemeData;
	var HebrewCharsDataObjects = HebrewCharsData;
	var SpecialGraphsDataObjects = SpecialGraphsData;
	var ThingsToFindDataObjects = ThingsToFindData;
	var SectionBreaksDataObjects = SectionBreaksData;
	var ToolsDataObjects = ToolsData;
	var DiscourseUnitsDataObjects = DiscourseUnitsData;
	var LineRelationshipsDataObjects = LineRelationshipsData;
	// var LexemeAlphIDToLexemeTextDataObjects = LexemeAlphIDToLexemeTextData;  //eventually, merge these mappings into text data table or lexemes data
	var FigurativeSpeechTypesDataObjects = FigurativeSpeechTypesData;
	var FiguresDataObjects = FiguresData;
	// var SemanticNodesDataObjects = SemanticNodesData;
	// var SemanticLinksDataObjects = SemanticLinksData;
    var LensesDataObjects = LensesData;
    var RepetitionLinkGroupCategoriesDataObjects = RepetitionLinkGroupCategoriesData;
    var RepetitionLinkGroupCategoryGroupsDataObjects = RepetitionLinkGroupCategoryGroupsData;
    var MainSemanticDomainsDataObjects = MainSemanticDomainsData;
    var SDBHSemanticDomainsDataObjects = SDBHSemanticDomainsData;
    var CompositeSemanticDomainsDataObjects = CompositeSemanticDomainsData;
    var SemanticRelationshipGroupsDataObjects = SemanticRelationshipGroupsData;
    var SemanticOutlinesDataObjects = SemanticOutlinesData;
	var TagVariablesDataObjects = TagVariablesData;
	var TagTemplatesDataObjects = TagTemplatesData;
	var SemanticRolesDataObjects = SemanticRolesData;
	var CustomSearchAdditionalOptionsDataObjects = CustomSearchAdditionalOptionsData;

    var ThematicStatementsDataObjects = ThematicStatementsData
    var ThematicStatementIDsByVerseDataObjects = ThematicStatementIDsByVerseData

    var TagAttributesDataObjects = TagAttributesData

    var BookNamesDataObjects = BookNamesData
    this.dictBookNamesByIndex = new Map()
    for(var o of BookNamesDataObjects.Books)
        this.dictBookNamesByIndex.set(o.ID, o.Name)

    var MaxChaptersByBookDataObjects = MaxChaptersByBookData
    this.listMaxChaptersByBook = MaxChaptersByBookDataObjects.MaxChaptersByBook

    this.dictListOfChaptersEachRootOccursIn = new Map(Object.entries(ListOfChaptersEachRootOccursInData))
    this.dictListOfChaptersEachThematicStatementOccursIn = new Map(Object.entries(ListOfChaptersEachThematicStatementOccursInData))
    
    this.listRepetitionGroupsForAllChapters = []
    if(window.location.hostname.includes("localhost"))
    {
        if(this.blnPopulateAllRepetitionGroups)
        {
            let nBook = 19
            for(var nChapter = 1; nChapter <= this.listMaxChaptersByBook.find(mxc => mxc.Book === nBook).MaxChapter; nChapter++)
            {
                this.listRepetitionGroupsForAllChapters = this.listRepetitionGroupsForAllChapters.concat(this.LoadRepetitionLinkGroupsByChapter(nBook, nChapter))
            }
        }
    }

    //var ClausesDataObjects = ClausesData
    //this.listClauseData = ClausesDataObjects.Data

    // var SimScoreDataObjects = SimScoreData
    // this.listSimScoreDataForChapter = SimScoreDataObjects.Data

    // var EnglishTranslationsDataObjects = EnglishTranslationsData;
	// this.SaveTranslations(EnglishTranslationsData.EnglishTranslations);

    // var RepetitionLinkGroupDataObjects = RepetitionLinkGroupData;
    // var list = RepetitionLinkGroupDataObjects.RepetitionLinkGroups;
    //this.setState({listRepetitionLinkGroups: RepetitionLinkGroupDataObjects.RepetitionLinkGroups});

	// ThingsToFindDataObjects.ThingsToFind.sort(
	// 	(a, b) => a.ToolID != undefined && b.ToolID === undefined ? -1 : 
	// 	a.ToolID === undefined && b.ToolID != undefined ? 1 : a.Desc > b.Desc);

	SpecialGraphsDataObjects.SpecialGraphs.sort((a, b) => a.Desc.localeCompare(b.Desc));
	ThingsToFindDataObjects.ThingsToFind.sort((a, b) => a.Desc.localeCompare(b.Desc));
	ToolsDataObjects.Tools.sort((a, b) => a.ToolID - b.ToolID);

	//sorting by ParentLevel is so that the hierarchy can be processed (and the positions can be 
	//calculated) starting from leaves ending at the highest level
	for(var discourseUnit of DiscourseUnitsDataObjects.DiscourseUnits)
	{
		discourseUnit["ParentLevel"] = this.GetParentLevel(discourseUnit);
	}
	DiscourseUnitsDataObjects.DiscourseUnits.sort((a, b) => parseInt(a.ParentLevel) - parseInt(b.ParentLevel));

    this.listRhymeChains = RhymeChainDataObjects.Data
	this.listHebrewVerbStems = VerbStemDataObjects.AbbrHebrewStems;
	this.listHebrewVerbForms = VerbFormDataObjects.AbbrVerbForms;
	this.listLexicalGroups = LexicalGroupDataObjects.LexicalGroups;
	this.listRhymeGroups = RhymeGroupDataObjects.RhymeGroups;
	this.listLexemes = LexemeDataObjects.Lexemes;
	this.listHebrewChars = HebrewCharsDataObjects.HebrewChars;
	this.listThingsToFind = ThingsToFindDataObjects.ThingsToFind;
	this.listSpecialGraphs = SpecialGraphsDataObjects.SpecialGraphs;
    this.listTools = ToolsDataObjects.Tools;
    this.listRepetitionLinkGroupCategories = RepetitionLinkGroupCategoriesDataObjects.RepetitionLinkGroupCategories;
	this.listRepetitionLinkGroupCategoryGroups = RepetitionLinkGroupCategoryGroupsDataObjects.RepetitionLinkGroupCategoryGroups;
	this.listSemanticRoles = SemanticRolesDataObjects.SemanticRoles;
	this.listCustomSearchAdditionalOptions = CustomSearchAdditionalOptionsDataObjects.CustomSearchAdditionalOptions;

    this.listCompositeSemanticDomains = CompositeSemanticDomainsDataObjects.CompositeSemanticDomains;
    this.listSemanticRelationshipGroups = SemanticRelationshipGroupsDataObjects.SemanticRelationshipGroups;
    this.listSemanticOutlines = SemanticOutlinesDataObjects.SemanticOutlines;
	this.listTagVariables = TagVariablesDataObjects.TagVariables;
	this.listTagTemplates = TagTemplatesDataObjects.TagTemplates;
    
    this.listThematicStatements = ThematicStatementsDataObjects.Statements
    this.listThematicStatementIDsByVerse = ThematicStatementIDsByVerseDataObjects.Verses

	this.listRepetitionLinkGroupCategories.sort((a, b) => a.MainType < b.MainType);

    this.listMainSemanticDomains = MainSemanticDomainsDataObjects.MainSemanticDomains.map(o => ({Name: o.Name, LexicalIDs: o.Text.split(",").flatMap(s => s.split("^")[0].trim())}))
    this.listSDBH = SDBHSemanticDomainsDataObjects.Domains; //{Domain: "Promise", Type: "Lexical", ListWords: ['1234']}


    this.listTagAttributes = TagAttributesDataObjects.Attributes
    
    this.dictTagAttributesByShortcut = new Map()
    for(var o of this.listTagAttributes)
        this.dictTagAttributesByShortcut.set(o.Shortcut, o)
        
    this.dictTagAttributesByID = new Map()
    for(var o of this.listTagAttributes)
        this.dictTagAttributesByID.set(o.ID, o)

    // var EnglishVersionOnlyForDevDataObjects = EnglishVersionOnlyForDevData
    // this.listAllVersesForEnglishVersionOnlyForDev = EnglishVersionOnlyForDevData.Verses

    //var RootOccurrencesDataObjects = RootOccurrencesData
    //this.listRootOccurrencesData = RootOccurrencesDataObjects.Entries

    //add virtual semantic domains to the list
    //var stestundefineddomains = this.listCompositeSemanticDomains.flatMap(o => o.ListDomainGroups.filter(s => this.listSDBH.find(o2 => o2.Name.toLowerCase() === s.toLowerCase().trim()) === undefined).join(","));
        
    for(var o of this.listCompositeSemanticDomains)
    {
        var listTextIndexes = o.ListDomainGroups.flatMap(s => { 
            var domain = this.listSDBH.find(o2 => o2.Name.toLowerCase() === s.toLowerCase().trim());
            return domain === undefined ? [] : domain.ListWords; });
        this.listSDBH.push({"Name":o.Name, "Type":"composite", "ListWords": listTextIndexes});
    }
    
    //{"Type":"opposites","ListDomainGroups":[["new","old"],["bad","good"],[["great","large"],"little"]
    for(var o of this.listSemanticRelationshipGroups)
    {
        var listDomainNamesToSearch = o.ListDomainGroups.flat(Infinity).map(s => s.toLowerCase().trim());
        o.DomainsToSearch = this.listSDBH.filter(o => listDomainNamesToSearch.includes(o.Name.toLowerCase().trim()));
    }

    this.listRhymeGroups.forEach(o => o.ListLetters = o.HebrewText.split(',').map(s => s.trim()))
    this.listRhymeGroups.sort((a, b) => b.SimilarityPercent - a.SimilarityPercent);
   
	//this.listAllTextWords = textWordObjects.OSHB;
	this.listSectionBreaks = SectionBreaksDataObjects.SectionBreaks;
	this.listLineRelationships = LineRelationshipsDataObjects.LineRelationships;
	// this.listLexemeAlphIDToLexemeText = LexemeAlphIDToLexemeTextDataObjects.LexemeAlphIDToLexemeText;
	this.listFigurativeSpeechTypes = FigurativeSpeechTypesDataObjects.FigurativeSpeechTypes;

	//this.listSemanticLinks = SemanticLinksDataObjects.Links;
	//this.listSemanticLinkTypes = [...new Set(this.listSemanticLinks.map(l => l.type))]; //.sort((a,b) => a - b);
	
	//this.listUserAddedSemanticNodes = this.LoadUserAddedSemanticNodes();
	//this.setState({listSemanticNodes: SemanticNodesDataObjects.Nodes.concat(this.listUserAddedSemanticNodes)});

	//this.listTranslationsImported = EnglishTranslationsData.EnglishTranslations;
	// this.listTranslationsImported.forEach(r => r.TextIndexList = r.TextIndexes.split("^"));

	var listFiguresToSet = FiguresDataObjects.Figures;
	listFiguresToSet = this.LoadFigures();
	this.setState({listFigures: listFiguresToSet });

    this.setState({listLenses: LensesDataObjects.Lenses});
    this.setState({listTranslations: this.LoadTranslations()});
	this.setState({listWordTags: this.LoadWordTags()});
	this.setState({listWordsOverride: this.LoadWordOverrides()});	
	this.setState({listDiscourseUnits: DiscourseUnitsDataObjects.DiscourseUnits});

	if(this.blnPopulateAllChaptersAtLoad)
	{
		this.FetchGlobalData()
	}

	this.FetchChapters(this.state.listCurrentChapters.map(nChapter => ({Book: this.state.nCurrentBook, Chapter: nChapter})))
	//this.FetchCola(this.state.nCurrentBook, this.GetFirstCurrentChapter());

    //this.GenerateRepetitionLinkGroupsFromPGroups();

    this.ChangeView(this.state.sSelectedView)
	this.setState({ isLoading: false });
  }

	componentDidUpdate() {
		var test = 1;
	}

	MapSearchTermToPhraseFunctions(sTerm)
	{
		return sTerm === "V" ? ["Pred", "PreO"]:
			sTerm === "S" ? ["Subj"] :
			sTerm === "O" ? ["Objc"] :
			[sTerm];
	}

    GetPhraseFunction(w)
    {
        return w.ClauseFunction != undefined ? w.ClauseFunction : w.phrase_function
    }

	MapPhraseFunctionToLetter(w, blnPreserveOriginal)
	{
        if(w.ClauseFunction != undefined) 
            return w.ClauseFunction
		else 
            return w.phrase_function === "Pred" || w.phrase_function === "PreO" ? "V" :
			w.phrase_function === "Subj" ? "S" :
			w.phrase_function === "Objc" ? "O" : (blnPreserveOriginal ? w.phrase_function : "")
	}

	IsMainPhraseFunction(w)
	{
		return ['S', 'V', 'O', 'P'].includes(w.ClauseFunction) || w.phrase_function === "Pred" || w.phrase_function === "PreO" || w.phrase_function === "Subj" || w.phrase_function === "Objc";
	}

	IsPredicate(w)
	{
		return ['V', 'P', 'Pred','PreO', 'PreC'].includes(this.GetPhraseFunction(w))
	}

	IsSubject(w)
	{
		return ['Subj', 'S'].includes(this.GetPhraseFunction(w))
	}

	IsObject(w)
	{
		return ['Objc', 'O'].includes(this.GetPhraseFunction(w))
	}

	IsPredicateAdjunct(w)
	{
		return ['Loca', 'Time', 'Cmpl', 'Nega'].includes(this.GetPhraseFunction(w))
	}

	MergeConsecutiveDuplicateChars(s)
	{
		return s.replace(/(.)\1+/g, "$1");
	}

	GetPhraseFunctionOrdering(listWordsInLine)
	{
		return this.MergeConsecutiveDuplicateChars(listWordsInLine.map(w => this.MapPhraseFunctionToLetter(w, false)).join(""));
	}

	IsConsonant(hebrewChar)
	{
		var matchingRow = this.listHebrewChars.filter(c => c.Char === hebrewChar)[0];
		return matchingRow === undefined ? false : matchingRow.Consonant === "1";
	}

	IsVowel(hebrewChar)
	{
		var matchingRow = this.listHebrewChars.filter(c => c.Char === hebrewChar)[0];
		return matchingRow === undefined ? false : 
			(matchingRow.LongVowel === "1" || matchingRow.ShortVowel === "1" || matchingRow.IsSheva === "1");
	}

	LineWithWord(w, listLinesToUse)
	{
		return (listLinesToUse === undefined ? this.state.listLines : listLinesToUse).find(l => l.Words.includes(w));
	}

	PropositionWithWord(w, listPropositionsToUse)
	{
		return (listPropositionsToUse === undefined ? this.state.listPropositions : listPropositionsToUse).find(l => l.Words.includes(w));
	}
	
	GetClauseForWord(w, listClausesToUse)
	{
		return (listClausesToUse === undefined ? this.listClauses : listClausesToUse).find(c => c.Words.includes(w));
	}

	GetPhraseFunctionOrderForWord(w, listClausesToUse)
	{
		var clauseForWord = this.GetClauseForWord(w, listClausesToUse);
		return clauseForWord  === undefined ? undefined : clauseForWord.PhraseFunctionOrder;
	}

	ClusterMatchesTerm(cluster, sTermToCheck)
	{
		var sParameterSplit = sTermToCheck.split(":");
		var sTermCategory = sParameterSplit[0];
		var sTermValue = sParameterSplit.length < 2 ? "" : sParameterSplit[1];
		var blnNegativeMatch = false;
		var listToMatch = sTermValue.split(',').map(s => s.trim());

		var rangeToMatch = new NumberRange(0, 1000000);
		if(sTermCategory === "groupsincluster")
		{
			var rangeMatch = sTermValue.match(/(\d+)?,(\d+)?/);
			if (rangeMatch != null) 
			{
				if(rangeMatch[1] != undefined) rangeToMatch.Begin = parseInt(rangeMatch[1]);
				if(rangeMatch[2] != undefined) rangeToMatch.End = parseInt(rangeMatch[2]);
			}
		}

		if(listToMatch.length === 1 && (listToMatch[0] === "" || listToMatch[0] === "[]")) return true;

		return (sTermCategory === "any") ||			
			(sTermCategory === "groupsincluster" && (blnNegativeMatch ^ rangeToMatch.IndexInRange(this.GroupsInCluster(cluster).length)));	
	}

	ClusterMatchesTermOfOtherCluster(cluster1, cluster2, sTermToCheck)
	{
		var blnNegativeMatch = sTermToCheck.includes("!");
		var sTermCategory = sTermToCheck.replace("!", "").replace("/", "");

		if(sTermCategory.startsWith("groupsincluster"))
		{
			var match1 = sTermCategory.match(/groupsincluster:?(\d+)?/);
			var nTolerance = match1[1] === undefined ? 1 : parseInt(match1[1]);
			return blnNegativeMatch ^ (Math.abs(this.GroupsInCluster(cluster1).length - this.GroupsInCluster(cluster2).length) <= nTolerance);		
		}
		return false;
	}

	PGroupMatchesTerm(pgrp, sTermToCheck)
	{
		var sParameterSplit = sTermToCheck.split(":");
		var sTermCategory = sParameterSplit[0];
		var sTermValue = sParameterSplit.length < 2 ? "" : sParameterSplit[1];
		var blnNegativeMatch = false;
		var listToMatch = sTermValue.split(',').map(s => s.trim());

		var rangeToMatch = new NumberRange(0, 1000000);
		if(sTermCategory === "linecount")
		{
			var rangeMatch = sTermValue.match(/(\d+)?,(\d+)?/);
			if (rangeMatch != null) 
			{
				if(rangeMatch[1] != undefined) rangeToMatch.Begin = parseInt(rangeMatch[1]);
				if(rangeMatch[2] != undefined) rangeToMatch.End = parseInt(rangeMatch[2]);
			}
		}

		if(listToMatch.length === 1 && (listToMatch[0] === "" || listToMatch[0] === "[]")) return true;
		
		return (sTermCategory === "any") ||			
			(sTermCategory === "linecount" && (blnNegativeMatch ^ rangeToMatch.IndexInRange(pgrp.Lines.length)));	
	}

	PGroupMatchesTermOfOtherPGroup(pgrp1, pgrp2, sTermToCheck)
	{
		var blnNegativeMatch = sTermToCheck.includes("!");
		var sTermCategory = sTermToCheck.replace("!", "").replace("/", "");
		
		if(sTermCategory.startsWith("linecount"))
		{
			var match1 = sTermCategory.match(/linecount:?(\d+)?/);
			var nTolerance = match1[1] === undefined ? 1 : parseInt(match1[1]);
			return blnNegativeMatch ^ (Math.abs(pgrp1.Lines.length - pgrp2.Lines.length) <= nTolerance);		
		}
		return false;
	}

	LineMatchesTerm(line, sTermToCheck, listLinesToUse)
	{
		var sParameterSplit = sTermToCheck.split(":");
		var sTermCategory = sParameterSplit[0];
		var sTermValue = sParameterSplit.length < 2 ? "" : sParameterSplit[1];
		var blnNegativeMatch = false;
		//var listToMatch = [];

		var rangeToMatch = new NumberRange(0, 1000000);
		if(sTermCategory === "linesyl" || sTermCategory === "wordsinline")
		{
			var rangeMatch = sTermValue.match(/(\d+)?,(\d+)?/);
			if (rangeMatch != null) 
			{
				if(rangeMatch[1] != undefined) rangeToMatch.Begin = parseInt(rangeMatch[1]);
				if(rangeMatch[2] != undefined) rangeToMatch.End = parseInt(rangeMatch[2]);
			}
		}

		//if(listToMatch.length === 1 && (listToMatch[0] === "" || listToMatch[0] === "[]")) return true;

		if(sTermCategory === "posl")
		{
			var matchPosL = sTermValue.match(/(\d+)/);
			if (matchPosL == null) 
				return false;
			else
			{
				var nPercentInListToFind = parseFloat(matchPosL[1]) / 100;
				var nClosestIndexToPercent = Math.round(listLinesToUse.length * nPercentInListToFind);
				if(nClosestIndexToPercent > listLinesToUse.length - 1)
					nClosestIndexToPercent = listLinesToUse.length - 1;

				if(listLinesToUse.length % 2 > 0) //if it's odd
					return listLinesToUse[nClosestIndexToPercent] === line;
				else if(listLinesToUse.length > nClosestIndexToPercent)
				{
					//if it's even, show the next line, too
					return listLinesToUse[nClosestIndexToPercent] === line ||
						((nClosestIndexToPercent < listLinesToUse.length - 1) && 
							listLinesToUse[nClosestIndexToPercent + 1] === line);
				}
			}
		}
		
		if(sTermCategory === "pgrporder")
		{
			if(sTermValue === "sandwich") sTermValue = "(.).\\1";
			return blnNegativeMatch ^ (line.PGroupOrder != undefined && RegExp(sTermValue).test(line.PGroupOrder));
		}

		//TODO: pgrporder
		return (sTermCategory === "any") ||
			(sTermCategory === "linesyl" && (blnNegativeMatch ^ rangeToMatch.IndexInRange(line.SyllableCount))) ||
			(sTermCategory === "fig" && (blnNegativeMatch ^ line.FigurativeLanguage === true)) ||
			(sTermCategory === "wordsinline" && (blnNegativeMatch ^ rangeToMatch.IndexInRange(line.Words.length)));
	}

	LineMatchesTermOfOtherLine(line1, line2, sTermToCheck, listLinesToUse)
	{
		var blnNegativeMatch = sTermToCheck.includes("!");
		var sTermCategory = sTermToCheck.replace("!", "").replace("/", "");

		if(sTermCategory.startsWith("linesyl"))
		{
			var sylMatch = sTermCategory.match(/linesyl:?(\d+)?/);
			var nTolerance = sylMatch[1] === undefined ? 1 : parseInt(sylMatch[1]);
			return blnNegativeMatch ^ (Math.abs(line1.SyllableCount - line2.SyllableCount) <= nTolerance);		
		}
		else if(sTermCategory.startsWith("wordsinline"))
		{
			var sylMatch = sTermCategory.match(/wordsinline:?(\d+)?/);
			var nTolerance = sylMatch[1] === undefined ? 1 : parseInt(sylMatch[1]);
			return blnNegativeMatch ^ (Math.abs(line1.Words.length - line2.Words.length) <= nTolerance);			
        }
        else if(sTermCategory.startsWith("overlap"))
        {
            if(line1.PGroupOrder === undefined || line2.PGroupOrder === undefined) return false;

            var overlapMatch = sTermCategory.match(/overlap:(\d+),(\d+)/);
            var nMinOverlapping = overlapMatch[1] === undefined ? 1 : parseInt(overlapMatch[1]);
            var nMaxOverlapping = overlapMatch[2] === undefined ? 1 : parseInt(overlapMatch[2]);
            var nNumberOverlapping = line1.PGroupOrder.split("").filter(s => line2.PGroupOrder.split("").includes(s)).length;
            return blnNegativeMatch ^ (nNumberOverlapping >= nMinOverlapping && nNumberOverlapping <= nMaxOverlapping);
        }
		else if(sTermCategory === "repetitiongroup")
		{
			var repGroup1 = this.GetRepetitionGroupForLine(line1);
			var repGroup2 = this.GetRepetitionGroupForLine(line2);
			return blnNegativeMatch ^ (repGroup1 != undefined && repGroup1 === repGroup2);			
		}
		else if(sTermCategory === "repetitiongroupcluster")
		{
			var repGroupCluster1 = this.GetRepetitionGroupClusterForLine(line1);
			var repGroupCluster2 = this.GetRepetitionGroupClusterForLine(line2);
			return blnNegativeMatch ^ (repGroupCluster1 != undefined && repGroupCluster1 === repGroupCluster2);			
		}
		else if(sTermCategory === "chiasm" || sTermCategory === "same" || sTermCategory === "samefirst" || 
			sTermCategory === "samelast" || sTermCategory === "bookends")
		{
			if(line1.PGroupOrder === undefined || line2.PGroupOrder === undefined ||
			    this.GetRepetitionGroupForLine(line1) != this.GetRepetitionGroupForLine(line2))	
				return blnNegativeMatch;

			if(sTermCategory === "chiasm")
				return blnNegativeMatch ^ (line1.PGroupOrder.length > 1 && line2.PGroupOrder.length > 1 &&
					line1.PGroupOrder[line1.PGroupOrder.length - 1] === line2.PGroupOrder[0] &&
					line1.PGroupOrder[line1.PGroupOrder.length - 2] === line2.PGroupOrder[1]);
			else if(sTermCategory === "bookends")
				return blnNegativeMatch ^ (line1.PGroupOrder.length > 1 && line2.PGroupOrder.length > 1 &&
					line1.PGroupOrder[0] === line2.PGroupOrder[line2.PGroupOrder.length - 1]);
			else if(sTermCategory === "same")
				return blnNegativeMatch ^ (line1.PGroupOrder === line2.PGroupOrder);
			else if(sTermCategory === "samefirst")
				return blnNegativeMatch ^ (line1.PGroupOrder[0] === line2.PGroupOrder[0]);
			else if(sTermCategory === "samelast")
				return blnNegativeMatch ^ (line1.PGroupOrder[line1.PGroupOrder.length - 1] === line2.PGroupOrder[line2.PGroupOrder.length - 1]);
		}
		
		//pgrporder:ABC
		return false;
	}

	ClauseMatchesTerm(clause, sTermToCheck)
	{
		var sParameterSplit = sTermToCheck.split(":");
		var sTermCategory = sParameterSplit[0];
		var sTermValue = sParameterSplit.length < 2 ? "" : sParameterSplit[1];
		var blnNegativeMatch = false;
		var listToMatch = sTermValue.split(',').map(s => s.trim());

		// var rangeToMatch = new NumberRange(0, 1000000);
		// if(sTermCategory === "...")
		// {
		// 	var rangeMatch = sTermValue.match(/(\d+)?,(\d+)?/);
		// 	if (rangeMatch != null) 
		// 	{
		// 		if(rangeMatch[1] != undefined) rangeToMatch.Begin = parseInt(rangeMatch[1]);
		// 		if(rangeMatch[2] != undefined) rangeToMatch.End = parseInt(rangeMatch[2]);
		// 	}
		// }

		if(listToMatch.length === 1 && (listToMatch[0] === "" || listToMatch[0] === "[]")) return true;

		return (sTermCategory === "any") ||			
			(sTermCategory === "pforder" && (blnNegativeMatch ^ listToMatch.includes(clause.PhraseFunctionOrder)));	
	}

	ClauseMatchesTermOfOtherClause(clause1, clause2, sTermToCheck)
	{
		var blnNegativeMatch = sTermToCheck.includes("!");
		var sTermCategory = sTermToCheck.replace("!", "").replace("/", "");
		
		return (sTermCategory === "pforder" && (blnNegativeMatch ^ (clause1.PhraseFunctionOrder === clause2.PhraseFunctionOrder)));
	}

    // GetSDBHSemanticDomainListFromName(listNodeNames)
    // {
        
    //     //{"Name":"timeetc","ListDomainGroups":["time","Lasting","brief","speed","frequency"]},
    //     var listFromComposite = this.listCompositeSemanticDomains.filter(o => o.Name === listNodeNames.includes(o.Name.toLowerCase())).flat();
    //     if(listFromComposite.length > 0) return listFromComposite;
    //     else return this.listSDBH.filter(o => listNodeNames.includes(o.Name.toLowerCase()));
    // }

    // WordsOccursInSameSDBHSemanticDomain(w1, w2)
    // {
    //     var nTextIndex1 = parseInt(w1.TextIndex);
    //     var nTextIndex2 = parseInt(w2.TextIndex);

    //     var blnAnySDBHGroupsInCommon = this.listSDBH.some(o => o.ListWords.includes(nTextIndex1) && o.ListWords.includes(nTextIndex2));

    //     //{"Name":"timeetc","ListDomainGroups":["time","Lasting","brief","speed","frequency"]},
    //     var listFromComposite = this.listCompositeSemanticDomains.filter(o => o.Name === listNodeNames.includes(o.Name.toLowerCase())).flat();
    //     if(listFromComposite.length > 0) return listFromComposite;
    //     else return this.listSDBH.filter(o => listNodeNames.includes(o.Name.toLowerCase()));
    // }

	WordMatchesMorph(w, sTermToCheck, listLinesToUse)
	{
		//word has specified morphological feature
		//tsfpgncrw sp sg sn a i
		//e.g s:q or f:v or s:[^qpNhHt] or w

		//implement: 
		// 1) @lineend @linestart at end of term e.g. all@lineend
		// 2) [l,s,p]<=2 or l>3 or l=0 etc.
		// 3) firstconsonant/ and the other three
		// 4) [40%l,] and [2,] the percent or number of units in the match chain
		// 5) chars:2+ or 2chars matches >= 2 chars
		// 6) 1chars/1 -- 1chars/2  the number after the slash matches the index + 1 
		// in the match chain

        var blnNegativeMatch = sTermToCheck.includes("!");
        sTermToCheck = sTermToCheck.replace("!", "");
        
		var sParameterSplit = sTermToCheck.split(":");
		var sTermCategory = sParameterSplit[0];
		var sMorphValue = sParameterSplit.length < 2 ? "" : sParameterSplit[1];

		var listToMatch = [];
		var rangeToMatch = new NumberRange(0, 1000000);

		if(sTermCategory === "occ" || sTermCategory === "syl" || sTermCategory === "linesyl" || sTermCategory === "wordsinline")
		{
			var rangeMatch = sMorphValue.match(/(\d+)?,(\d+)?/);
			if (rangeMatch != null) 
			{
				if(rangeMatch[1] != undefined) rangeToMatch.Begin = parseInt(rangeMatch[1]);
				if(rangeMatch[2] != undefined) rangeToMatch.End = parseInt(rangeMatch[2]);
			}
		}
		else if(sTermCategory === "posw")

		{
			var matchPosW = sMorphValue.match(/(\d+)/);
			if (matchPosW == null) 
				return false;
			else
			{
				var nPercentInListToFind = parseFloat(matchPosW[1]) / 100;
				var nClosestIndexToPercent = Math.round(this.listTextWordsForChapter.length * nPercentInListToFind);
				return w === this.listTextWordsForChapter[nClosestIndexToPercent];
			}
		}
		else if(sTermToCheck.startsWith("rgrp"))
		{
			var rgrpMatch = sTermToCheck.match(/rgrp:(\d+)\[?([\d,]+)?\]?/);
			var nType = rgrpMatch[1] === undefined ? 1 : parseInt(rgrpMatch[1]);
			var listTags = rgrpMatch[2] === undefined ? undefined : rgrpMatch[2].split(",").map(s => s.trim());

			return blnNegativeMatch ^ (this.state.listRepetitionLinkGroups.
				filter(g => g.Type === nType && (listTags === undefined || g.ListTags.some(t => listTags.includes(t.CategoryID)))).
				some(g => g.ListWords.includes(w.TextIndex)));	
		}
		else if(sTermToCheck.startsWith("corr"))
		{
			var corrMatch = sTermToCheck.match(/corr:\[?([\d,]+)?\]?/);
			var listTags = corrMatch[1] === undefined ? undefined : corrMatch[1].split(",").map(s => s.trim());

			return blnNegativeMatch ^ (this.listCorrespondencesForChapter.
				filter(g => listTags === undefined || g.ListTags.some(t => listTags.includes(t.CategoryID))).
				some(g => g.ListWords.includes(w.TextIndex)));	
		}
		// else if(sTermToCheck.startsWith("participantinrole"))
		// {
		// 	//participantinrole:[1001,1004],[40,45]
		// 	var participantinroleMatch = sTermToCheck.match(/participantinrole:\[([\d,]+)\],\[([\d,]+)\]/);
		// 	var listParticipantIDs = participantinroleMatch[1].split(",").map(s => s.trim());
		// 	var listRoleIDs = participantinroleMatch[2].split(",").map(s => s.trim());

		// 	//{"TextIndex":"21","SemanticRoles":[{"RoleID":"33","IsForSuffix":false}],"SemanticCategoryIDs":[420,783]}
		// 	//{"ListWords":["16270","16267"],"ListTags":[{"CategoryID":"313","RelationPairReversed":false}],"Comment":"","Type":10,"WordsForWhichParticipantRefIsForSuffix":[]}
			
		// 	var listMatchingRolesForWord = this.GetWordTagForWord(w).SemanticRoles.filter(role => listRoleIDs.some(nID => role.RoleID === nID));
		// 	var listAllParticipantsForWord = this.state.listRepetitionLinkGroups.
		// 		filter(g => g.Type === 2 && g.ListWords.includes(w.TextIndex));

		// 	var listMatchingParticipantsForWord = listAllParticipantsForWord.
		// 		map(g => { return {IDs: g.ListTags.map(tag => tag.CategoryID), IsForSuffix: g.WordsForWhichParticipantRefIsForSuffix.includes(w.TextIndex)}}).
		// 		filter(o => listParticipantIDs.some(nID => o.IDs.includes(nID)));

		// 	//match if 1) the word has no suffix, 2) both have IsForSuffix = true, 3) both have IsForSuffix = false, or 
		// 	//4) if role IsForSuffix = true and 
		// 	//the word only has one particip ref group (which happens for non-verbs where the suffix participant is the only participant).

		// 	return blnNegativeMatch ^ (listMatchingRolesForWord.length > 0 && listMatchingParticipantsForWord.length > 0 &&
		// 		(w.SuffixPerson === undefined || listAllParticipantsForWord.length === 1 ||
		// 			(listMatchingRolesForWord.some(o => o.IsForSuffix) && listMatchingParticipantsForWord.some(o => o.IsForSuffix))	||
		// 			(listMatchingRolesForWord.some(o => !o.IsForSuffix) && listMatchingParticipantsForWord.some(o => !o.IsForSuffix))));
		// }
		else if(sTermToCheck.startsWith("participant"))
		{
			//participant:[1001,1004]
			var participantinroleMatch = sTermToCheck.match(/participant:\[([\d,]+)\]/);
			var listParticipantIDs = participantinroleMatch[1].split(",").map(s => s.trim());

			return blnNegativeMatch ^ this.state.listRepetitionLinkGroups.
				some(g => g.Type === 2 && g.ListWords.includes(w.TextIndex) && 
				listParticipantIDs.some(nID => g.ListTags.some(tag => tag.CategoryID === nID)));
		}
		else if(sTermCategory.startsWith("linkstoprevpgrp"))
		{
			var matchLinkParams = sMorphValue.match(/(\d+),(\d+),(\d+)/);
			if(matchLinkParams === null)
				return false;
			else 
			{ 
				var nMaxLinesAway = matchLinkParams[1] === undefined ? 1 : parseInt(matchLinkParams[1]);
				var nMaxSemanticLevels = matchLinkParams[2] === undefined ? 2 : matchLinkParams[2];
				var nMinChars = matchLinkParams[3] === undefined ? 3 : matchLinkParams[3];

				//the word is in the first line of its repetition group, and it has some strong connection 
				//to the last line of the previous repetition group, including suffixes, semantic node matching 
				//(which includes direct repetitions), same root, strong phono connection between 
				//first line and last line of previous...
				var listTermsToCheckAgainstPrev = ["sem:" + nMaxSemanticLevels, "chars:" + nMinChars, //"rhyme", 
					"lex", "root", "prep", "sfxpgn"]; //"s", "f", "pgn",

				var nRepGroupIndex = this.GetRepetitionGroupIndexForWord(w, listLinesToUse);
				if(nRepGroupIndex === -1 || nRepGroupIndex === 0 || 
					this.listRepetitionGroups[nRepGroupIndex].Lines[0] != this.LineWithWord(w, listLinesToUse)) return blnNegativeMatch;

				if(w.SuffixPerson === "3") return !blnNegativeMatch;
				var prevRepGroup = this.listRepetitionGroups[nRepGroupIndex - 1];
				for(var nLinesAway = 1; nLinesAway <= Math.min(nMaxLinesAway, prevRepGroup.Lines.length); nLinesAway++)
				{
					var listLinks = prevRepGroup.Lines[prevRepGroup.Lines.length - nLinesAway].Words.filter(wPrev => 
						listTermsToCheckAgainstPrev.some(t => this.WordMatchesMorphOfOtherWord(w, wPrev, t, listLinesToUse)));
					return blnNegativeMatch ^ listLinks.length > 0;
				}

				return blnNegativeMatch;
			}
		}	
		else if(sTermCategory.startsWith("nodeidforsemanticsearch"))
		{
			var matchSemNodeIDParams = sMorphValue.match(/\[([\d,]+)\]/);
			if(matchSemNodeIDParams === null)
				return false;
			else 
			{ 
				//match node with id and any children nodes along the types or parts relationships
				var listNodeIDsToFind = matchSemNodeIDParams[1].split(",").map(s => parseInt(s.trim()));
				var listNodesPassingFilter = this.state.listSemanticNodes.filter(n => listNodeIDsToFind.includes(n.ID));
				for(var n of listNodesPassingFilter)
				{
					if(this.WordIsASemanticTypeOrPartOfNode(n.ID, w)) 
						return !blnNegativeMatch
				}

				return blnNegativeMatch;
			}
		}
		else if(sTermCategory.startsWith("sem"))
		{
			var matchSemParams = sMorphValue.match(/([\w,]+)?/); //sMorphValue.match(/\[([\w,]+)?\],(\d+)?/);
			if(matchSemParams === null)
				return false;
			else 
			{ 
                var listNodeNames = matchSemParams[1] === undefined ? undefined : matchSemParams[1].split(",").map(s => s.trim().toLowerCase());
                if(listNodeNames === undefined) return false;
                
                var blnOccursInAnyMainGroup = this.listMainSemanticDomains.filter(o => listNodeNames.includes(o.Name.toLowerCase())).
                    some(o => o.LexicalIDs.includes(w.LexicalID));

                var nTextIndex = parseInt(w.TextIndex);
                var blnOccursInAnySDBHGroup = this.listSDBH.filter(o => listNodeNames.includes(o.Name.toLowerCase())).some(o => o.ListWords.includes(nTextIndex));
                return blnNegativeMatch ^ (blnOccursInAnyMainGroup || blnOccursInAnySDBHGroup);

				// var sNodeNameFilter = matchSemParams[1] === undefined ? undefined : matchSemParams[1];
				// var nMaxLevels = matchSemParams[3] === undefined ? 1 : parseInt(matchSemParams[3]);
				// if(sNodeNameFilter === undefined) return false;

				// //below commented out two lines are for the textbox version
				// // var rgxToMatchNode = new RegExp("\\b" + sNodeNameFilter);
				// // var listNodesPassingFilter = this.state.listSemanticNodes.filter(n => n.Names.match(rgxToMatchNode));
				// var listNodeIDsToFind = sNodeNameFilter.split(",").map(s => parseInt(s.trim()));
				// var listNodesPassingFilter = this.state.listSemanticNodes.filter(n => listNodeIDsToFind.includes(n.ID));
				// for(var n of listNodesPassingFilter)
				// {
				// 	if(this.SemanticDistanceBetweenNodeAndWord(n, w, nMaxLevels, true) <= nMaxLevels) 
				// 		return !blnNegativeMatch
				// }

				// return blnNegativeMatch;
			}
		}
		else
		{
			if (sTermCategory === "pgn" || sTermCategory === "sfxpgn")
			{
				listToMatch = sMorphValue.split(',').map(s => s.trim());
			}
			else
			{
				var rgxValueGroup = /\[(\^)?(\w+)\]/;
				var matchArray = rgxValueGroup.exec(sMorphValue);
				if (matchArray != null) 
				{
					blnNegativeMatch = matchArray[1] !== undefined;
					var listValuesInGroup = Array.from(matchArray[2]);
					for(const s of listValuesInGroup)
					{
						if (sTermCategory === "pf")
							for(const s2 of this.MapSearchTermToPhraseFunctions(s))
								listToMatch.push(s2);
						else
							listToMatch.push(s);
					};
				}
				else
				{
					if (sTermCategory === "pf")
						for(const s2 of this.MapSearchTermToPhraseFunctions(sMorphValue))
							listToMatch.push(s2);
					else
						listToMatch.push(sMorphValue);
				}
			}
		}
		
		if(sTermCategory === "lexgrp")
		{
			//does the list of lexical groups this word is in include one of the IDs were are looking for?
			var listLexicalGroupsForOne =
				this.listLexicalGroups.filter(r => r.ListWordIDs.split(',').includes(w.LexicalID)).map(r => r.ID);
			return blnNegativeMatch ^ listLexicalGroupsForOne.some(n => listToMatch.includes(n));
		}

		// if(sTermCategory === "fig")
		// {
		// 	//fig:"1"
		// 	//does the list of figures this word is in include one of the IDs were are looking for?
		// 	return blnNegativeMatch ^ this.GetFiguresContainingTextIndex(w.TextIndex).some(n => listToMatch.includes(String(n.FigureTypeID)));
		// }

		//XOR
		//blnNegativeMatch contains result
		//1 1 0
		//1 0 1
		//0 1 1
		//0 0 0

		//if there is no parameter specified, return true (for the select boxes without anything selected).
		if(listToMatch.length === 1 && (listToMatch[0] === "" || listToMatch[0] === "[]")) return true;

		var blnMorphMatch = 
		(sTermCategory === "any") ||
		(sTermCategory === "type" && (blnNegativeMatch ^ listToMatch.includes(w.WordType))) ||
		(sTermCategory === "s" && (blnNegativeMatch ^ listToMatch.includes(w.Stem))) ||
		(sTermCategory === "f" && (blnNegativeMatch ^ listToMatch.includes(w.Form))) ||
		(sTermCategory === "p" && (blnNegativeMatch ^ listToMatch.includes(w.Person))) ||
		(sTermCategory === "g" && (blnNegativeMatch ^ listToMatch.includes(w.Gender))) ||
		(sTermCategory === "n" && (blnNegativeMatch ^ listToMatch.includes(w.Number))) ||
		(sTermCategory === "pgn" && (blnNegativeMatch ^ listToMatch.includes(this.GetPGN(w)))) ||
		(sTermCategory === "cs" && (blnNegativeMatch ^ listToMatch.includes(w.ConstructState))) ||
		(sTermCategory === "prep" && (blnNegativeMatch ^ listToMatch.includes(w.Preposition))) ||
		(sTermCategory === "waw" && (blnNegativeMatch ^ (listToMatch.includes(w.Waw)))) ||
		(sTermCategory === "art" && (blnNegativeMatch ^ (listToMatch.includes(w.DefiniteArticle)))) ||
		(sTermCategory === "sfxp" && (blnNegativeMatch ^ listToMatch.includes(w.SuffixPerson))) ||
		(sTermCategory === "sfxg" && (blnNegativeMatch ^ listToMatch.includes(w.SuffixGender))) ||
		(sTermCategory === "sfxn" && (blnNegativeMatch ^ listToMatch.includes(w.SuffixNumber))) ||
		(sTermCategory === "sfxtype" && (blnNegativeMatch ^ listToMatch.includes(w.SuffixType))) ||
		(sTermCategory === "sfxpgn" && (blnNegativeMatch ^ listToMatch.includes(this.GetSuffixPGN(w)))) ||	
		(sTermCategory === "pf" && (blnNegativeMatch ^ listToMatch.includes(this.GetPhraseFunction(w)))) ||	
		(sTermCategory === "texttype" && (blnNegativeMatch ^ (w.clause_txt != undefined && listToMatch.every(s => w.clause_txt.includes(s))))) ||
		(sTermCategory === "lex" && (blnNegativeMatch ^ listToMatch.includes(w.LexicalID))) ||
		(sTermCategory === "occ" && (blnNegativeMatch ^ rangeToMatch.IndexInRange(parseInt(w.Occurrences)))) ||
		(sTermCategory === "syl" && (blnNegativeMatch ^ rangeToMatch.IndexInRange(parseInt(w.SyllableCount)))) ||
		(sTermCategory === "txt" && (blnNegativeMatch ^ listToMatch.some(w2 => w.FullText.includes(w2))));

		return blnMorphMatch;
	}

	WordRhymesWithOtherWord(w1, w2, sParameters)
	{
		//start or end same consonant or vowel
		//TODO: check for same vowel sequence in word?
		//TODO: allow same rhyme group with SimilarityScore >= 0.7 to count as rhyme
		//TODO: instead of just begin and end rhyme, maybe have syllable divisions 
		//and check for first consonant and vowel at syllable divisions.

		var blnAtStart = sParameters.includes("start");
		var blnAtEnd = sParameters.includes("end");
		var blnConsonantRhyme = sParameters.includes("cons");
		var blnVowelRhyme = sParameters.includes("vowel");

		//if neither are specified, do both
		if(!blnAtStart && !blnAtEnd)
		{
			blnAtStart = true;
			blnAtEnd = true;
		}
		if(!blnConsonantRhyme && !blnVowelRhyme)
		{
			blnConsonantRhyme = true;
			blnVowelRhyme = true;
		}

		var w1chars = Array.from(w1.FullText);
		var w2chars = Array.from(w2.FullText);

		if(blnConsonantRhyme)
		{				
			var w1Consonants = w1chars.filter(c => this.IsConsonant(c));
			var w2Consonants = w2chars.filter(c => this.IsConsonant(c));	

			if(w1Consonants.length > 0 && w2Consonants.length > 0)
			{
				if((blnAtStart && w1Consonants[0] === w2Consonants[0]) ||
				(blnAtEnd && w1Consonants[w1Consonants.length - 1] === w2Consonants[w2Consonants.length - 1]))
					return true;
			}
		}

		if(blnVowelRhyme)
		{
			var w1Vowels = w1chars.filter(c => this.IsVowel(c) || c.IsSheva);
			var w2Vowels = w2chars.filter(c => this.IsVowel(c) || c.IsSheva);
			if(w1Vowels.length > 0 && w2Vowels.length > 0)
			{
				if((blnAtStart && w1Vowels[0] === w2Vowels[0]) ||
				(blnAtEnd && w1Vowels[w1Vowels.length - 1] === w2Vowels[w2Vowels.length - 1]))
				return true;
			}
		}

		return false;
	}

    // AreThereInvertedConsonantsBetweenTheseWords(w1, w2)
	// {
	// 	var w1chars = Array.from(w1.FullText);
	// 	var w2chars = Array.from(w2.FullText);			
    //     var w1Consonants = w1chars.filter(c => this.IsConsonant(c));
    //     var w2Consonants = w2chars.filter(c => this.IsConsonant(c));	
        
    //     var listConsonantsInCommon = w1Consonants.filter(c => w2Consonants.some(c2 => c === c2));

    //     var blnSameConsonantStart = w1Consonants[0] === w2Consonants[0];
    //     var blnSameConsonantEnd = w1Consonants[w1Consonants.length - 1] === w2Consonants[w2Consonants.length - 1];

    //     return nConsonantsInCommon + nRhymeGroupSimilarityPercentSum + (blnSameConsonantStart ? 1 : 0) + (blnSameConsonantEnd ? 1 : 0); // + (blnSameVowelStart ? 1 : 0) + (blnSameVowelEnd ? 1 : 0);
    // }

	IsThereSpecifiedRelationshipBetweenWords(w1, w2, listLinkTypes)
	{
		if(w1.LexicalID === w2.LexicalID) return false;

		for(var node of this.FindNodesForWord(w1))
		{
			if(this.WordHasSpecifiedRelationshipToNode(node.ID, w2, listLinkTypes)) return true;
		}

		return false;
	}

    ContainsOrEquals(arrayOrValue, valueToCompare)
    {
        //{"Type":"opposites","ListDomainNames":[["new","old"],["bad","good"],[["great","large"],"little"]
        return Array.isArray(arrayOrValue) ? arrayOrValue.includes(valueToCompare.toLowerCase()) : arrayOrValue === valueToCompare.toLowerCase();
    }

	GetLastSectionBreakBeforeWord(w, listBibleVersionIDs)
	{
		var listBreaksBeforeWord = this.listSectionBreaks
			.filter(r => r.Book === w.Book && r.Chapter === w.Chapter && listBibleVersionIDs.includes(r.BibleVersionID))
			.flatMap(r => r.SectionBreaks.split(",").map(s => parseInt(s)))
			.filter(n => n <= w.Verse);

		return listBreaksBeforeWord.length === 0 ? 1 : Math.max(...listBreaksBeforeWord);
	}

	WordMatchesMorphOfOtherWord(w, w2, sTermToCheck, listLinesToUse)
	{
		//word followed by another word with the same or different value in one or more categories
		// t/ matches the wordtype of the previous match, lex/ same word
		// t!/ is the negative version
		// t/N matches the Nth word in the chain
		//note that these backreferences don't count non-capturing terms in their indexes
		//e.g. t:N--lex/  would mark nouns occuring > 1 in a chapter
		//var sSplit1 = sTerm.Split("/")[0];
		//[p.g.n]!/
		
		var blnNegativeMatch = sTermToCheck.includes("!");
		var sTermCategory = sTermToCheck.replace("!", "").replace("/", "");

		//console.log(w.TextIndex + " " +w2.TextIndex + " " + sTermToCheck);
		if(sTermCategory.startsWith("chars"))
		{
			var charsMatch = sTermCategory.match(/chars(:)?(\w+)?/);
			if(charsMatch === null)
				return false;
			else 
			{
				var nNumberOfSameChars = charsMatch[2] === undefined ? 1 : parseInt(charsMatch[2]);
				var w1Consonants = Array.from(w.FullText).filter(c => this.IsConsonant(c));
				var w2Consonants = Array.from(w2.FullText).filter(c => this.IsConsonant(c));				
				return blnNegativeMatch ^ (w1Consonants.filter(c => w2Consonants.includes(c)).length >= nNumberOfSameChars);
			}
		}
		else if(sTermCategory.includes("rhyme"))
		{
			return blnNegativeMatch ^ this.WordRhymesWithOtherWord(w, w2, sTermCategory);
		}
		else if(sTermCategory === "lexgrp")
		{
			//do the words share at least one lexical group?
			var listLexicalGroupsForOne =
				this.listLexicalGroups.filter(r => r.ListWordIDs.split(',').includes(w.LexicalID)).map(r => r.ID);
			var listLexicalGroupsForTwo =
				this.listLexicalGroups.filter(r => r.ListWordIDs.split(',').includes(w2.LexicalID)).map(r => r.ID);
			return blnNegativeMatch ^ listLexicalGroupsForOne.some(n => listLexicalGroupsForTwo.includes(n));
		}
		else if(sTermCategory === "sem")
		{
            //does any of our semantic domain groupings contain both words?
            var blnAnyMainGroupsInCommon = this.listMainSemanticDomains.some(g => g.LexicalIDs.includes(w.LexicalID) && g.LexicalIDs.includes(w2.LexicalID));

            var nTextIndex1 = parseInt(w.TextIndex);
            var nTextIndex2 = parseInt(w2.TextIndex);
    
            var blnAnySDBHGroupsInCommon = this.listSDBH.some(o => o.ListWords.includes(nTextIndex1) && o.ListWords.includes(nTextIndex2));

            return blnNegativeMatch ^ (blnAnyMainGroupsInCommon || blnAnySDBHGroupsInCommon);

            // var semMatch = sTermCategory.match(/sem(\w+)?:?(\w+)?/);
            // if(semMatch === null)
            // 	return false;
            // else 
            // {
            // 	//if the link type is specified, we want to search maximal levels (100)
            // 	var sRelations = semMatch[1] === undefined ? "" : semMatch[1];
            // 	var nMaxLevels = semMatch[2] === undefined ? (sRelations === "" ? 3 : 100) : parseInt(semMatch[2]);
            // 	var listLinkTypesAllowed = sRelations === "" ? [] :
            // 		sRelations === "syn" ? ["types", "parts"] : [sRelations];
            // 	var blnReturnTrueIfTheyAreSameNode = sRelations === "" || sRelations === "syn";

            // 	return blnNegativeMatch ^ this.WordsSemanticallySimilarEnough(w, w2, nMaxLevels, blnReturnTrueIfTheyAreSameNode, listLinkTypesAllowed);
            // }
        }
        else if(sTermCategory.startsWith("semrelationshipgroups"))
		{
            var srgMatch = sTermCategory.match(/semrelationshipgroups:(\w+)/);
			if(srgMatch === null)
				return false;
			else 
			{
                var sRelationship = srgMatch[1];

                //{"Type":"opposites","ListDomainNames":[["new","old"],["bad","good"],[["great","large"],"little"]
                //DomainsToSearch:[{},{}] 

                //does any of our semantic domain opposite groupings contain both words? 
                // var blnAnyMainGroupsInCommon = this.listMainSemanticDomains.some(g => g.LexicalIDs.includes(w.LexicalID) && g.LexicalIDs.includes(w2.LexicalID));

                var nTextIndex1 = parseInt(w.TextIndex);
                var nTextIndex2 = parseInt(w2.TextIndex);
        
                var oppRelationship = this.listSemanticRelationshipGroups.find(o => o.Type === sRelationship);
                var listDomainsToSearch = oppRelationship.DomainsToSearch;
                var listDomainsForWord1 = listDomainsToSearch.filter(o => o.ListWords.includes(nTextIndex1));
                var listDomainsForWord2 = listDomainsToSearch.filter(o => o.ListWords.includes(nTextIndex2));

                var blnSuccess = oppRelationship.ListDomainGroups.some(pair => 
                    (listDomainsForWord1.some(o2 => this.ContainsOrEquals(pair[0], o2.Name)) && listDomainsForWord2.some(o2 => this.ContainsOrEquals(pair[1], o2.Name))) ||
                    (listDomainsForWord2.some(o2 => this.ContainsOrEquals(pair[0], o2.Name)) && listDomainsForWord1.some(o2 => this.ContainsOrEquals(pair[1], o2.Name))));

                return blnNegativeMatch ^ (blnSuccess);
            }
		}
		else if(sTermCategory.startsWith("partof"))
		{
			return blnNegativeMatch ^ this.IsThereSpecifiedRelationshipBetweenWords(w, w2, ["parts"]);
		}
		else if(sTermCategory.startsWith("typeof"))
		{
			return blnNegativeMatch ^ this.IsThereSpecifiedRelationshipBetweenWords(w, w2, ["types"]);
		}
		else if(sTermCategory.startsWith("wholeof"))
		{
			return blnNegativeMatch ^ this.IsThereSpecifiedRelationshipBetweenWords(w2, w, ["parts"]);
		}
		else if(sTermCategory.startsWith("categoryof"))
		{
			return blnNegativeMatch ^ this.IsThereSpecifiedRelationshipBetweenWords(w2, w, ["types"]);
		}
        else if(sTermCategory.startsWith("rgrp"))
		{
			var rgrpMatch = sTermCategory.match(/rgrp:?(\d+)?/);
			var nType = rgrpMatch[1] === undefined ? 1 : parseInt(rgrpMatch[1]);
			return blnNegativeMatch ^ (this.state.listRepetitionLinkGroups.filter(g => g.Type === nType).some(g => g.ListWords.includes(w.TextIndex) && g.ListWords.includes(w2.TextIndex)));	
		}
		else if(sTermToCheck.startsWith("corr"))
		{
			var corrMatch = sTermToCheck.match(/corr:\[?([\d,]+)?\]?/);
			var listTags = corrMatch[1] === undefined ? undefined : corrMatch[1].split(",").map(s => s.trim());

			return blnNegativeMatch ^ (this.listCorrespondencesForChapter.
				filter(g => listTags === undefined || g.ListTags.some(t => listTags.includes(t.CategoryID))).
				some(g => g.ListWords.includes(w.TextIndex) && g.ListWords.includes(w2.TextIndex)));
		}
		else if(sTermToCheck.startsWith("participant"))
		{
			var listParticipants = this.state.listRepetitionLinkGroups.some(g => g.Type === 2);
			var listParticipantsForWord1 = listParticipants.filter(g => g.ListWords.includes(w.TextIndex));
			var listParticipantsForWord2 = listParticipants.filter(g => g.ListWords.includes(w2.TextIndex));

			return blnNegativeMatch ^ listParticipantsForWord1.some(g1 => listParticipantsForWord2.some(g2 => 
				g1.ListTags.some(tag1 => g2.ListTags.some(tag2 => tag1.CategoryID === tag2.CategoryID))));
		}
		else if(sTermCategory.startsWith("syl"))
		{
			var sylMatch = sTermCategory.match(/syl:?(\d+)?/);
			var nTolerance = sylMatch[1] === undefined ? 1 : parseInt(sylMatch[1]);
			return blnNegativeMatch ^ (Math.abs(parseInt(w.SyllableCount) - parseInt(w2.SyllableCount)) <= nTolerance);		
		}
		else if(sTermCategory.startsWith("section"))
		{
			var sectionMatch = sTermCategory.match(/section(:)?([\w,]+)?/);
			if(sectionMatch === null)
				return false;
			else 
			{
				var listVersionIDs = sectionMatch[2] === undefined ? 2 : sectionMatch[2].split(",").map(s => s.trim());	
				return blnNegativeMatch ^ (this.GetLastSectionBreakBeforeWord(w2, listVersionIDs) === this.GetLastSectionBreakBeforeWord(w, listVersionIDs));
			}
		}
		else if(sTermCategory === "repetitiongroup")
		{
			var repGroup1 = this.GetRepetitionGroupForWord(w, listLinesToUse);
			var repGroup2 = this.GetRepetitionGroupForWord(w2, listLinesToUse);
			return blnNegativeMatch ^ (repGroup1 != undefined && repGroup1 === repGroup2);			
		}
		else if(sTermCategory === "repetitiongroupcluster")
		{
			var repGroupCluster1 = this.GetRepetitionGroupClusterForWord(w, listLinesToUse);
			var repGroupCluster2 = this.GetRepetitionGroupClusterForWord(w2, listLinesToUse);
			return blnNegativeMatch ^ (repGroupCluster1 != undefined && repGroupCluster1 === repGroupCluster2);			
		}

		//make sure the word types so the morph comparison is meaningful, (except for the WordType category!)
		//when matching root, make sure it doesn't match the same word                       
		var blnMorphMatch = 
			(sTermCategory === "type" && (blnNegativeMatch ^ (w2.WordType === w.WordType))) ||
			(sTermCategory === "s" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.Stem === w.Stem))) ||
			(sTermCategory === "f" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.Form === w.Form))) ||
			(sTermCategory === "p" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.Person === w.Person))) ||
			(sTermCategory === "g" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.Gender === w.Gender))) ||
			(sTermCategory === "n" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.Number === w.Number))) ||
			(sTermCategory === "pgn" && w2.WordType === w.WordType && (blnNegativeMatch ^ (this.GetPGN(w2) === this.GetPGN(w)))) ||
			(sTermCategory === "sfxpgn" && w2.WordType === w.WordType && (blnNegativeMatch ^ (this.GetSuffixPGN(w2) === this.GetSuffixPGN(w)))) ||
			(sTermCategory === "cs" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.ConstructState === w.ConstructState))) ||
			(sTermCategory === "prep" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.Preposition === w.Preposition))) ||
			(sTermCategory === "waw" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.Waw === w.Waw))) ||
			(sTermCategory === "art" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.DefiniteArticle === w.DefiniteArticle))) ||
			(sTermCategory === "interrogative" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.Interrogative === w.Interrogative))) ||
			(sTermCategory === "sp" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.SuffixPerson === w.SuffixPerson))) ||
			(sTermCategory === "sg" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.SuffixGender === w.SuffixGender))) ||
			(sTermCategory === "sn" && w2.WordType === w.WordType && (blnNegativeMatch ^ (w2.SuffixNumber === w.SuffixNumber))) ||
			(sTermCategory === "lex" && (blnNegativeMatch ^ (w2.LexicalID === w.LexicalID))) ||
			(sTermCategory === "texttype" && (blnNegativeMatch ^ (w2.clause_txt === w.clause_txt))) ||
			(sTermCategory === "clause" && (blnNegativeMatch ^ (w2.ClauseID === w.ClauseID))) ||
			(sTermCategory === "verse" && (blnNegativeMatch ^ (w2.Verse === w.Verse))) ||
            (sTermCategory === "pgrp" && (blnNegativeMatch ^ (this.GetPGroupForWord(w2) === this.GetPGroupForWord(w)))) ||
            (sTermCategory === "semoppprep" && (blnNegativeMatch ^ (this.ArePrepositionsSemanticallyOpposite(w2, w)))) ||
            (sTermCategory === "semsimprep" && (blnNegativeMatch ^ (this.ArePrepositionsSemanticallySimilar(w2, w)))) ||
            (sTermCategory === "perscompl13" && (blnNegativeMatch ^ (this.AreWordsFirstAndThirdPersonComplement(w2, w)))) ||
            (sTermCategory === "perscompl23" && (blnNegativeMatch ^ (this.AreWordsSecondAndThirdPersonComplement(w2, w)))) ||
            (sTermCategory === "perscompl12" && (blnNegativeMatch ^ (this.AreWordsFirstAndSecondPersonComplement(w2, w)))) ||
			(sTermCategory === "root" && w2.LexicalID !== w.LexicalID && (blnNegativeMatch ^ (w2.ParentRoot === w.ParentRoot && w2.ParentRoot != '')));
			
			return blnMorphMatch;
	}
	
	ObjectMatchesTerm(obj, sTerm, listAllLines, sObjType)
	{
		return sObjType === "line" ? this.LineMatchesTerm(obj, sTerm, listAllLines) : 
			sObjType === "clause" ? this.ClauseMatchesTerm(obj, sTerm) : 
			sObjType === "pgrp" ? this.PGroupMatchesTerm(obj, sTerm) : 
			sObjType === "cluster" ? this.ClusterMatchesTerm(obj, sTerm) : 
			this.WordMatchesMorph(obj, sTerm, listAllLines);
	}

	ObjectMatchesTermOfOtherObject(backReferencedObj, obj, sTerm, listAllLines, sObjType)
	{
		return sObjType === "line" ? this.LineMatchesTermOfOtherLine(backReferencedObj, obj, sTerm, listAllLines) :
			sObjType === "clause" ? this.ClauseMatchesTermOfOtherClause(backReferencedObj, obj, sTerm) : 
			sObjType === "pgrp" ? this.PGroupMatchesTermOfOtherPGroup(backReferencedObj, obj, sTerm) : 
			sObjType === "cluster" ? this.ClusterMatchesTermOfOtherCluster(backReferencedObj, obj, sTerm) : 
			this.WordMatchesMorphOfOtherWord(backReferencedObj, obj, sTerm, listAllLines);
	}

	TermMatches(listPrecedingMatches, obj, sTerm, listAllLines, sObjType)
	{
		//check for backreferences in the term like / or /1. If no number specified, default is previous index.
		var nBackReferenceIndex = undefined;
		var matchFirstBackReference = sTerm.match(/\/(\d+)?/);
		if(matchFirstBackReference !== null)
		{
			nBackReferenceIndex = matchFirstBackReference[1] === undefined ? 
				listPrecedingMatches.length - 1 : parseInt(matchFirstBackReference[1]) - 1;
		}
		var backReferencedObj = 
			nBackReferenceIndex === undefined || listPrecedingMatches === undefined ? undefined :
			listPrecedingMatches[nBackReferenceIndex];

		//console.log(w.TextIndex + " " + sTerm);
		//must match all subterms in the split array
		for(const sAndTerm of sTerm.split("&"))
		{
			var blnAndTermSatisfied = false;
			if(sAndTerm.includes("|"))
			{
				for(const sOrTerm of sAndTerm.split("|"))
				{
					if(sAndTerm.includes("/") && backReferencedObj !== undefined ?
					  	this.ObjectMatchesTermOfOtherObject(backReferencedObj, obj, sOrTerm, listAllLines, sObjType) : 
						this.ObjectMatchesTerm(obj, sOrTerm, listAllLines, sObjType)) 
					{
						blnAndTermSatisfied = true;
						break;
					}
				}
			}
			else		
			{	
				blnAndTermSatisfied = sAndTerm.includes("/") && backReferencedObj !== undefined ?
					this.ObjectMatchesTermOfOtherObject(backReferencedObj, obj, sAndTerm, listAllLines, sObjType) : 
					this.ObjectMatchesTerm(obj, sAndTerm, listAllLines, sObjType);
			}

			if(!blnAndTermSatisfied) return false;
		}

		return true;
	}

	ExtractSimilarityParametersFromString(sToExtractFrom)
	{
		var rgx = /sim[wl]:(\w+)/;
		var match = sToExtractFrom.match(rgx);
		if(match !== null)
		{
			var sWithoutIt = sToExtractFrom.replace(match[0], "");
			return [match[0], sWithoutIt];
		}
		else
			return ["", sToExtractFrom];
	}

	GetRangeForTerm(sTerm)
	{
		if(sTerm === "") return new NumberRange(1, 10000000000);  //e.g. a--b
		
		var matchTermRange = sTerm.match(/\{(\d)?,(\d)?\}/); 
		if(matchTermRange === null) 
			return new NumberRange(1, 1);	//e.g. a-b
		else
		{	
			//e.g. a-{2,3}-b
			var nTermOccursAtLeastHowManyTimes = 1;
			var nTermOccursAtMostHowManyTimes = 1;
		
			if(matchTermRange[1] !== undefined) 
				nTermOccursAtLeastHowManyTimes = parseInt(matchTermRange[1]);
			if(matchTermRange[2] !== undefined) 
				nTermOccursAtMostHowManyTimes = parseInt(matchTermRange[2]);
		}

		return new NumberRange(nTermOccursAtLeastHowManyTimes, nTermOccursAtMostHowManyTimes);
	}

	//check whether the min unit value in listObjectsToCompare is a specified dinstance away from the max unit value.
	SatisfiesConstraint(sConstrainedUnitType, sConstrainedUnitOperator, nConstrainedUnitValue, listObjectsToCompare, listLinesToUse, sObjType, listRepetitionGroupsToUse) 
	{ 
		if(sConstrainedUnitType === "" || sObjType === "clause" || sObjType === "cluster") return true;
        if(sObjType === "line" && sConstrainedUnitType != "repgrp") return true;

		var listUnitValues;
		if(sConstrainedUnitType === "l")
            listUnitValues = listObjectsToCompare.map(w => listLinesToUse.findIndex(r => r.Words.includes(w)));
		else if(sConstrainedUnitType === "repgrp")
		{
			if(sObjType === "line")
				listUnitValues = listObjectsToCompare.map(l => listRepetitionGroupsToUse.findIndex(r => r.Lines.includes(l)));
			else
				listUnitValues = listObjectsToCompare.map(w => listRepetitionGroupsToUse.findIndex(r => r.Lines.some(l => l.Words.includes(w))));
		}
		else if(sConstrainedUnitType === "v" && Object.keys(this.GroupArrayByKey(listObjectsToCompare, "Chapter")).length > 1)
			listUnitValues = [0, 1000000];
		else
		{
			var sField = sConstrainedUnitType === "v" ? "Verse" :
				sConstrainedUnitType === "p" ? "phrase_atom_number" :
				sConstrainedUnitType === "c" ? "ClauseID" :
				sConstrainedUnitType === "s" ? "sentence_atom_number" : "TextIndex";

			listUnitValues = listObjectsToCompare.map(w => parseInt(w[sField]));

			// nDiff =	sConstrainedUnitType === "w" ? parseInt(w1.TextIndex) - parseInt(w2.TextIndex) :
			// 	sConstrainedUnitType === "p" ? parseInt(w1.phrase_atom_number) - parseInt(w2.phrase_atom_number) :
			// 	sConstrainedUnitType === "c" ? parseInt(w1.ClauseID) - parseInt(w2.ClauseID) :
			// 	sConstrainedUnitType === "s" ? parseInt(w1.sentence_atom_number) - parseInt(w2.sentence_atom_number) : 
			// 	sConstrainedUnitType === "v" ? parseInt(w1.Chapter) != parseInt(w2.Chapter) ? 100000 : 
			// 		parseInt(w1.Verse) - parseInt(w2.Verse) : 0;
		}
		
		var nDiff = Math.abs(Math.max(...listUnitValues) - Math.min(...listUnitValues));
			 
		return sConstrainedUnitOperator === ">=" & nDiff >= nConstrainedUnitValue ? true :
			sConstrainedUnitOperator === "<=" & nDiff <= nConstrainedUnitValue ? true :
			sConstrainedUnitOperator === ">" & nDiff > nConstrainedUnitValue ? true :
			sConstrainedUnitOperator === ">" & nDiff >= nConstrainedUnitValue  ? true :
			sConstrainedUnitOperator === "=" & nDiff === nConstrainedUnitValue  ? true : false;
	};

	ParseConstraintString(sToParse)
	{
		var sConstrainedUnitType = "";
		var sConstrainedUnitOperator = "";
		var nConstrainedUnitValue = undefined;
		var unitConstraintMatch = sToParse.match(/([lcspvw]|repgrp|pgrpval)(>=|<=|>|<|=)(\d+)/);
		if(unitConstraintMatch !== null)
		{
			sConstrainedUnitType = unitConstraintMatch[1];
			sConstrainedUnitOperator = unitConstraintMatch[2];
			nConstrainedUnitValue = parseInt(unitConstraintMatch[3]);
			sToParse = sToParse.replace(unitConstraintMatch[0], "");
		}
		
		return { "MainString": sToParse, "UnitType": sConstrainedUnitType, 
			"Operator": sConstrainedUnitOperator, "Value": nConstrainedUnitValue}
	}

	WordSatisfiesLinePositionConstraint(w, term, listLinesToUse)
	{
		if(!term.AtLineStart && !term.AtLineEnd) return true;

		var lineItIsIn = listLinesToUse.find(r => r.Words.includes(w));
		if(lineItIsIn === undefined)
			return undefined;
		else
		{
			var nIndexInLine = lineItIsIn.Words.findIndex(r => r === w);
			return (term.AtLineStart && nIndexInLine === 0) || (term.AtLineEnd && nIndexInLine === lineItIsIn.Words.length - 1);
		}
	}

	FindQueryMatches(listToUse, sToFind, listAllLines, sObjType, listAllRepetitionGroups)
	{
		//X~ means "return only words where the property X changes from the previous word in the returned sequence
		var sPropertyChange = "";
		var propertyChangeMatch = sToFind.match(/\s+(\w+(:[\w,]+)?)\~/);
		if(propertyChangeMatch !== null)
		{
			sPropertyChange = propertyChangeMatch[1];
			sToFind = sToFind.replace(propertyChangeMatch[0], "");
		}

		var constraint = this.ParseConstraintString(sToFind);
		sToFind = constraint.MainString;
		sToFind = sToFind.replace(/\s+/g, "");
		if(sToFind === "") return;
		
		var listTerms = sToFind.split("-").map((s, i, arr) => 
			({QueryString: s.trim().replace(/(lineend|linestart)/gi, "").replace(/^\(/, "").replace(/\)$/, ""), 
			RangeFromPreviousTerm: i === 0 ? undefined : this.GetRangeForTerm(arr[i-1].trim()),
			AtLineStart: s.includes("linestart"), AtLineEnd: s.includes("lineend"), 
			IsNonCapturing: s.includes("("), ContainsBackReference: s.includes("/")}))
			.filter(o => o.QueryString != "" && !o.QueryString.includes("{")); 

		//for backreferences, let all objects in on first pass, then compare to previous on second pass.
		for(var nTerm = 0; nTerm < listTerms.length; nTerm++)
		{
			var currentTerm = listTerms[nTerm];
			currentTerm.Results = listToUse
				.filter(o => (sObjType != "word" || this.WordSatisfiesLinePositionConstraint(o, currentTerm, listAllLines)) && 
					(currentTerm.ContainsBackReference ? true : 
					 this.TermMatches(undefined, o, currentTerm.QueryString, listAllLines, sObjType)))
				.map(o => ({Object: o, SuccessChain: nTerm === 0 ? [[o]] : []}));
		}

		for(var nTerm = 1; nTerm < listTerms.length; nTerm++)
		{
			//compare one row to the previous and enforce adjacency
			//if no objects for a term match previous, break early for efficiency.
			var currentTerm = listTerms[nTerm];		
			var blnAtLeastOneObjectInThisTermIsAdjacentToPreviousTerm = false;			
			for(var oThis of currentTerm.Results)
			{
				var listPreviousOnesAdjacentToThis = listTerms[nTerm - 1].Results.filter(oPrev => 
					(currentTerm.ContainsBackReference ? this.TermMatches(oPrev.SuccessChain.flat(), oThis.Object, currentTerm.QueryString, listAllLines, sObjType) : true) &&
					currentTerm.RangeFromPreviousTerm.IndexInRange(
						(listToUse.findIndex(o3 => 
							sObjType === "clause" ? (o3.EndIndex === oThis.Object.EndIndex) : 
							sObjType === "line" ? (o3.TextIndexRangeEnd === oThis.Object.TextIndexRangeEnd) : 
							sObjType === "pgrp" ? (o3.Lines[0].TextIndexRangeEnd === oThis.Object.Lines[0].TextIndexRangeEnd) : 
							sObjType === "cluster" ? (o3.Lines[0].TextIndexRangeEnd === oThis.Object.Lines[0].TextIndexRangeEnd) : 
							(o3.TextIndex === oThis.Object.TextIndex)) - 
						 listToUse.findIndex(o3 => 
							sObjType === "clause" ? (o3.EndIndex === oPrev.Object.EndIndex) : 
							sObjType === "line" ? (o3.TextIndexRangeEnd === oPrev.Object.TextIndexRangeEnd) : 
							sObjType === "pgrp" ? (o3.Lines[0].TextIndexRangeEnd === oPrev.Object.Lines[0].TextIndexRangeEnd) : 
							sObjType === "cluster" ? (o3.Lines[0].TextIndexRangeEnd === oPrev.Object.Lines[0].TextIndexRangeEnd) : 
							(o3.TextIndex === oPrev.Object.TextIndex)))));

				if(!blnAtLeastOneObjectInThisTermIsAdjacentToPreviousTerm)
					blnAtLeastOneObjectInThisTermIsAdjacentToPreviousTerm = listPreviousOnesAdjacentToThis.length > 0;

                var copyOflistPreviousOnesAdjacentToThis = [];
                for(var o of listPreviousOnesAdjacentToThis)
                {
                    copyOflistPreviousOnesAdjacentToThis.push(o.SuccessChain.flat());
                }

                //oThis.SuccessChain = listPreviousOnesAdjacentToThis.flatMap(o => o.SuccessChain);
				oThis.SuccessChain = copyOflistPreviousOnesAdjacentToThis; //Array.from(listPreviousOnesAdjacentToThis.flatMap(o => Array.from(o.SuccessChain)));
				if(!currentTerm.IsNonCapturing)
					oThis.SuccessChain.forEach(arr => arr.push(oThis.Object));

				// listPreviousOnesAdjacentToThis.flatMap(o => 
				// 	currentTerm.IsNonCapturing ? [o.SuccessChain] : [o.SuccessChain.concat([oThis.Object])]);
			}

			if(!blnAtLeastOneObjectInThisTermIsAdjacentToPreviousTerm) break;
		}

		//make sure all the objects in each sequence satisfy the constraint as a group (e.g. they're all in the same clause)
		var listSequencesFound = listTerms[listTerms.length - 1].Results
			.filter(o => o.SuccessChain.length > 0).flatMap(o => o.SuccessChain)		
			.filter(arrayOfObjects => this.SatisfiesConstraint(constraint.UnitType, constraint.Operator, constraint.Value, arrayOfObjects, listAllLines, sObjType, listAllRepetitionGroups));

		//var sTest = listSequencesFound.map(arr => arr.map(w => w.TextIndex).join(" ")).join(", ")

		if(sPropertyChange != "")
		{
			//compare only the first element ([0]) of each matched sequence
			return listSequencesFound
			.sort((arr1, arr2) => 
				sObjType === "cluster" ? (parseInt(arr1[0].Lines[0].TextIndexRangeEnd) - parseInt(arr2[0].Lines[0].TextIndexRangeEnd)) : 
				sObjType === "pgrp" ? (parseInt(arr1[0].Lines[0].TextIndexRangeEnd) - parseInt(arr2[0].Lines[0].TextIndexRangeEnd)) : 
				sObjType === "line" ? (parseInt(arr1[0].TextIndexRangeEnd) - parseInt(arr2[0].TextIndexRangeEnd)) : 
				sObjType === "clause" ? (parseInt(arr1[0].EndIndex) - parseInt(arr2[0].EndIndex)) : 
				(parseInt(arr1[0].TextIndex) - parseInt(arr2[0].TextIndex)))
			.filter((arr, i, listofarr) => i != 0 && (!this.ObjectMatchesTermOfOtherObject(listofarr[i - 1][0], arr[0], sPropertyChange, listAllLines, sObjType)));
		}
		else
			return listSequencesFound; //.map(seq => seq.map(w => w.Object));
	}

	FindQueryMatchesChaining(listWordsToUse, sToFind, listAllLines, listAllClauses, listAllRepetitionGroups, listAllRepetitionGroupClusters)
	{
		var listQueryChain = sToFind.split("#");
		var listWordsToUseFiltered = listWordsToUse;
		var listLinesToUseFiltered = listAllLines;
		var listClausesToUseFiltered = listAllClauses;
		var listRepetitionGroupsToUseFiltered = listAllRepetitionGroups;
		var listRepetitionGroupClustersToUseFiltered = listAllRepetitionGroupClusters;

		for(var n = 0; n < listQueryChain.length; n++)
		{
			var sToFindPart = listQueryChain[n].trim();

			var sObjType = "word";
			var listToUse = listWordsToUseFiltered;
			var objTypeMatch = sToFindPart.match(/^\s*(line|clause|pgrp|cluster)s\b/);
			if(objTypeMatch !== null)
			{
				sObjType = objTypeMatch[1];
				if(sObjType === "line") listToUse = listLinesToUseFiltered;
				else if(sObjType === "clause") listToUse = listClausesToUseFiltered;
				else if(sObjType === "pgrp") listToUse = listRepetitionGroupsToUseFiltered;
				else if(sObjType === "cluster") listToUse = listRepetitionGroupClustersToUseFiltered;
				sToFindPart = sToFindPart.replace(objTypeMatch[0], "");
			}

			if(n === listQueryChain.length - 1)
			{
                //whatever object it is, return word sequences at the end.
                var listWordsToReturn = undefined;
				var listFinalSequences = this.FindQueryMatches(listToUse, sToFindPart, listAllLines, sObjType, listAllRepetitionGroups);
				if(listFinalSequences != undefined) 
				    listWordsToReturn = (sObjType === "line" || sObjType === "clause") ? 
                        listFinalSequences.map(arroflines => arroflines.flatMap(l => l.Words)) : 
                        (sObjType === "pgrp" || sObjType === "cluster") ? 
                        listFinalSequences.map(arroflinegroups => arroflinegroups.flatMap(lg => lg.Lines.flatMap(l => l.Words))) : 
                        listFinalSequences;
                    
                return {MatchingWords: listWordsToReturn, MainObjectType: sObjType};
			}
			else
			{
				//keep the various object lists in sync, in case e.g. one part of the chain is word, another is line.
				var listResultingObjects = this.FindQueryMatches(listToUse, sToFindPart, listAllLines, sObjType, listAllRepetitionGroups).flat();
				if(sObjType === "line")
				{
					listLinesToUseFiltered = listResultingObjects;
					listWordsToUseFiltered = listWordsToUseFiltered.filter(w => listLinesToUseFiltered.some(l => l.Words.includes(w)));
					listClausesToUseFiltered = listClausesToUseFiltered.filter(c => listLinesToUseFiltered.some(l => l.Words.some(w => c.Words.includes(w))));
					listRepetitionGroupsToUseFiltered = listRepetitionGroupsToUseFiltered.filter(g => listLinesToUseFiltered.some(l => g.Lines.includes(l)));				
					listRepetitionGroupClustersToUseFiltered = listRepetitionGroupClustersToUseFiltered.filter(g => listLinesToUseFiltered.some(l => g.Lines.includes(l)));
				}
				else if(sObjType === "clause")
				{
					listClausesToUseFiltered = listResultingObjects;
					listLinesToUseFiltered = listLinesToUseFiltered.filter(l => listClausesToUseFiltered.some(c => c.Words.some(w => l.Words.includes(w))));
					listWordsToUseFiltered = listWordsToUseFiltered.filter(w => listClausesToUseFiltered.some(c => c.Words.includes(w)));
					listRepetitionGroupsToUseFiltered = listRepetitionGroupsToUseFiltered.filter(g => listClausesToUseFiltered.some(c => c.Words.some(w => g.Lines.some(l => l.Words.includes(w)))));
					listRepetitionGroupClustersToUseFiltered = listRepetitionGroupClustersToUseFiltered.filter(g => listClausesToUseFiltered.some(c => c.Words.some(w => g.Lines.some(l => l.Words.includes(w)))));								
				}
				else if(sObjType === "pgrp")
				{
					listRepetitionGroupsToUseFiltered = listResultingObjects;
					listRepetitionGroupClustersToUseFiltered = listRepetitionGroupClustersToUseFiltered.filter(g => listRepetitionGroupsToUseFiltered.some(g2 => g2.Lines.some(l => g.Lines.includes(l))));
					listLinesToUseFiltered = listLinesToUseFiltered.filter(l => listRepetitionGroupsToUseFiltered.some(g => g.Lines.includes(l)));
					listWordsToUseFiltered = listWordsToUseFiltered.filter(w => listRepetitionGroupsToUseFiltered.some(g => g.Lines.some(l => l.includes(w))));
					listClausesToUseFiltered = listClausesToUseFiltered.filter(c => listRepetitionGroupsToUseFiltered.some(g => g.Lines.some(l => c.Words.some(w => l.includes(w)))));				
				}
				else if(sObjType === "cluster")
				{
					listRepetitionGroupClustersToUseFiltered = listResultingObjects;
					listRepetitionGroupsToUseFiltered = listRepetitionGroupsToUseFiltered.filter(g => listRepetitionGroupClustersToUseFiltered.some(g2 => g2.Lines.some(l => g.Lines.includes(l))));
					listLinesToUseFiltered = listLinesToUseFiltered.filter(l => listRepetitionGroupClustersToUseFiltered.some(g => g.Lines.includes(l)));
					listWordsToUseFiltered = listWordsToUseFiltered.filter(w => listRepetitionGroupClustersToUseFiltered.some(g => g.Lines.some(l => l.includes(w))));
					listClausesToUseFiltered = listClausesToUseFiltered.filter(c => listRepetitionGroupClustersToUseFiltered.some(g => g.Lines.some(l => c.Words.some(w => l.includes(w)))));
				}
				else
				{
					listWordsToUseFiltered = listResultingObjects;
					listLinesToUseFiltered = listLinesToUseFiltered.filter(l => l.Words.some(w => listWordsToUseFiltered.includes(w)));
					listClausesToUseFiltered = listClausesToUseFiltered.filter(c => c.Words.some(w => listWordsToUseFiltered.includes(w)));
					listRepetitionGroupsToUseFiltered = listRepetitionGroupsToUseFiltered.filter(g => listWordsToUseFiltered.some(w => g.Lines.some(l => l.Words.includes(w))));
					listRepetitionGroupClustersToUseFiltered = listRepetitionGroupClustersToUseFiltered.filter(g => listWordsToUseFiltered.some(w => g.Lines.some(l => l.Words.includes(w))));					
				}			
			}
		}
	}

	CalculatePhonologicalSimilarity(w1, w2)
	{
		var nTotalScore = 0;
		var listLinkDescriptions = [];

		//another way: if word is in same sentence, >= 1 letters in common 
		//else, >= 2 letters in common or 1 rhyme

		var nNumberOfConsonantsInCommonThreshold = 2;
		var charsForWord1 = Array.from(w1.FullText);
		var charsForWord2 = Array.from(w2.FullText);

		var w1Consonants = charsForWord1.filter(c => this.IsConsonant(c));
		var w2Consonants = charsForWord2.filter(c => this.IsConsonant(c));	
		var w1Vowels = charsForWord1.filter(c => this.IsVowel(c));
		var w2Vowels = charsForWord2.filter(c => this.IsVowel(c));

		var listConsonantsInCommon = w1Consonants.filter(c => w2Consonants.includes(c));
		if(listConsonantsInCommon.length >= nNumberOfConsonantsInCommonThreshold)
		{
			nTotalScore += 1.0 * listConsonantsInCommon.length;
			var listVowelsInCommon = w1Vowels.filter(c => w2Vowels.includes(c));
			listLinkDescriptions.push("Consonants: " + listConsonantsInCommon.join(",") + 
				", Vowels: " + listVowelsInCommon.join(","));
		}

		//TODO: same number of syllables?

		//rhyme: start or end same consonant or vowel
		//TODO: check for same vowel sequence in word?
		//TODO: allow same rhyme group with SimilarityScore >= 0.7 to count as rhyme
		//TODO: instead of just begin and end rhyme, maybe have syllable divisions 
		//and check for first consonant and vowel at syllable divisions.

		if(w1Consonants.length > 0 && w2Consonants.length > 0)
		{
			if(w1Consonants[0] === w2Consonants[0])
			{
				nTotalScore += 2.0;
				listLinkDescriptions.push("Initial Rhyme: " + w1Consonants[0]);	
			}
			
			if(w1Consonants[w1Consonants.length - 1] === w2Consonants[w2Consonants.length - 1])
			{
				nTotalScore += 2.0;
				listLinkDescriptions.push("End Rhyme: " + w1Consonants[0]);	
			}
		}

		if(w1Vowels.length > 0 && w2Vowels.length > 0)
		{
			if(w1Vowels[0] === w2Vowels[0])
			{
				nTotalScore += 2.0;
				listLinkDescriptions.push("Initial Rhyme: " + w1Vowels[0]);	
			}
			
			if(w1Vowels[w1Vowels.length - 1] === w2Vowels[w2Vowels.length - 1])
			{
				nTotalScore += 2.0;
				listLinkDescriptions.push("End Rhyme: " + w1Vowels[0]);	
			}
		}

		return { Score: nTotalScore, LinkDescriptionsList: listLinkDescriptions };

		//phonological similarity between words: starting from first letter of first word,
		//compare that letter to all the letters of the other word. Repeat for the rest of
		//the letters of the first word. HebrewChars table contains different levels of similarity
		//between characters, if not in there, is 0%. Add all the scores for each comparison
		//and divide by FirstWord.Length * SecondWord.Length to get similarityScorePerLetter.
		//If the letters are very similar and the WordPositionPercent is similar, give that comparison
		//extra weight, and label it as a rhyme for a separate view.
		
		// var nLetterPositionPercentMultiplier = 5;

		// for(var nLetter1 = 0; nLetter1 < charsForWord1.length; nLetter1++)
		// {
		// 	var letter1 = charsForWord1[nLetter1];
		// 	for (var nLetter2 = 0; nLetter2 < charsForWord2.length; nLetter2++)
		// 	{
		// 		var letter2 = charsForWord2[nLetter2];

		// 		var nScoreToAdd = 0.0;
		// 		var nLetterPositionPercentOne = nLetter1 / (1.0 * w1.FullText.length);
		// 		var nLetterPositionPercentTwo = nLetter2 / (1.0 * w2.FullText.length);
		// 		var nLetterPositionPercentScore = 0; //nLetterPositionPercentMultiplier * (1 - Math.abs(nLetterPositionPercentOne - nLetterPositionPercentTwo));

		// 		if (letter1 === letter2)
		// 			nScoreToAdd += 1.0 + nLetterPositionPercentScore;
		// 		else
		// 		{
		// 			//see if they both belong to the same group of similar sounds.
		// 			//if not, at least give a little score so that similar length words 
		// 			//receive a higher score.
		// 			var listRhymeGroupsForOne = this.listRhymeGroups.filter(r => r.HebrewText.split(',').includes(letter1));
		// 			var listRhymeGroupsForTwo = this.listRhymeGroups.filter(r => r.HebrewText.split(',').includes(letter2));
		// 			var listRhymeGroupsBothAreIn = listRhymeGroupsForOne.filter(r => listRhymeGroupsForTwo.includes(r));
		// 			nScoreToAdd += listRhymeGroupsBothAreIn.length === 0 ? 0.2 :
		// 				Math.max(...listRhymeGroupsBothAreIn.map(r => r.SimilarityPercent))  + nLetterPositionPercentScore;
		// 		}

		// 		nTotalScore += nScoreToAdd;
		// 	}
		// }

		// return nTotalScore; // / (w1.FullText.length * w2.FullText.length);
	}

	CalculateMorphologicalSimilarity(w1, w2)
	{
		var nTotalScore = 0.0;
		var listLinkDescriptions = [];

		if (w1.WordType !== w2.WordType) 
			return { Score: 0.0, LinkDescriptionsList: [] };
		else 
		{
			nTotalScore += 3.0;
			listLinkDescriptions.push("Word Type: " + w1.WordType);
		}

		//TODO: add listLinkDescriptions for the below
		//stems that are similar but not the same are q and Q, p and P, h and H     
		if (w1.WordType === "V")
		{
			if (w1.Stem === w2.Stem)
				nTotalScore += 1.0;
			else
			{
				var sStemGroup1 = this.listHebrewVerbStems.filter(r => r.Abbr === w1.Stem).map(r => r.StemGroup)[0];
				var sStemGroup2 = this.listHebrewVerbStems.filter(r => r.Abbr === w2.Stem).map(r => r.StemGroup)[0];
				if (sStemGroup1 === sStemGroup2)
					nTotalScore += 0.5;
			}
			
			if (w1.Form === w2.Form) 
				nTotalScore += 2.0;
			else
			{
				var sFormGroup1 = this.listHebrewVerbForms.filter(r => r.Abbr === w1.Form).map(r => r.FormGroup)[0];
				var sFormGroup2 = this.listHebrewVerbForms.filter(r => r.Abbr === w2.Form).map(r => r.FormGroup)[0];
				if (sFormGroup1 === sFormGroup2)
					nTotalScore += 1.5;
			}
		}

		if (w1.Person !== undefined && w1.Person === w2.Person) nTotalScore += 1.0;
		if (w1.Gender !== undefined && w1.Gender === w2.Gender) nTotalScore += 0.7;
		if (w1.Number !== undefined && w1.Number === w2.Number) nTotalScore += 1.0;

		if (w1.SuffixPerson !== undefined && w1.SuffixPerson === w2.SuffixPerson) nTotalScore += 1.0;
		if (w1.SuffixGender !== undefined && w1.SuffixGender === w2.SuffixGender) nTotalScore += 0.7;
		if (w1.SuffixNumber !== undefined && w1.SuffixNumber === w2.SuffixNumber) nTotalScore += 1.0;

		if (w1.Waw !== "0" && w1.Waw === w2.Waw) nTotalScore += 0.75;
		if (w1.Preposition !== undefined && w1.Preposition === w2.Preposition) nTotalScore += 0.75;
		if (w1.DefiniteArticle !== "0" && w1.DefiniteArticle === w2.DefiniteArticle) nTotalScore += 0.75;
		if (w1.AttachedRelative !== "0" && w1.AttachedRelative === w2.AttachedRelative) nTotalScore += 0.75;
		if (w1.Interrogative !== "0" && w1.Interrogative === w2.Interrogative) nTotalScore += 0.75;

		return { Score: nTotalScore, LinkDescriptionsList: listLinkDescriptions };
	}

	// GetSemanticDomainsForWord(w)
	// {
	// 	var listLexemesForThisWord = this.listLexemes.filter(r => r.ID === w.LexicalID);
	// 	if(listLexemesForThisWord.length === 0) return [];

	// 	var sSemanticDomains = this.listLexemes.filter(r => r.ID === w.LexicalID)[0].SemanticDomains;
	// 	if(sSemanticDomains === undefined) 
	// 		return [];
	// 	return sSemanticDomains.split(/[,>]/).map(s => s.trim());
	// }

	// CalculateSemanticDomainsShared(w1, w2)
	// {
	// 	return this.GetSemanticDomainsForWord(w1).filter(s => this.GetSemanticDomainsForWord(w2).includes(s));
	// }

	FindNodesForWord(word)
	{
		return this.state.listSemanticNodes.filter(n => n.LexicalIDs.find(r => r.ID === parseInt(word.LexicalID)) != undefined);
	}

	FindSDBHDomainsForWord(word, sType)
	{
		return this.listSDBH.filter(o => o.Type === sType && o.ListWords.some(n => n === parseInt(word.TextIndex)));  //&& o.Type === "l"/"c"
	}

	FindNodesByName(sName)
	{
		var rgxToMatchNode = new RegExp("\\b" + sName + "\\b");
		return this.state.listSemanticNodes.filter(n => n.Names.match(rgxToMatchNode));
	}

	FindNodeByID(nID)
	{
		return this.state.listSemanticNodes.find(n => n.ID === nID);
	}

    GetAllNodesThatAreTypesOrPartsOfNode(nodeIDToStartAt, listNodeIDsToExclude, listResultingLexicalIDs, listLinksTraversed)
	{
        //if subnode type, recurse down to its subnodes, but if it is other, don't go down just take the words in that node
        var listLinkTypesToExclude = ["causedby", "resultsin", "doneby", "char", "belongsto", "ableto", "doneto", "beginpoint", "endpoint", "appliesto", "polarity"];
        var node = this.FindNodeByID(nodeIDToStartAt);
        listResultingLexicalIDs.push(node.LexicalIDs.map(o => o.ID));

        var listLinksWithNode = this.listSemanticLinks.filter(l => 
            !listLinksTraversed.includes(l) && !listLinkTypesToExclude.includes(l.type) &&
            (l.node1 === nodeIDToStartAt && !listNodeIDsToExclude.includes(l.node2)));	

        var listTypeOrPartLinks = listLinksWithNode.filter(l => l.type === "types" || l.type === "parts");
        // var listNonTypeOrPartLinks = listLinksWithNode.filter(l => !(l.type === "types" || l.type === "parts"));	
        
        // for(var linkToEndAt of listNonTypeOrPartLinks)
        // {
        //     var otherNodeID = linkToEndAt.node1 === nodeIDToStartAt ? linkToEndAt.node2 : linkToEndAt.node1;
        //     var otherNode = this.FindNodeByID(otherNodeID);
        //     listResultingLexicalIDs.push(otherNode.LexicalIDs.map(o => o.ID));
        // }

        if(listTypeOrPartLinks.length === 0)
        {
            return listResultingLexicalIDs;
        }
        else
        {
            for(var linkToExplore of listTypeOrPartLinks)
            {
                listLinksTraversed.push(linkToExplore);
                var otherNode = linkToExplore.node1 === nodeIDToStartAt ? linkToExplore.node2 : linkToExplore.node1;
                return this.GetAllNodesThatAreTypesOrPartsOfNode(otherNode, listNodeIDsToExclude, listResultingLexicalIDs, listLinksTraversed);				
            }
        }
    }
    
	//check all the links from nodeIDToStartAt for direct connection to nodeIDToFind. 
	//if not found, check all the nodes on each of those links
	//nLinkLevelsLeft should never be undefined so we can avoid infinite loops on graph cycles
	DistanceToNodeFromNodeViaDirectOrAdjacentLinks(nodeIDToFind, nodeIDToStartAt, result, nLinkLevelsLeft, listLinkTypesAllowed, nNodeToCheckInLinks)
	{
		var listLinksToExplore = this.listSemanticLinks.filter(l => 
			(listLinkTypesAllowed === undefined || listLinkTypesAllowed.includes(l.type)) && 
			(nNodeToCheckInLinks === 1 ? (l.node1 === nodeIDToStartAt) :
			 nNodeToCheckInLinks === 2 ? (l.node2 === nodeIDToStartAt) : 
			 (l.node1 === nodeIDToStartAt || l.node2 === nodeIDToStartAt)));	

		//if nNodeToCheckInLinks is 1 or 2, check the opposite side of the link 
		var listValidLinks = listLinksToExplore.filter(l => 
			 nNodeToCheckInLinks === 1 ? (l.node2 === nodeIDToFind) :
			 nNodeToCheckInLinks === 2 ? (l.node1 === nodeIDToFind) : 
			 (l.node1 === nodeIDToFind || l.node2 === nodeIDToFind))

		result.CurrentLinkDistance++;

		if(listValidLinks.length > 0)
		{
			result.LinksTraversed.push(listValidLinks[0]);
			return result;
		}
		else if(nLinkLevelsLeft === 0)
		{
			return undefined;
		}
		else
		{
			for(var linkToCheck of listLinksToExplore)
			{
				result.LinksTraversed.push(linkToCheck);
				var adjacentNodeToCheck = linkToCheck.node1 === nodeIDToStartAt ? linkToCheck.node2 : linkToCheck.node1;
				var resultOfCheck = this.DistanceToNodeFromNodeViaDirectOrAdjacentLinks(nodeIDToFind, adjacentNodeToCheck, result, nLinkLevelsLeft - 1, listLinkTypesAllowed, nNodeToCheckInLinks);
				if(resultOfCheck != undefined) return resultOfCheck;

				// var nMinLinkDistance = undefined;
				// for(var link in listLinksToExplore)
				// {
				// 	var nLinkDistance = if(nLinkDistance != undefined && nLinkDistance < nMinLinkDistance)
				// 		nMinLinkDistance = nLinkDistance;
				// }
				// return nMinLinkDistance != undefined && nMinLinkDistance <= nMaxLinkDistance;
			}

			return undefined;
		}
	}
	
	WordHasSpecifiedRelationshipToNode(hyperNodeID, wordToCheck, listLinkTypes)
	{
		var wordTag = this.GetWordTagForWord(wordToCheck)
		var nodeIDsToFind = wordTag != undefined ? wordTag.SemanticCategoryIDs : this.FindNodesForWord(wordToCheck).map(n => n.ID);
		if(hyperNodeID === undefined || nodeIDsToFind.length === 0) return undefined;
		if(nodeIDsToFind.some(n => n === hyperNodeID)) return true;

		for(var nID of nodeIDsToFind)
		{
			for(var sLinkType of listLinkTypes)
			{
				var result = this.DistanceToNodeFromNodeViaDirectOrAdjacentLinks(nID, hyperNodeID, {"Word1": wordToCheck, "Word2": undefined, "NodeToStartAt": hyperNodeID, "NodeToFind": nID, "CurrentLinkDistance": 0, "LinksTraversed": []}, 100, sLinkType , 1);
				if(result != undefined)
				{
					if(this.blnSemanticLinksDebugView)
						this.listForSemanticDebugging.push(result);
					return true;
				}
			}
		}
	}

	WordIsASemanticTypeOrPartOfNode(hyperNodeID, wordToCheck)
	{
		return this.WordHasSpecifiedRelationshipToNode(hyperNodeID, wordToCheck, ["types", "parts"]);
	}

	SemanticDistanceBetweenNodes(n1, n2, nMaxLinkDistance, blnReturnTrueIfTheyAreSameNode, listLinkTypesAllowed)
	{
		if(n1 === n2) return blnReturnTrueIfTheyAreSameNode ? 0 : undefined;
		if(n1 === undefined || n2 === undefined) return undefined;

		var result = this.DistanceToNodeFromNodeViaDirectOrAdjacentLinks(n1.ID, n2.ID, {"Word1": undefined, "Word2": undefined, "NodeToStartAt": n1, "NodeToFind": n2, "CurrentLinkDistance": 0, "LinksTraversed": []}, nMaxLinkDistance, listLinkTypesAllowed, undefined);
		
		if(this.blnSemanticLinksDebugView && result != undefined)
			this.listForSemanticDebugging.push(result);
		
		return result;
	}

	SemanticDistanceBetweenNodeAndWord(nodeToStartAt, word, nMaxLinkDistance, blnReturnTrueIfTheyAreSameNode, listLinkTypesAllowed)
	{
		var nodesToFind = this.FindNodesForWord(word);
		if(nodeToStartAt === undefined || nodesToFind.length === 0) return undefined;
		if(nodesToFind.every(n => n === nodeToStartAt)) return blnReturnTrueIfTheyAreSameNode ? 0 : undefined;

		var resultWithShortestDistance = undefined;
		for(var nToFind of nodesToFind)
		{
			var result = this.DistanceToNodeFromNodeViaDirectOrAdjacentLinks(nToFind.ID, nodeToStartAt.ID, {"Word1": word, "Word2": undefined, "NodeToStartAt": nodeToStartAt, "NodeToFind": nToFind, "CurrentLinkDistance": 0, "LinksTraversed": []}, nMaxLinkDistance, listLinkTypesAllowed, undefined);
			if(result != undefined && (resultWithShortestDistance === undefined || result.CurrentLinkDistance < resultWithShortestDistance.CurrentLinkDistance))
				resultWithShortestDistance = result;
		}

		if(this.blnSemanticLinksDebugView && resultWithShortestDistance != undefined)
			this.listForSemanticDebugging.push(resultWithShortestDistance);
		
		return resultWithShortestDistance === undefined ? undefined : resultWithShortestDistance.CurrentLinkDistance;
	}

	//link distance 0 means they are at the same node
	SemanticDistanceBetweenWords(w1, w2, nMaxLinkDistance, blnReturnTrueIfTheyAreSameNode, listLinkTypesAllowed)
	{
		//{"Nodes":[
		//{ ID:1, "Desc":"sky, heaven", "LexicalIDs":["ID":24,"ID":27]} 
		//]}
		//{"Links":[{"type":"part","node1":1,"node2":28}]

		var nodesToStartAt = this.FindNodesForWord(w1);		
		var nodesToFind = this.FindNodesForWord(w2);
		if(nodesToStartAt.length === 0 || nodesToFind.length === 0) return undefined;
		if(nodesToFind.every(n => nodesToStartAt.includes(n))) return blnReturnTrueIfTheyAreSameNode ? 0 : undefined;

		var resultWithShortestDistance = undefined;
		for(var nToStartAt of nodesToStartAt)
		{
			for(var nToFind of nodesToFind)
			{
				var result = this.DistanceToNodeFromNodeViaDirectOrAdjacentLinks(nToFind.ID, nToStartAt.ID, {"Word1": w1, "Word2": w2, "NodeToStartAt": nToStartAt, "NodeToFind": nToFind, "CurrentLinkDistance": 0, "LinksTraversed": []}, nMaxLinkDistance, listLinkTypesAllowed, undefined);
				if(result != undefined && (resultWithShortestDistance === undefined || result.CurrentLinkDistance < resultWithShortestDistance.CurrentLinkDistance))
					resultWithShortestDistance = result;
			}
		}
		
		if(this.blnSemanticLinksDebugView && resultWithShortestDistance != undefined)
			this.listForSemanticDebugging.push(resultWithShortestDistance);

		return resultWithShortestDistance === undefined ? undefined : resultWithShortestDistance.CurrentLinkDistance;
	}

	WordsSemanticallySimilarEnough(w1, w2, nMaxLinkDistance, blnReturnTrueIfTheyAreSameNode, listLinkTypesAllowed)
	{
		var nLinkDistance = this.SemanticDistanceBetweenWords(w1, w2, nMaxLinkDistance, blnReturnTrueIfTheyAreSameNode, listLinkTypesAllowed);
		return nLinkDistance != undefined && nLinkDistance <= nMaxLinkDistance;
	}

	//semantic similarity between words: 100% - same lexical id, 90% - same root, 
	//80% common word pair in lexical group, 70% synonym in lexical group, 60% antonym
	//otherwise use the BERT embedding dot product. Use the root, not lexical ID,
	//to represent each word to the embedding function.
	CalculateSemanticSimilarity(w1, w2, nMaxLinkDistance)
	{
		if (w1.LexicalID === w2.LexicalID)
		{
			return { Score: 1.0, LinkDescriptionsList: ["Same Word"] };
		}
		else if (w1.ParentRoot === w2.ParentRoot && w1.ParentRoot != '')
		{
			return { Score: 0.85, LinkDescriptionsList: ["Same Root"] };
		}
		else
		{
			var nLinkDistance = this.SemanticDistanceBetweenWords(w1, w2, nMaxLinkDistance, true);
			return { Score: (nLinkDistance === undefined ? 0 : Math.max(0, 0.7 - (nLinkDistance * 0.15))), LinkDescriptionsList: ["Ontology"] };
		}
	}
	
	//syntactic similarity between words: 1) same phrase function, 2) similar ClausePositionPercent
	//(WordIndexInClause / ClauseLength). Add these two with some weightings.
	CalculateSyntacticSimilarity(w1, w2)
	{
		var nScore = 0.0;
		var listLinkDescriptions = [];

		var listWordsInSameLineAsWordOne = this.state.listLines.filter(r => r.Words.includes(w1))[0];
		var listWordsInSameLineAsWordTwo = this.state.listLines.filter(r => r.Words.includes(w2))[0];

		//clause position percent
		var nWordOneIndexInClause = listWordsInSameLineAsWordOne.indexOf(w1);
		var nWordTwoIndexInClause = listWordsInSameLineAsWordTwo.indexOf(w2);
		var nClausePositionPercentOne = nWordOneIndexInClause / (1.0 * listWordsInSameLineAsWordOne.length);
		var nClausePositionPercentTwo = nWordTwoIndexInClause / (1.0 * listWordsInSameLineAsWordTwo.length);
		nScore += 1 - Math.abs(nClausePositionPercentOne - nClausePositionPercentTwo);
		
		//phrase function
		if(this.GetPhraseFunction(w1) === this.GetPhraseFunction(w2))
		{
			nScore += 1;
			listLinkDescriptions.push("Phrase Function (" + this.GetPhraseFunction(w1) + ")");
		}

		return { Score: nScore, LinkDescriptionsList: listLinkDescriptions };
	}

    GroupArray(xs)
	{
		return xs.reduce(function(rv, x) {
		  (rv[x] = rv[x] || []).push(x);
		  return rv;
		}, {});
	}

	GroupArrayByKey(xs, key) 
	{
		return xs.reduce(function(rv, x) {
		  (rv[x[key]] = rv[x[key]] || []).push(x);
		  return rv;
		}, {});
	};

	// GroupBySemanticDomain(listWords) 
	// {
	// 	var listLexemes = this.listLexemes;
	// 	return listWords.reduce(function(rv, w) {
	// 		//var lexemeRow = listLexemes.find(r => r.ID === w.LexicalID);
	// 		var lexemeForThisWord = listLexemes.find(r => r.ID === w.LexicalID);
	// 		var sSemanticDomains = lexemeForThisWord === undefined ? undefined : lexemeForThisWord.SemanticDomains;
	// 		var sFirstDomain = sSemanticDomains === undefined ? "" : sSemanticDomains.split(/[,>]/).map(s => s.trim())[0];
	// 		(rv[sFirstDomain] = rv[sFirstDomain] || []).push(w);
	// 		return rv;
	// 	}, {});
	// };

	GroupByLetters(listWords, sParameter) 
	{
		var dictToReturn = new Map();
		var sMode = 
			sParameter.includes("consonant") ? "consonant" : 
			sParameter.includes("vowel") ? "vowel" : "all";

		var listCharsToDo = this.listHebrewChars.filter(c => 
			(sMode === "consonant" && c.Consonant === "1") ||
			(sMode === "vowel" && (c.LongVowel === "1" || c.ShortVowel === "1")) ||
			sMode === "all").sort((a,b) => a < b);
		for(var c of listCharsToDo)
		{
			dictToReturn.set(c.Char, listWords.filter(w => w.FullText.includes(c.Char)));
		}
		return dictToReturn;
	};

	GroupByRepeated(listWordsToUse, sMorphCode)
	{
		var groupByRepeatedMatch = sMorphCode.match(/withrepeated:(\w+),?(\d+)?/);
		if(groupByRepeatedMatch === null) return;
		
		var sField = groupByRepeatedMatch[1];
		var nTimesRepeated = groupByRepeatedMatch[2] === undefined ? 2 : parseInt(groupByRepeatedMatch[2]);
		var listRepeatGroups = [];

		//test to see if the field actually exists in the objects in the list
		var listApplicableWords = sField === "semanticdomain" ? listWordsToUse : listWordsToUse.filter(w => w[sField] !== undefined);
		if(listApplicableWords.length > 0)
		{
			var groupedValuesObject = this.GroupArrayByKey(listApplicableWords, sField);

			for(var k of Object.keys(groupedValuesObject))
			{
				var listInGroup = groupedValuesObject[k];

				if(sField === "ParentRoot")
				{
					//don't add if they all have the same LexicalID
					var lexicalIDTestGrouping = this.GroupArrayByKey(listInGroup, "LexicalID");
					if(Object.keys(lexicalIDTestGrouping).length < nTimesRepeated) continue;
				}

				if(k !== "" && listInGroup.length >= nTimesRepeated)
					listRepeatGroups.push(listInGroup);
			}
		}

		return listRepeatGroups;
	}


	
	//pattern report
	//for each type of linking criterion, start at first word in chapter and look for a chain of other words that
	//meet the same criterion that are within the same clause/sentence or at the same or inverse 
	//percent position in their respective consecutive clauses, with some % clause length buffer allowed (e.g they both start a clause).
	//A pattern consists of >= 2 words linked. Each pattern gets a different color. 
	//Have a parameter that tells how many different patterns must occur together to count?
	//Chiasm is when one pair is completely within another. Interlinked is when one (but not all) of one pair occurs
	//between the other pair (e.g. ABAB or AABAB). Color these types uniquely?
	//Consider allowing linked words be a pattern across clauses in different positions if more than one
	//occurs together AABB or ABAB in some way.

	// CalculatePatterns()
	// {
	// 	var listLinesToDo = this.state.listLines; //.Where(r => r.Book == nBook && r.Chapter == nChapter).ToList();		
		
	// 	var listWordTypes = ["V", "N", "A", "P", "T", "D", "R"];

	// 	var listPositionPercentRanges =
	// 		[ new NumberRange(0, 0.2), new NumberRange(0.21, 0.4), new NumberRange(0.41, 0.6),
	// 		  new NumberRange(0.61, 0.8), new NumberRange(0.81, 1.0) ];

	// 	var mapPatterns = new Map(
	// 		[ ["Consonants", []], ["Vowels", []], ["WordType", []], ["SemanticDomain", []] ]
	// 	);

	// 	for (var nLine = 0; nLine < listLinesToDo.length; nLine++)
	// 	{
	// 		var listWordsInLine = listLinesToDo[nLine];
	// 		for (var nWord = 0; nWord < listWordsInLine.length; nWord++)
	// 		{
	// 			var w = listWordsInLine[nWord];
	// 			var nLinePositionPercentRange = listPositionPercentRanges.findIndex(r => 
	// 				r.IndexInRange(nWord / (1.0 * listWordsInLine.length)));

	// 			//words contain same consonant
	// 			for(const cToFind of this.listHebrewChars.filter(c2 => c2.Consonant === "1").map(c2 => c2.Char))
	// 			{
	// 				var wChars = Array.from(w.FullText);
	// 				if(wChars.includes(cToFind)) 
	// 				{
	// 					mapPatterns.get("Consonants").push({ Word: w, LineNumber: nLine, 
	// 						LinePositionPercentRange: nLinePositionPercentRange,
	// 						LetterIsAtBeginningOfWord: wChars.indexOf(cToFind) === 0 || 
	// 							(w.Waw && wChars.indexOf(cToFind) === 1),
	// 						LetterIsAtEndOfWord: wChars.indexOf(cToFind) === wChars.length - 1,
	// 						MatchType: "Consonant: " + cToFind});
	// 				}
	// 			}

	// 			//words have same initial consonant
	// 			// for(const cToFind of this.listHebrewChars.filter(c2 => c2.Consonant === "1").map(c2 => c2.Char))
	// 			// {
	// 			// 	var wChars = Array.from(w.FullText);
	// 			// 	if(wChars.includes(cToFind)) 
	// 			// 	{
	// 			// 		mapPatterns.get("Consonants").push({ Word: w, LineNumber: nLine, 
	// 			// 			LinePositionPercentRange: nLinePositionPercentRange,
	// 			// 			LetterIsAtBeginningOfWord: wChars.indexOf(cToFind) === 0 || 
	// 			// 				(w.Waw && wChars.indexOf(cToFind) === 1),
	// 			// 			LetterIsAtEndOfWord: wChars.indexOf(cToFind) === wChars.length - 1,
	// 			// 			MatchType: "Initial Consonant: " + cToFind});
	// 			// 	}
	// 			// }

	// 			//word type
	// 			for(const sWordType of listWordTypes)
	// 			{
	// 				if(w.WordType === sWordType) 
	// 				{
	// 					mapPatterns.get("WordType").push({ Word: w, LineNumber: nLine, 
	// 						LinePositionPercentRange: nLinePositionPercentRange,
	// 						MatchType: "WordType: " + sWordType});
	// 				}
	// 			}
	// 		}
	// 	}

	// 	var listDiscoveredPatterns = [];
	// 	for (var [sPatternKey, listMatchChains] of mapPatterns) 
	// 	{
	// 		if(sPatternKey === "Consonants") // || sPatternKey === "Vowels")
	// 		{
	// 			// same consonant or vowel at:
	// 			// 1) end of last words of lines <=2 lines apart
	// 			var listCriterion1 = listMatchChains.filter(r => 
	// 				r.LinePositionPercentRange === listPositionPercentRanges.length - 1);

	// 			// 2) beginning of first words of lines <=2 lines apart
	// 			// 3) within same line, with same letter position range in >= 2 words
	// 			// 4) within same line in >=40% of the words
	// 			// 5) in >=2 words surrounded by another pair of words that
	// 			// share one same consonant
	// 			// 6) in >=2 words enclosing another pair of words that
	// 			// share one same consonant (converse of 5)

	// 		}

	// 		var listInSameLine = this.GroupArrayByKey(listMatchChains, "LineNumber");
	// 		if(listInSameLine.length >= (sPatternKey === "WordType" ? 2 : 3))
	// 			listDiscoveredPatterns.push({ PatternKey: sPatternKey, PatternType: "Same Line", Units: listInSameLine });

	// 		var listAtSamePositionPercentRange = this.GroupArrayByKey(listMatchChains, "LinePositionPercentRange");
	// 		if(listInSameLine.length >= 2)
	// 			listDiscoveredPatterns.push({ PatternKey: sPatternKey, PatternType: "Same Position Percent", Units: listAtSamePositionPercentRange });

	// 		// for(const chainElement of listMatchChains)
	// 		// {
	// 		// 	var listOthersInSameLine = listMatchChains.filter(ch => ch.LineNumber === chainElement.LineNumber);
	// 		// 	if(listOthersInSameLine.length >= 2 &&
	// 		// 		!listDiscoveredPatterns.some(r => r.PatternType === "Same Line" && r.Units.some(r2 => r2.LineNumber === chainElement.LineNumber)))
	// 		// 		listDiscoveredPatterns.push({ PatternKey: sPatternKey, PatternType: "Same Line", Units: listOthersInSameLine });

	// 		// 	var listOthersInSamePositionPercentRange = listMatchChains.filter(ch => 
	// 		// 		ch.LinePositionPercent - chainElement.LinePositionPercent < 0.2 || 
	// 		// 		ch.LinePositionPercent - chainElement.LinePositionPercent > 0.8);
	// 		// 	if(listOthersInSamePositionPercentRange.length >= 3 &&
	// 		// 		!listDiscoveredPatterns.some(r => r.PatternType === "Same Position Percent" && r.Units.some(r2 => r2.LinePositionPercent === chainElement.LinePositionPercent)))
	// 		// 		listDiscoveredPatterns.push({ PatternKey: sPatternKey, PatternType: "Same Position Percent", Units: listOthersInSamePositionPercentRange });			
	// 		// }
			
	// 		// if(sPatternKey === "Consonants" || sPatternKey === "Vowels")
	// 		// {
	// 		// 	var listOnesWithInitialRhyme = listMatchChains.filter(ch => ch.LetterAtBeginningOfWord === true);
	// 		// 	if(listOnesWithInitialRhyme.length >= 2
	// 		// }
	// 	}
		
	// 	this.setState({listSelectedSequences: listDiscoveredPatterns});
	// }

	generateDistinguishingHslaColors (saturation, lightness, alpha, nColorsToGenerate) {
		let colors = [];
		let huedelta = Math.trunc(360 / nColorsToGenerate);
	
		for (let i = 0; i < nColorsToGenerate; i++) {
		let hue = i * huedelta;
		colors.push(`hsla(${hue},${saturation}%,${lightness}%,${alpha})`);
		}
	
		return colors;
	}

    // GetTextDecoration(textWord)
    // {
    //     if(this.state.sColorBy === "rgrp")
    //     {
    //         if(this.state.currentRepetitionLinkGroup != undefined && this.state.currentRepetitionLinkGroup.ListWords.includes(textWord.TextIndex))
    //             return "underline";
    //         else 
    //             return "none";
    //     }
    // }

    AnyLensIsEnabled()
    {
        return this.state.listLenses.filter(l => l.Enabled || l.Sticky).length > 0;
    }

    SyllableRhymeLensIsEnabled()
    {
        return this.LensTypeIsEnabled("syllablerhyme")
    }

    SyllableAtSameIndexInLineLensIsEnabled()
    {
        return this.LensTypeIsEnabled("SyllableAtSameIndexInLine")
    }

    TaggedRhymeChainsLensIsEnabled()
    {
        return this.LensTypeIsEnabled("handtaggedrhymegroupsbysyllable")
    }

    // FirstSyllableInLinesLensIsEnabled()
    // {
    //     return this.LensTypeIsEnabled("firstsyllableinlines")
    // }

    // LastSyllableInLinesLensIsEnabled()
    // {
    //     return this.LensTypeIsEnabled("lastsyllableinlines")
    // }

    SyllablesWithDoubledConsonantLensIsEnabled()
    {
        return this.LensTypeIsEnabled("syllableswithdoubledconsonants")
    }

    SomeSyllableSpecificLensIsEnabled()
    {
        return this.SomeSyllableSpecificHoverLensIsEnabled() || this.CadenceChangesLensIsEnabled() || 
            this.SyllablesWithDoubledConsonantLensIsEnabled() || this.LetterInTransliterationLensIsEnabled() || this.TaggedRhymeChainsLensIsEnabled()
    }

    RhymeLensIsEnabled()
    {
        return this.LensTypeIsEnabled("rhyme")
    }
    
    WordRhymeLensIsEnabled()
    {
        return this.LensTypeIsEnabled("wordrhyme")
    }

    VowelChainLensIsEnabled()
    {
        return this.LensTypeIsEnabled("vowelchains")
    }

    ConsonantChainLensIsEnabled()
    {
        return this.LensTypeIsEnabled("consonantchains")
    }
    
    CadenceChangesLensIsEnabled()
    {
        return this.LensTypeIsEnabled("cadencechanges")
    }

    PaceAndRhythmLensIsEnabled()
    {
        return this.LensTypeIsEnabled("paceandrhythm")
    }

    PaceAndRhythmLensCountByWordsIsEnabled()
    {
        return this.LensTypeIsEnabled("paceandrhythmcountbywords")
    }

    AverageInterstressLengthPerLineIsEnabled()
    {
        return this.LensTypeIsEnabled("AverageInterstressLengthPerLine")
    }

    NumberOfLinksPerLineChartIsEnabled()
    {
        return this.LensTypeIsEnabled("NumberOfLinksPerLineChart")
    }

    DistanceForEachWordInAnyLinkGroupFromLastWordInAnyLinkGroupChartIsEnabled()
    {
        return this.LensTypeIsEnabled("DistanceForEachWordInAnyLinkGroupFromLastWordInAnyLinkGroupChart")
    }

    DistanceForEachWordInALinkGroupFromLastWordInThatLinkGroupChartIsEnabled()
    {
        return this.LensTypeIsEnabled("DistanceForEachWordInALinkGroupFromLastWordInThatLinkGroupChart")
    }

    MomentumChartIsEnabled()
    {
        return this.LensTypeIsEnabled("MomentumChart")
    }

    LetterInTransliterationLensIsEnabled()
    {
        return this.LensTypeIsEnabled("letterintransliteration")
    }

    AllSimilarityLensIsEnabled()
    {
        return this.LensTypeIsEnabled('allsimilarity')
    }

    AllSimilarityForLinesLensIsEnabled()
    {
        return this.LensTypeIsEnabled('allsimilarityforlines')
    }

    AllSimilarityForStanzasLensIsEnabled()
    {
        return this.LensTypeIsEnabled('allsimilarityforstanzas')
    }

    AlltLensIsEnabled()
    {
        return this.LensTypeIsEnabled('allt')
    }

    SemanticSimilarityLensIsEnabled()
    {
        return this.LensTypeIsEnabled('semanticsimilarity')
    }

    RootCooccurrenceLensIsEnabled()
    {
        return this.LensTypeIsEnabled('rootcooccurrence')
    }

    DifferenceAmountLensIsEnabled()
    {
        return this.LensTypeIsEnabled('differenceamount')
    }

    LensIsRepLens(l)
    {
        return l.LensType === "reprootsmindiff" || l.LensType === "reprootsnumrepeats" || l.LensType === "reprootsmaxdistance" || l.LensType === "repwords" || l.LensType === "reproots"
    }
    
    RepLensIsEnabled()
    {
        return this.state.listLenses.some(l => (l.Enabled || l.Sticky) && this.LensIsRepLens(l))
    }

    LocalDensityLensIsEnabled()
    {
        return this.state.listLenses.some(l => (l.Enabled || l.Sticky) && l.LensType === "localdensity")
    }

    PatternLensIsEnabled()
    {
        return this.state.listLenses.some(l => (l.Enabled || l.Sticky) && l.LensType === "patterninfield")
    }

    AllNearbyRepetitionLensIsEnabled()
    {
        return this.state.listLenses.some(l => (l.Enabled || l.Sticky) && l.LensType === "allnearbyrepetition")
    }

    FirstWordInSemanticChainsLensIsEnabled()
    {
        return this.state.listLenses.some(l => (l.Enabled || l.Sticky) && l.LensType === "FirstWordInSemanticChains")
    }

    LensTypeIsEnabled(sLensType)
    {
        return this.state.listLenses.some(l => (l.Enabled || l.Sticky) && l.LensType === sLensType)
    }
    
    WordsBySoundGroupLensIsEnabled()
    {
        return this.LensTypeIsEnabled('WordsBySoundGroupCombination') || this.LensTypeIsEnabled('WordsBySoundGroupInitial') || this.LensTypeIsEnabled('WordsBySoundGroupFinal')
        || this.LensTypeIsEnabled('WordsBySoundGroupsInitialAndFinal') || this.LensTypeIsEnabled('WordsBySoundGroupFinalSyllableWithoutInitialConsonant') ||
        this.LensTypeIsEnabled('WordsBySoundGroupAnywhere') || this.LensTypeIsEnabled('WordsBySoundGroupSameAccentedSyllable') || 
        this.LensTypeIsEnabled('SameAccentedVowelWithNoOrCompatibleFinalConsonant') || 
        this.LensTypeIsEnabled('SameAccentedVowelWithNoOrCompatibleFinalConsonantOrInitialSoundGroup') || 
        this.LensTypeIsEnabled('WordsBySoundGroupInitialConsonantOfStressedSyllable') || 
        this.LensTypeIsEnabled('WordsBySoundGroupConsonant') || this.LensTypeIsEnabled('WordsBySoundGroupFinalConsonant')
    }

    GroupByUnitHeatmapIsEnabled()
    {
        return this.LensTypeIsEnabled("SoundGroupByUnitHeatmap") || 
            this.LensTypeIsEnabled("SemanticGroupByUnitHeatmap") || this.LensTypeIsEnabled("RepeatedRootGroupByUnitHeatmap")
    }

    GetLensToColorBy()
    {
        if(this.state.oLensToColorTextBy !== null && this.state.oLensToColorTextBy.NoneOption) return null

        let listLensesThatAreOn = this.GetLensesThatAreOn()
        return this.state.oLensToColorTextBy !== null && listLensesThatAreOn.includes(this.state.oLensToColorTextBy) ? 
            this.state.oLensToColorTextBy : 
            listLensesThatAreOn.length === 0 ? null : listLensesThatAreOn[0]
    }

    ColorByLensType(sLensType)
    {
        let oLensToUseForColor = this.GetLensToColorBy()
        return oLensToUseForColor !== null && oLensToUseForColor.LensType === sLensType
    }

    SemanticChainsLensIsEnabled()
    {
        return this.state.listLenses.some(l => (l.Enabled || l.Sticky) && l.LensType === "handtaggedsemanticchains")
    }

    SemanticChainsLensAmongUnitsIsEnabled()
    {
        return this.state.listLenses.some(l => (l.Enabled || l.Sticky) && l.LensType === "handtaggedsemanticchainsunits")
    }
    
    ConnectionsLensIsEnabled()
    {
        return this.state.listLenses.some(l => (l.Enabled || l.Sticky) && 
            (l.LensType === "handtaggedconnections" || l.LensType === "handtaggedconnectionsunitoffirstoccurrence" || 
            l.LensType === "handtaggedconnectionspercentageofunitsitoccursin" || 
            l.LensType === "ConnectionsGeneratedFromSemanticLinksPreview" || 
            l.LensType === "ConnectionsGeneratedFromSemanticLinksPreviewunitoffirstoccurrence"))
    }

    MainConnectionsLensIsEnabled()
    {
        return this.state.listLenses.some(l => (l.Enabled || l.Sticky) && l.LensType === "handtaggedconnections")
    }

    GetRepetitionLinkGroupDensityColor(w)
    {
        var nRepetitionLinkGroupOccs = this.GetRepetitionLinkGroupList().filter(g => g.ListWords.includes(w.TextIndex)).length;
        return nRepetitionLinkGroupOccs === 0 ? "LightGray" : 
            nRepetitionLinkGroupOccs === 1 ? "Blue" : 
            nRepetitionLinkGroupOccs === 2 ? "Green" : 
            nRepetitionLinkGroupOccs === 3 ? "Goldenrod" : 
            nRepetitionLinkGroupOccs === 4 ? "Orange" : 
            nRepetitionLinkGroupOccs === 5 ? "Red" : 
            nRepetitionLinkGroupOccs === 6 ? "Purple" : "Black";
    }

    GetDescForLensType(sLensType)
    {
        return sLensType === "s" ? "Stem" :
            sLensType === "f" ? "Form" :
            sLensType === "g" ? "Gender" :
            sLensType === "n" ? "Number" :
            sLensType === "constructstate" ? "Construct State" :
            sLensType === "pf" ? "Phrase Function" :
            sLensType === "sfxtype" ? "Suffix Type" :
            sLensType === "wordtype" ? "Word Type" :
            sLensType === "preposition" ? "Preposition" :
            sLensType === "pforder" ? "Phrase Function Order" :
            sLensType === "pgn" ? "PGN" :
            sLensType === "lex" ? "Lexical ID" :
            sLensType === "mysem" ? "Semantic Groups 1" :
            sLensType === "sfxpgn" ? "Suffix PGN" : sLensType;
    }

    GetColorArrayForLensType(sLensType)
    {
        return sLensType === "s" ? this.colorsForStems :
            sLensType === "f" ? this.colorsForForms :
            sLensType === "g" ? this.colorsForGender :
            sLensType === "n" ? this.colorsForNumber :
            sLensType === "constructstate" ? this.colorsForConstructState :
            sLensType === "pf" ? this.colorsForPhraseFunctions :
            sLensType === "pforder" ? this.colorsForPhraseFunctionOrder :
            sLensType === "sfxtype" ? this.colorsForSuffixType : 
            sLensType === "wordtype" ? this.colorsForWordType :
            sLensType === "preposition" ? this.colorsForPreposition :
            sLensType === "case" ? this.colorsForCases :
            sLensType === "tense" ? this.colorsForTenses :
            sLensType === "voice" ? this.colorsForVoices :
            sLensType === "mood" ? this.colorsForMoods :
            sLensType === "pgn" || sLensType === "sfxpgn" ? this.colorsForPGN : 
            sLensType === "pn" ? this.colorsForPN : null;
    }

    GetPrepositionForWord(w)
    {
        //['903', '877', '6361', '4077', '435', '4790']
        ////b = 903, l = 4077, m = 4790, k = 3892
        return (w.Preposition === 'b' || w.LexicalID === '903') ? 'b' :
            (w.Preposition === 'l' || w.LexicalID === '4077') ? 'l' :
            (w.Preposition === 'm' || w.LexicalID === '4790') ? 'm' :
            (w.Preposition === 'k' || w.LexicalID === '3892') ? 'k' : 
            w.LexicalID === '877' ? 'et' :
            w.LexicalID === '6361' ? 'al' :
            w.LexicalID === '435' ? 'el' :
            w.Preposition
    }

    GetValueForLensType(w, sLensType)
    {
        return sLensType === "s" ? w.Stem : 
            sLensType === "f" ? w.Form :
            sLensType === "g" ? w.Gender :
            sLensType === "n" ? w.Number :
            sLensType === "case" ? w.Case :
            sLensType === "tense" ? w.Tense :
            sLensType === "voice" ? w.Voice :
            sLensType === "mood" ? w.Mood :
            sLensType === "constructstate" ? w.ConstructState :
            sLensType === "pf" ? this.GetPhraseFunction(w) :
            sLensType === "sfxtype" ? w.SuffixType :
            sLensType === "wordtype" ? w.WordType :
            sLensType === "preposition" ? this.GetPrepositionForWord(w) :
            sLensType === "pforder" ? this.GetPhraseFunctionOrderForWord(w) :
            sLensType === "pgn" ? this.GetPGN(w) :
            sLensType === "pn" ? this.GetPN(w) :
            sLensType === "sfxpgn" ? this.GetSuffixPGN(w) : 
            sLensType === "LexicalID" ? w.LexicalID :
            sLensType === "ParentRoot" ? w.ParentRoot :
            sLensType === "mysem" ? this.listMainSemanticDomains.filter(o => o.LexicalIDs.includes(w.LexicalID)) :
            sLensType === "sdbh" ? this.listSDBH.filter(o => o.Type === 'l' && o.ListWords.includes(parseInt(w.TextIndex))) :
            sLensType === "ref" ? w.Refs.concat(w.SubjRefs) :
            sLensType === "rhyme" ? this.GetRhymeAmountColor(w, this.state.currentWordForHoverLens) : 
            sLensType === "allsimilarity" ? this.GetAllSimilarityAmountScore(w, this.state.currentWordForHoverLens).Color : "";
    }

    MapValueToNameForLensType(sValue, sLensType)
    {
        return sLensType === "s" ? this.listHebrewVerbStems.find(r => r.Abbr === sValue).Desc : 
        sLensType === "f" ? this.listHebrewVerbForms.find(r => r.Abbr === sValue).Desc :
        sLensType === "g" ? this.descsForGenderAbbr.find(r => r.Abbr === sValue).Desc :
        sLensType === "n" ? this.descsForNumberAbbr.find(r => r.Abbr === sValue).Desc :
        sLensType === "constructstate" ? this.descsForConstructState.find(r => r.Abbr === sValue).Desc :
        sLensType === "sfxtype" ? this.descsForSuffixType.find(r => r.Abbr === sValue).Desc :
        sLensType === "wordtype" ? this.descsForWordType[sValue] : 
        sLensType === "preposition" ? "Prep " + sValue.toUpperCase(): sValue;
    }

	GetLensColorForValue(w, sLensType, colorArray)
	{
        if(sLensType === "rgrp")
        {
            //filter for words in this chapter to keep the colors consistent - so each chapters groups start at index 0
            //update: the commented out below was because it was too slow - find a way to speed it up!
            var nRepetitionLinkGroupIndex = this.GetRepetitionLinkGroupList(). //filter(g => this.listTextWordsForChapter.some(w2 => w2.TextIndex === g.ListWords[0])).
                findIndex(g => g.ListWords.includes(w.TextIndex) &&
                (g.ListTags.length === 0 || g.ListTags.some(tag => this.IsGroupForRepetitionLinkGroupCategoryIDCurrentlySelected(tag.CategoryID))));
            return nRepetitionLinkGroupIndex === -1 ? "Gray" : 
                this.listLinkGroupColors[nRepetitionLinkGroupIndex % this.listLinkGroupColors.length];
        }

        return colorArray === null ? "Gray" : colorArray[this.GetValueForLensType(w, sLensType)];
	}

    GetCharsInWord(sText, listConsonantToExclude)
    {
        if(sText === undefined) return []
        var listChars = Array.from(sText)
        return listChars.filter(c => !listConsonantToExclude.includes(c))
    }

    RemoveCantillations(sText)
    {
        return sText.replaceAll(/[\u0591-\u05AF]/g,"") //.replace("׀", "").replace("׃","").replace("־","")
    }
    
    GetConsonantGroupsToUse()
    {
        return this.blnChapterIsHebrew ? this.listConsonantGroupsForHebrew : this.listConsonantGroupsForGreek
    }

    GetGroupedConsonantsInWord(sText, listConsonantToExclude)
    {
        //return the same letter for initial and final forms
        //remove the long vowels since they can be confused with consonants
        //remove cantillations since they can get between consonant + vowel combos we are trying to remove
        if(sText === undefined) return []

        var sTextProcessed = sText.toString()
        if(this.blnChapterIsHebrew)
        {
            //take out long vowels
            var sTextProcessed = this.RemoveCantillations(sTextProcessed)

            //don't take out double yods - those are consonants even if they are preceded by a hireq
            sTextProcessed = sTextProcessed.replaceAll('\u05d9\u05bc', 'doubledyodh')
            sTextProcessed = sTextProcessed.replaceAll('\u05d4\u05bc', 'consonanthe')

            for(var sLongVowel of ['ִי', 'ֵי', 'וֹ', 'וּ', '\u05b8\u05d4', '\u05b6\u05d9'])
            {
                sTextProcessed = sTextProcessed.replaceAll(sLongVowel, '')
            }

            sTextProcessed = sTextProcessed.replaceAll('doubledyodh', '\u05d9\u05bc')
            sTextProcessed = sTextProcessed.replaceAll('consonanthe', '\u05d4\u05bc')

            // if(sText != sTextProcessed) console.log(sText, sTextProcessed)
        }

        // console.log(this.GetCharsInWord(sTextProcessed, listConsonantToExclude).filter(c => this.GetConsonantGroupsToUse().find(g => g.ListChars.includes(c)) === undefined))
        return this.GetCharsInWord(sTextProcessed, listConsonantToExclude).map(c => {
            var oConsonantGroup = this.GetConsonantGroupsToUse().find(g => g.ListChars.includes(c))
            return oConsonantGroup === undefined ? '' : oConsonantGroup.Name
        }).filter(s => s != '')
    }

    // AlltForOnlyCertainConsonantsAtBeginning(sText1, sText2)
    // {
    //     var listConsonantToExclude = [] //['ה', 'ו', 'י', 'ו']
    //     return this.GetGroupedConsonantsInWord(sText1, listConsonantToExclude)[0] === this.GetGroupedConsonantsInWord(sText2, listConsonantToExclude)[0]
    // }

    GetSubsequencesInCommon(sText1, listChars)
    {
        var listSuccessfulSequencesPerStartChar = []
        for(var nStartChar = 0; nStartChar < listChars.length - 1; nStartChar++)
        {
            listSuccessfulSequencesPerStartChar.push([])
            for(var nSeqLength = 2; nStartChar + nSeqLength <= listChars.length; nSeqLength++)
            {
                var sSequenceToTry = listChars.slice(nStartChar, nStartChar + nSeqLength).join('')
                if(sText1.includes(sSequenceToTry))
                {
                    listSuccessfulSequencesPerStartChar[listSuccessfulSequencesPerStartChar.length - 1].push(sSequenceToTry)
                }
                else break
            }
        }

        return listSuccessfulSequencesPerStartChar
    }

    CalculateVowelSequence(sText)
    {
        // [1], [2,3], [4,5], [6]
        // 1246
        // 1346
        // 1256
        // 1356

        if(sText === undefined) return []
        var listChars = Array.from(sText)
        var listVowelGroupsToUse = this.blnChapterIsHebrew ? this.listVowelGroupsForHebrew : this.listVowelGroupsForGreek
        var listGroupIDsPerChar = listChars.map(c => listVowelGroupsToUse.
            filter(g => g.Chars.includes(c))).filter(lg => lg.length > 0).map(lg => lg[0].ID) //lg.map(g => g.ID)

        return listGroupIDsPerChar
    }

    CalculateVowelSequenceScore(sText1, sText2)
    {
        var listSequence1 = this.CalculateVowelSequence(sText1)
        var listSequence2 = this.CalculateVowelSequence(sText2)

        // console.log(listSequence1, listSequence2)
        var listSuccessfulSequencesPerStartChar = this.GetSubsequencesInCommon(listSequence1.join(''), listSequence2)
        var listSuccessfulSequencesPerStartCharRev = this.GetSubsequencesInCommon([...listSequence1].reverse().join(''), listSequence2)

        var listMaxLengthsPerStartChar = listSuccessfulSequencesPerStartChar.map(l => l.length === 0 ? 0 : Math.max(...l.map(s => s.length)))
        var nMaxLengthOfAllSequences = Math.max(...listMaxLengthsPerStartChar)

        var listMaxLengthsPerStartCharRev = listSuccessfulSequencesPerStartCharRev.map(l => l.length === 0 ? 0 : Math.max(...l.map(s => s.length)))
        var nMaxLengthOfAllSequencesRev = Math.max(...listMaxLengthsPerStartCharRev)

        // var nScore = Math.max(nMaxLengthOfAllSequences, nMaxLengthOfAllSequencesRev)
        // if(nScore > 0) console.log(sText1, sText2, listSequence1, listSequence2, nScore)
        
        return {Score: Math.max(nMaxLengthOfAllSequences, nMaxLengthOfAllSequencesRev), Reverse: nMaxLengthOfAllSequencesRev > nMaxLengthOfAllSequences}
    }

    CalculateWordRhyme(sText1, sText2, blnAlltOnly, dictRarityFactorByConsonant, blnConsoleLogResults)
	{		
        var listConsonants1 = this.GetGroupedConsonantsInWord(sText1, [])
        var listConsonants2 = this.GetGroupedConsonantsInWord(sText2, [])

        var listConsonantsInCommon = [... new Set(listConsonants1.filter(c => listConsonants2.some(c2 => c === c2)))]
        // var nConsonantsInCommonFactor = dictRarityFactorByConsonant === undefined ? listConsonantsInCommon.length : 
        //     listConsonantsInCommon.map(c => dictRarityFactorByConsonant.get(c)).reduce((acc, n) => acc + n, 0)

        var nConsonantsInCommonFactor = listConsonantsInCommon.length

        var nRarityAddition = (this.blnChapterIsHebrew ? this.listRarityFactorsForRhymeForHebrew : this.listRarityFactorsForRhymeForGreek).
            filter(o => o.Chars.some(c => listConsonantsInCommon.includes(c))).reduce((acc, o) => acc + o.Factor, 0)
        
        var blnSameConsonantStart = listConsonants1[0] === listConsonants2[0]
        var blnSameConsonantEnd = listConsonants1[listConsonants1.length - 1] === listConsonants2[listConsonants2.length - 1]

        var nRhymeGroupSimilarityAddition = 0
        var nSequenceScore = 0
        var blnMaxSequenceIsReversed = false

        if(!blnAlltOnly)
        {
            //match by similarity percent for pairs of consonants between the words
            var listN2sAlreadyMatched = []
            for(var c1 of listConsonants1)
            {
                var nMaxSimilarityPercentFor1 = 0
                var n2 = 0
                var n2Matched = -1

                for(var c2 of listConsonants2)
                {
                    if(c1 != c2 && !listN2sAlreadyMatched.includes(n2))
                    {
                        var listSimilarityPercentsForPair = (this.blnChapterIsHebrew ? this.listSoundSimilarityGroupsForHebrew : this.listSoundSimilarityGroupsForGreek).
                            filter(o => o.Chars.includes(c1) && o.Chars.includes(c2)).map(o => o.SimilarityPercent)

                        if(listSimilarityPercentsForPair.length > 0)
                        {
                            var nMaxSimilarityPercentForPair = Math.max(...listSimilarityPercentsForPair)
                            if(nMaxSimilarityPercentForPair > nMaxSimilarityPercentFor1) 
                            {
                                n2Matched = n2
                                nMaxSimilarityPercentFor1 = nMaxSimilarityPercentForPair
                            }
                        }
                    }

                    n2 += 1
                }

                listN2sAlreadyMatched.push(n2Matched)
                nRhymeGroupSimilarityAddition += nMaxSimilarityPercentFor1
            }

            var listSuccessfulSequencesPerStartChar = this.GetSubsequencesInCommon(listConsonants1.join(''), listConsonants2)
            var listSuccessfulSequencesPerStartCharRev = this.GetSubsequencesInCommon([...listConsonants1].reverse().join(''), listConsonants2)
            
            // console.log(sText1, sText2, listConsonants2, sConsonantOnlyText1, listSuccessfulSequencesPerStartChar, listMaxLengthsPerStartChar)
            // || (sText2 === 'כֹּחִ֗י')
            var listMaxLengthsPerStartChar = listSuccessfulSequencesPerStartChar.map(l => l.length === 0 ? 0 : Math.max(...l.map(s => s.length)))
            var nMaxLengthOfAllSequences = Math.max(...listMaxLengthsPerStartChar)

            var listMaxLengthsPerStartCharRev = listSuccessfulSequencesPerStartCharRev.map(l => l.length === 0 ? 0 : Math.max(...l.map(s => s.length)))
            var nMaxLengthOfAllSequencesRev = Math.max(...listMaxLengthsPerStartCharRev)

            // if(sText2 === 'תַּ֝עְלִ֗ים') console.log(listSuccessfulSequencesPerStartChar, listMaxLengthsPerStartChar, nMaxLengthOfAllSequences)
            // var nDistinctSequences = listMaxLengthsPerStartChar.filter(n => n > 0).length
            nSequenceScore = Math.max(nMaxLengthOfAllSequences, nMaxLengthOfAllSequencesRev) //+ (nDistinctSequences > 0 ? (nDistinctSequences - 1))
            blnMaxSequenceIsReversed = nMaxLengthOfAllSequencesRev > nMaxLengthOfAllSequences
            // if(nDistinctSequences > 0) console.log(sText1, sText2, sConsonantOnlyText1, listConsonants2, listSuccessfulSequencesPerStartChar, listMaxLengthsPerStartChar)
        }
	
        //sText1 === 'λαβεῖν.' || 
        if(blnConsoleLogResults) console.log(nConsonantsInCommonFactor, nRarityAddition, nRhymeGroupSimilarityAddition, 
            nSequenceScore, (blnSameConsonantStart ? 1 : 0), (blnSameConsonantEnd ? 0.5 : 0), listN2sAlreadyMatched)
        
        return nConsonantsInCommonFactor + nRarityAddition + nRhymeGroupSimilarityAddition + nSequenceScore + (blnSameConsonantStart ? 1 : 0) + (blnSameConsonantEnd ? 0.5 : 0)

        // var nSimilarity = this.stringSimilarity.compareTwoStrings(sText1, sText2)
        // if(nSimilarity > 0.2) console.log(sText1, sText2, nSimilarity)

        // if(w1.TextIndex === '11' && w2.TextIndex === '7') 
        // {
        //     console.log(blnSameConsonantStart)
        // }

        //תּ,ת,טּ,ט
        //this.listRhymeGroups.filter(r => r.HebrewText.split(',').includes(letter1))  SimilarityPercent

        //this.listRhymeGroups.forEach(o => o.ListLetters = r.HebrewText.split(',').trim());
        //(acc, line) => acc + line.length, 0

        // var w1Vowels = w1chars.filter(c => this.IsVowel(c) || c.IsSheva)
        // var w2Vowels = w2chars.filter(c => this.IsVowel(c) || c.IsSheva)

        // var blnSameVowelStart = w1Vowels[0] === w2Vowels[0];
        // var blnSameVowelEnd = w1Vowels[w1Vowels.length - 1] === w2Vowels[w2Vowels.length - 1];

        //return (blnSameConsonantStart ? 1 : 0) + (blnSameConsonantEnd ? 1 : 0) + (blnAlltOnly ? 0 : (nConsonantsInCommon + nRhymeGroupSimilarityPercentSum)) // + (blnSameVowelStart ? 1 : 0) + (blnSameVowelEnd ? 1 : 0);       
    }
    
    GetRhymeAmountColor(w1, w2, blnAlltOnly)
    {
        if(w1 === undefined || w2 === undefined) return "Gray";
        if(w1.FullText === w2.FullText) return "Black";

        var nAmount = this.CalculateWordRhyme(w1.FullText, w2.FullText, blnAlltOnly) //(w2.TextIndex === '44003003013')

        if(blnAlltOnly)
        {
            return nAmount === 1 ? "Red" : 
                nAmount === 2 ? "Purple" : "LightGray"
        }
        else
        {
            if(this.blnChapterIsHebrew)
            {
                return nAmount < 1 ? "LightGray" : 
                    nAmount < 2 ? "Gray" : 
                    nAmount < 3 ? "Green" : 
                    nAmount < 4 ? "Orange" : 
                    nAmount < 5 ? "Red" : 
                    nAmount < 6 ? "Purple" : "Black"
            }
            else
            {
                return nAmount < 1.5 ? "LightGray" : 
                    nAmount < 3 ? "Gray" : 
                    nAmount < 4.5 ? "Green" : 
                    nAmount < 6 ? "Orange" : 
                    nAmount < 7.5 ? "Red" : 
                    nAmount < 9 ? "Purple" : "Black"
            }
        }
    }

    ReplaceThingsInTransliterationBeforeGettingSounds(s)
    {
        return s.replaceAll('iy', 'î').replaceAll('ay', '5').replaceAll('ēy', 'ē').replaceAll('ey', 'ē')
    }

    GetBasicVowelsInTransliteration(s)
    {
        s = s.replaceAll('î', 'i').replaceAll('û', 'u').replaceAll('ā', 'a').replaceAll('â', 'a').replaceAll('ô', 'o')
        s = s.replace(/[^aiîoeuûēəāâêôj5]/g, '')
        return [...s]
    }

    GetVowelsInTransliteration(s)
    {
        s = s.replace(/[^aiîoeuûēəāâêôj5]/g, '')
        return [...s]
    }

    GetConsonantsInTransliteration(s)
    {
        s = s.replace(/[^šṣḵmhtḥsmnpfbvdklʿʾywzrgq]/g, '')
        return [...s]
    }

    RemoveNonVowelsAndNonConsonants(s)
    {
        if(this.blnChapterIsHebrew)
        {
            return s.replaceAll('*', '').replaceAll('|', '').replaceAll('^', '').replaceAll('?', '').replaceAll('!', '').replaceAll(':', '')
        }
        else
        {
            return s.replaceAll('*', '').replaceAll(',', '').replaceAll(';', '').replaceAll('?', '').replaceAll('!', '').replaceAll('.', '')
                .replace('·', '').replace('’', '')
        }
    }

    SplitSyllableForComparison(syl)
    {
        var s = this.RemoveNonVowelsAndNonConsonants(syl).replaceAll('iy', 'î').replaceAll('ay', '5').replaceAll('ēy', 'ē')
        return [...s]
    }

    SoundSimilarity(s1, s2)
    {
        if(s1 == s2) return 1.0

        //if the sounds are in the same array, score it for that level.
        var l1 = [['a', 'a', 'ā', 'â'], ['o', 'ô'], ['u', 'û'], ['e', 'ê']]
        if(l1.filter(l => l.includes(s1) && l.includes(s2)).length > 0) return 0.9

        var l2 = [['ḵ', 'ḥ'], ['q', 'k']]
        if(l2.filter(l => l.includes(s1) && l.includes(s2)).length > 0) return 1.0

        var l3 = [['s', 'š'], ['s', 'ṣ'], ['s', 'z'], ['b', 'v'], ['b', 'p'], ['l', 'r'], ['k', 'g'], ['t', 'd'], ['p', 'f'], ['f', 'v'], ['ḵ', 'ḥ'], ['ḵ', 'q'], ['ʿ', 'ʾ'], ['e', 'ê', 'ē'], ['i', 'î']]
        if(l3.filter(l => l.includes(s1) && l.includes(s2)).length > 0) return 0.3

        return 0
    }

    GetSoundChainAmountForWords(w1, w2, sSoundType)
    {
        if(sSoundType != 'v' && sSoundType != 'c') return 0

        var s1 = this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(w1.Syllables.join('')))
        var s2 = this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(w2.Syllables.join('')))

        // if(sSoundType === 'v')
        // {
        //     s1 = s1.replaceAll('î', 'i').replaceAll('û', 'u').replaceAll('ā', 'a').replaceAll('â', 'a').replaceAll('ô', 'o')
        //     s2 = s2.replaceAll('î', 'i').replaceAll('û', 'u').replaceAll('ā', 'a').replaceAll('â', 'a').replaceAll('ô', 'o')
        // }

        //var listVowels = ['a', 'i', 'î', 'o', 'e', 'u', 'û', 'ē', 'ə', 'ā', 'â', 'ê', 'ô', 'j', '5']
        //var listConsonants = ['š', 'ṣ', 'ḵ', 'm', 'h', 't', 'ḥ', 's', 'm', 'n', 'p', 'f', 'b', 'v', 'd', 'k', 'l', 'ʿ', 'ʾ', 'y', 'w', 'z', 'r', 'g', 'q']
        //var listSoundsToUse = sSoundType === 'v' ? listVowels : listConsonants

        //var listSounds1 = [...s1].map((sLetter, nLetter) => ({Letter: sLetter, LetterIndex: nLetter})).filter(o => listSoundsToUse.includes(o.Letter))
        //var listSounds2 = [...s2].map((sLetter, nLetter) => ({Letter: sLetter, LetterIndex: nLetter})).filter(o => listSoundsToUse.includes(o.Letter))

        var listSounds1 = sSoundType === 'v' ? this.GetBasicVowelsInTransliteration(s1) : this.GetConsonantsInTransliteration(s1)
        var listSounds2 = sSoundType === 'v' ? this.GetBasicVowelsInTransliteration(s2) : this.GetConsonantsInTransliteration(s2)

        //console.log(listSounds1, listSounds2)
        
        var nMaxScoreForThisPairOfWords = 0
        var sWindowForMax = ''
        //var listMatchedLetterIndexesForMaxScore = []

        for(var nWindowSize = 2; nWindowSize < Math.min(listSounds1.length, listSounds2.length) + 1; nWindowSize++)
        {
            for(var nWindowStartIndex1 = 0; nWindowStartIndex1 < listSounds1.length; nWindowStartIndex1++)
            {
                var windowRange = {'begin': nWindowStartIndex1, 'end': nWindowStartIndex1 + nWindowSize}
                var listToCompare1 = listSounds1.slice(windowRange['begin'], windowRange['end'])

                for(var nWindowStartIndex2 = 0; nWindowStartIndex2 < listSounds2.length; nWindowStartIndex2++)
                {
                    var listToCompare2 = listSounds2.slice(nWindowStartIndex2, nWindowStartIndex2 + nWindowSize)

                    //compare index 0 to index 0, 1 to 1, etc.
                    var nScoreForThisWindow = 0
                    var nMatchedSufficiently = 0
                    //var listMatchedLetterIndexesForWindow = []

                    for(var nIndexToCompare = 0; nIndexToCompare < Math.min(listToCompare1.length, listToCompare2.length); nIndexToCompare++)
                    {
                        var nSoundSimilarity = this.SoundSimilarity(listToCompare1[nIndexToCompare], listToCompare2[nIndexToCompare])
                        if(nSoundSimilarity > 0) //0.5
                        {
                            nScoreForThisWindow += 1.0 * nSoundSimilarity //(sSoundType === 'v' ? 1.0 : 1.0)
                            //listMatchedLetterIndexesForWindow.push(listToCompare1[nIndexToCompare].LetterIndex)
                            nMatchedSufficiently += 1
                        }
                    }

                    if (nMatchedSufficiently === nWindowSize)
                    {
                        //console.log(nScoreForThisWindow, listToCompare1, listToCompare2, s1, s2)
                        if(nScoreForThisWindow > nMaxScoreForThisPairOfWords) 
                        {
                            nMaxScoreForThisPairOfWords = nScoreForThisWindow

                            //if they are not an identical match, show both strings for clarity
                            var sWindowToShow1 = listToCompare1.join('')
                            var sWindowToShow2 = listToCompare2.join('')
                            sWindowForMax = sWindowToShow1 === sWindowToShow2 ? sWindowToShow1 : (sWindowToShow1 + '-' + sWindowToShow2)
                            //listMatchedLetterIndexesForMaxScore = listMatchedLetterIndexesForWindow
                        }
                    }
                }
            }
        }

        //adjust the indexes if there are letters that will be expanded later, like to sh or ts
        // var listStringsThatNeedAdjustedUp = ['ṣ', 'š', 'ḵ', 'ê']
        // var listStringsThatNeedAdjustedDown = ['iym', 'iyn', 'ah', 'ayw', 'iyw']

        // for(var nToAdjust = 0; nToAdjust < listMatchedLetterIndexesForMaxScore.length; nToAdjust++)
        // {
        //     var nAdjustmentAmount = 0
        //     var sPreviousContext = s1.slice(0, nToAdjust)
        //     for(var n1 = 0; n1 < sPreviousContext.length; n1++)
        //     {
        //         for(var sUp of listStringsThatNeedAdjustedUp)
        //         {
        //             if(sPreviousContext.startsWith(sUp))
        //             {
        //                 nAdjustmentAmount += 1
        //             }
        //         }
        //         for(var sDown of listStringsThatNeedAdjustedDown)
        //         {
        //             if(sPreviousContext.startsWith(sDown))
        //             {
        //                 nAdjustmentAmount -= 1
        //             }
        //         }
        //     }

        //     listMatchedLetterIndexesForMaxScore[nToAdjust] += nAdjustmentAmount
        // }

        // w['Syllables'].map(s => s.replaceAll(':', '').replaceAll('ṣ', 'ts').replaceAll('š', 'sh').replaceAll('ḵ', 'kh')
        //     .replaceAll('iym', 'im').replaceAll('iyn', 'in').replaceAll('ê', 'ey').replaceAll('â', 'a')
        //     .replaceAll('ô', 'o').replaceAll('û', 'u').replaceAll('ah', 'a').replaceAll('ayw', 'av').replaceAll('iyw', 'iv'))

        //console.log(sWindowForMax, listSounds1, listSounds2, nMaxScoreForThisPairOfWords, listMatchedLetterIndexesForMaxScore)

        return {Score: nMaxScoreForThisPairOfWords, WindowForMax: sWindowForMax} //, MatchedLetterIndexes: listMatchedLetterIndexesForMaxScore}
    }

    GetSoundChainColorForWords(w1, w2)
    {
        var oResultVowels = this.GetSoundChainAmountForWords(w1, w2, 'v')
        var oResultConsonants = this.GetSoundChainAmountForWords(w1, w2, 'c')

        //console.log(oResultVowels, oResultConsonants)
        w1.InfoForSoundChainLens = oResultVowels.WindowForMax + ' ' + oResultConsonants.WindowForMax

        var nAmount = oResultVowels.Score + oResultConsonants.Score
        var sColor = nAmount < 1 ? "LightGray" : 
            nAmount < 3 ? "Gray" : 
            nAmount < 4 ? "Green" : 
            nAmount < 5 ? "Red" : "Purple"

        //console.log(nAmount)
        return sColor //{Word: w1, Color: sColor} //, LetterIndexes: oResult.MatchedLetterIndexes}
    }

    GetRhymeAmountForSyllables(syl1, syl2, blnOnlyWhenBothAtWordBeginningOrEnd, sRestrictToLocation)
    {
        //syl2 is the hovered or stickied one
        var blnBothAccented = syl1.hasFullAccent && syl2.hasFullAccent
        var blnBothAtWordBeginning = syl1.syllableIndex === 0 && syl2.syllableIndex === 0
        var blnBothAtWordEnd = syl1.isLastSyllableInWord && syl2.isLastSyllableInWord
        var blnSyl2AtWordMiddle = syl2.syllableIndex > 0 && !syl2.isLastSyllableInWord

        if(sRestrictToLocation === 'beginning' && !blnBothAtWordBeginning) return 0
        if(sRestrictToLocation === 'end' && !blnBothAtWordEnd) return 0
        if(sRestrictToLocation === 'beginning or end' && !(blnBothAtWordBeginning || blnBothAtWordEnd)) return 0
        if(sRestrictToLocation === 'middle' && (blnBothAtWordBeginning || blnBothAtWordEnd)) return 0
        if(sRestrictToLocation === 'mostfrequent' && !this.IsSyllableInPrimeRhymePositions(syl1)) return 0
        if(sRestrictToLocation === 'accented' && !syl1.hasFullAccent) return 0
        
        //nMaxDistanceCutoff = 10
        //nScalingFactor = 0 if (n - nPreviousWord) == nMaxDistanceCutoff else nMaxScalingFactor / (n - nPreviousWord)

        //compare each syllable with those in listSyllablesInPreviousWord
        //If the similar sound occurs at the beginning or end of both words, add bonus points
        //If there is a sequence of two or more similar consonants or vowels, 
        //add bonus points to all the syllables containing those sounds.

        var nAmount = 0
        var listSounds = this.SplitSyllableForComparison(syl1.syllable)
        var listSounds2 = this.SplitSyllableForComparison(syl2.syllable)

        nAmount += 1 * this.SoundSimilarity(listSounds[0], listSounds2[0]) * (blnBothAtWordBeginning && blnBothAccented ? 1.8 : blnBothAccented ? 1.5 : blnBothAtWordBeginning ? 1.4 : 1)

        if(listSounds.length > 1 && listSounds2.length > 1)
        {
            nAmount += 1 * this.SoundSimilarity(listSounds[1], listSounds2[1]) * (blnBothAtWordEnd && blnBothAccented ? 1.8 : blnBothAccented ? 1.5 : blnBothAtWordEnd ? 1.3 : 1)
        }

        //compare the last consonant in closed syllables, which have 3 sounds in them.
        if(listSounds.length == 3 && listSounds2.length == 3)
        { 
            nAmount += 1 * this.SoundSimilarity(listSounds[2], listSounds2[2]) * (blnBothAtWordEnd && blnBothAccented ? 1.8 : blnBothAccented ? 1.5 : blnBothAtWordEnd ? 1.3 : 1)
        }

        //if the hovered syllable is in the middle of the word, look for matches in all positions
        //if it is a very good match at a different place in the word, display it anyway
        if(nAmount < 4 && blnOnlyWhenBothAtWordBeginningOrEnd && !blnSyl2AtWordMiddle && !(blnBothAtWordBeginning || blnBothAtWordEnd)) return 0

        return nAmount
    }

    GetRhymeAmountColorForSyllables(syl1, listSyllables2, blnOnlyWhenBothAtWordBeginningOrEnd, sRestrictToLocation)
    {
        if(listSyllables2.some(syl2 => syl1.syllable === syl2.syllable)) return "Black"

        var nAmount = 0
        for(const syl2 of listSyllables2)
        {
            nAmount += this.GetRhymeAmountForSyllables(syl1, syl2, blnOnlyWhenBothAtWordBeginningOrEnd, sRestrictToLocation)
        }

        return nAmount < 0.25 ? "LightGray" : 
            nAmount < 1 ? "Gray" : 
            nAmount < 2 ? "Green" : 
            nAmount < 3 ? "Orange" : 
            nAmount < 4 ? "Red" : 
            nAmount < 5 ? "Purple" : "Black"
    }

    GetCombinedRhymeAmountForSyllables(w1, w2, sRestrictToLocation)
    {
        if(w1.FullText === w2.FullText) return "Black"

        var nMaxSyllableScoreForWords = 0
        var listSufficientlyMatchedSyllables = []
        
        for(var syl1 of w1.SyllableObjects)
        {
            for(var syl2 of w2.SyllableObjects)
            {
                var nScore = this.GetRhymeAmountForSyllables(syl1, syl2, false, sRestrictToLocation)
                if(nScore > nMaxSyllableScoreForWords) 
                {
                    nMaxSyllableScoreForWords = nScore
                    listSufficientlyMatchedSyllables.push(syl1.syllable + '-' + syl2.syllable)
                }
                else if(nScore >= 2) listSufficientlyMatchedSyllables.push(syl1.syllable + '-' + syl2.syllable)
            }
        }

        var oResultVowelChains = this.GetSoundChainAmountForWords(w1, w2, 'v')
        var oResultConsonantChains = this.GetSoundChainAmountForWords(w1, w2, 'c')

        //console.log(oResultVowels, oResultConsonants)
        w1.InfoForSoundChainLens = oResultVowelChains.WindowForMax + ' ' + oResultConsonantChains.WindowForMax + ' ' + 
            listSufficientlyMatchedSyllables.join(' ')

        return oResultVowelChains.Score + oResultConsonantChains.Score + nMaxSyllableScoreForWords
    }

    GetCombinedAmountColorForSyllables(w1, w2, sRestrictToLocation)
    {
        var nAmount = this.GetCombinedRhymeAmountForSyllables(w1, w2, sRestrictToLocation)
        return nAmount < 1 ? "LightGray" : 
            nAmount < 2 ? "Gray" : 
            nAmount < 4 ? "Green" : 
            nAmount < 5 ? "Orange" : 
            nAmount < 6 ? "Red" : 
            nAmount < 7 ? "Purple" : "Black"
    }

    GetCombinedRhymeMaximumAmount(w1, listWordsToUse, sRestrictToLocation)
    {
        var nMaxScore = 0

        var nTextIndex1 = parseInt(w1.TextIndex)
        for(var w2 of listWordsToUse.filter(w3 => Math.abs(parseInt(w3.TextIndex) - nTextIndex1) <= this.state.nMaxTextIndexDistanceForRhymeMaximumAmountCalcs))
        {
            if(w1 === w2) continue

            var nScoreForThisComparison = this.GetCombinedRhymeAmountForSyllables(w1, w2, sRestrictToLocation)
            if(nScoreForThisComparison > nMaxScore) 
            {
                nMaxScore = nScoreForThisComparison
            }
        }

        return nMaxScore
    }

    GetCombinedRhymeMaximumAmountColor(w1, listWordsToUse, sRestrictToLocation)
    {
        var nAmount = this.GetCombinedRhymeMaximumAmount(w1, listWordsToUse, sRestrictToLocation)
        return nAmount < 4 ? "LightGray" : 
            //nAmount < 2 ? "Gray" : 
            nAmount < 5 ? "Green" : 
            nAmount < 7 ? "Red" : 
            nAmount < 8 ? "Purple" : "Black"
    }

    IsSyllableInPrimeRhymePositions(oSyllable)
    {
        //the first syllable in the line, the first accented syllable in the line, and the last accented syllable in the line
        return this.state.listLines.some(l => l.SyllableObjects[0] === oSyllable) || 
            this.state.listLines.some(l => {
                var listAccentedSyllableInLine = l.SyllableObjects.filter(oSyl => oSyl.hasFullAccent)
                return listAccentedSyllableInLine[0] === oSyllable || listAccentedSyllableInLine[listAccentedSyllableInLine.length - 1] === oSyllable})
    }

    TextIndexesAreWithinRangeForRhymeMaximum(nTextIndex1, nTextIndex2, blnOnlyLookAtPreviousSyllablesForRhyme)
    {
        var nDifference = Math.abs(nTextIndex1 - nTextIndex2)
        if(blnOnlyLookAtPreviousSyllablesForRhyme)
        {
            return nTextIndex1 > nTextIndex2 && nDifference <= this.state.nMaxTextIndexDistanceForRhymeMaximumAmountCalcs
        }
        else
        {
            return nDifference <= this.state.nMaxTextIndexDistanceForRhymeMaximumAmountCalcs
        }
    }

    GetSyllableRhymeMaximumAmount(oSyl1, listSyllablesToUse, sLocationRestriction)
    {
        var nMaxScore = 0

        if(sLocationRestriction === 'mostfrequent' && !this.IsSyllableInPrimeRhymePositions(oSyl1)) return 0
        if(sLocationRestriction === 'accented' && !oSyl1.hasFullAccent) return 0

        //console.log(listSyllablesToUse)
        //var nTextIndex1 = parseInt(oSyl1.word.TextIndex)
        var oLineForSyllable1 = this.GetLineContainingWord(oSyl1.word)

        var listSyllablesToUse2 = listSyllablesToUse.filter(syl => this.GetLineContainingWord(syl.word) === oLineForSyllable1)
        //listSyllablesToUse.filter(syl => this.TextIndexesAreWithinRangeForRhymeMaximum(nTextIndex1, parseInt(syl.word.TextIndex), this.state.blnOnlyLookAtPreviousSyllablesForRhyme))

        for(var syl2 of listSyllablesToUse2)
        {
            if(oSyl1.word === syl2.word) continue
            if(sLocationRestriction === 'mostfrequent' && !this.IsSyllableInPrimeRhymePositions(syl2)) continue
            if(sLocationRestriction === 'accented' && !syl2.hasFullAccent) continue

            var nScoreForThisComparison = this.GetRhymeAmountForSyllables(oSyl1, syl2, false, sLocationRestriction)
            if(nScoreForThisComparison > nMaxScore) 
            {
                nMaxScore = nScoreForThisComparison
                //if(oSyl1.syllable === "vēyt") console.log(oSyl1.syllable, syl2.syllable, nScoreForThisComparison)
            }
        }

        //if(oSyl1.syllable === "vēyt" && syl2.syllable === "mim*") console.log(oSyl1, syl2, nMaxScore)
        //console.log(oSyl1, syl2, nMaxScore)

        return nMaxScore
    }

    GetSyllableRhymeMaximumAmountColor(oSyl1, listSyllablesToUse, sLocationRestriction)
    {
        var nAmount = this.GetSyllableRhymeMaximumAmount(oSyl1, listSyllablesToUse, sLocationRestriction)

        if(sLocationRestriction === 'mostfrequent' || 
            sLocationRestriction === 'accented')
        {
            //have a different, more generous scale to show more of the syllables
            return nAmount < 1.5 ? "LightGray" : 
                nAmount < 2 ? "Gray" : 
                nAmount < 3 ? "Green" : 
                nAmount < 4 ? "Red" : 
                nAmount < 5 ? "Purple" : "Black"
        }
        else
        {
            return nAmount < 0.9 ? "LightGray" : 
                nAmount < 1.5 ? "Gray" : 
                nAmount < 2 ? "Green" : 
                nAmount < 2.5 ? "Red" : 
                nAmount < 3 ? "Purple" : "Black"
        }
    }

    GetSyllableRhymeCumulativeAmountColor(oSyl1, listSyllablesToUse, sLocationRestriction)
    {
        //var listScoresBySyllable = []
        //var listToReturn = []

        var nMaxScalingFactor = 1
        var nMaxDistanceCutoff = 10
        var nScore = 0
        
        var nTextIndex1 = parseInt(oSyl1.word.TextIndex)
        var listOtherWords = listSyllablesToUse.map(o => o.word)

        for(var w of listOtherWords)
        {
            var nTextIndexDistance = nTextIndex1 - parseInt(w.TextIndex)
            if(nTextIndexDistance > 0 && nTextIndexDistance < nMaxDistanceCutoff)
            {
                var nScalingFactor = nMaxScalingFactor / 1.0 * nTextIndexDistance
                var nMaximumScoreForWord = 0

                for(var sylPrev of listSyllablesToUse.filter(oSyl => oSyl.word == w))
                {
                    nScore = this.GetRhymeAmountForSyllables(oSyl1, sylPrev, false, sLocationRestriction) * nScalingFactor
                    if(nScore > nMaximumScoreForWord) nMaximumScoreForWord = nScore
                }

                nScore += nMaximumScoreForWord
            }
        }

        // var nSyl = listSyllablesToUse.indexOf(oSyl1)
        // //for(var nSyl = 0; nSyl < listSyllablesToUse.length - 1; nSyl++)
        // //{
        //     var nScore = 0
        //     //oSyl1 = listSyllablesToUse[nSyl]
        //     for(var nSylPrev = (nSyl - nMaxDistanceCutoff < 0) ? 0 : (nSyl - nMaxDistanceCutoff); nSylPrev < nSyl; nSylPrev++)
        //     {
        //         var oSyl2 = listSyllablesToUse[nSyl]
        //         var nScalingFactor = (nSyl - nSylPrev) == nMaxDistanceCutoff ? 0 : (3 * nMaxScalingFactor) / (nSyl - nSylPrev)
        //         nScore += this.GetRhymeAmountForSyllables(oSyl1, oSyl2, false, sLocationRestriction) * nScalingFactor
        //     }

        //     //listScoresBySyllable.push({'Syllable': oSyl1, 'TotalScore': nTotalScoreForSyllable})
        // //}

        //listToReturn.push({ListWords: listScoresBySyllable., Color: 'red'})
        //return listToReturn;

        var nAmount = nScore
        return nAmount < 0.25 ? "LightGray" : 
            nAmount < 1 ? "Gray" : 
            nAmount < 2 ? "Green" : 
            nAmount < 3 ? "Orange" : 
            nAmount < 4 ? "Red" : 
            nAmount < 5 ? "Purple" : "Black"
    }


    CharLens(listChars)
    {
        return [{ListWords: this.listTextWordsForChapter.filter(w => listChars.some(c => w.FullText.includes(c))), 'Color': 'Blue'}]
    }

    WordsWithPenultimateAccentLens()
    {
        return [{ListWords: this.listTextWordsForChapter.filter(w => w.HasPenultimateAccent), 'Color': 'Blue'}]
    }

    WordHasDageshHazaqOrMappiq(w)
    {
        var listChars = Array.from(w.FullText)
        var listValidIndexesOfDagesh = listChars.reduce((c, v, n) => v === '\u05bc' ? c.concat(n) : c, []).
            filter(n => {
                var blnWordInitial = n <= 1
                var blnWithWaw = listChars[n - 1] === '\u05d5'
                var blnWithBegadkefatAfterSheva = listChars[n - 2] === '\u05b0' && this.listBegadkefat.includes(listChars[n - 1])
                
                return !(blnWordInitial || blnWithWaw || blnWithBegadkefatAfterSheva)
            })
        return listValidIndexesOfDagesh.length > 0
    }

    DageshLens(listTextWords)
    {
        return [{ListWords: listTextWords.filter(w => this.WordHasDageshHazaqOrMappiq(w)), 'Color': 'Blue'}]
    }

    WordIsInterrogative(w)
    {
        return w.MorphCode.includes('HTi/')
    }

    InterrogativeLens(listTextWords)
    {
        return [{ListWords: listTextWords.filter(w => this.WordIsInterrogative(w)), 'Color': 'Blue'}]
    }

    WordSatisfiesConstructStateLensCriteria(w)
    {
        return w.ConstructState === 'c' && w.SuffixPerson === undefined && w.LexicalID != '3850'
    }

    ConstructStateLens(listTextWords)
    {
        //not kol - there is a different lens for that
        return [{ListWords: listTextWords.filter(w => this.WordSatisfiesConstructStateLensCriteria(w)), 'Color': 'Blue'}]
    }

    GetGlossIndexesFromGlossesForSemanticSimilarity(w)
    {
        // console.log(w.Gloss.split('^').flatMap(s => s.split(' ')).filter(s => s != '' && !this.listGlossStopwords.includes(s)))
        return w.Gloss.split('^').filter(s => s != '' && !this.listGlossStopwords.includes(s)).map(s => this.listSimScoreDataForChapter.GlossList.indexOf(s)).filter(n => n > -1)
    }

    GetSemanticSimilarityAmountColor(w1, w2)
    {
        if(w1 === undefined || w2 === undefined || this.listSimScoreDataForChapter.GlossList === undefined) return "Gray"
        if(w1.Gloss === w2.Gloss) return 'Black'

        var listGlossIndexes1 = this.GetGlossIndexesFromGlossesForSemanticSimilarity(w1)
        var listGlossIndexes2 = this.GetGlossIndexesFromGlossesForSemanticSimilarity(w2)

        if(listGlossIndexes1.length > 0 && listGlossIndexes2.length > 0 && listGlossIndexes1[0] === listGlossIndexes2[0]) return 'Black'

        // console.log(listGlossIndexes1)
        // console.log(listGlossIndexes2)

        var listScores = this.listSimScoreDataForChapter.SimScores.filter(o => (listGlossIndexes1.includes(o.N1) && listGlossIndexes2.includes(o.N2)) || 
            (listGlossIndexes1.includes(o.N2) && listGlossIndexes2.includes(o.N1))).map(o => o.Score)

        // if(listGlossIndexes2.length > 1)
        // {
        //     console.log(w1.Gloss)
        //     console.log(listScores)
        // }

        var nScore = listScores.length === 0 ? 0 : Math.max(...listScores)
        return nScore < 0.3 ? "LightGray" : 
            nScore < 0.4 ? "Gray" : 
            nScore < 0.5 ? "Green" : 
            nScore < 0.65 ? "Orange" : 
            nScore < 0.75 ? "Red" : 
            nScore < 0.85 ? "Purple" : "Black";
    }
    
    IncludeWordInRootCooccurrenceLens(w)
    {
        return ['N', 'V', 'A'].includes(w.WordType) //&& !['3270'].includes(w.LexicalID)
    }

    GetRootCooccurrenceAmountColor(w1, w2)
    {
        if(!this.IncludeWordInRootCooccurrenceLens(w1) || !this.IncludeWordInRootCooccurrenceLens(w2)) return 'LightGray'

        if(w1 === undefined || w2 === undefined) return "Gray"
        if(w1.ParentRoot === w2.ParentRoot && w1.ParentRoot != '') return 'Black'

        var nRootIndex1 = this.listRootCooccurrenceDataForChapter.RootList.indexOf(w1.ParentRoot)
        var nRootIndex2 = this.listRootCooccurrenceDataForChapter.RootList.indexOf(w2.ParentRoot)

        var sRoot1 = this.listRootCooccurrenceDataForChapter.RootList[nRootIndex1]
        var sRoot2 = this.listRootCooccurrenceDataForChapter.RootList[nRootIndex2]

        if(sRoot1 === '' || sRoot2 === '') return "LightGray"
        
        var listScores = this.listRootCooccurrenceDataForChapter.Scores.filter(o => (nRootIndex1 === o.R1 && nRootIndex2 === o.R2) || 
            (nRootIndex1 === o.R2 && nRootIndex2 === o.R1)).map(o => o.N)

        // console.log(this.listRootCooccurrenceDataForChapter.Scores)
        var nScore = listScores.length === 0 ? 0 : Math.max(...listScores)

        // var nOccs1 = this.listRootOccurrencesData.find(o => o.Root === sRoot1).Occs
        // var nOccs2 = this.listRootOccurrencesData.find(o => o.Root === sRoot2).Occs
        // // var nAverageOccs = ((nOccs1 + nOccs2) / 2.0)

        // nScore = (nOccs1 > 100 || nOccs2 > 100) ? 0 : nScore

        // return nScore < 0.1 ? "LightGray" : 
        //     nScore < 0.2 ? "Gray" : 
        //     nScore < 0.3 ? "Green" : 
        //     nScore < 0.4 ? "Orange" : 
        //     nScore < 0.5 ? "Red" : 
        //     nScore < 0.6 ? "Purple" : 
        //     nScore >= 0.7 ? "Black" : "LightGray";

        // var listDistributionForChapter = this.listRootCooccurrenceDataForChapter.Scores.map(o => 
        //     (this.listRootOccurrencesData.find(o2 => o2.Root === this.listRootCooccurrenceDataForChapter.RootList[o.R1]).Occs + 
        //     this.listRootOccurrencesData.find(o2 => o2.Root === this.listRootCooccurrenceDataForChapter.RootList[o.R2]).Occs) / 2.0)
        // navigator.clipboard.writeText(JSON.stringify(listDistributionForChapter))

        return nScore < 2 ? "LightGray" : 
            nScore < 5 ? "Gray" : 
            nScore < 10 ? "Green" : 
            nScore < 20 ? "Orange" : 
            nScore < 30 ? "Red" : 
            nScore < 50 ? "Purple" : 
            nScore >= 100 ? "Black" : "LightGray"
    }

    GetParticleType(w)
    {
        return w.WordType != 'T' ? undefined : w.MorphCode.slice(2,3)
    }

    ParticlesLens(listTextWords)
    {
        var listToReturn = []
        var listParticles = listTextWords.filter(w => w.WordType === 'T')
        var listDistinctParticleTypes = [...new Set(listParticles.map(w => this.GetParticleType(w)))]

        for(var sParticleType of listDistinctParticleTypes)
        {
            listToReturn.push({ListWords: listParticles.filter(w => this.GetParticleType(w) === sParticleType), 
                Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
        }

        return listToReturn
        // var groupedByLexicalID = this.GroupArrayByKey(this.listTextWordsForChapter.filter(w => w.WordType === 'T'), 'LexicalID')
        // return Object.keys(groupedByLexicalID).map((k, n) => ({ListWords: groupedByLexicalID[k], 
        //     Color: this.listLinkGroupColors[n % this.listLinkGroupColors.length]}))
    }

    EllipsisLens(listTextWords)
    {
        return [{ListWords: listTextWords.filter(w => w.clause_typ === 'Ellp'), Color: 'Green'}]
    }

    GroupArrayByKeyLens(sKey, listTextWordsToUse)
    {
        var listToReturn = [];
        var groupedByKey = this.GroupArrayByKey(listTextWordsToUse, sKey);
        for(var k of Object.keys(groupedByKey))
        {
            if(groupedByKey[k].length > 1)
            {
                var listInstancesOfWord = groupedByKey[k]
                //var sTextOfAllInstances = listInstancesOfWord.map(w1 => w1.FullText).join(' ')
                //listInstancesOfWord.forEach(w1 => w1.InfoForRepLens = sTextOfAllInstances)

                listToReturn.push({Name: k, ListWords: listInstancesOfWord, 
                    Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
            }
        }
        return listToReturn;
    }

    RepeatedWordsLens(listTextWordsToUse)
    {
        var listToReturn = [];
        var groupedByLexicalID = this.GroupArrayByKey(listTextWordsToUse, "LexicalID");
        for(var k of Object.keys(groupedByLexicalID))
        {
            if(groupedByLexicalID[k].length > 1)
            {
                var listInstancesOfWord = groupedByLexicalID[k]
                var sTextOfAllInstances = listInstancesOfWord.map(w1 => w1.FullText).join(' ')
                listInstancesOfWord.forEach(w1 => w1.InfoForRepLens = sTextOfAllInstances)

                listToReturn.push({ListWords: listInstancesOfWord, 
                    Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
            }
        }
        return listToReturn;
    }

    RepeatedRootsLens(listTextWordsToUse, blnOnlyShowGroupsWithDifferentGlosses)
    {
        var listToReturn = [];

        //var listLexicalIDsForRepeatedWords = this.RepeatedWordsLens().flatMap(g => g.ListWords.map(w => w.LexicalID));
        var groupedByLexicalID = this.GroupArrayByKey(listTextWordsToUse, "ParentRoot");
        for(var k of Object.keys(groupedByLexicalID))
        {
            if(k != '' && groupedByLexicalID[k].length > 1)
            {
                var listInstancesOfWord = groupedByLexicalID[k] //.filter(w => !listLexicalIDsForRepeatedWords.includes(w.LexicalID))
                var sTextOfAllInstances = listInstancesOfWord.map(w1 => w1.FullText).join(' ')
                listInstancesOfWord.forEach(w1 => w1.InfoForRepLens = sTextOfAllInstances)

                listToReturn.push({ListWords: listInstancesOfWord, 
                    Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
            }
        }

        if(blnOnlyShowGroupsWithDifferentGlosses)
        {
            listToReturn = listToReturn.filter(o => [...new Set(o.ListWords.map(w => this.FilterOutGlossStopwords(w)))].length > 1)
        }
        
        return listToReturn;
    }

    GetBreakGroupAnchorWords(sGroupLinesByToUse)
    {
        var listToReturn = []
        var listLinesByBreakGroup = this.GetLinesByBreakGroup(this.state.listLines, sGroupLinesByToUse)

        for(var listLinesInGroup of listLinesByBreakGroup)
        {
            listToReturn.push(this.GetBeginningMiddleEnd(listLinesInGroup))

            // listToReturn.push({
            //     BeginningWords: this.GetUnitPartLines(listLinesInGroup, sGroupLinesByToUse, 'beginning', 0).flatMap(l => l.Words),
            //     EndingWords: this.GetUnitPartLines(listLinesInGroup, sGroupLinesByToUse, 'ending', 0).flatMap(l => l.Words)
            // })

            // listToReturn.push({
            //     BeginningWords: this.GetUnitPartLines(listLinesInGroup, sGroupLinesByToUse, 'beginning', 0).flatMap(l => l.Words).concat(
            //         this.GetUnitPartLines(listLinesInGroup, sGroupLinesByToUse, 'beginning', 1).flatMap(l => l.Words)),
            //     EndingWords: this.GetUnitPartLines(listLinesInGroup, sGroupLinesByToUse, 'ending', 0).flatMap(l => l.Words).concat(
            //         this.GetUnitPartLines(listLinesInGroup, sGroupLinesByToUse, 'ending', 1).flatMap(l => l.Words))
            // })
        }

        return listToReturn
    }

    UnitBeginningMiddleEndLens()
    {
        var listToReturn = []
        var listAnchorWordsByBreakGroup = this.GetBreakGroupAnchorWords(this.state.sGroupLinesBy)

        for(var o of listAnchorWordsByBreakGroup)
        {
            listToReturn.push({ListWords: o.Beginning.flatMap(l => l.Words), Color: 'Blue'})
            listToReturn.push({ListWords: o.Middle.flatMap(l => l.Words), Color: 'Purple'})
            listToReturn.push({ListWords: o.End.flatMap(l => l.Words), Color: 'Green'})
        }
        
        return listToReturn
    }

    WordPairsAcrossLists(listWords1, listWords2, sColor, sPosition, nUnit, sUnitToGroupBy)
    {
        var listToReturn = []
        for(var w1 of listWords1)
        {
            for(var w2 of listWords2)
            {
                if(w1 != w2 && this.GetAllSimilarityAmountScore(w1, w2).Score > 4) //w1.ParentRoot === w2.ParentRoot) //this.GetAllSimilarityAmountScore(w1, w2).Score > 3)
                {
                    listToReturn.push({ListWords: [w1, w2], Color: sColor, Name: sPosition, Unit: nUnit, UnitToGroupBy: sUnitToGroupBy,
                        AxisLabel: w1.FullText + '-' + w2.FullText, Positions: [sPosition]})
                }
            }
        }

        return listToReturn
    }

    BookendingInSameUnitLens()
    {
        var listToReturn = []
        var listAnchorWordsByBreakGroup = this.GetBreakGroupAnchorWords(this.state.sGroupLinesBy)

        for(var o of listAnchorWordsByBreakGroup)
        {
            var listWordPairs = this.WordPairsAcrossLists(o.BeginningWords, o.EndingWords, 'Blue', 'Intraunit Bookends')
            listWordPairs.forEach((o,n) => o.Color = this.listLinkGroupColors[n % this.listLinkGroupColors.length])
            listToReturn = listToReturn.concat(listWordPairs)
        }

        return listToReturn
    }

    ConsecutiveUnitLinksLens()
    {
        var listToReturn = []
        var listAnchorWordsByBreakGroup = this.GetBreakGroupAnchorWords(this.state.sGroupLinesBy)

        for(var nUnit = 0; nUnit < listAnchorWordsByBreakGroup.length - 1; nUnit++)
        {
            var oUnit1 = listAnchorWordsByBreakGroup[nUnit]
            var oUnit2 = listAnchorWordsByBreakGroup[nUnit + 1]

            this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.BeginningWords, oUnit2.BeginningWords, 'Blue', 'Begin-Begin')
            this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.EndingWords, oUnit2.EndingWords, 'Blue', 'End-End')
            this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.EndingWords, oUnit2.BeginningWords, 'Blue', 'End-Begin')
            this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.BeginningWords, oUnit2.EndingWords, 'Blue', 'Begin-End')
        }

        return listToReturn
    }

    AddWordPairsToLinkListIfNew(listToAddTo, listWords1, listWords2, sColor, sName, nUnit, sUnitToGroupBy)
    {
        var listToMaybeAdd = this.WordPairsAcrossLists(listWords1, listWords2, sColor, sName, nUnit, sUnitToGroupBy)
        for(var o of listToMaybeAdd)
        {
            //merge ones with the same root all into one list
            var oOneWithSameRoots = o.ListWords[0].ParentRoot != o.ListWords[1].ParentRoot ? undefined : 
                listToAddTo.find(o2 => o2.ListWords[0].ParentRoot === o2.ListWords[1].ParentRoot && 
                    o.ListWords[0].ParentRoot === o2.ListWords[0].ParentRoot)

            if(oOneWithSameRoots != undefined)
            {
                oOneWithSameRoots.ListWords = oOneWithSameRoots.ListWords.concat(o.ListWords)
                oOneWithSameRoots.AxisLabel = oOneWithSameRoots.ListWords[0].FullText
                oOneWithSameRoots.Name += ', ' + o.Name
                oOneWithSameRoots.Positions = oOneWithSameRoots.Positions.concat(o.Positions)
            }
            else
            {
                var oOneAlreadyAdded = listToAddTo.find(o2 => (o.ListWords[0] === o2.ListWords[0] && o.ListWords[1] === o2.ListWords[1]) || 
                    (o.ListWords[1] === o2.ListWords[0] && o.ListWords[0] === o2.ListWords[1]))

                if(oOneAlreadyAdded != undefined)
                {
                    oOneAlreadyAdded.Name += ', ' + o.Name
                    oOneAlreadyAdded.Positions = oOneAlreadyAdded.Positions.concat(o.Positions)
                }
                else
                {
                    listToAddTo.push(o)
                }
            }
        }
    }

    AllUnitLinksLens(blnShowRepeatedWordsNotIncludedHere, blnOnlyShowBeginningAndEndLinks, blnShowIntraUnitLinks)
    {
        var listToReturn = []
        var blnDoAllUnitTypesTogether = true
        var listUnitsToGroupBy = (blnDoAllUnitTypesTogether || blnShowRepeatedWordsNotIncludedHere) ? 
            ['StartsLevel4Group', 'StartsClusterGroup', 'StartsCluster', 'StartsRepetitionGroup'] : [this.state.sGroupLinesBy]

        for(var sUnitToGroupBy of listUnitsToGroupBy)
        {
            var listAnchorWordsByBreakGroup = this.GetBreakGroupAnchorWords(sUnitToGroupBy)

            if(blnShowIntraUnitLinks)
            {
                for(var nUnit = 0; nUnit < listAnchorWordsByBreakGroup.length; nUnit++)
                {
                    var oUnit = listAnchorWordsByBreakGroup[nUnit]
                    var listWordPairs = this.WordPairsAcrossLists(oUnit.Beginning, oUnit.End, 'Green', 'Intraunit Bookends', nUnit, sUnitToGroupBy)
                    listToReturn = listToReturn.concat(listWordPairs)
                }
            }

            for(var nUnit = 0; nUnit < listAnchorWordsByBreakGroup.length - 1; nUnit++)
            {
                var oUnit1 = listAnchorWordsByBreakGroup[nUnit]
                var oUnit2 = listAnchorWordsByBreakGroup[nUnit + 1]

                this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.Beginning, oUnit2.Beginning, 'Red', 'Begin-Begin', nUnit, sUnitToGroupBy)
                this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.End, oUnit2.End, 'Red', 'End-End', nUnit, sUnitToGroupBy)
                this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.End, oUnit2.Beginning, 'Blue', 'End-Begin', nUnit, sUnitToGroupBy)
                this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.Beginning, oUnit2.End, 'Blue', 'Begin-End', nUnit, sUnitToGroupBy)

                if(!blnOnlyShowBeginningAndEndLinks)
                {
                    this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.Middle, oUnit2.Middle, 'Blue', 'Middle-Middle', nUnit, sUnitToGroupBy)
                    this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.Beginning, oUnit2.Middle, 'Blue', 'Begin-Middle', nUnit, sUnitToGroupBy)
                    this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.Middle, oUnit2.End, 'Blue', 'Middle-End', nUnit, sUnitToGroupBy)
                    this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.Middle, oUnit2.Beginning, 'Blue', 'Middle-Begin', nUnit, sUnitToGroupBy)
                    this.AddWordPairsToLinkListIfNew(listToReturn, oUnit1.End, oUnit2.Middle, 'Blue', 'End-Middle', nUnit, sUnitToGroupBy)
                }
            }
        }

        if(blnShowIntraUnitLinks && !blnOnlyShowBeginningAndEndLinks)
        {
            //add relationships between consecutive lines
            for(var nLine = 0; nLine < this.state.listLines.length - 1; nLine++)
            {
                var oLine1 = this.state.listLines[nLine]
                var oLine2 = this.state.listLines[nLine + 1]

                this.AddWordPairsToLinkListIfNew(listToReturn, oLine1.Words, oLine2.Words, 'Purple', 'Consecutive Lines', -1, '')
            }
        }

        if(blnShowRepeatedWordsNotIncludedHere)
        {
            var listWordsIncludedHere = listToReturn.flatMap(o => o.ListWords.flat())

            var listRepeatedWordsGroups = this.RepeatedRootsLens(false)
            listRepeatedWordsGroups.forEach(g => g.ListWords = g.ListWords.filter(w => !listWordsIncludedHere.includes(w)))
            return listRepeatedWordsGroups.filter(g => g.ListWords.length > 1)

            // var listRepeatedWords = Object.values(this.GroupArrayByKey(this.listTextWordsForChapter, "ParentRoot")).filter(l => l.length > 1).flatMap(l => l)
            // var listWordsIncludedHere = listToReturn.flatMap(o => o.ListWords.flat())
            // return [{ListWords: listRepeatedWords.filter(w => !listWordsIncludedHere.includes(w)), Color: 'Blue'}]
        }

        // var listCalculationsByName = []
        // var listCalculationsBetweenUnits = []
        // for(var sUnitToGroupBy of listUnitsToGroupBy)
        // {
        //     var listResultsForGroupUnit = listToReturn.filter(o => o.UnitToGroupBy === sUnitToGroupBy)
        //          listResultsForGroupUnit.forEach(o => o.PositionsString = o.Positions.join(' ')) //TODO: Group by all elements in array
        //     var groupedByName = this.GroupArrayByKey(listResultsForGroupUnit, "PositionsString")
        //     listCalculationsByName.push({UnitToGroupBy: sUnitToGroupBy, Groups: Object.keys(groupedByName).
        //         map(k => ({Name: k, Number: groupedByName[k].length})).
        //         sort((a,b) => b.Number - a.Number)}) //a.Name.localeCompare(b.Name)

        //     var groupedByUnit = this.GroupArrayByKey(listResultsForGroupUnit.filter(o => !['Intraunit Bookends', 'Consecutive Lines'].includes(o.Name)), "Unit")
        //     listCalculationsBetweenUnits.push({UnitToGroupBy: sUnitToGroupBy, Groups: Object.keys(groupedByUnit).
        //         map(k => ({Unit: k, Number: groupedByUnit[k].length})).
        //         sort((a,b) => b.Number - a.Number)})
        // }

        // console.log(listCalculationsByName)
        // console.log(listCalculationsBetweenUnits)
        // console.log(listToReturn)

        return listToReturn
    }

    RepetitionLinkGroupLens(nType, listTags)
    {
        var listToReturn = [];
		listToReturn = this.GetRepetitionLinkGroupsForCurrentChapter().
			filter(g => g.Type === nType && (listTags === undefined || listTags.some(sID => g.ListTags.some(t => t.CategoryID === sID)))).
			map((g,index) => {
				return {ListWords: g.ListWords.map(n => this.GetWordWithTextIndexInChapter(n)), 
					Name: g.Comment + (g.Comment === "" ? "" : "; ") + g.ListTags.map(t => this.GetDescForRepetitionLinkGroupCategoryID(t.CategoryID)).join(", "), 
					Color: this.listLinkGroupColors[index % this.listLinkGroupColors.length]}});
        return listToReturn;
    }

	GetColorByMainType(sMainType)
	{
		// [ "Blue", "Red", "Fuchsia", "Green", "DarkMagenta", "DarkOrange", "Maroon", "CornflowerBlue", "Indigo", "DarkCyan",  
		// "Brown", "hsl(43, 80%, 40%)", "Black", "Crimson", "Olive"];

		return sMainType === undefined ? "Black" :
			sMainType === "Similar" ? "DarkCyan" :
			sMainType === "Opposite" ? "Blue" :
			sMainType === "Associated" ? "Green" :
			sMainType === "Discourse Relationship" ? "hsl(43, 80%, 40%)" :
			sMainType === "Rhyme" ? "CornflowerBlue" : "Red";
	}

	GetColorPriorityByMainType(sMainType)
	{
		// [ "Blue", "Red", "Fuchsia", "Green", "DarkMagenta", "DarkOrange", "Maroon", "CornflowerBlue", "Indigo", "DarkCyan",  
		// "Brown", "hsl(43, 80%, 40%)", "Black", "Crimson", "Olive"];

		return sMainType === undefined ? 0 :
			sMainType === "Similar" ? 2 :
			sMainType === "Opposite" ? 1 :
			sMainType === "Associated" ? 3 :
			sMainType === "Discourse Relationship" ? 4 :
			sMainType === "Rhyme" ? 5 : 0;
	}

	GetCalculationsStringForCorrespondenceGroup(calcs, blnShowSame, blnShowDifferent)
	{
		//{Same: Array(1), Different: Array(1), Special: Array(0), PrimaryWordType: 'V', RatioOfSameToDifferent: 1}
        var sCalculationsPartOne = ''
        if(calcs.ComparisonsAndCalculationsByWordType != undefined)
        {
            // sCalculationsPartOne = calcs.ComparisonsAndCalculationsByWordType.map(o => o.Different.join(", "))
            
            var sCalculationsSame = blnShowSame ? calcs.ComparisonsAndCalculationsByWordType.map(o => o.Same.join(", ")).join("; ") : ''
            var sCalculationsDifferent = blnShowDifferent ? calcs.ComparisonsAndCalculationsByWordType.map(o => o.Different.join(", ")).join("; ") : ''
            var blnShowBoth = blnShowSame && blnShowDifferent
            sCalculationsPartOne = (blnShowBoth && (sCalculationsDifferent != '') ? 'Different: ' : '')  + sCalculationsDifferent + 
                (blnShowBoth && (sCalculationsSame != '') ? ', Same: ' : '') + sCalculationsSame
        }

		//ContainsWordsFirstAndSecondPerson, ContainsPrepositionsSemanticallyOpposite, AllToNoAll, NoAllToAll, SingleNounToConstruct, ConstructToSingleNoun, DifferentPolarity
		var listCalculationsPartTwo = [];
		if(calcs.ContainsWordsFirstAndSecondPerson) listCalculationsPartTwo.push("1st & 2nd Person");
		if(calcs.ContainsPrepositionsSemanticallyOpposite) listCalculationsPartTwo.push("Semantically Opposite Prepositions");
		if(calcs.AllToNoAll || calcs.NoAllToAll) listCalculationsPartTwo.push("One kol");
		if(calcs.SingleNounToConstruct || calcs.ConstructToSingleNoun) listCalculationsPartTwo.push("Construct Phrase/Single Noun Variance");
		if(calcs.DifferentPolarity) listCalculationsPartTwo.push("Different Polarity");

		return sCalculationsPartOne + (sCalculationsPartOne === "" || listCalculationsPartTwo.length === 0 ? "" : ", ") + listCalculationsPartTwo.join(", ");
	}

    CalculateDifferencesInCalcGroup(calcs, comp)
    {
        return (comp.Different.length + (calcs.DifferentPolarity ? 1 : 0) + 
        ((calcs.ConstructToSingleNoun || calcs.SingleNounToConstruct) ? 1 : 0))
    }

	CorrespondenceLens(lens, listCorrespondenceCategoriesToShowInLens, blnCalculationString)
	{
		var blnColorByMainType = this.state.blnColorCorrespondenceLensByMainType;

		//TODO:this.listCorrespondencesForChapter loads only current chapter -> change the first filter below.
		var listCorrespondencesForChapter = this.listCorrespondencesForChapter; //.filter(g => g.ListWords.some(nTextIndex => this.listTextWordsForChapter.some(w => w.TextIndex === nTextIndex)));
		
        if(blnCalculationString) 
        {
            listCorrespondencesForChapter.filter(o => o.Calculations === undefined).
            forEach(o => o.Calculations = this.CalculateRepetitionLinkGroupCategoriesFromWords(o.ListWords.map(n => this.GetWordWithTextIndexInChapter(n)), this.state.listLines, false, true));
        }

        // console.log(listCorrespondencesForChapter)
        
        var listCorrespondencesForChapterFiltered = listCorrespondencesForChapter.filter(g => listCorrespondenceCategoriesToShowInLens === undefined || listCorrespondenceCategoriesToShowInLens.length === 0 ||
            listCorrespondenceCategoriesToShowInLens.some(cat => g.ListTags.some(t => t.CategoryID === cat.ID)))
        
        if(blnCalculationString) 
        {
            if(lens.Differences != undefined) 
                listCorrespondencesForChapterFiltered = listCorrespondencesForChapterFiltered.filter(g => 
                    g.Calculations.ComparisonsAndCalculationsByWordType != undefined && 
                    g.Calculations.ComparisonsAndCalculationsByWordType.some(c2 => this.CalculateDifferencesInCalcGroup(g.Calculations, c2) === lens.Differences))
            
            if(lens.DifferentField != undefined) 
                listCorrespondencesForChapterFiltered = listCorrespondencesForChapterFiltered.filter(g => 
                    g.Calculations.ComparisonsAndCalculationsByWordType != undefined && 
                    g.Calculations.ComparisonsAndCalculationsByWordType.some(c2 => c2.Different.includes(lens.DifferentField)))

            if(lens.CalculationsPresent != undefined) 
                listCorrespondencesForChapterFiltered = listCorrespondencesForChapterFiltered.filter(g => 
                    lens.CalculationsPresent.split(',').map(scp => scp.trim()).some(scp => g.Calculations[scp] === true))

            // listCorrespondencesForChapterFiltered = listCorrespondencesForChapterFiltered.filter(g => 
            //     g.Calculations.ComparisonsAndCalculationsByWordType.some(c2 => c2.Different.includes('PositionInLine')))
        }

		var listToReturn = listCorrespondencesForChapterFiltered.map((g,index) => {
				var sMainType = !blnColorByMainType || g.ListTags.length === 0 ? undefined : this.GetMainTypeForRepetitionLinkGroupCategoryID(g.ListTags[0].CategoryID);
				var sTagText = g.ListTags.map(t => this.GetTagRelationPairText(t)).join(", ");
				var sCalculationText = !blnCalculationString ? '' : this.GetCalculationsStringForCorrespondenceGroup(g.Calculations, true, true);

				return {ListWords: g.ListWords.map(n => this.GetWordWithTextIndexInChapter(n)), 
					Name: g.Comment + (g.Comment === "" ? "" : "; ") + sTagText + (sTagText === "" || sCalculationText === "" ? "" : ", ") + sCalculationText,
					Color: !blnColorByMainType ? this.listLinkGroupColors[index % this.listLinkGroupColors.length] : this.GetColorByMainType(sMainType),			
					ColorPriority: this.GetColorPriorityByMainType(sMainType)}});

        return listToReturn
		//this.setState({listWordGroupsForEnabledLenses: [{Lens: lens, ListGroups: listToReturn}]});
	}

    HandTaggedRhymeGroupsLens(listTextWordsToUse)
    {
        //will need to replace listRepetitionLinkGroups in the future with some saved json files
        //for now, get the groups that have textindexes for this chapter (i.e. in listTextWordsToUse)
        return this.state.listRepetitionLinkGroups.filter(g => g.Type === 5 && g.ListWords.some(sTextIndex => listTextWordsToUse.some(w => w.TextIndex === sTextIndex)))
            .map((g, n) => ({ListWords: g.ListWords.map(n => this.GetWordWithTextIndexInChapter(n)), Name: '', 
                Color: this.listLinkGroupColors[n % this.listLinkGroupColors.length]}))
    }

    GetSemanticChainsForCurrentChapter(listTextWordsToUse)
    {
        return this.state.listRepetitionLinkGroups.map((g, n) => ({ListWords: g.ListWords, Type: g.Type, IndexInFullList: n}))
        .filter(g => g.Type === 8 && g.ListWords.some(sTextIndex => listTextWordsToUse.some(w => w.TextIndex === sTextIndex)))
    }

    GetSemanticChainsLensNumberOfBatches()
    {
        return Math.ceil(this.GetSemanticChainsForCurrentChapter(this.listTextWordsForChapter).length / this.state.nSemanticChainsLensBatchSize)
    }

    SemanticChainsLens(listTextWordsToUse)
    {
        //will need to replace listRepetitionLinkGroups in the future with some saved json files
        //for now, get the groups that have textindexes for this chapter (i.e. in listTextWordsToUse)
        //var nBatchStartIndex = this.state.nSemanticChainsLensCurrentBatch * this.state.nSemanticChainsLensBatchSize
        var blnColorByDistance = false

        return this.GetSemanticChainsForCurrentChapter(listTextWordsToUse) //.sort((a,b) => b.ListWords.length - a.ListWords.length).slice(nBatchStartIndex, nBatchStartIndex + this.state.nSemanticChainsLensBatchSize)
        .map((g, n) => {            
            //100 102 109
            //2 7
            var sColor = ''

            if(blnColorByDistance)
            {
                var nAverageDistanceBetweenWordsInGroup = g.ListWords.map((sTextIndex, n, arr) => n === 0 ? 0 : parseInt(arr[n]) - parseInt(arr[n-1]))
                    .filter(n => n > 0).reduce((acc, n) => acc + n, 0) / (1.0 * (g.ListWords.length - 1))
                
                sColor = nAverageDistanceBetweenWordsInGroup >= 50 ? 'Black' : 
                    nAverageDistanceBetweenWordsInGroup >= 28 ? 'Purple' : 
                    nAverageDistanceBetweenWordsInGroup > 14 ? 'Red' : 
                    nAverageDistanceBetweenWordsInGroup > 7 ? 'Blue' : 
                    nAverageDistanceBetweenWordsInGroup > 3.5 ? 'Green' : 'CornflowerBlue'
            }
            else
            {
                sColor = this.listLinkGroupColors[n % this.listLinkGroupColors.length]
            }

            return {ListWords: g.ListWords.map(n => this.GetWordWithTextIndexInChapter(n)), Name: n.toString(), Color: sColor}
        })
    }

    ConnectionsFromSemanticLinksPreviewLens(sColorCodeBy)
    {
        // var sGroupLinesByToUse = this.state.nCurrentLinkGroupType === 21 ? 'StartsRepetitionGroup' :
        //     this.state.nCurrentLinkGroupType === 22 ? 'StartsCluster' : 
        //     this.state.nCurrentLinkGroupType === 23 ? 'StartsClusterGroup' : 'StartsLevel4Group'

        // var sGroupLinesByForSuperGroup = this.state.nCurrentLinkGroupType === 21 ? 'StartsCluster' :
        //     this.state.nCurrentLinkGroupType === 22 ? 'StartsClusterGroup' : 
        //     this.state.nCurrentLinkGroupType === 23 ? 'StartsLevel4Group' : 'ByChapter'

        // var listLineGroups = this.GetLinesForSideBySideMode(this.state.listLines, sGroupLinesByToUse)
        // var listLineSuperGroups = this.GetLinesForSideBySideMode(this.state.listLines, sGroupLinesByForSuperGroup)

        var listLineGroups = this.GetLineGroupsForConnectionsLens()
        var listLineSuperGroups = this.GetSuperLineGroupsForConnectionsLens()

        //this.GenerateConnectionsFromSemanticLinks()
        return this.GenerateConnectionsAboveCurrentMaximumConnectionLevelFromCurrentConnections().filter(g => g.Type === this.state.nCurrentLinkGroupType).map((g, n) => {
            var sColor = 'Black'

            if(sColorCodeBy === 'unitoffirstoccurrence')
            {       
                let oLineOfFirstWordInGroup = this.GetLineContainingWord(this.GetWordWithTextIndexInChapter(g.ListWords.sort((a,b) => parseInt(a) - parseInt(b))[0]))
                let nIndexOfLineGroupWithFirstWordInGroup = listLineGroups.findIndex(lg => lg.Lines.includes(oLineOfFirstWordInGroup))
                let nIndexOfLineSuperGroupWithFirstWordInGroup = listLineSuperGroups.findIndex(lg => lg.Lines.includes(oLineOfFirstWordInGroup))

                var nTotalLineGroupsInSuperGroupsPreviousToThisOne = 0
                if(nIndexOfLineSuperGroupWithFirstWordInGroup > 0)
                {
                    let listPreviousSuperGroups = listLineSuperGroups.slice(0, nIndexOfLineSuperGroupWithFirstWordInGroup)
                    nTotalLineGroupsInSuperGroupsPreviousToThisOne = listLineGroups.filter(lg => lg.Lines.some(lgl => 
                        listPreviousSuperGroups.some(lg2 => lg2.Lines.includes(lgl)))).length

                    //console.log(listPreviousSuperGroups, nTotalLineGroupsInSuperGroupsPreviousToThisOne)
                }

                //nTotalLineGroupsInSuperGroupsPreviousToThisOne is subtracted from the index so that each line group at this unit level
                //starts at 0, so the colors are consistent between groups
                sColor = //(nIndexOfLineGroupWithFirstWordInGroup - nTotalLineGroupsInSuperGroupsPreviousToThisOne) > 6 ? 'LightGray' : 
                    nIndexOfLineGroupWithFirstWordInGroup === -1 ? 'Black' : 
                    this.listLinkGroupColors[(nIndexOfLineGroupWithFirstWordInGroup - nTotalLineGroupsInSuperGroupsPreviousToThisOne) % this.listLinkGroupColors.length]
            }
            else
            {
                sColor = this.listLinkGroupColors[n % this.listLinkGroupColors.length]
            }

            return {ListWords: g.ListWords.map(n => this.GetWordWithTextIndexInChapter(n)), Name: n.toString(), Color: sColor}
        })
    }

    GetLineGroupsForConnectionsLens()
    {
        let sGroupLinesByToUse = this.state.nCurrentLinkGroupType === 21 ? 'StartsRepetitionGroup' :
            this.state.nCurrentLinkGroupType === 22 ? 'StartsCluster' : 
            this.state.nCurrentLinkGroupType === 23 ? 'StartsClusterGroup' : 'StartsLevel4Group'

        return this.GetLinesForSideBySideMode(this.state.listLines, sGroupLinesByToUse)
    }

    GetSuperLineGroupsForConnectionsLens()
    {
        let sGroupLinesByForSuperGroup = this.state.nCurrentLinkGroupType === 21 ? 'StartsCluster' :
            this.state.nCurrentLinkGroupType === 22 ? 'StartsClusterGroup' : 
            this.state.nCurrentLinkGroupType === 23 ? 'StartsLevel4Group' : 'ByChapter'
        
        return this.GetLinesForSideBySideMode(this.state.listLines, sGroupLinesByForSuperGroup)
    }

    RepetitionUnitLevelsPerWordLens(listTextWordsToUse)
    {
        // <MenuItem value={20}>Inside Verses</MenuItem>
        // <MenuItem value={21}>Inside Verse Groups</MenuItem>
        // <MenuItem value={22}>Between Verse Groups</MenuItem>
        // <MenuItem value={23}>Unit Level 3</MenuItem>
        // <MenuItem value={24}>Unit Level 4</MenuItem>
        // <MenuItem value={25}>Inside Lines</MenuItem>

        //for each word, counts how many unit levels that that word occurs in at least one repetition group 
        let listConnectionsForChapterByLinkGroupType = [20, 21, 22, 23, 24, 25].map(nLinkGroupType => ({LinkGroupType: nLinkGroupType, 
            ListRepetitionGroups: this.state.listRepetitionLinkGroups
            .filter(g => g.Type === nLinkGroupType && g.ListWords.some(sTextIndex => listTextWordsToUse.some(w => w.TextIndex === sTextIndex)))}))

        return listTextWordsToUse.map(w => {
            let nUnitLevelsWithWord = listConnectionsForChapterByLinkGroupType
                .filter(o => o.ListRepetitionGroups.some(g => g.ListWords.some(sTextIndex => sTextIndex === w.TextIndex))).length

            let sColor = nUnitLevelsWithWord === 0 ? 'LightGray' : 
            nUnitLevelsWithWord === 1 ? 'Gray' : 
            nUnitLevelsWithWord === 2 ? 'Green' : 
            nUnitLevelsWithWord === 3 ? 'DarkCyan' : 
            nUnitLevelsWithWord === 4 ? 'Red' : 
            nUnitLevelsWithWord === 5 ? 'Purple' : 'Black'
            
            return {ListWords: [w], Name: '', Color: sColor}
        })
    }

    ConnectionsLens(listTextWordsToUse, sColorCodeBy)
    {
        //sort the groups by the least word index in each group
        //console.log(this.state.listRepetitionLinkGroups)

        
        // let listRepetitionLinkGroups = this.GetRepetitionLinkGroupList()
        // var nRepetitionLinkGroupIndex = listRepetitionLinkGroups.findIndex(g => {
        //     let nIndexInListOfWords = g.ListWords.indexOf(oSyllable.word.TextIndex)
        //     if(nIndexInListOfWords === -1) return false

        //     let nSyllableIndexInGroupForWord = g.ListSyllableIndexesByWord[nIndexInListOfWords]

        //     //when blnSyllableModeForRepetitionLinkGroupTool is activated, only color the syllables involved
        //     return (nSyllableIndexInGroupForWord === -1 || nSyllableIndexInGroupForWord === oSyllable.syllableIndex) &&
        //     (!this.state.blnSyllableModeForRepetitionLinkGroupTool || nSyllableIndexInGroupForWord === oSyllable.syllableIndex) &&
        //     (g.ListTags.length === 0 || g.ListTags.some(tag => this.IsGroupForRepetitionLinkGroupCategoryIDCurrentlySelected(tag.CategoryID)))
        // })
        
        // return nRepetitionLinkGroupIndex === -1 ? "Gray" : 
        //     this.listLinkGroupColors[nRepetitionLinkGroupIndex % this.listLinkGroupColors.length]


        //if blnColorIndividualSyllablesForRepetitionLinkGroups is not checked, don't show any groups with individual syllables linked

        let listConnectionsForChapterAndGroupType = this.state.listRepetitionLinkGroups
            .map((g, n) => ({g: g, GroupIndexInChapter: n}))
            .filter(o => o.g.Type === this.state.nCurrentLinkGroupType && o.g.ListWords.some(sTextIndex => listTextWordsToUse.some(w => w.TextIndex === sTextIndex)) &&
                (this.state.blnColorIndividualSyllablesForRepetitionLinkGroups || !o.g.ListSyllableIndexesByWord.some(nsiw => nsiw !== -1)))
            .toSorted((a,b) => parseInt(a.g.ListWords.sort((a2,b2) => parseInt(a2) - parseInt(b2))[0]) - 
                parseInt(b.g.ListWords.sort((a2,b2) => parseInt(a2) - parseInt(b2))[0]))
        
        var listLineGroups = this.GetLineGroupsForConnectionsLens()
        var listLineSuperGroups = this.GetSuperLineGroupsForConnectionsLens()
        //console.log(listLineGroups, listLineSuperGroups)

        return listConnectionsForChapterAndGroupType.map((o, n) => { 
            let g = o.g
            var sColor = 'Black'
            var nIndexOfLineGroup = -1

            if(sColorCodeBy === 'unitoffirstoccurrence')
            {
                let oLineOfFirstWordInGroup = this.GetLineContainingWord(this.GetWordWithTextIndexInChapter(g.ListWords.sort((a,b) => parseInt(a) - parseInt(b))[0]))
                let nIndexOfLineGroupWithFirstWordInGroup = listLineGroups.findIndex(lg => lg.Lines.includes(oLineOfFirstWordInGroup))
                let nIndexOfLineSuperGroupWithFirstWordInGroup = listLineSuperGroups.findIndex(lg => lg.Lines.includes(oLineOfFirstWordInGroup))

                var nTotalLineGroupsInSuperGroupsPreviousToThisOne = 0
                if(nIndexOfLineSuperGroupWithFirstWordInGroup > 0)
                {
                    let listPreviousSuperGroups = listLineSuperGroups.slice(0, nIndexOfLineSuperGroupWithFirstWordInGroup)
                    nTotalLineGroupsInSuperGroupsPreviousToThisOne = listLineGroups.filter(lg => lg.Lines.some(lgl => 
                        listPreviousSuperGroups.some(lg2 => lg2.Lines.includes(lgl)))).length
                }

                //nTotalLineGroupsInSuperGroupsPreviousToThisOne is subtracted from the index so that each line group at this unit level
                //starts at 0, so the colors are consistent between groups
                nIndexOfLineGroup = nIndexOfLineGroupWithFirstWordInGroup - nTotalLineGroupsInSuperGroupsPreviousToThisOne
                sColor = nIndexOfLineGroupWithFirstWordInGroup === -1 ? 'Black' : 
                    this.listLinkGroupColors[nIndexOfLineGroup % this.listLinkGroupColors.length]

                {/* <MenuItem value={20}>Inside Verses</MenuItem>
                <MenuItem value={21}>Inside Verse Groups</MenuItem>
                <MenuItem value={22}>Between Verse Groups</MenuItem>
                <MenuItem value={23}>Unit Level 3</MenuItem> */}

                {/* <MenuItem value={'StartsRepetitionGroup'}>1</MenuItem>
                <MenuItem value={'StartsCluster'}>2</MenuItem>
                <MenuItem value={'StartsClusterGroup'}>3</MenuItem>
                <MenuItem value={'StartsLevel4Group'}>4</MenuItem> */}
            }
            else if(sColorCodeBy === 'percentageofunitsitoccursin')
            {
                let listAllLinesInConnectionsGroup = [...new Set(g.ListWords.map(sTextIndex => this.GetLineContainingWord(this.GetWordWithTextIndexInChapter(sTextIndex))))]
                let nPercentOfLineGroupsContainingThisConnectionsGroup = 
                    listLineGroups.filter(lg => lg.Lines.some(l => listAllLinesInConnectionsGroup.includes(l))).length / (1.0 * listLineGroups.length)

                //"hsl(120, 100%, 35%)", "hsl(0, 40%, 65%)"
                //sColor = 'hsl(' + (360 * nPercentOfLineGroupsContainingThisConnectionsGroup) + ', 100%, 35%)'
                sColor = 'hsl(0, 0%, ' + (nPercentOfLineGroupsContainingThisConnectionsGroup < 0.1 ? 0.9 : ((1 - nPercentOfLineGroupsContainingThisConnectionsGroup) * 100)) + '%)'
            }
            else
            {
                sColor = this.listLinkGroupColors[n % this.listLinkGroupColors.length]
            }
            
            var listWords = g.ListWords.map(n => this.GetWordWithTextIndexInChapter(n))

            if(this.state.blnEachRepetitionGroupShouldHaveRepeatedRoots)
            {
                var groupedByRoot = this.GroupArrayByKey(listWords, "ParentRoot")
                let listRepeatedRoots = Object.keys(groupedByRoot).filter(k => k != '' && groupedByRoot[k].length > 1)
                listWords = listWords.filter(w => listRepeatedRoots.includes(w.ParentRoot))
            }

            return {ListWords: listWords, Name: n.toString(), FirstLineGroupIndex: nIndexOfLineGroup, Color: sColor, 
                RepetitionGroupIndexInChapter: o.GroupIndexInChapter}
        })
    }

    SetCommentForCurrentConnectionsGroup(sComment)
    {
        if(this.state.nRepetitionGroupIndexInChapterForCurrentConnectionsGroup >= 0 && 
            this.state.nRepetitionGroupIndexInChapterForCurrentConnectionsGroup < this.state.listRepetitionLinkGroups.length)
        {
            let listToSet = this.state.listRepetitionLinkGroups
            listToSet[this.state.nRepetitionGroupIndexInChapterForCurrentConnectionsGroup].Comment = sComment
            this.SaveRepetitionLinkGroupsAndSetState(listToSet)
        }
    }

    SetIsContrastForCurrentConnectionsGroup(blnValue)
    {
        if(this.state.nRepetitionGroupIndexInChapterForCurrentConnectionsGroup >= 0 && 
            this.state.nRepetitionGroupIndexInChapterForCurrentConnectionsGroup < this.state.listRepetitionLinkGroups.length)
        {
            let listToSet = this.state.listRepetitionLinkGroups
            listToSet[this.state.nRepetitionGroupIndexInChapterForCurrentConnectionsGroup].IsContrast = blnValue
            this.SaveRepetitionLinkGroupsAndSetState(listToSet)
        }
    }
    
    DoThingsAfterChangingCurrentLinkGroupType()
    {
        //this.ChangeLensSticky(this.state.listLenses.find(l => l.LensType === 'handtaggedconnections'), false)

        let oFirstCurrentlyEnabledLens = this.state.listLenses.find(l => (l.Enabled || l.Sticky))
        if(oFirstCurrentlyEnabledLens !== undefined)
        {
            this.ChangeLensSticky(oFirstCurrentlyEnabledLens, true)
        }

        //this.ChangeLensSticky(this.state.listLenses.find(l => l.LensType === 'handtaggedconnections'), true)
        this.setState({nIndexOfSemanticGroupShowing: 0})
        ////this.GenerateDevelopmentDiagramForChapterIfShowing()
    }

    getStandardDeviation(array, isPopulation)
    {
        if (!array || array.length < 2) return 0;
        
        // 1. Calculate the mean (average)
        const mean = array.reduce((acc, val) => acc + val, 0) / array.length;
        
        // 2. Calculate sum of squared differences from the mean
        const sumOfSquares = array.reduce((acc, val) => acc + Math.pow(val - mean, 2), 0);
        
        // 3. Divide by (n - 1) for Sample, or (n) for Population, then take square root
        const divisor = array.length - (isPopulation ? 0 : 1);
        return Math.sqrt(sumOfSquares / divisor);
    }

    // FixTranslationLines()
    // {
    //     //move all the following translation lines after a certain point up one line
    //     var listTranslationLinesToSet = this.state.listOurTranslationLines

    //     // listTranslationLinesToSet = listTranslationLinesToSet.filter(tl => tl.LineIndex !== 1)
    //     // for(var nTranslationLineIndex = 1; nTranslationLineIndex < listTranslationLinesToSet.length; nTranslationLineIndex++)
    //     // {
    //     //     listTranslationLinesToSet[nTranslationLineIndex].LineIndex -= 1
    //     // }

    //     for(var nTranslationLineIndex = 11; nTranslationLineIndex < listTranslationLinesToSet.length; nTranslationLineIndex++)
    //     {
    //         listTranslationLinesToSet[nTranslationLineIndex].LineIndex = nTranslationLineIndex
    //     }

    //     // this.setState({listOurTranslationLines: listTranslationLinesToSet})

    //     console.log(listTranslationLinesToSet)
    //     this.SaveOurTranslationLines(listTranslationLinesToSet)
    // }

    // GenerateListOfChaptersEachRootOccursIn()
    // {
    //     fetch("HebrewTextData/allchaptersinpoeticbooks.json")
	// 	.then(res => res.json())
	// 	.then(data => 
	// 	{
	// 		var listTextWordsForBook = data.OSHB.filter(w => w.Book === '19') 
    //         var dictListOfChaptersEachRootOccursInToSet = new Map()
            
    //         var groupedByRoot = this.GroupArrayByKey(listTextWordsForBook, "ParentRoot")
    //         for(var k of Object.keys(groupedByRoot))
    //         {
    //             if(k != '' && groupedByRoot[k].length > 1)
    //             {
    //                 var listInstancesOfRoot = groupedByRoot[k]
    //                 var listChaptersRootOccursIn = [...new Set(listInstancesOfRoot.map(w => parseInt(w.Chapter)))].toSorted((a, b) => a - b).join(', ')
    //                 dictListOfChaptersEachRootOccursInToSet.set(k, listChaptersRootOccursIn)
    //             }
    //         }

    //         navigator.clipboard.writeText(JSON.stringify(Object.fromEntries(dictListOfChaptersEachRootOccursInToSet)))
    //     })
    // }

    // GenerateListOfChaptersEachThematicStatementOccursIn()
    // {
    //     fetch("HebrewTextData/allchaptersinpoeticbooks.json")
	// 	.then(res => res.json())
	// 	.then(data => 
	// 	{
	// 		var listTextWordsForBook = data.OSHB.filter(w => w.Book === '19') 
    //         var dictListOfChaptersEachThematicStatementOccursInToSet = new Map()
    //         for(var ots of this.listThematicStatements)
    //         {
    //             var listWordsWithStatement = listTextWordsForBook.filter(w => w.ThematicStatementIDs != undefined && w.ThematicStatementIDs.includes(ots.ID))
    //             if(listWordsWithStatement.length > 1)
    //             {
    //                 var listChaptersRootOccursIn = [...new Set(listWordsWithStatement.map(w => parseInt(w.Chapter)))].toSorted((a, b) => a - b).join(', ')
    //                 dictListOfChaptersEachThematicStatementOccursInToSet.set(ots.ID, ots.Name + ': ' + listChaptersRootOccursIn)
    //             }
    //         }

    //         navigator.clipboard.writeText(JSON.stringify(Object.fromEntries(dictListOfChaptersEachThematicStatementOccursInToSet)))
    //     })
    // }


    TakePicture()
    {
        // Create a temporary link element
        const link = document.createElement('a')
        link.download = 'my-canvas-drawing.png'
        link.href = this.canvasRef.current.toDataURL('image/png')
        
        // Trigger download and remove link
        link.click()
    }
    
    CalculateConnectionThingsForAllPoeticChapters()
    {
        // fetch("CorrespondenceData/correspondences_" + sFileBasicName + ".json")
        // .then(res => res.json())
        // .then(data => 
        // {
        //     var listCorrespondencesForChapterToSet = data.Correspondences
        //     var locallyStoredCorrespondences = this.LoadRepetitionLinkGroupsByChapter(nBook, nChapter)

        //     if(locallyStoredCorrespondences !== null && locallyStoredCorrespondences.length > 0)
        //     {
        //         listCorrespondencesForChapterToSet = locallyStoredCorrespondences
        //     }

        //     this.listCorrespondencesForChapter = listCorrespondencesForChapterToSet
        //     this.setState({listRepetitionLinkGroups: listCorrespondencesForChapterToSet})
        //     //this.setState({blnShowInterlinear: false})
        //     //this.setState({blnShowOurTranslation: true})

        //     this.SetLines(listLinesToSet)
        // })

        //allcorrespondencesinpoeticbooks

        fetch("HebrewTextData/allchaptersinpoeticbooks.json")
		.then(res => res.json())
		.then(data => 
		{
			var listTextWordsForAllChapters = data.OSHB; //.filter(w => parseInt(w.TextIndex) > 16887 && parseInt(w.TextIndex) <= 17000);  

			//TODO before running: fix global line list - it doesn't correspond to what is in the individual files
			fetch("LineData/alllinesinpoeticbooks.json")
			.then(res => res.json())
			.then(data => 
			{
                var listLinesForAllChapters = data.Lines
                
                fetch("CorrespondenceData/allcorrespondencesinpoeticbooks.json")
                .then(res => res.json())
                .then(data => 
                {
                    var listCorrespondencesForAllChapters = data.CorrespondencesByBookAndChapter

                    //let listSimilarOppositeTagCategories = [{ID: '28'}, {ID: '312'}, {ID: '310'}, 
                    //    {ID: '74'}, {ID: '308'}, {ID: '66'}, {ID: '69'}, {ID: '304'}]

                    var textWordsByBook = this.GroupArrayByKey(listTextWordsForAllChapters, "Book")
                    for(var sBookToDo of Object.keys(textWordsByBook))
                    {						
                        if(sBookToDo != '19') continue
                        //console.log('Book: ' + sBookToDo)

                        var textWordsByChapter = this.GroupArrayByKey(textWordsByBook[sBookToDo], "Chapter")

                        for(var nLinkGroupType of [20, 21, 22, 23, 24, 25])
                        {
                            let sGroupLinesByToUseForSubGroups = nLinkGroupType === 21 ? 'StartsRepetitionGroup' :
                            nLinkGroupType === 22 ? 'StartsCluster' : 
                            nLinkGroupType === 23 ? 'StartsClusterGroup' : 'StartsLevel4Group'

                            let sGroupLinesByForSuperGroup = nLinkGroupType === 21 ? 'StartsCluster' :
                            nLinkGroupType === 22 ? 'StartsClusterGroup' : 
                            nLinkGroupType === 23 ? 'StartsLevel4Group' : 'ByChapter'

                            var listRepetitionGroupsPerSubUnit = []
                            var listRepetitionGroupsPerNumberOfLinesInUnit = []
                            // var listAveragesAcrossSubunitsBySuperUnit = []
                            var listPercentGroupsContainingRepeatedRoot = []
                            var listPercentLinesContainingAnInsideLineGroup = []

                            for(var sChapterToDo of Object.keys(textWordsByChapter)) //.slice(0, 10)
                            {						
                                //if(sChapterToDo != '1') continue
                                //|| parseInt(sChapterToDo) > 200
                                //if(parseInt(sChapterToDo) > 5) continue
                                //console.log('Chapter: ' + sChapterToDo)

                                var listWordsInChapter = textWordsByChapter[sChapterToDo]
                                for(var w of listWordsInChapter)
                                {
                                    var listSyllableObjectsForWord = this.GetSyllableObjectsForWord(w)
                
                                    w.SyllableObjects = listSyllableObjectsForWord
                                    w.Transliteration = listSyllableObjectsForWord.map(syl => syl.syllable).join('')
                                    w.HasFullAccent = listSyllableObjectsForWord.some(syl => syl.hasFullAccent)
                                    w.MainAccentedSyllable = listSyllableObjectsForWord.find(syl => syl.hasFullAccent)
                                    w.HasSecondaryAccent = listSyllableObjectsForWord.some(syl => syl.hasSecondaryAccent)
                                    w.HasFinalAccent = listSyllableObjectsForWord.some(syl => syl.hasFullAccent && syl.isLastSyllableInWord)
                                    w.HasPenultimateAccent = listSyllableObjectsForWord.some((syl, n, arr) => syl.hasFullAccent && syl.syllableIndex === arr.length - 2)
                                }

                                var listLinesInChapter = listLinesForAllChapters.filter(ol => ol.Book === sBookToDo && ol.Chapter === sChapterToDo)
                                this.CalculateLines(listLinesInChapter, listWordsInChapter)
                                
                                //GetMaximumGroupLevelInLines()
                                //get the maximum unit hierarchy level that is not superscription and is not the first non-superscription line
                                var sMaximumGroupLevelInLines = ''
                                let listToLookIn = listLinesInChapter.filter(l => !l.IsSuperscription).slice(1)
                                for(let sGroupLinesByToTest of ['StartsLevel4Group', 'StartsClusterGroup', 'StartsCluster', 'StartsRepetitionGroup'])
                                {
                                    if(listToLookIn.some(l => this.LineStartsNewUnitAtCurrentLevel(l, sGroupLinesByToTest))) 
                                    {
                                        sMaximumGroupLevelInLines = sGroupLinesByToTest
                                        break
                                    }
                                }

                                let nMaximumLinkGroupType = sMaximumGroupLevelInLines === 'StartsLevel4Group' ? 24 :
                                    sMaximumGroupLevelInLines === 'StartsClusterGroup' ? 23 :
                                    sMaximumGroupLevelInLines === 'StartsCluster' ? 22 : 21

                                //&& nLinkGroupType !== 20 (only before the inside verse connections are done)
                                if(nLinkGroupType !== 25 && nLinkGroupType > nMaximumLinkGroupType) continue

                                // <MenuItem value={20}>Inside Verses</MenuItem>
                                // <MenuItem value={21}>Inside Verse Groups</MenuItem>
                                // <MenuItem value={22}>Between Verse Groups</MenuItem>
                                // <MenuItem value={23}>Unit Level 3</MenuItem>
                                // <MenuItem value={24}>Unit Level 4</MenuItem>
                                // <MenuItem value={25}>Inside Lines</MenuItem>

                                // <MenuItem value={'Line'}>Line</MenuItem>
                                // <MenuItem value={'StartsRepetitionGroup'}>1</MenuItem>
                                // <MenuItem value={'StartsCluster'}>2</MenuItem>
                                // <MenuItem value={'StartsClusterGroup'}>3</MenuItem>
                                // <MenuItem value={'StartsLevel4Group'}>4</MenuItem>
                                // <MenuItem value={'ByChapter'}>Chapter</MenuItem>

                                var listCorrespondencesInChapter = listCorrespondencesForAllChapters.find(ol => ol.Book === parseInt(sBookToDo) && 
                                    ol.Chapter === parseInt(sChapterToDo)).RepetitionLinkGroupsByChapter

                                let listConnectionsForChapterAndGroupType = listCorrespondencesInChapter
                                .filter(g => g.Type === nLinkGroupType && !g.IsPreposition && !g.IsSuffix && 
                                    g.ListWords.some(sTextIndex => listWordsInChapter.some(w => w.TextIndex === sTextIndex)))

                                let listLinesContainedInConnectionsForChapterAndGroupType = listConnectionsForChapterAndGroupType
                                .map(g => g.ListWords.map(sTextIndex => listLinesInChapter.find(r => 
                                    r.Words.includes(listWordsInChapter.find(w => w.TextIndex === sTextIndex)))))

                                if(nLinkGroupType === 25)
                                {
                                    let nLinesWithAtLeastOneGroup = [...new Set(listLinesContainedInConnectionsForChapterAndGroupType.flat())].length

                                    //exclude the chapters that haven't been done yet
                                    if(nLinesWithAtLeastOneGroup > 0)
                                    {
                                        listPercentLinesContainingAnInsideLineGroup.push(nLinesWithAtLeastOneGroup / (1.0 * listLinesInChapter.length))
                                    }
                                }
                                // else if(nLinkGroupType === 20) //this if is for only before the inside verse connections are done
                                // {
                                //     let listSimilarOppositeCorrespondencesForChapter = listCorrespondencesInChapter.filter(g => 
                                //         listSimilarOppositeTagCategories.some(cat => g.ListTags.some(t => t.CategoryID === cat.ID)))

                                //     let listLinesContainedInSimilarOppositeGroupsForChapter = listSimilarOppositeCorrespondencesForChapter
                                //     .map(g => g.ListWords.map(sTextIndex => listLinesInChapter.find(r => 
                                //         r.Words.includes(listWordsInChapter.find(w => w.TextIndex === sTextIndex)))))

                                //     var listLinesByVerse = this.GetLinesForSideBySideMode(listLinesInChapter, 'StartsRepetitionGroup')
                                //     for(let oVerse of listLinesByVerse)
                                //     {
                                //         let nRepetitionGroupsContainedInVerse = listLinesContainedInSimilarOppositeGroupsForChapter
                                //         .filter(listLinesInRepetitionGroup => {
                                //             return oVerse.Lines.some(l => listLinesInRepetitionGroup.includes(l))
                                //         }).length

                                //         let nRepetitionGroupsPerNumberOfLinesInUnit = nRepetitionGroupsContainedInVerse / (1.0 * oVerse.Lines.length)
                                //         listRepetitionGroupsPerNumberOfLinesInUnit.push(nRepetitionGroupsPerNumberOfLinesInUnit)

                                //         //console.log(nRepetitionGroupsContainedInVerse, oVerse.Lines.length, nRepetitionGroupsPerNumberOfLinesInUnit)
                                //     }
                                // }
                                else
                                {
                                    let nPercentGroupsContainingRepeatedRoot = listConnectionsForChapterAndGroupType
                                    .filter(g => {
                                        let listWords = g.ListWords.map(sTextIndex => listWordsInChapter.find(w => w.TextIndex === sTextIndex))
                                        .filter(w => w !== undefined)

                                        var groupedByRoot = this.GroupArrayByKey(listWords, "ParentRoot")
                                        return Object.keys(groupedByRoot).some(k => k != '' && groupedByRoot[k].length > 1)
                                    }).length / (1.0 * listConnectionsForChapterAndGroupType.length)

                                    listPercentGroupsContainingRepeatedRoot.push(nPercentGroupsContainingRepeatedRoot)
            
                                    //console.log(sChapterToDo, listLinesContainedInConnectionsForChapterAndGroupType)

                                    if(nLinkGroupType === 20)
                                    {
                                        //console.log(sChapterToDo, listCorrespondencesInChapter.filter(g => g.Type === nLinkGroupType), listConnectionsForChapterAndGroupType)
                                        var listLinesByVerse = this.GetLinesForSideBySideMode(listLinesInChapter, 'StartsRepetitionGroup')
                                        for(let oVerse of listLinesByVerse)
                                        {
                                            let nRepetitionGroupsContainedInVerse = listLinesContainedInConnectionsForChapterAndGroupType
                                            .filter(listLinesInRepetitionGroup => {
                                                return oVerse.Lines.some(l => listLinesInRepetitionGroup.includes(l))
                                            }).length

                                            let nRepetitionGroupsPerNumberOfLinesInUnit = nRepetitionGroupsContainedInVerse / (1.0 * oVerse.Lines.length)
                                            listRepetitionGroupsPerNumberOfLinesInUnit.push(nRepetitionGroupsPerNumberOfLinesInUnit)

                                            //console.log(nRepetitionGroupsContainedInVerse, oVerse.Lines.length, nRepetitionGroupsPerNumberOfLinesInUnit)
                                        }
                                    }
                                    else
                                    {
                                        var listSubLineGroups = this.GetLinesForSideBySideMode(listLinesInChapter, sGroupLinesByToUseForSubGroups)
                                        var listSuperLineGroups = this.GetLinesForSideBySideMode(listLinesInChapter, sGroupLinesByForSuperGroup)

                                        //for each unit, average across its subunits this calculation: the number of repetition groups involving that subunit
                                        for(let oSuperLineGroup of listSuperLineGroups)
                                        {
                                            var listSubunits = listSubLineGroups.filter(lg => lg.Lines.some(l => oSuperLineGroup.Lines.includes(l)))

                                            let nRepetitionGroupsContainedInSuperunit = listLinesContainedInConnectionsForChapterAndGroupType
                                            .filter(listLinesInRepetitionGroup => {
                                                return oSuperLineGroup.Lines.some(l => listLinesInRepetitionGroup.includes(l))
                                            }).length

                                            let nRepetitionGroupsPerSubUnit = nRepetitionGroupsContainedInSuperunit / (1.0 * listSubunits.length)
                                            let nRepetitionGroupsPerNumberOfLinesInUnit = nRepetitionGroupsContainedInSuperunit / (1.0 * oSuperLineGroup.Lines.length)

                                            listRepetitionGroupsPerSubUnit.push(nRepetitionGroupsPerSubUnit)
                                            listRepetitionGroupsPerNumberOfLinesInUnit.push(nRepetitionGroupsPerNumberOfLinesInUnit)
                                        }
                                    }
                                }
                            }

                            // let nAverageForLinkGroupTypeAcrossChapters = listAveragesAcrossSubunitsBySuperUnit
                            // .reduce((acc, n) => acc + n, 0) / (1.0 * listAveragesAcrossSubunitsBySuperUnit.length)

                            let nAverageAcrossChaptersForRepetitionGroupsPerSubUnit = listRepetitionGroupsPerSubUnit
                            .reduce((acc, n) => acc + n, 0) / (1.0 * listRepetitionGroupsPerSubUnit.length)

                            let nAverageAcrossChaptersForRepetitionGroupsPerNumberOfLinesInUnit = listRepetitionGroupsPerNumberOfLinesInUnit
                            .reduce((acc, n) => acc + n, 0) / (1.0 * listRepetitionGroupsPerNumberOfLinesInUnit.length)
                            
                            let listPercentGroupsContainingRepeatedRootFilteredForNans = listPercentGroupsContainingRepeatedRoot.filter(n => !Number.isNaN(n))
                            let nAverageAcrossChaptersOfPercentGroupsContainingRepeatedRoot = listPercentGroupsContainingRepeatedRootFilteredForNans
                            .reduce((acc, n) => acc + n, 0) / (1.0 * listPercentGroupsContainingRepeatedRootFilteredForNans.length)

                            console.log(nLinkGroupType, nAverageAcrossChaptersForRepetitionGroupsPerSubUnit, 
                                nAverageAcrossChaptersForRepetitionGroupsPerNumberOfLinesInUnit,
                                this.getStandardDeviation(listRepetitionGroupsPerNumberOfLinesInUnit, true),
                                nAverageAcrossChaptersOfPercentGroupsContainingRepeatedRoot)
                        }

                        let listPercentLinesContainingAnInsideLineGroupFilteredForNans = listPercentLinesContainingAnInsideLineGroup.filter(n => !Number.isNaN(n))
                        let nAverageForPercentLinesContainingAnInsideLineGroup = listPercentLinesContainingAnInsideLineGroupFilteredForNans
                            .reduce((acc, n) => acc + n, 0) / (1.0 * listPercentLinesContainingAnInsideLineGroupFilteredForNans.length)

                        console.log("nAverageForPercentLinesContainingAnInsideLineGroup: ", nAverageForPercentLinesContainingAnInsideLineGroup, 
                            this.getStandardDeviation(listPercentLinesContainingAnInsideLineGroupFilteredForNans, true))
                    }

                    window.alert('done!')
                })
            })
        })
    }
    
    FirstWordInSemanticChainsLens(listTextWordsToUse)
    {
        var listToReturn = []
        for(var g of this.GetSemanticChainsForCurrentChapter(listTextWordsToUse))
        {   
            var nWordsInGroup = g.ListWords.length

            listToReturn.push({ListWords: g.ListWords.map(sWordIndex => this.GetWordWithTextIndexInChapter(sWordIndex)), 
                Name: '', Color: nWordsInGroup >= 15 ? 'Black' : nWordsInGroup >= 10 ? 'Purple' : nWordsInGroup >= 7 ? 'Red' : 
                nWordsInGroup >= 5 ? 'Blue' : nWordsInGroup >= 3 ? 'Green' : nWordsInGroup >= 2 ? 'CornflowerBlue' : 'LightGray', 
                MainWord: this.GetWordWithTextIndexInChapter(g.ListWords.sort((a,b) => parseInt(a) - parseInt(b))[0])})
        }

        return listToReturn //[{ListWords: listFirstWords, Name: '', Color: 'Green'}]
    }

    SemanticChainsByLocationLens(listTextWordsToUse)
    {
        var listLinesByBreakGroup = this.GetLinesByBreakGroup(this.state.listLines, this.state.sGroupLinesBy)
        
        var listGroups = []
        for(var g of this.GetSemanticChainsForCurrentChapter(listTextWordsToUse))
        {
            var listWordsWithLocations = g.ListWords.map((sTextIndex, n, arr) => {
                var w = this.GetWordWithTextIndexInChapter(sTextIndex)

                var listFound = listLinesByBreakGroup.map((oBreakGroup, nBreakGroup) => ({BreakGroupIndex: nBreakGroup,
                    LineIndex: oBreakGroup.findIndex(l => l.Words.includes(w))})).filter(o => o.LineIndex > 0)

                if(listFound.length > 0)
                {
                    var nLinesInBreakGroup = listLinesByBreakGroup[listFound[0].BreakGroupIndex].length

                    return {Word: w, BreakGroupIndex: listFound[0].BreakGroupIndex, 
                        LineLocation: listFound[0].LineIndex <= 1 ? 'beginning' : 
                        (listFound[0].LineIndex >= nLinesInBreakGroup - 2) ? 'end' : 'middle'}
                }
            }).filter(o => o != undefined)

            listGroups.push({WordsWithLocations: listWordsWithLocations})
        }

        // console.log(listGroups)
        
        var sToFind = ''
        var listToReturn = []

        if(sToFind === 'beginning of multiple groups')
        {
            listToReturn = listGroups.filter(g => [...new Set(g.WordsWithLocations.filter(o => o.LineLocation === 'beginning').map(o => o.BreakGroupIndex))].length > 1)
                .map(g => ({ListWordsToShow: g.WordsWithLocations.filter(o => o.LineLocation === 'beginning').map(o => o.Word)}))
        }
        else
        {
            listToReturn = listGroups.filter(g => g.WordsWithLocations.filter(o => o.LineLocation === 'beginning' || o.LineLocation === 'end').length > 1)
                .map(g => ({ListWordsToShow: g.WordsWithLocations.filter(o => o.LineLocation === 'beginning' || o.LineLocation === 'end').map(o => o.Word)}))
        }

        return listToReturn.map((g, n) => ({ListWords: g.ListWordsToShow, Name: '', Color: this.listLinkGroupColors[n % this.listLinkGroupColors.length]}))
    }

    RemoveQuiescentFinalConsonants(s)
    {
        return s.replace(/[ʿʾ]$/, '')
    }

    FilterWordGroupsForChains(listWords, nMinWindowLength, nMaxDistanceBetweenClusterElementsAddedToWindowLength, blnByMaxLinesApart)
    {
        //3 4 5 9 10 10 11 12 16
        var listToReturn = []

        for(var nWindowStart = 0; nWindowStart < listWords.length; nWindowStart++)
        {
            //if(sPropertyName === 'suffixpgn' && sPropertyValue === '1ms') console.log(nWindowStart)

            var nSuccessfulWindowLength = 0
            for(var nWindowLength = nMinWindowLength; nWindowLength <= listWords.length - nWindowStart; nWindowLength++)
            {
                var listForWindowByLine = listWords.slice(nWindowStart, nWindowStart + nWindowLength).map(o => o.LineIndex)

                if(blnByMaxLinesApart)
                {
                    //>= 3 occurrences no more than one line apart
                    //(nWindowLength === 2 && Math.max(...listForWindowByLine) - Math.min(...listForWindowByLine) === 0) || 
                    if(listForWindowByLine.every((nLine, nIndex, arr) => nIndex === 0 || nLine - arr[nIndex - 1] <= this.state.nMaxLinesApartForChains))
                    {
                        nSuccessfulWindowLength = nWindowLength
                    }
                    else break
                }
                else
                {
                    var listForWindowByVerse = listWords.slice(nWindowStart, nWindowStart + nWindowLength).map(o => o.Verse)

                    //occurrences no more than one verse apart or cluster together in about the same number of lines as the window length
                    if(Math.max(...listForWindowByLine) - Math.min(...listForWindowByLine) <= nWindowLength + nMaxDistanceBetweenClusterElementsAddedToWindowLength ||
                        listForWindowByVerse.every((nVerse, nIndex, arr) => nIndex === 0 || nVerse - arr[nIndex - 1] <= 1))
                    {
                        nSuccessfulWindowLength = nWindowLength
                    }
                    else break
                }
            }

            if(nSuccessfulWindowLength > 0)
            {
                listToReturn.push(listWords.slice(nWindowStart, nWindowStart + nSuccessfulWindowLength).map(o => o.Word))

                //adding nSuccessfulWindowLength to nWindowStart will avoid overlapping chains
                nWindowStart += nSuccessfulWindowLength - 1
            }
        }

        return listToReturn
    }

    SyllableStartsWithAVowel(oSyllable)
    {
        if(this.blnChapterIsHebrew)
        {
            return false
        }
        else
        {
            return ['a', 'i', 'o', 'ē', 'u', 'ō', 'e', 'A', 'E', 'I', 'O', 'U', 'Ē', 'О̄'].includes(oSyllable.syllableWithSingleConsonants.slice(0,1))
        }
    }
    
    SyllableEndsWithAVowel(oSyllable)
    {
        if(this.blnChapterIsHebrew)
        {
            return oSyllable.length === 2
        }
        else
        {
            return ['a', 'i', 'o', 'ē', 'u', 'ō', 'e'].includes(oSyllable.syllableWithSingleConsonants.slice(-1))
        }
    }

    SyllableStartsWithSound(oSyllable, sSound)
    {
        return oSyllable.syllableWithSingleConsonants.toLowerCase().startsWith(sSound)
    }

    SyllableEndsWithSound(oSyllable, sSound)
    {
        if(this.blnChapterIsHebrew)
        {
            return sSound === 'y' ? false : sSound === 'h' ? oSyllable.endsWithConsonantalHe : oSyllable.syllableWithSingleConsonants.endsWith(sSound)
        }
        else
        {
            return oSyllable.syllableWithSingleConsonants.endsWith(sSound)
        }
    }

    SyllableHasSound(oSyllable, sSound)
    {
        //if(oSyllable.syllableWithSingleConsonants.includes(sSound)) console.log(oSyllable.syllableWithSingleConsonants, sSound, oSyllable.syllableWithSingleConsonants.includes(sSound))
        if(this.blnChapterIsHebrew)
        {
            return sSound === 'y' ? oSyllable.syllableWithSingleConsonants.startsWith('y') : 
                sSound === 'h' ? (oSyllable.syllableWithSingleConsonants.startsWith('h') || oSyllable.endsWithConsonantalHe) :
                oSyllable.syllableWithSingleConsonants.includes(sSound)
        }
        else
        {
            return oSyllable.syllableWithSingleConsonants.includes(sSound)
        }
    }

    WordsMatchingProperty(sPropertyName, sPropertyValue, listTextWordsToUse, listLinesToUse,
        listVowelsInGroup1, listFinalConsonantsInGroup1, listInitialConsonantsInGroup2, listVowelsInGroup2, listFinalConsonantsInGroup2, 
        listSoundGroup1ForSequence, listSoundGroup2ForSequence, listSoundGroup3ForSequence)
    {
        return listTextWordsToUse.filter(w => {
            var lineForWord = listLinesToUse.find(l => l.Words.includes(w))
            if(lineForWord != undefined && lineForWord.IsSuperscription) return false

            if(sPropertyName === 'SemanticDomain')
            {
                //w.BSGs != undefined && w.BSGs.includes(nsg)
                //this.listSDBH.filter(o => o.ListWords.includes(parseInt(w.TextIndex))).map(o => o.Name)
        
                return this.listMainSemanticDomains.some(o => o.Name === sPropertyValue && o.LexicalIDs.includes(w.LexicalID))
            }
            else if(sPropertyName === 'SoundSequencesBetweenWords')
            {
                return w.SyllableObjects.some(so => listSoundGroup1ForSequence.some(sSound => this.SyllableHasSound(so, sSound))) && 
                    w.SyllableObjects.some(so => listSoundGroup2ForSequence.some(sSound => this.SyllableHasSound(so, sSound))) &&
                    (listSoundGroup3ForSequence.length === 0 || w.SyllableObjects.some(so => listSoundGroup3ForSequence.some(sSound => this.SyllableHasSound(so, sSound))))
            }
            else if(sPropertyName === 'SyllableSounds')
            {
                return w.SyllableObjects.some(so => 
                    ((listInitialConsonantsInGroup2.length === 0 && this.SyllableStartsWithAVowel(so)) || 
                    listInitialConsonantsInGroup2.some(sSound => this.SyllableStartsWithSound(so, sSound))) && 
                    listVowelsInGroup1.some(sSound => this.SyllableHasSound(so, sSound)) &&
                    ((listFinalConsonantsInGroup1.length === 0 && this.SyllableEndsWithAVowel(so)) || 
                     listFinalConsonantsInGroup1.some(sSound => this.SyllableEndsWithSound(so, sSound))))
            }
            else if(sPropertyName === 'StrongRhymeOnFinalSyllable')
            {
                if(!w.HasFinalAccent || w.LexicalID === '3270') return false

                var oLastSyllable = w.SyllableObjects[w.SyllableObjects.length - 1]
                var sLastSyllable = this.RemoveQuiescentFinalConsonants(this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(
                    oLastSyllable.syllableWithSingleConsonants)))

                var sVowel = sLastSyllable.slice(1,2)
                var sFinalConsonant = sLastSyllable.length === 2 ? '' : sLastSyllable.slice(2,3)
                
                //if(listVowelsInGroup1.includes('i') && sVowel === 'i') console.log(sVowel, sFinalConsonant, listVowelsInGroup1, listFinalConsonantsInGroup1)
                return listVowelsInGroup1.includes(sVowel) && 
                    ((sFinalConsonant === '' && listFinalConsonantsInGroup1.length === 0) ||
                     (sFinalConsonant !== '' && 
                        ((listFinalConsonantsInGroup1[0] === 'h' && oLastSyllable.endsWithConsonantalHe) || 
                        listFinalConsonantsInGroup1.includes(sFinalConsonant))))
            }
            else if(sPropertyName === 'StrongRhymeOnPenultimateSyllable')
            {
                if(!w.HasPenultimateAccent || w.LexicalID === '3270') return false

                var oPenultimateSyllable = w.SyllableObjects[w.SyllableObjects.length - 2]
                var sPenultimateSyllable = this.RemoveQuiescentFinalConsonants(this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(
                    oPenultimateSyllable.syllableWithSingleConsonants)))
                var sPenultimateVowel = sPenultimateSyllable.slice(1,2)
                var sFinalConsonantInPenultimateSyllable = sPenultimateSyllable.length === 2 ? '' : sPenultimateSyllable.slice(2,3)

                var oLastSyllable = w.SyllableObjects[w.SyllableObjects.length - 1]
                var sFinalSyllable = this.RemoveQuiescentFinalConsonants(this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(
                    oLastSyllable.syllableWithSingleConsonants)))
                var sInitialConsonantInFinalSyllable = sFinalSyllable.slice(0,1)
                var sFinalVowel = sFinalSyllable.slice(1,2)
                var sFinalConsonantInFinalSyllable = sFinalSyllable.length === 2 ? '' : sFinalSyllable.slice(2,3)

                var blnPenultimateSyllableMatch = listVowelsInGroup1.includes(sPenultimateVowel) && 
                    ((sFinalConsonantInPenultimateSyllable === '' && listFinalConsonantsInGroup1.length === 0) ||
                    (sFinalConsonantInPenultimateSyllable !== '' && 
                    ((listFinalConsonantsInGroup1[0] === 'h' && oPenultimateSyllable.endsWithConsonantalHe) || 
                        listFinalConsonantsInGroup1.includes(sFinalConsonantInPenultimateSyllable))))

                var blnFinalSyllableMatch = listVowelsInGroup2.includes(sFinalVowel) && 
                    (listInitialConsonantsInGroup2.includes(sInitialConsonantInFinalSyllable)) &&
                    ((sFinalConsonantInFinalSyllable === '' && listFinalConsonantsInGroup2.length === 0) ||
                    (sFinalConsonantInFinalSyllable !== '' && 
                    ((listFinalConsonantsInGroup2[0] === 'h' && oLastSyllable.endsWithConsonantalHe) || 
                    listFinalConsonantsInGroup2.includes(sFinalConsonantInFinalSyllable))))

                // if(['12351', '12355', '12359'].includes(w.TextIndex) && listVowelsInGroup1.includes('ē') && listVowelsInGroup2.includes('a') && 
                //     listInitialConsonantsInGroup2.includes('ḵ') && listFinalConsonantsInGroup1.length === 0 && listFinalConsonantsInGroup2.length === 0)
                // {
                //     // var listVowelGroups = [['a', 'a', 'ā', 'â'], ['e'], ['ê', 'ē'], ['i', 'î'], ['o', 'ô'], ['u', 'û'], ['5']]
                //     // var listFinalConsonantGroups = [[], ['l'], ['r'], ['m'], ['n'], ['ḵ', 'ḥ', 'q', 'k', 'g'], ['s', 'š'], ['s', 'ṣ'], ['s', 'z'], 
                //     //     ['b', 'p'], ['t', 'd'], ['f', 'v']] //, ['ʿ', 'ʾ']
                //     // var listInitialConsonantGroups = [['l'], ['r'], ['m'], ['n'], ['y'], 
                //     //     ['ḵ', 'ḥ', 'q', 'k', 'g', 'h'], ['s', 'š'], ['s', 'ṣ'], ['s', 'z'], ['b', 'p'], ['t', 'd'], ['f', 'v'], ['ʿ', 'ʾ']]

                //     console.log(w.TextIndex, blnPenultimateSyllableMatch, blnFinalSyllableMatch, sPenultimateVowel, sFinalConsonantInPenultimateSyllable, 
                //         sInitialConsonantInFinalSyllable, sFinalVowel, sFinalConsonantInFinalSyllable, listVowelsInGroup1, listVowelsInGroup2,
                //         listInitialConsonantsInGroup2, listFinalConsonantsInGroup1, listFinalConsonantsInGroup2)
                // }

                return blnPenultimateSyllableMatch && blnFinalSyllableMatch
            }
            else if(sPropertyName === 'verb')
            {
                //q3ms
                //var sForm = sPropertyValue.slice(0,1)
                var sPerson = sPropertyValue.slice(0,1)
                var sGender = sPropertyValue.slice(1,2)
                var sNumber = sPropertyValue.slice(2,3)

                return w.Person === sPerson && w.Gender === sGender && w.Number === sNumber //&& w.Form === sForm
            }
            else if(sPropertyName === 'stem')
            {
                var oStemEntryForWord = this.listHebrewVerbStems.find(r => r.Abbr === w.Stem)
                return oStemEntryForWord != undefined && oStemEntryForWord.StemGroup === sPropertyValue
            }
            else if(sPropertyName === 'verbform')
            {
                return w.Form === sPropertyValue
            }
            else if(sPropertyName === 'participle')
            {
                return (w.Form === 'r' || w.Form === 's')
            }
            else if(sPropertyName === 'Preposition')
            {
                //b = 903, l = 4077, m = 4790, k = 3892
                return w.Preposition === sPropertyValue || 
                    (sPropertyValue === 'b' && w.LexicalID === '903') ||
                    (sPropertyValue === 'l' && w.LexicalID === '4077') || 
                    (sPropertyValue === 'm' && w.LexicalID === '4790') || 
                    (sPropertyValue === 'k' && w.LexicalID === '3892')
            }
            else if(sPropertyName === 'pgn')
            {
                var sPerson = sPropertyValue.slice(0,1)
                var sGender = sPropertyValue.slice(1,2)
                var sNumber = sPropertyValue.slice(2,3)

                return (w.Person === sPerson && (w.Gender === 'c' || w.Gender === sGender) && w.Number === sNumber) ||
                    (w.SuffixPerson === sPerson && (w.SuffixGender === 'c' || w.SuffixGender === sGender) && w.SuffixNumber === sNumber) ||
                    (sPerson === '1' && sNumber === 's' && w.LexicalID === '612') ||
                    (sPerson === '2' && sGender === 'm' && sNumber === 's' && w.LexicalID === '880')
            }
            else
            {
                var sPropertyValueForWord = (sPropertyName === 'pgn' ? this.GetPGN(w) : 
                sPropertyName === 'suffixpgn' ? this.GetSuffixPGN(w) : w[sPropertyName])
                return sPropertyValueForWord === sPropertyValue
            }
        })
    }

    LookForChainsForProperty(sPropertyName, sPropertyValue, listTextWordsToUse, listLinesToUse, nMinWindowLength, nMaxDistanceBetweenClusterElementsAddedToWindowLength,
        listVowelsInGroup1, listFinalConsonantsInGroup1, listInitialConsonantsInGroup2, listVowelsInGroup2, listFinalConsonantsInGroup2, 
        listSoundGroup1ForSequence, listSoundGroup2ForSequence, listSoundGroup3ForSequence)
    {
        var listToReturn = []

        var listWordsMatchingProperty = this.WordsMatchingProperty(sPropertyName, sPropertyValue, listTextWordsToUse, listLinesToUse,
            listVowelsInGroup1, listFinalConsonantsInGroup1, listInitialConsonantsInGroup2, listVowelsInGroup2, listFinalConsonantsInGroup2, 
            listSoundGroup1ForSequence, listSoundGroup2ForSequence, listSoundGroup3ForSequence)
        .map(w => ({LineIndex: listLinesToUse.findIndex(l => l.Words.includes(w)), Verse: parseInt(w.Verse), Word: w}))

        //if(sPropertyValue === '1287') console.log(listWordsMatchingProperty, this.FilterWordGroupsForChains(listWordsMatchingProperty, nMinWindowLength, nMaxDistanceBetweenClusterElementsAddedToWindowLength, false)) //, listSoundGroup1ForSequence, listSoundGroup2ForSequence)
        //if(sPropertyName === 'StrongRhymeOnPenultimateSyllable' && listWordsMatchingProperty.some(w => w.TextIndex === '12355')) console.log(listWordsMatchingProperty)
        //if(sPropertyName === 'Preposition' && sPropertyValue === 'b') console.log(listWordsMatchingProperty)
        //console.log(listTextWordsToUse.map(w => this.GetSuffixPGN(w)))

        var sStemDesc = ''
        if(sPropertyName === 'stem')
        {
            var oStemAbbrMapping = this.listHebrewVerbStems.find(r => r.Abbr === (sPropertyValue === 'n' ? 'N' : sPropertyValue))
            sStemDesc = oStemAbbrMapping === undefined ? 'stem=?' : oStemAbbrMapping.Desc.toLowerCase()
        }

        var sNameForStrongRhyme = 
            sPropertyName === 'StrongRhymeOnFinalSyllable' ? (listVowelsInGroup1[0] + (listFinalConsonantsInGroup1.length === 0 ? '' : listFinalConsonantsInGroup1[0])) :
            sPropertyName === 'StrongRhymeOnPenultimateSyllable' ? 
            (listVowelsInGroup1[0] + (listFinalConsonantsInGroup1.length === 0 ? '' : listFinalConsonantsInGroup1[0]) + 
            listInitialConsonantsInGroup2[0] + listVowelsInGroup2[0] + (listFinalConsonantsInGroup2.length === 0 ? '' : listFinalConsonantsInGroup2[0])) : ''

        var sNameForSoundSequences = sPropertyName === 'SoundSequencesBetweenWords' ? 
            listSoundGroup1ForSequence[0] + listSoundGroup2ForSequence[0] + (listSoundGroup3ForSequence.length === 0 ? '' : listSoundGroup3ForSequence[0]): ''

        var sNameForSyllableSounds = sPropertyName === 'SyllableSounds' ? ((listInitialConsonantsInGroup2.length === 0 ? '' : listInitialConsonantsInGroup2[0]) + listVowelsInGroup1[0] + (listFinalConsonantsInGroup1.length === 0 ? '' : listFinalConsonantsInGroup1[0])) : ''

        for(var listWordsInChain of this.FilterWordGroupsForChains(listWordsMatchingProperty, nMinWindowLength, nMaxDistanceBetweenClusterElementsAddedToWindowLength, false))
        {
            listToReturn.push({ListWords: listWordsInChain, 
                PropertyName: sPropertyName,
                Name: (sPropertyName === 'SemanticDomain' ? sPropertyValue : 
                sPropertyName === 'LexicalID' ? listWordsMatchingProperty[0].Word.Lexeme : 
                sPropertyName === 'Preposition' ? sPropertyValue :
                sPropertyName === 'verb' ? sPropertyValue :
                sPropertyName === 'pgn' ? sPropertyValue :
                sPropertyName === 'infinitive' ? ('infin=' + sPropertyValue) :
                
                sPropertyName === 'stem' ? sStemDesc :
                sPropertyName === 'suffixpgn' ? ('sfx=' + sPropertyValue) :
                sPropertyName === 'SoundSequencesBetweenWords' ? sNameForSoundSequences :
                sPropertyName === 'SyllableSounds' ? sNameForSyllableSounds :
                (sPropertyName === 'StrongRhymeOnFinalSyllable' || sPropertyName === 'StrongRhymeOnPenultimateSyllable') ? sNameForStrongRhyme :
                sPropertyName),

                Color: sPropertyName === 'suffixpgn' ? 'Green' : 
                sPropertyName === 'Preposition' ? 'Red' : 
                (sPropertyName === 'SemanticDomain' || sPropertyName === 'LexicalID') ? 'Purple' : 'Blue'}) //this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
        }

        return listToReturn
    }

    LexicalChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse, nChainCutoffValueForLens)
    {
        var listToReturn = []

        //1 2 4 8 9 10
        //1 1 2 3 3 5 6 9

        var listLexicalIDsRepeatedInChapter = []
        var groupedByLexicalID = this.GroupArrayByKey(listTextWordsToUse, "LexicalID")
        
        for(var k of Object.keys(groupedByLexicalID))
        {
            if(groupedByLexicalID[k].length > 1)
            {
                listLexicalIDsRepeatedInChapter.push(k)
            }
        }

        var listLexicalIDsToExclude = ['903', '4077', '4790', '3892']
        for(var sLexicalID of listLexicalIDsRepeatedInChapter.filter(s => !listLexicalIDsToExclude.includes(s)))
        {
            listToReturn = listToReturn.concat(this.LookForChainsForProperty('LexicalID', sLexicalID, listTextWordsToUse, listLinesToUse, nChainCutoffValueForLens, 1))
        }

        return listToReturn
    }

    AllNearbyRepetitionLens(lens, listTextWordsToUse, listLinesToUse, blnOnlySemanticChains)
    {
        var listCombined = []
        var listWordsAndNumberOfGroups = []
        // var listGroups = [[], [], [], [], []]

        //listCombined = listCombined.concat(this.CorrespondenceLens(lens, [{ID: '28'}, {ID: '312'}, {ID: '310'}, 
        //    {ID: '74'}, {ID: '308'}, {ID: '66'}, {ID: '69'}, {ID: '304'}], false))

        listCombined = listCombined.concat(this.SemanticChainsLens(listTextWordsToUse))
        
        if(!blnOnlySemanticChains)
        {
            listCombined = listCombined.concat(this.MorphologicalChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse, 2))
            listCombined = listCombined.concat(this.LexicalChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse, 2))
        }

        for(var w of listTextWordsToUse)
        {
            var listGroups = listCombined.filter(g => g.ListWords.includes(w))

            //if(w.TextIndex === '13473') console.log(listGroups)
            //if(listGroups.flatMap(g => g.ListWords).some(w2 => w2.TextIndex === '13473')) console.log(w.TextIndex, listGroups)

            var nMaxWordsInOneGroup = Math.max(...listGroups.map(g => g.ListWords.length))
            var sWordColor = nMaxWordsInOneGroup >= 15 ? 'Black' : nMaxWordsInOneGroup >= 10 ? 'Purple' : nMaxWordsInOneGroup >= 7 ? 'Red' : 
                nMaxWordsInOneGroup >= 5 ? 'Blue' : nMaxWordsInOneGroup >= 3 ? 'Green' : nMaxWordsInOneGroup >= 2 ? 'Maroon' : 'LightGray'

            listWordsAndNumberOfGroups.push({Word: w, MaxWordsInOneGroup: nMaxWordsInOneGroup, WordColor: sWordColor,
                NumberOfGroups: listGroups.length, WordsGroupedWithThisWord: listGroups.flatMap(g => g.ListWords)})
        }

        var listToReturn = listWordsAndNumberOfGroups.filter(o => o.WordsGroupedWithThisWord.length > 1)
        .map((o, n) => {
            return {ListWords: o.WordsGroupedWithThisWord, Name: o.MaxWordsInOneGroup.toString(), Color: o.WordColor, MainWord: o.Word}
        })

        return listToReturn
        
        //console.log(listCombined)
        //for each line, find the word with the most groups, and put that in listGroup1
        // for(var line of listLinesToUse)
        // {
        //     var listWordsAndNumberOfGroups = []
        //     for(var w of line.Words)
        //     {
        //         listWordsAndNumberOfGroups.push({Word: w, GroupsWithThisWord: listCombined.filter(g => g.ListWords.includes(w)).flatMap(g => g.ListWords)})
        //     }

        //     // var listDistinctNumbers = listWordsAndNumberOfGroups.map(o => o.GroupsWithThisWord).sort((a,b) => b - a)
        //     // for(var n of listDistinctNumbers)
        //     // {
        //     // }

        //     //var listWordsAndNumberOfGroupsSorted = listWordsAndNumberOfGroups.filter(o => o.GroupsWithThisWord > 0).sort((a,b) => b.GroupsWithThisWord - a.GroupsWithThisWord)

        //     //console.log(listWordsAndNumberOfGroupsSorted)
        //     // for(var nGroup = 0; nGroup < 4; nGroup++)
        //     // {
        //     //     if(listWordsAndNumberOfGroupsSorted.length > nGroup) listGroups[nGroup].push(listWordsAndNumberOfGroupsSorted[nGroup].Word)   
        //     // }
        // }
        // return listGroups.filter(l => l.length > 0)
        //     .map((l, n) => ({ListWords: l, Name: 'level ' + n.toString(), 
        //         Color: n === 0 ? 'Red' : n === 1 ? 'Green' : n === 2 ? 'Blue' : 'LightGray'}))
    }

    PrepopulateSemanticChainsForChapter()
    {
        if(this.state.nCurrentLinkGroupType != 8) return
        if(this.state.listRepetitionLinkGroups.some(g => g.ListWords.some(w => this.listTextWordsForChapter.some(w2 => w.TextIndex === w2.TextIndex))))
        {
            window.alert('There are already semantic chains in this chapter. Cannot prepopulate.')
            return
        }

        var listToSet = this.state.listRepetitionLinkGroups
        //this.state.listLines
        //list(set([l.split('^')[0].strip() for l in s.split(',')])) from MainSemanticDomains.json

        var listWordGroups = [{"ListWordIDs":['433', '447', '456', '3269', '3270', '9470', '126', '150', '3253'],"Description":"Words For God"},
            {"ListWordIDs":['2075', '618', '2183', '450', '880', '610', '2185', '2158', '612', '2016', '3892'],"Description": 'Pronouns'}, 
            {"ListWordIDs":['175', '359', '364', '369', '371', '373', '394', '395', '400', '598', '2046', '4369', '4395', '4620', '9823', '9836', '9858'],"Description":"Question Words"},
            {"ListWordIDs":['16', '172', '205', '206', '275', '328', '356', '506', '600', '1038', '1968', '1969', '2012', '2013', '2029', '2090', '2097', '2618', '5340', '9472', '9508'],"Description":"Emotion Exclamations"},
            {"ListWordIDs":['6307', '4766', '1428', '8375', '8270', '7663', '1031', '9566', '4248', '4985', '4102', '3231', '7943', '3876', '5092', 
                '7524', '6304', '923', '698', '3526', '7898', '9822', '405', '6934', '4767', '3116', '8902', '5028', '7856', '7978', '1370', '9811', '3434', 
                '1705', '860', '6797', '2805', '7368', '1894', '6530', '9487', '8913', '3964', '5506', '3626', '10087', '9627', '8278', '4098', '7989', 
                '3437', '10013', '3407', '6677', '7899', '5317', '6967', '7662', '10038', '270', '5673', '4354', '9397', '1714', '2324', '1699', '9963', 
                '6862', '3446', '5685', '261', '8883', '681', '8966', '8825', '7987', '5091', '8842', '9593', '7048', '7741', '4735', '1909', '8567', '6869', 
                '6675', '1877', '8923', '9810', '1426', '4771', '7850', '6566', '5686', '4254', '5778', '4891', '7201', '9922', '9744', '6580', '6508', '4182', 
                '10075', '1742', '2561', '7847', '8630', '3944', '7762', '7783', '9504', '10174', '7901', '4093', '4092'], "Description": 'parts of the body'}]
            
        for(var wg of listWordGroups)
        {
            var listTextIndexesForMatchingWords = this.listTextWordsForChapter.filter(w => wg.ListWordIDs.includes(w.LexicalID)).map(w => w.TextIndex)
            if(listTextIndexesForMatchingWords.length > 1)
            {
                listToSet.push({ListWords: listTextIndexesForMatchingWords, ListTags: [], Comment: wg.Description, Type: 8})
                //console.log(listTextIndexesForMatchingWords)
            }
        }

        //ki '3828', lo '4078', kol '3850'
        var listToExclude = ['903', '877', '6361', '4077', '435', '4790']
        for(var g of this.RepeatedRootsLens(this.listTextWordsForChapter, false))
        {
            var sFirstWordLexicalID = g.ListWords[0].LexicalID
            if(listToExclude.includes(sFirstWordLexicalID) || listWordGroups.some(wg => wg.ListWordIDs.includes(sFirstWordLexicalID))) continue

            listToSet.push({ListWords: g.ListWords.map(w => w.TextIndex), ListTags: [], Comment: '', 
                Type: 8})
        }
        
        //console.log(listToSet)
        this.SaveRepetitionLinkGroupsAndSetState(listToSet)
    }
    
    SemanticChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse)
    {
        var listToReturn = []
        var listDomainsToExclude = ['measurement']

        for(var sSemanticDomain of this.listMainSemanticDomains.map(o => o.Name).filter(s => !listDomainsToExclude.includes(s)))
        {
            listToReturn = listToReturn.concat(this.LookForChainsForProperty('SemanticDomain', sSemanticDomain, listTextWordsToUse, listLinesToUse, this.state.nChainCutoffValue, 1))
        }

        //only include lexical chains that are not already mostly contained in a semantic chain
        var listLexicalChainsToInclude = this.LexicalChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse, this.state.nChainCutoffValue)
            .filter(o1 => !listToReturn.some(o2 => {
                var nWordsInCommon = o2.ListWords.filter(w => o1.ListWords.includes(w)).length
                return nWordsInCommon >= o1.ListWords.length - 1
        }))

        // for(var o1 of this.LexicalChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse, this.state.nChainCutoffValue))
        // {
        //     if(!listToReturn.some(o2 => o2.ListWords.filter(w => o1.ListWords.includes(w)).length > 1))
        //     listLexicalChainsToInclude.append(o1)
        // }
        // .filter(o => o.ListWords.filter(w => listToReturn.some(o2 => o2.ListWords.includes(w))).length > 1)

        //console.log(listToReturn)
        return listToReturn.concat(listLexicalChainsToInclude)
    }

    
    // GetVowelsInTransliteration(s)
    // {
    //     s = s.replace(/[^aiîoeuûēəāâêôj5]/g, '')
    //     return [...s]
    // }

    // GetConsonantsInTransliteration(s)
    // {
    //     s = s.replace(/[^šṣḵmhtḥsmnpfbvdklʿʾywzrgq]/g, '')
    //     return [...s]
    // }

    // VowelSimilarityForStrongRhyme(s1, s2)
    // {
    //     var listSounds = [['a', 'a', 'ā', 'â'], ['e'], ['ê', 'ē'], ['i', 'î'], ['o', 'ô'], ['u', 'û'], ['5']]
    //     return listSounds.some(l => l.includes(s1) && l.includes(s2))
    // }

    // ConsonantSimilarityForStrongRhyme(s1, s2)
    // {
    //     var listSounds = [['ḵ', 'ḥ', 'q', 'k', 'g'], ['s', 'š'], ['s', 'ṣ'], ['s', 'z'], ['b', 'p'], ['t', 'd'], ['f', 'v'], ['ʿ', 'ʾ']]
    //     return listSounds.some(l => l.includes(s1) && l.includes(s2))
    // }

    // WordsHaveStrongRhyme(w1, w2)
    // {
    //     //strong rhyme depends on the accented vowel, but the consonant sound after the vowel changes the vowel, so that must also be taken into consideration.
    //     //Algorithm: compute chains, for each pair of words, that pair rhymes if 
    //     //1) the accent is final in both or penultimate in both, 
    //     //2) the vowel in the accented syllable and following syllable (if the accent is penultimate) must be the same basic vowel, 
    //     //3) any consonants immediately after the vowel in the accented syllable and the vowel in the following syllable (if applicable) 
    //     //are of the same class (b-p, f-v, s-sh, s-ts, t-d, k-g-q-kh) (e.g. nadad and natat).

    //     if(w1.HasPenultimateAccent && w2.HasPenultimateAccent)
    //     {
    //         var sLastTwoSyllables1 = this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(
    //             w1.SyllableObjects.filter(syl => syl.hasFullAccent || syl.isLastSyllableInWord).map(syl => syl.syllableWithSingleConsonants).join('')))
    //         var sLastTwoSyllables2 = this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(
    //             w2.SyllableObjects.filter(syl => syl.hasFullAccent || syl.isLastSyllableInWord).map(syl => syl.syllableWithSingleConsonants).join('')))


    //     }
    //     else if(w1.HasFinalAccent && w2.HasFinalAccent)
    //     {
    //         var s1 = this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(
    //             w1.SyllableObjects.filter(syl => syl.hasFullAccent).map(syl => syl.syllableWithSingleConsonants).join('')))
    //         var s2 = this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(
    //             w2.SyllableObjects.filter(syl => syl.hasFullAccent).map(syl => syl.syllableWithSingleConsonants).join('')))

    //         return s1.length === s2.length && 
    //             this.VowelSimilarityForStrongRhyme(s1.slice(1,2), s2.slice(1,2)) && 
    //             (s1.length === 2 || (s1.length === 3 && this.ConsonantSimilarityForStrongRhyme(s1.slice(2,3), s2.slice(2,3))))
    //     }
    // }

    SoundChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse)
    {
        var listLensWordGroups = []

        var listSoundGroups = []
        
        if(this.blnChapterIsHebrew)
        {
            listSoundGroups = [{"Name": "a" , "ListChars": ["a", "â"], "StringsToExclude": ["ay"]},
                {"Name": "e" , "ListChars": ["e"], "StringsToExclude": ["ey"]},
                {"Name": "ē" , "ListChars": ["ē", "ê", "ey"], "StringsToExclude": []},
                {"Name": "ay" , "ListChars": ["ay"], "StringsToExclude": []},
                {"Name": "i" , "ListChars": ["i"], "StringsToExclude": []},
                {"Name": "o" , "ListChars": ["o", "ô"], "StringsToExclude": []},
                {"Name": "u" , "ListChars": ["u", "û"], "StringsToExclude": []},
                
                {"Name": "k", "ListChars": ["k", "q", "g"], "StringsToExclude": []},
                {"Name": "ḥ", "ListChars": ["ḵ", "ḥ"], "StringsToExclude": []},
                {"Name": "h", "ListChars": ["h"], "StringsToExclude": []},
                {"Name": "s", "ListChars": ["s", "z"], "StringsToExclude": []},
                {"Name": "š", "ListChars": ["š"], "StringsToExclude": []},
                {"Name": "ṣ", "ListChars": ["ṣ"], "StringsToExclude": []},
                {"Name": "p", "ListChars": ["b", "p"], "StringsToExclude": []},
                {"Name": "t", "ListChars": ["t", "d"], "StringsToExclude": []},
                {"Name": "f", "ListChars": ["f", "v"], "StringsToExclude": []},
                {"Name": "ʿ", "ListChars": ["ʿ"], "StringsToExclude": []},
                {"Name": "ʾ", "ListChars": ["ʾ"], "StringsToExclude": []},
                {"Name": "l", "ListChars": ["l"], "StringsToExclude": []},
                {"Name": "r", "ListChars": ["r"], "StringsToExclude": []},
                {"Name": "m", "ListChars": ["m"], "StringsToExclude": []},
                {"Name": "n", "ListChars": ["n"], "StringsToExclude": []},
                {"Name": "y", "ListChars": ["y"], "StringsToExclude": []}]
        }
        else
        {
            listSoundGroups = [{"Name": "a", "ListChars": ["a", "A"], "StringsToExclude": ["ai", "Ai", "au", "Au"]},
            {"Name": "i", "ListChars": ["i", "I"], "StringsToExclude": ["ai", "Ai", "ei", "Ei", "oi", "Oi", "ui", "Ui"]},
            {"Name": "o", "ListChars": ["o", "O"], "StringsToExclude": ["oi", "Oi", "ou", "Ou"]},
            {"Name": "ē", "ListChars": ["ē", "Ē"], "StringsToExclude": ["ēu", "Ēu"]},
            {"Name": "u", "ListChars": ["u", "U"], "StringsToExclude": ["au", "Au", "eu", "Eu", "ou", "Ou", "ui", "Ui", "ēu", "Ēu"]},
            {"Name": "ō", "ListChars": ["ō", "О̄"], "StringsToExclude": []},
            {"Name": "e", "ListChars": ["e", "E"], "StringsToExclude": ["ei", "Ei", "eu", "Eu"]},
            
            {"Name": "ai", "ListChars": ["ai", "Ai"], "StringsToExclude": []},
            {"Name": "au", "ListChars": ["au", "Au"], "StringsToExclude": []},
            {"Name": "ei", "ListChars": ["ei", "Ei"], "StringsToExclude": []},
            {"Name": "eu", "ListChars": ["eu", "Eu"], "StringsToExclude": []},
            {"Name": "oi", "ListChars": ["oi", "Oi"], "StringsToExclude": []},
            {"Name": "ou", "ListChars": ["ou", "Ou"], "StringsToExclude": []},
            {"Name": "ēu", "ListChars": ["ēu", "Ēu"], "StringsToExclude": []},
            {"Name": "ui", "ListChars": ["ui", "Ui"], "StringsToExclude": []},
            
            {"Name": "p", "ListChars": ["p", "b", "P", "B"], "StringsToExclude": []},
            {"Name": "t", "ListChars": ["d", "t", "D", "T"], "StringsToExclude": []},
            {"Name": "k", "ListChars": ["k", "g", "K", "G"], "StringsToExclude": []},
            {"Name": "ḵ", "ListChars": ["ḵ", "Ḵ"], "StringsToExclude": []},
            {"Name": "l", "ListChars": ["l", "L"], "StringsToExclude": []},
            {"Name": "m", "ListChars": ["m", "M"], "StringsToExclude": []},
            {"Name": "n", "ListChars": ["n", "N", "ŋ"], "StringsToExclude": []},
            {"Name": "f", "ListChars": ["f", "F"], "StringsToExclude": []},
            {"Name": "s", "ListChars": ["s", "z", "S", "Z"], "StringsToExclude": []},
            {"Name": "r", "ListChars": ["r", "R"], "StringsToExclude": []},
            {"Name": "h", "ListChars": ["h", "H"], "StringsToExclude": []},
            {"Name": "th", "ListChars": ["θ", "Θ"], "StringsToExclude": []}]
        }

        listSoundGroups.reverse()
        for(var g of listSoundGroups)
        {
            var listWordsInGroup = []
            var listWordsInGroupMatchingAtRightLocation = []
            for(var w of listTextWordsToUse)
            {
                //only include y at the beginning of the syllable because we are looking for the consonant version here
                var listSyllableObjectsMatchingGroup = false
                
                if(this.blnChapterIsHebrew)
                {
                    listSyllableObjectsMatchingGroup = w.SyllableObjects.filter(oSyllable => 
                        g.ListChars.some(c => 
                            (g.ListChars.includes('y') ? oSyllable.syllableWithSingleConsonants.startsWith('y') : 
                            g.ListChars.includes('h') ? (oSyllable.syllableWithSingleConsonants.startsWith('h') || oSyllable.endsWithConsonantalHe) :
                            oSyllable.syllableWithSingleConsonants.includes(c)) && 
                        !g.StringsToExclude.some(s => oSyllable.syllableWithSingleConsonants.includes(s))))
                }
                else
                {
                    listSyllableObjectsMatchingGroup = w.SyllableObjects.filter(oSyllable => 
                        g.ListChars.some(c => oSyllable.syllableWithSingleConsonants.includes(c) && 
                        !g.StringsToExclude.some(s => oSyllable.syllableWithSingleConsonants.includes(s))))
                }

                if(listSyllableObjectsMatchingGroup.length > 0)
                {
                    if(listSyllableObjectsMatchingGroup.some(oSyllable => this.SyllableIsInRightLocation(oSyllable)))
                    {
                        listWordsInGroupMatchingAtRightLocation.push(w)
                    }

                    listWordsInGroup.push(w)
                }
            }
            
            var listChains = this.FilterWordGroupsForChains(listWordsInGroup.map(w => 
                ({LineIndex: listLinesToUse.findIndex(l => l.Words.includes(w)), Verse: parseInt(w.Verse), Word: w})), this.state.nChainCutoffValue, 0, true)
                
            for(var listWordsInChain of listChains)
            {
                listLensWordGroups.push({ListWords: listWordsInChain, WordsMatchingAtRightLocation: listWordsInGroupMatchingAtRightLocation, 
                    Name: g.Name, Color: this.listLinkGroupColors[listLensWordGroups.length % this.listLinkGroupColors.length]})
            }
        }

        return listLensWordGroups
    }

    RhymeChainsBetweenLinesLens()
    {
        //{"s":"at","l":["6","11","18"]}
        return this.listRhymeChains.filter(o => parseInt(o.Book) === this.state.nCurrentBook && this.state.listCurrentChapters.includes(parseInt(o.Chapter)))
            .flatMap(o => o.Groups.filter(o2 => o2.l.length >= this.state.nChainCutoffValue)
            .map((o2, n) => { 
                let listWords = o2.l.map(sTextIndex => this.GetWordWithTextIndexInChapter(sTextIndex))
                
                return {ListWords: listWords, Name: o2.s, WordsToNotColor: this.state.blnDoNotColorFirstWordInChain ? [listWords[0]] : [],
                    Color: this.listLinkGroupColors[n % this.listLinkGroupColors.length]}
            }))
    }

    RhymeChainsBetweenLinesCalculation(listTextWordsToUse, listLinesToUse)
    {
        var listToReturn = []

        var listVowelGroups = [['a', 'a', 'ā', 'â'], ['ē', 'ê', 'e'], ['i', 'î'], ['o', 'ô'], ['u', 'û'], ['5']]
        var listFinalConsonantGroups = [[], ['l'], ['r'], ['m'], ['n'], ['k', 'g', 'q'], ['ḵ', 'ḥ'], ['š'], ['s', 'z', 'ṣ'], 
            ['b', 'p'], ['t', 'd'], ['f', 'v'], ['h']] //, ['ʿ', 'ʾ']
        var listInitialConsonantGroups = [['l'], ['r'], ['m'], ['n'], ['y'], 
            ['k', 'g', 'q'], ['ḵ', 'ḥ', 'h'], ['š'], ['s', 'z', 'ṣ'], ['b', 'p'], ['t', 'd'], ['f', 'v'], ['ʿ', 'ʾ']]

        for(var listVowelsInGroup of listVowelGroups)
        {
            for(var listConsonantsInGroup of listFinalConsonantGroups)
            {
                listToReturn = listToReturn.concat(this.LookForChainsForProperty('StrongRhymeOnFinalSyllable', '', listTextWordsToUse, listLinesToUse, 2, 1, 
                    listVowelsInGroup, listConsonantsInGroup))
            }
        }

        for(var listVowelsInGroup1 of listVowelGroups)
        {
            for(var listFinalConsonantsInGroup1 of listFinalConsonantGroups)
            {
                for(var listVowelsInGroup2 of listVowelGroups)
                {
                    for(var listInitialConsonantsInGroup of listInitialConsonantGroups)
                    {
                        for(var listFinalConsonantsInGroup2 of listFinalConsonantGroups)
                        {
                            listToReturn = listToReturn.concat(this.LookForChainsForProperty('StrongRhymeOnPenultimateSyllable', '', listTextWordsToUse, listLinesToUse, 2, 1, 
                                listVowelsInGroup1, listFinalConsonantsInGroup1, listInitialConsonantsInGroup, listVowelsInGroup2, listFinalConsonantsInGroup2))
                        }
                    }
                }
            }
        }

        listToReturn.forEach((oChain, nChain) => oChain.Color = this.listLinkGroupColors[nChain % this.listLinkGroupColors.length])
        return listToReturn

        // var w1 = listTextWordsToUse[0]
        // var w2 = listTextWordsToUse[1]
        // this.WordsHaveStrongRhyme(w1, w2)
        
        // return []
    }

    
    CalculateRhymeChainsForAllPoeticChapters()
    {
        fetch("HebrewTextData/allchaptersinpoeticbooks.json")
		.then(res => res.json())
		.then(data => 
		{
			var listTextWordsForAllChapters = data.OSHB; //.filter(w => parseInt(w.TextIndex) > 16887 && parseInt(w.TextIndex) <= 17000);  

			//TODO before running: fix global line list - it doesn't correspond to what is in the individual files
			fetch("LineData/alllinesinpoeticbooks.json")
			.then(res => res.json())
			.then(data => 
			{
                var listLinesForAllChapters = data.Lines

                var listChainsByChapter = []
                var textWordsByBook = this.GroupArrayByKey(listTextWordsForAllChapters, "Book")
                for(var sBookToDo of Object.keys(textWordsByBook))
                {						
                    if(sBookToDo != '19') continue
                    console.log('Book: ' + sBookToDo)

                    var textWordsByChapter = this.GroupArrayByKey(textWordsByBook[sBookToDo], "Chapter");
                    for(var sChapterToDo of Object.keys(textWordsByChapter)) //.slice(0, 10)
                    {						
                        //if(sChapterToDo != '24') continue
                        //|| parseInt(sChapterToDo) > 200
                        //if(parseInt(sChapterToDo) > 5) continue
                        //console.log('Chapter: ' + sChapterToDo)

                        var listWordsInChapter = textWordsByChapter[sChapterToDo]
                        for(var w of listWordsInChapter)
                        {
                            var listSyllableObjectsForWord = this.GetSyllableObjectsForWord(w)
        
                            w.SyllableObjects = listSyllableObjectsForWord
                            w.Transliteration = listSyllableObjectsForWord.map(syl => syl.syllable).join('')
                            w.HasFullAccent = listSyllableObjectsForWord.some(syl => syl.hasFullAccent)
                            w.HasSecondaryAccent = listSyllableObjectsForWord.some(syl => syl.hasSecondaryAccent)
                            w.HasFinalAccent = listSyllableObjectsForWord.some(syl => syl.hasFullAccent && syl.isLastSyllableInWord)
                            w.HasPenultimateAccent = listSyllableObjectsForWord.some((syl, n, arr) => syl.hasFullAccent && syl.syllableIndex === arr.length - 2)
                        }

                        var listLinesInChapter = listLinesForAllChapters.filter(ol => ol.Book === sBookToDo && ol.Chapter === sChapterToDo)
                        this.CalculateLines(listLinesInChapter, listWordsInChapter)

                        //console.log(listLinesInChapter)
                        //console.log()
                        listChainsByChapter.push({'Book': sBookToDo, 'Chapter': sChapterToDo, 'Groups': 
                            this.RhymeChainsBetweenLinesCalculation(listWordsInChapter, listLinesInChapter).map(g => ({s: g.Name.replace('5', 'ay'), l: g.ListWords.map(w => w.TextIndex)}))})
                    }
                }

                window.alert('done!')
                console.log(JSON.stringify(listChainsByChapter))
            })
        })
    }

    MorphologicalChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse, nChainCutoffValueForLens)
    {
        var listToReturn = []

        for(var sPreposition of ['b', 'l', 'k', 'm'])
        {
            listToReturn = listToReturn.concat(this.LookForChainsForProperty('Preposition', sPreposition, listTextWordsToUse, listLinesToUse, nChainCutoffValueForLens, 1))
        }

        for(var sSuffixPGN of ['1ms', '2ms', '2fs', '3ms', '3fs', '1mp', '2mp', '2fp', '3mp', '3fp', '1cs'])
        {
            listToReturn = listToReturn.concat(this.LookForChainsForProperty('suffixpgn', sSuffixPGN, listTextWordsToUse, listLinesToUse, nChainCutoffValueForLens, 1))
        }
    
        for(var sPGN of ['1ms', '2ms', '2fs', '3ms', '3fs', '1mp', '2mp', '2fp', '3mp', '3fp', '1cs', '3cp'])
        {
            //for(var sForm of ['i', 'v', 'p', 'q', 'h', 'w', 'j'])
            //{
                listToReturn = listToReturn.concat(this.LookForChainsForProperty('verb', sPGN, listTextWordsToUse, listLinesToUse, nChainCutoffValueForLens, 1))
            //}
        }

        // for(var sPGN of ['1ms', '2ms', '2fs', '3ms', '3fs', '1mp', '2mp', '2fp', '3mp', '3fp'])
        // {
        //     listToReturn = listToReturn.concat(this.LookForChainsForProperty('pgn', sPGN, listTextWordsToUse, listLinesToUse, nChainCutoffValueForLens, 1))
        // }

        // for(var sStem of ['n', 'h', 'p'])
        // {
        //     listToReturn = listToReturn.concat(this.LookForChainsForProperty('stem', sStem, listTextWordsToUse, listLinesToUse, nChainCutoffValueForLens, 1))
        // }

        for(var sInfinitive of ['c', 'a'])
        {
            listToReturn = listToReturn.concat(this.LookForChainsForProperty('infinitive', sInfinitive, listTextWordsToUse, listLinesToUse, nChainCutoffValueForLens, 1))
        }

        listToReturn = listToReturn.concat(this.LookForChainsForProperty('participle', '', listTextWordsToUse, listLinesToUse, nChainCutoffValueForLens, 1))

        return listToReturn
    }

    SyllableChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse)
    {
        var listToReturn = []

        var listInitialConsonantGroups = []
        var listVowelGroups = []
        var listFinalConsonantGroups = []

        if(this.blnChapterIsHebrew)
        {
            listInitialConsonantGroups = [['l'], ['r'], ['m'], ['n'], ['y'], 
                ['k', 'g', 'q'], ['ḵ', 'ḥ', 'h'], ['š'], ['s', 'z', 'ṣ'], ['b', 'p'], ['t', 'd'], ['f', 'v'], ['ʿ', 'ʾ']]
            listVowelGroups = [['a', 'a', 'ā', 'â'], ['e'], ['ē', 'ê'], ['i', 'î'], ['o', 'ô'], ['u', 'û'], ['5']]
            listFinalConsonantGroups = [[], ['l'], ['r'], ['m'], ['n'], ['k', 'g', 'q'], ['ḵ', 'ḥ'], ['š'], ['s', 'z', 'ṣ'], 
                ['b', 'p'], ['t', 'd'], ['f', 'v'], ['h']] //, ['ʿ', 'ʾ']
        }
        else
        {
            listInitialConsonantGroups = [[], ["p", "b"], ["d", "t"], ["k", "g"], ["ḵ", "Ḵ"], ["l"], ['m'], 
                ['n', 'ŋ'], ['f'], ['r'], ['h'], ["s", "z"], ["θ", "Θ"]]
            listVowelGroups = [['a'], ['i'], ['o'], ['ē', 'Ē'], ['u'], ['ō', 'О̄'], ['e'], ['ai'], ['au'], ['ei'], ['eu'], ['oi'], ['ou'], ['ēu', 'Ēu'], ['ui']]
            listFinalConsonantGroups = [[], ["p", "b"], ["d", "t"], ["k", "g"], ["ḵ", "Ḵ"], ["l"], ['m'], 
                ['n', 'ŋ'], ['f'], ['r'], ['h'], ["s", "z"], ["θ", "Θ"]]
        }

        for(var listInitialConsonantsInGroup of listInitialConsonantGroups)
        {
            for(var listVowelsInGroup of listVowelGroups)
            {
                for(var listFinalConsonantsInGroup of listFinalConsonantGroups)
                {
                    listToReturn = listToReturn.concat(this.LookForChainsForProperty('SyllableSounds', '', listTextWordsToUse, listLinesToUse, 2, 1, 
                        listVowelsInGroup, listFinalConsonantsInGroup, listInitialConsonantsInGroup, [], [], [], [], [], []))
                }
            }
        }

        listToReturn.forEach((oChain, nChain) => oChain.Color = this.listLinkGroupColors[nChain % this.listLinkGroupColors.length])
        return listToReturn
    }

    SoundSequenceChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse)
    {
        var listToReturn = []

        //TODO: exclude the same lexical IDs
        //for this function, include groups of the bgdkpt that change pronounciation, since we are also interested
        //in things like consonantal root soundplay?

        var listVowelGroups = []
        var listConsonantGroups = []

        if(this.blnChapterIsHebrew)
        {
            listVowelGroups = [['a', 'a', 'ā', 'â'], ['e'], ['ē', 'ê'], ['i', 'î'], ['o', 'ô'], ['u', 'û'], ['5']]
            listConsonantGroups = [['l'], ['r'], ['m'], ['n'], ['y'], 
                //['k', 'ḵ'], ['b', 'v'], ['p', 'f'],
                ['k', 'g', 'q'], ['ḵ', 'ḥ', 'h'], ['š'], ['s', 'z', 'ṣ'], ['b', 'p'], ['t', 'd'], ['f', 'v']] //, ['ʿ', 'ʾ']
        }
        else
        {
            listConsonantGroups = [["p", "b", "P", "B"], ["d", "t", "D", "T"], ["k", "g", "K", "G"], ["ḵ", "Ḵ"], ["l", "L"], ['m', 'M'], 
            ['n', 'N', 'ŋ'], ['f', 'F'], ['r', 'R'], ['h', 'H'], ["s", "z", "S", "Z"], ["θ", "Θ"]]
            listVowelGroups = [['a', 'A'], ['i', 'I'], ['o', 'O'], ['ē', 'Ē'], ['u', 'U'], ['ō', 'О̄'], ['e', 'E']]
        }

        var listCombosDone = []
        for(var listInGroup1 of listConsonantGroups)
        {
            for(var listInGroup2 of listConsonantGroups)
            {
                for(var listInGroup3 of listConsonantGroups)
                {
                    var sCombo = [listInGroup1[0], listInGroup2[0], listInGroup3[0]].sort((a,b) => a.localeCompare(b)).join('')
                    if(!listCombosDone.includes(sCombo) &&
                        listInGroup1[0] != listInGroup2[0] && 
                        listInGroup2[0] != listInGroup3[0] && 
                        listInGroup1[0] != listInGroup3[0])
                    {
                        listToReturn = listToReturn.concat(this.LookForChainsForProperty('SoundSequencesBetweenWords', '', listTextWordsToUse, listLinesToUse, 2, 1, 
                            [], [], [], [], [], listInGroup1, listInGroup2, listInGroup3))
                        listCombosDone.push(sCombo)
                    }
                }
            }
        }

        for(var listInGroup1 of listVowelGroups)
        {
            for(var listInGroup2 of listVowelGroups)
            {
                for(var listInGroup3 of listVowelGroups)
                {
                    var sCombo = [listInGroup1[0], listInGroup2[0], listInGroup3[0]].sort((a,b) => a.localeCompare(b)).join('')
                    if(!listCombosDone.includes(sCombo) &&
                        listInGroup1[0] != listInGroup2[0] && 
                        listInGroup2[0] != listInGroup3[0] && 
                        listInGroup1[0] != listInGroup3[0])
                    {
                        listToReturn = listToReturn.concat(this.LookForChainsForProperty('SoundSequencesBetweenWords', '', listTextWordsToUse, listLinesToUse, 2, 1, 
                            [], [], [], [], [], listInGroup1, listInGroup2, listInGroup3))
                        listCombosDone.push(sCombo)
                    }
                }
            }
        }

        listToReturn.forEach((oChain, nChain) => oChain.Color = this.listLinkGroupColors[nChain % this.listLinkGroupColors.length])
        return listToReturn
    }

    NumberOfChainsBetweenLinesByWordLens(listTextWordsToUse, listLinesToUse)
    {
        var listChainGroupsForChapter = this.MorphologicalChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse, this.state.nChainCutoffValue)
            .concat(this.SemanticChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse))

        var listColorByWord = this.listTextWordsForChapter.map(w => {
            var nChainsThisWordIsAPartOf = listChainGroupsForChapter.filter(o => o.ListWords.includes(w)).length
            var nColor = nChainsThisWordIsAPartOf === 0 ? "LightGray" : 
                nChainsThisWordIsAPartOf === 1 ? "Green" : 
                nChainsThisWordIsAPartOf === 2 ? "Blue" : 
                nChainsThisWordIsAPartOf === 3 ? "Red" : "Purple" 

            return {W: w, Color: nColor}
        })

        var listColors = [...new Set(listColorByWord.map(o => o.Color))]
        return listColors.map(s => ({ListWords: listColorByWord.filter(o => o.Color === s).map(o => o.W), Name: '', Color: s}))
    }

    WordRhythmLens(listTextWordsToUse)
    {
        var listToReturn = []
        
        for(var nSyllables = 1; nSyllables <= 6; nSyllables++)
        {
            listToReturn.push({Name: nSyllables.toString() + ' Syllables', 
                ListWords: listTextWordsToUse.filter(w => w.SyllableObjects.length === nSyllables), 
                Color: this.listLinkGroupColors[nSyllables % this.listLinkGroupColors.length]})

            // listToReturn.push({Name: nSyllables.toString() + ' Syllables, Final Accent', 
            //     ListWords: listTextWordsToUse.filter(w => w.SyllableObjects.length === nSyllables && w.HasFinalAccent), 
            //     Color: this.listLinkGroupColors[(nSyllables * 2) % this.listLinkGroupColors.length]})

            // listToReturn.push({Name: nSyllables.toString() + ' Syllables, Penultimate Accent', 
            //     ListWords: listTextWordsToUse.filter(w => w.SyllableObjects.length === nSyllables && w.HasPenultimateAccent), 
            //     Color: this.listLinkGroupColors[(nSyllables * 2 + 1) % this.listLinkGroupColors.length]})
        }

        return listToReturn
    }
    
    PropertyOrderLens(sProperty, listLinesToUse)
    {
        var listToReturn = []
        for(var line of listLinesToUse)
        {
            let sPropertyOrder = line.Words.map(w => w[sProperty])
            .reduce((accumulator, currentElement) => {
                if (accumulator.length === 0 || currentElement !== accumulator[accumulator.length - 1]) 
                {
                  accumulator.push(currentElement)
                }
                return accumulator
              }, [])
            .join(', ')

            let nExistingIndex = listToReturn.findIndex(o => o.Name === sPropertyOrder)

            if(nExistingIndex > -1)
            {
                listToReturn[nExistingIndex].ListWords = listToReturn[nExistingIndex].ListWords.concat(line.Words)
                listToReturn[nExistingIndex].Lines.push(line)
            }
            else
            {
                listToReturn.push({Name: sPropertyOrder, ListWords: line.Words, Lines: [line], ByLine: true,
                    Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
            }
        }

        return listToReturn.filter(g => g.Lines.length > 1)
    }

    InterstressLengthOrderInLineLens(listLinesToUse)
    {
        var listToReturn = []
        for(var line of listLinesToUse)
        {
            let sInterstressLengthOrderInLine = line.Words.map(w => this.GetSyllableDistanceToPreviouslyAccentedSyllableForWord(w).toString())
            .reduce((accumulator, currentElement) => {
                if (accumulator.length === 0 || currentElement !== accumulator[accumulator.length - 1]) 
                {
                  accumulator.push(currentElement)
                }
                return accumulator
              }, [])
            .join(', ')
                
            let nExistingIndex = listToReturn.findIndex(o => o.Name === sInterstressLengthOrderInLine)
            if(nExistingIndex > -1)
            {
                listToReturn[nExistingIndex].ListWords = listToReturn[nExistingIndex].ListWords.concat(line.Words)
                listToReturn[nExistingIndex].Lines.push(line)
            }
            else
            {
                listToReturn.push({Name: sInterstressLengthOrderInLine, Lines: [line], ByLine: true,
                    ListWords: line.Words, Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
            }
        }

        return listToReturn.filter(g => g.Lines.length > 1)
    }

    AverageInterstressLengthPerLineLens(listLinesToUse)
    {
        var listToReturn = []
        for(var line of listLinesToUse)
        {
            let nAverageInterstressLengthForLine = Math.round(line.Words.map(w => this.GetSyllableDistanceToPreviouslyAccentedSyllableForWord(w))
                .reduce((acc, n) => acc + n, 0) / (1.0 * line.Words.length))
                
            let nExistingIndex = listToReturn.findIndex(o => o.N === nAverageInterstressLengthForLine)
            if(nExistingIndex > -1)
            {
                listToReturn[nExistingIndex].ListWords = listToReturn[nExistingIndex].ListWords.concat(line.Words)
                listToReturn[nExistingIndex].Lines.push(line)
            }
            else
            {
                listToReturn.push({Name: nAverageInterstressLengthForLine.toString(), N: nAverageInterstressLengthForLine, 
                    Lines: [line], ByLine: true,
                    ListWords: line.Words, Color: this.GetColorForCadenceSyllableDistance(nAverageInterstressLengthForLine, false)})
            }
        }

        return listToReturn
    }

    FindLineSyllableCountThemesLens(listLinesToUse)
    {
        let nPatternLength = 3
        let dictPatterns = new Map()
        
        for(var nLineStartingPattern = 0; nLineStartingPattern <= listLinesToUse.length - nPatternLength; nLineStartingPattern++)
        {
            let listLinesInPattern = listLinesToUse.slice(nLineStartingPattern, nLineStartingPattern + nPatternLength)
            let sPattern = listLinesInPattern.map(l => l.SyllableCount).join(', ')

            if(dictPatterns.has(sPattern))
            {
                //let listOfListOfLinesInPattern = dictPatterns.get(sPattern)
                dictPatterns.set(sPattern, dictPatterns.get(sPattern).concat(listLinesInPattern))
            }
            else
            {
                dictPatterns.set(sPattern, [listLinesInPattern])
            }
        }

        let listRepeatedPatterns = Array.from(dictPatterns, ([sPattern, listOfListOfLinesInPattern]) => 
            ({Pattern: sPattern, ListOfListOfLinesInPattern: listOfListOfLinesInPattern})).filter(o => o.ListOfListOfLinesInPattern.length > 1)

        console.log(listRepeatedPatterns)

        return listRepeatedPatterns.map((o, n) => {
            let listLinesInPattern = o.ListOfListOfLinesInPattern.flat()
            return {Name: o.Pattern, Lines: listLinesInPattern, ByLine: true, GroupsWithPattern: o.ListOfListOfLinesInPattern.length, 
                ListWords: listLinesInPattern.flatMap(l => l.Words), 
                Color: this.listLinkGroupColors[n % this.listLinkGroupColors.length]}})
    }

    GetNumberOfSyllablesIncreaseChainsForLines(listLinesToUse, sComparisonType, sColor)
    {
        // console.log(listLinesToUse.flatMap(l => l.Words.map(w => w.Transliteration).join(' ')))
        var listToReturn = []
        let nMinChainLength = 3

        for(var nLine1 = 0; nLine1 <= listLinesToUse.length - nMinChainLength; nLine1++)
        {
            let nLastLineInMinimumLengthChain = nLine1 + nMinChainLength - 1
            for(var nLastLineInChain = nLastLineInMinimumLengthChain; nLastLineInChain < listLinesToUse.length; nLastLineInChain++)
            {
                var blnSyllablesCountIsOrdered = true
                for(var nLineInPotentialChain = nLine1 + 1; nLineInPotentialChain <= nLastLineInChain; nLineInPotentialChain++)
                {
                    if(sComparisonType === 'asc')
                    {
                        if(listLinesToUse[nLineInPotentialChain].SyllableCount <= listLinesToUse[nLineInPotentialChain - 1].SyllableCount)
                        {
                            blnSyllablesCountIsOrdered = false
                            break
                        }
                    }
                    else if(sComparisonType === 'desc')
                    {
                        if(listLinesToUse[nLineInPotentialChain].SyllableCount >= listLinesToUse[nLineInPotentialChain - 1].SyllableCount)
                        {
                            blnSyllablesCountIsOrdered = false
                            break
                        }
                    }
                    else
                    {
                        if(listLinesToUse[nLineInPotentialChain].SyllableCount !== listLinesToUse[nLineInPotentialChain - 1].SyllableCount)
                        {
                            blnSyllablesCountIsOrdered = false
                            break
                        }
                    }
                }

                // if(sComparisonType === 'asc')
                // {
                //     console.log(nLine1, listLinesToUse[nLine1].Words.map(w => w.Transliteration).join(' '))
                // }

                // if(nLine1 === 9 && sComparisonType === 'asc')
                // {
                //     console.log(listLinesToUse[nLine1].Words.map(w => w.Transliteration).join(' '), nLastLineInChain, nLastLineInMinimumLengthChain, blnSyllablesCountIsOrdered)
                // }

                let blnLastLineOfChainIsLastLine = nLastLineInChain === listLinesToUse.length - 1
                if(!blnSyllablesCountIsOrdered || blnLastLineOfChainIsLastLine)
                {
                    //nLastLineInChain > nLastLineInMinimumLengthChain means that at least one 
                    //iteration of this loop had blnSyllablesCountIsOrdered === true

                    if(nLastLineInChain > nLastLineInMinimumLengthChain || 
                        (blnSyllablesCountIsOrdered && blnLastLineOfChainIsLastLine))
                    {
                        let blnLastLineException = blnSyllablesCountIsOrdered && blnLastLineOfChainIsLastLine
                        let listLinesInChain = listLinesToUse.slice(nLine1, nLastLineInChain + (blnLastLineException ? 1 : 0))

                        listToReturn.push({Name: listLinesInChain.map(l => l.SyllableCount).join(', '), 
                            Lines: listLinesInChain, ByLine: true, 
                            ListWords: listLinesInChain.flatMap(l => l.Words), 
                            Color: sColor}) //this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]

                        //move the first line to the end of the chain to avoid duplicate chains
                        nLine1 = nLastLineInChain - 1
                        // console.log('changed nLine1 to ' + nLastLineInChain)
                    }

                    break
                }
            }
        }

        // console.log(listToReturn)
        return listToReturn
    }

    LineIsSelah(l)
    {
        return l.Words.length === 1 && l.Words[0].LexicalID === '5937'
    }

    FilterLinesToRemoveSelahLines(listLines)
    {
        //remove lines with just selah
        return listLines.filter(l => !this.LineIsSelah(l))
    }

    NumberOfSyllablesInLineIncreaseOrDecreaseChainsAllLinesLens(listLinesToUse)
    {
        let listLinesToUse2 = this.FilterLinesToRemoveSelahLines(listLinesToUse.filter(l => !l.IsSuperscription))

        return this.GetNumberOfSyllablesIncreaseChainsForLines(listLinesToUse2, 'asc', 'Green').concat(
            this.GetNumberOfSyllablesIncreaseChainsForLines(listLinesToUse2, 'desc', 'Purple')).concat(
            this.GetNumberOfSyllablesIncreaseChainsForLines(listLinesToUse2, 'equal', 'Blue'))
    }

    NumberOfSyllablesInLineIncreaseOrDecreaseChainsLevel1UnitBoundariesLens(listLinesToUse)
    {
        let listLineGroups = this.GetLinesForSideBySideMode(listLinesToUse, 'StartsRepetitionGroup')
        let listFirstLinesInGroups = this.FilterLinesToRemoveSelahLines(listLineGroups.map(oLineGroup => oLineGroup.Lines[0]))
        let listLastLinesInGroups = this.FilterLinesToRemoveSelahLines(listLineGroups.map(oLineGroup => oLineGroup.Lines[oLineGroup.Lines.length - 1]))

        var listToReturn = []

        listToReturn = listToReturn.concat(this.GetNumberOfSyllablesIncreaseChainsForLines(listFirstLinesInGroups))
        listToReturn = listToReturn.concat(this.GetNumberOfSyllablesIncreaseChainsForLines(listLastLinesInGroups))

        return listToReturn
    }

    ChangeInSyllablesPerLineInLastLineOfLevel1UnitLens(listLinesToUse)
    {
        var listLineGroupsForLevel1 = this.GetLinesForSideBySideMode(listLinesToUse, 'StartsRepetitionGroup')

        var listToReturn = [{Name: 'Less',  Lines: [], ByLine: true, ListWords: [], LineGroups: [], Color: 'Purple'},
            {Name: 'Equal', Lines: [], ByLine: true, ListWords: [], LineGroups: [], Color: 'Blue'},
            {Name: 'Greater', Lines: [], ByLine: true, ListWords: [], LineGroups: [], Color: 'Green'}]

        for(var oLineGroup of listLineGroupsForLevel1)
        {
            let listLinesInGroupToUse = this.FilterLinesToRemoveSelahLines(oLineGroup.Lines)
            let nLinesInGroup = listLinesInGroupToUse.length
            if(nLinesInGroup < 2) continue

            let nSyllablesInNextToLastLine = listLinesInGroupToUse[nLinesInGroup - 2].SyllableCount
            let nSyllablesInLastLine = listLinesInGroupToUse[nLinesInGroup - 1].SyllableCount
            
            let nGroupIndex = nSyllablesInLastLine < nSyllablesInNextToLastLine ? 0 :
                nSyllablesInLastLine === nSyllablesInNextToLastLine ? 1 : 2

            listToReturn[nGroupIndex].LineGroups.push(oLineGroup)
            for(var line of listLinesInGroupToUse)
            {
                listToReturn[nGroupIndex].ListWords = listToReturn[nGroupIndex].ListWords.concat(line.Words)
                listToReturn[nGroupIndex].Lines.push(line)
            }
        }

        // console.log(listToReturn)
        return listToReturn
    }

    GetColorForPercent(nPercent, blnLighterVersion)
    {
        //"hsl(0, 100%, 35%)", "hsl(0, 40%, 65%)"
        const listSpectrumColorsDarker = [
            "hsl(0, 100%, 35%)",    // Red
            "hsl(27.7, 100%, 35%)", // Red-orange
            "hsl(55.4, 100%, 35%)", // Orange-yellow
            "hsl(83.1, 100%, 35%)", // Yellow-green
            "hsl(110.8, 100%, 35%)",// Green
            "hsl(138.5, 100%, 35%)",// Green-cyan
            "hsl(166.2, 100%, 35%)",// Cyan
            "hsl(193.9, 100%, 35%)",// Cyan-blue
            "hsl(221.6, 100%, 35%)",// Blue
            "hsl(249.3, 100%, 35%)",// Blue-purple
            "hsl(277, 100%, 35%)",  // Purple
            "hsl(304.7, 100%, 35%)",// Magenta
            "hsl(332.4, 100%, 35%)" // Pink-red
            ]
        
        const listSpectrumColorsLighter = [
                "hsl(0, 40%, 65%)",    // Red
                "hsl(27.7, 40%, 65%)", // Red-orange
                "hsl(55.4, 40%, 65%)", // Orange-yellow
                "hsl(83.1, 40%, 65%)", // Yellow-green
                "hsl(110.8, 40%, 65%)",// Green
                "hsl(138.5, 40%, 65%)",// Green-cyan
                "hsl(166.2, 40%, 65%)",// Cyan
                "hsl(193.9, 40%, 65%)",// Cyan-blue
                "hsl(221.6, 40%, 65%)",// Blue
                "hsl(249.3, 40%, 65%)",// Blue-purple
                "hsl(277, 40%, 65%)",  // Purple
                "hsl(304.7, 40%, 65%)",// Magenta
                "hsl(332.4, 40%, 65%)" // Pink-red
            ]

        let listSpectrumColors = blnLighterVersion ? listSpectrumColorsLighter : listSpectrumColorsDarker

        return nPercent < 0.07 ? 'DarkGray' : 
            nPercent < 0.14 ? listSpectrumColors[2] :
            nPercent < 0.21 ? listSpectrumColors[3] :
            nPercent < 0.28 ? listSpectrumColors[4] :
            nPercent < 0.35 ? listSpectrumColors[5] :
            nPercent < 0.42 ? listSpectrumColors[6] : 
            nPercent < 0.49 ? listSpectrumColors[7] : 
            nPercent < 0.56 ? listSpectrumColors[8] : 
            nPercent < 0.63 ? listSpectrumColors[9] : 
            nPercent < 0.7 ? listSpectrumColors[10] : 
            nPercent < 0.77 ? listSpectrumColors[11] : 
            nPercent < 0.84 ? listSpectrumColors[12] : 
            nPercent < 0.91 ? listSpectrumColors[0] : listSpectrumColors[1] 
    }

    GetColorForLinksInLineCount(nLinksInLine, blnLighterVersion)
    {
        let blnRhymeLinksInLineVersion = true

        const listSpectrumColorsDarker = [
            "hsl(0, 100%, 35%)",    // Red
            "hsl(27.7, 100%, 35%)", // Red-orange
            "hsl(55.4, 100%, 35%)", // Orange-yellow
            "hsl(83.1, 100%, 35%)", // Yellow-green
            "hsl(110.8, 100%, 35%)",// Green
            "hsl(138.5, 100%, 35%)",// Green-cyan
            "hsl(166.2, 100%, 35%)",// Cyan
            "hsl(193.9, 100%, 35%)",// Cyan-blue
            "hsl(221.6, 100%, 35%)",// Blue
            "hsl(249.3, 100%, 35%)",// Blue-purple
            "hsl(277, 100%, 35%)",  // Purple
            "hsl(304.7, 100%, 35%)",// Magenta
            "hsl(332.4, 100%, 35%)" // Pink-red
            ]
        
        const listSpectrumColorsLighter = [
                "hsl(0, 40%, 65%)",    // Red
                "hsl(27.7, 40%, 65%)", // Red-orange
                "hsl(55.4, 40%, 65%)", // Orange-yellow
                "hsl(83.1, 40%, 65%)", // Yellow-green
                "hsl(110.8, 40%, 65%)",// Green
                "hsl(138.5, 40%, 65%)",// Green-cyan
                "hsl(166.2, 40%, 65%)",// Cyan
                "hsl(193.9, 40%, 65%)",// Cyan-blue
                "hsl(221.6, 40%, 65%)",// Blue
                "hsl(249.3, 40%, 65%)",// Blue-purple
                "hsl(277, 40%, 65%)",  // Purple
                "hsl(304.7, 40%, 65%)",// Magenta
                "hsl(332.4, 40%, 65%)" // Pink-red
            ]

        let listSpectrumColors = blnLighterVersion ? listSpectrumColorsLighter : listSpectrumColorsDarker

        if(blnRhymeLinksInLineVersion)
        {
            return nLinksInLine === 0 ? 'DarkGray' : 
            nLinksInLine === 1 ? listSpectrumColors[2] :
            nLinksInLine === 2 ? listSpectrumColors[5] :
            nLinksInLine === 3 ? listSpectrumColors[8] :
            nLinksInLine === 4 ? listSpectrumColors[10] :
            nLinksInLine === 5 ? listSpectrumColors[0] : listSpectrumColors[1]
        }
        else
        {
            return nLinksInLine === 0 ? 'DarkGray' : 
                nLinksInLine === 1 ? listSpectrumColors[2] :
                nLinksInLine === 2 ? listSpectrumColors[3] :
                nLinksInLine === 3 ? listSpectrumColors[4] :
                nLinksInLine === 4 ? listSpectrumColors[5] :
                nLinksInLine === 5 ? listSpectrumColors[6] : 
                nLinksInLine === 6 ? listSpectrumColors[7] : 
                nLinksInLine === 7 ? listSpectrumColors[8] : 
                nLinksInLine === 8 ? listSpectrumColors[9] : 
                nLinksInLine === 9 ? listSpectrumColors[10] : 
                nLinksInLine === 10 ? listSpectrumColors[11] : 
                nLinksInLine === 11 ? listSpectrumColors[12] : 
                nLinksInLine === 12 ? listSpectrumColors[0] : listSpectrumColors[1]
        }
    }

    GetColorForLineSyllableCount(nSyllables, blnLighterVersion)
    {
        // return nSyllables < 4 ? 'DarkGray' : 
        //     nSyllables < 5 ? 'DarkGreen' :
        //     nSyllables < 6 ? 'DarkCyan' :
        //     nSyllables < 7 ? 'DarkBlue' :
        //     nSyllables < 8 ? 'Purple' :
        //     nSyllables < 9 ? 'Red' : 
        //     nSyllables < 10 ? 'DarkGoldenrod' : 
        //     nSyllables < 11 ? 'Green' : 
        //     nSyllables < 12 ? 'LightSeaGreen' : 
        //     nSyllables < 13 ? 'CornflowerBlue' : 
        //     nSyllables < 14 ? 'Fuchsia' : 
        //     nSyllables < 15 ? 'LightCoral' : 
        //     nSyllables < 16 ? 'Orange' : 'Olive'

        const listSpectrumColorsDarker = [
            "hsl(0, 100%, 35%)",    // Red
            "hsl(27.7, 100%, 35%)", // Red-orange
            "hsl(55.4, 100%, 35%)", // Orange-yellow
            "hsl(83.1, 100%, 35%)", // Yellow-green
            "hsl(110.8, 100%, 35%)",// Green
            "hsl(138.5, 100%, 35%)",// Green-cyan
            "hsl(166.2, 100%, 35%)",// Cyan
            "hsl(193.9, 100%, 35%)",// Cyan-blue
            "hsl(221.6, 100%, 35%)",// Blue
            "hsl(249.3, 100%, 35%)",// Blue-purple
            "hsl(277, 100%, 35%)",  // Purple
            "hsl(304.7, 100%, 35%)",// Magenta
            "hsl(332.4, 100%, 35%)" // Pink-red
            ]
        
        const listSpectrumColorsLighter = [
                "hsl(0, 40%, 65%)",    // Red
                "hsl(27.7, 40%, 65%)", // Red-orange
                "hsl(55.4, 40%, 65%)", // Orange-yellow
                "hsl(83.1, 40%, 65%)", // Yellow-green
                "hsl(110.8, 40%, 65%)",// Green
                "hsl(138.5, 40%, 65%)",// Green-cyan
                "hsl(166.2, 40%, 65%)",// Cyan
                "hsl(193.9, 40%, 65%)",// Cyan-blue
                "hsl(221.6, 40%, 65%)",// Blue
                "hsl(249.3, 40%, 65%)",// Blue-purple
                "hsl(277, 40%, 65%)",  // Purple
                "hsl(304.7, 40%, 65%)",// Magenta
                "hsl(332.4, 40%, 65%)" // Pink-red
            ]

        let listSpectrumColors = blnLighterVersion ? listSpectrumColorsLighter : listSpectrumColorsDarker

        return nSyllables < 4 ? 'DarkGray' : 
            nSyllables < 5 ? listSpectrumColors[2] :
            nSyllables < 6 ? listSpectrumColors[3] :
            nSyllables < 7 ? listSpectrumColors[4] :
            nSyllables < 8 ? listSpectrumColors[5] :
            nSyllables < 9 ? listSpectrumColors[6] : 
            nSyllables < 10 ? listSpectrumColors[7] : 
            nSyllables < 11 ? listSpectrumColors[8] : 
            nSyllables < 12 ? listSpectrumColors[9] : 
            nSyllables < 13 ? listSpectrumColors[10] : 
            nSyllables < 14 ? listSpectrumColors[11] : 
            nSyllables < 15 ? listSpectrumColors[12] : 
            nSyllables < 16 ? listSpectrumColors[0] : listSpectrumColors[1] 
    }

    NumberOfSyllablesInLineLens(listLinesToUse)
    {
        var listToReturn = []
        for(var line of listLinesToUse)
        {
            let nSyllables = line.SyllableCount
            let nExistingIndex = listToReturn.findIndex(o => o.N === nSyllables)

            if(nExistingIndex > -1)
            {
                listToReturn[nExistingIndex].ListWords = listToReturn[nExistingIndex].ListWords.concat(line.Words)
                listToReturn[nExistingIndex].Lines.push(line)
            }
            else
            {
                listToReturn.push({Name: nSyllables.toString(), N: nSyllables, 
                    Lines: [line], ByLine: true, ListWords: line.Words, Color: this.GetColorForLineSyllableCount(nSyllables, false)})
            }
        }

        return listToReturn
    }

    NumberOfWordsInLineLens(listLinesToUse)
    {
        var listToReturn = []
        for(var line of listLinesToUse)
        {
            let nWordsInLine = line.Words.length
            let nExistingIndex = listToReturn.findIndex(o => o.N === nWordsInLine)

            if(nExistingIndex > -1)
            {
                listToReturn[nExistingIndex].ListWords = listToReturn[nExistingIndex].ListWords.concat(line.Words)
                listToReturn[nExistingIndex].Lines.push(line)
            }
            else
            {
                listToReturn.push({Name: nWordsInLine.toString(), N: nWordsInLine, 
                    Lines: [line], ByLine: true, ListWords: line.Words, Color: this.GetColorForLineSyllableCount(nWordsInLine, false)})
            }
        }

        return listToReturn
    }

    NumberOfFullAccentsInLineLens(listLinesToUse)
    {
        var listToReturn = []
        for(var line of listLinesToUse)
        {
            let nWordsWithFullAccent = line.Words.filter(w => w.HasFullAccent).length
            let nExistingIndex = listToReturn.findIndex(o => o.N === nWordsWithFullAccent)

            if(nExistingIndex > -1)
            {
                listToReturn[nExistingIndex].ListWords = listToReturn[nExistingIndex].ListWords.concat(line.Words)
                listToReturn[nExistingIndex].Lines.push(line)
            }
            else
            {
                let sGroupColor = nWordsWithFullAccent < 2 ? 'DarkGray' : 
                    nWordsWithFullAccent === 2 ? 'Green' :
                    nWordsWithFullAccent === 3 ? 'Blue' :
                    nWordsWithFullAccent === 4 ? 'Purple' :
                    nWordsWithFullAccent === 5 ? 'Red' : 'Orange'

                listToReturn.push({Name: nWordsWithFullAccent.toString(), N: nWordsWithFullAccent, 
                    Lines: [line], ByLine: true, ListWords: line.Words, Color: sGroupColor})
            }
        }

        return listToReturn
    }

    NumberOfPenultimateAccentsInLineLens(listLinesToUse)
    {
        var listToReturn = []
        for(var line of listLinesToUse)
        {
            let nWordsWithPenultimateAccent = line.Words.filter(w => w.HasPenultimateAccent).length
            let nExistingIndex = listToReturn.findIndex(o => o.N === nWordsWithPenultimateAccent)

            if(nExistingIndex > -1)
            {
                listToReturn[nExistingIndex].ListWords = listToReturn[nExistingIndex].ListWords.concat(line.Words)
                listToReturn[nExistingIndex].Lines.push(line)
            }
            else
            {
                let sGroupColor = nWordsWithPenultimateAccent === 0 ? 'DarkGray' : 
                    nWordsWithPenultimateAccent === 1 ? 'Green' :
                    nWordsWithPenultimateAccent === 2 ? 'Blue' :
                    nWordsWithPenultimateAccent === 3 ? 'Purple' :
                    nWordsWithPenultimateAccent === 4 ? 'Red' : 'Orange'

                listToReturn.push({Name: nWordsWithPenultimateAccent.toString(), N: nWordsWithPenultimateAccent, 
                    Lines: [line], ByLine: true, ListWords: line.Words, Color: sGroupColor})
            }
        }

        return listToReturn
    }

    RepeatedRootMinimumDifferenceLens(listTextWordsToUse, listLinesTouse)
    {
        // for each word that is a repeated root in the psalm, color code the minimum number of differences, comparing each pair. Extend this to repeated synonyms/same semantic domain?
        // This is to find where there is direct repetition to see what possible structural functions direct repetition has.

        var listToReturn = [];

        //var listLexicalIDsForRepeatedWords = this.RepeatedWordsLens().flatMap(g => g.ListWords.map(w => w.LexicalID));
        var groupedByLexicalID = this.GroupArrayByKey(listTextWordsToUse, "LexicalID");
        for(var k of Object.keys(groupedByLexicalID))
        {
            var listInstancesOfWord = groupedByLexicalID[k].filter(w => ['N', 'V', 'A'].includes(w.WordType) && !['3270'].includes(w.LexicalID))
            if(listInstancesOfWord.length > 1)
            {
                var sTextOfAllInstances = listInstancesOfWord.map(w1 => w1.FullText).join(' ')
                var nMinDifferenceScoreSoFar = 10000

                for(var w1 of listInstancesOfWord)
                {
                    w1.InfoForRepLens = sTextOfAllInstances
                    for(var w2 of listInstancesOfWord)
                    {
                        if(w1 === w2) continue

                        var calcs = this.CalculateRepetitionLinkGroupCategoriesFromWords([w1, w2], listLinesTouse, false, true)
                        var nCompareGroups = calcs.ComparisonsAndCalculationsByWordType.length
                        var nDifferenceScore = (calcs.ComparisonsAndCalculationsByWordType.map(c2 => c2.Different.length).reduce((acc, n) => acc + n, 0) / (1.0 * nCompareGroups)) + 
                            (calcs.DifferentPolarity ? 1 : 0) + ((calcs.ConstructToSingleNoun || calcs.SingleNounToConstruct) ? 1 : 0)

                        if(nDifferenceScore < nMinDifferenceScoreSoFar) nMinDifferenceScoreSoFar = nDifferenceScore
                    }
                }

                var nScore = nMinDifferenceScoreSoFar
                var sColor = nScore < 1 ? "Black" : 
                    nScore < 2 ? "Purple" : 
                    nScore < 3 ? "Red" : 
                    nScore < 4 ? "Orange" : 
                    nScore < 5 ? "Green" : 
                    nScore < 6 ? "Gray" : "LightGray"

                listToReturn.push({ListWords: listInstancesOfWord, Color: sColor})
            }
        }
        
        return listToReturn;
    }
    
    RepeatedRootNumberOfRepeatsLens(listTextWordsToUse)
    {
        // for each word that is a repeated root in the psalm, color code the number of times it occurs

        var listToReturn = [];

        //var listLexicalIDsForRepeatedWords = this.RepeatedWordsLens().flatMap(g => g.ListWords.map(w => w.LexicalID));
        var groupedByLexicalID = this.GroupArrayByKey(listTextWordsToUse, "LexicalID");
        for(var k of Object.keys(groupedByLexicalID))
        {
            var listInstancesOfWord = groupedByLexicalID[k].filter(w => ['N', 'V', 'A'].includes(w.WordType) && !['3270'].includes(w.LexicalID))
            if(listInstancesOfWord.length > 1)
            {
                var sTextOfAllInstances = listInstancesOfWord.map(w1 => w1.FullText).join(' ')
                listInstancesOfWord.forEach(w1 => w1.InfoForRepLens = sTextOfAllInstances)

                var nScore = listInstancesOfWord.length
                var sColor = nScore > 9 ? "Black" : 
                    nScore > 7 ? "Purple" : 
                    nScore > 4 ? "Red" : 
                    nScore > 2 ? "Orange" : "Green"

                listToReturn.push({ListWords: listInstancesOfWord, Color: sColor})
            }
        }
        
        return listToReturn;
    }

    RepeatedRootMaxDistanceLens(listTextWordsToUse)
    {
        // for each word that is a repeated root in the psalm, color code the maximum distance between occurrences
        var listToReturn = [];
        var groupedByLexicalID = this.GroupArrayByKey(listTextWordsToUse, "LexicalID");
        for(var k of Object.keys(groupedByLexicalID))
        {
            var listInstancesOfWord = groupedByLexicalID[k].filter(w => ['N', 'V', 'A'].includes(w.WordType) && !['3270'].includes(w.LexicalID))
            if(listInstancesOfWord.length > 1)
            {
                var listTextIndexesOfAllInstances = listInstancesOfWord.map(w1 => parseInt(w1.TextIndex))
                var nMaxDistance = Math.max(...listTextIndexesOfAllInstances) - Math.min(...listTextIndexesOfAllInstances)

                var sTextOfAllInstances = listInstancesOfWord.map(w1 => w1.FullText).join(' ')
                listInstancesOfWord.forEach(w1 => w1.InfoForRepLens = sTextOfAllInstances)

                var nScore = nMaxDistance / (1.0 * listTextWordsToUse.length)
                var sColor = nScore > 0.8 ? "Black" : 
                    nScore > 0.6 ? "Purple" : 
                    nScore > 0.4 ? "Red" : 
                    nScore > 0.2 ? "Orange" : 
                    nScore > 0.1 ? "Green" : "Blue"

                listToReturn.push({ListWords: listInstancesOfWord, Color: sColor})
            }
        }
        
        return listToReturn;
    }

    LocalDensityLens(sType)
    {
        var listToReturn = []
        var listConsonantToExclude = ['ה', 'ו', 'י', 'ו']
        var blnClusters = false

        for(var nLine = 0; nLine < this.state.listLines.length; nLine++)
        {
            var oLine = this.state.listLines[nLine]
            var listWordsInLine = oLine.Words
            var listWordsToCompare = listWordsInLine //.map(w => w)
            // console.log(this.GetRepetitionGroupClusterForLine(oLine))

            if(blnClusters)
            {
                var lineGroupToCompare = this.state.sGroupLinesBy === 'StartsRepetitionGroup' ? this.GetRepetitionGroupForLine(oLine) :
                    this.state.sGroupLinesBy === 'StartsCluster' ? this.GetRepetitionGroupClusterForLine(oLine) : 
                    this.GetRepetitionGroupClusterGroupForLine(oLine)

                if(lineGroupToCompare != undefined)
                {
                    listWordsToCompare = lineGroupToCompare.Lines.flatMap(l => l.Words)
                }
            }
            else
            {
                if(nLine > 0) listWordsToCompare = listWordsToCompare.concat(this.state.listLines[nLine - 1].Words)
                if(nLine < this.state.listLines.length - 1) listWordsToCompare = listWordsToCompare.concat(this.state.listLines[nLine + 1].Words)
            }

            for(var w1 of listWordsInLine)
            {
                var listWordsInGroup = [w1]
                var sColor = ''

                if(sType === 'alliteration')
                {
                    var sInitialConsonant1 = this.GetGroupedConsonantsInWord(w1.FullText, listConsonantToExclude)[0]
                    for(var w2 of listWordsToCompare)
                    {
                        if(w1 === w2) continue
                        var sInitialConsonant2 = this.GetGroupedConsonantsInWord(w2.FullText, listConsonantToExclude)[0]
                        if(sInitialConsonant1 === sInitialConsonant2) listWordsInGroup.push(w2)
                    }

                    // console.log(listWordsInGroup)
                    var nScore = listWordsInGroup.length === 1 ? 0 : ((listWordsInGroup.length / listWordsToCompare.length) * 14)
                    sColor = nScore < 2 ? "LightGray" : 
                        nScore < 3 ? "Green" : 
                        nScore < 4 ? "Orange" : 
                        nScore < 5 ? "Red" : 
                        nScore < 6 ? "Purple" : "Black"
                }
                else if(sType === 'composite_similarity')
                {
                    for(var w2 of listWordsToCompare)
                    {
                        if(w1 === w2) continue
                        var nTotalScore = this.GetAllSimilarityAmountScore(w1, w2).Score
                        // console.log(w1.TextIndex + ' ' + w2.TextIndex)
                        // if(w1.TextIndex === '37') console.log(w2)
                        if(nTotalScore > 0) listWordsInGroup.push(w2)
                    }

                    var nScore = listWordsInGroup.length === 1 ? 0 : ((listWordsInGroup.length / listWordsToCompare.length) * 14)
                    sColor = nScore < 2 ? "LightGray" : 
                        nScore < 3 ? "Green" : 
                        nScore < 4 ? "Orange" : 
                        nScore < 5 ? "Red" : 
                        nScore < 6 ? "Purple" : "Black"
                }

                listToReturn.push({ListWords: listWordsInGroup, Color: sColor})
            }

            // var initialConsonantGrouping = this.GroupArray(listWordsToCompare.map(w => this.GetGroupedConsonantsInWord(w.FullText, listConsonantToExclude)[0]))
            // console.log(initialConsonantGrouping)

            // for(var w of listWordsInLine)
            // {
            //     var sInitialConsonantForThisWord = this.GetGroupedConsonantsInWord(w.FullText, listConsonantToExclude)[0]
            //     // console.log(initialConsonantGrouping[sInitialConsonantForThisWord])
            //     var nScore = initialConsonantGrouping[sInitialConsonantForThisWord].length
            //     var sColor = nScore < 1 ? "LightGray" : 
            //         nScore < 2 ? "Gray" : 
            //         nScore < 3 ? "Green" : 
            //         nScore < 4 ? "Orange" : 
            //         nScore < 5 ? "Red" : 
            //         nScore < 6 ? "Purple" : "Black"

            //     var oExistingGroup = listToReturn.find(o => o.Color === sColor)
            //     if(oExistingGroup === undefined) listToReturn.push({ListWords: [w], Color: sColor})
            //     else oExistingGroup.ListWords.push(w)
            // }
        }

        return listToReturn
    }

    MostLikelyReiterationsLens()
    {
        var listToReturn = []
        var nMaxToFind = 3

        for(var w1 of this.listTextWordsForChapter)
        {
            if(listToReturn.some(o => o.ListWords.includes(w1))) continue

            var listReiterations = []
            var listOtherWords = this.listTextWordsForChapter.filter(w2 => w2 != w1)
            
            var listRepeatedRoots = listOtherWords.filter(w2 => w2.ParentRoot === w1.ParentRoot && w1.ParentRoot != '')
            if(listRepeatedRoots.length > 0) listReiterations = listRepeatedRoots

            if(listReiterations.length === 0)
            {
                var listForAllSimilarity = listOtherWords.map(w2 => ({Word: w2, Score: this.GetAllSimilarityAmountScore(w1, w2).Score})).
                    filter(o => o.Score > 5).sort((a,b) => b.Score - a.Score).map(o => o.Word)
                
                if(listForAllSimilarity.length > 0) listReiterations = listForAllSimilarity.slice(0, Math.min(listForAllSimilarity.length, nMaxToFind))
            }

            if(listReiterations.length === 0)
            {
                var listForRhyme = listOtherWords.map(w2 => ({Word: w2, Score: this.CalculateWordRhyme(w1.FullText, w2.FullText, false)})).
             filter(o => o.Score >= 5).sort((a,b) => b.Score - a.Score).map(o => o.Word)
                
                if(listForRhyme.length > 0) listReiterations = listForRhyme.slice(0, Math.min(listForRhyme.length, nMaxToFind))
            }

            if(listReiterations.length > 0)
                listToReturn.push({ListWords: listReiterations.concat([w1]), Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
        }

        // console.log(listToReturn.filter(o => o.ListWords.some(w => w.TextIndex === '26')))
        return listToReturn
    }

    GetAllSimilarityColorFromScore(nScore)
    {
        return nScore < 1 ? "LightGray" : 
            nScore < 2 ? "#239b56" : // #239b56 
            nScore < 3 ? "CornflowerBlue" : //"#ca6f1e" : 
            // nScore < 3 ? "Blue" : "hsl(43, 80%, 40%)"
            nScore < 4 ? "Red" : 
            nScore < 5 ? "Purple" : "Black"
    }

    GetAllSimilarityAmountScoreNew(w1, w2)
    {
        //{"A": "19573", "L": [{"B": "19576", "N": 8.5, "S": "suffix pgn root emotion stem form"}, {"B": "19584", "N": 6.5, "S": "root emotion stem"}
        var oForA = this.listAllSimilarityPairsForChapter.find(o => o.A === w1.TextIndex)
        var oForB = oForA === undefined ? undefined : oForA.L.find(o => o.B === w2.TextIndex)
        return oForB === undefined ? {Score: 0, ListSimilarities: '', Color: 'LightGray'} : 
            {Score: oForB.N, ListSimilarities: oForB.S, Color: this.GetAllSimilarityColorFromScore(oForB.N)}
    }

    GetAllSimilarityAmountColorForLines(l1, l2)
    {
        if(l1 === undefined || l2 === undefined) return 'LightGray'

        var listOfSimilarities = []
        var nScore = 0
        
        for(var w1 of l1.Words)
        {
            for(var w2 of l2.Words)
            {
                nScore += this.GetAllSimilarityAmountScoreNew(w1, w2).Score
            }
        }

        return nScore < 2.3 ? "LightGray" : 
            nScore < 4.6 ? "#239b56" : // #239b56 
            nScore < 7 ? "CornflowerBlue" : //"#ca6f1e" : 
            // nScore < 7 ? "Blue" : "hsl(43, 80%, 40%)"
            nScore < 9.2 ? "Red" : 
            nScore < 11.5 ? "Purple" : "Black"
    }

    GetMinTextIndex(listWords)
    {
        return Math.min(...listWords.map(w => parseInt(w.TextIndex)))
    }

    GetMaxTextIndex(listWords)
    {
        return Math.max(...listWords.map(w => parseInt(w.TextIndex)))
    }

    GetPropertyForWord(w, sProperty)
    {
        if(sProperty === 'preposition')
        {
            return w.Preposition
        }
        else if(sProperty === 'waw')
        {
            return w.Waw === '1'
        }
        else if(sProperty === 'suffix')
        {
            return this.GetSuffixPGN(w)
        }
        else if(sProperty === 'pgn')
        {
            return this.GetPGN(w)
        }
        else if(sProperty === 'pn')
        {
            return this.GetPN(w)
        }
        else if(sProperty === 'article')
        {
            return w.DefiniteArticle === '1'
        }
        else if(sProperty === 'mappiq')
        {
            return this.WordHasDageshHazaqOrMappiq(w)
        }
        else if(sProperty === 'interrogative')
        {
            return this.WordIsInterrogative(w)
        }
        else if(sProperty === 'specialsuffix')
        {
            return ['n', 'h', 'd'].includes(w.SuffixType)
        }
        else if(sProperty === 'construct')
        {
            return this.WordSatisfiesConstructStateLensCriteria(w)
        }
        else if(sProperty === 'root')
        {
            return w.ParentRoot
        }
        else if(sProperty === 'maqaf')
        {
            return w.FullText.includes('־')
        }
        else if(sProperty === 'vocative')
        {
            return w.phrase_function === 'Voct'
        }
        else if(sProperty === 'wordtype')
        {
            return ['P', 'D', 'C', 'R'].includes(w.WordType) ? w.WordType : undefined
        }
        else if(sProperty === 'particletype')
        {
            return this.GetParticleType(w)
        }
        else if(sProperty === 'stem')
        {
            return w.Stem
        }
        else if(sProperty === 'form')
        {
            return w.Form
        }
        else if(sProperty === 'case')
        {
            return w.Case
        }
        else if(sProperty === 'mood')
        {
            return w.Mood
        }
        else if(sProperty === 'tense')
        {
            return w.Tense
        }
        else if(sProperty === 'combinedform')
        {
            return (w.Form === 'r' || w.Form === 's') ? 'participle' :
                (w.Form === 'q' || w.Form === 'w') ? 'sequential' :
                (w.Form === 'h' || w.Form === 'v' || w.Form === 'j') ? 'imperative-like' :
                w.Form
        }
        else if(sProperty === 'semanticdomains')
        {
            return w.BSGs.map(nsg => 'bsg_' + this.listBSGs.find(oBSG => oBSG.ID === nsg).GroupName).concat(
                this.listMainSemanticDomains.filter(g => g.LexicalIDs.includes(w.LexicalID)).map(o => 'main_' + o.Name)).concat(
                this.listSDBH.filter(o => o.ListWords.includes(parseInt(w.TextIndex)) && o.Name != '').map(o => 'sdbh_' + o.Name))
        }
        // else if(sProperty === 'consonants')
        // {
        //     return [...new Set(this.GetGroupedConsonantsInWord(w.FullText, []))]
        // }
        // else if(sProperty === 'vowels')
        // {
        //     return [...new Set(this.CalculateVowelSequence(w.FullText))]
        // }
        // else if(sProperty === 'consonantsequences')
        // {
        //     return 
        // }
        // else if(sProperty === 'vowelsequences')
        // {
        //     return 
        // }
        

        return undefined
    }

    GetAllSimilarityAmountScoresForChapterBasedOnRarity()
    {
        var nMaximumScore = 5
        var nMaximumScorePerProperty = 1

        //find all common properties between the two words, like waw + form_participle + stem_niphal + semanticdomain_perception
        //find all other occurrences of that property combination within the chapter
        //(but how to deal with words that have all the combination except what they can't have 
        //because of wordtype (verb-only properties; probably the maximum of the different sub-combinations...)
        //count them and subtract it from some maximum score (linear or exponential curve?)
        //add to the score for each feature that shows intentional patterning like all occurrences are in one cluster?
        //perhaps have an experimental version that adds position in line and position (beginning, middle, end) in higher groups, 
        //like semanticdomain_emotion + lineposition_1 + stanza_beginning?

        //note - before running this, make sure that allpsalmschapters.json is up to date by running this Python code:
        //listAllWordsInPsalms = []
        // sHebrewDataPath = 'C:/Users/Jason Sommerlad/Documents/psalms project/dev/web/my-app/public/HebrewTextData/'
        // for sFilename in [f for f in os.listdir(sHebrewDataPath) if f.startswith('19_') and f.endswith('.json')]:
        //     with open(sHebrewDataPath + sFilename, mode='r', encoding='utf-8') as hebtextfile:
        //         hebrewTextData = json.loads(hebtextfile.read())
        //     for w in hebrewTextData['OSHB']:
        //         listAllWordsInPsalms.append(w)
        // with open('C:/Users/Jason Sommerlad/Documents/psalms project/dev/web/my-app/public/HebrewTextData/allpsalmschapters.json', mode='w') as allHebrewFile:
        //     allHebrewFile.write(json.dumps({'OSHB': listAllWordsInPsalms}))

        //also make sure alllines is up to date
        
        console.log('ERROR: need to comment back in alllines.json and put it in the src folder!')
        var listLinesForAllChapters = [] //require('./alllines.json').Lines

        var listWordPairsByChapter = []
        var listLinePairsByChapter = []
        var listStanzaPairsByChapter = []

        fetch("HebrewTextData/allchapters.json") //allpsalmschapters.json
        .then(res => res.json())
        .then(data => 
        {
            this.listTextWordsForAllChapters = data.OSHB

            var textWordsByBook = this.GroupArrayByKey(this.listTextWordsForAllChapters, "Book")
            for(var sBookToDo of Object.keys(textWordsByBook))
            {						
                if(sBookToDo != '19') continue
                console.log('Book: ' + sBookToDo)

                var textWordsByChapter = this.GroupArrayByKey(textWordsByBook[sBookToDo], "Chapter");
                for(var sChapterToDo of Object.keys(textWordsByChapter)) //.slice(0, 10)
                {						
                    if(sChapterToDo != '18') continue
                    // if(parseInt(sChapterToDo) <= 130 || parseInt(sChapterToDo) > 151) continue
                    console.log(sChapterToDo)

                    var blnThisChapterIsHebrew = parseInt(sBookToDo) < 40

                    var listPropertiesToCheck = !blnThisChapterIsHebrew ? ['pn', 'case', 'mood', 'tense', 'root', 'wordtype'] :
                        ['preposition', 'suffix', 'pgn', 'article', 'stem', 'combinedform', 'waw',
                        'mappiq', 'interrogative', 'specialsuffix', 'construct', 'root', 'maqaf', 'vocative', 'wordtype', 'particletype']

                        //'suffixrefs', 'semanticdomains', 'consonants', 'vowels', 'consonantsequences', 'vowelsequences'] //(sequences can also be reversed)
                    
                    var propertySpecificFactors = !blnThisChapterIsHebrew ? {'pn': 1, 'case': 1, 'mood': 1, 'tense': 1, 'root': 5, 'wordtype': 2} : 
                        {'preposition': 1, 'suffix': 1, 'pgn': 1, 'article': 1, 'stem': 1, 'combinedform': 1, 'waw': 1,
                        'mappiq': 1, 'interrogative': 2, 'specialsuffix': 2, 'construct': 1, 'root': 5, 'maqaf': 1, 'vocative': 1, 'wordtype': 3, 'particletype': 2}

                    var listWordPairsForChapter = []
                    var listWordsInChapter = textWordsByChapter[sChapterToDo]

                    if(!blnThisChapterIsHebrew)
                    {
                        //filter out things like the article
                        var listLexicalIDsToFilterOut = ['3588']
                        listWordsInChapter = listWordsInChapter.filter(w => !listLexicalIDsToFilterOut.includes(w.LexicalID))
                    }

                    for(var w of listWordsInChapter)
                    {
                        var listPropertiesForWord = []
                        for(var sp of listPropertiesToCheck)
                        {
                            var sOrList = this.GetPropertyForWord(w, sp)
                            if(Array.isArray(sOrList))
                            {
                                for(var sps of sOrList)
                                {
                                    if(sps != undefined && sps != '') listPropertiesForWord.push(sp + '_' + sps)   
                                }
                            }
                            else if(sOrList != undefined && sOrList != '') listPropertiesForWord.push(sp + '_' + sOrList)
                        }

                        w.Properties = listPropertiesForWord
                    }

                    var dictRarityFactorByProperty = new Map()
                    for(var sp of [...new Set(listWordsInChapter.flatMap(w => w.Properties))])
                    {
                        var sPropertyName = sp.split('_')[0]
                        var nOccs = listWordsInChapter.filter(wc => wc.Properties.includes(sp)).length
                        var nWordsCompatibleWithProperty = listWordsInChapter.filter(wc => wc.Properties.some(sp2 => sp2.split('_')[0] === sPropertyName)).length
                        dictRarityFactorByProperty.set(sp, propertySpecificFactors[sPropertyName] * (1 - (nOccs / (1.0 * nWordsCompatibleWithProperty))))
                    }

                    var dictRarityFactorByConsonant = new Map()
                    // for(var c of this.GetConsonantGroupsToUse().map(g => g.Name))
                    // {
                    //     var nOccs = listWordsInChapter.filter(w => this.GetGroupedConsonantsInWord(w.FullText, []).includes(c)).length
                    //     dictRarityFactorByConsonant.set(c, 1 - ((1.5 * nOccs) / (1.0 * listWordsInChapter.length)))
                    // }

                    // console.log(listWordsInChapter.find(w => w.TextIndex === '228'))
                    // console.log(dictRarityFactorByConsonant)
                    // console.log([...new Set(listWordsInChapter.flatMap(w => w.Properties))])
                    // console.log(dictRarityFactorByProperty) //.filter((value, key) => isNaN(value)))

                    var listWordPairsForChapter = []
                    for(var w1 of listWordsInChapter)
                    {
                        var listForA = []
                        for(var w2 of listWordsInChapter)
                        {
                            if(w1 != w2)
                            {
                                var nScore =  0
                                var listPropertiesInCommon = []

                                if(w1.FullText === w2.FullText)
                                {
                                    nScore = nMaximumScore
                                    listPropertiesInCommon = ['fulltext']
                                }
                                else
                                {
                                    listPropertiesInCommon = w1.Properties.filter(sp => w2.Properties.includes(sp))

                                    var blnRootInCommon = listPropertiesInCommon.some(sp => sp.startsWith('root_'))
                                    if(blnRootInCommon)
                                    {
                                        //remove properties that generally will correlate with root
                                        var listIndexesToRemove = listPropertiesInCommon.map((sp, n) => ({SP: sp, N: n})).
                                            filter(osp => osp.SP.startsWith('wordtype_') || osp.SP.startsWith('particletype_')).map(osp => osp.N)
                                        
                                        listIndexesToRemove.forEach(nsp => listPropertiesInCommon.splice(nsp, 1))
                                    }

                                    nScore = listPropertiesInCommon.map(sp => nMaximumScorePerProperty * dictRarityFactorByProperty.get(sp)).reduce((acc, n) => acc + n, 0)

                                    // if(w1.TextIndex === '7822' && w2.TextIndex === '7860') console.log(listPropertiesInCommon, listPropertiesInCommon.map(sp => nMaximumScorePerProperty * dictRarityFactorByProperty.get(sp)))

                                    if((w1.RefsG != undefined && w1.RefsG.includes(w2.TextIndex)) || 
                                       (w2.RefsG != undefined && w2.RefsG.includes(w1.TextIndex)))
                                    {
                                        nScore += 2
                                        listPropertiesInCommon.push('suffixref')
                                    }

                                    //if the root is the same, it will rhyme and likely have the same semantic domains, so don't double count it
                                    if(!blnRootInCommon)
                                    {
                                        var listBSGsInCommon = []
                                        if(w1.BSGs != undefined && w2.BSGs != undefined) listBSGsInCommon = w1.BSGs.filter(nsg => w2.BSGs.includes(nsg)).map(nsg => this.listBSGs.find(oBSG => oBSG.ID === nsg).GroupName)

                                        var blnLNInCommon = blnThisChapterIsHebrew ? false : w1.LN === w2.LN
                                        var listMainGroupsInCommon = !blnThisChapterIsHebrew ? [] : this.listMainSemanticDomains.filter(g => g.LexicalIDs.includes(w1.LexicalID) && g.LexicalIDs.includes(w2.LexicalID)).map(o => o.Name)
                                        var listSDBHGroupsInCommon = !blnThisChapterIsHebrew ? [] : this.listSDBH.filter(o => o.ListWords.includes(parseInt(w1.TextIndex)) && o.ListWords.includes(parseInt(w2.TextIndex) && o.Name != '')).map(o => o.Name)
                                        if(listMainGroupsInCommon.length > 0 || listSDBHGroupsInCommon.length > 0 || listBSGsInCommon.length > 0 || blnLNInCommon) 
                                        {
                                            nScore += 2
                                            listPropertiesInCommon.push(listMainGroupsInCommon.concat(listSDBHGroupsInCommon).concat(listBSGsInCommon).concat([w1.LN]).join(' '))
                                        }
                                    
                                        if(this.CalculateWordRhyme(w1.FullText, w2.FullText, false, dictRarityFactorByConsonant) >= (blnThisChapterIsHebrew ? 5 : 7.5)) //, (w1.TextIndex === '7822' && w2.TextIndex === '7860')
                                        {
                                            nScore += 2
                                            listPropertiesInCommon.push('rhyme')
                                        }
                                        else if(this.CalculateWordRhyme(w1.Lexeme, w2.Lexeme, false, dictRarityFactorByConsonant) >= (blnThisChapterIsHebrew ? 3 : 4.5))
                                        {
                                            nScore += 2
                                            listPropertiesInCommon.push('rhyme')
                                        }
                                        
                                        var oVowelSequenceResult = this.CalculateVowelSequenceScore(w1.FullText, w2.FullText)
                                        if(oVowelSequenceResult.Score >= (blnThisChapterIsHebrew ? 2 : 3))
                                        {
                                            nScore += oVowelSequenceResult.Score - 1
                                            listPropertiesInCommon.push((oVowelSequenceResult.Reverse ? 'r' : '') + 'vseq')
                                        }

                                        if(w1.FullText.includes('\u05bb') && w2.FullText.includes('\u05bb'))
                                        {
                                            nScore += 2
                                            listPropertiesInCommon.push('rarevowel')
                                        }
                                    }
                                }

                                // if(w1.TextIndex === '7822' && w2.TextIndex === '7860') console.log(listPropertiesInCommon, nScore)
                                if(nScore >= 1) 
                                {
                                    listForA.push({B: w2.TextIndex, N: parseFloat(nScore.toFixed(1)), 
                                        S: [...new Set(listPropertiesInCommon.map(sp => !sp.includes('_') ? sp : sp.split('_')[0]))].join(' ')})
                                }
                            }
                        }

                        listWordPairsForChapter.push({A: w1.TextIndex, L: listForA})
                    }

                    listWordPairsByChapter.push({Book: sBookToDo, Chapter: sChapterToDo, Pairs: listWordPairsForChapter})


                    //now do the lines based on the word pair calculations above
                    var listLinePairsForChapter = []
                    var listLinesForChapter = listLinesForAllChapters.filter(ol => ol.Book === sBookToDo && ol.Chapter === sChapterToDo)

                    this.CalculateLines(listLinesForChapter, listWordsInChapter)

                    for(var l1 of listLinesForChapter)
                    {
                        var listForLineA = []
                        var listWords1 = l1.Words
                        var listLinesToCompare = listLinesForChapter.filter(l => l != l1)

                        for(var l2 of listLinesToCompare)
                        {
                            var listWords2 = l2.Words
                            var oScore = this.GetAllSimilarityBetweenWordLists(listWords1, listWords2, false, listWordPairsForChapter)
                            
                            // console.log(oScore, listWords1, listWords2)
                            if(oScore.TotalPositiveScores > 1 || listWords1.length <= 2 || listWords2.length <= 2) 
                                listForLineA.push({B0: parseInt(l2.TextIndexRangeBegin), BE: parseInt(l2.TextIndexRangeEnd), N: oScore.Score, 
                                    S: oScore.SimilaritiesAfterDeletion + 
                                        (oScore.SimilaritiesForDeletedObjects.length === 0 ? '' : (', also: ' + oScore.SimilaritiesForDeletedObjects))})
                        }
                        
                        listLinePairsForChapter.push({A0: parseInt(l1.TextIndexRangeBegin), AE: parseInt(l1.TextIndexRangeEnd), L: listForLineA})
                    }

                    listLinePairsByChapter.push({Book: sBookToDo, Chapter: sChapterToDo, Pairs: listLinePairsForChapter})


                    //now do the lines based on the word pair calculations above
                    var listStanzaPairsForChapter = []
                    var listWordsByBreakGroup = this.GetWordsByBreakGroup(listLinesForChapter, 'StartsRepetitionGroup') //StartsRepetitionGroup, StartsCluster

                    for(var listWords1 of listWordsByBreakGroup)
                    {
                        var listForStanzaA = []
                        for(var listWords2 of listWordsByBreakGroup)
                        {
                            if(listWords1 === listWords2) continue

                            var oScore = this.GetAllSimilarityBetweenWordLists(listWords1, listWords2, false, listWordPairsForChapter)
                            
                            if(oScore.TotalPositiveScores > 3 || listWords1.length <= 6 || listWords2.length <= 6)
                                listForStanzaA.push({B0: this.GetMinTextIndex(listWords2), BE: this.GetMaxTextIndex(listWords2), N: oScore.Score, 
                                    S: oScore.SimilaritiesAfterDeletion + 
                                        (oScore.SimilaritiesForDeletedObjects.length === 0 ? '' : (', also: ' + oScore.SimilaritiesForDeletedObjects))})
                        }
                        
                        listStanzaPairsForChapter.push({A0: this.GetMinTextIndex(listWords1), AE: this.GetMaxTextIndex(listWords1), L: listForStanzaA})
                    }

                    listStanzaPairsByChapter.push({Book: sBookToDo, Chapter: sChapterToDo, Pairs: listStanzaPairsForChapter})
                }
            }

            window.alert('done!')
            console.log(JSON.stringify({Words: listWordPairsByChapter, Lines: listLinePairsByChapter, Stanzas: listStanzaPairsByChapter}))

            //use the following python to process it
            // def MakeSimFrozenFiles(sFromFilename):
            //     with open('C:/Users/Jason Sommerlad/Documents/psalms project/dev/' + sFromFilename, mode='r', encoding='utf-8') as f:
            //         listObjects = json.loads(f.read())
            //     for oChapter in listObjects['Words']:
            //         with open('C:/Users/Jason Sommerlad/Documents/psalms project/dev/web/my-app/public/AllSimilarityData/allsim_' + oChapter['Book'] + '_' + oChapter['Chapter'] + '.json', mode='w') as file:
            //             file.write(json.dumps({'Pairs': oChapter['Pairs']}))
            //     for oChapter in listObjects['Lines']:
            //         with open('C:/Users/Jason Sommerlad/Documents/psalms project/dev/web/my-app/public/AllSimilarityLinesData/allsimlines_' + oChapter['Book'] + '_' + oChapter['Chapter'] + '.json', mode='w') as file:
            //             file.write(json.dumps({'Pairs': oChapter['Pairs']}))
            //
            // MakeSimFrozenFiles('AllSim19_63.json')
        })
    }

    GetAllSimilarityAmountScore(w1, w2)
    {
        // for the hovered word, find words that rhyme >= red, or same lexical root, semantic domain, preposition or suffix pgn, 
        // same less common stem (!= qal) or form (!= perfect/imperfect) or calculation similarity >= purple

        // if(w1.TextIndex === '1' && w2.TextIndex === '3')
        // {
        //     console.log('something')
        // }

        if(w1 === undefined || w2 === undefined) return {Score: 0, ListSimilarities: '', W1: w1, W2: w2, Color: this.GetAllSimilarityColorFromScore(0)}
        if(w1.FullText === w2.FullText) return {Score: 5, ListSimilarities: 'fulltext', W1: w1, W2: w2, Color: this.GetAllSimilarityColorFromScore(10)}

        var listOfSimilarities = []
        var nScore = 0

        // var listTextSplits1 = w1.SeparatedText.split('/')
        // var listTextSplits2 = w2.SeparatedText.split('/')

        // if(w1.TextIndex === '17603' && w2.TextIndex === '17689') console.log(w1.GRefs)
        //if(w1.Refs.includes(w2.ID) || w2.Refs.includes(w1.ID))
        if((w1.RefsG != undefined && w1.RefsG.includes(w2.TextIndex)) || 
           (w2.RefsG != undefined && w2.RefsG.includes(w1.TextIndex)))
        {
            nScore += 2
            listOfSimilarities.push('suffixref')
        }
        
        if(w1.Preposition != '' && w1.Preposition != undefined && w1.Preposition === w2.Preposition) 
        {
            nScore += 1
            listOfSimilarities.push('preposition')
            // listTextSplits1 = listTextSplits1.slice(w1.Waw ? 2 : 1, listTextSplits1.length)
            // listTextSplits2 = listTextSplits2.slice(w2.Waw ? 2 : 1, listTextSplits2.length)
        }
        
        //suffixes and prepositions will rhyme, so they are less of a factor in the score
        var sSuffixPGN1 = this.GetSuffixPGN(w1)
        if(sSuffixPGN1 != '' && sSuffixPGN1 === this.GetSuffixPGN(w2)) 
        {
            nScore += 0.5
            listOfSimilarities.push('suffix')
            // listTextSplits1 = listTextSplits1.slice(0, listTextSplits1.length - 1)
            // listTextSplits2 = listTextSplits2.slice(0, listTextSplits2.length - 1)
        }

        var sPGN1 = this.GetPGN(w1)
        if(sPGN1 != '' && sPGN1 === this.GetPGN(w2)) 
        {
            nScore += 0.5
            listOfSimilarities.push('pgn')
        }

        if(w1.Waw === '1' && w1.Waw === w2.Waw) 
        {
            nScore += 0.5
            listOfSimilarities.push('waw')
        }

        if(w1.DefiniteArticle === '1' && w1.DefiniteArticle === w2.DefiniteArticle)
        {
            nScore += 0.4
            listOfSimilarities.push('article')
        }
        else if(this.WordHasDageshHazaqOrMappiq(w1) && this.WordHasDageshHazaqOrMappiq(w2))
        {
            //don't count initial mappiq if there is a definite article, since the definite article produces doubling
            //TODO: count non-initial mappiqs even if there is a definite article
            nScore += 0.4
            listOfSimilarities.push('mappiq')
        }

        if(this.WordIsInterrogative(w1) && this.WordIsInterrogative(w2))
        {
            nScore += 3
            listOfSimilarities.push('interrogative')
        }

        if(w1.SuffixType === w2.SuffixType && ['n', 'h', 'd'].includes(w1.SuffixType)) 
        {
            nScore += 3
            listOfSimilarities.push('special_suffix')
        }

        if(this.WordSatisfiesConstructStateLensCriteria(w1) && this.WordSatisfiesConstructStateLensCriteria(w2))
        {
            nScore += 0.75
            listOfSimilarities.push('construct')
        }

        // if(w1.TextIndex === '6298' && w2.TextIndex === '6380') console.log(w1, w2.ParentRoot, w1.ParentRoot === w2.ParentRoot && w1.ParentRoot != '')
        if(w1.ParentRoot === w2.ParentRoot && w1.ParentRoot != '') 
        {
            nScore += 4
            listOfSimilarities.push('root')
        }

        if(w1.FullText.includes('־') && w2.FullText.includes('־'))
        {
            nScore += 0.5
            listOfSimilarities.push('maqaf')
        }

        if(w1.phrase_function === 'Voct' && w2.phrase_function === 'Voct')
        {
            nScore += 1
            listOfSimilarities.push('vocatives')
        }

        //maybe add fronting in when doing the frozen calculation, since it is more intensive?
        // var listFrontedWords = this.listClauses.flatMap(l => {
        //     var nIndexOfFirsVerb = l.Words.findIndex(w => w.WordType === 'V')
        //     if(nIndexOfFirsVerb < 0) return false
        //     return l.Words.slice(0, nIndexOfFirsVerb).filter(w => ['N', 'A', 'P', 'R'].includes(w.WordType))
        // })
        // if(listFrontedWords.includes(w1) && listFrontedWords.includes(w2))
        // {
        //     nScore += 1
        //     listOfSimilarities.push('fronting')
        // }

        //if the root is the same, it will rhyme, so don't double count it
        if(!listOfSimilarities.includes('root'))
        {
            if(w1.WordType === w2.WordType && ['P', 'D', 'C', 'R'].includes(w1.WordType))
            {
                nScore += 3
                listOfSimilarities.push('wordtype')
            }
        
            if(w1.WordType === w2.WordType && w1.WordType === 'T' && this.GetParticleType(w1) === this.GetParticleType(w2))
            {
                nScore += 3
                listOfSimilarities.push('particletype')
            }

            var listBSGsInCommon = []
            if(w1.BSGs != undefined && w2.BSGs != undefined) listBSGsInCommon = w1.BSGs.filter(nsg => w2.BSGs.includes(nsg)).map(nsg => this.listBSGs.find(oBSG => oBSG.ID === nsg).GroupName)

            var listMainGroupsInCommon = this.listMainSemanticDomains.filter(g => g.LexicalIDs.includes(w1.LexicalID) && g.LexicalIDs.includes(w2.LexicalID)).map(o => o.Name)
            var listSDBHGroupsInCommon = this.listSDBH.filter(o => o.ListWords.includes(parseInt(w1.TextIndex)) && o.ListWords.includes(parseInt(w2.TextIndex) && o.Name != '')).map(o => o.Name)
            if(listMainGroupsInCommon.length > 0 || listSDBHGroupsInCommon.length > 0 || listBSGsInCommon.length > 0) 
            {
                nScore += 2
                listOfSimilarities.push(listMainGroupsInCommon.concat(listSDBHGroupsInCommon).concat(listBSGsInCommon).join(' '))
            }
        
            // if(listOfSimilarities.length > 0) console.log(listOfSimilarities, listTextSplits2)

            // var sTextForRhyme1 = listTextSplits1.join('')
            // var sTextForRhyme2 = listTextSplits2.join('')

            if(this.CalculateWordRhyme(w1.FullText, w2.FullText, false) >= 5)
            {
                nScore += 2
                listOfSimilarities.push('text_rhyme')
            }
            else if(this.CalculateWordRhyme(w1.Lexeme, w2.Lexeme, false) >= 3)
            {
                nScore += 2
                listOfSimilarities.push('lexeme_rhyme')
            }
            
            var oVowelSequenceResult = this.CalculateVowelSequenceScore(w1.FullText, w2.FullText)
            if(oVowelSequenceResult.Score >= 2)
            {
                nScore += oVowelSequenceResult.Score - 1
                listOfSimilarities.push((oVowelSequenceResult.Reverse ? 'reverse_' : '') + 'vowel_sequence')
            }

            if(w1.FullText.includes('\u05bb') && w2.FullText.includes('\u05bb'))
            {
                nScore += 2
                listOfSimilarities.push('same_rare_vowel')
            }
            // if(this.AlltForOnlyCertainConsonantsAtBeginning(w1.Lexeme, w2.Lexeme))
            // {
            //     nScore += 1
            //     listOfSimilarities.push('lexeme_alliteration')
            // }
        }

        // var blnSameCorrespondenceGroup = this.listCorrespondencesForChapter.
        //     some(g => g.ListWords.includes(w1.TextIndex) && g.ListWords.includes(w2.TextIndex))
        // if(blnSameCorrespondenceGroup) nTotalScore +=1

        // var blnSameRef = w1.Refs.includes(w2.ID) || w2.Refs.includes(w1.ID) || 
        //     w1.Refs.some(sRef => w2.Refs.includes(sRef)) || w2.Refs.some(sRef => w1.Refs.includes(sRef)) // || w1.SubjRefs.includes(sRef)
        // if(blnSameRef) 
        // {
        //     nScore += 1
        //     listOfSimilarities.push('sameref')
        // }

        if(w1.WordType === w2.WordType)
        {
            if(w1.Stem === w2.Stem && w1.Stem != undefined && w1.Stem != '') // && w1.Stem != 'q'
            {
                nScore += 0.5
                listOfSimilarities.push('stem')
            }

            //group the participles, sequentials, and imperative like things together
            if((w1.Form === w2.Form && w1.Form != undefined && w1.Form != '') || 
                ((w1.Form === 'r' && w2.Form === 's') || (w1.Form === 's' && w2.Form === 'r')) || 
                ((w1.Form === 'q' && w2.Form === 'w') || (w1.Form === 'w' && w2.Form === 'q')) || 
                ((w1.Form === 'h' && w2.Form === 'v') || (w1.Form === 'v' && w2.Form === 'h')) || 
                ((w1.Form === 'h' && w2.Form === 'j') || (w1.Form === 'j' && w2.Form === 'h')) || 
                ((w1.Form === 'v' && w2.Form === 'j') || (w1.Form === 'j' && w2.Form === 'v'))) // && w1.Form != 'p' && w1.Form != 'i'
            {
                //give bonus score if they exactly the same and are less common (not perfect or imperfect)
                nScore += 0.5
                if(w1.Form === w2.Form && !['p', 'i'].includes(w1.Form)) nScore += 0.5

                listOfSimilarities.push('form')
            }

            // else
            // {
            //     var calcs = this.CalculateRepetitionLinkGroupCategoriesFromWords([w1, w2], this.state.listLines, false, true)
            //     var nCompareGroups = calcs.ComparisonsAndCalculationsByWordType.length
            //     var nSimilarityScore = (calcs.ComparisonsAndCalculationsByWordType.map(c2 => c2.Same.length).reduce((acc, n) => acc + n, 0) / (1.0 * nCompareGroups)) + 
            //         (calcs.DifferentPolarity ? -1 : 0) + ((calcs.ConstructToSingleNoun || calcs.SingleNounToConstruct) ? -1 : 0)

            // if(nSimilarityScore >= 8) 
            // {
            //     nScore += 1
            //     listOfSimilarities.push('repcalcs')
            // }
            //     // if(nSimilarityScore >= 8) console.log(nSimilarityScore)
            // }
        }
        
        // if(w2.FullText === 'אַ֥שְֽׁרֵי') console.log(listOfSimilarities)

        if(listOfSimilarities.includes('pgn') && listOfSimilarities.includes('stem') && listOfSimilarities.includes('form')) nScore += 1.5
        else if(listOfSimilarities.includes('pgn') && (listOfSimilarities.includes('stem') || listOfSimilarities.includes('form'))) nScore += 1
        else if(listOfSimilarities.includes('stem') && listOfSimilarities.includes('form')) nScore += 1

        return {Score: nScore, ListSimilarities: listOfSimilarities.join(' '), W1: w1, W2: w2, Color: this.GetAllSimilarityColorFromScore(nScore)}
    }

    MaxAllSimilarityLens()
    {
        // console.log(this.GetAllSimilarityAmountScore(this.GetWordWithTextIndexInChapter('17674'), this.GetWordWithTextIndexInChapter('17688')))
        var listColorByWord = []
        var listWordsInChapter = this.listTextWordsForChapter
        for(var w of listWordsInChapter)
        {
            var oForA = this.listAllSimilarityPairsForChapter.find(o => o.A === w.TextIndex)
            var nMaxScoreForWord = oForA === undefined ? 0 : Math.max(...oForA.L.map(o => o.N))
            listColorByWord.push({W: w, Color: this.GetAllSimilarityColorFromScore(nMaxScoreForWord)})
        }

        var listColors = [...new Set(listColorByWord.map(o => o.Color))]
        return listColors.map(s => ({ListWords: listColorByWord.filter(o => o.Color === s).map(o => o.W), Name: '', Color: s}))
    }

    CalculateAllSimilarityForAllChapters()
    {
        //note - before running this, make sure that allpsalmschapters.json is up to date by running this Python code:
        //listAllWordsInPsalms = []
        // sHebrewDataPath = 'C:/Users/Jason Sommerlad/Documents/psalms project/dev/web/my-app/public/HebrewTextData/'
        // for sFilename in [f for f in os.listdir(sHebrewDataPath) if f.startswith('19_') and f.endswith('.json')]:
        //     with open(sHebrewDataPath + sFilename, mode='r', encoding='utf-8') as hebtextfile:
        //         hebrewTextData = json.loads(hebtextfile.read())
        //     for w in hebrewTextData['OSHB']:
        //         listAllWordsInPsalms.append(w)
        // with open('C:/Users/Jason Sommerlad/Documents/psalms project/dev/web/my-app/public/HebrewTextData/allpsalmschapters.json', mode='w') as allHebrewFile:
        //     allHebrewFile.write(json.dumps({'OSHB': listAllWordsInPsalms}))

        var listWordPairsByChapter = []

        fetch("HebrewTextData/allchapters.json") //allpsalmschapters.json
        .then(res => res.json())
        .then(data => 
        {
            this.listTextWordsForAllChapters = data.OSHB

            var textWordsByBook = this.GroupArrayByKey(this.listTextWordsForAllChapters, "Book")
            for(var sBookToDo of Object.keys(textWordsByBook).slice(9))
            {						
                if(sBookToDo === '19') continue
                console.log('Book: ' + sBookToDo)

                var textWordsByChapter = this.GroupArrayByKey(textWordsByBook[sBookToDo], "Chapter");
                for(var sChapterToDo of Object.keys(textWordsByChapter)) //.slice(0, 10)
                {						
                    console.log(sChapterToDo)

                    var listWordPairsForChapter = []
                    var listWordsInChapter = textWordsByChapter[sChapterToDo]
                    for(var w1 of listWordsInChapter)
                    {
                        var listForA = []
                        for(var w2 of listWordsInChapter)
                        {
                            if(w1 != w2) // && !listWordPairsForChapter.some(owp => owp.A === w2.TextIndex && owp.B === w1.TextIndex))
                            {
                                var oScore = this.GetAllSimilarityAmountScore(w1, w2)
                                    
                                // if(w1.TextIndex === '17674' && w2.TextIndex === '17688') console.log(oScore)
                                if(oScore.Score >= 1) 
                                {
                                    listForA.push({B: w2.TextIndex, N: oScore.Score, S: oScore.ListSimilarities})
                                }
                            }
                        }

                        listWordPairsForChapter.push({A: w1.TextIndex, L: listForA})
                    }

                    listWordPairsByChapter.push({Book: sBookToDo, Chapter: sChapterToDo, Pairs: listWordPairsForChapter})
                }
            }

            window.alert('done!')
            console.log(JSON.stringify(listWordPairsByChapter))

            //use the following python to process it
            // with open('C:/Users/Jason Sommerlad/Documents/psalms project/dev/AllSim132.json', mode='r', encoding='utf-8') as f:
            // listObjects = json.loads(f.read())

            // for nChapter in range(1,151):
            // sChapter = str(nChapter)
            // listObjectsForChapter = [o for o in listObjects if o['Chapter'] == sChapter]
            // if len(listObjectsForChapter) > 0:
            //     with open('C:/Users/Jason Sommerlad/Documents/psalms project/dev/web/my-app/public/AllSimilarityData/allsim_19_' + sChapter + '.json', mode='w') as file:
            //         file.write(json.dumps({'Pairs': listObjectsForChapter[0]['Pairs']}))
        })
    }

    // CalculateAllSimilarityForLinesForAllChapters()
    // {
    //     //note - before running this, make sure that allpsalmschapters.json is up to date by running this Python code:
    //     //listAllWordsInPsalms = []
    //     // sHebrewDataPath = 'C:/Users/Jason Sommerlad/Documents/psalms project/dev/web/my-app/public/HebrewTextData/'
    //     // for sFilename in [f for f in os.listdir(sHebrewDataPath) if f.startswith('19_') and f.endswith('.json')]:
    //     //     with open(sHebrewDataPath + sFilename, mode='r', encoding='utf-8') as hebtextfile:
    //     //         hebrewTextData = json.loads(hebtextfile.read())
    //     //     for w in hebrewTextData['OSHB']:
    //     //         listAllWordsInPsalms.append(w)
    //     // with open('C:/Users/Jason Sommerlad/Documents/psalms project/dev/web/my-app/public/HebrewTextData/allpsalmschapters.json', mode='w') as allHebrewFile:
    //     //     allHebrewFile.write(json.dumps({'OSHB': listAllWordsInPsalms}))

    //     //also make sure allpsalmslines is up to date
        
    //     var listLinesForAllChapters = [] //require('./allpsalmslines.json').Lines
    //     var listLinePairsByChapter = []

    //     fetch("HebrewTextData/allpsalmschapters.json") //allpsalmschapters.json //allchapters
    //     .then(res => res.json())
    //     .then(data => 
    //     {
    //         this.listTextWordsForAllChapters = data.OSHB

    //         var textWordsByBook = this.GroupArrayByKey(this.listTextWordsForAllChapters, "Book")
    //         for(var sBookToDo of Object.keys(textWordsByBook))
    //         {						
    //             // if(sBookToDo === '19') continue
    //             console.log('Book: ' + sBookToDo)

    //             var textWordsByChapter = this.GroupArrayByKey(textWordsByBook[sBookToDo], "Chapter");
    //             for(var sChapterToDo of Object.keys(textWordsByChapter).slice(0, 1)) //.slice(0, 10)
    //             {						
    //                 console.log(sChapterToDo)

    //                 var listLinePairsForChapter = []
    //                 var listWordsInChapter = textWordsByChapter[sChapterToDo]
    //                 var listLinesForChapter = listLinesForAllChapters.filter(ol => ol.Book === sBookToDo && ol.Chapter === sChapterToDo)

    //                 this.CalculateLines(listLinesForChapter, listWordsInChapter)

    //                 for(var l1 of listLinesForChapter)
    //                 {
    //                     var listForA = []
    //                     var listWords1 = l1.Words
    //                     var listLinesToCompare = listLinesForChapter.filter(l => l != l1)

    //                     for(var l2 of listLinesToCompare)
    //                     {
    //                         var listWords2 = l2.Words
    //                         var oScore = this.GetAllSimilarityBetweenWordLists(listWords1, listWords2, true)
    //                         // console.log(oScore, listWords1, listWords2)
    //                         if(oScore.TotalPositiveScores > 1) listForA.push({B0: l2.TextIndexRangeBegin, BE: l2.TextIndexRangeEnd, N: oScore.Score, 
    //                             S: oScore.SimilaritiesAfterDeletion + 
    //                                 (oScore.SimilaritiesForDeletedObjects.length === 0 ? '' : (', deleted: ' + oScore.SimilaritiesForDeletedObjects))})
    //                     }
                        
    //                     listLinePairsForChapter.push({A0: l1.TextIndexRangeBegin, AE: l1.TextIndexRangeEnd, L: listForA})
    //                 }

    //                 listLinePairsByChapter.push({Book: sBookToDo, Chapter: sChapterToDo, Pairs: listLinePairsForChapter})

    //                 // 
    //                 // var listWordsInChapter = textWordsByChapter[sChapterToDo]
    //                 // for(var w1 of listWordsInChapter)
    //                 // {
    //                 //     var listForA = []
    //                 //     for(var w2 of listWordsInChapter)
    //                 //     {
    //                 //         if(w1 != w2) // && !listWordPairsForChapter.some(owp => owp.A === w2.TextIndex && owp.B === w1.TextIndex))
    //                 //         {
    //                 //             var oScore = this.GetAllSimilarityAmountScore(w1, w2)
                                    
    //                 //             // if(w1.TextIndex === '17674' && w2.TextIndex === '17688') console.log(oScore)
    //                 //             if(oScore.Score >= 1) 
    //                 //             {
    //                 //                 listForA.push({B: w2.TextIndex, N: oScore.Score, S: oScore.ListSimilarities})
    //                 //             }
    //                 //         }
    //                 //     }

    //                 //     listWordPairsForChapter.push({A: w1.TextIndex, L: listForA})
    //                 // }

    //             }
    //         }

    //         window.alert('done!')
    //         console.log(JSON.stringify(listLinePairsByChapter))

    //         //use the following python to process it
    //         // with open('C:/Users/Jason Sommerlad/Documents/psalms project/dev/AllSim132.json', mode='r', encoding='utf-8') as f:
    //         // listObjects = json.loads(f.read())

    //         // for nChapter in range(1,151):
    //         // sChapter = str(nChapter)
    //         // listObjectsForChapter = [o for o in listObjects if o['Chapter'] == sChapter]
    //         // if len(listObjectsForChapter) > 0:
    //         //     with open('C:/Users/Jason Sommerlad/Documents/psalms project/dev/web/my-app/public/AllSimilarityData/allsim_19_' + sChapter + '.json', mode='w') as file:
    //         //         file.write(json.dumps({'Pairs': listObjectsForChapter[0]['Pairs']}))
    //     })
    // }

    GetDifferenceAmountColor(wComparedToHovered, wHovered)
    {
        if(wComparedToHovered === undefined || wHovered === undefined) return "Gray"
        else if(wComparedToHovered === wHovered) return 'Black'
        else if(wComparedToHovered.WordType != wHovered.WordType) return 'LightGray'

        var calcs = this.CalculateRepetitionLinkGroupCategoriesFromWords([wComparedToHovered, wHovered], this.state.listLines, false, true)
        var nCompareGroups = calcs.ComparisonsAndCalculationsByWordType.length

        wHovered.InfoForDifferenceLens = ''
        wComparedToHovered.InfoForDifferenceLens = this.GetCalculationsStringForCorrespondenceGroup(calcs, true, true)

        // var nSimilarityScore = (calcs.ComparisonsAndCalculationsByWordType.map(c2 => c2.Same.length).reduce((acc, n) => acc + n, 0) / (1.0 * nCompareGroups)) + 
        //     (calcs.DifferentPolarity ? -1 : 0) + ((calcs.ConstructToSingleNoun || calcs.SingleNounToConstruct) ? -1 : 0)

        var nDifferenceScore = (calcs.ComparisonsAndCalculationsByWordType.map(c2 => c2.Different.length).reduce((acc, n) => acc + n, 0) / (1.0 * nCompareGroups)) + 
            (calcs.DifferentPolarity ? 1 : 0) + ((calcs.ConstructToSingleNoun || calcs.SingleNounToConstruct) ? 1 : 0)

        // var nScore = nDifferenceScore / nSimilarityScore
        // var sColor = nScore < 0.25 ? "LightGray" : 
        //     nScore < 0.5 ? "Gray" : 
        //     nScore < 0.75 ? "Green" : 
        //     nScore < 1 ? "Orange" : 
        //     nScore < 2 ? "Red" : 
        //     nScore < 3 ? "Purple" : 
        //     nScore >= 3 ? "Black" : "LightGray"

        var nScore = nDifferenceScore
        var sColor = nCompareGroups === 0 ? 'Pink': nScore < 1 ? "LightGray" : 
            nScore < 2 ? "Gray" : 
            nScore < 3 ? "Green" : 
            nScore < 4 ? "Orange" : 
            nScore < 5 ? "Red" : 
            nScore < 6 ? "Purple" : "Black"

        return sColor
    }
    
    SameDifferentLens()
	{
		var blnColorByMainType = this.state.blnColorCorrespondenceLensByMainType;

		//TODO:this.listCorrespondencesForChapter loads only current chapter -> change the first filter below.
		var listCorrespondencesForChapter = this.listCorrespondencesForChapter; //.filter(g => g.ListWords.some(nTextIndex => this.listTextWordsForChapter.some(w => w.TextIndex === nTextIndex)));
		listCorrespondencesForChapter.filter(o => o.Calculations === undefined).forEach(o => o.Calculations = this.CalculateRepetitionLinkGroupCategoriesFromWords(o.ListWords.map(n => this.GetWordWithTextIndexInChapter(n)), this.state.listLines, false, true));

        // console.log(listCorrespondencesForChapter)
        
        var listToReturn = [];
        
        // var nMaxLinesBetweenToSearch = 1
        // var blnConstrainToCorrespondences = true
		// 
        // for(var nLine1 = 0; nLine1 < this.state.listLines.length - 1; nLine1++)
        // {
        //     for(var nLine2 = nLine1 + 1; nLine2 <= nLine1 + nMaxLinesBetweenToSearch; nLine2++)
        //     {
        //         var listWords1 = this.state.listLines[nLine1].Words
        //         var listWords2 = this.state.listLines[nLine2].Words

        //         if(blnConstrainToCorrespondences)
        //         {
        //             var listWordsBoth = (listWords1 + listWords2).filter(w => )
        //         }
        //     }
        // }

		listToReturn = listCorrespondencesForChapter.
			map((g,index) => {
				var sMainType = !blnColorByMainType || g.ListTags.length === 0 ? undefined : this.GetMainTypeForRepetitionLinkGroupCategoryID(g.ListTags[0].CategoryID);
				var sTagText = g.ListTags.map(t => this.GetTagRelationPairText(t)).join(", ");
				var sCalculationText = this.GetCalculationsStringForCorrespondenceGroup(g.Calculations, true, true);
                var listWords = g.ListWords.map(n => this.GetWordWithTextIndexInChapter(n)).filter(w => w !== undefined)
                var calcs = g.Calculations
                
                var nScore = 0
                if(calcs.ComparisonsAndCalculationsByWordType != undefined)
                {
                    var nCompareGroups = calcs.ComparisonsAndCalculationsByWordType.length

                    // console.log(calcs.ComparisonsAndCalculationsByWordType.map(c2 => c2.Different.length).reduce((acc, n) => acc + n, 0))
                    var nSimilarityScore = (calcs.ComparisonsAndCalculationsByWordType.map(c2 => c2.Same.length).reduce((acc, n) => acc + n, 0) / (1.0 * nCompareGroups)) + 
                        (calcs.DifferentPolarity ? -1 : 0) + ((calcs.ConstructToSingleNoun || calcs.SingleNounToConstruct) ? -1 : 0)

                    var nDifferenceScore = (calcs.ComparisonsAndCalculationsByWordType.map(c2 => c2.Different.length).reduce((acc, n) => acc + n, 0) / (1.0 * nCompareGroups)) + 
                        (calcs.DifferentPolarity ? 1 : 0) + ((calcs.ConstructToSingleNoun || calcs.SingleNounToConstruct) ? 1 : 0)

                    nScore = nDifferenceScore / nSimilarityScore
                }

                var sColor = nScore < 0.25 ? "LightGray" : 
                    nScore < 0.5 ? "Gray" : 
                    nScore < 0.75 ? "Green" : 
                    nScore < 1 ? "Orange" : 
                    nScore < 2 ? "Red" : 
                    nScore < 3 ? "Purple" : 
                    nScore >= 3 ? "Black" : "LightGray"
            
                // var sColor = nScore < 1 ? "LightGray" : 
                //     nScore < 2 ? "Gray" : 
                //     nScore < 3 ? "Green" : 
                //     nScore < 4 ? "Orange" : 
                //     nScore < 5 ? "Red" : 
                //     nScore < 6 ? "Purple" : "Black";
                

                var blnInclude = true
                // var blnInclude = (listWords.some(w => w.WordType === 'N' && w.Gender === 'm') && listWords.some(w => w.WordType === 'N' && w.Gender === 'f')) || 
                // (listWords.some(w => w.WordType === 'N' && w.Number === 's') && listWords.some(w => w.WordType === 'N' && w.Number === 'p')) || 
                // (listWords.some(w => w.WordType === 'V' && w.Number === 's') && listWords.some(w => w.WordType === 'V' && w.Number === 'p')) ||
                // (listWords.some(w => w.WordType === 'V' && w.Form === 'p') && listWords.some(w => w.WordType === 'V' && w.Form === 'i'))

				return {ListWords: listWords, Include: blnInclude,
					Name: nScore + ' ' + g.Comment + (g.Comment === "" ? "" : "; ") + sTagText + (sTagText === "" || sCalculationText === "" ? "" : ", ") + sCalculationText,
                    DiffScore: nDifferenceScore, SimScore: nSimilarityScore,
					Color: sColor}});

        // console.log(listToReturn.map(o => ({Length: o.ListWords.length, Calc: o.DiffScore / o.SimScore})))
        // console.log(listCorrespondencesForChapter)
        // console.log(listCorrespondencesForChapter.flatMap(o => o.Calculations.ComparisonsAndCalculationsByWordType))
        return listToReturn.filter(o => o.Include)
	}

    PatternToArray(sPattern)
    {
        //[[0,3], [1,2]]
        var listCharsInPattern = sPattern.split('')
        var listDistinctCharsInPattern = [...new Set(listCharsInPattern)]
        listDistinctCharsInPattern.sort()

        var nPatternGroups = listDistinctCharsInPattern.length
        var listPatternGroups = new Array(nPatternGroups)
        for (var i = 0; i < nPatternGroups; i++)
        {
            var listIndexesInGroup = listCharsInPattern.map((s, nCharIndex) => ({s: s, n: nCharIndex})).filter(o => listDistinctCharsInPattern.indexOf(o.s) === i).map(o => o.n)
            // var blnConsecutive = listIndexesInGroup.length > 1 && Math.max(...listIndexesInGroup) - Math.min(...listIndexesInGroup) === listIndexesInGroup.length - 1
            listPatternGroups[i] = {IndexesInGroup: listIndexesInGroup}
        }
        
        return listPatternGroups
    }

    DeduplicateLensResults(listToProcess)
    {
        //sort biggest first for the deduplication below
        listToProcess.sort((a,b) => b.ListWords.length - a.ListWords.length)

        //remove groups that are entirely contained in another group
        var listToRemove = []
        for(var o1 of listToProcess)
        {
            for(var o2 of listToProcess)
            {
                if(o1 != o2 && o1.ListWords.every(w => o2.ListWords.includes(w))) listToRemove.push(o1)
            }   
        }

        return listToProcess.filter(o => !listToRemove.includes(o))
    }

    GetWordListForChapterUncollapsedWhereFieldIsPopulated(sField)
    {
        var listTextWordsSorted = this.listTextWordsForChapter
        listTextWordsSorted.sort((a,b) => parseInt(a.TextIndex) - parseInt(b.TextIndex))

        var listToReturn = listTextWordsSorted.map(w => ({ListWords: [w], SameValue: this.GetValueForLensType(w, sField)})).
            filter(o => o.SameValue != undefined && o.SameValue != '')

        return listToReturn
    }

    GetWordListForChapterCollapsedBySameValueForField(sField, blnFieldValueIsAList)
    {
        var listTextWordsSorted = this.listTextWordsForChapter
        listTextWordsSorted.sort((a,b) => parseInt(a.TextIndex) - parseInt(b.TextIndex))

        var listCollapsed = []
        var listConsecutiveUnitsWithSameValue = []
        for(var w of listTextWordsSorted)
        {
            var currentValue = this.GetValueForLensType(w, sField)

            var lastValue = listConsecutiveUnitsWithSameValue.length === 0 ? undefined : 
                this.GetValueForLensType(listConsecutiveUnitsWithSameValue[listConsecutiveUnitsWithSameValue.length - 1], sField)
            
            if(currentValue == undefined || currentValue == '') continue

            if(listConsecutiveUnitsWithSameValue.length === 0)
            {
                listConsecutiveUnitsWithSameValue = [w]
            }
            else if((!blnFieldValueIsAList && currentValue == lastValue) || (blnFieldValueIsAList && currentValue.some(cvo => lastValue.includes(cvo))))
            {
                listConsecutiveUnitsWithSameValue.push(w)
            }
            else //if(listConsecutiveUnitsWithSameValue.length > 1)
            {
                listCollapsed.push({ListWords: listConsecutiveUnitsWithSameValue, SameValue: lastValue})
                listConsecutiveUnitsWithSameValue = [w]
            }
        }

        //leftover one
        if(listConsecutiveUnitsWithSameValue.length > 1)
        {
            listCollapsed.push({ListWords: listConsecutiveUnitsWithSameValue,
                SameValue: this.GetValueForLensType(listConsecutiveUnitsWithSameValue[listConsecutiveUnitsWithSameValue.length - 1], sField)})
        }

        // console.log(listCollapsed)
        return listCollapsed
    }

    GetPatternsForField(sFieldPlus, listPatterns, blnFieldValueIsAList)
    {
        var sField = sFieldPlus === 'f_no_participles' ? 'f' : sFieldPlus

        var listUncollapsed = this.GetWordListForChapterUncollapsedWhereFieldIsPopulated(sField)
        var listCollapsed = this.GetWordListForChapterCollapsedBySameValueForField(sField, blnFieldValueIsAList)

        if(sFieldPlus === 'f_no_participles')
        {
            listUncollapsed = listUncollapsed.filter(o => !['r', 's'].includes(o.SameValue))
            listCollapsed = listCollapsed.filter(o => !['r', 's'].includes(o.SameValue))
        }

        var listToReturn = []
        for(var oPattern of listPatterns)
        {
            var listToUse = oPattern.UseUncollapsed  ? listUncollapsed : listCollapsed

            for(var n = 0; n < listToUse.length; n++)
            {
                //{MinPattern: 'aaa', Increment: 'a'}
                var sPattern = oPattern.MinPattern
                var blnMatched = true

                while(blnMatched)
                {
                    // console.log(sPattern)
                    var sPatternCleaned = sPattern //sPattern.replaceAll('*', '')
                    // console.log(sPatternCleaned)

                    //if the last loop iteration matched, try to match another increment
                    var listPatternGroups = this.PatternToArray(sPatternCleaned)
                    var listAllIndexesInPatternGroups = listPatternGroups.flat()
                    var nMaxPatternGroupIndex = Math.max(...listAllIndexesInPatternGroups)

                    if(n + nMaxPatternGroupIndex >= listToUse.length) break

                    // console.log(g)
                    var listObjectsForMatchedIndexes = []
                    for(var g of listPatternGroups)
                    {
                        var listObjectsForThoseIndexes = listToUse.filter((o, nValueIndex) => g.IndexesInGroup.map(n2 => n2 + n).includes(nValueIndex))
                        
                        if(listObjectsForThoseIndexes.length === g.IndexesInGroup.length && 
                            (new Set(listObjectsForThoseIndexes.map(o => o.SameValue)).size) === 1)
                        {
                            // console.log(g.IndexesInGroup.map(n2 => n2 + n), listObjectsForThoseIndexes)
                            listObjectsForMatchedIndexes = listObjectsForMatchedIndexes.concat(listObjectsForThoseIndexes)
                        }
                        else
                        {
                            //if they are not all the same value, this is not a match
                            blnMatched = false
                            break
                        }
                    }
                    
                    if(blnMatched)
                    {
                        // console.log(listObjectsForMatchedIndexes)
                        // var listObjectsForMatchedIndexes = listToUse.filter((o, nValueIndex) => listAllIndexesInPatternGroups.map(n2 => n2 + n).includes(nValueIndex))
                        var listValuesForMatchedIndexes = listObjectsForMatchedIndexes.map(o => o.SameValue)

                        //make sure the value groups are different, and as many as there are different pattern groups
                        if((new Set(listValuesForMatchedIndexes).size) === listPatternGroups.length)
                        {
                            listToReturn.push({ListWords: listObjectsForMatchedIndexes.flatMap(o => o.ListWords),
                                Name: this.GetDescForLensType(sField) + ' ' + sPatternCleaned, Field: sField})
                                //+ ' ' + listValuesForMatchedIndexes.join(', ')
                        }
                    }

                    // if(!sPattern.includes('*')) break
                        
                    // var listToInsert = []
                    // for(var nChar = 1; nChar < sPattern.length; nChar++)
                    // {
                    //     //'aa*bb*'
                    //     //for each * insert before it another copy of the letter right before it
                    //     if(sPattern[nChar] === '*')
                    //         listToInsert.push({Index: nChar, Char: sPattern[nChar - 1]})
                    // }

                    // for(var oToInsert of listToInsert)
                    //     sPattern.splice(oToInsert.Index, 0, oToInsert.Char) 

                    //TODO: StarIncrementType
                    if(oPattern.Increment === '') break
                    sPattern += oPattern.Increment
                }
            }
        }

        return this.DeduplicateLensResults(listToReturn)
    }
    
    GetPatternsForChapter()
    {
        var listToReturn = []
        // var listPatterns = ['abba', 'abcba', 'abcdcba', 'abcdedcba', 'abcdefedcba', 'abcabc', 'abcdabcd', 'abcdeabcde', 'abcdefabcdef',
        // 'ababab', 'abababab', 'ababababab', 'abababababab', 'ababababababab', 'abababababababab', 'ababababababababab', 
        // 'abababa', 'ababababa', 'abababababa', 'ababababababa', 'abababababababa', 'ababababababababa', 'abababababababababa']

        // [[0,1], [2, 3]]
        //StarIncrementType: 'nextletterinalphabet', 
        var listPatterns = [{MinPattern: 'aaa', Increment: 'a', UseUncollapsed: true},
            {MinPattern: 'abab', Increment: 'ab', UseUncollapsed: false},
            {MinPattern: 'ababa', Increment: 'ba', UseUncollapsed: false},

            {MinPattern: 'abcabc', Increment: 'abc', UseUncollapsed: false},
            {MinPattern: 'abcdabcd', Increment: 'abcd', UseUncollapsed: false},

            {MinPattern: 'abba', Increment: '', UseUncollapsed: true},
            {MinPattern: 'abcba', Increment: '', UseUncollapsed: false},
            {MinPattern: 'abcdcba', Increment: '', UseUncollapsed: false},
            {MinPattern: 'abcdedcba', Increment: '', UseUncollapsed: false},
            {MinPattern: 'abcdefedcba', Increment: '', UseUncollapsed: false}
        ]

            //{MinPattern: 'aa*bb*aa*', Increment: 'aa*bb*aa*', UseUncollapsed: true},
            //{MinPattern: 'aa*bb*cc*', Increment: 'aa*bb*cc*', UseUncollapsed: true},
            // {MinPattern: 'abba', Increment: '', UseUncollapsed: true},
            // // {MinPattern: 'abcba', Increment: '', UseUncollapsed: true},
            // // {MinPattern: 'abcdcba', Increment: '', UseUncollapsed: true},
            // // {MinPattern: 'abcdedcba', Increment: '', UseUncollapsed: true},
            // // {MinPattern: 'abcdefedcba', Increment: '', UseUncollapsed: true},
            // {MinPattern: 'abab', Increment: 'ab'}, {MinPattern: 'ababa', Increment: 'ba'}]

        for(var sField of ['s', 'f', 'f_no_participles', 'preposition', 'pgn', 'sfxpgn']) //['s', 'f', 'f_no_participles', 'preposition', 'pgn', 'sfxpgn', 'ref']
        {
            var listMorePatterns = [] 
            // ['preposition', 'sfxpgn'].includes(sField) ? [{MinPattern: 'aaa', Increment: 'a', UseUncollapsed: true}] : []
            listToReturn = listToReturn.concat(this.GetPatternsForField(sField, listPatterns.concat(listMorePatterns), ['ref'].includes(sField)))
        }

        listToReturn.forEach((o, n) => o.Color = this.listLinkGroupColors[n % this.listLinkGroupColors.length])
        return listToReturn
    }
    
    PatternDensityLens()
    {
        var listWordsInPatterns = this.GetPatternsForChapter() //.map(o => o.ListWords)

        var listToReturn = []
        for(var w of this.listTextWordsForChapter)
        {
            //only count the word once per sField, like once for all the form patterns it is in.
            var nScore = new Set(listWordsInPatterns.filter(o => o.ListWords.includes(w)).map(o => o.Field)).size

            var sColor = nScore < 1 ? "LightGray" : 
                nScore < 2 ? "Green" : 
                nScore < 3 ? "Orange" : 
                nScore < 4 ? "Red" : 
                nScore < 5 ? "Purple" : "Black"

            listToReturn.push({ListWords: [w], Name: '', Color: sColor})
        }

        return listToReturn
    }

    PatternLens()
    {
        return this.GetPatternsForChapter()
    }

    WordsForGroupedByFieldPatternsAreEqual(w1, w2, sField)
    {
        if(sField === 'mysem')
        {
            return this.listMainSemanticDomains.some(o => o.LexicalIDs.includes(w1.LexicalID) && o.LexicalIDs.includes(w2.LexicalID))
        }
        else return this.GetValueForLensType(w1, sField) === this.GetValueForLensType(w2, sField)
    }

    GroupedByFieldPatternsFieldValuesContainValue(listFieldValues, w, sField)
    {
        if(sField === 'mysem')
        {
            var listDomainsForWord = this.GetValueForLensType(w, sField)
            // console.log(listFieldValues, listDomainsForWord)
            return listFieldValues.some(o => listDomainsForWord.includes(o))
        }
        else return listFieldValues.includes(this.GetValueForLensType(w, sField))
    }

    GetNearbyRepeatedSemanticPatterns(sField)
    {
        var listToReturn = []
        var listRepeatedFields = []

        if(sField === 'mysem')
        {
            listRepeatedFields = this.listMainSemanticDomains.filter(o => this.listTextWordsForChapter.filter(w => o.LexicalIDs.includes(w.LexicalID).length > 1))
        }
        else
        {
            var groupedField = this.GroupArrayByKey(this.listTextWordsForChapter, sField)
            listRepeatedFields = Object.keys(groupedField).filter(s => groupedField[s].length > 1)
        }

        // console.log(listRepeatedFields)

        var nLineHalfRange = (sField === 'mysem' || sField === 'sdbh') ? 0 : 0
        var nWordsThatMustOverlapBetweenLineGroups = (sField === 'mysem' || sField === 'sdbh') ? 1 : 1

        var listRepeatedFieldGroups = []
        for(var nLine = nLineHalfRange; nLine < this.state.listLines.length - nLineHalfRange; nLine++)
        {
            var nLineRangeBegin = nLine - nLineHalfRange < 0 ? 0 : nLine - nLineHalfRange
            var nLineRangeEnd = nLine + nLineHalfRange >= this.state.listLines.length ? this.state.listLines.length - 1 : nLine + nLineHalfRange
            var listLinesNearby = this.state.listLines.slice(nLineRangeBegin, nLineRangeEnd + 1)
            var listOtherRepeatedWordsNearby = listLinesNearby.flatMap(l => l.Words).filter(w => this.GroupedByFieldPatternsFieldValuesContainValue(listRepeatedFields, w, sField))
            listRepeatedFieldGroups.push(listOtherRepeatedWordsNearby)
            // listRepeatedFields.filter(s => listLinesNearby.flatMap(l => l.Words).map(w => this.GetValueForLensType(w, sField)).includes(s)).join(' '))
        }

        var listTextWordsSorted = this.listTextWordsForChapter.filter(w => this.GroupedByFieldPatternsFieldValuesContainValue(listRepeatedFields, w, sField))
        listTextWordsSorted.sort((a,b) => parseInt(a.TextIndex) - parseInt(b.TextIndex))
        
        // console.log(listTextWordsSorted)
        for(var ng1 = 0; ng1 < listRepeatedFieldGroups.length - nLineHalfRange; ng1++)
        {
            for(var ng2 = ng1 + nLineHalfRange + 1; ng2 < listRepeatedFieldGroups.length; ng2++)
            {
                //there are at least nWordsThatMustOverlapBetweenLineGroups different words in common
                var listOverlappingWordsIn1 = listRepeatedFieldGroups[ng1].filter(w1 => listRepeatedFieldGroups[ng2].
                    filter(w2 => this.WordsForGroupedByFieldPatternsAreEqual(w1, w2, sField)).length >= nWordsThatMustOverlapBetweenLineGroups)

                var listOverlappingFields = listOverlappingWordsIn1.map(w => this.GetValueForLensType(w, sField))
                
                //add a new group if the words have more than one distinct value for the field
                if(new Set(listOverlappingFields).size > 1)
                {
                    var listOverlappingWordsIn2 = listRepeatedFieldGroups[ng2].filter(w2 => listRepeatedFieldGroups[ng1].some(w1 => this.WordsForGroupedByFieldPatternsAreEqual(w1, w2, sField)))
                    var sName = sField

                    if(sField === 'mysem') 
                    {
                        listOverlappingFields = listOverlappingFields.flat()
                        sName = [...new Set(listOverlappingFields.map(oof => oof.Name))].sort().join(' ')
                    }

                    //listTextWordsSorted.filter(w => this.GroupedByFieldPatternsFieldValuesContainValue(listOverlappingFields, w, sField))
                    listToReturn.push({ListWords: listOverlappingWordsIn1.concat(listOverlappingWordsIn2), Name: sName})
                }
            }
        }

        return this.DeduplicateLensResults(listToReturn)
    }

    NearbyRepeatedSemanticPatternsLens(listFields)
    {
        var listToReturn = []

        for(var sField of listFields) //['LexicalID', 'ParentRoot', 'mysem']) 'sdbh'
        {
            listToReturn = listToReturn.concat(this.GetNearbyRepeatedSemanticPatterns(sField))
        }

        listToReturn.forEach((o, n) => o.Color = this.listLinkGroupColors[n % this.listLinkGroupColors.length])
        // console.log(listToReturn)

        return listToReturn
    }

    LinesWithCorrespondenceGroupsWordsInDifferentOrder(listTextWordsToUse, listLinesToUse)
    {
        var listSemanticGroups = this.GetSemanticChainsForCurrentChapter(listTextWordsToUse)

        var listSemanticGroupIndexesByLine = listLinesToUse.map(l => l.Words.flatMap(w => 
            listSemanticGroups.map((corr, n) => ({Corr: corr, N: n})).filter(o => o.Corr.ListWords.includes(w.TextIndex)).map(o => o.N)))
        //console.log(listSemanticGroupIndexesByLine)
        
        //9, 10, 17
        //10, 17, 9

        var listToReturn = []
        //var listLineIndexesFound = []

        for (var nLine1 = 0; nLine1 < listLinesToUse.length - 2; nLine1++)
        {
            let nLine2 = nLine1 + 1
            var listCorrGroupIndexes1 = listSemanticGroupIndexesByLine[nLine1]
            var listCorrGroupIndexes2 = listSemanticGroupIndexesByLine[nLine2]

            //get the group indexes that intersect between the lines
            var listInBoth1 = listCorrGroupIndexes1.filter(n => listCorrGroupIndexes2.includes(n))
            var listInBoth2 = listCorrGroupIndexes2.filter(n => listCorrGroupIndexes1.includes(n))

            //if(nLine1 === 18)
            //{
            //console.log(nLine1, nLine2, listInBoth1, listInBoth2, listInBoth1.map(n => listSemanticGroups[n].ListWords.map(sTextIndex => this.GetWordWithTextIndexInChapter(sTextIndex).Transliteration)))
            //}

            //if the first element is not the same, the overlapping semantic groups are in a different order between the lines
            if(listInBoth1[0] != listInBoth2[0])
            {
                for(var nSemanticGroup of listInBoth1)
                {
                    listToReturn.push({ListWords: listSemanticGroups[nSemanticGroup].ListWords.map(sTextIndex => this.GetWordWithTextIndexInChapter(sTextIndex))
                        .filter(w => listLinesToUse[nLine1].Words.includes(w) || listLinesToUse[nLine2].Words.includes(w)), 
                        Name: '', Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
                }

                //listLineIndexesFound.push(nLine1)
                //listLineIndexesFound.push(nLine2)
            }

            // var blnFound = false
            // for(var nCorrGroupIndex1 of listInBoth)
            // {
            //     if(blnFound) break
            //     for(var nOtherIndexIn1 of listCorrGroupIndexes2.filter(n => n != nCorrGroupIndex1))
            //     {
            //         var signOf1 = Math.sign(listCorrGroupIndexes1.indexOf(nCorrGroupIndex1) - listCorrGroupIndexes1.indexOf(nOtherIndexIn1))
            //         var signOf2 = Math.sign(listCorrGroupIndexes2.indexOf(nCorrGroupIndex1) - listCorrGroupIndexes2.indexOf(nOtherIndexIn1))

            //         if(signOf1 != signOf2)
            //         {
            //             blnFound = true
            //             break
            //         }
            //     }
            // }

            // if(blnFound)
            // {
            //     listLineIndexesFound.push(nLine1)
            //     listLineIndexesFound.push(nLine2)
            // }
        }

        //console.log(listWordsInChiasmsFound)
        return listToReturn
        //return [{ListWords: listLinesToUse.filter((l, nl) => listLineIndexesFound.includes(nl)).flatMap(l => l.Words), Name: '', Color: 'Blue'}]

        //check variance of relative position of the words within the line
        // var nCorrGroupIndexesByLine = this.state.listLines.map(l => l.Words.map(w => 
        //     this.listCorrespondencesForChapter.filter(corr => corr.ListWords.includes(w.TextIndex))))


        // var lineFor1 = listLinesToUse.find(l => l.Words.some(w => w === w1))
        // var nIndexInLineFor1 = lineFor1.Words.findIndex(w => w === w1)

        // //1,3 2 
        // //2 1,4
        // //4 1
        // listLinesToUse.map()
        // this.listCorrespondencesForChapter.map(o => o.ListWords)
        // g.ListWords.map(n => this.GetWordWithTextIndexInChapter(n)),
    
            
    }

    LinesThatArePerhapsTooLong(listLinesToUse)
    {
        //lines that have more than 3 accent groups. Maqqephs join words into accent groups.
        return [{ListWords: listLinesToUse.filter(l => l.Words.length - l.Words.filter(w => w.FullText.includes('־')).length > 3).flatMap(l => l.Words), Name: '', Color: 'Blue'}]
    }

    LinesWithNoVerbsLens(listLinesToUse)
    {
        return [{ListWords: listLinesToUse.filter(l => !l.Words.some(w => w.WordType === 'V')).flatMap(l => l.Words), Name: '', Color: 'Blue'}]
    }

    LinesWithFrontingBeforeVerbsLens(blnGroupByPhraseFunction)
    {
        //not c or d
        //all word types: {'V', 'R', 'T', 'C', 'A', 'P', 'D', 'N'}
        //group by phrase function
        // console.log(this.listClauses)

        var listFrontedWords = this.listClauses.flatMap(l => {
            var nIndexOfFirsVerb = l.Words.findIndex(w => w.WordType === 'V')
            if(nIndexOfFirsVerb < 0) return false
            return l.Words.slice(0, nIndexOfFirsVerb).filter(w => ['N', 'A', 'P', 'R'].includes(w.WordType))
        })

        if(blnGroupByPhraseFunction)
        {
            return Object.keys(this.GroupArrayByKey(listFrontedWords, 'phrase_function')).map((s, index) => {
                return {ListWords: listFrontedWords.filter(w => w.phrase_function === s), Name: s, 
                    Color: this.listLinkGroupColors[index % this.listLinkGroupColors.length]}
            })
        }
        else
        {
            return [{ListWords: listFrontedWords, Name: "Fronted", 
                Color: this.listLinkGroupColors[0]}]
        }
    }

    VerbsWithSuffixes(listTextWordsToUse, listLinesToUse)
    {
        var blnExcludeParticlesInLine = true
        var listWordsAtBeginningOfLines = listLinesToUse.flatMap(l => this.GetBeginningMiddleEnd(blnExcludeParticlesInLine ? l.Words.filter(w => !['T', 'R', 'C'].includes(w.WordType)) : l.Words).Beginning) 
           
        return [{ListWords: listTextWordsToUse.filter(w => listWordsAtBeginningOfLines.includes(w) && this.GetSuffixPGN(w) != ''), 'Color': 'Blue'}]
    }

    VocativesLens(listTextWordsToUse)
    {
        // var listToReturn = [{ListWords: [], Color: 'Red'}, {ListWords: [], Color: 'Purple'}, {ListWords: [], Color: 'Blue'}]

        // for(var w of this.listTextWordsForChapter.filter(w => w.phrase_function === 'Voct'))
        // {
        //     var oClause = this.GetClauseForWord(w, this.listClauses)
        //     if(oClause != undefined)
        //     {
        //         var nIndexInClause = oClause.Words.indexOf(w)
        //         // console.log(oClause)
        //         var nListToReturnIndex = nIndexInClause === 0 ? 0 : nIndexInClause === oClause.length - 1 ? 2 : 1
        //         listToReturn[nListToReturnIndex].ListWords.push(w)
        //     }
        // }

        return [{ListWords: listTextWordsToUse.filter(w => w.phrase_function === 'Voct'), Color: 'Blue'}]
    }

	GetOptionsForSemanticSearchAutoComplete()
	{
		//add options for semnode last, filtering out anything with a desc already in the options list.
		//{Desc: "psalmist", Type: "participantref"}, {Desc: "praise", Type: "semnode"}, {Desc: "because", Type: "semrole"}
		var listToReturn = [];

		var listParticipantCategories = this.listRepetitionLinkGroupCategories.filter(o => o.LinkGroupTypes.includes("2"));
		listToReturn = listToReturn.concat(listParticipantCategories.map(o => { return {Desc: "participant: " + o.Desc, IDs: o.ID, Type: "participantref"}}));
		listToReturn = listToReturn.concat([...new Set(listParticipantCategories.map(o => o.MainType))].
			filter(s => listParticipantCategories.filter(cat => cat.MainType === s).length > 1).
			map(s => { return {Desc: "participant: " + s, IDs: listParticipantCategories.filter(cat => cat.MainType === s).map(cat => cat.ID).join(","), Type: "maintypeparticipantref"}}));

		//listToReturn = listToReturn.concat(this.listSemanticRoles.map(o => { return {Desc: o.Keywords.join("/"), IDs: o.ID, Type: "semrole"}}));

		listToReturn = listToReturn.concat(this.listCustomSearchAdditionalOptions);	
		listToReturn = listToReturn.concat(this.state.listSemanticNodes.filter(node => !listToReturn.some(o => o.Desc === node.Names)).
			map(o => { return {Desc: o.Names, IDs: o.ID, Type: "semnode"}}));

		return listToReturn;
	}

	JoinSubterms(listSubterms)
	{
		var lastSubterm = listSubterms[listSubterms.length - 1];
		if(lastSubterm.includes("[") && !lastSubterm.includes("]")) listSubterms[listSubterms.length - 1] += "]";

		return listSubterms.join(" & ");
	}

	GetTermStringForOptionList(listOptions, nIndexOfTermGroup)
	{
		var listTermsWithCategory = listOptions.filter(o => o.TermCategory !== undefined);
		var listTermsWithoutCategory = listOptions.filter(o => o.TermCategory === undefined);

		var sForTermsWithCategory = Object.keys(this.GroupArrayByKey(listTermsWithCategory, "TermCategory")).map(s => {
			var commaMode = listTermsWithCategory[0].JoinWithComma;

			return s + ":" + (commaMode ? "" : "[") +
				listTermsWithCategory.filter(o => o.TermCategory === s).map(o => o.Value).join(commaMode ? "," : "") + 
				(commaMode ? "" : "]")
			}).join(" & ");

		return sForTermsWithCategory + (sForTermsWithCategory === "" || listTermsWithoutCategory.length === 0 ? "" : " & ") + 
			listTermsWithoutCategory.map(o => {
				if(o.Type === "literal") return o.Value;
				else if(o.Type === "participantref") return "participant:[" + o.IDs + "]";
				else if(o.Type === "semnode") return "nodeidforsemanticsearch:[" + o.IDs + "]";
				else if(o.Value === "backreference") return o.Value + "/" + nIndexOfTermGroup + 1;
			}).join(" & ");
	}

	CustomSearchLens(listSelectedOptions)
	{
		//var listSelectedOptions = this.state.listSelectedOptionsForSemanticSearch; //[{Desc: "psalmist", IDs: [1001], Type: "participantref"}, {Desc: "praise", IDs: [852], Type: "semnode"}];
		var customLens = this.state.listLenses.find(l => l.LensType === "custom");

		if(listSelectedOptions === undefined || listSelectedOptions.length < 1) 
		{
			this.setState({listWordGroupsForEnabledLenses: [{Lens: customLens, ListGroups: []}]});
			return; // [];
		}

		var listConstraintOptions = listSelectedOptions.filter(o => o.Type === "constraint");
		var sConstraint = listConstraintOptions.length === 0 ? "" : listConstraintOptions[0].Value;

		var listGroupByOptions = listSelectedOptions.filter(o => o.Type === "groupby");
		var sGroupBy = listGroupByOptions.length === 0 ? undefined : listGroupByOptions[0].Value;

		var listQueriesToDo = [];

		//only support one of these coocurrence requirements right now, as the highest level split of the query
		var listCooccurrenceRequirementsIndex = listSelectedOptions.findIndex(o => o.Type === "querygroupcooccurrencerequirement");
		var sQueryGroupCooccurrenceRequirement = listCooccurrenceRequirementsIndex === -1 ? undefined : listSelectedOptions[listCooccurrenceRequirementsIndex].Value;
		
		var selectedOptionListsByQuery = listCooccurrenceRequirementsIndex === -1 ? [listSelectedOptions] :
			[listSelectedOptions.slice(0, listCooccurrenceRequirementsIndex), listSelectedOptions.slice(listCooccurrenceRequirementsIndex + 1, listSelectedOptions.length)];

		for(var listSelectedOptionsForThisQuery of selectedOptionListsByQuery)
		{
			var listDemarcatingOptions = listSelectedOptionsForThisQuery.map((o, nIndex) => ({Option: o, IndexOfOption: nIndex})).
				filter(o => o.Option.Type === "followedby");

			var listTermGroups = listDemarcatingOptions.map((o, nIndex, arr) => {
				var nPreviousDemarcatingIndex = nIndex === 0 ? -1 : arr[nIndex - 1].IndexOfOption;
				return {Options: listSelectedOptionsForThisQuery.slice(nPreviousDemarcatingIndex + 1, o.IndexOfOption), Demarcator: o.Option};
			});
			
			//get the last segment
			var nLastDemarcatingIndex = listTermGroups.length === 0 ? -1 : listDemarcatingOptions[listDemarcatingOptions.length - 1].IndexOfOption;
			listTermGroups.push({Options: listSelectedOptionsForThisQuery.slice(nLastDemarcatingIndex + 1, listSelectedOptionsForThisQuery.length), Demarcator: undefined});

			//put them together
			var sTerms = listTermGroups.map((g, nIndexOfGroup) => this.GetTermStringForOptionList(g.Options, nIndexOfGroup) + 
				(g.Demarcator === undefined ? "" :
				g.Demarcator.Value === "followedimmediatelyby" ? "-" :
				g.Demarcator.Value === "followedby" ? "--" :
				g.Demarcator.Value === "occurswith" ? " occurswith " : "")).join("");

			listQueriesToDo.push({Name: "", Query: sTerms + (sTerms.length === 0 ? "" : sConstraint), GroupBy: sGroupBy});
		}

		var listResults = this.PerformLensQueries(listQueriesToDo, sQueryGroupCooccurrenceRequirement, false);
		this.setState({listWordGroupsForEnabledLenses: [{Lens: customLens, ListGroups: listResults}]});


		//TODO: add support for "and" ("or"?), what to use instead of -- so the term sequence can be in any order

		//this.state.listSelectedOptionsForSemanticSearch
		//because God help Israel psalmist so Israel psalmist praise God

		//participantinrole:[God],[agent,speaker,mover,innerstater] & semnode:[help] & participantinrole:[God],[reason] -- 
		//participantinrole:[Israel, psalmist],[o1] --
		// participantinrole:[Israel, psalmist],[s] & semnode:praise -- participantinrole:[God],[o] pgrp=0

		//{Desc: "psalmist", IDs: [1001], Type: "participantref"}, {Desc: "praise", IDs: [852], Type: "semnode"}, {Desc: "because", IDs: [], Type: "semrole"}
		
		// var sSubjectLikeRoleIDs = "1,2,3,4,5,6,7,8";
		// var sObject1LikeRoleID = "40";

		// var sTerms = "";
		// var nNumberOfTermsSoFar = 0;
		// var listSubTermsForCurrentTerm = [];
		// var sConstraint = "";
		// //var sCurrentRoleIDs = "";

		// for(var o of listSelectedOptions)
		// {
		// 	// if(o.Type === "semrole")
		// 	// {
		// 	// 	if(listSubTermsForCurrentTerm.length > 0) listTerms.push(listSubTermsForCurrentTerm.join(" & "));
		// 	// 	listSubTermsForCurrentTerm = [];
		// 	// 	sCurrentRoleIDs = o.IDs;
		// 	// }

		// 	if(o.Type === "participantref")
		// 	{
		// 		listSubTermsForCurrentTerm.push("participant:[" + o.IDs + "]");
		// 		//var sRoleIDsToUse = sCurrentRoleIDs != "" ? sCurrentRoleIDs : sSubjectLikeRoleIDs;
		// 		//listSubTermsForCurrentTerm.push("participantinrole:[" + o.IDs + "],[" + sRoleIDsToUse + "]");
		// 	}
		// 	else if(o.Type === "semnode")
		// 	{
		// 		listSubTermsForCurrentTerm.push("nodeidforsemanticsearch:[" + o.IDs + "]");
		// 		//if(sCurrentRoleIDs === "") sCurrentRoleIDs = sObject1LikeRoleID;
		// 	}
		// 	else if(o.Type === "constraint")
		// 	{
		// 		sConstraint = o.Constraint;
		// 	}
		// 	else if(o.Type === "TermCategory")
		// 	{
		// 		listSubTermsForCurrentTerm.push(o.Value + ":[");
		// 	}
		// 	else if(o.Type === "TermValue")
		// 	{
		// 		var sValueToAppend = o.Value;
		// 		var lastSubterm = listSubTermsForCurrentTerm[listSubTermsForCurrentTerm.length - 1];
		// 		if(!lastSubterm.endsWith("[")) sValueToAppend = "," + sValueToAppend;

		// 		listSubTermsForCurrentTerm[listSubTermsForCurrentTerm.length - 1] += sValueToAppend;
		// 	}
		// 	else if(o.Combiner === "followedby")
		// 	{
		// 		sTerms += this.JoinSubterms(listSubTermsForCurrentTerm) + "--";
		// 		listSubTermsForCurrentTerm = [];
		// 		nNumberOfTermsSoFar++;
		// 	}
		// 	else if(o.Combiner === "sameparticipantas")
		// 	{
		// 		//blah--nodeidforsemanticsearch:[1,2]--participant/2
		// 		sTerms += this.JoinSubterms(listSubTermsForCurrentTerm) + "--participant/" + nNumberOfTermsSoFar + 1;
		// 		listSubTermsForCurrentTerm = [];
		// 		nNumberOfTermsSoFar++;
		// 	}
		// }

		// sTerms += this.JoinSubterms(listSubTermsForCurrentTerm);

		// return this.PerformLensQueries([{Name: "", Query: sTerms + (sTerms.length === 0 ? "" : sConstraint)}], "", false);

		// //var sSentence = "God help"; //"because God help Israel,psalmist so Israel,psalmist praise God";
		// //participantinrole:[God],[agent] && sem:help	

		// //var participantRegex = new RegExp("(" + listAllParticipantDescs.join("|") + ")", "g");
        
		// // var rangeMatch = sMorphValue.match(/(\d+)/g);
		// // if (rangeMatch != null) 
		// // {
		// // 	if(rangeMatch[1] != undefined) rangeToMatch.Begin = parseInt(rangeMatch[1]);
		// // 	if(rangeMatch[2] != undefined) rangeToMatch.End = parseInt(rangeMatch[2]);
		// // }

		// // var listMatchingRolesForWord = this.GetWordTagForWord(w).SemanticRoles.filter(role => listRoleIDs.some(nID => role.RoleID === nID));
		// // var listAllParticipantsForWord = this.state.listRepetitionLinkGroups.
		// // 	filter(g => g.Type === 2 && g.ListWords.includes(w.TextIndex));

		// // var listMatchingParticipantsForWord = listAllParticipantsForWord.
		// // 	map(g => { return {IDs: g.ListTags.map(tag => tag.CategoryID), IsForSuffix: g.WordsForWhichParticipantRefIsForSuffix.includes(w.TextIndex)}}).
		// // 	filter(o => listParticipantIDs.some(nID => o.IDs.includes(nID)));
			


		// //split by booleans and/or
		// // var listByAndOr = sSentence.split(/(and|or)/);
		
		// // //split by keywords connected to semantic roles, like locatedat, when, so, because
		// // var list2 = sSentence.split(/(because|so|when|locatedat)/);
		// //if(s === "because")

	}

    ClauseOrderLens()
    {
        var listDifferentOrders = [...new Set(this.listTextWordsForChapter.flatMap(w => w.ClauseOrders))]
        
        var listToReturn = listDifferentOrders.map((s, index) => {
            return {ListWords: this.listTextWordsForChapter.filter(w => w.ClauseOrders != undefined && w.ClauseOrders.includes(s)), 
                Name: s, Color: this.listLinkGroupColors[index % this.listLinkGroupColors.length]}})

        return listToReturn.filter(o => o.ListWords.length > 1);
    }

    SDBHLens(sType)
    {
        var listToReturn = [];
        //{Domain: "Promise", Type: "Lexical", ListWords: ['1234']}

        if(this.state.nCurrentBook === 19)
        {
            listToReturn = this.listSDBH.filter(o => o.Type === sType && this.listTextWordsForChapter.
                some(w => o.ListWords.includes(parseInt(w.TextIndex)))).map((g,index) => {
                return {ListWords: g.ListWords.filter(n => this.listTextWordsForChapter.some(w => parseInt(w.TextIndex) === n)).
                    flatMap(n => this.listTextWordsForChapter.filter(w => parseInt(w.TextIndex) === n)), 
                    Name: g.Name, Color: this.listLinkGroupColors[index % this.listLinkGroupColors.length]}});
        }
        else
        {
            var listSDBHCategories = [...new Set(this.listTextWordsForChapter.flatMap(w => w.SDBH))]
            listToReturn = listSDBHCategories.map((s, index) => {
                return {ListWords: this.listTextWordsForChapter.filter(w => w.SDBH != undefined && w.SDBH.includes(s)), 
                    Name: s, Color: this.listLinkGroupColors[index % this.listLinkGroupColors.length]}})
        }

        return listToReturn.filter(o => o.ListWords.length > 1);
    }

    SDBHSubrangeLens(sType, nRangeBegin, nRangeEnd)
    {
        var listToReturn = [];
        var listToUse = this.listSDBH.filter(o => o.Type === sType).slice(nRangeBegin, nRangeEnd + 1)
        listToReturn = listToUse.filter(o => this.listTextWordsForChapter.
            some(w => o.ListWords.includes(parseInt(w.TextIndex)))).map((g,index) => {
            return {ListWords: g.ListWords.filter(n => this.listTextWordsForChapter.some(w => parseInt(w.TextIndex) === n)).
                flatMap(n => this.listTextWordsForChapter.filter(w => parseInt(w.TextIndex) === n)), 
                Name: g.Name, Color: this.listLinkGroupColors[index % this.listLinkGroupColors.length]}});
        
        // console.log(this.listSDBH.filter(o => o.Type === sType))
        return listToReturn.filter(o => o.ListWords.length > 1);
    }

    SDBHByNamesLens(sType, listNames)
    {
        var listToReturn = [];
        var listToUse = this.listSDBH.filter(o => o.Type === sType && listNames.includes(o.Name))
        listToReturn = listToUse.filter(o => this.listTextWordsForChapter.
            some(w => o.ListWords.includes(parseInt(w.TextIndex)))).map((g,index) => {
            return {ListWords: g.ListWords.filter(n => this.listTextWordsForChapter.some(w => parseInt(w.TextIndex) === n)).
                flatMap(n => this.listTextWordsForChapter.filter(w => parseInt(w.TextIndex) === n)), 
                Name: g.Name, Color: this.listLinkGroupColors[index % this.listLinkGroupColors.length]}});
        
        return listToReturn.filter(o => o.ListWords.length > 1);
    }

    GetSuffixOrPronounPGN(w)
    {
        return w.WordType === 'P' ?  this.GetPGN(w) : this.GetSuffixPGN(w)
    }

    SuffixPGNTransitionsWithinRefGroupLens()
    {
        var listToReturn = []
        var listHeadwordsWithTransitions = []

        for(var wHeadword of this.listTextWordsForChapter.filter(w => w.SubjRefsG != undefined))
        {
            //pronouns are found in the non-subject refs
            var listPGNsWithRef = this.listTextWordsForChapter.filter(w => wHeadword.SubjRefsG.includes(w.TextIndex)).map(w => ({W: w, PGN: this.GetPGN(w)}))
            var listSuffixPGNsWithRef = this.listTextWordsForChapter.filter(w => wHeadword.RefsG.includes(w.TextIndex)).map(w => ({W: w, PGN: this.GetSuffixOrPronounPGN(w)}))
            var listWordsInGroup = listPGNsWithRef.concat(listSuffixPGNsWithRef).filter(o => o.PGN != '').sort((a,b) => parseInt(a.W.TextIndex) - parseInt(b.W.TextIndex))

            if(listWordsInGroup.length > 0)
            {
                var listTransitionWords = []
                var listLastReferencePGN = listWordsInGroup[0].PGN
                // if(wHeadword.TextIndex === '70') console.log(listWordsInGroup[0], listLastReferencePGN)
                for(var o of listWordsInGroup)
                {
                    // if(wHeadword.TextIndex === '70') console.log(o)
                    if(o.PGN != listLastReferencePGN)
                    {
                        listTransitionWords.push(o.W)
                        listLastReferencePGN = o.PGN
                    }
                }

                if(listTransitionWords.length > 0)
                {
                    listHeadwordsWithTransitions.push(wHeadword)
                    listToReturn.push({ListWords: [wHeadword].concat(listTransitionWords), Name: this.GetGlossForWord(wHeadword), Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
                }
            }
        }

        //insert this at the beginning
        listToReturn.splice(0, 0, {ListWords: listHeadwordsWithTransitions, Name: 'Head of Group', Color: 'Gray', ColorPriority: 100})

        return listToReturn
    }

    SameRefGroupLens()
    {
        var listToReturn = []

        for(var wHeadword of this.listTextWordsForChapter.filter(w => w.RefsG != undefined))
        {
            listToReturn.push({ListWords: [wHeadword].concat(this.listTextWordsForChapter.filter(w => wHeadword.RefsG.includes(w.TextIndex)))
                .concat(this.listTextWordsForChapter.filter(w => wHeadword.SubjRefsG.includes(w.TextIndex))), 
                Name: this.GetGlossForWord(wHeadword), Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
        }

        return listToReturn
    }

    SuffixRefLens()
    {
        var listToReturn = [];
        var listRefs = new Set(this.listTextWordsForChapter.flatMap(w => w.Refs))

        for(var sRef of listRefs)
        {
            if(sRef != undefined)
            {
                var listNames = this.listTextWordsForChapter.filter(w => w.ID === sRef).map(w => this.GetGlossForWord(w))
                listToReturn.push({ListWords: this.listTextWordsForChapter.filter(w => w.ID === sRef || w.Refs.includes(sRef)), 
                    Name: listNames.length > 0 ? listNames[0] : "", Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]});
            }
        }

        return listToReturn;
    }

    SubjectRefLens()
    {
        var listToReturn = [];
        var listRefs = new Set(this.listTextWordsForChapter.flatMap(w => w.SubjRefs))

        for(var sRef of listRefs)
        {
            if(sRef != undefined)
            {
                var listNames = this.listTextWordsForChapter.filter(w => w.ID === sRef).map(w => this.GetGlossForWord(w))
                listToReturn.push({ListWords: this.listTextWordsForChapter.filter(w => w.ID === sRef || w.SubjRefs.includes(sRef)), 
                    Name: listNames.length > 0 ? listNames[0] : "", Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]});
            }
        }

        return listToReturn;
    }

    RefLens()
    {
        var listToReturn = [];
        var listRefs = new Set(this.listTextWordsForChapter.flatMap(w => [w.Refs, w.SubjRefs]).flat())

        for(var sRef of listRefs)
        {
            if(sRef != undefined)
            {
                var listNames = this.listTextWordsForChapter.filter(w => w.ID === sRef).map(w => this.GetGlossForWord(w))
                listToReturn.push({ListWords: this.listTextWordsForChapter.filter(w => w.ID === sRef || w.Refs.includes(sRef) || w.SubjRefs.includes(sRef)), 
                    Name: listNames.length > 0 ? listNames[0] : "", Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]});
            }
        }

        return listToReturn;
    }
    
    // SameReferenceDifferentPGNLens()
    // {
    //     var listToReturn = [];
    //     var listRefs = new Set(this.listTextWordsForChapter.flatMap(w => [w.Refs, w.SubjRefs]).flat())

    //     for(var sRef of listRefs)
    //     {
    //         if(sRef != undefined)
    //         {
    //             var listPGNsWithRef = this.listTextWordsForChapter.filter(w => w.SubjRefs.includes(sRef)).map(w => this.GetPGN(w))
    //             var listSuffixPGNsWithRef = this.listTextWordsForChapter.filter(w => w.Refs.includes(sRef)).map(w => this.GetSuffixPGN(w))
    //             var listAllPGNsForRef = listPGNsWithRef.concat(listSuffixPGNsWithRef)

    //             // if(sRef === "19002002008")
    //             // {
    //             //     console.log(listAllPGNsForRef.filter(spgn => spgn != undefined && spgn != ''))
    //             // }

    //             var listDifferentPGNs = [...new Set(listAllPGNsForRef.filter(spgn => spgn != undefined && spgn != ''))]

    //             if(listDifferentPGNs.length > 1)
    //             {
    //                 var listNames = this.listTextWordsForChapter.filter(w => w.ID === sRef).map(w => this.GetGlossForWord(w))
    //                 listToReturn.push({ListWords: this.listTextWordsForChapter.filter(w => w.ID === sRef || w.Refs.includes(sRef) || w.SubjRefs.includes(sRef)), 
    //                     Name: (listNames.length > 0 ? listNames[0] + ' ' : "") + listDifferentPGNs.join(', '), Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
    //             }
    //         }
    //     }

    //     return listToReturn
    // }

    OccurrencesLens()
    {
        var listToReturn = [{Name: '<= 2', Color: 'Purple', ListWords: []}, {Name: '3-5', Color: 'Red', ListWords: []}, 
            {Name: '6-10', Color: 'Orange', ListWords: []}, {Name: '11-20', Color: 'Green', ListWords: []}]

        for(var w of this.listTextWordsForChapter)
        {
            var nOccs = parseInt(w.Occurrences)

            if(nOccs <= 2) listToReturn[0].ListWords.push(w)
            else if(nOccs >= 3 && nOccs <= 5) listToReturn[1].ListWords.push(w)
            else if(nOccs >= 6 && nOccs <= 10) listToReturn[2].ListWords.push(w)
            else if(nOccs >= 11 && nOccs <= 20) listToReturn[3].ListWords.push(w)
        }

        return listToReturn
    }

    GlobalSemanticSimilarityLens()
    {
        var listToReturn = [{Name: '', Color: 'Purple', ListWords: []}, {Name: '', Color: 'Red', ListWords: []}, 
        {Name: '', Color: 'Orange', ListWords: []}, {Name: '', Color: 'Green', ListWords: []}, 
        {Name: '', Color: 'Gray', ListWords: []}, {Name: '', Color: 'LightGray', ListWords: []}]

        for(var w of this.listTextWordsForChapter)
        {
            var nScore = w.GlobalSim
            //0.02, 0.46, 0.065, 0.088, 0.12
            //0.0009, 0.015, 0.03, 0.05, 0.1
            if(nScore >= 0.12) listToReturn[0].ListWords.push(w)
            else if(nScore >= 0.088  && nScore < 0.12) listToReturn[1].ListWords.push(w)
            else if(nScore >= 0.065 && nScore < 0.088) listToReturn[2].ListWords.push(w)
            else if(nScore >= 0.46 && nScore < 0.065) listToReturn[3].ListWords.push(w)
            else if(nScore >= 0.02 && nScore < 0.46) listToReturn[4].ListWords.push(w)
            else if(nScore >= 0.01 && nScore < 0.02) listToReturn[5].ListWords.push(w)

            // if(nScore >= 30) listToReturn[0].ListWords.push(w)
            // else if(nScore >= 25 && nScore < 30) listToReturn[1].ListWords.push(w)
            // else if(nScore >= 20 && nScore < 25) listToReturn[2].ListWords.push(w)
            // else if(nScore >= 15 && nScore < 20) listToReturn[3].ListWords.push(w)
            // else if(nScore >= 10 && nScore < 15) listToReturn[4].ListWords.push(w)
            // else if(nScore >= 5 && nScore < 10) listToReturn[5].ListWords.push(w)
        }

        return listToReturn
    }

    MainSemanticDomainsLens()
    {
        var listToReturn = [];

        //{"Name":"society and relationship","Text":"8183^רָצוֹן^goodwill}
        listToReturn = this.listMainSemanticDomains.map((o,index) => {              
            return {ListWords: o.LexicalIDs.filter(s => this.listTextWordsForChapter.some(w => w.LexicalID === s)).
                flatMap(s => this.listTextWordsForChapter.filter(w => w.LexicalID === s)), 
                Name: o.Name, Color: this.listLinkGroupColors[index % this.listLinkGroupColors.length]}});

        return listToReturn.filter(o => o.ListWords.length > 1);
    }

    SemanticGroupsFromGlossesTogetherLens()
    {
        var listToReturn = []
        var listBSGs = new Set(this.listTextWordsForChapter.flatMap(w => [w.BSGs]).flat())

        for(var nID of listBSGs)
        {
            if(nID != undefined)
            {
                var listWordsForID = this.listTextWordsForChapter.filter(w => w.BSGs.includes(nID))
                if(listWordsForID.length > 1)
                {
                    listToReturn.push({ListWords: listWordsForID, Name: this.listBSGs.find(oBSG => oBSG.ID === nID).GroupName, 
                        Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
                }
            }
        }

        return listToReturn
    }

    SemanticGroupsFromGlossesIndividualLens(nGroupID)
    {
        return [{ListWords: this.listTextWordsForChapter.filter(w => w.BSGs.includes(nGroupID)), 'Color': 'Purple'}]
    }

    LoweNidaLens(listTextWordsToUse)
    {
        var listToReturn = [];
        var groupedByLexicalID = this.GroupArrayByKey(listTextWordsToUse, "LN");
        for(var k of Object.keys(groupedByLexicalID))
        {
            if(groupedByLexicalID[k].length > 1)
            {
                var listInstancesOfWord = groupedByLexicalID[k]
                var sTextOfAllInstances = listInstancesOfWord.map(w1 => w1.FullText).join(' ')
                listInstancesOfWord.forEach(w1 => w1.InfoForRepLens = sTextOfAllInstances)

                listToReturn.push({ListWords: listInstancesOfWord, Name: k,
                    Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
            }
        }
        return listToReturn;
    }
    
    ThematicStatementsLens(listTextWordsToUse)
    {
        var listToReturn = []
        for(var ots of this.listThematicStatements)
        {
            var listWordsWithStatement = listTextWordsToUse.filter(w => w.ThematicStatementIDs != undefined && w.ThematicStatementIDs.includes(ots.ID))
            if(listWordsWithStatement.length > 0)
            {
                listToReturn.push({ListWords: listWordsWithStatement, Name: ots.Name, 
                    ByLine: true, Lines: [...new Set(listWordsWithStatement.map(w => this.GetLineContainingWord(w)))],
                    Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
            }
        }
        return listToReturn
    }

    GeneralLens(listTextWordsToUse, sLensType)
    {
        var listGroups = []
        var colorArray = this.GetColorArrayForLensType(sLensType);
        if(colorArray != null)
        {
            for(var k of Object.keys(colorArray))
            {
                var listWordsWithValue = listTextWordsToUse.filter(w => this.GetValueForLensType(w, sLensType) === k);
                if(listWordsWithValue.length > 0)
                    listGroups.push({ListWords: listWordsWithValue, Name: this.MapValueToNameForLensType(k, sLensType), 
                        Color: this.GetLensColorForValue(listWordsWithValue[0], sLensType, colorArray)});
            }
        }

        return listGroups
    }

	GetPossibleTextMappingsForTagVariable(listSemanticDomains)
	{
		//{Domain: "Promise", Type: "Lexical", ListWords: ['1234']}
		var listFromSDBH = this.listSDBH.filter(o => listSemanticDomains.includes(o.Domain)).
			flatMap(o => this.listTextWordsForChapter.filter(w => o.ListWords.some(s => w.LexicalID === s)));

        //{"Name":"society and relationship","Text":"8183^רָצוֹן^goodwill}
        var listFromMine = this.listMainSemanticDomains.filter(o => listSemanticDomains.includes(o.Name)).    
			flatMap(o => this.listTextWordsForChapter.filter(w => o.LexicalIDs.some(s => w.LexicalID === s)));

        return listFromSDBH.concat(listFromMine);
	}

    FilterLensWordGroupsByIntraOrInterUnitsLensScope(listWordGroups)
    {
        if(this.state.sIntraOrInterUnitsLensScope === 'between' || this.state.sIntraOrInterUnitsLensScope === 'inside')
        {
            var listWordsByBreakGroup = this.GetWordsByBreakGroup(this.state.listLines, this.state.sGroupLinesBy)

            return listWordGroups.filter(g => {
                var nNumberOfGroupsTheyOccurIn = [...new Set(g.ListWords.map(w => listWordsByBreakGroup.findIndex(lw => lw.includes(w))))].length
                if(this.state.sIntraOrInterUnitsLensScope === 'between') return nNumberOfGroupsTheyOccurIn > 1
                else return nNumberOfGroupsTheyOccurIn === 1
            })
        }
        else return listWordGroups
    }

    GetWordGroupsForEnabledLenses(listLinesToUse, listSyllablesToUse)
    {
        var listToReturn = [];

        let listTextWordsToUse = (this.state.blnExcludeSuperscriptionFromLenses ? listLinesToUse.filter(l => !l.IsSuperscription) : listLinesToUse)
            .flatMap(l => l.Words)
            
        // console.log(this.PerformLensQueries([{"Name":"Waw","Query":"waw:1"}], '', true))
        
        //make lenses prettier, circles with gradient downward?
        for(var l of this.state.listLenses.filter(l => l.Enabled || l.Sticky))
        {
            if(l.Queries != undefined)
                listToReturn.push({Lens: l, ListGroups: this.PerformLensQueries(l.Queries, '', true)})
            else if(l.LensType === "BookendingInSameUnit")
                listToReturn.push({Lens: l, ListGroups: this.BookendingInSameUnitLens()})
            else if(l.LensType === "ConsecutiveUnitLinks")
                listToReturn.push({Lens: l, ListGroups: this.ConsecutiveUnitLinksLens()})
            else if(l.LensType === "AllUnitLinks")
                listToReturn.push({Lens: l, ListGroups: this.AllUnitLinksLens(l.ShowRepeatedWordsNotIncludedHere, l.OnlyShowBeginningAndEndLinks, l.ShowIntraUnitLinks)})
            else if(l.LensType === "UnitBeginningMiddleEnd")
                listToReturn.push({Lens: l, ListGroups: this.UnitBeginningMiddleEndLens()})
            else if(l.LensType === "repwords")
                listToReturn.push({Lens: l, ListGroups: this.RepeatedWordsLens(listTextWordsToUse)});
            else if(l.LensType === "reproots")
				listToReturn.push({Lens: l, ListGroups: this.RepeatedRootsLens(listTextWordsToUse, l.OnlyShowGroupsWithDifferentGlosses)});
            else if(l.LensType === "reprootsmindiff")
				listToReturn.push({Lens: l, ListGroups: this.RepeatedRootMinimumDifferenceLens(listTextWordsToUse, listLinesToUse)})
            else if(l.LensType === "reprootsnumrepeats")
				listToReturn.push({Lens: l, ListGroups: this.RepeatedRootNumberOfRepeatsLens(listTextWordsToUse)})
            else if(l.LensType === "reprootsmaxdistance")
				listToReturn.push({Lens: l, ListGroups: this.RepeatedRootMaxDistanceLens(listTextWordsToUse)})

            else if(l.LensType === "phrasetype")
                listToReturn.push({Lens: l, ListGroups: this.GroupArrayByKeyLens('phrase_type', listTextWordsToUse)})
            else if(l.LensType === "clausetype")
                listToReturn.push({Lens: l, ListGroups: this.GroupArrayByKeyLens('clause_typ', listTextWordsToUse)})

			else if(l.LensType === "corr")
			{
				listToReturn.push({Lens: l, ListGroups: this.CorrespondenceLens(l, this.state.listCorrespondenceCategoriesToShowInLens, true)});
				//this.CorrespondenceLens(l, this.state.listCorrespondenceCategoriesToShowInLens, true);
				//return;
			}
            else if(l.LensType === "corrsimilaroropposite")
			{
                //['28', '312', '310', '74', '308', '66', '69', '304'] 75 is questionable
				listToReturn.push({Lens: l, ListGroups: this.CorrespondenceLens(l, [{ID: '28'}, {ID: '312'}, {ID: '310'}, 
                    {ID: '74'}, {ID: '308'}, {ID: '66'}, {ID: '69'}, {ID: '304'}], false)})
			}
            else if(l.LensType === "allnearbyrepetition")
                listToReturn.push({Lens: l, ListGroups: this.AllNearbyRepetitionLens(l, listTextWordsToUse, listLinesToUse, false)})
            else if(l.LensType === "semanticchainscoloredbychainlength")
                listToReturn.push({Lens: l, ListGroups: this.AllNearbyRepetitionLens(l, listTextWordsToUse, listLinesToUse, true)})

			// else if(l.LensType === "custom")
			// 	listToReturn.push({Lens: l, ListGroups: this.CustomSearchLens()});
            else if(l.LensType === "wordrhythm")
                listToReturn.push({Lens: l, ListGroups: this.WordRhythmLens(listTextWordsToUse)})

            else if(l.LensType === "ChangeInSyllablesPerLineInLastLineOfLevel1Unit")
                listToReturn.push({Lens: l, ListGroups: this.ChangeInSyllablesPerLineInLastLineOfLevel1UnitLens(listLinesToUse)})
            else if(l.LensType === "NumberOfSyllablesInLineIncreaseOrDecreaseChainsAllLines")
                listToReturn.push({Lens: l, ListGroups: this.NumberOfSyllablesInLineIncreaseOrDecreaseChainsAllLinesLens(listLinesToUse)})
            else if(l.LensType === "NumberOfSyllablesInLineIncreaseOrDecreaseChainsLevel1UnitBoundaries")
                listToReturn.push({Lens: l, ListGroups: this.NumberOfSyllablesInLineIncreaseOrDecreaseChainsLevel1UnitBoundariesLens(listLinesToUse)})
            else if(l.LensType === "FindLineSyllableCountThemes")
                listToReturn.push({Lens: l, ListGroups: this.FindLineSyllableCountThemesLens(listLinesToUse)})
                

            else if(l.LensType === "NumberOfSyllablesInLine")
                listToReturn.push({Lens: l, ListGroups: this.NumberOfSyllablesInLineLens(listLinesToUse)})
            else if(l.LensType === "NumberOfWordsInLine")
                listToReturn.push({Lens: l, ListGroups: this.NumberOfWordsInLineLens(listLinesToUse)})
            else if(l.LensType === "NumberOfFullAccentsInLine")
                listToReturn.push({Lens: l, ListGroups: this.NumberOfFullAccentsInLineLens(listLinesToUse)})
            else if(l.LensType === "NumberOfPenultimateAccentsInLine")
                listToReturn.push({Lens: l, ListGroups: this.NumberOfPenultimateAccentsInLineLens(listLinesToUse)})

            else if(l.LensType === "InterstressLengthOrderInLine")
                listToReturn.push({Lens: l, ListGroups: this.InterstressLengthOrderInLineLens(listLinesToUse)})
            else if(l.LensType === "AverageInterstressLengthPerLine")
                listToReturn.push({Lens: l, ListGroups: this.AverageInterstressLengthPerLineLens(listLinesToUse)})

            else if(l.LensType === "handtaggedrhymegroups")
                listToReturn.push({Lens: l, ListGroups: this.HandTaggedRhymeGroupsLens(listTextWordsToUse)})
            else if(l.LensType === "handtaggedsemanticchains")
                listToReturn.push({Lens: l, ListGroups: this.SemanticChainsLens(listTextWordsToUse)})

            else if(l.LensType === "handtaggedconnections")
                listToReturn.push({Lens: l, ListGroups: this.ConnectionsLens(listTextWordsToUse, '')})
            else if(l.LensType === "handtaggedconnectionsunitoffirstoccurrence")
                listToReturn.push({Lens: l, ListGroups: this.ConnectionsLens(listTextWordsToUse, 'unitoffirstoccurrence')})
            else if(l.LensType === "handtaggedconnectionspercentageofunitsitoccursin")
                listToReturn.push({Lens: l, ListGroups: this.ConnectionsLens(listTextWordsToUse, 'percentageofunitsitoccursin')})
            else if(l.LensType === "ConnectionsGeneratedFromSemanticLinksPreview")
                listToReturn.push({Lens: l, ListGroups: this.ConnectionsFromSemanticLinksPreviewLens('')})                
            else if(l.LensType === "ConnectionsGeneratedFromSemanticLinksPreviewunitoffirstoccurrence")
                listToReturn.push({Lens: l, ListGroups: this.ConnectionsFromSemanticLinksPreviewLens('unitoffirstoccurrence')})
                
            else if(l.LensType === "RepetitionUnitLevelsPerWord")
                listToReturn.push({Lens: l, ListGroups: this.RepetitionUnitLevelsPerWordLens(listTextWordsToUse)})

            else if(l.LensType === "FirstWordInSemanticChains")
                listToReturn.push({Lens: l, ListGroups: this.FirstWordInSemanticChainsLens(listTextWordsToUse)})
            else if(l.LensType === "SemanticChainsByLocation")
                listToReturn.push({Lens: l, ListGroups: this.SemanticChainsByLocationLens(listTextWordsToUse)})

            else if(l.LensType === "morphologicalchainsbetweenlines")
                listToReturn.push({Lens: l, ListGroups: this.MorphologicalChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse, this.state.nChainCutoffValue)})
            else if(l.LensType === "semanticchainsbetweenlines")
                listToReturn.push({Lens: l, ListGroups: this.SemanticChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse)})
            else if(l.LensType === "lexicalchainsbetweenlines")
                listToReturn.push({Lens: l, ListGroups: this.LexicalChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse, this.state.nChainCutoffValue)})
            else if(l.LensType === "soundchainsbetweenlines")
                listToReturn.push({Lens: l, ListGroups: this.SoundChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse)})
            else if(l.LensType === "syllablechainsbetweenlines")
                listToReturn.push({Lens: l, ListGroups: this.SyllableChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse)})  
            else if(l.LensType === "soundsequencechainsbetweenlines")
                listToReturn.push({Lens: l, ListGroups: this.SoundSequenceChainsBetweenLinesLens(listTextWordsToUse, listLinesToUse)})    
                
            else if(l.LensType === "WordsBySoundGroupCombination")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'combination')})
            else if(l.LensType === "WordsBySoundGroupSameAccentedSyllable")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'SameAccentedSyllable')})
            else if(l.LensType === "SameAccentedVowelWithNoOrCompatibleFinalConsonant")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'SameAccentedVowelWithNoOrCompatibleFinalConsonant')})
            else if(l.LensType === "SameAccentedVowelWithNoOrCompatibleFinalConsonantOrInitialSoundGroup")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'SameAccentedVowelWithNoOrCompatibleFinalConsonantOrInitialSoundGroup')})
            else if(l.LensType === "WordsBySoundGroupInitialConsonantOfStressedSyllable")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'WordsBySoundGroupInitialConsonantOfStressedSyllable')})
                
            else if(l.LensType === "WordsBySoundGroupConsonant")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'WordsBySoundGroupConsonant')})
            else if(l.LensType === "WordsBySoundGroupFinalConsonant")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'WordsBySoundGroupFinalConsonant')})

            else if(l.LensType === "WordsBySoundGroupInitial")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse,'initial')})
            else if(l.LensType === "WordsBySoundGroupFinal")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'final')})
            else if(l.LensType === "WordsBySoundGroupsInitialAndFinal")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'oneinitialsyllableandoneinfinalsyllable')})
            else if(l.LensType === "WordsBySoundGroupAnywhere")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'anywhere')})
                
            else if(l.LensType === "syllablerhyme")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'anywhere')})

            else if(l.LensType === "WordsBySoundGroupFinalSyllableWithoutInitialConsonant")
                listToReturn.push({Lens: l, ListGroups: this.WordsBySoundGroupLens(listTextWordsToUse, 'finalsyllablewithoutinitialconsonant')})

            else if(l.LensType === "LastSyllableForRhyme")
                listToReturn.push({Lens: l, ListGroups: this.LastSyllableForRhymeLens(listTextWordsToUse)})
                
            else if(l.LensType === "rhymechainsbetweenlines")
                listToReturn.push({Lens: l, ListGroups: this.RhymeChainsBetweenLinesLens()})
                
            else if(l.LensType === "NumberOfChainsBetweenLinesByWord")
                listToReturn.push({Lens: l, ListGroups: this.NumberOfChainsBetweenLinesByWordLens(listTextWordsToUse, listLinesToUse)})

            else if(l.LensType === "samedifferent")
                listToReturn.push({Lens: l, ListGroups: this.SameDifferentLens()});
            else if(l.LensType === "allref")
                listToReturn.push({Lens: l, ListGroups: this.RefLens()})
            else if(l.LensType === "sfxref")
                listToReturn.push({Lens: l, ListGroups: this.SuffixRefLens()})
            else if(l.LensType === "subjectref")
                listToReturn.push({Lens: l, ListGroups: this.SubjectRefLens()})
            else if(l.LensType === "SameRefGroup")
                listToReturn.push({Lens: l, ListGroups: this.SameRefGroupLens()})
            else if(l.LensType === "SuffixPGNTransitionsWithinRefGroup")
                listToReturn.push({Lens: l, ListGroups: this.SuffixPGNTransitionsWithinRefGroupLens()})
            // else if(l.LensType === "refswithdifferentpgn")
            //     listToReturn.push({Lens: l, ListGroups: this.SameReferenceDifferentPGNLens()});
            else if(l.LensType === "occs")
                listToReturn.push({Lens: l, ListGroups: this.OccurrencesLens()});
            else if(l.LensType === "globalsemanticsimilarity")
                listToReturn.push({Lens: l, ListGroups: this.GlobalSemanticSimilarityLens()});
            else if(l.LensType === "lowenida")
                listToReturn.push({Lens: l, ListGroups: this.LoweNidaLens(listTextWordsToUse)})
            else if(l.LensType === "sdbhlex")
                listToReturn.push({Lens: l, ListGroups: this.SDBHLens("l")});
            else if(l.LensType === "sdbhcont")
                listToReturn.push({Lens: l, ListGroups: this.SDBHLens("c")});
            else if(l.LensType === "sdbhcomposite")
                listToReturn.push({Lens: l, ListGroups: this.SDBHLens("composite")});
            else if(l.LensType === "sdbhcompositerange")
                listToReturn.push({Lens: l, ListGroups: this.SDBHSubrangeLens("composite", l.Range[0], l.Range[1])});
            else if(l.LensType === "sdbhcompositebyname")
                listToReturn.push({Lens: l, ListGroups: this.SDBHByNamesLens("composite", l.Names)});
            else if(l.LensType === "mysemdom")
                listToReturn.push({Lens: l, ListGroups: this.MainSemanticDomainsLens()});
            else if(l.LensType === "SemanticGroupsFromGlossesTogether")
                listToReturn.push({Lens: l, ListGroups: this.SemanticGroupsFromGlossesTogetherLens(l.GroupID)})
            else if(l.LensType === "SemanticGroupsFromGlossesIndividual")
                listToReturn.push({Lens: l, ListGroups: this.SemanticGroupsFromGlossesIndividualLens(l.GroupID)})
            else if(l.LensType === "thematicstatements")
                listToReturn.push({Lens: l, ListGroups: this.ThematicStatementsLens(listTextWordsToUse)})
            else if(l.LensType === "noverb")
                listToReturn.push({Lens: l, ListGroups: this.LinesWithNoVerbsLens(listLinesToUse)})
            else if(l.LensType === "frontinggroupedbyphrasefunction")
                listToReturn.push({Lens: l, ListGroups: this.LinesWithFrontingBeforeVerbsLens(true)})
            else if(l.LensType === "fronting")
                    listToReturn.push({Lens: l, ListGroups: this.LinesWithFrontingBeforeVerbsLens(false)})
            else if(l.LensType === "vocatives")
                listToReturn.push({Lens: l, ListGroups: this.VocativesLens(listTextWordsToUse)})
            else if(l.LensType === "MostLikelyReiterations")
                listToReturn.push({Lens: l, ListGroups: this.MostLikelyReiterationsLens()})
            else if(l.LensType === "LinesThatArePerhapsTooLong")
                listToReturn.push({Lens: l, ListGroups: this.LinesThatArePerhapsTooLong(listLinesToUse)})
            else if(l.LensType === "letter")
                listToReturn.push({Lens: l, ListGroups: this.CharLens(l.LettersToFind)})
            else if(l.LensType === "wordswithpenultimateaccent")
                listToReturn.push({Lens: l, ListGroups: this.WordsWithPenultimateAccentLens(l.LettersToFind)})
                
            else if(l.LensType === "dagesh")
                listToReturn.push({Lens: l, ListGroups: this.DageshLens(listTextWordsToUse)})
            else if(l.LensType === "constructstate")
                listToReturn.push({Lens: l, ListGroups: this.ConstructStateLens(listTextWordsToUse)})
            else if(l.LensType === "particles")
                listToReturn.push({Lens: l, ListGroups: this.ParticlesLens(listTextWordsToUse)})
            else if(l.LensType === "localdensity")
                listToReturn.push({Lens: l, ListGroups: this.LocalDensityLens(l.DensityType)});
            else if(l.LensType === "patterninfield")
                listToReturn.push({Lens: l, ListGroups: this.PatternLens()})
            else if(l.LensType === "patterninfield_density")
                listToReturn.push({Lens: l, ListGroups: this.PatternDensityLens()})
            else if(l.LensType === "nearby_repeated_semantic_patterns")
                listToReturn.push({Lens: l, ListGroups: this.NearbyRepeatedSemanticPatternsLens(l.Fields)})
            else if(l.LensType === "LinesWithCorrespondenceGroupsWordsInDifferentOrder")
                listToReturn.push({Lens: l, ListGroups: this.LinesWithCorrespondenceGroupsWordsInDifferentOrder(listTextWordsToUse, listLinesToUse)});
            else if(l.RepetitionLinkGroupType != undefined)
                listToReturn.push({Lens: l, ListGroups: this.RepetitionLinkGroupLens(l.RepetitionLinkGroupType, l.ListTags)});
            else if(l.LensType === "ellipsis")
                listToReturn.push({Lens: l, ListGroups: this.EllipsisLens(listTextWordsToUse)})
                
            else if(l.LensType === "pforder")
                listToReturn.push({Lens: l, ListGroups: this.PropertyOrderLens('phrase_function', listLinesToUse)}) //this.ClauseOrderLens()
            else if(l.LensType === "ptorder")
                listToReturn.push({Lens: l, ListGroups: this.PropertyOrderLens('phrase_type', listLinesToUse)})
            else if(l.LensType === "ctorder")
                listToReturn.push({Lens: l, ListGroups: this.PropertyOrderLens('clause_typ', listLinesToUse)})

            else if(l.LensType === "interrogative")
                listToReturn.push({Lens: l, ListGroups: this.InterrogativeLens(listTextWordsToUse)})
            else if(l.LensType === "MaxAllSimilarity")
                listToReturn.push({Lens: l, ListGroups: this.MaxAllSimilarityLens()})
            else if(l.LensType === "AggregateAllSimilarityBetweenWordLists")
                listToReturn.push({Lens: l, ListGroups: this.AggregateAllSimilarityBetweenWordListsLens(l.AggregateType)})
            else if(l.LensType === "SimilarWordsGroupedTogether")
                listToReturn.push({Lens: l, ListGroups: this.SimilarWordsGroupedTogetherLens(listTextWordsToUse, listLinesToUse)})
            else if(l.LensType === "SimilarLinesGroupedTogether")
                listToReturn.push({Lens: l, ListGroups: this.SimilarLinesGroupedTogetherLens(listLinesToUse)})
            else if(l.LensType === "SimilarStanzasGroupedTogether")
                listToReturn.push({Lens: l, ListGroups: this.SimilarStanzasGroupedTogetherLens(listLinesToUse)})
            else if(l.LensType === "verbswithsuffixes")
                listToReturn.push({Lens: l, ListGroups: this.VerbsWithSuffixes(listTextWordsToUse, listLinesToUse)})
            else if(l.LensType === "syllablerhymecumulativeamount")
                listToReturn.push({Lens: l, ListGroups: this.SyllableRhymeCumulativeAmountLens(listSyllablesToUse)})
            else
            {
                listToReturn.push({Lens: l, ListGroups: this.GeneralLens(listTextWordsToUse, l.LensType)})
            }
        }

        listToReturn.forEach(o => o.ListGroups = this.FilterLensWordGroupsByIntraOrInterUnitsLensScope(o.ListGroups))
        return listToReturn
    }
    
    SetWordGroupsForEnabledLenses()
    {
        let blnEachRepetitionGroupShouldSpanMultipleChapters = this.state.listCurrentChapters.length > 1
        var listWordGroupsForEnabledLensesToSet = this.GetWordGroupsForEnabledLenses(this.state.listLines, this.listSyllablesForChapter)

        if(blnEachRepetitionGroupShouldSpanMultipleChapters)
        {
            for(var n = 0; n < listWordGroupsForEnabledLensesToSet.length; n++)
            {
                listWordGroupsForEnabledLensesToSet[n].ListGroups = listWordGroupsForEnabledLensesToSet[n].ListGroups
                .filter(g => [...new Set(g.ListWords.filter(w => w !== undefined).map(w => w.Chapter))].length > 1)
            }
        }

        this.setState({listWordGroupsForEnabledLenses: 
            //this.listTextWordsForChapter, 
            listWordGroupsForEnabledLensesToSet}, () => {
            this.GenerateDevelopmentDiagramForChapterIfShowing()
        })

        // if(this.blnDevView && this.state.blnGlobalDistributionForQueries && this.state.blnShowWordDotChart) this.SetDataForDotChartForAllPsalms()
    }

    ChangeLensEnabled(lens, blnValue)
    {
        lens.Enabled = blnValue;
		var listToSet = this.state.listLenses;

        if(lens.LensType != undefined && lens.LensType.startsWith('allsimilarity') && !blnValue && this.state.listWordGroupsForCurrentHoverTypeLens.length > 0) 
            this.setState({listWordGroupsForCurrentHoverTypeLens: []})

        this.setState({listLenses: listToSet}, this.SetWordGroupsForEnabledLenses())
    }

    EnableSingleLens(lensToEnable)
    {
		var listToSet = this.state.listLenses
        listToSet.forEach(l => {
            l.Enabled = false
            l.Sticky = false
        })

        lensToEnable.Enabled = true
        lensToEnable.Sticky = true
        this.setState({listLenses: listToSet}, this.SetWordGroupsForEnabledLenses())
    }

    ChangeLensSticky(lens, blnValue)
    {
        lens.Sticky = blnValue;
		var listToSet = this.state.listLenses;
		if(lens.LensType === "custom") this.setState({blnShowSemanticSearchAutocomplete: lens.Sticky});
        this.setState({listLenses: listToSet}, this.SetWordGroupsForEnabledLenses())
    }

    AllHoveredOrStickiedWordsForLens()
    {
        return this.state.listCurrentStickiedWordsForHoverLens.concat([this.state.currentWordForHoverLens])
    }

    WordIsStickiedOrHovered(w)
    {
        return this.AllHoveredOrStickiedWordsForLens().includes(w)
    }

    GetHoveredOrFirstStickiedWordForLens()
    {
        return this.state.listCurrentStickiedWordsForHoverLens.length > 0 ? this.state.listCurrentStickiedWordsForHoverLens[0] :
            this.state.currentWordForHoverLens != undefined ? this.state.currentWordForHoverLens : undefined
    }

    GetHoveredOrFirstStickiedSyllableForLens()
    {
        return this.state.listCurrentStickiedSyllablesForHoverLens.length > 0 ? this.state.listCurrentStickiedSyllablesForHoverLens[0] :
            this.state.currentSyllableForHoverLens != undefined ? this.state.currentSyllableForHoverLens : undefined
    }

    SomeWordIsStickiedOrHovered()
    {
        return this.state.currentWordForHoverLens != undefined || this.state.listCurrentStickiedWordsForHoverLens.length > 0 //this.state.listWordsHoveredWhileDragging != undefined && this.state.listWordsHoveredWhileDragging.length > 0 
    }
    
    SomeSyllableIsStickiedOrHovered()
    {
        return this.state.currentSyllableForHoverLens != undefined || this.state.listCurrentStickiedSyllablesForHoverLens.length > 0 
    }

    SomeWordGroupIsSelectedInLineChart()
    {
        return this.state.listSelectedWordGroupsInLineChart.length > 0
    }
    
    WordIsInAGroupSelectedInLineChart(w)
    {
        return this.state.listSelectedWordGroupsInLineChart.some(g => g.ListWords.includes(w))
    }

    WordIsInThisLensGroupWithCurrentHoveredWord(w, g)
    {
        if(this.LocalDensityLensIsEnabled())
        {
            return this.WordIsStickiedOrHovered(g.ListWords[0]) && g.ListWords.includes(w)
        }
        else
        {
            return g.ListWords.includes(w) && g.ListWords.some(w2 => this.WordIsStickiedOrHovered(w2))
        }
    }
    
    GetMainWordsForFirstWordInSemanticChains()
    {
        var oLens = this.state.listWordGroupsForEnabledLenses.find(o => o.Lens.LensType === 'FirstWordInSemanticChains')
        if(oLens === undefined) return []
        return oLens.ListGroups.map(g => g.MainWord)
    }
    
    WordIsInALensGroupWithCurrentHoveredWord(w)
    {
        //option to select how lens are combined to show hover word groups:
        //"all" shows only words in the same group for *all* the enabled lenses, "any" for any of them.

        if(this.state.listSelectedWordGroupsInLineChart.length > 0)
        {
            return this.state.listSelectedWordGroupsInLineChart.some(g => g.ListWords.includes(w))
        }
        else if(this.PatternLensIsEnabled() && this.AllHoveredOrStickiedWordsForLens().length > 0)
        {
            var oCurrentPatternLensWordGroupForWord = this.GetCurrentPatternLensWordGroupForHoveredWord()
            return oCurrentPatternLensWordGroupForWord != null && oCurrentPatternLensWordGroupForWord.ListWords.includes(w)
        }
        else if(this.state.listWordGroupsForCurrentHoverTypeLens.length > 0)
        {
            return this.state.listWordGroupsForCurrentHoverTypeLens.some(g => this.WordIsInThisLensGroupWithCurrentHoveredWord(w, g))
        }
        else if(this.AllNearbyRepetitionLensIsEnabled() || this.FirstWordInSemanticChainsLensIsEnabled())
        {
            var sLensType = this.AllNearbyRepetitionLensIsEnabled() ? 'allnearbyrepetition' : 'FirstWordInSemanticChains'
            var oLens = this.state.listWordGroupsForEnabledLenses.find(o => o.Lens.LensType === sLensType)
            if(oLens === undefined) return false

            var listGroupsForHoveredWords = oLens.ListGroups.filter(g => this.WordIsStickiedOrHovered(g.MainWord))
            return listGroupsForHoveredWords.some(g => g.ListWords.includes(w))

            // if(this.FirstWordInSemanticChainsLensIsEnabled())
            // {
            //     return listGroupsForHoveredWords.some(g => g.WordsInGroup.includes(w))
            // }
            // else
            // {
            //     return listGroupsForHoveredWords.some(g => g.ListWords.includes(w))
            // }
        }
        else
        {
            return (this.state.listWordGroupsForEnabledLenses.length > 0 &&
                ((this.state.sLensHoverCombineMode === "any" &&
                    this.state.listWordGroupsForEnabledLenses.some(o => o.ListGroups.some(g => this.WordIsInThisLensGroupWithCurrentHoveredWord(w, g)))) ||
                (this.state.sLensHoverCombineMode === "all" &&
                    this.state.listWordGroupsForEnabledLenses.every(o => o.ListGroups.some(g => this.WordIsInThisLensGroupWithCurrentHoveredWord(w, g))))))
        }
    }
    
    GetAllWordsInALensGroupWithCurrentHoveredWord()
    {
        return this.listTextWordsForChapter.filter(w => this.WordIsInALensGroupWithCurrentHoveredWord(w));
    }

    // GetAllInfoForLensGroupsWithCurrentHoveredWord()
    // {
    //     return this.state.listWordGroupsForEnabledLenses.some(o => o.ListGroups.some(g => g.ListWords.includes(w) && g.ListWords.some(w2 => this.WordIsStickiedOrHovered(w2)))
    // }

    GetLensGroupsThatWordIsIn(w)
    {
        if(w === undefined) return [];
        return this.state.listWordGroupsForEnabledLenses.flatMap(o => o.ListGroups.filter(g => g.ListWords.includes(w)));
    }

    GetNameListForLensGroupsWordIsIn(w)
    {
        // return [...new Set(this.GetLensGroupsThatWordIsIn(w).map(g => g.Name))].join(", ");

        if(w === undefined) return '';

        return [...new Set(this.state.listWordGroupsForEnabledLenses.filter(o => o.Lens.LensType != 'allnearbyrepetition').flatMap(o => {
            var sNames = o.ListGroups.filter(g => g.ListWords.includes(w)).map(g => g.Name).join(', ')
            return sNames //sNames == '' ? o.Lens.Name : sNames
        }))].join(", ");
    }

    GetCurrentPatternLensWordGroupForHoveredWord()
    {
        var listEitherStickiedOrHoveredButNotBoth = this.state.listCurrentStickiedWordsForHoverLens.length > 0 ? this.state.listCurrentStickiedWordsForHoverLens :
            this.state.currentWordForHoverLens != undefined ? [this.state.currentWordForHoverLens] : []

        var listGroups = this.state.listWordGroupsForEnabledLenses.
            flatMap(o => o.ListGroups.filter(g => o.Lens.LensType === "patterninfield" && 
                g.ListWords.some(w2 => listEitherStickiedOrHoveredButNotBoth.includes(w2))))

        if(listGroups.length === 0) return null

        var nIndexToUse = this.state.nPatternLensWordGroupsToShowColorsForIndex >= listGroups.length ? 
            listGroups.length - 1 : this.state.nPatternLensWordGroupsToShowColorsForIndex

        return listGroups[nIndexToUse]
    }

    // GetBoldedLetterIndexesByWord()
    // {
    //     var listToReturn = []
    //     for(var textWord of this.listTextWordsForChapter)
    //     {
    //         var oForWord = {Word: textWord, Color: 'Black', LetterIndexes: []}

    //         if(textWord != this.GetHoveredOrFirstStickiedWordForLens())
    //         {
    //             if(this.state.blnShowLenses && this.VowelChainLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
    //             {
    //                 oForWord = this.GetSoundChainColorForWords(textWord, this.GetHoveredOrFirstStickiedWordForLens(), 'v');
    //             }
    //             else if(this.state.blnShowLenses && this.ConsonantChainLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
    //             {
    //                 oForWord = this.GetSoundChainColorForWords(textWord, this.GetHoveredOrFirstStickiedWordForLens(), 'c');
    //             }
    //         }

    //         listToReturn.push(oForWord)
    //     }

    //     return listToReturn
    // }

    CalculateCadenceThingsForAllPoeticChapters()
    {
        fetch("HebrewTextData/allchaptersinpoeticbooks.json")
		.then(res => res.json())
		.then(data => 
		{
			var listTextWordsForAllChapters = data.OSHB; //.filter(w => parseInt(w.TextIndex) > 16887 && parseInt(w.TextIndex) <= 17000);  

			//TODO before running: fix global line list - it doesn't correspond to what is in the individual files
			fetch("LineData/alllinesinpoeticbooks.json")
			.then(res => res.json())
			.then(data => 
			{
                var listLinesForAllChapters = data.Lines

                var listResults = []
                var listDistanceOrderForLines = []
                var listLLSL = [0, 0, 0]
                
                var textWordsByBook = this.GroupArrayByKey(listTextWordsForAllChapters, "Book")
                for(var sBookToDo of Object.keys(textWordsByBook))
                {						
                    if(sBookToDo != '19') continue
                    //console.log('Book: ' + sBookToDo)

                    var textWordsByChapter = this.GroupArrayByKey(textWordsByBook[sBookToDo], "Chapter");
                    for(var sChapterToDo of Object.keys(textWordsByChapter)) //.slice(0, 10)
                    {						
                        //if(sChapterToDo != '24') continue
                        //|| parseInt(sChapterToDo) > 200
                        //if(parseInt(sChapterToDo) > 5) continue
                        //console.log('Chapter: ' + sChapterToDo)

                        var listWordsInChapter = textWordsByChapter[sChapterToDo]
                        for(var w of listWordsInChapter)
                        {
                            var listSyllableObjectsForWord = this.GetSyllableObjectsForWord(w)
        
                            w.SyllableObjects = listSyllableObjectsForWord
                            w.Transliteration = listSyllableObjectsForWord.map(syl => syl.syllable).join('')
                            w.HasFullAccent = listSyllableObjectsForWord.some(syl => syl.hasFullAccent)
                            w.MainAccentedSyllable = listSyllableObjectsForWord.find(syl => syl.hasFullAccent)
                            w.HasSecondaryAccent = listSyllableObjectsForWord.some(syl => syl.hasSecondaryAccent)
                            w.HasFinalAccent = listSyllableObjectsForWord.some(syl => syl.hasFullAccent && syl.isLastSyllableInWord)
                            w.HasPenultimateAccent = listSyllableObjectsForWord.some((syl, n, arr) => syl.hasFullAccent && syl.syllableIndex === arr.length - 2)
                        }

                        var listLinesInChapter = listLinesForAllChapters.filter(ol => ol.Book === sBookToDo && ol.Chapter === sChapterToDo)
                        this.CalculateLines(listLinesInChapter, listWordsInChapter)

                        //let listTranslationWordIndexLinksForChapter = 
                        //let listOurTranslationLinesForChapter = 
                        
                        
                        let listResultsForChapter = listWordsInChapter.map(w => {
                            var sTranslation = w.Gloss.replaceAll('^', ' ')
                            if(w.SyllableObjects.length === 0) return {Word: w, Translation: sTranslation, DistanceToPreviousAccentedSyllable: -1}
                            let oMainAccentedSyllable = w.MainAccentedSyllable != undefined ? w.MainAccentedSyllable : 
                                this.GetNextAccentedSyllableForGlobalCalculation(w.SyllableObjects[0], listLinesInChapter)
                            if(oMainAccentedSyllable === undefined) return {Word: w, Translation: sTranslation, DistanceToPreviousAccentedSyllable: -1}
    
                            let oSyllable = oMainAccentedSyllable
                            let blnCountBeatsInsteadOfJustAccents = false
                            let blnInSameLineOnly = true
                            var oLineOfSyllable = this.GetLineContainingWordForGlobalCalculation(oSyllable.word, listLinesInChapter)
                            if(blnInSameLineOnly && oLineOfSyllable === undefined) return {Word: w, Translation: sTranslation, DistanceToPreviousAccentedSyllable: 0}

                            let blnIsFirstInLine = oLineOfSyllable.Words.length > 0 && oLineOfSyllable.Words[0] === w
                            let blnIsSecondInLine = oLineOfSyllable.Words.length > 1 && oLineOfSyllable.Words[1] === w 
                            let blnIsLastInLine = oLineOfSyllable.Words.length > 0 && oLineOfSyllable.Words[oLineOfSyllable.Words.length - 1] === w

                            var nIndexOfThisSyllable = blnInSameLineOnly ? oLineOfSyllable.SyllableObjects.indexOf(oSyllable) : 
                                this.listSyllablesForChapter.indexOf(oSyllable)

                            if(oSyllable.word.IsFirstInLine || !oLineOfSyllable.SyllableObjects.some((syl, n) => n < nIndexOfThisSyllable && syl.hasFullAccent)) 
                                return {Word: w, Translation: sTranslation, DistanceToPreviousAccentedSyllable: nIndexOfThisSyllable + 1, 
                                    IsFirstInLine: blnIsFirstInLine, IsSecondInLine: blnIsSecondInLine, IsLastInLine: blnIsLastInLine}

                            var nDistanceToPreviousAccentedSyllable = 0
                            for(var nPreviousSyllable = nIndexOfThisSyllable - 1; nPreviousSyllable >=0; nPreviousSyllable--)
                            {
                                var oSylPrev = blnInSameLineOnly ? oLineOfSyllable.SyllableObjects[nPreviousSyllable] : 
                                    this.listSyllablesForChapter[nPreviousSyllable]

                                var blnCountThisAsAccent = oSylPrev.hasFullAccent && (!blnCountBeatsInsteadOfJustAccents || 
                                    this.state.listRepetitionLinkGroups.some(g => g.Type === 5 && g.ListWords.includes(oSylPrev.word.TextIndex)))

                                if(!blnCountThisAsAccent)
                                {
                                    //if this syllable starts with a double consonant or it starts with 
                                    //the same letter that the previous syllable ends with
                                    var oSylPrevPrev = nPreviousSyllable <= 0 ? undefined : 
                                        blnInSameLineOnly ? oLineOfSyllable.SyllableObjects[nPreviousSyllable - 1] : 
                                        this.listSyllablesForChapter[nPreviousSyllable - 1]

                                    var blnDoubledAtBeginning = /^([šṣḵmhtḥsmnpfbvdklʿʾywzrgq])\1/g.test(oSylPrev.syllableWithSingleConsonants) ||
                                        (nPreviousSyllable > 0 && oSylPrev.syllable.slice(0,1) === oSylPrevPrev.syllableWithSingleConsonants.slice(-1))

                                    nDistanceToPreviousAccentedSyllable += 1 //(oSylPrev.syllable.includes('ə') ? 0.5 : 1) + (blnDoubledAtBeginning ? 0.7 : 0)
                                }
                                else 
                                {
                                    nDistanceToPreviousAccentedSyllable += 1
                                    break
                                }
                            }

                            // var listLinksForTranslationWord = listTranslationWordIndexLinksForChapter.filter(o => o.Original === sTextIndex)
                            // let sTranslation = listLinksForTranslationWord.sort((a,b) => a.Translation - b.Translation)
                            // .map(link => {
                            //     var oTranslationForLine = listOurTranslationLinesForChapter.find(o => o.Chapter === link.Chapter && o.LineIndex === link.LineIndex)
                            //     if(oTranslationForLine === undefined) return ''

                            //     var nWordIndexInTranslation = link.Translation
                            //     var listWords = oTranslationForLine.Translation.split(' ')
                            //     return nWordIndexInTranslation >= listWords.length ? '' : listWords[nWordIndexInTranslation]
                            // }).join(' ')

                            return {Word: w, Translation: w.Gloss.replaceAll('^', ' '), DistanceToPreviousAccentedSyllable: nDistanceToPreviousAccentedSyllable,
                                IsFirstInLine: blnIsFirstInLine, IsSecondInLine: blnIsSecondInLine, IsLastInLine: blnIsLastInLine}
                        })

                        listResults = listResults.concat(listResultsForChapter)

                        listDistanceOrderForLines = listDistanceOrderForLines.concat(listLinesInChapter.map(line => {
                            let listForLine = listResultsForChapter.filter(o => 
                                line.Words.includes(o.Word)).map(o => o.DistanceToPreviousAccentedSyllable.toString())
                            
                            if(listForLine.length === 1)
                            {
                                //console.log(line.Words.map(w2 => w2.Transliteration).join(' '), line.Words.map(w2 => w2.TextIndex).join(' '))
                            }

                            return listForLine.join(' ')
                        }))

                        let listLLSLForChapter = this.ChangeInSyllablesPerLineInLastLineOfLevel1UnitLens(listLinesInChapter)
                        listLLSL[0] += listLLSLForChapter[0].LineGroups.length
                        listLLSL[1] += listLLSLForChapter[1].LineGroups.length
                        listLLSL[2] += listLLSLForChapter[2].LineGroups.length
                    }
                }

                //window.alert('done!')

                //calculation 1
                //console.log(Object.groupBy(listResults, (o) => o.DistanceToPreviousAccentedSyllable)) //JSON.stringify(Object.groupBy(listResults, (n) => n)))

                //calculation 2
                // for(var n of [1,4,5,6,7,8])
                // {
                //     console.log('Distance: ' + n.toString(), 
                //     [...new Set(listResults.filter(o => o.DistanceToPreviousAccentedSyllable === n)
                //     .map(o => o.Translation))].join(', '))
                // }
                
                //calculation 3
                // console.log(Object.entries(Object.groupBy(listDistanceOrderForLines, (o) => o))
                //     .map(([key, value]) => ([key, value.length]))
                //     .sort((a,b) => b[1] - a[1]))

                //calculation 4
                // console.log('first', Object.groupBy(listResults.filter(r => r.IsFirstInLine), (o) => o.DistanceToPreviousAccentedSyllable))
                // console.log('second', Object.groupBy(listResults.filter(r => r.IsSecondInLine), (o) => o.DistanceToPreviousAccentedSyllable))
                // console.log('last', Object.groupBy(listResults.filter(r => r.IsLastInLine), (o) => o.DistanceToPreviousAccentedSyllable))

                //calculation 5
                console.log(listLLSL)
            })
        })
    }

    CalculateSyllableDistanceToPreviouslyAccentedSyllable(oSyllable, blnCountBeatsInsteadOfJustAccents)
    {
        //find the distance to the last syllable that had the accent
        let blnInSameLineOnly = true
        var nDistanceToPreviousAccentedSyllable = 0
        var oLineOfSyllable = this.GetLineContainingWord(oSyllable.word)
        if(blnInSameLineOnly && oLineOfSyllable === undefined) return 0

        var nIndexOfThisSyllable = blnInSameLineOnly ? oLineOfSyllable.SyllableObjects.indexOf(oSyllable) : 
            this.listSyllablesForChapter.indexOf(oSyllable)

        // if(oSyllable.word.TextIndex === '42' || oSyllable.word.TextIndex === '43')
        // {
        //     console.log(oSyllable.word.Transliteration, oSyllable.word.IsFirstInLine, nIndexOfThisSyllable + 1)
        // }

        if(oSyllable.word.IsFirstInLine || !oLineOfSyllable.SyllableObjects.some((syl, n) => n < nIndexOfThisSyllable && syl.hasFullAccent)) return nIndexOfThisSyllable + 1

        for(var nPreviousSyllable = nIndexOfThisSyllable - 1; nPreviousSyllable >=0; nPreviousSyllable--)
        {
            var oSylPrev = blnInSameLineOnly ? oLineOfSyllable.SyllableObjects[nPreviousSyllable] : 
                this.listSyllablesForChapter[nPreviousSyllable]

            var blnCountThisAsAccent = oSylPrev.hasFullAccent && (!blnCountBeatsInsteadOfJustAccents || 
                this.state.listRepetitionLinkGroups.some(g => g.Type === 5 && g.ListWords.includes(oSylPrev.word.TextIndex)))

            // if(oSyllable.word.TextIndex === '43')
            // {
            //     console.log(oSylPrev, blnCountThisAsAccent, blnCountBeatsInsteadOfJustAccents, nDistanceToPreviousAccentedSyllable)
            // }

            if(!blnCountThisAsAccent)
            {
                //if this syllable starts with a double consonant or it starts with 
                //the same letter that the previous syllable ends with
                var oSylPrevPrev = nPreviousSyllable <= 0 ? undefined : 
                    blnInSameLineOnly ? oLineOfSyllable.SyllableObjects[nPreviousSyllable - 1] : 
                    this.listSyllablesForChapter[nPreviousSyllable - 1]

                var blnDoubledAtBeginning = /^([šṣḵmhtḥsmnpfbvdklʿʾywzrgq])\1/g.test(oSylPrev.syllableWithSingleConsonants) ||
                    (nPreviousSyllable > 0 && oSylPrev.syllable.slice(0,1) === oSylPrevPrev.syllableWithSingleConsonants.slice(-1))

                nDistanceToPreviousAccentedSyllable += 1 //(oSylPrev.syllable.includes('ə') ? 0.5 : 1) + (blnDoubledAtBeginning ? 0.7 : 0)
            }
            else 
            {
                nDistanceToPreviousAccentedSyllable += 1
                break
            }
        }

        // if(oSyllable.word.TextIndex === '43')
        // {
        //     console.log('done', nDistanceToPreviousAccentedSyllable)
        // }

        return nDistanceToPreviousAccentedSyllable
    }

    GetLineContainingWordForGlobalCalculation(w, listLinesToUse)
    {
        return listLinesToUse.find(r => r.Words.includes(w))
    }

    GetNextAccentedSyllableForGlobalCalculation(oSyllable, listLinesToUse)
    {
        if(oSyllable.hasFullAccent) return oSyllable

        let blnInSameLineOnly = true
        var oLineOfSyllable = this.GetLineContainingWordForGlobalCalculation(oSyllable.word, listLinesToUse)
        if(oLineOfSyllable === undefined) 
        {
            //console.log(oSyllable.word, listLinesToUse)
            return undefined
        }

        var nIndexOfThisSyllable = oLineOfSyllable.SyllableObjects.indexOf(oSyllable)
        
        return oLineOfSyllable.SyllableObjects.slice(nIndexOfThisSyllable).find(oSyllable2 => oSyllable2.hasFullAccent && 
            (!blnInSameLineOnly || this.GetLineContainingWordForGlobalCalculation(oSyllable2.word, listLinesToUse) === oLineOfSyllable))
    }

    GetNextAccentedSyllable(oSyllable)
    {
        if(oSyllable.hasFullAccent) return oSyllable

        let blnInSameLineOnly = true
        var oLineOfSyllable = this.GetLineContainingWord(oSyllable.word)
        //if(oLineOfSyllable === undefined) return undefined
        var nIndexOfThisSyllable = oLineOfSyllable.SyllableObjects.indexOf(oSyllable)
        
        return oLineOfSyllable.SyllableObjects.slice(nIndexOfThisSyllable).find(oSyllable2 => oSyllable2.hasFullAccent && 
            (!blnInSameLineOnly || this.GetLineContainingWord(oSyllable2.word) === oLineOfSyllable))
    }

    GetSyllableDistanceToPreviouslyAccentedSyllableForWord(w)
    {
        if(w.SyllableObjects.length === 0) return -1
        let oMainAccentedSyllable = w.MainAccentedSyllable != undefined ? w.MainAccentedSyllable : this.GetNextAccentedSyllable(w.SyllableObjects[0])
        if(oMainAccentedSyllable === undefined) return -1

        return this.CalculateSyllableDistanceToPreviouslyAccentedSyllable(oMainAccentedSyllable, false)
    }

    GetColorForCadenceSyllableDistance(nDistance, blnLighterVersion)
    {
        // return sColorName === 'Red' ? ['0', '100%', '50%'] :
        // sColorName === 'Purple' ? ['300', '100%', '25%'] :
        // sColorName === 'DarkOrange' ? ['33', '100%', '50%'] :
        // sColorName === 'Green' ? ['120', '100%', '25%'] :
        // sColorName === 'Blue' ? ['240', '100%', '50%'] :
        // sColorName === 'Black' ? ['0', '0%', '0%'] :
        // sColorName === 'Brown' ? ['0', '59%', '41%'] :
        // sColorName === 'GreenYellow' ? ['84', '100%', '59%'] :
        // sColorName === 'Orange' ? ['39', '100%', '50%'] :
        // sColorName === 'Gold' ? ['51', '100%', '50%'] :
        // sColorName === 'Fuchsia' ? ['300', '100%', '50%'] :
        // sColorName === 'hsl(43, 80%, 40%)' ? ['43', '89%', '38%'] :
        // sColorName === 'DarkCyan' ? ['180', '100%', '27%'] :
        // sColorName === 'Maroon' ? ['0', '100%', '25%'] :
        // sColorName === 'Indigo' ? ['275', '100%', '25%'] :
        // sColorName === 'DarkMagenta' ? ['300', '100%', '27%'] :
        // sColorName === 'CornflowerBlue' ? ['219', '79%', '66%'] :
        // sColorName === 'LightGreen' ? ['120', '73%', '75%'] :
        // sColorName === 'Olive' ? ['60', '100%', '25%'] : undefined

        const listSpectrumColorsDarker = [
            //red, green, purple, blue, orange, CornflowerBlue, Fuchsia, Goldenrod, GreenYellow
            "hsl(0, 100%, 50%)",
            "hsl(120, 100%, 25%)",
            "hsl(300, 100%, 25%)",
            "hsl(240, 92%, 45%)",
            "hsl(39, 100%, 50%)",
            "hsl(219, 79%, 66%)",
            "hsl(300, 100%, 50%)",
            "hsl(43, 74%, 50%)",
            "hsl(84, 100%, 59%)",
            ]

        const listSpectrumColorsLighter = [
            "hsl(0, 60%, 70%)",
            "hsl(120, 40%, 65%)",
            "hsl(300, 40%, 65%)",
            "hsl(240, 40%, 65%)",
            "hsl(39, 60%, 80%)",
            "hsl(219, 60%, 80%)",
            "hsl(300, 60%, 80%)",
            "hsl(43, 60%, 80%)",
            "hsl(84, 60%, 80%)",
            ]

        let listSpectrumColors = blnLighterVersion ? listSpectrumColorsLighter : listSpectrumColorsDarker
    
        return nDistance === 0 ? 'Silver' : 
            nDistance === 1 ? listSpectrumColors[0] : 
            nDistance === 2 ? listSpectrumColors[1] :
            nDistance === 3 ? listSpectrumColors[2] :
            nDistance === 4 ? listSpectrumColors[3] :
            nDistance === 5 ? listSpectrumColors[4] :
            nDistance === 6 ? listSpectrumColors[5] :
            nDistance === 7 ? listSpectrumColors[6] :
            nDistance === 8 ? listSpectrumColors[7] :
            nDistance === 9 ? listSpectrumColors[8] : 'Black'
    }

    DoesSyllableHaveDoubledConsonant(oSyllable)
    {
        var nIndexOfThisSyllable = oSyllable.syllableIndex

        //check if the word starts with a doubled consonant
        if(/^([šṣḵmhtḥsmnpfbvdklʿʾywzrgq])\1/g.test(oSyllable.syllableWithSingleConsonants)) return true
        
        //if the doubled consonant is split between two syllables, both of them have doubled consonants
        var listSyllablesInTheWord = oSyllable.word.SyllableObjects //this.listSyllablesForChapter.filter(oSyl => oSyl.word === oSyllable.word)
        var sSyl = oSyllable.syllableWithSingleConsonants

        //if the first letter in this syllable = the last letter of the previous syllable
        if(nIndexOfThisSyllable > 0 && sSyl.slice(0,1) === listSyllablesInTheWord[nIndexOfThisSyllable - 1].syllableWithSingleConsonants.slice(-1)) return true

        //if the last letter in this syllable = the first letter of the next syllable
        if(!oSyllable.isLastSyllableInWord && listSyllablesInTheWord[nIndexOfThisSyllable + 1].syllableWithSingleConsonants.slice(0,1) === sSyl.slice(-1)) return true
        
        return false
    }

    SyllableIsInRightLocation(oSyllable)
    {
        var sRestrictToLocation = this.state.sLocationRestrictionForSyllableRhyme

        if(sRestrictToLocation === 'beginning' && !oSyllable.syllableIndex === 0) return false
        if(sRestrictToLocation === 'end' && !oSyllable.isLastSyllableInWord) return false
        if(sRestrictToLocation === 'beginning or end' && !(oSyllable.syllableIndex === 0 || oSyllable.isLastSyllableInWord)) return false
        if(sRestrictToLocation === 'middle' && (oSyllable.syllableIndex === 0 || oSyllable.isLastSyllableInWord)) return false
        if(sRestrictToLocation === 'mostfrequent' && !this.IsSyllableInPrimeRhymePositions(oSyllable)) return false
        if(sRestrictToLocation === 'accented' && !oSyllable.hasFullAccent) return false

        return true
    }

    SyllableMatchesLetterInTransliterationLens(oSyllable)
    {
        if(!this.SyllableIsInRightLocation(oSyllable)) return false

        var listEnabledLensesForThis = this.state.listLenses.filter(l => (l.Enabled || l.Sticky) && l.LensType === "letterintransliteration")
        
        //endsWithConsonantalHe
        //only show the syllables for words with all of the selected letters, and also, this current syllable must contain one of those letters
        return listEnabledLensesForThis.every(l => oSyllable.word.SyllableObjects.some(oSyl => 
                (l.LettersToFind.includes('y') ? oSyllable.syllableWithSingleConsonants.startsWith('y') : 
                l.LettersToFind.includes('h') ? (oSyllable.syllableWithSingleConsonants.startsWith('h') || oSyllable.endsWithConsonantalHe) :
                l.LettersToFind.some(c => oSyl.syllableWithSingleConsonants.includes(c))) && !l.StringsToExclude.some(s => oSyl.syllableWithSingleConsonants.includes(s)))) &&
            listEnabledLensesForThis.some(l => 
                (l.LettersToFind.includes('y') ? oSyllable.syllableWithSingleConsonants.startsWith('y') : 
                l.LettersToFind.includes('h') ? (oSyllable.syllableWithSingleConsonants.startsWith('h') || oSyllable.endsWithConsonantalHe) :
                l.LettersToFind.some(c => 
                oSyllable.syllableWithSingleConsonants.includes(c))) && !l.StringsToExclude.some(s => oSyllable.syllableWithSingleConsonants.includes(s))) ? true : false
    }

    CalculateSyllableRhymeScore(syl1, syl2, oSyllableAfterSyllable2, listSoundGroups)
    {
        // if(listSoundGroups.filter(g => g.ListSyllableData.some(sd => sd.Syllable === syl2)).length > 0)
        // {
        //     console.log(syl2.syllable, listSoundGroups.some(g => g.ListSyllableData.some(sd => sd.Syllable === syl2 && sd.IsClosedSyllable)))
        // }

        let listSoundGroupsInCommon = listSoundGroups.filter(g => g.ListSyllables.includes(syl1) && g.ListSyllables.includes(syl2))
        let nAmount = listSoundGroupsInCommon.length

        let listVowelSoundGroupsInCommon = listSoundGroupsInCommon.filter(oSoundGroup => oSoundGroup.Group.IsVowel)
        let listConsonantSoundGroupsInCommon = listSoundGroupsInCommon.filter(oSoundGroup => !oSoundGroup.Group.IsVowel)

        let nDistanceBetweenSyllables = Math.abs(this.listSyllablesForChapter.indexOf(syl2) - this.listSyllablesForChapter.indexOf(syl1))
        let nDistanceBetweenWords = Math.abs(parseInt(syl2.word.TextIndex) - parseInt(syl1.word.TextIndex))

        let blnBothStartWithSameSound = listConsonantSoundGroupsInCommon.some(g => 
            g.ListSyllableData.some(sd => sd.Syllable === syl1 && sd.Initial) && 
            g.ListSyllableData.some(sd => sd.Syllable === syl2 && sd.Initial))

        let blnCommonVowelOnAccentedSyllable = listVowelSoundGroupsInCommon.some(g => 
            g.ListSyllableData.some(sd => sd.Syllable === syl1 && sd.IsAccentedSyllable) && 
            g.ListSyllableData.some(sd => sd.Syllable === syl2 && sd.IsAccentedSyllable))

        
        if(oSyllableAfterSyllable2 !== undefined)
        {
            //check if syl1 is similar in some way to syl2 + oSyllableAfterSyllable2
            //ʿa-leykha hashə-lakh-tiy mēr-aḥ-em

            if(blnBothStartWithSameSound)
            {
                let blnSyllable2IsClosed = listSoundGroups.some(g => g.ListSyllableData.some(sd => sd.Syllable === syl2 && sd.IsClosedSyllable))
                
                // if(syl1.syllable === 'lakh*' && syl2.syllable === 'ley*')
                // {
                //     console.log(syl1.syllable, syl2.syllable, oSyllableAfterSyllable2.syllable, blnSyllable2IsClosed)
                // }

                //if syl1 has a final consonant and syl2 does not, but oSyllableAfterSyllable2 has that same final consonant as its initial
                if(!blnSyllable2IsClosed && listSoundGroups.some(g => 
                    g.ListSyllableData.some(sd => sd.Syllable === syl1 && sd.Final) && 
                    g.ListSyllableData.some(sd => sd.Syllable === oSyllableAfterSyllable2 && sd.Initial)))
                {
                    //console.log(syl1.syllable, syl2.syllable, oSyllableAfterSyllable2.syllable)
                    nAmount += 10
                }
            }
        }

        if(listConsonantSoundGroupsInCommon.length > 0)
        {
            //add extra for consecutive syllables or same beginning syllables for nearby words (alliteration)
            
            if(nDistanceBetweenSyllables === 1)
            {
                nAmount += 1
            }
            else if(syl2.syllableIndex === 0 && syl1.syllableIndex === 0)
            {
                if(blnBothStartWithSameSound)
                {
                    if(nDistanceBetweenWords <= 2)
                    {
                        nAmount += 1
                    }
                }
            }
        }

        if(listVowelSoundGroupsInCommon.length > 0)
        {
            if(blnCommonVowelOnAccentedSyllable)
            {
                //console.log(syl1, syl2)
                nAmount += 1
            }
        }

        return nAmount
    }
    
    GetTextColorForSyllable(oSyllable)
    {
        if(!this.state.blnShowLenses || this.ColorByLensType('soundlinechart')) return "Black"

        if(this.ColorByLensType('syllablerhyme'))
		{
            if(this.ShowingDevelopmentDiagram())
            {
                if(this.state.oDevelopmentDiagramHoveredObject !== null)
                {
                    let nLineIndexForSyllable = this.state.listLines.findIndex(r => r.Words.includes(oSyllable.word))
                    if(nLineIndexForSyllable < 0 || Math.abs(this.state.oDevelopmentDiagramHoveredObject.LineIndex - nLineIndexForSyllable) > this.state.nMaxLinesApartForChains)
                    {
                        return 'LightGray'
                    }
                }

                let oSRLens = this.state.listWordGroupsForEnabledLenses.find(o => o.Lens.LensType === 'syllablerhyme')
                if(oSRLens != undefined)
                {
                    let listSoundGroups = oSRLens.ListGroups
    
                    if(this.state.oDevelopmentDiagramHoveredObject !== null && this.state.oDevelopmentDiagramHoveredObject.OriginalSyllable !== undefined)
                    {
                        let oSyllableHoveredOn = this.state.oDevelopmentDiagramHoveredObject.OriginalSyllable
                        let nIndexOfThisSyllable = this.listSyllablesForChapter.indexOf(oSyllable)
                        let oSyllableAfterThisSyllable = nIndexOfThisSyllable >= this.listSyllablesForChapter.length - 1 ? undefined :
                            this.listSyllablesForChapter[nIndexOfThisSyllable + 1]

                        if(oSyllable === oSyllableHoveredOn) return "Black"
                        let nAmount = this.CalculateSyllableRhymeScore(oSyllableHoveredOn, oSyllable, oSyllableAfterThisSyllable, listSoundGroups)
                        //listSoundGroups.filter(g => g.ListSyllables.includes(oSyllable) && g.ListSyllables.includes(oSyllableHoveredOn)).length

                        return nAmount === 0 ? "LightGray" : 
                            nAmount === 1 ? 'hsl(120, 20%, 60%)' : 
                            nAmount === 2 ? "Red" : "Black"
                    }
                    else
                    {
                        var nMaxSyllableAmount = 0
                        var nTotalOccurrencesOfSoundsInSyllableWithOthersInLine = 0
                        //let oLineForSyllable = this.GetLineContainingWord(oSyllable.word)
                        let nLineIndexForSyllable = this.state.listLines.findIndex(r => r.Words.includes(oSyllable.word))
                        let listOtherSyllablesToCompare = this.listSyllablesForChapter
                            .filter(syl => {
                                if(syl.word === oSyllable.word) return false
                                let nDistanceBetweenLines = Math.abs(nLineIndexForSyllable - this.state.listLines.findIndex(r => r.Words.includes(syl.word))) 
                                return nDistanceBetweenLines <= this.state.nMaxLinesApartForChains //&& nDistanceBetweenLines >= 0
                            })

                        for(var nIndexOfSyllable2 = 0; nIndexOfSyllable2 < listOtherSyllablesToCompare.length; nIndexOfSyllable2++)
                        {
                            let oSyllable2 = listOtherSyllablesToCompare[nIndexOfSyllable2]
                            let oSyllableAfterSyllable2 = nIndexOfSyllable2 >= listOtherSyllablesToCompare.length - 1 ? undefined :
                                listOtherSyllablesToCompare[nIndexOfSyllable2 + 1]

                            let nAmount = this.CalculateSyllableRhymeScore(oSyllable, oSyllable2, oSyllableAfterSyllable2, listSoundGroups)
                            nTotalOccurrencesOfSoundsInSyllableWithOthersInLine += nAmount

                            if(nAmount > nMaxSyllableAmount)
                            {
                                nMaxSyllableAmount = nAmount
                            }
                        }

                        //if(nMaxSyllableAmount === 2) return "Red"
                        //if(nMaxSyllableAmount > 2) return "Black"

                        // return nTotalOccurrencesOfSoundsInSyllableWithOthersInLine < 1 ? "LightGray" : 
                        // nTotalOccurrencesOfSoundsInSyllableWithOthersInLine < 3 ? "Green" : 
                        // nTotalOccurrencesOfSoundsInSyllableWithOthersInLine < 5 ? "Red" : "Black"

                        return nMaxSyllableAmount === 0 ? "LightGray" : 
                            nMaxSyllableAmount === 1 ? 'hsl(120, 20%, 60%)' : 
                            nMaxSyllableAmount === 2 ? "Red" : 
                            nMaxSyllableAmount < 8 ? 'Black' : "Purple"
                    }
                }

                return "Black"
            }
            else
            {
                if(this.SomeSyllableIsStickiedOrHovered())
                {
                    return oSyllable === this.GetHoveredOrFirstStickiedSyllableForLens() ? "Black" : 
                        this.GetRhymeAmountColorForSyllables(oSyllable, [this.GetHoveredOrFirstStickiedSyllableForLens()], this.state.blnSyllableRhymeOnlyWhenBothAtWordBeginningOrEnd, this.state.sLocationRestrictionForSyllableRhyme)
                }
                else
                {
                    return this.GetSyllableRhymeMaximumAmountColor(oSyllable, this.listSyllablesForChapter, this.state.sLocationRestrictionForSyllableRhyme)
                    //return this.GetSyllableRhymeCumulativeAmountColor(oSyllable, this.listSyllablesForChapter, this.state.sLocationRestrictionForSyllableRhyme)
                }
            }
        }
        else if(this.ColorByLensType('SoundGroupByUnitHeatmap'))
        {
            if(this.state.oDevelopmentDiagramHoveredObject !== null && this.state.oDevelopmentDiagramHoveredObject.OriginalSyllable !== undefined)
            {
                let listSoundGroupNamesForHoveredSyllable = this.listAllSoundGroupsWordsSyllableIndexes
                    .filter(o => o.Word === this.state.oDevelopmentDiagramHoveredObject.OriginalWord && 
                        o.SyllableIndexes.includes(this.state.oDevelopmentDiagramHoveredObject.OriginalSyllable.syllableIndex))
                    .map(o => o.Name)

                let listToUseForColor = this.listAllSoundGroupsWordsSyllableIndexes.filter(o =>  
                    o.Word === oSyllable.word && 
                    o.SyllableIndexes.includes(oSyllable.syllableIndex) &&
                    listSoundGroupNamesForHoveredSyllable.includes(o.Name))

                if(listToUseForColor.length > 0)
                {
                    return listToUseForColor[0].Color
                }

                // let listTopSoundGroupsWordsSyllableIndexesAndColorsForHoveredWord = this.listTopSoundGroupsWordsSyllableIndexesAndColors.filter(o => 
                //     o.Word === this.state.oDevelopmentDiagramHoveredObject.OriginalWord && 
                //     o.SyllableIndexes.includes(this.state.oDevelopmentDiagramHoveredObject.OriginalSyllable.syllableIndex))

                // for(var o of listTopSoundGroupsWordsSyllableIndexesAndColorsForHoveredWord)
                // {
                //     let oToUseForColor = this.listAllSoundGroupsWordsSyllableIndexes.find(o2 => 
                //         o2.Name === o.Name && 
                //         o2.Word === oSyllable.word && o2.SyllableIndexes.includes(oSyllable.syllableIndex))

                //     if(oToUseForColor !== undefined) return o.Color
                // }
                
                return 'LightGray'
            }
            else
            {
                let oToUseForColor = this.listTopSoundGroupsWordsSyllableIndexesAndColors.find(o => 
                    o.Word === oSyllable.word && o.SyllableIndexes.includes(oSyllable.syllableIndex))
                
                if(oToUseForColor === undefined) return 'LightGray'

                if(this.state.oHoveredObjectForSoundGroupByUnitChart !== null)
                {
                    return this.state.oHoveredObjectForSoundGroupByUnitChart.ListWordsInLineGroup.includes(oSyllable.word) ? oToUseForColor.Color : 'LightGray'
                }
                else
                {
                    return oToUseForColor.Color
                }
            }
        }
        else if(this.ColorByLensType('SyllableAtSameIndexInLine'))
		{
            if(!this.SomeSyllableIsStickiedOrHovered()) return 'Black'

            let oHoveredSyllable = this.GetHoveredOrFirstStickiedSyllableForLens()

            var oLineOfHoveredSyllable = this.GetLineContainingWord(oHoveredSyllable.word)
            if(oLineOfHoveredSyllable === undefined) return 'LightGray'
            var nIndexInLineOfHoveredSyllable = oLineOfHoveredSyllable.SyllableObjects.indexOf(oHoveredSyllable)

            var oLineOfSyllable = this.GetLineContainingWord(oSyllable.word)
            if(oLineOfSyllable === undefined) return 'LightGray'
            var nIndexInLineOfSyllable = oLineOfSyllable.SyllableObjects.indexOf(oSyllable)

            return oSyllable === oHoveredSyllable ? "Black" : nIndexInLineOfSyllable === nIndexInLineOfHoveredSyllable ? 'Green' : 'LightGray'
        }
        else if(this.ColorByLensType('syllableswithdoubledconsonants'))
        {
            return this.DoesSyllableHaveDoubledConsonant(oSyllable) ? 'Green' : 'LightGray'
        }
        // else if(this.FirstSyllableInLinesLensIsEnabled())
        // {
        //     return "Black"// oSyllable.syllableIndex === 0 ? 'Green' : 'LightGray'
        //     //return oSyllable.syllableIndex === 0 && this.state.listLines.some(l => l.Words[0] === oSyllable.word) ? 'Green' : 'LightGray'
        // }
        // else if(this.LastSyllableInLinesLensIsEnabled())
        // {
        //     return ((oSyllable.syllableIndex === 0 || oSyllable.isLastSyllableInWord) && this.state.listLines.some(l => l.Words[0] === oSyllable.word)) || 
        //         (oSyllable.isLastSyllableInWord && this.state.listLines.some(l => l.Words[l.Words.length - 1] === oSyllable.word)) ? 'Green' : 'LightGray'
        // }
        else if(this.ColorByLensType('cadencechanges'))
        {
            let oNextAccentedSyllable = this.GetNextAccentedSyllable(oSyllable)

            return oNextAccentedSyllable === undefined ? 'Silver' : 
                this.GetColorForCadenceSyllableDistance(this.CalculateSyllableDistanceToPreviouslyAccentedSyllable(oNextAccentedSyllable, false), false)
        }
        else if(this.ColorByLensType('letterintransliteration'))
        {
            return this.SyllableMatchesLetterInTransliterationLens(oSyllable) ? 'Green' : 'LightGray'
        }
        else if(this.ColorByLensType('handtaggedrhymegroupsbysyllable'))
        {
            //maybe don't show the first textindex in each group
            var blnHighlightFirstWordInGroup = true
            var sTextIndex = oSyllable.word.TextIndex
            var oGroupWithThisWord = this.state.listRepetitionLinkGroups.find(g => g.Type === 5 && g.ListWords.includes(sTextIndex))
            
            if((oSyllable.hasFullAccent || oSyllable.hasSecondaryAccent) && oGroupWithThisWord != undefined)
            {
                //the blue is 75% light
                //66b3ff 80bfff
                return (blnHighlightFirstWordInGroup && 
                    oGroupWithThisWord.ListWords.sort((a,b) => parseInt(a) - parseInt(b)).indexOf(sTextIndex) === 0) ? 
                    'Green' : 'Green'
            }

            return 'Silver'
        }
        else if(this.ColorByLensType('rhymechainsbetweenlines') || 
            this.ColorByLensType('WordsBySoundGroupSameAccentedSyllable') || 
            this.ColorByLensType('SameAccentedVowelWithNoOrCompatibleFinalConsonant') ||
            this.ColorByLensType('WordsBySoundGroupInitialConsonantOfStressedSyllable'))
        {
            if(oSyllable.hasFullAccent)
            {
                let sColor = this.GetTextColor(oSyllable.word)
                return sColor === 'LightGray' ? (!oSyllable.isLastSyllableInWord ? 'hsl(0, 0%, 70%)' : 'hsl(0, 0%, 75%)') : sColor
            }
            else
            {
                return 'hsl(0, 0%, 75%)'
            }
        }
        else if(this.ColorByLensType('WordsBySoundGroupInitial'))
        {
            if(oSyllable.syllableIndex === 0)
            {
                let sColor = this.GetTextColor(oSyllable.word, 'SameInitialSoundGroup')
                return sColor === 'LightGray' ? (!oSyllable.isLastSyllableInWord ? 'hsl(0, 0%, 70%)' : 'hsl(0, 0%, 75%)') : sColor
            }
            else
            {
                return 'hsl(0, 0%, 75%)'
            }
        }
        else if(this.ColorByLensType('SameAccentedVowelWithNoOrCompatibleFinalConsonantOrInitialSoundGroup'))
        {
            if(oSyllable.hasFullAccent)
            {
                let sColor = this.GetTextColor(oSyllable.word, 'SameAccentedVowelWithNoOrCompatibleFinalConsonant')
                if(sColor === 'LightGray')
                {
                    if(oSyllable.syllableIndex > 0)
                    {
                        return !oSyllable.isLastSyllableInWord ? 'hsl(0, 0%, 70%)' : 'hsl(0, 0%, 75%)'
                    }
                    //if oSyllable.syllableIndex === 0, we want the program flow to go to
                    //if(oSyllable.syllableIndex === 0) below
                }
                else
                {
                    return sColor
                }
            }
            
            if(oSyllable.syllableIndex === 0)
            {
                let sColor = this.GetTextColor(oSyllable.word, 'SameInitialSoundGroup')
                return sColor === 'LightGray' ? (!oSyllable.isLastSyllableInWord ? 'hsl(0, 0%, 70%)' : 'hsl(0, 0%, 75%)') : sColor
            }
            else
            {
                return 'hsl(0, 0%, 75%)'
            }
        }
        else if(this.state.sColorBy === "rgrp" || this.MainConnectionsLensIsEnabled() || this.state.blnConnectionsPresentationMode)
        {
            let listRepetitionLinkGroups = this.GetRepetitionLinkGroupList()
            var nRepetitionLinkGroupIndex = listRepetitionLinkGroups.findIndex(g => {
                let nIndexInListOfWords = g.ListWords.indexOf(oSyllable.word.TextIndex)
                if(nIndexInListOfWords === -1) return false

                let nSyllableIndexInGroupForWord = g.ListSyllableIndexesByWord[nIndexInListOfWords]

                if(!this.state.blnColorIndividualSyllablesForRepetitionLinkGroups && this.state.sColorBy !== "rgrp")
                {
                    //if blnColorIndividualSyllablesForRepetitionLinkGroups is false and the repetition group tool is not active, 
                    //only color the syllable if it is not linked as an individual syllable
                    return nSyllableIndexInGroupForWord === -1
                }

                //when blnSyllableModeForRepetitionLinkGroupTool is activated, only color the syllables involved
                return (nSyllableIndexInGroupForWord === -1 || nSyllableIndexInGroupForWord === oSyllable.syllableIndex) &&
                (!this.state.blnSyllableModeForRepetitionLinkGroupTool || nSyllableIndexInGroupForWord === oSyllable.syllableIndex) &&
                (g.ListTags.length === 0 || g.ListTags.some(tag => this.IsGroupForRepetitionLinkGroupCategoryIDCurrentlySelected(tag.CategoryID)))
            })
            
            return nRepetitionLinkGroupIndex === -1 ? "Gray" : 
                this.listLinkGroupColors[nRepetitionLinkGroupIndex % this.listLinkGroupColors.length];
        }
        else
        {
            return this.GetTextColor(oSyllable.word)
        }
    }

	GetTextColor(textWord, sCategoryForLinkFiltering)
	{
        if(this.state.listWordsPossiblyMappingToCurrentSubtags.length > 0)
		{
			return this.state.listWordsPossiblyMappingToCurrentSubtags.some(w => w === textWord) ? "Red" : "Black";
		}
        else if(this.state.blnShowLenses && (this.ColorByLensType("consonantlinechart") || this.ColorByLensType("soundlinechart") || 
            this.ColorByLensType('SoundGroupByUnitHeatmap')) && this.SomeWordGroupIsSelectedInLineChart())
		{
            return this.WordIsInAGroupSelectedInLineChart(textWord) ? 'Black' : 'LightGray'
        }
        else if(this.state.blnShowLenses && (this.ColorByLensType("SemanticGroupByUnitHeatmap") || this.ColorByLensType("RepeatedRootGroupByUnitHeatmap")))
        {
            if(this.state.oDevelopmentDiagramHoveredObject !== null)
            {
                let oWordHoveredOn = this.state.oDevelopmentDiagramHoveredObject.OriginalWord
                let listTopGroupsWordsAndColorsForHoveredWord = this.listTopGroupsWordsAndColors.filter(o => 
                    o.Word === oWordHoveredOn)

                for(var o of listTopGroupsWordsAndColorsForHoveredWord)
                {
                    let oToUseForColor = this.listAllGroupsWords.find(o2 => 
                        o2.Name === o.Name && o2.Word === textWord)

                    if(oToUseForColor !== undefined) return o.Color
                }
                
                return 'Black'
            }
            else
            {
                let oToUseForColor = this.listTopGroupsWordsAndColors.find(o => o.Word === textWord)
                return oToUseForColor === undefined ? 'Black' : oToUseForColor.Color
            }
        }
        else if(this.state.blnShowLenses && this.NumberOfLinksPerLineChartIsEnabled())
        {
            if(this.ColorByLensType('FirstWordInLinkGroups'))
            {
                let listGroupTypesForWord = this.listWordsStartingLinkGroups.filter(o => o.Word === textWord).map(o => o.GroupType)
                if(listGroupTypesForWord.length === 0) return 'hsl(0, 0%, 80%)'
                
                let nMaxGroupTypeForWord = Math.max(...listGroupTypesForWord)

                return nMaxGroupTypeForWord === 1 ? 'Green' :
                nMaxGroupTypeForWord === 2 ? 'Purple' :
                nMaxGroupTypeForWord === 3 ? 'Blue' :
                nMaxGroupTypeForWord === 4 ? 'Red' :
                nMaxGroupTypeForWord === 5 ? 'Orange' : 'CornflowerBlue'
            }
            else if(this.ColorByLensType('ClosestDistanceFromLastWordInSameLinkGroups'))
            {
                let nDistance = this.dictClosestDistanceFromLastWordInSameLinkGroupsPerWord.get(textWord)

                return nDistance === undefined ? 'hsl(0, 0%, 70%)' :
                nDistance === 0 ? 'Black' :
                nDistance === 1 ? 'Green' :
                nDistance === 2 ? 'Purple' :
                nDistance === 3 ? 'Blue' :
                nDistance === 4 ? 'Red' :
                nDistance === 5 ? 'Orange' : 'CornflowerBlue'
            }
            else
            {
                let nLinksForWord = this.dictLinksPerWord.get(textWord)

                return (nLinksForWord === undefined || nLinksForWord === 0) ? 'hsl(0, 0%, 70%)' :
                nLinksForWord === 1 ? 'Green' :
                nLinksForWord === 2 ? 'Purple' :
                nLinksForWord === 3 ? 'Blue' :
                nLinksForWord === 4 ? 'Red' :
                nLinksForWord === 5 ? 'Orange' : 'CornflowerBlue'
            }
        }
        else if(this.state.blnShowLenses && this.CadenceChangesLensIsEnabled() && this.ColorByLensType('cadencechanges'))
		{
            let nSyllableDistance = this.GetSyllableDistanceToPreviouslyAccentedSyllableForWord(textWord)

            return nSyllableDistance === -1 || (nSyllableDistance > 1 && nSyllableDistance < 4) ? 'Silver' : 
                this.GetColorForCadenceSyllableDistance(nSyllableDistance, false)
		}
		else if(this.state.blnShowLenses && this.state.listWordGroupsForEnabledLenses.length > 0)
		{
            if(this.PatternLensIsEnabled() && (this.SomeWordIsStickiedOrHovered() || this.SomeWordGroupIsSelectedInLineChart()))
            {
                //&& g.ListWords.includes(w)

                var oCurrentPatternLensWordGroupForWord = null

                var listSelectedLineChartWordGroupsForWord = this.state.listSelectedWordGroupsInLineChart.filter(g => g.ListWords.includes(textWord))
                if(listSelectedLineChartWordGroupsForWord.length > 0)
                {
                    //in case there are multiple selected, use the same index as the regular pattern lens does to move through the groups
                    var nIndexToUseForLineChartWordGroups = this.state.nPatternLensWordGroupsToShowColorsForIndex >= listSelectedLineChartWordGroupsForWord.length ? 
                        listSelectedLineChartWordGroupsForWord.length - 1 : this.state.nPatternLensWordGroupsToShowColorsForIndex
                    oCurrentPatternLensWordGroupForWord = listSelectedLineChartWordGroupsForWord[nIndexToUseForLineChartWordGroups]
                }
                else
                {
                    oCurrentPatternLensWordGroupForWord = this.GetCurrentPatternLensWordGroupForHoveredWord()
                }

                // var oCurrentPatternLensWordGroupForWord = oSelectedLineChartWordGroupForWord != undefined ? oSelectedLineChartWordGroupForWord :
                //     this.GetCurrentPatternLensWordGroupForHoveredWord()
                    
                if(oCurrentPatternLensWordGroupForWord != null && oCurrentPatternLensWordGroupForWord.ListWords.includes(textWord))
                {
                    //show field level colors
                    var sFieldForHoverColor = oCurrentPatternLensWordGroupForWord.Field
                    var colorArray = this.GetColorArrayForLensType(sFieldForHoverColor)
                    return colorArray === null ? oCurrentPatternLensWordGroupForWord.Color : this.GetLensColorForValue(textWord, sFieldForHoverColor, colorArray)
                }
                else
                {
                    var listPatternLensWordGroupsForTextWord = this.state.listWordGroupsForEnabledLenses.
                        flatMap(o => o.ListGroups.filter(g => o.Lens.LensType === "patterninfield" && g.ListWords.includes(textWord)))

                    if(listPatternLensWordGroupsForTextWord.length > 0)
                    {
                        //show group level colors
                        return listPatternLensWordGroupsForTextWord[0].Color
                    }
                    else return 'LightGray'
                }
            }
            else
            {
                // var listLensWordGroupsForWordSorted = 
                //     this.state.listWordGroupsForEnabledLenses.
                //         flatMap(o => o.ListGroups.filter(g => o.Lens.LensType === "localdensity" ? (g.ListWords[0] === textWord) : g.ListWords.includes(textWord))).
                //         sort((a,b) => b.ColorPriority - a.ColorPriority)
                // listLensWordGroupsForWordSorted[0].Color

                let oLensToUse = this.state.listWordGroupsForEnabledLenses.find(o => o.Lens === this.GetLensToColorBy())
                if(oLensToUse === undefined || oLensToUse.Lens.DoesNotColorText) return 'Black'

                let listGroupsInLensWithWord = oLensToUse.ListGroups.filter(g => g.ListWords.includes(textWord))
                if(listGroupsInLensWithWord.length === 0) return 'LightGray'

                let oLensGroup = listGroupsInLensWithWord[0]
                if(sCategoryForLinkFiltering !== undefined)
                {
                    let listGroupsInLensWithWordMatchingCategory = listGroupsInLensWithWord.filter(o => o.CategoryForLinkFiltering === sCategoryForLinkFiltering)
                    if(listGroupsInLensWithWordMatchingCategory.length === 0) return 'LightGray'

                    oLensGroup = listGroupsInLensWithWordMatchingCategory[0]
                }

                let sColorFromLens = oLensGroup.WordsToNotColor !== undefined && oLensGroup.WordsToNotColor.includes(textWord) ? 'LightGray' : oLensGroup.Color

                if(this.FirstWordInSemanticChainsLensIsEnabled() && !this.SomeWordIsStickiedOrHovered())
                {
                    return this.GetMainWordsForFirstWordInSemanticChains().includes(textWord) ? sColorFromLens : 'DarkGray'
                }
                else
                {
                    return sColorFromLens
                }
            }
		}
        else if(this.state.blnShowLenses && this.state.listWordGroupsForCurrentHoverTypeLens.length > 0)
		{
            var oHoverTypeLensWordGroupForWord = this.state.listWordGroupsForCurrentHoverTypeLens.find(g => g.ListWords.includes(textWord))
            
            return oHoverTypeLensWordGroupForWord === undefined ? 'LightGray' : 
                oHoverTypeLensWordGroupForWord.SelectedWords.includes(textWord) ? 'Black' : 
                oHoverTypeLensWordGroupForWord.Color
        }
        // else if(this.state.blnShowLenses && this.AllSimilarityLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		// {
		// 	return textWord === this.GetHoveredOrFirstStickiedWordForLens() ? "Black" : this.GetAllSimilarityAmountScore(textWord, this.GetHoveredOrFirstStickiedWordForLens()).Color
		// }
        else if(this.state.blnShowLenses && this.RhymeLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		{
			return textWord === this.GetHoveredOrFirstStickiedWordForLens() ? "Black" : this.GetRhymeAmountColor(textWord, this.GetHoveredOrFirstStickiedWordForLens());
		}
        else if(this.state.blnShowLenses && this.AlltLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		{
			return textWord === this.GetHoveredOrFirstStickiedWordForLens() ? "Black" : this.GetRhymeAmountColor(textWord, this.GetHoveredOrFirstStickiedWordForLens());
		}
        else if(this.state.blnShowLenses && this.WordRhymeLensIsEnabled())
		{
            if(this.SomeWordIsStickiedOrHovered())
            {
                return textWord === this.GetHoveredOrFirstStickiedWordForLens() ? "Black" : this.GetCombinedAmountColorForSyllables(textWord, this.GetHoveredOrFirstStickiedWordForLens(), this.state.sLocationRestrictionForSyllableRhyme)
            }
            else
            {
                return this.GetCombinedRhymeMaximumAmountColor(textWord, this.listTextWordsForChapter, this.state.sLocationRestrictionForSyllableRhyme)
            }
		}
        // else if(this.state.blnShowLenses && this.VowelChainLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		// {
		// 	return textWord === this.GetHoveredOrFirstStickiedWordForLens() ? "Black" : this.GetSoundChainColorForWords(textWord, this.GetHoveredOrFirstStickiedWordForLens(), 'v');
		// }
        // else if(this.state.blnShowLenses && this.ConsonantChainLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		// {
		// 	return textWord === this.GetHoveredOrFirstStickiedWordForLens() ? "Black" : this.GetSoundChainColorForWords(textWord, this.GetHoveredOrFirstStickiedWordForLens(), 'c');
		// }
        // else if(this.state.blnShowLenses && this.AllSimilarityForLinesLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		// {
        //     var oSelectedWord = this.GetHoveredOrFirstStickiedWordForLens()
        //     var l1 = this.GetLineContainingWord(textWord)
        //     var l2 = this.GetLineContainingWord(oSelectedWord)
        //     return l1 === l2 ? "Black" : this.GetAllSimilarityAmountColorForLines(l1, l2)
		// }
        else if(this.state.blnShowLenses && this.SemanticSimilarityLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		{
			return textWord === this.GetHoveredOrFirstStickiedWordForLens() ? "Black" : this.GetSemanticSimilarityAmountColor(textWord, this.GetHoveredOrFirstStickiedWordForLens());
		}
        // else if(this.state.blnShowLenses && this.RootCooccurrenceLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		// {
		// 	return textWord === this.GetHoveredOrFirstStickiedWordForLens() ? "Black" : this.GetRootCooccurrenceAmountColor(textWord, this.GetHoveredOrFirstStickiedWordForLens());
		// }
        else if(this.state.blnShowLenses && this.DifferenceAmountLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		{
			return textWord === this.GetHoveredOrFirstStickiedWordForLens() ? "Black" : this.GetDifferenceAmountColor(textWord, this.GetHoveredOrFirstStickiedWordForLens());
		}
        else if(this.state.nSelectedToolID === this.nColaSplitToolID || this.state.nSelectedToolID === this.nColaMergeToolID)
        {
            var lineTextWordIsIn = this.GetLineContainingWord(textWord)
            return (lineTextWordIsIn === undefined || !lineTextWordIsIn.UnsureAboutDelineation) ? 'Black' : 'Red'
        }
        
		else if(this.InSemanticRoleMode())
		{
			//the tags with suffixes should have at least one tag with IsForSuffix and at least one tag with !IsForSuffix
			//mark problems with red
			var listPassiveStems = ["N", "P", "Q", "H", "t"];

			var tagForWord = this.GetWordTagForWord(textWord);
			if(tagForWord != undefined) 
				return (this.state.listSemanticRolesToShowInSemanticRoleMode.length > 0 && 
						!this.state.listSemanticRolesToShowInSemanticRoleMode.some(o => tagForWord.SemanticRoles.some(o2 => o2.RoleID === o.ID))) ? "DarkGray" :
					tagForWord.SemanticRoles.some(o => o.RoleID === "38") ? "Blue" :
					tagForWord.SemanticRoles.length > 0 && textWord.SuffixPerson != undefined && textWord.WordType != "R" &&
					(!tagForWord.SemanticRoles.some(o => o.IsForSuffix) || !tagForWord.SemanticRoles.some(o => !o.IsForSuffix)) ? "Red" :
					(!tagForWord.SemanticRoles.some(o => o.RoleID === "40") && listPassiveStems.includes(textWord.Stem)) ? "Red" :
					tagForWord.SemanticRoles.length > 0 ? "DarkCyan" : "DarkGray";
		}

		var listSeqsItIsIn = this.state.listQueries.filter(q => q.Results.flat().includes(textWord));

		if(listSeqsItIsIn.length > 0 || (this.state.sColorBy != "" && (this.state.sMorphCode === "" || this.state.sMorphCode === undefined)))
		{
			// if(this.state.colorAllParameter !== "")
			// 	return this.state.colorAllParameter;

			if(this.state.sColorBy === "s")
				return this.colorsForStems[textWord.Stem] === undefined ? "Gray" : this.colorsForStems[textWord.Stem];
			else if(this.state.sColorBy === "f")
				return this.colorsForForms[textWord.Form] === undefined ? "Gray" : this.colorsForForms[textWord.Form];
			else if(this.state.sColorBy === "g")
				return this.colorsForGender[textWord.Gender] === undefined ? "Gray" : this.colorsForGender[textWord.Gender];   
			else if(this.state.sColorBy === "n")
				return this.colorsForNumber[textWord.Number] === undefined ? "Gray" : this.colorsForNumber[textWord.Number];
			else if(this.state.sColorBy === "pf")
            {
                var sPF = this.GetPhraseFunction(textWord)
				return this.colorsForPhraseFunctions[sPF] === undefined ? "LightGray" : this.colorsForPhraseFunctions[sPF]
            }      
			else if(this.state.sColorBy === "sfxtype")
				return this.colorsForNumber[textWord.SuffixType] === undefined ? "Gray" : this.colorsForSuffixType[textWord.SuffixType];	
            else if(this.state.sColorBy === "wordtype")
            {
                return this.colorsForWordType[textWord.WordType] === undefined ? "Gray" : (textWord.Form === "r" || textWord.Form === "s") ? "Purple" :
                    this.colorsForWordType[textWord.WordType];
            }				
			else if(this.state.sColorBy === "preposition")
				return this.colorsForPreposition[textWord.Preposition] === undefined ? "Gray" : this.colorsForPreposition[textWord.Preposition];				
			else if(this.state.sColorBy === "pgrp")
			{
				var pGroup = this.GetPGroupValueIndexForWord(textWord, this.state.listLines); //this.GetPGroupForWord(textWord); 
				return this.colorsForPGroups[pGroup] === undefined ? "Gray" : this.colorsForPGroups[pGroup];				
            }
            else if(this.state.sColorBy === "rgrp")
			{
                //filter for words in this chapter to keep the colors consistent - so each chapters groups start at index 0
                //update: the commented out below was because it was too slow - find a way to speed it up!
                var nRepetitionLinkGroupIndex = this.GetRepetitionLinkGroupList(). //filter(g => this.listTextWordsForChapter.some(w => w.TextIndex === g.ListWords[0])).
                    findIndex(g => g.ListWords.includes(textWord.TextIndex) &&
                    (g.ListTags.length === 0 || g.ListTags.some(tag => this.IsGroupForRepetitionLinkGroupCategoryIDCurrentlySelected(tag.CategoryID))))
                    
                return nRepetitionLinkGroupIndex === -1 ? "Gray" : 
                    this.listLinkGroupColors[nRepetitionLinkGroupIndex % this.listLinkGroupColors.length];
            }
            else if(this.state.sColorBy === "rhyme")
            {
                return this.GetRhymeAmountColor(textWord, this.state.currentWordForHoverLens);
            }
            // else if(this.state.sColorBy === "allsimilarity")
            // {
            //     return this.GetAllSimilarityAmountScore(textWord, this.state.currentWordForHoverLens).Color
            // }
            else if(this.state.sColorBy === "rgrpdensity")
			{
                return this.GetRepetitionLinkGroupDensityColor(textWord);
            }
			else if(this.state.sColorBy === "pforder")
			{
				var sPFOrder = this.GetPhraseFunctionOrderForWord(textWord);
				return this.colorsForPhraseFunctionOrder[sPFOrder] === undefined ? "Gray" : this.colorsForPhraseFunctionOrder[sPFOrder];
			}
			else if(this.state.sColorBy === "fig")
			{
				var firstFigureTypeContainingThisWord = this.GetTypeOfFirstFigureContainingTextIndex(textWord.TextIndex);
				return firstFigureTypeContainingThisWord === undefined ? "Black" : 
					this.colorsForFigures[String(firstFigureTypeContainingThisWord)] === undefined ? "Gray" : 
					this.colorsForFigures[String(firstFigureTypeContainingThisWord)];	
			}
			else if(this.state.sColorBy === "pgn")
			{
				var sPGN = this.GetPGN(textWord);
				return this.colorsForPGN[sPGN] === undefined ? "LightGray" : this.colorsForPGN[sPGN];  
			}
			else if(this.state.sColorBy === "sfxpgn")
			{
				var sSuffixPGN = this.GetSuffixPGN(textWord);
				return this.colorsForPGN[sSuffixPGN] === undefined ? "LightGray" : this.colorsForPGN[sSuffixPGN];  
			}
			else if(this.state.sColorBy === "wordlinkgroup")
			{
				var linkGroup = this.state.listWordLinkGroups.find(o => o.Objects.includes(textWord));
				if(linkGroup === undefined)
					return "black"; 
				else
					return linkGroup.Color;
			}
			else if(this.state.sColorBy === "linelinkgroup")
			{
				var lineItisIn = this.LineWithWord(textWord);
				var linkGroup = this.state.listLineLinkGroups.find(o => o.Objects.includes(lineItisIn));
				if(linkGroup === undefined)
					return "black"; 
				else
					return linkGroup.Color;
			}
			else if(this.state.sColorBy === "")
			{
				if(listSeqsItIsIn[0].Results.length === 1)
					return "red"; //default for single element sequences
				else
				{
					var nSequenceIndex = this.state.listQueries.indexOf(listSeqsItIsIn[0]);
					return this.distinguishingColors[nSequenceIndex]; //default for everything else selected
				}
			}
		}
		else if((this.state.blnShowWordSimilarity || this.state.blnShowWordSimilarity) && 
				 this.state.listUnitSimilaritiesToCurrentUnit.length > 0)
		{
			//1.5, range 1 to 2, (1.5-1) / range = 0.5 /1 = 50% * nMaxWhiteness (60) = 30
			//nMaxWhiteness - 30 = 30   
			var otherUnitInList = this.state.listUnitSimilaritiesToCurrentUnit.find(r => 
				this.state.blnShowWordSimilarity ? 
				r.Unit2 === textWord :
				r.Unit2.includes(textWord));

			if(otherUnitInList === undefined)
				return 'hsla(255, 100%, '+ this.state.nMaxWhitenessForSimilarityHighlightingNoMatch + '%, 1.0)'; //make it almost invisible
			else
			{
				var nSimilarityScore = otherUnitInList.SimilarityScore;        
				var nSimilarityScorePercentIntoRange = (nSimilarityScore - this.state.nMinSimilarityScore) / this.state.nSimilarityScoreRange;
				var nWhitenessOffsetFromMax = parseInt(this.state.nRangeOfWhitenessForSimilarityHighlighting * nSimilarityScorePercentIntoRange);				
				var nColor = 'hsla(255, 100%,'+ 
					(this.state.nMaxWhitenessForSimilarityHighlightingMatch - nWhitenessOffsetFromMax) +'%,1.0)';				
				return nColor;
			}
		}
		else if(this.state.sLinkReportObjectType !== "")
		{
			var unitInList = this.state.sLinkReportObjectType === "line" ?
				this.state.listUnitSimilaritiesToCurrentUnit.find(r => 
					this.state.sLinkReportConstraint === "prevline" ? 
						r.Unit2.includes(textWord) :
						(r.Unit1.includes(textWord) || r.Unit2.includes(textWord))) :
				this.state.listUnitSimilaritiesToCurrentUnit.find(r =>
					 r.Unit1 === textWord || r.Unit2 === textWord);
				
			if(unitInList === undefined)
				return 'hsla(255, 100%, 93%, 1.0)'; //make it almost invisible
			else
			{      
				//if a word has no links, gray it out, otherwise all words in a line get the same color gradation.
				var blnWordHasLinks = true;
				if(this.state.sLinkReportObjectType === "line")
				{
					 blnWordHasLinks = this.state.listUnitSimilaritiesToCurrentUnit.some(r => 
						r.WordLinks.some(r2 => r2.Word1 === textWord || r2.Word2 === textWord));
				}

				if(!blnWordHasLinks)
					return 'hsla(255, 100%, 93%, 1.0)'; //make it almost invisible
				else
				{
					var nSimilarityScorePercentIntoRange = (unitInList.SimilarityScore - this.state.nMinSimilarityScore) / this.state.nSimilarityScoreRange;
					var nWhitenessOffsetFromMax = parseInt(this.state.nRangeOfWhitenessForSimilarityHighlighting * nSimilarityScorePercentIntoRange);
					var nColor = 'hsla(255, 100%,'+ 
						(this.state.nMaxWhitenessForSimilarityHighlightingMatch - nWhitenessOffsetFromMax) +'%,1.0)';
					return nColor;
				}
			}
		}
		else
			return "Black";  //not selected or anything
	}
    
	// CalculateColorChart(sColorBy)
	// {
	// 	var graphData = [];
	// 	var listLegendItems = undefined;
		
	// 	var nGraphWidth = 1000;	
	// 	var nGraphHeight = 100;
	// 	var nGraphLeftMargin = 400;

	// 	if(sColorBy != "" && sColorBy != "rgrp")
	// 	{	
	// 		var listWordsForGraph = this.listTextWordsForChapter;	
	// 		if(listWordsForGraph.length === 0) return undefined;

	// 		var colorMapping =
	// 			sColorBy === "s" ? this.colorsForStems :
	// 			sColorBy === "f" ? this.colorsForForms :
	// 			sColorBy === "g" ? this.colorsForGender :
	// 			sColorBy === "n" ? this.colorsForNumber :
	// 			sColorBy === "pf" ? this.colorsForPhraseFunctions :
	// 			sColorBy === "pforder" ? this.colorsForPhraseFunctionOrder :
	// 			sColorBy === "sfxtype" ? this.colorsForSuffixType : 
	// 			sColorBy === "wordtype" ? this.colorsForWordType :
	// 			sColorBy === "preposition" ? this.colorsForPreposition :
	// 			sColorBy === "pgrp" ? this.colorsForPGroups :
	// 			sColorBy === "fig" ? this.colorsForFigures :
	// 			sColorBy === "pgn" || sColorBy === "sfxpgn" ? this.colorsForPGN : null;

	// 		var abbreviationMapping = 
	// 			sColorBy === "s" ? this.listHebrewVerbStems :
	// 			sColorBy === "f" ? this.listHebrewVerbForms :
	// 			sColorBy === "g" ? this.descsForGenderAbbr :
	// 			sColorBy === "n" ? this.descsForNumberAbbr : 
	// 			sColorBy === "sfxtype" ? this.descsForSuffixType: null;

	// 		graphData = listWordsForGraph.map((w, nIndex) => {
	// 			var value = this.GetValueForColorMapping(w, sColorBy);
	// 			var sColor = (sColorBy === "wordlinkgroup" || sColorBy === "linelinkgroup" || sColorBy === "rgrpdensity") ? (value === undefined ? undefined : value.Color) : 
	// 				colorMapping[value];
	// 			return {HebrewTextForHint: this.GetGraphPopoverHintForWord(w), 
	// 				WordsToHighlight: this.MapTextIndicesToWordToHighlight([w.TextIndex]), id: value, x: nIndex, y: 1, opacity: 1.0,
	// 			color: sColor === undefined ? "White" : sColor
	// 		}});

	// 		if(colorMapping != null)
	// 		{
	// 			var valuesInData = Array.from(new Set(listWordsForGraph.map(w => this.GetValueForColorMapping(w, sColorBy))));
	// 			listLegendItems = Object.entries(colorMapping)
	// 				.filter((key,value) => valuesInData.includes(key[0]))
	// 				.map((key,value) => ({title: abbreviationMapping === null ? key[0] : abbreviationMapping.find(r => r.Abbr === key[0]).Desc, 
	// 					color: key[1], strokeWidth: 14, id: key[0]}));
	// 		}
	// 	}

	// 	this.setState({listColorChartData: {"Data": graphData, LegendItems: listLegendItems,
	// 		"GraphWidth": nGraphWidth, "GraphHeight": nGraphHeight, "GraphLeftMargin": nGraphLeftMargin}});
	// }

	// ShowColorChart()
	// {
	// 	var graphData = this.state.listColorChartData.Data;
	// 	var listLegendItems = this.state.listColorChartData.LegendItems;
	// 	var nGraphWidth = this.state.listColorChartData.GraphWidth;
	// 	var nGraphHeight = this.state.listColorChartData.GraphHeight;
	// 	var nGraphLeftMargin = this.state.listColorChartData.GraphLeftMargin;
	// 	var sGraphUniqueName = "ColorChart";

	// 	if(graphData === undefined || graphData.length === 0) return;

	// 	return (
	// 		<div style={{backgroundColor:"white", marginTop:"15px"}}>			
	// 		{listLegendItems != undefined &&			
	// 		<DiscreteColorLegend orientation="horizontal" width={nGraphWidth} items={listLegendItems} 
	// 		  onItemMouseEnter={(item, index, event) => {
	// 			this.blnColorChartLegendStickyHover = false;
	// 			var listColorChartDataToSet = this.state.listColorChartData;
	// 			listColorChartDataToSet.Data.forEach(d => d.opacity = d.id === item.id ? 1 : 0);
	// 			this.setState({listColorChartData: listColorChartDataToSet});
	// 		  }}
	// 		  onItemMouseLeave={(item, index, event) => {
	// 			if(!this.blnColorChartLegendStickyHover)
	// 			{
	// 				var listColorChartDataToSet = this.state.listColorChartData;
	// 				listColorChartDataToSet.Data.forEach(d => d.opacity = 1);
	// 				this.setState({listColorChartData: listColorChartDataToSet});
	// 			}
	// 		  }}
	// 		  onItemClick={(Object, number) => this.blnColorChartLegendStickyHover = true }
	// 		  />}
			
	// 		<XYPlot width={nGraphWidth} height={nGraphHeight} margin={{left: nGraphLeftMargin}} onMouseLeave={() => this.setState({sHintText: false})}>
	// 			<VerticalGridLines />
	// 			<HorizontalGridLines />
	// 			<VerticalBarSeries colorType="literal" data={graphData} 
	// 			// onNearestXY={d => this.setState({graphValue: d})} 
				
	// 			onValueClick={(value, {index}) => {	
	// 				this.setState({listGraphTextIndicesToHighlight: value.WordsToHighlight});
	// 				this.ScrollToWords(value.WordsToHighlight); 
	// 			}}

	// 			onNearestXY={(value, {index}) => {	
	// 				this.setState({hintLocation: value});					
	// 				  this.setState({sHintText: value.HebrewTextForHint});	//this.listGraphDataAndSettings[sGraphUniqueName].Data[index]										
	// 				this.setState({sGraphUniqueNameCurrentlyShowingHint: sGraphUniqueName});
	// 			}}
	// 			/>

	// 			{this.state.sGraphUniqueNameCurrentlyShowingHint === sGraphUniqueName && 
	// 			<Hint value={this.state.hintLocation}>
	// 				<div style={{ 
	// 					background: 'black',
	// 					fontFamily: "SBL Hebrew", 
	// 					color: "white", 
	// 					fontSize:"22px",
	// 					//width: this.state.listSelectedWords.includes(w) ? "750px" : "default", borderStyle: "solid"           
	// 				}}>
	// 				<p>{this.state.sHintText}</p>
	// 				</div>
	// 			  </Hint>}
	// 		</XYPlot>
	// 		</div>
	// 	)
    // }

    DrawClausesByParticipantView()
    {
        // return <div style={{textAlign:"center"}}>
        //     <TreeView style={{height: 216, flexGrow: 1, maxWidth: 400}}
        //         defaultCollapseIcon={<ExpandMoreIcon />}
        //         defaultExpandIcon={<ChevronRightIcon />}>

        //         <TreeItem nodeId="1" label="Applications">
        //             <TreeItem
        //             nodeId="2"
        //             label={
        //                 <TextField
        //                 value={""}
        //                 variant="outlined"
        //                 //InputProps={{ classes: { input: classes.inputInput } }}
        //                 style={{padding: "4px 8px"}}
        //                 //onChange={handleChange}
        //                 />
        //             }
        //             />
        //             <TreeItem nodeId="3" label="Chrome" />
        //             <TreeItem nodeId="4" label="Webstorm" />
        //         </TreeItem>
        //         <TreeItem nodeId="5" label="Documents">
        //             <TreeItem nodeId="6" label="Material-UI">
        //             <TreeItem nodeId="7" label="src">
        //                 <TreeItem nodeId="8" label="index.js" />
        //                 <TreeItem nodeId="9" label="tree-view.js" />
        //             </TreeItem>
        //             </TreeItem>
        //         </TreeItem>

        //         {this.state.listLines.map(line => <TreeItem nodeId={line.Words[0].TextIndex} label={line.Words[0].FullText}></TreeItem>)}
        //     </TreeView>
        // </div>
    }

    GetAlignedClauseTD(listWords)
    {
        return <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left', borderStyle: "solid", borderWidth: "1px", paddingLeft: "5px", paddingRight: "5px"}}>          
            {listWords.map(w => 
                <span class="TextWordDiv" //title={blnTranslation ? "test2" : }
                style={{ fontFamily: "SBL Hebrew", fontSize: "22px", color: this.GetTextColor(w)}}>
                    {w.FullText + (w.FullText.endsWith("־") ? "" : " ")}</span> )}   
        </td>
    }

	DrawPropositionLines()
	{
		if(this.state.listPropositions === null) return;

		return <div style={{display: "inline-block", verticalAlign:"top", textAlign:"center"}}>
        <table style={{paddingRight: "20px", display: "inline-block", borderCollapse: "collapse"}}>
            <tr>
            {this.state.listPropositions.map(proposition =>
                <>
                <tr>						
                <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left'}}>
                    {Array(parseInt(proposition.IndentLevel) * this.nSpacesPerLineIndent).fill(<span>&nbsp;</span>)}				
                    {this.GetSpansForWords(proposition.Words, false, true, false, false)}
                </td>
            
                <td style={{paddingLeft: "5px", userSelect: "none"}}>
                    {this.state.blnShowVerseNumbers && this.listVerseBeginNumbersAndWords != undefined && 
                    (!this.listVerseBeginNumbersAndWords.some(r => proposition.Words.includes(r.Word)) ? '' :
                        this.listVerseBeginNumbersAndWords.find(r => proposition.Words.includes(r.Word)).VerseNumber)}
                </td>

                {/* {this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID &&
                    <td style={{paddingLeft: "5px"}}> 
                        {this.GetRepetitionGroupLinksForLine(proposition).map(g => 
                            <span style={{
                                borderStyle: this.state.listCurrentRepetitionLinkGroups != undefined && this.state.listCurrentRepetitionLinkGroups.includes(g) ? "solid" : "none",
                                borderColor: "black",
                                borderWidth: "1px",
                            }}
                            onMouseEnter={(event) => this.handleHoverRepetitionLinkGroup(g)}
                            onMouseLeave={(event) => this.handleHoverLeaveRepetitionLinkGroup(g)}
                            onClick={(event) => this.handleClickRepetitionLinkGroup(g, proposition)}>
                            {g.ListWords.length}&nbsp;</span>)}</td>
                } */}

                {/* <td style={{textAlign:"left", minWidth: "50px"}} 
                    onClick={(event) => {
                        if(!proposition.InTranslationEditMode) this.UpdateLineField(proposition, "InTranslationEditMode", true)}}>
                    {this.state.blnShowTranslation && Array(parseInt(proposition.IndentLevel) * this.nSpacesPerLineIndent).fill(<span>&nbsp;</span>)}				
                    {this.state.blnShowTranslation && (
                        proposition.InTranslationEditMode ? 

                        <input type="text" variant="outlined" size={40} autoFocus 
                            defaultValue={this.MergeTranslationsForEdit(proposition.Words)}
                            onKeyDown={(event) => {
                                if(event.key === "Enter") 
                                {
                                    this.SplitAndSaveEditedTranslation(proposition.Words, event.target.value);
                                    this.UpdateLineField(proposition, "InTranslationEditMode", false);
                                }}}
                        /> :

                        this.GetSpansForWords(proposition.Words, true, true, false, false))}
                </td> */}

                {/* {nLineIndex === 0 && <td style={{textAlign:"left", paddingLeft: "10px"}} rowspan="0">{this.DrawSemanticOutline()}</td>} */}
            </tr>

            {!this.state.blnShowSVGLineLinks && this.state.blnBreakAfterRepetitionGroupEnd && this.PropositionEndsARepetitionGroup(proposition) && <tr><td colSpan={10} style={{userSelect: "none"}}>&nbsp;</td></tr>}
            </>)}
			</tr>
        </table>
        </div>
	}
    
    WordShouldBeIncludedInLinesLocking(w)
    {
        if(this.state.blnShowLenses && this.AllSimilarityLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		{
            var wToCompareTo = this.GetHoveredOrFirstStickiedWordForLens()
			return w === wToCompareTo || this.GetAllSimilarityAmountScore(w, wToCompareTo).Score >= 3
		}
        else if(this.state.blnShowLenses && this.RhymeLensIsEnabled() && this.SomeWordIsStickiedOrHovered())
		{
            var wToCompareTo = this.GetHoveredOrFirstStickiedWordForLens()
			return w === wToCompareTo || ['Black', 'Purple', 'Red'].includes(this.GetRhymeAmountColor(w, wToCompareTo))
		}
        else return this.WordIsOutlined(w)
    }

    GetLinesForRepetitionGroupsWithOutlinedWords()
    {
        //get all lines in a repetition group that has an outlined word in it.
        //if the line is not in a repetition group, include the whole verse if it has the word in it.
        return this.state.listLines.filter(l => {
            // var rg = this.GetRepetitionGroupForLine(l)

            // if(rg === undefined)
            // {
                if(l.Words.length === 0) return false
                var listWordsInSameVerse = this.listTextWordsForChapter.filter(w => w.Verse === l.Words[0].Verse)
                return listWordsInSameVerse.some(w => this.WordShouldBeIncludedInLinesLocking(w))
            // }
            // else
            // {
            //     return rg.Lines.some(l2 => l2.Words.some(w => this.WordShouldBeIncludedInLinesLocking(w)))
            // }
        }) 
    }

    GetLinesToDraw()
    {
        if(this.state.blnBreakLinesByWordsMatchingLenses && this.state.blnShowLenses)
        {
            var listTextWordsToUse = this.listTextWordsForChapter
            var listWordsToBreakBy = []

            if(this.LetterInTransliterationLensIsEnabled())
            {
                listWordsToBreakBy = listTextWordsToUse.filter(w => {
                    return w.SyllableObjects.some(oSyllable => this.SyllableMatchesLetterInTransliterationLens(oSyllable))
                })
            }
            else if(this.state.listWordGroupsForEnabledLenses.length > 0)
            {
                listWordsToBreakBy = listTextWordsToUse.filter(w => {
                    return this.state.listWordGroupsForEnabledLenses.some(o => o.ListGroups.some(g => g.ListWords.includes(w)))
                })    
            }
            
            var listLinesToReturn = [{Words: []}]

            for(var w of listTextWordsToUse)
            {
                listLinesToReturn[listLinesToReturn.length - 1].Words.push(w)

                if(listWordsToBreakBy.includes(w))
                {
                    listLinesToReturn.push({Words: []})
                }
            }

            for(var line of listLinesToReturn)
            {
                line.SyllableObjects = line.Words.flatMap(w => w.SyllableObjects)
                line.SyllableCount = line.SyllableObjects.length
                line.IndentLevel = 0
            }

            //console.log(listWordsToBreakBy)
            //console.log(listLinesToReturn)
            return listLinesToReturn.length > 1 ? listLinesToReturn : this.state.listLines
        }
        else if(this.state.listLockedLinesToShow.length > 0 && !this.state.blnShiftDown)
        {
            return this.state.listLockedLinesToShow
        }
        else if(this.state.blnRestrictTextToVerseRangesToHighlight)
        {
            var listLineIndexRangesToHighlight = this.GetLineIndexRangesForCurrentVerseRangesString()
            return this.state.listLines.filter((l,n) => listLineIndexRangesToHighlight.some(r => n >= r.Begin && n <= r.End))
        }
        else if(this.state.listLockedLinesToShow.length > 0 && this.state.blnShiftDown && (this.SomeWordIsStickiedOrHovered() || this.SomeWordGroupIsSelectedInLineChart()))
        {
            return this.GetLinesForRepetitionGroupsWithOutlinedWords()
        }
        else return this.state.listLines
    }
    
    GetLinesForSideBySideMode(listToDraw, sGroupLinesByToUse)
    {
        var nFirstLineIndex = 0
        if(sGroupLinesByToUse != 'ByChapter')
        {
            nFirstLineIndex = listToDraw.filter(l => l.IsSuperscription).length
            listToDraw = listToDraw.filter(l => !l.IsSuperscription)
        }

        var listToReturn = this.GetLinesByBreakGroup(listToDraw, sGroupLinesByToUse).map((l, n, arr) => ({Lines: l}))

        var nCurrentAbsoluteIndexOfFirstLineInGroup = nFirstLineIndex
        for(var o of listToReturn)
        {
            o.AbsoluteIndexOfFirstLineInGroup = nCurrentAbsoluteIndexOfFirstLineInGroup
            nCurrentAbsoluteIndexOfFirstLineInGroup += o.Lines.length
        }

        return listToReturn
    }

    DrawClauses(listClausesToDraw)
    {
        // console.log(listClausesToDraw)
        return <div style={this.blnChapterIsHebrew ? {display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px', 
            width: !this.state.blnTextUnitSideBySideMode ? '100%' : this.state.blnShowHebrew && this.state.blnShowInterlinear ? '33%' : '20%'} :

            {display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px'}}>

        <table style={this.blnChapterIsHebrew ? {paddingRight: "20px", display: "inline-block", borderCollapse: "collapse"} :
            {width: '50%', display: "inline-block", borderCollapse: "collapse"}}>
            {listClausesToDraw.map((clause, nClauseIndex) => {
                // if(this.blnDevView && this.state.blnShowEnglishVersion)
                // {
                //     var sVerse = clause.Words[0].Verse
                //     var blnAddEnglishVersionColumn = (nClauseIndex === 0 || (nClauseIndex > 0 && listClausesToDraw[nClauseIndex - 1].Words.length > 0 && listClausesToDraw[nClauseIndex - 1].Words[0].Verse != sVerse))

                //     var sEnglishVersion = ''
                //     if(blnAddEnglishVersionColumn)
                //     {
                //         // var listClausesForVerse = dictClausesByVerse.get(sVerse)
                //         // var nClausesInThisVerse = listClausesForVerse === undefined ? 0 : dictClausesByVerse.get(sVerse).length

                //         var oEnglishVersion = this.listVersesForEnglishVersionOnlyForDevForCurrentBook.find(av => av.Verse === sVerse)
                //         if(oEnglishVersion != undefined) sEnglishVersion = oEnglishVersion.VerseText
                //     }
                // }

                return <>
                {/* {!this.state.blnShowSVGLineLinks && this.BreakBeforeLine(line, nClauseIndex, sLineBreakUnit) && <tr><td colSpan={10} style={{userSelect: "none"}}>&nbsp;</td></tr>} */}

                <tr>						
                    {this.state.blnShowHebrew && <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left'}}>
                        {Array(parseInt(clause.Indent) * this.nSpacesPerLineIndent).fill(<span>&nbsp;</span>)}				
                        {this.GetSpansForWords(clause.Words, false, true, false, false)}
                    </td>}
                
                    <td style={{paddingLeft: "5px", userSelect: "none"}}>
                        {this.state.blnShowVerseNumbers && this.listVerseBeginNumbersAndWords != undefined && 
                        (!this.listVerseBeginNumbersAndWords.some(r => clause.Words.includes(r.Word)) ? '' :
                            this.listVerseBeginNumbersAndWords.find(r => clause.Words.includes(r.Word)).VerseNumber)}
                    </td>

                    {/* {blnAddEnglishVersionColumn && <td rowspan={nLinesInThisVerse} 
                        style={{paddingLeft: "5px", paddingRight: "5px", maxWidth: "250px", fontFamily: "Calibri", fontSize: "18px"}}>{sEnglishVersion}</td>} */}

                    {this.state.blnShowInterlinear && <td style={{textAlign:"left", minWidth: "50px", paddingLeft: '10px'}}>
                        {this.state.blnShowTranslation && Array(parseInt(clause.Indent) * this.nSpacesPerLineIndent).fill(<span>&nbsp;</span>)}				
                        {this.state.blnShowTranslation && this.GetSpansForWords(clause.Words, !this.state.blnShowGlossesInsteadOfTranslation, true, this.state.blnShowGlossesInsteadOfTranslation, false)}
                    </td>}
                </tr>
            </>})}
        </table>
        </div>
    }

    GetColorForDevelopmentRepetitionGroup(nRepetitionGroup, nPercentOfLightness)
    {
        // sColorName === 'Red' ? ['0', '100%', '50%'] :
        // sColorName === 'Purple' ? ['300', '100%', '25%'] :
        // sColorName === 'DarkOrange' ? ['33', '100%', '50%'] :
        // sColorName === 'Green' ? ['120', '100%', '25%'] :
        // sColorName === 'Blue' ? ['240', '100%', '50%'] :
        // sColorName === 'Black' ? ['0', '0%', '0%'] :
        // sColorName === 'Brown' ? ['0', '59%', '41%'] :
        // sColorName === 'GreenYellow' ? ['84', '100%', '59%'] :
        // sColorName === 'Orange' ? ['39', '100%', '50%'] :
        // sColorName === 'Gold' ? ['51', '100%', '50%'] :
        // sColorName === 'Fuchsia' ? ['300', '100%', '50%'] :
        // sColorName === 'hsl(43, 80%, 40%)' ? ['43', '89%', '38%'] :
        // sColorName === 'DarkCyan' ? ['180', '100%', '27%'] :
        // sColorName === 'Maroon' ? ['0', '100%', '25%'] :
        // sColorName === 'Indigo' ? ['275', '100%', '25%'] :
        // sColorName === 'DarkMagenta' ? ['300', '100%', '27%'] :
        // sColorName === 'CornflowerBlue' ? ['219', '79%', '66%'] :
        // sColorName === 'LightGreen' ? ['120', '73%', '75%'] :
        // sColorName === 'Olive' ? ['60', '100%', '25%'] : undefined

        var listHSLValues = 
            nRepetitionGroup === 0 ? ['33', '100%', '50%'] : 
            nRepetitionGroup === 1 ? ['120', '100%', '25%'] : 
            nRepetitionGroup === 2 ? ['240', '100%', '50%'] :
            nRepetitionGroup === 3 ? ['300', '100%', '35%'] :
            nRepetitionGroup === 4 ? ['180', '75%', '35%'] : 
            nRepetitionGroup === 5 ? ['348', '83%', '47%'] : 
            nRepetitionGroup === 6 ? ['43', '80%', '40%'] : 
            nRepetitionGroup === 7 ? ['219', '79%', '66%'] : 
            nRepetitionGroup === 8 ? ['6', '93%', '71%'] : 
            nRepetitionGroup === 9 ? ['60', '100%', '25%'] : 
            nRepetitionGroup === 10 ? ['20', '40%', '35%'] : 
            nRepetitionGroup === 11 ? ['20', '40%', '35%'] : 
            nRepetitionGroup === 12 ? ['20', '40%', '35%'] : 
            nRepetitionGroup === 14 ? ['20', '40%', '35%'] : 
            nRepetitionGroup === 15 ? ['20', '40%', '35%'] : 
            nRepetitionGroup === 16 ? ['20', '40%', '35%'] : 
            nRepetitionGroup === 17 ? ['20', '40%', '35%'] : 
            nRepetitionGroup === 18 ? ['20', '40%', '35%'] :  
            nRepetitionGroup === 19 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 20 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 21 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 22 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 23 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 24 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 25 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 26 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 27 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 28 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 29 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 30 ? ['20', '40%', '35%'] :
            nRepetitionGroup === 31 ? ['20', '40%', '35%'] : ['0', '0%', '0%']

        return 'hsl(' + listHSLValues[0] + ', ' + listHSLValues[1] + ', ' + Math.min(80, Math.floor((parseInt(listHSLValues[2].replace('%', '')) * nPercentOfLightness))) + '%)'
    }

    GetKeyForDevelopmentThemeGroup(nGroupID)
    {
        return nGroupID < 10 ? nGroupID.toString() :
            nGroupID === 10 ? 'q' :
            nGroupID === 11 ? 'w' :
            nGroupID === 12 ? 'e' :
            nGroupID === 14 ? 'r' :
            nGroupID === 15 ? 't' :
            nGroupID === 16 ? 'y' :
            nGroupID === 17 ? 'u' :
            nGroupID === 18 ? 'o' :
            nGroupID === 19 ? 'p' : 
            nGroupID === 20 ? 'd' :
            nGroupID === 21 ? 'f' :
            nGroupID === 22 ? 'j' :
            nGroupID === 23 ? 'k' :
            nGroupID === 24 ? 'x' :
            nGroupID === 25 ? 'v' :
            nGroupID === 26 ? 'b' :
            nGroupID === 27 ? 'n' :
            nGroupID === 28 ? 'm' :
            nGroupID === 29 ? ',' :
            nGroupID === 30 ? '.' :
            nGroupID === 31 ? '/' : '?'
    }

    GetDescForDevelopmentThemeGroup(nGroupID)
    {
        var sToReturn = 'Theme ' + nGroupID.toString()
        var oDescForGroup = this.state.listDevelopmentRepetitionDescsForGroupsByChapter.find(o => o.ID === nGroupID)
        if(oDescForGroup != undefined)
        {
            sToReturn = oDescForGroup.Desc
        }

        return sToReturn
    }

    GetDevelopmentDiagramThemeChart()
    {
        var sChapter = this.GetFirstCurrentChapter().toString()

        var listGroups = [...new Set(this.state.listDevelopmentRepetitionGroupsByChapter.filter(o => o.Chapter === sChapter).flatMap(o => o.Groups))]
        .map(nGroupID => ({GroupID: nGroupID, Desc: this.GetDescForDevelopmentThemeGroup(nGroupID),
            LineIndexes: this.state.listDevelopmentRepetitionGroupsByChapter
            .filter(o => o.Chapter === sChapter && o.Groups.includes(nGroupID))
            .map(o => o.LineIndex)}))
        .sort((a,b) => Math.min(...a.LineIndexes) - Math.min(...b.LineIndexes))
        .map((oGroup, n) => ({GroupID: oGroup.GroupID, Desc: oGroup.Desc, LineIndexes: oGroup.LineIndexes, y: n}))

        // var listYTickKeys = listGroups.map(oGroup => )
        var nMaxY = Math.max(...listGroups.map(oGroup => oGroup.y))
        var nHeight = 25 * listGroups.length

        return <XYPlot width={1225} height={nHeight < 100 ? 100 : nHeight} 
            margin={{left: 275, right: 500, top: 20, bottom: 20}}>

            {this.GetGroupBreakLines(nMaxY, true, this.state.sGroupLinesBy)}

            {listGroups.map(oGroup => {
                var sColor = this.GetColorForDevelopmentRepetitionGroup(oGroup.GroupID, 1.35) //'LightGray'
                var listData = oGroup.LineIndexes.map(nLine => ({x: nLine, y: oGroup.y, color: sColor}))

                //LineMarkSeries
                return <MarkSeries lineStyle={{stroke: sColor}} colorType="literal" data={listData}/>
            })}

            <YAxis orientation='right' position='start'
                tickFormat={v => {
                    var oGroupWithID = listGroups.find(oGroup => oGroup.y === v)
                    return oGroupWithID === undefined ? '' : oGroupWithID.Desc
                }}
                tickTotal = {listGroups.length} 
                style={{text: {fontSize: 20, fontFamily: 'Calibri'}}} />
        </XYPlot>
    }

    DrawDevelopmentDiagramThemeDescs()
    {
        if(this.state.blnColorLinesByDevelopmentRepetitionGroup)
        {
            var sChapter = this.GetFirstCurrentChapter().toString()
            //sort the group ids by number of occurrences
            var listGroupIDs = [...new Set(this.state.listDevelopmentRepetitionGroupsByChapter.filter(o => o.Chapter === sChapter).flatMap(o => o.Groups))]
            .map(nGroupID => ({GroupID: nGroupID, 
                Occurrences: this.state.listDevelopmentRepetitionGroupsByChapter.filter(o => o.Chapter === sChapter && o.Groups.includes(nGroupID)).length}))
            .sort((a,b) => b.Occurrences - a.Occurrences).map(o => o.GroupID)

            return listGroupIDs.map(nGroupID => {
                var sText = this.GetDescForDevelopmentThemeGroup(nGroupID)

                return nGroupID === this.state.nDevelopmentDiagramColorKeyGroupIDBeingEdited ? 
                    <input type="text" defaultValue={sText} size={20} style={{marginLeft: '20px'}} autoFocus
                    
                    onFocus={(e) => this.setState({blnEditThemeNameHasFocus: true})}
                    onBlur={(e) => this.setState({blnEditThemeNameHasFocus: false})}
                    onKeyDown={(event) => {
                        if(event.key === "Enter") 
                        {
                            this.SetDescForDevelopmentRepetitionGroup(this.state.nDevelopmentDiagramColorKeyGroupIDBeingEdited, sChapter, event.target.value)
                            this.setState({nDevelopmentDiagramColorKeyGroupIDBeingEdited: -1})
                            this.setState({blnEditThemeNameHasFocus: false})
                        }}} /> :

                    <span style={{color: this.GetColorForDevelopmentRepetitionGroup(nGroupID, 1.0), marginLeft: '20px'}}
                    onClick={() => this.setState({nDevelopmentDiagramColorKeyGroupIDBeingEdited: nGroupID})}
                    onMouseEnter={() => this.setState({nDevelopmentDiagramColorKeyGroupIDBeingHovered: nGroupID})}
                    onMouseLeave={() => this.setState({nDevelopmentDiagramColorKeyGroupIDBeingHovered: -1})}
                    >{sText + ' ' + this.GetKeyForDevelopmentThemeGroup(nGroupID)}</span>
            })
        }
    }

    GetOurTranslationLinksForTextIndexInOriginal(sTextIndex)
    {
        return this.state.listTranslationWordIndexLinks.filter(o => o.Original === sTextIndex)
    }

    GetWordsForEachGrammaticalGroup(listTextWordsToUse, sGroupType)
    {
        var listToReturn = []

        if(sGroupType === 'prepositions')
        {
            for(var sPreposition of ['b', 'l', 'k', 'm'])
            {
                listToReturn.push({TranslationLinkGroupsByTextIndexMainWordType: 'preposition', 
                    Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length],
                    ListWords: this.WordsMatchingProperty('Preposition', sPreposition, listTextWordsToUse, [])})
            }
        }

        if(sGroupType === 'suffixes')
        {
            for(var sSuffixPGN of ['1ms', '2ms', '2fs', '3ms', '3fs', '1mp', '2mp', '2fp', '3mp', '3fp', '1cs'])
            {
                listToReturn.push({TranslationLinkGroupsByTextIndexMainWordType: 'suffix',
                    Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length],
                    ListWords: this.WordsMatchingProperty('suffixpgn', sSuffixPGN, listTextWordsToUse, [])})
            }
        }

        // for(var sPGN of ['1ms', '2ms', '2fs', '3ms', '3fs', '1mp', '2mp', '2fp', '3mp', '3fp', '1cs', '3cp'])
        // {
        //     listToReturn.push({ListWords: this.WordsMatchingProperty('verb', sPGN, listTextWordsToUse, [])})
        // }

        // for(var sStem of ['n', 'h', 'p'])
        // {
        //     listToReturn.push({ListWords: this.WordsMatchingProperty('stem', sStem, listTextWordsToUse, [])})
        // }

        //['i', 'v', 'p', 'q', 'h', 'w', 'j']
        if(sGroupType === 'certainverbforms')
        {
            for(var sForm of ['c', 'a', 'v'])
            {
                listToReturn.push({Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length],
                    ListWords: this.WordsMatchingProperty('verbform', sForm, listTextWordsToUse, [])})
            }

            listToReturn.push({Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length],
                ListWords: this.WordsMatchingProperty('participle', '', listTextWordsToUse, [])})
        }

        return listToReturn
    }

    GetIndexesOfSoundGroupInSyllable(g, sSyllable, blnSyllableEndsWithConsonantalHe)
    {
        if(g.ListChars.includes('y'))
        {
            return sSyllable.startsWith('y') ? [0] : []
        }
        else if(g.ListChars.includes('h'))
        {
            return (sSyllable.startsWith('h') ? [0] : []) + (blnSyllableEndsWithConsonantalHe ? [sSyllable.length - 1] : [])
        }
        else
        {
            return g.ListChars.map(c => sSyllable.indexOf(c))
        }
    }

    LastSyllableForRhymeLens(listTextWordsToUse)
    {
        let listLastSyllableGroups = [['iy', 'î'], ['ay'], 
            ['ēy', 'ē', 'ey', 'ê', 'ēh'], ['o', 'ô'], ['av', 'aw'], ['im', 'îm'], ['ot', 'ôt'], 
            ['kha', 'khâ'], ['ēkh'], ['ayikh'], ['u', 'û'], ['am'], ['hem'], ['khem'], ['nu', 'ēnu', 'ēynu']]

        // {"Name": "a" , "ListChars": ["a", "â"], "StringsToExclude": ["ay"], "IsVowel": true},
        // {"Name": "i" , "ListChars": ["i"], "StringsToExclude": [], "IsVowel": true},
        // {"Name": "iy" , "ListChars": ["î"], "StringsToExclude": [], "IsVowel": true},
        // {"Name": "e" , "ListChars": ["e"], "StringsToExclude": ["ey"], "IsVowel": true},
        // {"Name": "ē" , "ListChars": ["ē", "ê", "ey"], "StringsToExclude": [], "IsVowel": true},
        // {"Name": "ay" , "ListChars": ["ay", "5"], "StringsToExclude": [], "IsVowel": true},
        // {"Name": "o" , "ListChars": ["o", "ô"], "StringsToExclude": [], "IsVowel": true},
        // {"Name": "u" , "ListChars": ["u", "û"], "StringsToExclude": [], "IsVowel": true},

        //s.replaceAll('iy', 'î').replaceAll('ay', '5').replaceAll('ēy', 'ē').replaceAll('ey', 'ē')

        var listToReturn = []
        
        for(var listStringsInGroup of listLastSyllableGroups)
        {
            listToReturn.push({Name: listStringsInGroup[0], 
                ListWords: listTextWordsToUse.filter(w => {
                    //console.log(w.Transliteration)
                    return listStringsInGroup.some(s => this.RemoveNonVowelsAndNonConsonants(w.Transliteration).endsWith(s))
                    // let oLastSyllable = this.RemoveQuiescentFinalConsonants(this.RemoveNonVowelsAndNonConsonants(
                    //     w.SyllableObjects[w.SyllableObjects.length - 1].syllableWithSingleConsonants))
                    // return listStringsInGroup.some(s => oLastSyllable.endsWith(s))
                }), 
                Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
        }

        return listToReturn.filter(o => o.ListWords.length > 1)
    }
    
    SyllableContainsSoundGroup(g, sSyllable, blnSyllableEndsWithConsonantalHe, sLocationInSyllable)
    {
        // if(g.Name === 'h' && sSyllable.includes('h'))
        // {
        //     console.log(sSyllable, sLocationInSyllable, sSyllable.startsWith('h'), blnSyllableEndsWithConsonantalHe, 
        //     ((sLocationInSyllable === 'initial' && sSyllable.startsWith('h')) || 
        //     (sLocationInSyllable === 'final' && blnSyllableEndsWithConsonantalHe)))
        // }

        return g.ListChars.some(c => 
            (g.ListChars.includes('y') ? sSyllable.startsWith('y') : 
            g.ListChars.includes('h') ? ((sLocationInSyllable === 'initial' && sSyllable.startsWith('h')) || 
                (sLocationInSyllable === 'final' && blnSyllableEndsWithConsonantalHe) ||
                (sLocationInSyllable === 'anywhere' && (sSyllable.startsWith('h') || blnSyllableEndsWithConsonantalHe))) :
            sSyllable.includes(c)) && 
            !g.StringsToExclude.some(s => sSyllable.includes(s)))    
    }

    WordsBySoundGroupLens(listTextWordsToUse, sTypeOfSimilarity)
    {
        //don't try to rhyme God's name, since we don't really know how it was pronounced
        let listTextWordsToUse2 = listTextWordsToUse.filter(w => w.LexicalID != '3270')

        let listAllVowels = ["a", "â", "i", "î", "ē", "ê", "ey", "e", "ay", "5", "o", "ô", "u", "û", "ə"]

        let listSoundGroups = [
             {"Name": "a" , "ListChars": ["a", "â"], "StringsToExclude": ["ay"], "IsVowel": true},
            {"Name": "i" , "ListChars": ["i", "î"], "StringsToExclude": [], "IsVowel": true},
            {"Name": "e" , "ListChars": ["e"], "StringsToExclude": ["ey"], "IsVowel": true},
            {"Name": "ē" , "ListChars": ["ē", "ê", "ey"], "StringsToExclude": [], "IsVowel": true},
            {"Name": "ay" , "ListChars": ["ay", "5"], "StringsToExclude": [], "IsVowel": true},
            {"Name": "o" , "ListChars": ["o", "ô"], "StringsToExclude": [], "IsVowel": true},
            {"Name": "u" , "ListChars": ["u", "û"], "StringsToExclude": [], "IsVowel": true},
            
            {"Name": "k.g", "ListChars": ["k", "q", "g"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "ḥ", "ListChars": ["ḵ", "ḥ"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "h", "ListChars": ["h"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "s.z", "ListChars": ["s", "z", "ṣ"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "š", "ListChars": ["š"], "StringsToExclude": [], "IsVowel": false},
            //{"Name": "ṣ", "ListChars": ["ṣ"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "p.b", "ListChars": ["b", "p"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "t.d", "ListChars": ["t", "d", "ṣ"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "f.v", "ListChars": ["f", "v", "w"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "ʿ", "ListChars": ["ʿ"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "ʾ", "ListChars": ["ʾ"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "l", "ListChars": ["l"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "r", "ListChars": ["r"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "m", "ListChars": ["m"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "n", "ListChars": ["n"], "StringsToExclude": [], "IsVowel": false},
            {"Name": "y", "ListChars": ["y"], "StringsToExclude": [], "IsVowel": false}]
        
        //console.log(listTextWordsToUse2.map(w => ({T: w.Transliteration, D: w.SyllableObjects})))

        var listWordsBySoundGroup = new Map()
        for(let g of listSoundGroups)
        {
            let listWordsWithSound = listTextWordsToUse2.map(w => {
                // let listSyllableIndexesWithSoundGroup = w.SyllableObjects.map((oSyllable, n) => [oSyllable, n])
                // .filter(([oSyllable, n]) => {
                //     let sSyllable = oSyllable.syllableWithSingleConsonants

                //     return g.ListChars.some(c => 
                //         (g.ListChars.includes('y') ? sSyllable.startsWith('y') : 
                //         g.ListChars.includes('h') ? (sSyllable.startsWith('h') || oSyllable.endsWithConsonantalHe) :
                //         sSyllable.includes(c)) && 
                //         !g.StringsToExclude.some(s => sSyllable.includes(s)))
                // })
                // .map(([oSyllable, n]) => n)

                return {Word: w, SyllableData: w.SyllableObjects.map((oSyllable, ns) => {
                    var sSyllable = this.RemoveQuiescentFinalConsonants(this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(
                        oSyllable.syllableWithSingleConsonants)))

                    if(!oSyllable.endsWithConsonantalHe && sSyllable.endsWith('h'))
                    {
                        sSyllable = sSyllable.slice(0, -1)
                    }

                    // if(w.TextIndex === '40')
                    // {
                    //     console.log(w.TextIndex, g.Name, sSyllable)
                    // }

                    //console.log(sSyllable, sSyllable.length > 0 && !listAllVowels.includes(sSyllable[sSyllable.length - 1]))

                    return {Syllable: oSyllable, 
                        IndexOfSyllable: ns, //SyllableString: sSyllable,
                        Anywhere: this.SyllableContainsSoundGroup(g, sSyllable, oSyllable.endsWithConsonantalHe, 'anywhere'), 
                        Initial: this.SyllableContainsSoundGroup(g, sSyllable.slice(0,1), oSyllable.endsWithConsonantalHe, 'initial'), 
                        Final: sSyllable.length > 2 && this.SyllableContainsSoundGroup(g, sSyllable.slice(2,3), oSyllable.endsWithConsonantalHe, 'final'),
                        //OccurrenceIndexes: this.GetIndexesOfSoundGroupInSyllable(g, sSyllable, oSyllable.endsWithConsonantalHe),
                        EndsWithConsonantalHe: oSyllable.endsWithConsonantalHe,
                        IsAccentedSyllable: oSyllable.hasFullAccent || oSyllable.HasSecondaryAccent,
                        IsClosedSyllable: sSyllable.length > 0 && !listAllVowels.includes(sSyllable[sSyllable.length - 1])} //length > 2
                })}
            }).filter(o => o.SyllableData.filter(sd => sd.Anywhere).length > 0)

            listWordsBySoundGroup.set(g.Name, listWordsWithSound)
        }

        //console.log(listWordsBySoundGroup)

        var listToReturn = []

        if(sTypeOfSimilarity === 'combination')
        {
            //words with >1 of the same sounds in neighboring syllables
            var listDone = []
            for(let g1 of listSoundGroups)
            {
                let listWordsForGroup1 = listWordsBySoundGroup.get(g1.Name)
                for(let g2 of listSoundGroups)
                {
                    if(g1 === g2 || (g1.IsVowel && g2.IsVowel) || 
                        (this.state.blnLookForReverseSoundSequencesInDiagram && listDone.some(oPairDone => oPairDone.g2 === g1 && oPairDone.g1 === g2))) continue

                    if(this.state.blnLookForReverseSoundSequencesInDiagram)
                    {
                        listDone.push({'g1': g1, 'g2': g2})
                    }

                    let listWordsForGroup2 = listWordsBySoundGroup.get(g2.Name)

                    //if one sound is a vowel and the other a consonant, they must be the same syllable
                    let blnVowelAndConsonant = (g1.IsVowel && !g2.IsVowel) || (!g1.IsVowel && g2.IsVowel)
                    let nMaxSyllableDistance = blnVowelAndConsonant ? 0 : 1

                    let listWordsWithBothGroups = listWordsForGroup1.filter(w => listWordsForGroup2.some(w2 => w.Word === w2.Word && 
                        w.SyllableData.filter(sd => sd.Anywhere).some(sd => 
                            w2.SyllableData.filter(sd => sd.Anywhere).some(sd2 => {
                                let nIndexDifference = sd2.IndexOfSyllable - sd.IndexOfSyllable
                                var blnSoundPositionComparison = false

                                if(blnVowelAndConsonant)
                                {
                                    blnSoundPositionComparison = sd.IsAccentedSyllable && 
                                        ((g1.IsVowel && sd2.Final) || (g2.IsVowel && sd.Initial))

                                    // if(nIndexDifference === 0 && sd.IsAccentedSyllable)
                                    // {
                                    //     console.log(w.Word.Transliteration, g1, g2, sd, sd2, blnSoundPositionComparison)
                                    // }
                                }
                                else
                                {
                                    let sdEarlier = this.state.blnLookForReverseSoundSequencesInDiagram ? (sd.IndexOfSyllable <= sd2.IndexOfSyllable ? sd : sd2) : sd
                                    let sdLater = this.state.blnLookForReverseSoundSequencesInDiagram ? (sd.IndexOfSyllable > sd2.IndexOfSyllable ? sd : sd2) : sd2

                                    blnSoundPositionComparison = (sdEarlier.Initial && sdLater.Initial && !sdEarlier.IsClosedSyllable) || 
                                        ((this.state.blnLookForReverseSoundSequencesInDiagram || nIndexDifference != 0) && sdEarlier.Final && sdLater.Initial) ||
                                        (nIndexDifference === 0 && sdEarlier.Initial && sdLater.Final)
                                }

                                // if((w.Word.TextIndex === '5407'))
                                // {
                                //     console.log(nIndexDifference, g1.Name, g2.Name, sd, sd2, blnSoundPositionComparison)
                                // }

                                return blnSoundPositionComparison && Math.abs(nIndexDifference) <= nMaxSyllableDistance && 
                                    (this.state.blnLookForReverseSoundSequencesInDiagram || nIndexDifference >= 0)
                            }))))

                    if(listWordsWithBothGroups.length > 1)
                    {
                        //exclude groups with words that are all from the same root
                        let listWords = listWordsWithBothGroups.map(o => o.Word)

                        // if(listWords.some(w => w.TextIndex === "39"))
                        // {
                        //     console.log([...new Set(listWords.map(w => w.LexicalID))])
                        // }

                        // var listMerged = listWordsWithBothGroups.reduce((acc, syl) => {
                        //     // Get the current syllable's text and its character indexes
                        //     const { text, indexes } = syl;
                            
                        //     // Calculate the current offset from the beginning of the word.
                        //     // The offset is the length of all previous syllables combined.
                        //     const offset = acc.offset;
                            
                        //     // Map the current syllable's indexes to their new absolute position
                        //     // in the word by adding the offset.
                        //     const absoluteIndexes = indexes.map(index => index + offset);
                            
                        //     // Return an object containing the new list of merged indexes
                        //     // and the updated offset for the next iteration.
                        //     return {
                        //         merged: [...acc.merged, ...absoluteIndexes],
                        //         offset: offset + text.length
                        //     };
                        //     }, {merged: [], offset: 0})

                        // listWordsWithBothGroups.map(o => {
                        //     var listOccurrenceIndexes = []
                        //     listOccurrenceIndexes = listOccurrenceIndexes.push() 
                        //     o.SyllableData.map((sd,n) => ({OccurrenceIndexes: sd.OccurrenceIndexes))
                        // })
                        
                        listToReturn.push({Name: g1.Name + '-' + g2.Name, CategoryForLinkFiltering: 'combination', 
                            Color: 'hsl(240, 75%, 50%)', ListWords: listWords}) //, OccurrenceIndexesByWord: })
                    }
                }
            }
        }

        if(sTypeOfSimilarity === 'SameAccentedSyllable')
        {
            var listDone = []
            for(let g1 of listSoundGroups)
            {
                let listWordsForGroup1 = listWordsBySoundGroup.get(g1.Name)
                for(let g2 of listSoundGroups)
                {
                    if(g1 === g2 || (g1.IsVowel && g2.IsVowel)) continue

                    let listWordsForGroup2 = listWordsBySoundGroup.get(g2.Name)

                    //if one sound is a vowel and the other a consonant, they must be the same syllable
                    let blnVowelAndConsonant = (g1.IsVowel && !g2.IsVowel) || (!g1.IsVowel && g2.IsVowel)
                    //let nMaxSyllableDistance = blnVowelAndConsonant ? 0 : 1

                    let listWordsWithBothGroups = listWordsForGroup1.filter(w => listWordsForGroup2.some(w2 => w.Word === w2.Word && 
                        w.SyllableData.filter(sd => sd.Anywhere).some(sd => 
                            w2.SyllableData.filter(sd => sd.Anywhere).some(sd2 => {
                                let nIndexDifference = sd2.IndexOfSyllable - sd.IndexOfSyllable

                                return nIndexDifference === 0 && blnVowelAndConsonant && sd.IsAccentedSyllable && ((g1.IsVowel && sd2.Final) || (g2.IsVowel && sd.Initial))
                            }))))

                    if(listWordsWithBothGroups.length > 1)
                    {
                        listToReturn.push({Name: g1.Name + '-' + g2.Name, CategoryForLinkFiltering: 'SameAccentedSyllable', 
                            Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], ListWords: listWordsWithBothGroups.map(o => o.Word)})
                    }
                }
            }
        }

        if(sTypeOfSimilarity === 'SameAccentedVowelWithNoOrCompatibleFinalConsonant')
        {
            var listDone = []
            for(let g1 of listSoundGroups.filter(g => g.IsVowel))
            {
                let listWordsForGroup1 = listWordsBySoundGroup.get(g1.Name)
                let listWordsForGroupWithTheVowelOnTheAccentedSyllableAndItsOpen = 
                    listWordsForGroup1.filter(o => o.SyllableData.some(o2 => o2.Anywhere && o2.IsAccentedSyllable)) //&& (!o2.IsClosedSyllable || o2.EndsWithConsonantalHe)))

                // if(g1.Name === 'a')
                // {
                //     console.log(listWordsForGroup1.map(w => ({T: w.Word.Transliteration, D: w.SyllableData})))
                //     //console.log(g1.Name, listWordsBySoundGroup.get(g1.Name))
                // }

                if(listWordsForGroupWithTheVowelOnTheAccentedSyllableAndItsOpen.length > 1)
                {
                    listToReturn.push({Name: g1.Name, CategoryForLinkFiltering: 'SameAccentedVowelWithNoOrCompatibleFinalConsonant', 
                        Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], 
                        ListWords: listWordsForGroupWithTheVowelOnTheAccentedSyllableAndItsOpen.map(o => o.Word)})
                }

                // for(let g2 of listSoundGroups.filter(g => !g.IsVowel))
                // {
                //     let listWordsForGroup2 = listWordsBySoundGroup.get(g2.Name)

                //     let listWordsWithBothGroups = listWordsForGroup1.filter(o => listWordsForGroup2.some(o2 => o.Word === o2.Word && 
                //         o.SyllableData.filter(sd => sd.Anywhere && sd.IsAccentedSyllable).some(sd => 
                //             o2.SyllableData.filter(sd => sd.Final && sd.IsAccentedSyllable).some(sd2 => sd2.IndexOfSyllable === sd.IndexOfSyllable))))

                //     if(listWordsWithBothGroups.length > 1)
                //     {
                //         listToReturn.push({Name: g1.Name + '-' + g2.Name, CategoryForLinkFiltering: 'SameAccentedVowelWithNoOrCompatibleFinalConsonant', 
                //             Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], 
                //             ListWords: listWordsWithBothGroups.map(o => o.Word)})
                //     }
                // }
            }
        }

        if(sTypeOfSimilarity === 'SameAccentedVowelWithNoOrCompatibleFinalConsonantOrInitialSoundGroup')
        {
            var listDone = []
            for(let g1 of listSoundGroups.filter(g => g.IsVowel))
            {
                let listWordsForGroup1 = listWordsBySoundGroup.get(g1.Name)
                let listWordsForGroupWithTheVowelOnTheAccentedSyllableAndItsOpen = 
                    listWordsForGroup1.filter(o => o.SyllableData.some(o2 => o2.Anywhere && o2.IsAccentedSyllable)) //&& (!o2.IsClosedSyllable || o2.EndsWithConsonantalHe)))

                // if(g1.Name === 'a')
                // {
                //     console.log(listWordsForGroup1.map(w => ({T: w.Word.Transliteration, D: w.SyllableData})))
                //     //console.log(g1.Name, listWordsBySoundGroup.get(g1.Name))
                // }

                if(listWordsForGroupWithTheVowelOnTheAccentedSyllableAndItsOpen.length > 1)
                {
                    listToReturn.push({Name: g1.Name, CategoryForLinkFiltering: 'SameAccentedVowelWithNoOrCompatibleFinalConsonant', 
                        Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], 
                        ListWords: listWordsForGroupWithTheVowelOnTheAccentedSyllableAndItsOpen.map(o => o.Word)})
                }
            }

            for(let g1 of listSoundGroups.filter(g => !g.IsVowel))
            {
                let listWordsForGroup1 = listWordsBySoundGroup.get(g1.Name)
                let listWordsForGroupWithTheConsonantInitial = 
                    listWordsForGroup1.filter(o => o.SyllableData.length > 0 && o.SyllableData[0].Initial)

                if(listWordsForGroupWithTheConsonantInitial.length > 1)
                {
                    listToReturn.push({Name: g1.Name, CategoryForLinkFiltering: 'SameInitialSoundGroup', 
                        Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], 
                        ListWords: listWordsForGroupWithTheConsonantInitial.map(o => o.Word)})
                }
            }
        }

        if(sTypeOfSimilarity === 'WordsBySoundGroupInitialConsonantOfStressedSyllable')
        {
            var listDone = []
            for(let g1 of listSoundGroups.filter(g => !g.IsVowel))
            {
                let listWordsForGroup1 = listWordsBySoundGroup.get(g1.Name)
                let listWordsForGroupWithTheConsonantInitial = 
                    listWordsForGroup1.filter(o => o.SyllableData.some(o2 => o2.Initial && o2.IsAccentedSyllable))

                if(listWordsForGroupWithTheConsonantInitial.length > 1)
                {
                    listToReturn.push({Name: g1.Name, CategoryForLinkFiltering: 'WordsBySoundGroupInitialConsonantOfStressedSyllable', 
                        Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], 
                        ListWords: listWordsForGroupWithTheConsonantInitial.map(o => o.Word)})
                }
            }
        }

        if(sTypeOfSimilarity === 'WordsBySoundGroupConsonant')
        {
            var listDone = []
            for(let g1 of listSoundGroups.filter(g => !g.IsVowel))
            {
                let listWordsForGroup1 = listWordsBySoundGroup.get(g1.Name)
                .filter(o => o.SyllableData.some(o2 => o2.Anywhere))

                if(listWordsForGroup1.length > 1)
                {
                    listToReturn.push({Name: g1.Name, CategoryForLinkFiltering: 'WordsBySoundGroupConsonant', 
                        Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], 
                        ListWords: listWordsForGroup1.map(o => o.Word)})
                }
            }
        }

        if(sTypeOfSimilarity === 'WordsBySoundGroupFinalConsonant')
        {
            var listDone = []
            for(let g1 of listSoundGroups.filter(g => !g.IsVowel))
            {
                let listWordsForGroup1 = listWordsBySoundGroup.get(g1.Name)
                .filter(o => o.SyllableData.length > 0 && o.SyllableData[o.SyllableData.length - 1].Final)

                if(listWordsForGroup1.length > 1)
                {
                    listToReturn.push({Name: g1.Name, CategoryForLinkFiltering: 'WordsBySoundGroupFinalConsonant', 
                        Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], 
                        ListWords: listWordsForGroup1.map(o => o.Word)})
                }
            }
        }

        if(sTypeOfSimilarity === 'finalsyllablewithoutinitialconsonant')
        {
            for(let gVowel of listSoundGroups.filter(g => g.IsVowel))
            {
                let listWordsForGroup1 = listWordsBySoundGroup.get(gVowel.Name)
                for(let gConsonant of listSoundGroups.filter(g => !g.IsVowel))
                {
                    let listWordsForGroup2 = listWordsBySoundGroup.get(gConsonant.Name)
                    let listWordsWithBothGroups = listWordsForGroup1.filter(w => 
                        listWordsForGroup2.some(w2 => {
                            if(w.Word !== w2.Word || w.SyllableData.length === 0) return false
                            let oLastSyllableDataVowel = w.SyllableData[w.SyllableData.length - 1]
                            let oLastSyllableDataConsonant = w2.SyllableData[w2.SyllableData.length - 1]
                            return oLastSyllableDataVowel.Anywhere && oLastSyllableDataConsonant.Final
                    }))
                 
                    if(listWordsWithBothGroups.length > 1)
                    {
                        let listWords = listWordsWithBothGroups.map(o => o.Word)
                        listToReturn.push({Name: gVowel.Name + gConsonant.Name, CategoryForLinkFiltering: 'finalsyllablewithoutinitialconsonant', 
                            Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], ListWords: listWords})
                    }
                }

                //for open syllables with that vowel
                let listWordsEndingInVowel = listWordsForGroup1.filter(w => {
                    if(w.SyllableData.length === 0) return false
                    let oLastSyllableDataVowel = w.SyllableData[w.SyllableData.length - 1]
                    return oLastSyllableDataVowel.Anywhere && !oLastSyllableDataVowel.IsClosedSyllable
                })

                if(listWordsEndingInVowel.length > 1)
                {
                    let listWords = listWordsEndingInVowel.map(o => o.Word)
                    listToReturn.push({Name: gVowel.Name, CategoryForLinkFiltering: 'finalsyllablewithoutinitialconsonant', 
                        Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], ListWords: listWords})
                }
            }
        }

        if(sTypeOfSimilarity === 'oneinitialsyllableandoneinfinalsyllable')
        {
            for(let g1 of listSoundGroups)
            {
                let listWordsForGroup1 = listWordsBySoundGroup.get(g1.Name)
                for(let g2 of listSoundGroups)
                {
                    let listWordsForGroup2 = listWordsBySoundGroup.get(g2.Name)
                    let listWordsWithBothGroups = listWordsForGroup1.filter(w => 
                        listWordsForGroup2.some(w2 => {
                            if(w.Word !== w2.Word || w.SyllableData.length === 0 || w2.SyllableData.length === 0) return false

                            let oLastSyllableData = w2.SyllableData[w2.SyllableData.length - 1]
                            return w.SyllableData[0].Initial && ((!g2.IsVowel && oLastSyllableData.Final) || 
                                (g2.IsVowel && oLastSyllableData.Anywhere && !oLastSyllableData.IsClosedSyllable))
                    }))
                 
                    if(listWordsWithBothGroups.length > 1)
                    {
                        let listWords = listWordsWithBothGroups.map(o => o.Word)
                        listToReturn.push({Name: g1.Name + ' initial, ' + g2.Name + ' final', CategoryForLinkFiltering: 'oneinitialsyllableandoneinfinalsyllable', 
                            Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], ListWords: listWords})
                    }
                }
            }
        }

        if(sTypeOfSimilarity === 'initial' || sTypeOfSimilarity === 'final' || sTypeOfSimilarity === 'anywhere')
        {
            for(let g of listSoundGroups)
            {
                //if(g.IsVowel || g.Name === "y") continue //|| g.Name === "m" || g.Name === "n"

                // , ThisConsonantEndsTheWord: !g.IsVowel && w.SyllableObjects.count > 0 && 
                //         g.ListChars.some(c => {
                //             let oLastSyllable = w.SyllableObjects[w.SyllableObjects.count - 1]
                //             return oLastSyllable.syllableWithSingleConsonants.endsWith(c) || (g.ListChars.includes('h') && oLastSyllable.endsWithConsonantalHe)
                //         }),

                let listWordsForGroup = listWordsBySoundGroup.get(g.Name)

                if(sTypeOfSimilarity === 'anywhere')
                {
                    if(listWordsForGroup.length > 1)
                    {
                        listToReturn.push({Name: g.Name, CategoryForLinkFiltering: 'anywhere', 
                            StringsInSoundGroup: g.ListChars, Group: g,
                            Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], 
                            ListWords: listWordsForGroup.map(o => o.Word),
                            ListSyllableData: listWordsForGroup.flatMap(o => o.SyllableData.filter(o2 => o2.Anywhere)),
                            ListSyllables: listWordsForGroup.flatMap(o => o.SyllableData.filter(o2 => o2.Anywhere).map(o2 => o2.Syllable)),
                            ListWordsAndSyllableIndexesInWords: listWordsForGroup.map(o => ({Word: o.Word, 
                                SyllableIndexes: o.SyllableData.filter(sd => sd.Anywhere).map(sd => sd.IndexOfSyllable)}))})
                    }
                }

                if(sTypeOfSimilarity === 'initial') //&& g.Name !== "y"
                {
                    //let listWithSameWordInitialSound = 
                    //    listWordsForGroup.filter(o => o.SyllableData.some(o2 => o2.Initial)).map(o => o.Word)

                    let listWithSameWordInitialSound = listWordsForGroup.filter(w => w.SyllableData.length > 0 && 
                       w.SyllableData[0].Initial).map(o => o.Word)
                        
                    if(listWithSameWordInitialSound.length > 1)
                    {
                        listToReturn.push({Name: g.Name + ' initial', CategoryForLinkFiltering: 'SameInitialSoundGroup', 
                            Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], ListWords: listWithSameWordInitialSound})
                    }
                }

                let blnShowIfVowelIsTheSameEvenInClosedSyllableWithDifferentConsonant = false
                if(sTypeOfSimilarity === 'final' && g.Name != 'y')
                {
                    let listWithSameWordFinalSound = listWordsForGroup.filter(w => {
                        if(w.SyllableData.length === 0) return false
                        let oLastSyllableData = w.SyllableData[w.SyllableData.length - 1]

                        return (!g.IsVowel && oLastSyllableData.Final) || 
                        (g.IsVowel && oLastSyllableData.Anywhere && 
                            (blnShowIfVowelIsTheSameEvenInClosedSyllableWithDifferentConsonant || !oLastSyllableData.IsClosedSyllable)) //&& oLastSyllableData.IsAccentedSyllable)
                    }).map(o => o.Word)

                    // if(g.Name === 'o') console.log(listWithSameWordFinalSound)
                    if(listWithSameWordFinalSound.length > 1)
                    {
                        listToReturn.push({Name: g.Name + ' final', CategoryForLinkFiltering: 'final', 
                            Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length], ListWords: listWithSameWordFinalSound})
                    }
                }

                // if(g.Name === "m")
                // {
                //     console.log(listWordsForGroup, listWithSameWordFinalSound, listToReturn)
                // }
            }
        }

        if(this.state.blnDoNotColorFirstWordInChain)
        {
            //console.log(listToReturn) //.filter(oGroup => oGroup.ListWords.some(w => w.TextIndex === '3620')))
            listToReturn.forEach(oGroup => oGroup.WordsToNotColor = [oGroup.ListWords[0]])
        }

        let blnConsoleLogSoundDataOccurrencesByLine = false
        if(blnConsoleLogSoundDataOccurrencesByLine)
        {
            //console.log(listToReturn)

            let listDataByLine = Array.from({length: this.state.listLines.length}, () => ({SoundData: []}))
            for(const g of listToReturn)
            {
                if(g.Group.IsVowel) continue

                for(const w of g.ListWords)
                {
                    let nLine = this.state.listLines.findIndex(r => r.Words.includes(w))

                    if(nLine > -1)
                    {
                        let nExistingIndex = listDataByLine[nLine].SoundData.findIndex(o => o.Group === g && o.Word === w)

                        if(nExistingIndex >= 0)
                        {
                            listDataByLine[nLine].SoundData[nExistingIndex].Count += 1
                        }
                        else
                        {
                            listDataByLine[nLine].SoundData.push({Group: g, Word: w, Count: 1})
                        }
                    }
                }
            }

            let listData = []
            for(var listSoundData of listDataByLine.map(o => o.SoundData.sort((a,b) => b.Count - b.Count)))
            {
                const soundCounts = listSoundData.map(o => o.Group.Name).reduce((accumulator, currentSound) => 
                {
                    const currentCount = accumulator[currentSound] ?? 0
                    accumulator[currentSound] = currentCount + 1
                    return accumulator
                }, {})

                const sortedByCount = Object.entries(soundCounts).sort(([, countA], [, countB]) => 
                {
                    return countB - countA;
                })

                listData.push(sortedByCount.map(o => o[0] + (o[1] > 1 ? (':' + o[1]) : '')).join(' '))
            }

            console.log(listData.join('\n'))
            //navigator.clipboard.writeText(listData.join('\n'))
        }

        //console.log(listToReturn)
        //console.log(listToReturn.filter(o => o.ListWords.some(w => w.TextIndex === '2594') && o.ListWords.some(w => w.TextIndex === '2601')))
        return listToReturn //.filter(o => [...new Set(o.ListWords.map(w => w.ParentRoot))].length > 1)
    }

    GetDiagramLinkGroupsFromWordGroups(listWordGroups, sChapter, blnHebrew, blnListContainsWordIndexesNotWords, sLinkGroupType, 
        lens, sColorToUseForAllGroups)
    {
        return listWordGroups.map((g, n) => {
            let listWordsToLinkInGroup = g.ByLine ? g.Lines.map(line => line.Words[0]) : g.ListWords
            
            // if(g.Name === 'a-t')
            // {
            //     console.log(g.WordsToNotColor) //listToReturn.filter(o => o.Name === 'a-t'))
            // }

            return {Chapter: sChapter, Width: 1, LinkGroupType: sLinkGroupType, CategoryForLinkFiltering: lens.CategoryForLinkFiltering,
                Color: sColorToUseForAllGroups !== '' ? sColorToUseForAllGroups : g.Color, Lens: lens, ByLine: g.ByLine, Name: g.Name,
                RepetitionGroupIndexInChapter: g.RepetitionGroupIndexInChapter,
                ExcludeLinksWithSameParentRoot: sLinkGroupType === 'lens' && lens.ExcludeLinksWithSameParentRoot, 
                WordsToNotColor: g.WordsToNotColor,
                LineAndWordIndexes: listWordsToLinkInGroup.sort((wordOrTextIndex1, wordOrTextIndex2) => 
                    parseInt(blnListContainsWordIndexesNotWords ? wordOrTextIndex1 : wordOrTextIndex1.TextIndex) - 
                    parseInt(blnListContainsWordIndexesNotWords ? wordOrTextIndex2 : wordOrTextIndex2.TextIndex))
                .filter(wordOrTextIndex => wordOrTextIndex !== undefined)
                .map(wordOrTextIndex => {
                    var oWord = blnListContainsWordIndexesNotWords ? this.GetWordWithTextIndexInChapter(wordOrTextIndex) : wordOrTextIndex
                        
                    if(blnHebrew)
                    {
                        var nLineIndex = this.state.listLines.findIndex(r => r.Words.includes(oWord))

                        if(nLineIndex > -1)
                        {
                            var nWordIndexToUse = this.state.listLines[nLineIndex].Words.indexOf(oWord)
                            return {LineIndex: nLineIndex, Word: oWord, WordIndexes: [nWordIndexToUse], WordIndexForDrawing: nWordIndexToUse}
                        }
                    }
                    else
                    {
                        var sTextIndex = blnListContainsWordIndexesNotWords ? wordOrTextIndex : wordOrTextIndex.TextIndex
                        var listLinksForTranslationWord = this.GetOurTranslationLinksForTextIndexInOriginal(sTextIndex)

                        if(listLinksForTranslationWord.length > 0)
                        {
                            let sTranslationLinkGroupsByTextIndexMainWordType = sLinkGroupType !== 'lens' ? '' : lens.TranslationLinkGroupsByTextIndexMainWordType

                            let dictMainWordInTranslationLinkGroupsByTextIndexToUse = 
                                sTranslationLinkGroupsByTextIndexMainWordType === 'preposition' ? this.state.dictMainPrepositionWordInTranslationLinkGroupsByTextIndex :
                                sTranslationLinkGroupsByTextIndexMainWordType === 'suffix' ? this.state.dictMainSuffixWordInTranslationLinkGroupsByTextIndex :
                                this.state.dictMainWordInTranslationLinkGroupsByTextIndex

                            let nTranslationIndexOfWordToDraw = dictMainWordInTranslationLinkGroupsByTextIndexToUse.get(sTextIndex)
                            var oMainLink = listLinksForTranslationWord.find(oLink => oLink.Translation == nTranslationIndexOfWordToDraw)

                            if(oMainLink === undefined)
                            {
                                oMainLink = listLinksForTranslationWord[0]
                            }

                            return {LineIndex: oMainLink.LineIndex, Word: oWord, WordIndexes: listLinksForTranslationWord.map(oLink => oLink.Translation), 
                                WordIndexForDrawing: oMainLink.Translation}
                        }
                    }

                    return undefined
                }).filter(o => o != undefined)}
        }).filter(o => o.LineAndWordIndexes.length > 1)
    }

    GetLineGroupsForDevelopmentDiagram(listLinesToUse)
    {
        return this.GetLinesForSideBySideMode(this.state.listLines, this.state.sGroupLinesBy) //'StartsRepetitionGroup')
    }

    GenerateDevelopmentDiagramForChapter(sChapter, sLanguage, listLinesToUse)
    {
        const canvas = this.canvasRef.current
        if(canvas === null) return
        
        const ctx = canvas.getContext('2d')

        const dpr = window.devicePixelRatio;
        const rect = canvas.getBoundingClientRect();

        // Set the "actual" size of the canvas
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;

        // Scale the context to ensure correct drawing operations
        ctx.scale(dpr, dpr);

        // Set the "drawn" size of the canvas
        canvas.style.width = `${rect.width}px`;
        canvas.style.height = `${rect.height}px`;
        
        // Now you can draw text and other elements on the canvas
        var blnBoxBorder = false

        ctx.font = sLanguage === 'original' ? '22px SBL Hebrew' : '18px Calibri'
        ctx.textAlign = 'left' //blnHebrew ? 'right' : 'left'
        //ctx.direction = 'rtl'
        ctx.textBaseline = 'middle'
        ctx.textRendering = 'optimizeLegibility'
        ctx.strokeStyle = 'black'

        //['StartsRepetitionGroup', 'StartsCluster', 'StartsClusterGroup', 'StartsLevel4Group']
        var sGroupLinesByToUse = this.state.sGroupLinesBy //listLinesToUse.some(l => l.StartsLevel4Group) ? 'StartsLevel4Group' : 'StartsClusterGroup'
        var sLineBreakSubunit = this.GetSubUnitForTextUnit(this.state.sGroupLinesBy)
        
        // this.setState({sGroupLinesBy: this.state.sGroupLinesBy === 'StartsRepetitionGroup' ? 'StartsCluster' : 
        //     this.state.sGroupLinesBy === 'StartsCluster' ? 'StartsClusterGroup' : 
        //     this.state.sGroupLinesBy === 'StartsClusterGroup' ? 'StartsLevel4Group' : 
        //     this.state.sGroupLinesBy === 'StartsLevel4Group' ? 'ByChapter' : 'StartsRepetitionGroup'}

        var nBoxPadding = blnBoxBorder ? 5 : 0
        var nXDistanceBetweenLineGroups = 40
        var nYDistanceBetweenSubunits = 30
        var nYDistanceForWrapping = 30
        var nXStart = 0
        var nYStart = 30

        var blnBreakAtEveryLine = false
        var nCurrentX = nXStart
        var listBoxesToSet = []
        var listBoxGroupsToSet = []
        var listLineIndexesInCurrentBoxGroup = []
        var listYForLastLineOfLineGroups = []
        var nXAtEndOfLongestLineInGroupMaximumValueAcrossAllGroups = 0

        var listLineGroups = this.GetLinesForSideBySideMode(listLinesToUse, sGroupLinesByToUse)
        //console.log(sChapter, blnHebrew, listLineGroups)
        for(var oLineGroup of listLineGroups)
        {
            var nCurrentY = nYStart

            //measure all the lines in the group first to make sure it will fit
            //store the measurements for later
            var dictMeasurements = new Map()
            var nMaxLineWidth = 0
            var nLineIndex = 0
            for(var line of oLineGroup.Lines)
            {
                var nAbsoluteLineIndex = nLineIndex + oLineGroup.AbsoluteIndexOfFirstLineInGroup
                var sText = ''
                if(sLanguage === 'original')
                {
                    sText = line.Words.map(w => w.FullText).join(' ')
                }
                else if(sLanguage === 'transliteration')
                {
                    sText = line.Words.map(w => w.Transliteration).join(' ').replaceAll('*', '').replaceAll('|', '')
                }
                else
                {
                    var oTranslationForLine = this.state.listOurTranslationLines.find(o => o.Chapter === sChapter && o.LineIndex === nAbsoluteLineIndex)
                    var sTranslationForLine = oTranslationForLine === undefined ? '?' : oTranslationForLine.Translation           
                    sText = sTranslationForLine
                }

                const metrics = ctx.measureText(sText)
                var nTextHeight = Math.abs(metrics.actualBoundingBoxAscent) + Math.abs(metrics.actualBoundingBoxDescent)
                var nTextWidth = metrics.width
                dictMeasurements.set(nAbsoluteLineIndex, {TextHeight: nTextHeight, TextWidth: nTextWidth})

                if(nTextWidth > nMaxLineWidth)
                {
                    nMaxLineWidth = nTextWidth
                }

                nLineIndex += 1
            }

            let nXAtEndOfLongestLineInGroup = nCurrentX + nMaxLineWidth
            if(nXAtEndOfLongestLineInGroup > rect.width && listYForLastLineOfLineGroups.length > 0)
            {
                nCurrentX = nXStart
                nCurrentY = Math.max(...listYForLastLineOfLineGroups) + nYDistanceForWrapping
                nYStart = nCurrentY
                listYForLastLineOfLineGroups = []
            }
            else if(nXAtEndOfLongestLineInGroup > nXAtEndOfLongestLineInGroupMaximumValueAcrossAllGroups)
            {
                nXAtEndOfLongestLineInGroupMaximumValueAcrossAllGroups = nXAtEndOfLongestLineInGroup
            }

            var nLineIndex = 0
            for(var line of oLineGroup.Lines)
            {
                var nAbsoluteLineIndex = nLineIndex + oLineGroup.AbsoluteIndexOfFirstLineInGroup
                if(blnBreakAtEveryLine || (this.state.blnShowSubunitBreaksInDevelopmentDiagram && this.BreakBeforeLine(line, nLineIndex, sLineBreakSubunit)))
                {
                    listBoxGroupsToSet.push({Chapter: sChapter, LineIndexes: listLineIndexesInCurrentBoxGroup})
                    listLineIndexesInCurrentBoxGroup = []
                    nCurrentY += nYDistanceBetweenSubunits
                }

                listLineIndexesInCurrentBoxGroup.push(nLineIndex + oLineGroup.AbsoluteIndexOfFirstLineInGroup)

                var textMeasurements = dictMeasurements.get(nAbsoluteLineIndex)

                var oDiagramBox = this.GetDevelopmentDiagramBoxForLineIndex(nAbsoluteLineIndex)
                var x = oDiagramBox === undefined ? nCurrentX : oDiagramBox.x
                var y = oDiagramBox === undefined ? nCurrentY : oDiagramBox.y

                listBoxesToSet.push({Chapter: sChapter, LineIndex: nAbsoluteLineIndex, x: x, y: y})
                
                nCurrentY += textMeasurements.TextHeight + this.state.nYDistanceBetweenLines
                nLineIndex += 1
            }

            listBoxGroupsToSet.push({Chapter: sChapter, LineIndexes: listLineIndexesInCurrentBoxGroup})
            listLineIndexesInCurrentBoxGroup = []

            nCurrentX += nMaxLineWidth + nXDistanceBetweenLineGroups
            listYForLastLineOfLineGroups.push(nCurrentY)
        }

        var nMaxYForAllLines = Math.max(...listYForLastLineOfLineGroups)
        if(nMaxYForAllLines > rect.height)
        {
            var nNewCanvasHeight = nMaxYForAllLines
            canvas.height = nNewCanvasHeight * dpr;
            canvas.style.height = `${nNewCanvasHeight}px`;
        }

        let nXStartForCentering = (window.innerWidth / 2 - nXAtEndOfLongestLineInGroupMaximumValueAcrossAllGroups / 2) + this.state.nLeftTextAlignmentOffset
        listBoxesToSet.forEach(box => box.x += nXStartForCentering)

        this.setState({nChartLeft: nXStartForCentering + 25})
        this.setState({nChartWidth: nXAtEndOfLongestLineInGroupMaximumValueAcrossAllGroups})

        this.setState({listDevelopmentDiagramBoxes: listBoxesToSet})
        this.setState({listDevelopmentDiagramBoxGroups: listBoxGroupsToSet})

        var blnOriginalOrTransliteration = sLanguage === 'original' || sLanguage === 'transliteration'
        var listLinkGroupsToSet = []

        let nNumberOfLensesOn = this.state.listWordGroupsForEnabledLenses.length
        for(var oLensGroup of this.state.listWordGroupsForEnabledLenses)
        {
            var listGroups = []
            if(!this.state.blnBreakLinkGroupsIntoChains || (oLensGroup.ListGroups.length > 0 && oLensGroup.ListGroups[0].ByLine))
            {
                listGroups = oLensGroup.ListGroups
            }
            else
            {
                for(var oGroup of oLensGroup.ListGroups)
                {
                    let listChainsInGroup = this.FilterWordGroupsForChains(
                        oGroup.ListWords.filter(w => w !== undefined).map(w => ({LineIndex: this.state.listLines.findIndex(l => l.Words.includes(w)), 
                            Verse: parseInt(w.Verse), Word: w})), 2, 1, true)

                    //after breaking the groups into chains, some words might be left out, so don't color those
                    //put all such words in all the broken out chain groups (for the chart) even though it is redundant

                    var listGroupsToAdd = []
                    let listAllWordsInChains = [] //listChainsInGroup.flat()     
                    for(var oChain of listChainsInGroup)
                    {
                        let listWordsInChain = oChain.flat()

                        let nChainLength = listWordsInChain.length
                        if(nChainLength >= this.state.nMinDevelopmentDiagramLinkGroupLengthToShow && 
                           nChainLength <= this.state.nMaxDevelopmentDiagramLinkGroupLengthToShow)
                        {
                            listGroupsToAdd.push({Color: oGroup.Color, Name: oGroup.Name, ListWords: listWordsInChain})
                            listAllWordsInChains = listAllWordsInChains.concat(listWordsInChain)
                        }
                    }

                    let listWordsLeftOutOfChains = oGroup.ListWords.filter(w => !listAllWordsInChains.includes(w))
                    let listWordsNotToColor = []

                    if(this.state.blnDoNotColorFirstWordInChain)
                    {
                        listWordsNotToColor = listChainsInGroup.map(listWordsInChain => listWordsInChain[0])
                    }

                    oGroup.WordsToNotColor = listWordsNotToColor.concat(listWordsLeftOutOfChains)
                    listGroupsToAdd.forEach(g => g.WordsToNotColor = listWordsNotToColor)

                    listGroups = listGroups.concat(listGroupsToAdd)
                }
            }

            listLinkGroupsToSet = listLinkGroupsToSet.concat(this.GetDiagramLinkGroupsFromWordGroups(listGroups, sChapter, 
                blnOriginalOrTransliteration, false, 'lens', oLensGroup.Lens, 'hsl(0, 0%, 65%)'
                //nNumberOfLensesOn === 1 ? '' : oLensGroup.Lens.ShowLightLinksIfNotOnlyLens ? 'hsl(0, 0%, 65%)' : 'Black'
                ))
        }
        
        this.setState({listDevelopmentDiagramLinkGroupLengths: [...new Set(listLinkGroupsToSet.map(o => o.LineAndWordIndexes.length))].toSorted()})

        //if(this.state.sShowLinksFromHoveredWhat === 'word')
        //{

        this.setState({listDevelopmentDiagramLinkGroups: listLinkGroupsToSet})

        if(this.state.blnConnectionsPresentationMode)
        {
            let nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet = this.state.nIndexOfSemanticGroupShowing >= listLinkGroupsToSet.length ? -1 : 
                listLinkGroupsToSet[this.state.nIndexOfSemanticGroupShowing].RepetitionGroupIndexInChapter

            this.setState({nRepetitionGroupIndexInChapterForCurrentConnectionsGroup: nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet})
            
            this.setState({sCommentForCurrentConnectionsGroup: nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet < 0 || 
                nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet >= this.state.listRepetitionLinkGroups.length ? '' :
                this.state.listRepetitionLinkGroups[nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet].Comment})

            this.setState({blnConnectionIsContrastForCurrentConnectionsGroup: nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet < 0 || 
                nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet >= this.state.listRepetitionLinkGroups.length ? '' :
                this.state.listRepetitionLinkGroups[nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet].IsContrast})

            if(this.state.blnConnectionsPresentationCommentEditMode)
            {
                var sDefaultCommentForCurrentConnectionsGroupToSet = ''
                var listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroupToSet = []

                if(!(nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet < 0 || 
                    nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet >= this.state.listRepetitionLinkGroups.length))
                {
                    let oCurrentRepetitionGroup = this.state.listRepetitionLinkGroups[nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet]
                    let listWordsInGroup = oCurrentRepetitionGroup.ListWords.map(sTextIndex => this.GetWordWithTextIndexInChapter(sTextIndex))
                    sDefaultCommentForCurrentConnectionsGroupToSet = listWordsInGroup.map(w => this.GetOurTranslationForWord(w)).join(' -> ')

                    let sListWordsForCurrentRepetitionSortedAndJoined = oCurrentRepetitionGroup.ListWords.map(sTextIndex => 
                        parseInt(sTextIndex)).toSorted((a,b) => a - b).join('_')

                    // listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroupToSet = this.listRepetitionGroupsForAllChapters
                    // .filter(g => g.Comment.length > 0 &&
                    //     g.ListWords.map(sTextIndex => parseInt(sTextIndex)).toSorted((a,b) => a - b).join('_') === sListWordsForCurrentRepetitionSortedAndJoined)
                    // .map(g => g.Comment)
                }

                this.setState({sDefaultCommentForCurrentConnectionsGroup: sDefaultCommentForCurrentConnectionsGroupToSet})
                // this.setState({listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroup: listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroupToSet})
            }
        }

        //}
        // else
        // {
        //     this.setState({listDevelopmentDiagramLinkGroups: listLinkGroupsToSet
        //         .filter(o => o.LineAndWordIndexes.length >= this.state.nMinDevelopmentDiagramLinkGroupLengthToShow && 
        //                         o.LineAndWordIndexes.length <= this.state.nMaxDevelopmentDiagramLinkGroupLengthToShow)})
        // }
    }

    PixelsToInches(nPixels)
    {
        return 'Inches(' + (nPixels / 50) + ')' //(96 * 3)
    }

    RGBForTextColor(sTextColor)
    {
        return 'RGBColor(0, 0, 0)'
    }

    AddRunForText(sText, sTextColor, sFontName, blnBoldText, x, y, nTextWidth, blnIsFirstTextboxInRow)
    {
        let listPythonLinesToReturn = []

        let nFontSize = 12
        let nAspectRatioForFont = 1.0
        let nInchesPerCharacter = (nFontSize  / 72) * nAspectRatioForFont

        listPythonLinesToReturn.push('listTextBoxes.append(slide.shapes.add_textbox(' + 
        (blnIsFirstTextboxInRow ? this.PixelsToInches(x) : 'listTextBoxes[-1].left + listTextBoxes[-1].width') + ', ' +  //x + nCharXOffsetFromTextStart, y
        this.PixelsToInches(y) + ', ' + 
        'Inches(' + (nInchesPerCharacter * sText.length) + ')' + ', ' + 
        'Inches(0.5)' + '))')

        listPythonLinesToReturn.push('listTextBoxes[-1].text_frame.word_wrap = False')
        listPythonLinesToReturn.push('listTextBoxes[-1].text_frame.vertical_anchor = MSO_VERTICAL_ANCHOR.MIDDLE')

        listPythonLinesToReturn.push('paragraph = listTextBoxes[-1].text_frame.paragraphs[0]')
        listPythonLinesToReturn.push('paragraph.font.size = Pt(' + nFontSize + ')')
        //listPythonLinesToReturn.push('paragraph.alignment = PP_ALIGN.CENTER')
        listPythonLinesToReturn.push('run = paragraph.add_run()')
        listPythonLinesToReturn.push('run.text = "' + sText + '"')
        listPythonLinesToReturn.push('run.font.name = "' + sFontName + '"')
        listPythonLinesToReturn.push('run.font.bold = ' + (blnBoldText ? 'True' : 'False'))
        listPythonLinesToReturn.push('run.font.color.rgb = ' + this.RGBForTextColor(sTextColor))

        //listPythonLinesToReturn.push('listTextBoxes[-1].text_frame.auto_size = MSO_AUTO_SIZE.SHAPE_TO_FIT_TEXT')

        // listPythonLinesToReturn.push('run = paragraph.add_run()')
        // listPythonLinesToReturn.push('run.text = "' + sText + '"')
        // listPythonLinesToReturn.push('run.font.name = "' + sFontName + '"')
        // listPythonLinesToReturn.push('run.font.bold = ' + (blnBoldText ? 'True' : 'False'))
        // listPythonLinesToReturn.push('run.font.color.rgb = ' + this.RGBForTextColor(sTextColor))

        return listPythonLinesToReturn
    }

    GenerateDevelopmentDiagramForPowerpoint(sChapter, sLanguage, listLinesToUse)
    {
        var listPythonLines = []
        
        listPythonLines.push('from pptx import Presentation')
        listPythonLines.push('from pptx.util import Inches')
        listPythonLines.push('from pptx.enum.shapes import MSO_CONNECTOR, MSO_SHAPE')
        listPythonLines.push('from pptx.util import Inches, Pt')
        listPythonLines.push('from pptx.enum.text import PP_ALIGN, MSO_VERTICAL_ANCHOR, MSO_AUTO_SIZE')
        listPythonLines.push('from pptx.dml.color import RGBColor')
        listPythonLines.push('prs = Presentation()')
        listPythonLines.push('listTextBoxes = []')

        // var pptx = new PptxGenJS()
        // var slide = pptx.addSlide()

        const canvas = this.canvasRef.current
        if(canvas === null) return
        const ctx = canvas.getContext('2d')
        const dpr = window.devicePixelRatio;
        const rect = canvas.getBoundingClientRect()

        let blnHebrew = sLanguage === 'original'
        ctx.font = blnHebrew ? '22px SBL Hebrew' : '18px Calibri'
        ctx.textAlign = 'left' //blnHebrew ? 'right' : 'left'
        //ctx.direction = 'rtl'
        ctx.textBaseline = 'middle'
        ctx.textRendering = 'optimizeLegibility'
        ctx.strokeStyle = 'black'

        let sFontName = blnHebrew ? 'SBL Hebrew' : 'Calibri'
        let sFontSize = blnHebrew ? '22' : '12'
        let sTextAlign = 'left' //blnHebrew ? 'right' : 'left'
        //ctx.direction = 'rtl'
        let sTextColor = 'black'

        var blnColorLinesByNumberOfExternalLinks = false

        //['StartsRepetitionGroup', 'StartsCluster', 'StartsClusterGroup', 'StartsLevel4Group']
        var sGroupLinesByToUse = this.state.sGroupLinesBy //listLinesToUse.some(l => l.StartsLevel4Group) ? 'StartsLevel4Group' : 'StartsClusterGroup'
        var sLineBreakSubunit = this.GetSubUnitForTextUnit(this.state.sGroupLinesBy)

        var nBoxPadding = 0
        var nXDistanceBetweenLineGroups = 40
        var nYDistanceBetweenSubunits = 30
        var nYDistanceForWrapping = 30
        var nXStart = 0
        var nYStart = 30

        var blnBreakAtEveryLine = false
        var nCurrentX = nXStart
        var listBoxesToSet = []
        var listBoxGroupsToSet = []
        var listLineIndexesInCurrentBoxGroup = []
        var listYForLastLineOfLineGroups = []
        var nXAtEndOfLongestLineInGroupMaximumValueAcrossAllGroups = 0

        var listLineGroups = this.GetLinesForSideBySideMode(listLinesToUse, sGroupLinesByToUse)
        //console.log(sChapter, blnHebrew, listLineGroups)
        for(var oLineGroup of listLineGroups)
        {
            var nCurrentY = nYStart

            //measure all the lines in the group first to make sure it will fit
            //store the measurements for later
            var dictMeasurements = new Map()
            var nMaxLineWidth = 0
            var nLineIndex = 0
            for(var line of oLineGroup.Lines)
            {
                var nAbsoluteLineIndex = nLineIndex + oLineGroup.AbsoluteIndexOfFirstLineInGroup
                var sText = ''
                if(sLanguage === 'original')
                {
                    sText = line.Words.map(w => w.FullText).join(' ')
                }
                else if(sLanguage === 'transliteration')
                {
                    sText = line.Words.map(w => w.Transliteration).join(' ').replaceAll('*', '').replaceAll('|', '')
                }
                else
                {
                    var oTranslationForLine = this.state.listOurTranslationLines.find(o => o.Chapter === sChapter && o.LineIndex === nAbsoluteLineIndex)
                    var sTranslationForLine = oTranslationForLine === undefined ? '?' : oTranslationForLine.Translation           
                    sText = sTranslationForLine
                }

                const metrics = ctx.measureText(sText)
                var nTextHeight = Math.abs(metrics.actualBoundingBoxAscent) + Math.abs(metrics.actualBoundingBoxDescent)
                var nTextWidth = metrics.width
                dictMeasurements.set(nAbsoluteLineIndex, {TextHeight: nTextHeight, TextWidth: nTextWidth})

                if(nTextWidth > nMaxLineWidth)
                {
                    nMaxLineWidth = nTextWidth
                }

                nLineIndex += 1
            }

            let nXAtEndOfLongestLineInGroup = nCurrentX + nMaxLineWidth
            if(nXAtEndOfLongestLineInGroup > rect.width && listYForLastLineOfLineGroups.length > 0)
            {
                nCurrentX = nXStart
                nCurrentY = Math.max(...listYForLastLineOfLineGroups) + nYDistanceForWrapping
                nYStart = nCurrentY
                listYForLastLineOfLineGroups = []
            }
            else if(nXAtEndOfLongestLineInGroup > nXAtEndOfLongestLineInGroupMaximumValueAcrossAllGroups)
            {
                nXAtEndOfLongestLineInGroupMaximumValueAcrossAllGroups = nXAtEndOfLongestLineInGroup
            }

            var nLineIndex = 0
            for(var line of oLineGroup.Lines)
            {
                if(nLineIndex > 0) continue

                var nAbsoluteLineIndex = nLineIndex + oLineGroup.AbsoluteIndexOfFirstLineInGroup
                if(blnBreakAtEveryLine || (this.state.blnShowSubunitBreaksInDevelopmentDiagram && this.BreakBeforeLine(line, nLineIndex, sLineBreakSubunit)))
                {
                    listBoxGroupsToSet.push({Chapter: sChapter, LineIndexes: listLineIndexesInCurrentBoxGroup})
                    listLineIndexesInCurrentBoxGroup = []
                    nCurrentY += nYDistanceBetweenSubunits
                }

                listLineIndexesInCurrentBoxGroup.push(nLineIndex + oLineGroup.AbsoluteIndexOfFirstLineInGroup)

                var textMeasurements = dictMeasurements.get(nAbsoluteLineIndex)

                var oDiagramBox = this.GetDevelopmentDiagramBoxForLineIndex(nAbsoluteLineIndex)
                var x = oDiagramBox === undefined ? nCurrentX : oDiagramBox.x
                var y = oDiagramBox === undefined ? nCurrentY : oDiagramBox.y

                listBoxesToSet.push({Chapter: sChapter, LineIndex: nAbsoluteLineIndex, x: x, y: y, 
                    width: textMeasurements.TextWidth, height: textMeasurements.TextHeight})
                
                nCurrentY += textMeasurements.TextHeight + this.state.nYDistanceBetweenLines
                nLineIndex += 1
            }

            listBoxGroupsToSet.push({Chapter: sChapter, LineIndexes: listLineIndexesInCurrentBoxGroup})
            listLineIndexesInCurrentBoxGroup = []

            nCurrentX += nMaxLineWidth + nXDistanceBetweenLineGroups
            listYForLastLineOfLineGroups.push(nCurrentY)
        }

        // var nMaxYForAllLines = Math.max(...listYForLastLineOfLineGroups)
        // if(nMaxYForAllLines > rect.height)
        // {
        //     var nNewCanvasHeight = nMaxYForAllLines
        //     canvas.height = nNewCanvasHeight * dpr;
        //     canvas.style.height = `${nNewCanvasHeight}px`;
        // }

        // let nXStartForCentering = (window.innerWidth / 2 - nXAtEndOfLongestLineInGroupMaximumValueAcrossAllGroups / 2) + this.state.nLeftTextAlignmentOffset
        // listBoxesToSet.forEach(box => box.x += nXStartForCentering)

        //this.setState({nChartLeft: nXStartForCentering + 25})
        //this.setState({nChartWidth: nXAtEndOfLongestLineInGroupMaximumValueAcrossAllGroups})

        //this.setState({listDevelopmentDiagramBoxes: listBoxesToSet})
        //this.setState({listDevelopmentDiagramBoxGroups: listBoxGroupsToSet})




        //from drawdevelopmentdiagram
        listPythonLines.push('slide = prs.slides.add_slide(prs.slide_layouts[6])')

        var listDevelopmentDiagramBoxesForChapter = listBoxesToSet
        var listDevelopmentDiagramLinkGroupsForChapter = this.GetDevelopmentDiagramLinkGroupsForChapter()

        var nBoxPadding = 5 //blnBoxBorder ? 5 : 0
        var blnOnlyColorWordsInCertainLinkGroups = false
        var listTextIndexesToColorFromLinkGroups = []
        var sCurrentTextColor = 'black'

        var listBoundingBoxesToSet = []
        for(var oDiagramBox of listDevelopmentDiagramBoxesForChapter)
        {
            var x = oDiagramBox.x
            var y = oDiagramBox.y
            var nLineIndex = oDiagramBox.LineIndex

            var listOriginalWordsInOrderForLine = this.state.listLines[nLineIndex] === undefined ? [] : this.state.listLines[nLineIndex].Words
            var listHebrewWordsInLine = !blnHebrew ? [] : listOriginalWordsInOrderForLine.map(w => w.FullText)

            //blnBoxBorder = this.state.oDevelopmentDiagramHoveredObject != null && 
            //this.state.oDevelopmentDiagramHoveredObject.LineIndex === nLineIndex

            sCurrentTextColor = 'black'
            var listAdditionalRepetitionGroupColors = []
            
            if(blnColorLinesByNumberOfExternalLinks)
            {
                //count all the links in link groups that have >= 1 link inside the line/unit
                //but exclude the links for that line/unit
                var nExternalLinksFromLine = this.state.listDevelopmentDiagramLinkGroups.filter(o => o.Chapter === sChapter &&
                    o.LineAndWordIndexes.some(lwi => nLineIndex === lwi.LineIndex))
                .flatMap(o => o.LineAndWordIndexes).filter(lwi => nLineIndex != lwi.LineIndex).length
                
                sCurrentTextColor = nExternalLinksFromLine > 40 ? 'black' : 
                    nExternalLinksFromLine > 30 ? 'purple' :
                    nExternalLinksFromLine > 20 ? 'red' :
                    nExternalLinksFromLine > 10 ? 'blue' :
                    nExternalLinksFromLine > 5 ? 'green' : 'cornflower'
            }
            
            if(this.state.blnColorLinesByDevelopmentRepetitionGroup)
            {            
                var oRepetitionGroup = this.state.listDevelopmentRepetitionGroupsByChapter.find(o => o.Chapter === sChapter &&
                    o.LineIndex === nLineIndex)

                if(oRepetitionGroup != undefined)
                {
                    var listRepetitionGroupsToShow = this.state.nDevelopmentDiagramColorKeyGroupIDBeingHovered === -1 ? 
                        oRepetitionGroup.Groups : oRepetitionGroup.Groups.filter(nGroup => nGroup === this.state.nDevelopmentDiagramColorKeyGroupIDBeingHovered)

                    if(listRepetitionGroupsToShow.length > 0)
                    {
                        sCurrentTextColor = this.GetColorForDevelopmentRepetitionGroup(listRepetitionGroupsToShow[0], 1.0)
                        if(listRepetitionGroupsToShow.length > 1)
                        {
                            //make the additional colors lighter since the boxes look darker than the text
                            listAdditionalRepetitionGroupColors = listRepetitionGroupsToShow.slice(1)
                                .map(nGroup => this.GetColorForDevelopmentRepetitionGroup(nGroup, 1.5))
                        }
                    }
                }
            }

            var sText = ''
            if(sLanguage === 'original')
            {
                sText = listHebrewWordsInLine.join(' ')
            }
            else if(sLanguage === 'transliteration')
            {
                sText = this.state.listLines[nLineIndex].Words.map(w => w.Transliteration).join(' ').replaceAll('*', '').replaceAll('|', '')
            }
            else
            {
                var oTranslationForLine = this.state.listOurTranslationLines.find(o => o.Chapter === sChapter && o.LineIndex === nLineIndex)
                var sTranslationForLine = oTranslationForLine === undefined ? '?' : oTranslationForLine.Translation
                sText = sTranslationForLine
            }

            const metrics = ctx.measureText(sText)
            var nTextHeight = Math.abs(metrics.actualBoundingBoxAscent) + Math.abs(metrics.actualBoundingBoxDescent)
            var nTextWidth = metrics.width
            
            // listPythonLines.push('listTextBoxes.append(slide.shapes.add_textbox(' + 
            // this.PixelsToInches(x) + ', ' +  //x + nCharXOffsetFromTextStart, y
            // this.PixelsToInches(y) + ', ' + 
            // this.PixelsToInches(nTextWidth) + ', ' + 
            // 'Inches(0.5)' + '))')

            // listPythonLines.push('listTextBoxes[-1].text_frame.word_wrap = False')
            // listPythonLines.push('listTextBoxes[-1].text_frame.auto_size = MSO_AUTO_SIZE.SHAPE_TO_FIT_TEXT')
            // listPythonLines.push('listTextBoxes[-1].text_frame.vertical_anchor = MSO_VERTICAL_ANCHOR.MIDDLE')

            // listPythonLines.push('paragraph = listTextBoxes[-1].text_frame.paragraphs[0]')
            // listPythonLines.push('paragraph.font.size = Pt(' + sFontSize + ')')
            // //listPythonLines.push('paragraph.alignment = PP_ALIGN.CENTER')

            if(sLanguage === 'transliteration' || sLanguage === 'original')
            {
                let nCharXOffsetFromTextStart = 0
                let nWordIndexInLine = 0

                for(let w of (sLanguage === 'original' ? this.state.listLines[nLineIndex].Words.slice().reverse() : this.state.listLines[nLineIndex].Words))
                {
                    let blnDontColorThisWord = blnOnlyColorWordsInCertainLinkGroups && !listTextIndexesToColorFromLinkGroups.includes(w.TextIndex)

                    // var nExternalLinksFromWord = this.state.listDevelopmentDiagramLinkGroups.filter(o => o.Chapter === sChapter &&
                    //     o.LineAndWordIndexes.some(lwi => nLineIndex === lwi.LineIndex))
                    //     .flatMap(o => o.LineAndWordIndexes).filter(lwi => nLineIndex != lwi.LineIndex && lwi.WordIndexForDrawing === nWordIndexInLine).length

                    if(sLanguage === 'transliteration')
                    {
                        for(let oSyllable of w.SyllableObjects)
                        {
                            let sSyllable = this.GetSyllableTextForDevelopmentDiagram(oSyllable)

                            //let blnSoundOrRhythmTransliteration = (this.state.sSelectedView === 'sound' || this.state.sSelectedView === 'rhythm') && sLanguage === 'transliteration'
                            //let blnUseBoldFont = (blnSoundOrRhythmTransliteration && this.SyllableShouldBeBolded(oSyllable))

                            if(!this.state.blnColorLinesByDevelopmentRepetitionGroup)
                            {
                                sCurrentTextColor = blnDontColorThisWord ? 'LightGray' : this.GetTextColorForSyllable(oSyllable)
                            }

                            listPythonLines = listPythonLines.concat(this.AddRunForText(sSyllable, sCurrentTextColor, sFontName, this.SyllableShouldBeBolded(oSyllable), x, y, ctx.measureText(sSyllable).width, false))
                            // ctx.fillText(sSyllable, x + nCharXOffsetFromTextStart, y)
                            nCharXOffsetFromTextStart += ctx.measureText(sSyllable).width
                        }
                        
                        if(this.state.blnShowVerseNumbers && this.listVerseEndIndexes.includes(parseInt(w.TextIndex)))
                        {
                            listPythonLines = listPythonLines.concat(this.AddRunForText('.', sCurrentTextColor, sFontName, false, x, y, ctx.measureText('.').width, false))
                            // ctx.fillText('.', x + nCharXOffsetFromTextStart, y)
                            nCharXOffsetFromTextStart += ctx.measureText('.').width
                        }
                        else if(w.HasFullAccent || !this.blnChapterIsHebrew)
                        {
                            listPythonLines = listPythonLines.concat(this.AddRunForText(' ', sCurrentTextColor, sFontName, false, x, y, ctx.measureText(' ').width, false))
                            // ctx.fillText(' ', x + nCharXOffsetFromTextStart, y)
                            nCharXOffsetFromTextStart += ctx.measureText(' ').width
                        }
                    }
                    else if(sLanguage === 'original')
                    {
                        if(w.HasFullAccent || !this.blnChapterIsHebrew)
                        {
                            listPythonLines = listPythonLines.concat(this.AddRunForText(' ', sCurrentTextColor, sFontName, false, x, y, ctx.measureText(' ').width, false))
                            // ctx.fillText(' ', x + nCharXOffsetFromTextStart, y)
                            nCharXOffsetFromTextStart += ctx.measureText(' ').width
                        }

                        let sTextForWord = w.FullText
                        let sTextColor = blnDontColorThisWord ? 'LightGray' : this.GetTextColor(w)
                        
                        if(!this.state.blnColorLinesByDevelopmentRepetitionGroup)
                        {
                            sCurrentTextColor = sTextColor //sTextColor === 'LightGray' || sTextColor === 'Silver' ? 'Black' : sTextColor
                        }

                        listPythonLines = listPythonLines.concat(this.AddRunForText(sTextForWord, sCurrentTextColor, sFontName, false, x, y, ctx.measureText(sTextForWord).width, false))
                        // ctx.fillText(sTextForWord, x + nCharXOffsetFromTextStart, y)
                        nCharXOffsetFromTextStart += ctx.measureText(sTextForWord).width
                    }

                    nWordIndexInLine += 1
                }
            }
            else
            {
                listOriginalWordsInOrderForLine = []

                var oTranslationForLine = this.state.listOurTranslationLines.find(o => o.Chapter === sChapter && o.LineIndex === nLineIndex)
                var sTranslationForLine = oTranslationForLine === undefined ? '?' : oTranslationForLine.Translation
                let listTranslationWords = sTranslationForLine.split(' ')

                let nCharXOffsetFromTextStart = 0
                for(var nWordIndexInLine = 0; nWordIndexInLine < listTranslationWords.length; nWordIndexInLine++)
                {
                    let sTextForWord = listTranslationWords[nWordIndexInLine]
                    let listOriginalWords = this.GetOriginalWordsForWordAndLineIndexOfOurTranslation(sChapter, nLineIndex, nWordIndexInLine)
                    let w = listOriginalWords.length === 0 ? undefined : listOriginalWords[0]
                    listOriginalWordsInOrderForLine.push(w)
                    
                    if(w != undefined && !this.state.blnColorLinesByDevelopmentRepetitionGroup)
                    {
                        let blnDontColorThisWord = blnOnlyColorWordsInCertainLinkGroups && !listTextIndexesToColorFromLinkGroups.includes(w.TextIndex)

                        let sTextColor = blnDontColorThisWord ? 'LightGray' : this.GetTextColor(w)
                        sCurrentTextColor = sTextColor //=== 'LightGray' || sTextColor === 'Silver' ? 'Black' : sTextColor
                    }

                    listPythonLines = listPythonLines.concat(this.AddRunForText(sTextForWord, sCurrentTextColor, sFontName, false, x + nCharXOffsetFromTextStart, y, ctx.measureText(sTextForWord).width, nWordIndexInLine === 0))
                    //slide.addText(sTextForWord, { x: PixelsToUnit(x + nCharXOffsetFromTextStart), y: PixelsToUnit(y), w: PixelsToUnit(ctx.measureText(sTextForWord).width), color: "DDDD00", fontFace: "Calibri", bold: false, fontSize: nFontSize})
                    // ctx.fillText(sTextForWord, x + nCharXOffsetFromTextStart, y)
                    nCharXOffsetFromTextStart += ctx.measureText(sTextForWord).width
                    
                    if(nWordIndexInLine < listTranslationWords.length - 1)
                    {
                        listPythonLines = listPythonLines.concat(this.AddRunForText(' ', sCurrentTextColor, sFontName, false, x + nCharXOffsetFromTextStart, y, ctx.measureText(' ').width, false))
                        //slide.addText(' ', { x: PixelsToUnit(x + nCharXOffsetFromTextStart), y: PixelsToUnit(y), w: PixelsToUnit(ctx.measureText(' ').width), color: "DDDD00", fontFace: "Calibri", bold: false, fontSize: nFontSize})
                    
                        // ctx.fillText(' ', x + nCharXOffsetFromTextStart, y)
                        nCharXOffsetFromTextStart += ctx.measureText(' ').width
                    }
                }
                
                if(this.state.blnShowVerseNumbers && listOriginalWordsInOrderForLine.some(w => w !== undefined && this.listVerseEndIndexes.includes(parseInt(w.TextIndex))))
                {
                    listPythonLines = listPythonLines.concat(this.AddRunForText('.', sCurrentTextColor, sFontName, false, x + nCharXOffsetFromTextStart, y, ctx.measureText('.').width, false))
                    // ctx.fillText('.', x + nCharXOffsetFromTextStart, y)
                    nCharXOffsetFromTextStart += ctx.measureText('.').width
                }

                //GetOurTranslationForWord
                //this.GetTranslationForWord(w)

                //ctx.font = sBasicFont
                //ctx.fillText(sText, x, y)
            }

            var listWordsInLine = []
            var xForCurrentWordInLine = x
            var listWordsInLineToMeasure = blnHebrew ? listHebrewWordsInLine.slice().reverse() : sText.split(' ')
            for(var w of listWordsInLineToMeasure)
            {
                var nWordWidth = ctx.measureText(w).width
                var nWordWidthWithTrailingSpace = ctx.measureText(w + ' ').width

                listWordsInLine.push({text: w, x: xForCurrentWordInLine, xMid: xForCurrentWordInLine + nWordWidth / 2,  xMax: xForCurrentWordInLine + nWordWidth})
                xForCurrentWordInLine += nWordWidthWithTrailingSpace
            }

            if(blnHebrew)
            {
                listWordsInLine.reverse()
            }

            var listSyllablesInLine = []
            var listOriginalSyllablesInOrderForLine = listOriginalWordsInOrderForLine.filter(w => w !== undefined).flatMap(w => w.SyllableObjects)
            
            if(sLanguage === 'transliteration')
            {
                var xForCurrentSyllableInLine = x
                for(var wordForSyllable of listOriginalWordsInOrderForLine)
                {
                    for(var syl of wordForSyllable.SyllableObjects)
                    {
                        var sSyllableText = this.GetSyllableTextForDevelopmentDiagram(syl)
                        var nSyllableWidth = ctx.measureText(sSyllableText).width
                        var nSyllableWidthWithTrailingSpace = ctx.measureText(sSyllableText + (syl.isLastSyllableInWord ? ' ' : '')).width

                        //console.log(sSyllableText, syl.isLastSyllableInWord, nSyllableWidthWithTrailingSpace)
                        listSyllablesInLine.push({text: sSyllableText, x: xForCurrentSyllableInLine, xMid: xForCurrentSyllableInLine + nSyllableWidth / 2,  xMax: xForCurrentSyllableInLine + nSyllableWidth})
                        xForCurrentSyllableInLine += nSyllableWidthWithTrailingSpace
                    }
                }
            }

            var oBoundingBox = {LineIndex: nLineIndex, Words: listWordsInLine, OriginalWordsInOrderForLine: listOriginalWordsInOrderForLine, 
                Syllables: listSyllablesInLine, OriginalSyllablesInOrderForLine: listOriginalSyllablesInOrderForLine,
                x: x - nBoxPadding, y: y - nTextHeight + nBoxPadding / 2, 
                width: nTextWidth + 2 * nBoxPadding, height: nTextHeight + 2 * nBoxPadding}
            oBoundingBox.xMax = oBoundingBox.x + oBoundingBox.width
            oBoundingBox.yMax = oBoundingBox.y + oBoundingBox.height
            oBoundingBox.yMid = oBoundingBox.y + oBoundingBox.height / 2
            listBoundingBoxesToSet.push(oBoundingBox)
        }









        // console.log(listDevelopmentDiagramBoxesForChapter, listBoxGroupsToSet, dpr)












        // for(let oBox of listBoxesToSet)
        // {
        //     listPythonLines.push('slide.shapes.add_textbox(' + 
        //         this.PixelsToInches(oBox.x) + ', ' + 
        //         this.PixelsToInches(oBox.y) + ', ' + 
        //         this.PixelsToInches(oBox.width) + ', ' + 
        //         this.PixelsToInches(oBox.height) + ')')

        //     listPythonLines.push('paragraph = tb1.text_frame.paragraphs[0]')
        //     listPythonLines.push('paragraph.text = "אַ֥שְֽׁרֵי"')
        //     listPythonLines.push('paragraph.font.size = Pt(' + sFontSize + ')')
        //     listPythonLines.push('run = paragraph.runs[0]')
        //     listPythonLines.push('run.font.name = "' + sFontName + '"')
        //     listPythonLines.push('paragraph.font.color.rgb = RGBColor(255, 0, 0)')
        //     listPythonLines.push('paragraph.alignment = PP_ALIGN.CENTER')
        // }


        listPythonLines.push('prs.save("/Users/admin/Documents/connected_boxes.pptx")')
        window.alert('done')
        navigator.clipboard.writeText(listPythonLines.join('\n'))

        // pptx.writeFile("Demo-Text")

        // slide = prs.slides.add_slide(prs.slide_layouts[6]) # blank layout

        // # 1. Add and position the first textbox
        // tb1 = slide.shapes.add_textbox(Inches(1), Inches(2), Inches(2), Inches(1))
        // center_x1 = tb1.left + int(tb1.width / 2)
        // center_y1 = tb1.top + int(tb1.height / 2)

        // # 2. Add and position the second textbox
        // tb2 = slide.shapes.add_textbox(Inches(5), Inches(4), Inches(2), Inches(1))
        // center_x2 = tb2.left + int(tb2.width / 2)
        // center_y2 = tb2.top + int(tb2.height / 2)

        // # 1. VERTICAL CENTERING (Applied to the text frame)
        // tb1.text_frame.vertical_anchor = MSO_VERTICAL_ANCHOR.MIDDLE
        // tb2.text_frame.vertical_anchor = MSO_VERTICAL_ANCHOR.MIDDLE

        // # Add text to the first paragraph
        // paragraph = tb1.text_frame.paragraphs[0]
        // paragraph.text = "אַ֥שְֽׁרֵי"
        // paragraph.font.size = Pt(40)
        // run = paragraph.runs[0]
        // run.font.name = 'SBL Hebrew'
        // paragraph.font.color.rgb = RGBColor(255, 0, 0)
        // paragraph.alignment = PP_ALIGN.CENTER








        
        // var blnOriginalOrTransliteration = sLanguage === 'original' || sLanguage === 'transliteration'
        // var listLinkGroupsToSet = []

        // let nNumberOfLensesOn = this.state.listWordGroupsForEnabledLenses.length
        // for(var oLensGroup of this.state.listWordGroupsForEnabledLenses)
        // {
        //     var listGroups = []
        //     if(!this.state.blnBreakLinkGroupsIntoChains || (oLensGroup.ListGroups.length > 0 && oLensGroup.ListGroups[0].ByLine))
        //     {
        //         listGroups = oLensGroup.ListGroups
        //     }
        //     else
        //     {
        //         for(var oGroup of oLensGroup.ListGroups)
        //         {
        //             let listChainsInGroup = this.FilterWordGroupsForChains(
        //                 oGroup.ListWords.filter(w => w !== undefined).map(w => ({LineIndex: this.state.listLines.findIndex(l => l.Words.includes(w)), 
        //                     Verse: parseInt(w.Verse), Word: w})), 2, 1, true)

        //             //after breaking the groups into chains, some words might be left out, so don't color those
        //             //put all such words in all the broken out chain groups (for the chart) even though it is redundant

        //             var listGroupsToAdd = []
        //             let listAllWordsInChains = [] //listChainsInGroup.flat()     
        //             for(var oChain of listChainsInGroup)
        //             {
        //                 let listWordsInChain = oChain.flat()

        //                 let nChainLength = listWordsInChain.length
        //                 if(nChainLength >= this.state.nMinDevelopmentDiagramLinkGroupLengthToShow && 
        //                    nChainLength <= this.state.nMaxDevelopmentDiagramLinkGroupLengthToShow)
        //                 {
        //                     listGroupsToAdd.push({Color: oGroup.Color, Name: oGroup.Name, ListWords: listWordsInChain})
        //                     listAllWordsInChains = listAllWordsInChains.concat(listWordsInChain)
        //                 }
        //             }

        //             let listWordsLeftOutOfChains = oGroup.ListWords.filter(w => !listAllWordsInChains.includes(w))
        //             let listWordsNotToColor = []

        //             if(this.state.blnDoNotColorFirstWordInChain)
        //             {
        //                 listWordsNotToColor = listChainsInGroup.map(listWordsInChain => listWordsInChain[0])
        //             }

        //             oGroup.WordsToNotColor = listWordsNotToColor.concat(listWordsLeftOutOfChains)
        //             listGroupsToAdd.forEach(g => g.WordsToNotColor = listWordsNotToColor)

        //             listGroups = listGroups.concat(listGroupsToAdd)
        //         }
        //     }

        //     listLinkGroupsToSet = listLinkGroupsToSet.concat(this.GetDiagramLinkGroupsFromWordGroups(listGroups, sChapter, 
        //         blnOriginalOrTransliteration, false, 'lens', oLensGroup.Lens, 'hsl(0, 0%, 65%)'
        //         //nNumberOfLensesOn === 1 ? '' : oLensGroup.Lens.ShowLightLinksIfNotOnlyLens ? 'hsl(0, 0%, 65%)' : 'Black'
        //         ))
        // }
        
        // this.setState({listDevelopmentDiagramLinkGroupLengths: [...new Set(listLinkGroupsToSet.map(o => o.LineAndWordIndexes.length))].toSorted()})

        // //if(this.state.sShowLinksFromHoveredWhat === 'word')
        // //{

        // this.setState({listDevelopmentDiagramLinkGroups: listLinkGroupsToSet})

        // if(this.state.blnConnectionsPresentationMode)
        // {
        //     let nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet = this.state.nIndexOfSemanticGroupShowing >= listLinkGroupsToSet.length ? -1 : 
        //         listLinkGroupsToSet[this.state.nIndexOfSemanticGroupShowing].RepetitionGroupIndexInChapter

        //     this.setState({nRepetitionGroupIndexInChapterForCurrentConnectionsGroup: nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet})
            
        //     this.setState({sCommentForCurrentConnectionsGroup: nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet < 0 || 
        //         nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet >= this.state.listRepetitionLinkGroups.length ? '' :
        //         this.state.listRepetitionLinkGroups[nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet].Comment})

        //     this.setState({blnConnectionIsContrastForCurrentConnectionsGroup: nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet < 0 || 
        //         nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet >= this.state.listRepetitionLinkGroups.length ? '' :
        //         this.state.listRepetitionLinkGroups[nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet].IsContrast})

        //     if(this.state.blnConnectionsPresentationCommentEditMode)
        //     {
        //         var sDefaultCommentForCurrentConnectionsGroupToSet = ''
        //         var listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroupToSet = []

        //         if(!(nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet < 0 || 
        //             nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet >= this.state.listRepetitionLinkGroups.length))
        //         {
        //             let oCurrentRepetitionGroup = this.state.listRepetitionLinkGroups[nRepetitionGroupIndexInChapterForCurrentConnectionsGroupToSet]
        //             let listWordsInGroup = oCurrentRepetitionGroup.ListWords.map(sTextIndex => this.GetWordWithTextIndexInChapter(sTextIndex))
        //             sDefaultCommentForCurrentConnectionsGroupToSet = listWordsInGroup.map(w => this.GetOurTranslationForWord(w)).join(' -> ')

        //             let sListWordsForCurrentRepetitionSortedAndJoined = oCurrentRepetitionGroup.ListWords.map(sTextIndex => 
        //                 parseInt(sTextIndex)).toSorted((a,b) => a - b).join('_')

        //             listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroupToSet = this.listRepetitionGroupsForAllChapters
        //             .filter(g => g.Comment.length > 0 &&
        //                 g.ListWords.map(sTextIndex => parseInt(sTextIndex)).toSorted((a,b) => a - b).join('_') === sListWordsForCurrentRepetitionSortedAndJoined)
        //             .map(g => g.Comment)
        //         }

        //         this.setState({sDefaultCommentForCurrentConnectionsGroup: sDefaultCommentForCurrentConnectionsGroupToSet})
        //         this.setState({listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroup: listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroupToSet})
        //     }
        // }
    }


    DrawLinkPair(oThisOne, oNextOne, ctx, listBoundingBoxesToSet, oLinkGroup, blnDoTriangleFiltering)
    {
        //blnAtLeastOneInterveningWord is to avoid 'triangles' when the distance is greater than one line
        let blnAtLeastOneInterveningWord = blnDoTriangleFiltering && oLinkGroup.LineAndWordIndexes.some(lwi => 
            lwi.LineIndex > Math.min(oThisOne.LineIndex, oNextOne.LineIndex) && 
            lwi.LineIndex < Math.max(oThisOne.LineIndex, oNextOne.LineIndex))

        if(oThisOne === oNextOne || blnAtLeastOneInterveningWord //|| 
            // (oLinkGroup.CategoryForLinkFiltering === 'initial' && Math.abs(oThisOne.LineIndex - oNextOne.LineIndex) > 1) ||
            // (oLinkGroup.CategoryForLinkFiltering === 'final' && Math.abs(oThisOne.LineIndex - oNextOne.LineIndex) > 2) ||
            //(oLinkGroup.ExcludeLinksWithSameParentRoot && oThisOne.Word.ParentRoot === oNextOne.Word.ParentRoot)
            ) return
        
        let sMode = this.state.sModeForShowOnlyLinksAtLineEdges
        if(sMode !== 'modeisoff')
        {
            if(oThisOne.LineIndex === oNextOne.LineIndex)
            {
                if(sMode != 'sameline') return
            }
            else
            {
                let listWordsForThisOneLine = this.state.listLines[oThisOne.LineIndex].Words
                let listWordsForNextOneLine = this.state.listLines[oNextOne.LineIndex].Words

                let blnThisFirst = oThisOne.Word === listWordsForThisOneLine[0]
                let blnThisLast = oThisOne.Word === listWordsForThisOneLine[listWordsForThisOneLine.length - 1]
                let blnNextFirst = oNextOne.Word === listWordsForNextOneLine[0]
                let blnNextLast = oNextOne.Word === listWordsForNextOneLine[listWordsForNextOneLine.length - 1]

                let blnShowLink = 
                (sMode === 'beginningtobeginningorendtoend' && 
                    ((blnThisFirst && blnNextFirst) || (blnThisLast && blnNextLast))) ||
                (sMode === 'beginningtobeginningorendtoendormiddletomiddle' && 
                    ((blnThisFirst && blnNextFirst) || (blnThisLast && blnNextLast) || 
                    (!blnThisFirst && !blnNextFirst && !blnThisLast && !blnNextLast))) ||
                (sMode === 'beginningtoendorendtobeginning' && ((blnThisFirst && blnNextLast) || (blnThisLast && blnNextFirst))) ||
                (sMode === 'middletomiddle' && !blnThisFirst && !blnNextFirst && !blnThisLast && !blnNextLast)

                if(!blnShowLink) return
            }
        }

        var oBoundingBox1 = listBoundingBoxesToSet.find(o => o.LineIndex === oThisOne.LineIndex)
        var oBoundingBox2 = listBoundingBoxesToSet.find(o => o.LineIndex === oNextOne.LineIndex)

        if(oBoundingBox1 != undefined && oBoundingBox2 != undefined)
        {
            if(oThisOne.WordIndexForDrawing < oBoundingBox1.Words.length && oNextOne.WordIndexForDrawing < oBoundingBox2.Words.length)
            {
                var x1 = oBoundingBox1.Words[oThisOne.WordIndexForDrawing].xMid
                var x2 = oBoundingBox2.Words[oNextOne.WordIndexForDrawing].xMid
                
                // let deltaX = x2 - x1
                // let deltaY = oBoundingBox2.yMid - oBoundingBox1.yMid
                // let nLineDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY)

                //900 = 0.3
                //20 = 1.0
                // let nPercentOfLightness = nLineDistance < 50 ? 1.0 :
                //     nLineDistance < 100 ? 1.1 :
                //     nLineDistance < 200 ? 1.4 :
                //     nLineDistance < 300 ? 1.7 :
                //     nLineDistance < 400 ? 2.0 :
                //     nLineDistance < 500 ? 2.4 :
                //     nLineDistance < 600 ? 2.7 :
                //     nLineDistance < 700 ? 3.0 : 3.4

                ctx.strokeStyle = oLinkGroup.Color //this.LightenColor(oLinkGroup.Color, nPercentOfLightness)
                ctx.lineWidth = oLinkGroup.Width
                ctx.beginPath()
                ctx.moveTo(x1, oBoundingBox1.yMid)
                ctx.lineTo(x2, oBoundingBox2.yMid)
                ctx.stroke()
                ctx.closePath()
            }
        }
    }

    GetSyllableTextForDevelopmentDiagram(oSyllable)
    {
        let blnMaqqeph = oSyllable['isLastSyllableInWord'] && !oSyllable.word.HasFullAccent && this.blnChapterIsHebrew
        return this.RemoveNonVowelsAndNonConsonants(oSyllable.syllable) + (blnMaqqeph ? '-' : '')
    }

    GetDevelopmentDiagramLinkGroupsForChapter()
    {
        return this.state.listDevelopmentDiagramLinkGroups.filter(o => o.Chapter === this.GetFirstCurrentChapter().toString() && 
            this.state.blnShowLinksForLensThatIsColoredBy || o.Lens !== this.GetLensToColorBy())
    }

    DrawDevelopmentDiagram()
    {
        const canvas = this.canvasRef.current
        if(canvas === null) return
        
        const ctx = canvas.getContext('2d')

        const dpr = window.devicePixelRatio;
        const rect = canvas.getBoundingClientRect();

        // Set the "actual" size of the canvas
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;

        // Scale the context to ensure correct drawing operations
        ctx.scale(dpr, dpr);

        // Set the "drawn" size of the canvas
        canvas.style.width = `${rect.width}px`;
        canvas.style.height = `${rect.height}px`;

        //context.canvas.width, context.canvas.height
        //context.fillStyle = '#000000'
        //context.fillRect(0, 0, 20, 20)

        // const pixelRatio = window.devicePixelRatio || 1;
        // const canvasWidth = canvas.offsetWidth;  // Get displayed width
        // const canvasHeight = canvas.offsetHeight; // Get displayed height

        // canvas.width = canvasWidth * pixelRatio;
        // canvas.height = canvasHeight * pixelRatio;

        // ctx.scale(pixelRatio, pixelRatio);

        // Now you can draw text and other elements on the canvas
        var sLanguage = this.state.sDevelopmentDiagramLanguage
        var blnHebrew = sLanguage === 'original'
        var blnColorLinesByNumberOfExternalLinks = false
        var blnBoxBorder = false

        let sBasicFont = blnHebrew ? '22px SBL Hebrew' : '18px Calibri'
        let sBoldFont = "bold " + sBasicFont

        ctx.font = sBasicFont
        ctx.textAlign = 'left' //blnHebrew ? 'right' : 'left'
        //ctx.direction = 'rtl'
        ctx.textBaseline = 'middle'
        ctx.textRendering = 'optimizeLegibility'

        var nBoxPadding = 5 //blnBoxBorder ? 5 : 0
        var sChapter = this.GetFirstCurrentChapter().toString()

        //console.log(sChapter, this.state.listDevelopmentDiagramBoxes)
        var listDevelopmentDiagramLinkGroupsForChapter = this.GetDevelopmentDiagramLinkGroupsForChapter()

        var blnOnlyColorWordsInCertainLinkGroups = false
        var listTextIndexesToColorFromLinkGroups = []

        if(this.state.oDevelopmentDiagramHoveredObject !== null && this.state.oDevelopmentDiagramBoxGroupSelectedToCompareWith !== null && 
           this.state.sShowLinksFromHoveredWhat === 'group')
        {
            var oHoveredBoxGroup = this.GetDevelopmentDiagramBoxGroupForLineIndex(sChapter, this.state.oDevelopmentDiagramHoveredObject.LineIndex)
            let oSelectedBoxGroup = this.state.oDevelopmentDiagramBoxGroupSelectedToCompareWith

            if(oHoveredBoxGroup != undefined)
            {
                blnOnlyColorWordsInCertainLinkGroups = true

                listTextIndexesToColorFromLinkGroups = [...new Set(listDevelopmentDiagramLinkGroupsForChapter
                .filter(oLinkGroup => 
                    oLinkGroup.LineAndWordIndexes.some(lwi => oHoveredBoxGroup.LineIndexes.includes(lwi.LineIndex)) && 
                    oLinkGroup.LineAndWordIndexes.some(lwi => oSelectedBoxGroup.LineIndexes.includes(lwi.LineIndex)))
                .flatMap(oLinkGroup => oLinkGroup.LineAndWordIndexes
                    .filter(lwi => oHoveredBoxGroup.LineIndexes.includes(lwi.LineIndex) || oSelectedBoxGroup.LineIndexes.includes(lwi.LineIndex))
                    .map(lwi => lwi.Word.TextIndex)))]

                //console.log(listTextIndexesToColorFromLinkGroups)
            }
        }
        
        var listDevelopmentDiagramBoxesForChapter = this.state.listDevelopmentDiagramBoxes.filter(o => o.Chapter === sChapter)

        var listBoundingBoxesToSet = []
        for(var oDiagramBox of listDevelopmentDiagramBoxesForChapter)
        {
            var x = oDiagramBox.x
            var y = oDiagramBox.y
            var nLineIndex = oDiagramBox.LineIndex

            var listOriginalWordsInOrderForLine = this.state.listLines[nLineIndex] === undefined ? [] : this.state.listLines[nLineIndex].Words
            var listHebrewWordsInLine = !blnHebrew ? [] : listOriginalWordsInOrderForLine.map(w => w.FullText)

            //blnBoxBorder = this.state.oDevelopmentDiagramHoveredObject != null && 
            //this.state.oDevelopmentDiagramHoveredObject.LineIndex === nLineIndex

            ctx.fillStyle = 'black'
            var listAdditionalRepetitionGroupColors = []
            
            if(blnColorLinesByNumberOfExternalLinks)
            {
                //count all the links in link groups that have >= 1 link inside the line/unit
                //but exclude the links for that line/unit
                var nExternalLinksFromLine = this.state.listDevelopmentDiagramLinkGroups.filter(o => o.Chapter === sChapter &&
                    o.LineAndWordIndexes.some(lwi => nLineIndex === lwi.LineIndex))
                .flatMap(o => o.LineAndWordIndexes).filter(lwi => nLineIndex != lwi.LineIndex).length
                
                ctx.fillStyle = nExternalLinksFromLine > 40 ? 'black' : 
                    nExternalLinksFromLine > 30 ? 'purple' :
                    nExternalLinksFromLine > 20 ? 'red' :
                    nExternalLinksFromLine > 10 ? 'blue' :
                    nExternalLinksFromLine > 5 ? 'green' : 'cornflower'
            }
            
            if(this.state.blnColorLinesByDevelopmentRepetitionGroup)
            {            
                var oRepetitionGroup = this.state.listDevelopmentRepetitionGroupsByChapter.find(o => o.Chapter === sChapter &&
                    o.LineIndex === nLineIndex)

                if(oRepetitionGroup != undefined)
                {
                    var listRepetitionGroupsToShow = this.state.nDevelopmentDiagramColorKeyGroupIDBeingHovered === -1 ? 
                        oRepetitionGroup.Groups : oRepetitionGroup.Groups.filter(nGroup => nGroup === this.state.nDevelopmentDiagramColorKeyGroupIDBeingHovered)

                    if(listRepetitionGroupsToShow.length > 0)
                    {
                        ctx.fillStyle = this.GetColorForDevelopmentRepetitionGroup(listRepetitionGroupsToShow[0], 1.0)
                        if(listRepetitionGroupsToShow.length > 1)
                        {
                            //make the additional colors lighter since the boxes look darker than the text
                            listAdditionalRepetitionGroupColors = listRepetitionGroupsToShow.slice(1)
                                .map(nGroup => this.GetColorForDevelopmentRepetitionGroup(nGroup, 1.5))
                        }
                    }
                }
            }

            var sText = ''
            if(sLanguage === 'original')
            {
                sText = listHebrewWordsInLine.join(' ')
            }
            else if(sLanguage === 'transliteration')
            {
                sText = this.state.listLines[nLineIndex].Words.map(w => w.Transliteration).join(' ').replaceAll('*', '').replaceAll('|', '')
            }
            else
            {
                var oTranslationForLine = this.state.listOurTranslationLines.find(o => o.Chapter === sChapter && o.LineIndex === nLineIndex)
                var sTranslationForLine = oTranslationForLine === undefined ? '?' : oTranslationForLine.Translation
                sText = sTranslationForLine
            }

            const metrics = ctx.measureText(sText)
            var nTextHeight = Math.abs(metrics.actualBoundingBoxAscent) + Math.abs(metrics.actualBoundingBoxDescent)
            var nTextWidth = metrics.width
            
            if(sLanguage === 'transliteration' || sLanguage === 'original')
            {
                let nCharXOffsetFromTextStart = 0
                let nWordIndexInLine = 0

                for(let w of (sLanguage === 'original' ? this.state.listLines[nLineIndex].Words.slice().reverse() : this.state.listLines[nLineIndex].Words))
                {
                    let blnDontColorThisWord = blnOnlyColorWordsInCertainLinkGroups && !listTextIndexesToColorFromLinkGroups.includes(w.TextIndex)

                    // var nExternalLinksFromWord = this.state.listDevelopmentDiagramLinkGroups.filter(o => o.Chapter === sChapter &&
                    //     o.LineAndWordIndexes.some(lwi => nLineIndex === lwi.LineIndex))
                    //     .flatMap(o => o.LineAndWordIndexes).filter(lwi => nLineIndex != lwi.LineIndex && lwi.WordIndexForDrawing === nWordIndexInLine).length

                    if(sLanguage === 'transliteration')
                    {
                        for(let oSyllable of w.SyllableObjects)
                        {
                            let sSyllable = this.GetSyllableTextForDevelopmentDiagram(oSyllable)

                            //let blnSoundOrRhythmTransliteration = (this.state.sSelectedView === 'sound' || this.state.sSelectedView === 'rhythm') && sLanguage === 'transliteration'
                            //let blnUseBoldFont = (blnSoundOrRhythmTransliteration && this.SyllableShouldBeBolded(oSyllable))
                            ctx.font = this.SyllableShouldBeBolded(oSyllable) ? sBoldFont : sBasicFont

                            if(!this.state.blnColorLinesByDevelopmentRepetitionGroup)
                            {
                                ctx.fillStyle = blnDontColorThisWord ? 'LightGray' : this.GetTextColorForSyllable(oSyllable)
                            }

                            ctx.fillText(sSyllable, x + nCharXOffsetFromTextStart, y)
                            nCharXOffsetFromTextStart += ctx.measureText(sSyllable).width
                        }
                        
                        if(this.state.blnShowVerseNumbers && this.listVerseEndIndexes.includes(parseInt(w.TextIndex)))
                        {
                            ctx.fillText('.', x + nCharXOffsetFromTextStart, y)
                            nCharXOffsetFromTextStart += ctx.measureText('.').width
                        }
                        else if(w.HasFullAccent || !this.blnChapterIsHebrew)
                        {
                            ctx.fillText(' ', x + nCharXOffsetFromTextStart, y)
                            nCharXOffsetFromTextStart += ctx.measureText(' ').width
                        }
                    }
                    else if(sLanguage === 'original')
                    {
                        if(w.HasFullAccent || !this.blnChapterIsHebrew)
                        {
                            ctx.fillText(' ', x + nCharXOffsetFromTextStart, y)
                            nCharXOffsetFromTextStart += ctx.measureText(' ').width
                        }

                        let sTextForWord = w.FullText
                        let sTextColor = blnDontColorThisWord ? 'LightGray' : this.GetTextColor(w)
                        
                        if(!this.state.blnColorLinesByDevelopmentRepetitionGroup)
                        {
                            ctx.fillStyle = sTextColor //sTextColor === 'LightGray' || sTextColor === 'Silver' ? 'Black' : sTextColor
                        }

                        ctx.fillText(sTextForWord, x + nCharXOffsetFromTextStart, y)
                        nCharXOffsetFromTextStart += ctx.measureText(sTextForWord).width
                    }

                    nWordIndexInLine += 1
                }
            }
            else
            {
                listOriginalWordsInOrderForLine = []

                var oTranslationForLine = this.state.listOurTranslationLines.find(o => o.Chapter === sChapter && o.LineIndex === nLineIndex)
                var sTranslationForLine = oTranslationForLine === undefined ? '?' : oTranslationForLine.Translation
                let listTranslationWords = sTranslationForLine.split(' ')

                let nCharXOffsetFromTextStart = 0
                for(var nWordIndexInLine = 0; nWordIndexInLine < listTranslationWords.length; nWordIndexInLine++)
                {
                    let sTextForWord = listTranslationWords[nWordIndexInLine]
                    let listOriginalWords = this.GetOriginalWordsForWordAndLineIndexOfOurTranslation(sChapter, nLineIndex, nWordIndexInLine)
                    let w = listOriginalWords.length === 0 ? undefined : listOriginalWords[0]
                    listOriginalWordsInOrderForLine.push(w)
                    
                    if(w != undefined && !this.state.blnColorLinesByDevelopmentRepetitionGroup)
                    {
                        let blnDontColorThisWord = blnOnlyColorWordsInCertainLinkGroups && !listTextIndexesToColorFromLinkGroups.includes(w.TextIndex)

                        let sTextColor = blnDontColorThisWord ? 'LightGray' : this.GetTextColor(w)
                        ctx.fillStyle = sTextColor //=== 'LightGray' || sTextColor === 'Silver' ? 'Black' : sTextColor
                    }

                    ctx.fillText(sTextForWord, x + nCharXOffsetFromTextStart, y)
                    nCharXOffsetFromTextStart += ctx.measureText(sTextForWord).width
                    
                    if(nWordIndexInLine < listTranslationWords.length - 1)
                    {
                        ctx.fillText(' ', x + nCharXOffsetFromTextStart, y)
                        nCharXOffsetFromTextStart += ctx.measureText(' ').width
                    }
                }
                
                if(this.state.blnShowVerseNumbers && listOriginalWordsInOrderForLine.some(w => w !== undefined && this.listVerseEndIndexes.includes(parseInt(w.TextIndex))))
                {
                    ctx.fillText('.', x + nCharXOffsetFromTextStart, y)
                    nCharXOffsetFromTextStart += ctx.measureText('.').width
                }

                //GetOurTranslationForWord
                //this.GetTranslationForWord(w)

                //ctx.font = sBasicFont
                //ctx.fillText(sText, x, y)
            }

            var nAdditionalRepetitionGroupColorWidth = 8
            var nAdditionalRepetitionGroupColorWidthSpaceBetweenColors = 5
            var nAdditionalRepetitionGroupColorWidthPlusSpace = nAdditionalRepetitionGroupColorWidth + nAdditionalRepetitionGroupColorWidthSpaceBetweenColors
            var nCurrentAdditionalRepetitionGroupColor = 0
            var nTotalAdditionalWidthFromTheColors = listAdditionalRepetitionGroupColors.length * nAdditionalRepetitionGroupColorWidthPlusSpace - 
                nAdditionalRepetitionGroupColorWidthSpaceBetweenColors

            for(var sGroupColor of listAdditionalRepetitionGroupColors)
            {
                ctx.fillStyle = sGroupColor
                ctx.fillRect(x + nTextWidth + 5 + (nAdditionalRepetitionGroupColorWidthPlusSpace * nCurrentAdditionalRepetitionGroupColor), 
                    y - nTextHeight / 2, nAdditionalRepetitionGroupColorWidth, nTextHeight * 0.7)
                nCurrentAdditionalRepetitionGroupColor += 1
            }

            var listWordsInLine = []
            var xForCurrentWordInLine = x
            var listWordsInLineToMeasure = blnHebrew ? listHebrewWordsInLine.slice().reverse() : sText.split(' ')
            for(var w of listWordsInLineToMeasure)
            {
                var nWordWidth = ctx.measureText(w).width
                var nWordWidthWithTrailingSpace = ctx.measureText(w + ' ').width

                listWordsInLine.push({text: w, x: xForCurrentWordInLine, xMid: xForCurrentWordInLine + nWordWidth / 2,  xMax: xForCurrentWordInLine + nWordWidth})
                xForCurrentWordInLine += nWordWidthWithTrailingSpace
            }

            if(blnHebrew)
            {
                listWordsInLine.reverse()
            }

            var listSyllablesInLine = []
            var listOriginalSyllablesInOrderForLine = listOriginalWordsInOrderForLine.filter(w => w !== undefined).flatMap(w => w.SyllableObjects)
            
            if(sLanguage === 'transliteration')
            {
                var xForCurrentSyllableInLine = x
                for(var wordForSyllable of listOriginalWordsInOrderForLine)
                {
                    for(var syl of wordForSyllable.SyllableObjects)
                    {
                        var sSyllableText = this.GetSyllableTextForDevelopmentDiagram(syl)
                        var nSyllableWidth = ctx.measureText(sSyllableText).width
                        var nSyllableWidthWithTrailingSpace = ctx.measureText(sSyllableText + (syl.isLastSyllableInWord ? ' ' : '')).width

                        //console.log(sSyllableText, syl.isLastSyllableInWord, nSyllableWidthWithTrailingSpace)
                        listSyllablesInLine.push({text: sSyllableText, x: xForCurrentSyllableInLine, xMid: xForCurrentSyllableInLine + nSyllableWidth / 2,  xMax: xForCurrentSyllableInLine + nSyllableWidth})
                        xForCurrentSyllableInLine += nSyllableWidthWithTrailingSpace
                    }
                }
            }

            var oBoundingBox = {LineIndex: nLineIndex, Words: listWordsInLine, OriginalWordsInOrderForLine: listOriginalWordsInOrderForLine, 
                Syllables: listSyllablesInLine, OriginalSyllablesInOrderForLine: listOriginalSyllablesInOrderForLine,
                x: x - nBoxPadding, y: y - nTextHeight + nBoxPadding / 2, 
                width: nTextWidth + nTotalAdditionalWidthFromTheColors + 2 * nBoxPadding, height: nTextHeight + 2 * nBoxPadding}
            oBoundingBox.xMax = oBoundingBox.x + oBoundingBox.width
            oBoundingBox.yMax = oBoundingBox.y + oBoundingBox.height
            oBoundingBox.yMid = oBoundingBox.y + oBoundingBox.height / 2
            listBoundingBoxesToSet.push(oBoundingBox)

            if(blnBoxBorder) 
            {
                ctx.strokeRect(oBoundingBox.x, oBoundingBox.y, oBoundingBox.width, oBoundingBox.height)
            }
        }

        this.listDevelopmentDiagramBoundingBoxesForLines = listBoundingBoxesToSet

        for(var l of this.state.listDevelopmentDiagramLines.filter(o => o.Chapter === sChapter))
        {
            ctx.strokeStyle = l.Color
            ctx.lineWidth = l.Width
            ctx.beginPath()
            ctx.moveTo(l.X1, l.Y1)
            ctx.lineTo(l.X2, l.Y2)
            ctx.stroke()
            ctx.closePath()
        }
        
        let blnSelectedIndexMode = this.state.blnConnectionsPresentationMode //this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'selectedindexoflinkgroup'
        let blnGroupSelectedToCompareWithMode = this.state.oDevelopmentDiagramBoxGroupSelectedToCompareWith !== null && 
            this.state.sShowLinksFromHoveredWhat === 'group'

        if(!blnGroupSelectedToCompareWithMode && (this.state.oDevelopmentDiagramHoveredObject !== null || 
            this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'onelineperlinkgroup' || blnSelectedIndexMode))
        {
            //TODO: have option to filter this for ParentRoot only?

            //TODO: use nMaxDevelopmentDiagramLinesAwayFromHoveredToShowForSound here somehow
            // if(this.state.nMaxDevelopmentDiagramLinesAwayFromHoveredToShowForSound < 10000 && 
            // Math.abs(lwi.LineIndex - this.state.oDevelopmentDiagramHoveredObject.LineIndex) > this.state.nMaxDevelopmentDiagramLinesAwayFromHoveredToShowForSound)

            let listLinkGroupsToUse = !blnSelectedIndexMode ? listDevelopmentDiagramLinkGroupsForChapter : 
                this.state.nIndexOfSemanticGroupShowing >= listDevelopmentDiagramLinkGroupsForChapter.length ? [] : 
                [listDevelopmentDiagramLinkGroupsForChapter[this.state.nIndexOfSemanticGroupShowing]]

            //console.log(listDevelopmentDiagramLinkGroupsForChapter, this.state.nIndexOfSemanticGroupShowing)
            //.filter(oLinkGroup => oLinkGroup.LinkGroupType === 'semantic')
            
            let oHovered = this.state.oDevelopmentDiagramHoveredObject
            if(oHovered != null)
            {
                if(this.state.sShowLinksFromHoveredWhat === 'word')
                {
                    listLinkGroupsToUse = listLinkGroupsToUse.filter(oLinkGroup => 
                        oLinkGroup.LineAndWordIndexes.some(lwi => (oLinkGroup.ByLine || lwi.WordIndexes.includes(oHovered.WordIndex)) && 
                            lwi.LineIndex === oHovered.LineIndex))
                }
                else if(this.state.sShowLinksFromHoveredWhat === 'line')
                {
                    listLinkGroupsToUse = listLinkGroupsToUse.filter(oLinkGroup => 
                        oLinkGroup.LineAndWordIndexes.some(lwi => lwi.LineIndex === oHovered.LineIndex))
                }
                else if(this.state.sShowLinksFromHoveredWhat === 'group')
                {
                    var oHoveredBoxGroup = this.GetDevelopmentDiagramBoxGroupForLineIndex(sChapter, oHovered.LineIndex)
                    if(oHoveredBoxGroup != undefined)
                    {
                        listLinkGroupsToUse = listLinkGroupsToUse.filter(oLinkGroup => 
                            oLinkGroup.LineAndWordIndexes.some(lwi => oHoveredBoxGroup.LineIndexes.includes(lwi.LineIndex)))
                    }
                }
            }

            //'StartsRepetitionGroup')
            let listLineGroups = this.state.blnConnectionsPresentationMode ? this.GetSuperLineGroupsForConnectionsLens() : 
                this.GetLinesForSideBySideMode(this.state.listLines, this.state.sGroupLinesBy)

            var listLineIndexesPerGroup = listLineGroups.map(oLineGroup => 
                Array.from({length: oLineGroup.Lines.length}, (_, i) => i)
                .map(n => oLineGroup.AbsoluteIndexOfFirstLineInGroup + n))

            for(var listLineIndexesInGroup of listLineIndexesPerGroup)
            {
                for(var oLinkGroup of listLinkGroupsToUse)
                {
                    let listGroupElementsSortedByLineNumber = oLinkGroup.LineAndWordIndexes
                        .filter(lwi => oHovered != null || listLineIndexesInGroup.includes(lwi.LineIndex))
                        .sort((a,b) => a.LineIndex - b.LineIndex)

                    if(listGroupElementsSortedByLineNumber.length >= this.state.nMinDevelopmentDiagramLinkGroupLengthToShow && 
                       listGroupElementsSortedByLineNumber.length <= this.state.nMaxDevelopmentDiagramLinkGroupLengthToShow)
                    {
                        for(var nlwi = 0; nlwi < listGroupElementsSortedByLineNumber.length - 1; nlwi++)
                        {
                            let oFrom = listGroupElementsSortedByLineNumber[nlwi]
                            let oTo = listGroupElementsSortedByLineNumber[nlwi + 1]
                            this.DrawLinkPair(oFrom, oTo, ctx, listBoundingBoxesToSet, oLinkGroup, false)
                        }
                    }
                }
            }
        }
        else if(!blnGroupSelectedToCompareWithMode && this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'unittounit' && this.state.sGroupLinesByForLens !== 'Line')
        {
            var listLineGroups = this.GetLinesForSideBySideMode(this.state.listLines, this.state.sGroupLinesByForLens)

            for(var nLineGroup = 0; nLineGroup < listLineGroups.length - this.state.nMaxLinesAwayForDefaultNoHoveredMode; nLineGroup++)
            {
                let nLineGroup2 = nLineGroup + this.state.nMaxLinesAwayForDefaultNoHoveredMode
                
                //for(var nLineGroup2 = nLineGroup + 1; nLineGroup2 <= nLineGroup + this.state.nMaxLinesAwayForDefaultNoHoveredMode; nLineGroup2++)
                //{

                let oLineGroup1 = listLineGroups[nLineGroup]
                let oLineGroup2 = listLineGroups[nLineGroup2]
                let listLinesIndexesFor1 = Array.from({length: oLineGroup1.Lines.length}, (_, i) => oLineGroup1.AbsoluteIndexOfFirstLineInGroup + i)
                let listLinesIndexesFor2 = Array.from({length: oLineGroup2.Lines.length}, (_, i) => oLineGroup2.AbsoluteIndexOfFirstLineInGroup + i)
                let listLinesIndexesForBothUnits = listLinesIndexesFor1.concat(listLinesIndexesFor2)

                let listLinkGroupsToUse = listDevelopmentDiagramLinkGroupsForChapter.filter(oLinkGroup => 
                    oLinkGroup.LineAndWordIndexes.some(lwi => listLinesIndexesFor1.includes(lwi.LineIndex)) &&
                    oLinkGroup.LineAndWordIndexes.some(lwi => listLinesIndexesFor2.includes(lwi.LineIndex)))

                for(var oLinkGroup of listLinkGroupsToUse)
                {
                    let listGroupElementsSortedByLineNumber = oLinkGroup.LineAndWordIndexes.filter(lwi =>
                        listLinesIndexesForBothUnits.includes(lwi.LineIndex)).sort((a,b) => a.LineIndex - b.LineIndex)
                        
                    for(var nlwi = 0; nlwi < listGroupElementsSortedByLineNumber.length - 1; nlwi++)
                    {
                        this.DrawLinkPair(listGroupElementsSortedByLineNumber[nlwi], listGroupElementsSortedByLineNumber[nlwi + 1], 
                            ctx, listBoundingBoxesToSet, oLinkGroup, false)
                    }
                }

                //}
            }
        }
        else
        {
            //'StartsCluster' //this.GetSubUnitForTextUnit(this.state.sGroupLinesBy)
            // var listLinesByBreakGroup = this.GetLinesByBreakGroup(this.state.listLines, this.state.sGroupLinesBy)
            
            var listLineGroups = this.GetLineGroupsForDevelopmentDiagram(this.state.listLines)
            let listLineIndexesFromTo = []

            if(this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'nolinks')
            {
                listLineIndexesFromTo = []
            }
            else if(blnGroupSelectedToCompareWithMode)
            {
                if(this.state.oDevelopmentDiagramHoveredObject !== null)
                {
                    var oHoveredBoxGroup = this.GetDevelopmentDiagramBoxGroupForLineIndex(sChapter, this.state.oDevelopmentDiagramHoveredObject.LineIndex)
                    let oSelectedBoxGroup = this.state.oDevelopmentDiagramBoxGroupSelectedToCompareWith
    
                    if(oHoveredBoxGroup != undefined)
                    {
                        for(let nLine1 of oSelectedBoxGroup.LineIndexes)
                        {
                            for(let nLine2 of oHoveredBoxGroup.LineIndexes)
                            {
                                listLineIndexesFromTo.push({From: nLine1, To: nLine2})
                            }
                        }

                        // listTextIndexesToColorFromLinkGroups = [...new Set(listDevelopmentDiagramLinkGroupsForChapter
                        // .filter(oLinkGroup => 
                        //     oLinkGroup.LineAndWordIndexes.some(lwi => oHoveredBoxGroup.LineIndexes.includes(lwi.LineIndex)) && 
                        //     oLinkGroup.LineAndWordIndexes.some(lwi => oSelectedBoxGroup.LineIndexes.includes(lwi.LineIndex)))
                        // .flatMap(oLinkGroup => oLinkGroup.LineAndWordIndexes
                        //     .filter(lwi => oHoveredBoxGroup.LineIndexes.includes(lwi.LineIndex) || oSelectedBoxGroup.LineIndexes.includes(lwi.LineIndex))
                        //     .map(lwi => lwi.Word.TextIndex)))]
    
                        //console.log(listTextIndexesToColorFromLinkGroups)
                    }
                }
            }
            else if(this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'unittounit')
            {
                for(var nLine = 0; nLine < this.state.listLines.length - this.state.nMaxLinesAwayForDefaultNoHoveredMode; nLine++)
                {
                    listLineIndexesFromTo.push({From: nLine, To: nLine + this.state.nMaxLinesAwayForDefaultNoHoveredMode})

                    // for(var nLine2 = nLine; nLine2 <= nLine + this.state.nMaxLinesAwayForDefaultNoHoveredMode; nLine2++)
                    // {
                    //     listLineIndexesFromTo.push({From: nLine, To: nLine2})
                    // }
                }
            }
            else if(this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'firstlineofsubunitsnotfirst' && listLineGroups.length > 1)
            {
                listLineIndexesFromTo = listLineGroups.slice(1).flatMap(oLineGroup => 
                    Array.from({length: oLineGroup.AbsoluteIndexOfFirstLineInGroup}, (_, i) => i)
                    .map(n => ({From: n , To: oLineGroup.AbsoluteIndexOfFirstLineInGroup})))
            }
            else if(this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'bookendingsubunits' && listLineGroups.length > 0)
            {
                listLineIndexesFromTo = listLineGroups.map(oLineGroup => ({
                    From: oLineGroup.AbsoluteIndexOfFirstLineInGroup, 
                    To: oLineGroup.AbsoluteIndexOfFirstLineInGroup + oLineGroup.Lines.length - 1}))
            }
            else if(this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'bookendingchapter' && listLineGroups.length > 0)
            {
                let oLastLineGroup = listLineGroups[listLineGroups.length - 1]
                let nLastLineIndexInChapter = oLastLineGroup.AbsoluteIndexOfFirstLineInGroup + oLastLineGroup.Lines.length - 1

                listLineIndexesFromTo = [{From: 0, To: nLastLineIndexInChapter}]
            }
            
            for(var oFromTo of listLineIndexesFromTo)
            {
                let listLinkGroupsToUse = listDevelopmentDiagramLinkGroupsForChapter
                    .filter(o => o.LineAndWordIndexes.some(lwi => lwi.LineIndex === oFromTo.From) &&
                        o.LineAndWordIndexes.some(lwi => lwi.LineIndex === oFromTo.To))

                for(var oLinkGroup of listLinkGroupsToUse)
                {
                    for(var oThisOne of oLinkGroup.LineAndWordIndexes.filter(lwi => lwi.LineIndex === oFromTo.From))
                    {
                        for(var oNextOne of oLinkGroup.LineAndWordIndexes.filter(lwi => lwi.LineIndex === oFromTo.To))
                        {
                            this.DrawLinkPair(oThisOne, oNextOne, ctx, listBoundingBoxesToSet, oLinkGroup, this.state.nMaxLinesAwayForDefaultNoHoveredMode > 1)
                        }
                    }
                }
            }
        }
    }

    AreThereDevelopmentDiagramsForChapter(sChapter)
    {
        return this.state.listDevelopmentDiagramBoxes.some(o => o.Chapter === sChapter)    
    }

    GetDevelopmentDiagramBoxForLineIndex(sChapter, nLineIndex)
    {
        return this.state.listDevelopmentDiagramBoxes.find(o => o.Chapter === sChapter && o.LineIndex === nLineIndex)
    }

    GetDevelopmentDiagramBoxGroupForLineIndex(sChapter, nLineIndex)
    {
        return this.state.listDevelopmentDiagramBoxGroups.find(o => o.Chapter === sChapter && o.LineIndexes.includes(nLineIndex))
    }
    
    GetDevelopmentDiagramBoundingBoxAtCoordinate(xParam, yParam)
    {
        const canvas = this.canvasRef.current
        if(canvas === null) return -1

        const canvasRect = canvas.getBoundingClientRect()
        const x = xParam - canvasRect.left - window.scrollX
        const y = yParam - canvasRect.top - window.scrollY

        var nWordIndexInLine = -1
        var nSyllableIndexInLine = -1
        var oBox = this.listDevelopmentDiagramBoundingBoxesForLines.find(o => x >= o.x && x <= o.xMax && y >= o.y && y <= o.yMax)
        if(oBox != undefined)
        {
            //console.log(yParam, oBox.y, oBox.yMax, oBox.Words.map(o2 => o2.text).join(' '))
            nWordIndexInLine = oBox.Words.findIndex(o => x >= o.x && x <= o.xMax)
            nSyllableIndexInLine = oBox.Syllables.findIndex(o => x >= o.x && x <= o.xMax)
        }
        // else
        // {
        //     var listSortedByYCloseness = this.listDevelopmentDiagramBoundingBoxesForLines
        //     .map(o => ({Object: o, Distance: Math.min(Math.abs(yParam - o.y), Math.abs(yParam - o.yMax))}))
        //     .sort((a,b) => a.Distance - b.Distance)
        //     .map(o => o.Object)

        //     if(listSortedByYCloseness.length > 0)
        //     {
        //         var o = listSortedByYCloseness[0]
        //         //console.log(xParam, yParam, o.Words.map(o2 => o2.text).join(' '), o.y, o.yMax)
        //     }
        // }

        return {BoundingBox: oBox, WordIndexInLine: nWordIndexInLine, SyllableIndexInLine: nSyllableIndexInLine}
    }

    SetDescForDevelopmentRepetitionGroup(nGroupID, sChapter, sDesc)
    {
        var oToSet = this.state.listDevelopmentRepetitionDescsForGroupsByChapter.find(o => o.ID === nGroupID)
        if(oToSet === undefined)
        {
            this.state.listDevelopmentRepetitionDescsForGroupsByChapter.push({ID: nGroupID, Desc: sDesc})
        }
        else
        {
            oToSet.Desc = sDesc
        }

        this.SaveDevelopmentRepetitionDescsForGroupsByChapter(this.state.listDevelopmentRepetitionDescsForGroupsByChapter)
    }

    SetDevelopmentRepetitionGroupForLine(nLine, nGroup, sChapter, blnAddInsteadOfReplace, blnClearGroupsForLine)
    {
        var oForChapterAndLine = this.state.listDevelopmentRepetitionGroupsByChapter.find(o => o.Chapter === sChapter && o.LineIndex === nLine)
        if(oForChapterAndLine === undefined)
        {
            if(!blnClearGroupsForLine)
            {
                this.state.listDevelopmentRepetitionGroupsByChapter.push({Chapter: sChapter, LineIndex: nLine, Groups: [nGroup]})
            }
        }
        else
        {
            if(blnClearGroupsForLine)
            {
                oForChapterAndLine.Groups = []
            }
            else
            {
                if(!oForChapterAndLine.Groups.includes(nGroup))
                {
                    if(blnAddInsteadOfReplace)
                    {
                        oForChapterAndLine.Groups.push(nGroup)
                    }
                    else 
                    {
                        oForChapterAndLine.Groups = [nGroup]
                    }
                }
            }
        }

        this.SaveDevelopmentRepetitionGroupsByChapter(this.state.listDevelopmentRepetitionGroupsByChapter)
    }

    RemoveDevelopmentRepetitionGroupFromLine(nLine, nGroupToRemove, sChapter)
    {
        var oForChapterAndLine = this.state.listDevelopmentRepetitionGroupsByChapter.find(o => o.Chapter === sChapter && o.LineIndex === nLine)
        if(oForChapterAndLine != undefined)
        {
            var nIndexToRemove = oForChapterAndLine.Groups.findIndex(nGroup => nGroup === nGroupToRemove)
            if(nIndexToRemove > -1)
            {
                oForChapterAndLine.Groups.splice(nIndexToRemove, 1)
                this.SaveDevelopmentRepetitionGroupsByChapter(this.state.listDevelopmentRepetitionGroupsByChapter)
            }
        }
    }

    DrawTextLines(oLineGroup)
    {
        // 15973
        // 16223
        // 16473
        // 16723
        // 16984

        var listLinesToDraw = oLineGroup.Lines

        // var listVersesInChapter = [...new Set(this.listTextWordsForChapter.map(w => w.Verse))].sort()
        var dictLinesByVerse = new Map()
        var sLineBreakUnit = this.state.sGroupLinesBy
        
        if(this.state.blnTextUnitSideBySideMode && this.state.blnSubunitBreaksInSideBySideMode)
        {
            //since the current unit shows the breaks via side by side columns, show a bonus level of breaks inside the units
            sLineBreakUnit = this.GetSubUnitForTextUnit(sLineBreakUnit)
            
            // var listUnitTypes = ['StartsCluster', 'StartsClusterGroup', 'StartsLevel4Group']
            // var nCurrentOne = listUnitTypes.indexOf(sLineBreakUnit)

            // if(nCurrentOne > 0)
            // {
            //     sLineBreakUnit = listUnitTypes[nCurrentOne - 1]
            // }
        }
        
        // listVersesInChapter.forEach(s => dictLinesByVerse.set(s, this.state.listLines.filter(l => l.Words.length > 0 && l.Words[0].Verse === s)))
        
        return <div style={this.blnChapterIsHebrew ? {display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px', 
            width: !this.state.blnTextUnitSideBySideMode ? '100%' : 
            this.state.blnShowHebrew && this.state.blnShowInterlinear && this.state.blnShowTransliteration ? '33%' : 
            this.state.blnShowHebrew && (this.state.blnShowInterlinear || this.state.blnShowTransliteration || this.state.blnShowOurTranslation) ? '33%' : 
            (!this.state.blnShowHebrew && (this.state.blnShowInterlinear && this.state.blnShowTransliteration)) ? '33%' : 
            '20%'} :

            {display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px'}}>

        <table style={this.blnChapterIsHebrew ? {paddingRight: "20px", display: "inline-block", borderCollapse: "collapse"} :
            {width: '50%', display: "inline-block", borderCollapse: "collapse"}}>
            {/* <tr><th></th><th></th>
            <th title={this.TagCheckboxesShouldBeDisabled() ? "" : "Starts Repetition Group"}>{!this.TagCheckboxesShouldBeDisabled() && "R"}</th>
            <th title={this.TagCheckboxesShouldBeDisabled() ? "" : "Starts Repetition Group Cluster"}>{!this.TagCheckboxesShouldBeDisabled() && "C"}</th>	
			<th title={this.TagCheckboxesShouldBeDisabled() ? "" : "Starts Repetition Group Cluster Group"}>{!this.TagCheckboxesShouldBeDisabled() && "G"}</th>	
            <th>{(this.state.blnShowLineRelationships || this.state.nSelectedToolID === this.nLineRelationshipsToolID) && "To Previous"}</th>
            <th>{(this.state.blnShowLineRelationships || this.state.nSelectedToolID === this.nLineRelationshipsToolID) && "To Next"}</th></tr> */}
            {/* <th></th> */}
            {listLinesToDraw.map((line, nLineIndex) => {
                if(this.blnDevView && this.state.blnShowEnglishVersion)
                {
                    var sVerse = line.Words[0].Verse
                    var blnAddEnglishVersionColumn = (nLineIndex === 0 || (nLineIndex > 0 && listLinesToDraw[nLineIndex - 1].Words.length > 0 && listLinesToDraw[nLineIndex - 1].Words[0].Verse != sVerse))

                    var sEnglishVersion = ''
                    if(blnAddEnglishVersionColumn)
                    {
                        var listLinesForVerse = dictLinesByVerse.get(sVerse)
                        var nLinesInThisVerse = listLinesForVerse === undefined ? 0 : dictLinesByVerse.get(sVerse).length

                        var oEnglishVersion = this.listVersesForEnglishVersionOnlyForDevForCurrentBook.find(av => av.Verse === sVerse)
                        if(oEnglishVersion != undefined) sEnglishVersion = oEnglishVersion.VerseText
                    }
                }

                return <>
                {!this.state.blnShowSVGLineLinks && this.BreakBeforeLine(line, nLineIndex, sLineBreakUnit) && <tr><td colSpan={10} style={{userSelect: "none"}}>&nbsp;</td></tr>}

                <tr>
                    						
                {this.state.blnShowHebrew && <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left'}}>
                    {/* {line.HadRangeGap == true && <span style={{backgroundColor: "red"}}>&nbsp;&nbsp;&nbsp;</span>} */}
                    {Array(parseInt(line.IndentLevel) * this.nSpacesPerLineIndent).fill(<span>&nbsp;</span>)}				
                    {this.GetSpansForWords(line.Words, false, true, false, false)}
                </td>}
            
                {this.state.blnShowTransliteration && <td style={{paddingLeft: "20px", textAlign:"left", minWidth: "50px"}}>
                    {this.state.blnShowTransliteration && Array(parseInt(line.IndentLevel) * this.nSpacesPerLineIndent).fill(<span>&nbsp;</span>)}				
                    {this.state.blnShowTransliteration && 
                        this.GetSpansForWords(line.Words, false, true, false, true)}
                </td>}
            
                <td style={{paddingLeft: "5px", userSelect: "none"}}>
                    {this.state.blnShowVerseNumbers && this.listVerseBeginNumbersAndWords != undefined && 
                    (!this.listVerseBeginNumbersAndWords.some(r => line.Words.includes(r.Word)) ? '' :
                        this.listVerseBeginNumbersAndWords.find(r => line.Words.includes(r.Word)).VerseNumber)}
                </td>

                {/* <td style={{paddingLeft: "5px", userSelect: "none"}}>
                    {nLineIndex}
                </td> */}

                <td style={{paddingLeft: "5px", userSelect: "none"}}>
                    {this.state.blnShowSyllableCounts && line.SyllableCount}
                </td>
                
                {/* {this.blnDevView &&
                <>
                <td style={{paddingLeft: "5px"}}>
                    {this.state.blnShowSyllableCounts && line.Words.reduce((acc, w) => acc + parseInt(w.SyllableCount), 0)}
                </td>
                
                <td style={{paddingLeft: "5px"}}>
                    {this.state.blnShowSyllableCounts && line.Words.length}
                </td>

                <td style={{paddingLeft: "5px"}}>
                    {this.state.blnShowPGroupOrder && line.PGroupOrder}
                </td>
                </>} */}

                {!this.TagCheckboxesShouldBeDisabled() &&					
                <>
                <td style={{paddingLeft: "0px"}} title='Unit Level 1'>
                    <Checkbox style={{marginLeft:"0px"}} onChange={(event) => this.UpdateLineField(line, "StartsRepetitionGroup", event.target.checked)} checked={line.StartsRepetitionGroup == true} />
                </td>
            
                <td style={{paddingLeft: "0px"}} title='Unit Level 2'>
                    <Checkbox style={{marginLeft:"0px"}} disabled={line.StartsRepetitionGroup != true} onChange={(event) => this.UpdateLineField(line, "StartsCluster", event.target.checked)} checked={line.StartsCluster == true} />
                </td>

				<td style={{paddingLeft: "0px"}} title='Unit Level 3'>
                    <Checkbox style={{marginLeft:"0px"}} disabled={line.StartsCluster != true} onChange={(event) => this.UpdateLineField(line, "StartsClusterGroup", event.target.checked)} checked={line.StartsClusterGroup == true} />
                </td>

                <td style={{paddingLeft: "0px"}} title='Unit Level 4'>
                    <Checkbox style={{marginLeft:"0px"}} disabled={line.StartsClusterGroup != true} onChange={(event) => this.UpdateLineField(line, "StartsLevel4Group", event.target.checked)} checked={line.StartsLevel4Group == true} />
                </td>

                <td style={{paddingLeft: "10px"}} title='Is Short Change From Pattern'>
                    <Checkbox style={{marginLeft:"0px"}} onChange={(event) => this.UpdateLineField(line, "IsShortChangeFromPattern", event.target.checked)} checked={line.IsShortChangeFromPattern == true} />
                </td>

                {this.blnShowSuperscriptionCheckbox && <td style={{paddingLeft: "10px"}} title='Is Superscription'>
                    <Checkbox style={{marginLeft:"0px"}} onChange={(event) => this.UpdateLineField(line, "IsSuperscription", event.target.checked)} checked={line.IsSuperscription == true} />
                </td>}

                {/* <td style={{paddingLeft: "5px"}}>
                    {this.state.blnShowLineGroupCheckboxes && 
                    <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.UpdateLineField(line, "NotInGroup", event.target.checked)} checked={line.NotInGroup == true} />}
                </td> */}

                {/* <td style={{paddingLeft: "5px"}}>
                    {this.state.blnShowLineGroupCheckboxes && 
                    <Checkbox style={{marginLeft:"15px"}} disabled={this.TagCheckboxesShouldBeDisabled()} onChange={(event) => this.UpdateLineField(line, "StartsSequenceGroup", event.target.checked)} checked={line.StartsSequenceGroup == true} />}
                </td> */}

                {/* <td style={{paddingLeft: "5px"}}>
                    {this.state.blnFigurativeLanguageCheckboxes && 
                    <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.UpdateLineField(line, "FigurativeLanguage", event.target.checked)} checked={line.FigurativeLanguage == true} />}
                </td> */}
                </>
                }

                {this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID && this.state.blnShowRepetitionLinkGroupLengthsDuringEditing &&
                    <td style={{paddingLeft: "5px"}}> 
                        {this.GetRepetitionGroupLinksForLine(line).map(g => 
                            <span style={{
                                borderStyle: this.state.listCurrentRepetitionLinkGroups != undefined && this.state.listCurrentRepetitionLinkGroups.includes(g) ? "solid" : "none",
                                borderColor: "black",
                                borderWidth: "1px",
                            }}
                            onMouseEnter={(event) => this.handleHoverRepetitionLinkGroup(g)}
                            onMouseLeave={(event) => this.handleHoverLeaveRepetitionLinkGroup(g)}
                            onClick={(event) => this.handleClickRepetitionLinkGroup(g, line)}>
                            {g.ListWords.length}&nbsp;</span>)}</td>
                }

                <td style={{paddingLeft: "10px"}}>
                    {this.state.nSelectedToolID === this.nLineRelationshipsToolID ?
                    
                    <Select
                    value={line.RelationshipToPrevious === null ? 0 : line.RelationshipToPrevious}
                    onChange={ (event) => this.UpdateLineField(line, "RelationshipToPrevious", event.target.value === 0 ? null : event.target.value) }
                    >
                    {this.listLineRelationships.map(r => <MenuItem value={r.ID}>{r.Desc}</MenuItem>)}
                    </Select> :
                    
                    !this.state.blnShowLineRelationships ? '' :
                    line.RelationshipToPrevious === null || line.RelationshipToPrevious == 0 ||
                    this.listLineRelationships.find(r => r.ID === line.RelationshipToPrevious) === undefined ? '' : 
                    this.listLineRelationships.find(r => r.ID === line.RelationshipToPrevious).Desc}
                </td>
                <td style={{paddingLeft: "10px"}}>
                    {this.state.nSelectedToolID === this.nLineRelationshipsToolID ?
                    
                    <Select
                    value={line.RelationshipToNext === null ? 0 : line.RelationshipToNext}
                    onChange={ (event) => this.UpdateLineField(line, "RelationshipToNext", event.target.value === 0 ? null : event.target.value) }
                    >
                    {this.listLineRelationships.map(r => <MenuItem value={r.ID}>{r.Desc}</MenuItem>)}
                    </Select> :
                    
                    !this.state.blnShowLineRelationships ? '' :
                    line.RelationshipToNext === null || line.RelationshipToNext == 0 ||
                    this.listLineRelationships.find(r => r.ID === line.RelationshipToNext) === undefined ? '' : 
                    this.listLineRelationships.find(r => r.ID === line.RelationshipToNext).Desc}
                </td>

                {blnAddEnglishVersionColumn && <td rowspan={nLinesInThisVerse} 
                    style={{paddingLeft: "5px", paddingRight: "5px", maxWidth: "250px", fontFamily: "Calibri", fontSize: "18px"}}>{sEnglishVersion}</td>}

                {this.state.blnShowInterlinear && <td style={{textAlign:"left", minWidth: "50px"}} 
                    onClick={(event) => {
                        if(!this.state.blnShowGlossesInsteadOfTranslation && !line.InTranslationEditMode) this.UpdateLineField(line, "InTranslationEditMode", true)}}>
                    {this.state.blnShowTranslation && Array(parseInt(line.IndentLevel) * this.nSpacesPerLineIndent).fill(<span>&nbsp;</span>)}				
                    {this.state.blnShowTranslation && (
                        line.InTranslationEditMode ? 

                        <input type="text" variant="outlined" size={40} autoFocus 
                            defaultValue={this.MergeTranslationsForEdit(line.Words)}
                            onKeyDown={(event) => {
                                if(event.key === "Enter") 
                                {
                                    this.SplitAndSaveEditedTranslation(line.Words, event.target.value);
                                    this.UpdateLineField(line, "InTranslationEditMode", false);
                                }}}
                        /> :

                        this.GetSpansForWords(line.Words, !this.state.blnShowGlossesInsteadOfTranslation, true, this.state.blnShowGlossesInsteadOfTranslation, false))}
                </td>}

                {this.state.blnShowOurTranslation && <td style={{textAlign:"left", minWidth: "50px", paddingBottom: this.state.blnShowHebrew ? '0px' : '8px'}}>
                    {this.GetSpansForTranslationOfLine(nLineIndex + oLineGroup.AbsoluteIndexOfFirstLineInGroup, line)}</td>}

                {this.state.blnShowThematicStatementsInline && <td style={{textAlign:"left", minWidth: "50px"}}>{
                    [...new Set(line.Words.filter(w => w.ThematicStatementIDs != undefined).flatMap(w => w.ThematicStatementIDs.map(nOtsID => this.listThematicStatements.find(ots => ots.ID === nOtsID).Name)))]
                    .map(s => <div>{s}</div>)
                }</td>}
                {/* {nLineIndex === 0 && <td style={{textAlign:"left", paddingLeft: "10px"}} rowspan="0">{this.DrawSemanticOutline()}</td>} */}
            </tr>

            {this.state.blnShowSVGLineLinks && 
            <tr><td style={{textAlign:  this.blnChapterIsHebrew ? 'right' : 'left', padding: "0px"}}>{this.GetLinkLinesToShow(line, 'hebrew', this.state.blnBreakAfterRepetitionGroupEnd && this.LineIsLastInItsRepetitionGroup(line))}</td>
                <td colSpan={this.TagCheckboxesShouldBeDisabled() ? 6 : 10}>&nbsp;</td>
                {/* <td style={{textAlign: "left", padding: "0px"}}><svg style={{verticalAlign: "top"}} height={20} width={100} /></td> */}
                <td style={{textAlign: "left", padding: "0px"}}>{this.GetLinkLinesToShow(line, 'translation', this.state.blnBreakAfterRepetitionGroupEnd && this.LineIsLastInItsRepetitionGroup(line))}</td>
            </tr>}
            </>})}
        </table>

        {this.state.blnShowTranslationEditBox && this.DrawTranslationEditBox(listLinesToDraw.length)}

        </div>
    }

    getCurrentLineIndexInTextArea(textarea) 
    {
        // Get the text content from the start of the textarea up to the cursor's position
        const textBeforeCursor = textarea.value.substr(0, textarea.selectionStart);
        
        // Split that substring by newline characters ('\n')
        const lines = textBeforeCursor.split('\n')
        return lines.length - 1
    }

    DrawTranslationEditBox(nRows)
    {
        return <>
        <textarea rows={nRows} ref={this.notesTextRef} cols="30" style={{verticalAlign:"top", fontFamily: "Calibri", fontSize: "20px"}}
        onFocus={(e) => this.setState({blnTranslationEditBoxHasFocus: true})}
        onBlur={(e) => {
            this.setState({sFromNotesBox: e.target.value})
            this.setState({blnTranslationEditBoxHasFocus: false})
        }} 
        // onKeyDown={(e) => {
        //     const textarea = this.notesTextRef.current
        //     if (!textarea) return
            
        //     if(e.key !== ' ' && e.key !== '.' && isFinite(e.key))
        //     {
        //         const nWordIndex = e.key === '0' ? 9 : (parseInt(e.key) - 1)
        //         const nLineIndex = this.getCurrentLineIndexInTextArea(textarea)
        //         if(nWordIndex >= this.state.listLines[nLineIndex].Words.length) return

        //         let w = this.state.listLines[nLineIndex].Words[nWordIndex]
                
        //         e.preventDefault()
        //         textarea.setRangeText(w.SyllableObjects.map(o => o.syllable).join('').replaceAll('*', '').replaceAll('|', '').replaceAll('^', '') + nWordIndex + ' ', textarea.selectionStart, textarea.selectionEnd, 'end')
        //     }
        // }}
        />
        {/* {window.location.hostname.includes("localhost") && <Button variant="contained" onClick={() => this.AddTranslationFromNotesBox()}>Add as Translation</Button>} */}
        </>
    }

    AddTranslationFromNotesBox()
    {
        var listLinesFromNotesBox = this.state.sFromNotesBox.split('\n').filter(s => s.length > 0).map(s => s.trim())
        var sCurrentChapter = this.GetFirstCurrentChapter().toString()
        var listTranslationLinesToSet = this.state.listOurTranslationLines

        if(listLinesFromNotesBox.length != this.state.listLines.length)
        {
            window.alert('the number of translations lines (' + listLinesFromNotesBox.length.toString() + 
                ') is not equal to the number of lines (' + this.state.listLines.length.toString() + ') in the original')
            return
        }
        else if(listTranslationLinesToSet.some(o => o.Chapter === sCurrentChapter))
        {
            if(!window.confirm("This will remove the current translation lines and links. Are you sure you want to do that?"))
            {
                return
            }

            listTranslationLinesToSet = listTranslationLinesToSet.filter(o => o.Chapter != sCurrentChapter)
            this.setState({listTranslationWordIndexLinks: this.state.listTranslationWordIndexLinks.filter(o => o.Chapter != sCurrentChapter)})
        }

        //{Chapter: '4', LineIndex: 5, Translation: ''}
        listTranslationLinesToSet = listTranslationLinesToSet.concat(listLinesFromNotesBox
            .map((sLine, nLine) => ({Chapter: sCurrentChapter, LineIndex: nLine, Translation: sLine})))

        this.SaveOurTranslationLines(listTranslationLinesToSet)
    }

    DrawVerses()
    {
        var listVersesInChapter = [...new Set(this.listTextWordsForChapter.map(w => parseInt(w.Verse)))].sort((a,b) => a - b)
        var listVersesToDraw = listVersesInChapter.map(nVerse => nVerse.toString()).map(sVerse => ({Verse: sVerse, Words: this.listTextWordsForChapter.filter(w => w.Verse === sVerse)}))

        return <div style={this.blnChapterIsHebrew ? {display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px', 
            width: '100%'} : 
            // this.state.blnShowHebrew && this.state.blnShowInterlinear && this.state.blnShowTransliteration ? '33%' : 
            // this.state.blnShowHebrew && (this.state.blnShowInterlinear || this.state.blnShowTransliteration) ? '33%' : 
            // (!this.state.blnShowHebrew && (this.state.blnShowInterlinear && this.state.blnShowTransliteration)) ? '33%' : 
            // '20%'} :

            {display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px'}}>

        <table style={this.blnChapterIsHebrew ? {paddingRight: "20px", display: "inline-block", borderCollapse: "collapse"} :
            {width: '50%', display: "inline-block", borderCollapse: "collapse"}}>
            {listVersesToDraw.map((verse, nVerseIndex) => {
                return <>
                <tr>						
                {this.state.blnShowHebrew && <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left'}}>				
                    {this.GetSpansForWords(verse.Words, false, true, false, false)}
                </td>}
            
                <td style={{paddingLeft: "8px", paddingRight: "8px", userSelect: "none"}}>
                    {this.state.blnShowVerseNumbers && verse.Verse}
                    {/* {this.state.blnShowVerseNumbers && this.listVerseBeginNumbersAndWords != undefined && 
                    (!this.listVerseBeginNumbersAndWords.some(r => verse.Words.includes(r.Word)) ? '' :
                        this.listVerseBeginNumbersAndWords.find(r => verse.Words.includes(r.Word)).VerseNumber)} */}
                </td>

                {this.state.blnShowTransliteration && <td style={{textAlign:"left", minWidth: "50px"}}>				
                    {this.GetSpansForWords(verse.Words, false, true, false, true)}
                </td>}

                {this.state.blnShowInterlinear && <td style={{textAlign:"left", minWidth: "50px"}}>				
                    {this.state.blnShowTranslation && this.GetSpansForWords(verse.Words, !this.state.blnShowGlossesInsteadOfTranslation, true, this.state.blnShowGlossesInsteadOfTranslation, false)}
                </td>}

                {/* this.GetOurTranslationForWord() */}
                {this.state.blnShowBSB && <td style={{textAlign:"left", minWidth: "50px", fontFamily: "Calibri", fontSize: "18px"}}>		
                    {this.GetSpansForBSB(this.listThematicStatementIDsByVerse.filter(ots => ots.Book === parseInt(verse.Words[0].Book) && 
                        ots.Chapter === parseInt(verse.Words[0].Chapter) && ots.Verse === parseInt(verse.Words[0].Verse))
                        .flatMap(ots => ots.Text), verse.Words)}
                </td>}

                {this.state.blnShowThematicStatementsInline && <td style={{textAlign:"left", minWidth: "50px"}}>{
                    [...new Set(verse.Words.filter(w => w.ThematicStatementIDs != undefined).flatMap(w => w.ThematicStatementIDs.map(nOtsID => this.listThematicStatements.find(ots => ots.ID === nOtsID).Name)))]
                    .map(s => <div>{s}</div>)
                }</td>}
            </tr>
            </>})}
        </table>
        </div>
    }

    GetBookNameForID(nID)
    {
        var sName = this.dictBookNamesByIndex.get(nID)
        var blnStartsWithNumber = !isNaN(sName[0])

        return blnStartsWithNumber ? (sName.slice(0,2).toUpperCase() + sName.slice(2).toLowerCase()) :
            (sName[0].toUpperCase() + sName.slice(1).toLowerCase())
    }

    FilterForThematicSearch(l, sSomeOrEverySearchCriteriaIsInList)
    {
        if(sSomeOrEverySearchCriteriaIsInList === 'some')
        {
            return l.filter(o => this.state.listThematicStatementsSelectedForSearch.some(o2 => o.IDs.includes(o2.ID) || 
                (o2.C != undefined && o2.C.some(nChildID => o.IDs.includes(nChildID)))))
        }
        else
        {
            return l.filter(o => this.state.listThematicStatementsSelectedForSearch.every(o2 => o.IDs.includes(o2.ID) || 
                (o2.C != undefined && o2.C.some(nChildID => o.IDs.includes(nChildID)))))
        }
    }

    DrawSearchResults()
    {
        var listThematicStatementIDsByVerseMatchingFinal = []

        var nVerseWindowLength = this.state.nMaxDistanceInVersesBetweenMultipleTagsSearched
        if(nVerseWindowLength === 0 || this.state.listThematicStatementsSelectedForSearch.length === 1)
        {
            listThematicStatementIDsByVerseMatchingFinal = this.FilterForThematicSearch(this.listThematicStatementIDsByVerse, 'every')
                .map(o => ({VerseRef: this.GetBookNameForID(o.Book) + ' ' + o.Chapter + ':' + o.Verse, Text: o.Text, IDs: o.IDs}))
        }
        else
        {
            //from a list of any possible matches, go result by result to see if all the criteria are present
            //within the user selected window of verses
            //for now, limit to the same chapter

            var listThematicStatementIDsByVerseMatching1 = this.FilterForThematicSearch(this.listThematicStatementIDsByVerse, 'some')
            for(var n = 0; n < listThematicStatementIDsByVerseMatching1.length; n++)
            {
                var nBook = listThematicStatementIDsByVerseMatching1[n].Book
                var nChapter = listThematicStatementIDsByVerseMatching1[n].Chapter
                var sBookAndChapterRef = this.GetBookNameForID(nBook) + ' ' + nChapter + ':'

                var listResultsInWindow = listThematicStatementIDsByVerseMatching1.slice(n, n + nVerseWindowLength + 1)
                    .filter(o => o.Book === nBook && o.Chapter === nChapter)

                //check if every criteria is found in some result in the window
                if(this.state.listThematicStatementsSelectedForSearch.every(o2 => 
                    listResultsInWindow.some(o => o.IDs.includes(o2.ID) || 
                    (o2.C != undefined && o2.C.some(nChildID => o.IDs.includes(nChildID))))))
                {
                    listThematicStatementIDsByVerseMatchingFinal.push({
                        VerseRef: sBookAndChapterRef + listResultsInWindow.map(o => o.Verse).join(','), 
                        Text: listResultsInWindow.map(o => o.Text).join('...'),
                        IDs: [...new Set(listResultsInWindow.flatMap(o => o.IDs))]})

                    n += nVerseWindowLength + 1
                }
            }
        }

        return <div style={{display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px', fontFamily: "Calibri", fontSize: "18px"}}>
            <table style={{width: '70%', textAlign:"left", display: "inline-block", borderCollapse: "separate", borderSpacing: "0 0.3em"}}>
                {listThematicStatementIDsByVerseMatchingFinal.map(o => {
                    return <tr style={{paddingBottom:"10px"}} title={[...new Set(o.IDs.flatMap(nOtsID => this.listThematicStatements.filter(ots => ots.ID === nOtsID).map(ots => ots.Name)))].join('; ')}>
                        <td style={{width: '10%'}}>{o.VerseRef}</td>
                        <td>{o.Text}</td>
                        {/* {<td style={{textAlign:"left"}}>{
                            [...new Set(o.IDs.map(nOtsID => this.listThematicStatements.find(ots => ots.ID === nOtsID).Name))]
                            .map(s => <div>{s}</div>)
                        }</td>} */}
                    </tr>})}
            </table>
        </div>
    }

    // FilterForSearchAndTag(l, sSomeOrEverySearchCriteriaIsInList, listSearchTerms)
    // {
    //     //console.log(l.filter(o => o.Lemmas === undefined), listSearchTerms)
    //     if(sSomeOrEverySearchCriteriaIsInList === 'some')
    //     {
    //         return l.filter(o => listSearchTerms.some(s => o.Lemmas.includes(s)))
    //     }
    //     else
    //     {
    //         return l.filter(o => listSearchTerms.every(s => o.Lemmas.includes(s)))
    //     }
    // }

    GetSpansForSearchAndTag(oVerse, nWordIndexToHighlight, oContext)
    {
        return <>
        {oContext.Before.length > 0 && <div class="TextWordDiv" style={{fontFamily: "Calibri", color: 'Black', marginBottom: '10px'}}>{oContext.Before}</div>}

        <div>
        {oVerse.Words.map((sWordToShow, nWordIndex) => {
            var sLemma = oVerse.Lemmas[nWordIndex]

            return <span class="TextWordDiv"
            style={{ 
                fontFamily: "Calibri", 
                fontWeight: nWordIndex === nWordIndexToHighlight ? "bold" : "normal",

                color: (this.state.blnHighlightBasicMaybeAttributeWordsInSearchAndTag && this.listBasicMaybeAttributeWords.includes(sLemma)) ||
                    (this.state.blnHighlightMaybeAttributeWordsInSearchAndTag && this.listMaybeAttributeWords.includes(sLemma)) ||
                    this.GetSearchAndTagMatchTerms().some(lst => !lst.Negative && lst.Term === sLemma) ? 'Blue' : 'Black', 

                borderStyle: "none", //blnWordIsOutlined && !this.AllSimilarityLensIsEnabled() ? "dotted" : "none", //dashed, dotted, inset, solid
                
                display: 'inline-block',
                // borderColor: (this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ? "red" :
                //     (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word)) ? "red" : 	
                //     (this.state.listWordsHoveredWhileDragging === undefined && this.DoesSelectedCurrentRepetitionLinkGroupIncludeWord(word) && this.GetRepetitionLinkGroupsContainingWord(word).length > 1) ? "blue" :		
                //     !this.state.listGraphTextIndicesToHighlight.some(gti => listTextIndexes.includes(gti.TextIndex) && gti.BorderColor != undefined) ? "black" :
                //     this.state.listGraphTextIndicesToHighlight.find(gti => listTextIndexes.includes(gti.TextIndex)).BorderColor,
                    
                // borderWidth:((this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ||
                //     (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word))) ? "4px" : "1px",

                fontSize: "18px"
                // userSelect: "none"  
            }}>

                {sWordToShow}
                {!oVerse.SpaceAfterWord[nWordIndex] ? '' : <span>&nbsp;</span>}
            </span>
        })}
        </div>

        {oContext.After.length > 0 && <div class="TextWordDiv" style={{fontFamily: "Calibri", color: 'Black', marginTop: '10px'}}>{oContext.After}</div>}
        </>
    }

    GetBSBVerseContext(oVerse)
    {
        var nVerses = this.state.nSearchAndTagVerseContextVersesBeforeAndAfter
        var nCurrentVerse = this.listBSBTextByVerse.findIndex(o => o.ID === oVerse.ID)

        return {
            Before: this.listBSBTextByVerse.slice(nCurrentVerse - nVerses, nCurrentVerse).map(o => o.Text).join(' '), 
            After: this.listBSBTextByVerse.slice(nCurrentVerse + 1, nCurrentVerse + nVerses).map(o => o.Text).join(' ')
        }
    }

    GetSelectedSemanticGroupForSearchAndTag()
    {
        return this.listSemanticGroupsForSearchAndTag.filter(o => this.state.listSemanticGroupsForSearchAndTagSelectedForTagging.includes(o.BSG))[0]
    }

    GetSearchAndTagMatchTerms()
    {
        return this.state.sSearchAndTagMatchFilterByLemma.length === 0 ? [] : 
            this.state.sSearchAndTagMatchFilterByLemma.split(' ').map(s => 
                ({Term: s.replace('!', '').replace('#', '').replace('@', '').replace('=', '').replaceAll('_', ' ').replaceAll('"', ''), 
                Negative: s.startsWith('!'), InTags: s.includes('#'), InTagAttributes: s.includes('@'), 
                ExactMatch: s.includes('"'), MatchWordBeingTaggedInResult: s.startsWith('=')}))
    }

    GetSearchAndTagMatchResults()
    {       
        var oSelectedSemanticGroup = this.GetSelectedSemanticGroupForSearchAndTag()
        if(oSelectedSemanticGroup === undefined) return []

        var listSearchTerms = this.GetSearchAndTagMatchTerms()

        //console.log(listSearchTerms)

        //tag desc
        var listTagFilters = listSearchTerms.filter(lst => lst.InTags)
        var blnTagFiltersPresent = listTagFilters.length > 0

        var listTagIDsPassing = !blnTagFiltersPresent ? [] : 
            listTagFilters[0].Term === 'none' ? [0] :
            this.state.listTagInventory.filter(t => listTagFilters.every(lst => lst.ExactMatch ? t.Desc === lst.Term : t.Desc.includes(lst.Term))).map(t => t.ID)

        var listMatchIDsForTagFilters = !blnTagFiltersPresent ? [] : this.state.listTagsForMatchesInSemanticGroups.filter(o => 
            o.Tags.some(t => listTagIDsPassing.includes(t.ID))).map(o => o.MatchID)

        //console.log(listSearchTerms, listTagIDsPassing, listMatchIDsForTagFilters.filter(s => s.startsWith('Genesis_14_15')))

        //tag attribute desc
        var listTagAttributeFilters = listSearchTerms.filter(lst => lst.InTagAttributes)
        var blnTagAttributeFiltersPresent = listTagAttributeFilters.length > 0

        var listTagAttributeIDsPassing = !blnTagAttributeFiltersPresent ? [] : 
            this.listTagAttributes.filter(ta => listTagAttributeFilters.every(lst => lst.ExactMatch ? ta.Desc === lst.Term : ta.Desc.includes(lst.Term))).map(t => t.ID)

        var listMatchIDsForTagAttributeFilters = !blnTagAttributeFiltersPresent ? [] : this.state.listTagsForMatchesInSemanticGroups.filter(o => 
            o.Tags.some(t => t.Attributes.some(ta => listTagAttributeIDsPassing.includes(ta)))).map(o => o.MatchID)

        return oSelectedSemanticGroup.Matches.filter(o => {
            if(blnTagFiltersPresent && !listMatchIDsForTagFilters.includes(o.ID)) return false
            if(blnTagAttributeFiltersPresent && !listMatchIDsForTagAttributeFilters.includes(o.ID)) return false

            var oVerse = this.dictBSBTextByVerseByID.get(o.VerseID)

            return listSearchTerms.every(lst => {
                if(lst.InTags || lst.InTagAttributes)
                {
                    //already checked for these all together above, for efficiency
                    return true
                }
                else
                {
                    return (!lst.Negative && ((lst.MatchWordBeingTaggedInResult && oVerse.Lemmas[o.BSBWordIndex] === lst.Term) || 
                            (!lst.MatchWordBeingTaggedInResult && oVerse.Lemmas.some(sl => lst.Term === sl)))) || 
                        (lst.Negative && ((lst.MatchWordBeingTaggedInResult && oVerse.Lemmas[o.BSBWordIndex] != lst.Term) || 
                            (!lst.MatchWordBeingTaggedInResult && oVerse.Lemmas.every(sl => lst.Term !== sl))))
                }
            })
        })
    }

    GetNumberOfSearchAndTagResultBatches()
    {
        return Math.ceil(this.state.listCurrentSearchAndTagMatchResults.length / this.state.nSearchAndTagResultsBatchSize)
    }

    DrawTagEditingControls()
    {
        return <div>
            <input size='30' 
                onChange={(event) => {
                    this.setState({sTagEditingControlsDescFilter: event.target.value})
                }}
                onFocus={() => this.setState({blnEditTagBoxHasFocus: true})}
                onBlur={() => this.setState({blnEditTagBoxHasFocus: false})}/>

            {this.FilterTagInventoryBasedOnTyping(this.state.sTagEditingControlsDescFilter, true)
                //.filter(t => this.state.sTagEditingControlsDescFilter.length === 0 || t.Desc.toLowerCase().includes(this.state.sTagEditingControlsDescFilter))
                .map(t => {
                    var nIndexInUnfilteredInventory = this.state.listTagInventory.indexOf(t)

                    return <div>
                        <input size='30' value={t.Desc} 
                            onChange={(event) => {
                                this.state.listTagInventory[nIndexInUnfilteredInventory].Desc = event.target.value
                                this.SaveTagInventory(this.state.listTagInventory)
                            }}
                            onFocus={() => this.setState({blnEditTagBoxHasFocus: true})}
                            onBlur={() => this.setState({blnEditTagBoxHasFocus: false})}    
                        />
                        <input size='1' style={{marginLeft: '10px'}} value={t.Shortcut} 
                            onKeyDown={(event) => {
                                if(event.key >= '0' && event.key <= '9')
                                {
                                    this.state.listTagInventory[nIndexInUnfilteredInventory].Shortcut = event.key
                                    this.SaveTagInventory(this.state.listTagInventory)
                                }
                                // else if(event.key === 'Delete' || event.key === 'Backspace')
                                // {
                                //     this.state.listTagInventory[nIndexInUnfilteredInventory].Shortcut = ''
                                //     this.SaveTagInventory(this.state.listTagInventory)
                                // }
                            }}
                            onFocus={() => this.setState({blnEditTagBoxHasFocus: true})}
                            onBlur={() => this.setState({blnEditTagBoxHasFocus: false})}    
                        />

                        <input size='2' style={{marginLeft: '10px'}} value={t.SemanticGroupID} 
                            onChange={(event) => {
                                this.state.listTagInventory[nIndexInUnfilteredInventory].SemanticGroupID = parseInt(event.target.value)
                                this.SaveTagInventory(this.state.listTagInventory)
                            }}
                        />

                        <span style={{marginLeft: '10px'}} onClick={() => {
                            this.state.listTagInventory.splice(nIndexInUnfilteredInventory, 1)
                            this.SaveTagInventory(this.state.listTagInventory)
                        }}>Del</span>
                    </div>
                })
            }
        </div>
    }

    FilterTagInventoryBasedOnTyping(sFilter, blnReturnAllForEmptyFilter)
    {
        //var oSelectedSemanticGroup = this.state.oSelectedSemanticGroupForTagInventory //this.GetSelectedSemanticGroupForSearchAndTag()
        if(sFilter === '' && !blnReturnAllForEmptyFilter) return []

        if(this.state.listSelectedSemanticGroupsForTagInventory.length === 0 && this.state.blnOnlyUseTagInventoryForCurrentSemanticGroup) return []
        var listSelectedSemanticGroupIDs = this.listSemanticGroupsForSearchAndTag.filter(o => this.state.listSelectedSemanticGroupsForTagInventory.includes(o.BSG)).map(o => o.ID)

        var listFilter1 = this.state.listTagInventory.filter(o => 
            (!this.state.blnOnlyUseTagInventoryForCurrentSemanticGroup || listSelectedSemanticGroupIDs.includes(o.SemanticGroupID)))

        if(sFilter === '' && blnReturnAllForEmptyFilter)
        {
            return listFilter1
        }
        else
        {
            return listFilter1.filter(o => o.Desc.toLowerCase().includes(sFilter))
        }
    }

    DrawTagThingsForCurrentTyping()
    {
        if(this.state.blnNewTagInputIsVisible)
        {
            return <span style={{marginTop: '10px', borderStyle: 'solid'}}>{this.state.sSearchAndTagInventoryFilter}</span>
        }
        else
        {
            var listTagsMatchingCurrentTyping = this.state.sSearchAndTagInventoryFilter.length === 0 ? [] :
                this.FilterTagInventoryBasedOnTyping(this.state.sSearchAndTagInventoryFilter, false)

            if(listTagsMatchingCurrentTyping.length > 0 && listTagsMatchingCurrentTyping.length <= this.state.nMaxCurrentTypingMatchesForResultsToBeShown)
            {
                // blnOnlyUseTagInventoryForCurrentSemanticGroup: false,
                // nTagShortcutBatchNumber: 0,
                // nTagShortcutBatchSize: 5,
                //789 789 
                var nCurrentShortcutBatchStart = this.state.nTagShortcutBatchNumber * this.state.nTagShortcutBatchSize
                return <div style={{marginTop: '10px'}}>
                    {listTagsMatchingCurrentTyping.map((t,nt) => {
                        return <div>{t.Desc + (((nt - nCurrentShortcutBatchStart) < 0 ||
                            (nt + this.nStartNumberForTagSearchAndSelect - nCurrentShortcutBatchStart) >= 10) ? '' : 
                            ' ' + (nt + this.nStartNumberForTagSearchAndSelect - nCurrentShortcutBatchStart))}</div>
                    })}
                </div>
            }
            else
            {
                return <span style={{marginTop: '10px'}}>{this.state.sSearchAndTagInventoryFilter}</span>
            }
        }
    }

    AddTagForCurrentlySelectedSemanticGroup(sNewTags)
    {
        //return the ID for the last tag added from this string
        //(multiple tags can be added if separated by semicolon)

        //{"NewID":1,"OldID":1,"SemanticGroupID":52,"Desc":"trusting/believing in God","Shortcut":"1"}
        //{"SemanticGroupID":283,"MatchID":"Jeremiah_34_13_15","Tags":[{"ID":22,"Attributes":[],"OldID":22}]}
        
        var oSelectedSemanticGroup = this.GetSelectedSemanticGroupForSearchAndTag()
        if(oSelectedSemanticGroup === undefined) return

        var nNextID = this.state.listTagInventory.length === 0 ? 1 : 
            (Math.max(...this.state.listTagInventory.map(o => o.ID)) + 1)

        for(var s of sNewTags.split(';'))
        {
            var sToAdd = s.trim()
            if(sToAdd != '' && !this.state.listTagInventory.some(t => t.Desc === sToAdd))
            {
                //console.log(sToAdd)
                this.state.listTagInventory.push({"ID": nNextID, "Desc": sToAdd, "SemanticGroupID": oSelectedSemanticGroup.ID})
                nNextID += 1
            }
        }
        
        this.SaveTagInventory(this.state.listTagInventory)

        return nNextID - 1
    }
    
    DrawSearchAndTagResults()
    {
        // var listSearchTerms = this.state.sSearchAndTagText.split(' ')
        // var listSearchDataMatchingFinal = []

        // var nVerseWindowLength = this.state.nMaxDistanceInVersesBetweenMultipleSearchAndTagsSearched
        // if(nVerseWindowLength === 0 || this.state.listThematicStatementsSelectedForSearch.length === 1)
        // {
        //     listSearchDataMatchingFinal = this.FilterForSearchAndTag(this.listSearchDataForWholeBible, 'every', listSearchTerms)
        //         .map(o => ({VerseRef: o.VerseRef, Text: o.Text}))
        // }
        // else
        // {
        //     //from a list of any possible matches, go result by result to see if all the criteria are present
        //     //within the user selected window of verses
        //     //for now, limit to the same chapter

        //     var listSearchDataMatching1 = this.FilterForSearchAndTag(this.listSearchDataForWholeBible, 'some', listSearchTerms)
        //     for(var n = 0; n < listSearchDataMatching1.length; n++)
        //     {
        //         var sBookAndChapter = listSearchDataMatching1[n].BookAndChapter

        //         var listResultsInWindow = listSearchDataMatching1.slice(n, n + nVerseWindowLength + 1)
        //             .filter(o => o.BookAndChapter === sBookAndChapter)

        //         //check if every criteria is found in some result in the window
        //         if(listSearchTerms.every(s => listResultsInWindow.some(o => o.Lemmas.includes(s))))
        //         {
        //             listSearchDataMatchingFinal.push({
        //                 VerseRef: listResultsInWindow.map(o => o.VerseRef).join(','), 
        //                 Text: listResultsInWindow.map(o => o.Text).join('...')})

        //             n += nVerseWindowLength + 1
        //         }
        //     }
        // }

        // this.listBSBTextByVerse
        // this.listSemanticGroupsForSearchAndTag

        //{"ID": 63, "Desc": ""}
        //{SemanticGroupID: 1, TagList: [63]}
        //{SemanticGroupID: 1, MatchID: 1, Tags: [{ID: 3, Attributes: ['n']}, {ID: 1, Attributes: ['c']}]}

        var nBatchStartIndex = this.state.nSearchAndTagResultsCurrentBatchIndex * this.state.nSearchAndTagResultsBatchSize

        return <div style={{display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px', fontFamily: "Calibri", fontSize: "18px"}}>
            <table style={{width: '70%', textAlign:"left", display: "inline-block", borderCollapse: "separate", borderSpacing: "0 0.3em"}}>
                {this.state.listCurrentSearchAndTagMatchResults.slice(nBatchStartIndex, nBatchStartIndex + this.state.nSearchAndTagResultsBatchSize).map(o => {
                    var nIndexToUse1 = this.state.listTagsForMatchesInSemanticGroups.findIndex(o2 => o2.MatchID === o.ID)
                    
                    var oVerse = this.dictBSBTextByVerseByID.get(o.VerseID)
                    var blnContext = this.state.listSearchAndTagMatchIndexesWithContext.includes(nIndexToUse1)
                    var oContext = blnContext ? this.GetBSBVerseContext(oVerse) : {Before: '', After: ''}

                    return <tr style={{paddingBottom:"10px"}} 
                        onMouseEnter={(event) => {
                            //if there is a new tag being edited in a match, don't change it until it is done
                            if(!(this.state.blnNewTagInputIsVisible && this.state.nCurrentTagIDForSearchAndTag > -1))
                            {
                                this.setState({nCurrentlyHoveredSearchAndTagMatchIndex: nIndexToUse1})
                                this.setState({sSearchAndTagInventoryFilter: ''})

                                if(this.state.nCurrentTagIDForSearchAndTag > -1)
                                {
                                    this.state.listTagsForMatchesInSemanticGroups[nIndexToUse1].Tags[this.state.nTagIndexBeingEditedForCurrentSearchAndTag].ID = this.state.nCurrentTagIDForSearchAndTag
                                    this.SaveMatchTags(this.state.listTagsForMatchesInSemanticGroups)
                                }
                            }
                        }}

                        onMouseLeave={(event) => {
                            if(!(this.state.blnNewTagInputIsVisible && this.state.nCurrentTagIDForSearchAndTag > -1))
                            {
                                this.setState({nCurrentlyHoveredSearchAndTagMatchIndex: -1})
                                this.setState({nTagIndexBeingEditedForCurrentSearchAndTag: 0})
                                this.setState({nTagShortcutBatchNumber: 0})
                            }
                        }}>

                        <td style={{width: '10%'}}>{oVerse.VerseRef}</td>
                        <td>
                            {this.state.nCurrentlyHoveredSearchAndTagMatchIndex === nIndexToUse1 && 
                             this.state.blnCurrentlyHoveredSearchAndTagMatchIndexInOriginalText ? 
                                <div style={{fontFamily: "SBL Hebrew", fontSize:"22px"}}>{oVerse.Original}</div> : 
                                this.GetSpansForSearchAndTag(oVerse, o.BSBWordIndex, oContext)}

                            {this.state.nCurrentlyHoveredSearchAndTagMatchIndex === nIndexToUse1 && this.DrawTagThingsForCurrentTyping()}                               
                        </td>
                        <td>
                            {this.state.listTagsForMatchesInSemanticGroups[nIndexToUse1].Tags.map((t, nt, arr) => {
                                var oTagInInventory = this.state.listTagInventory.find(ti => ti.ID === t.ID)

                                //console.log(this.state.listTagInventory, t, oTagInInventory)

                                return <div>
                                {/* <select style={{margin:"15px", borderStyle: this.state.nTagIndexBeingEditedForCurrentSearchAndTag === nt ? 'solid' : 'none'}}
                                    value={this.state.listTagsForMatchesInSemanticGroups[nIndexToUse1].Tags[nt].ID}
                                    // onKeyDown={(event) => { 
                                    //     if (event.key in this.dictTagOptionIndexByKey) 
                                    //     {
                                    //         const nOptionIndex = this.dictTagOptionIndexByKey[event.key]
                                    //         if(nOptionIndex < event.target.options.length) 
                                    //         {
                                    //             event.target.selectedIndex = nOptionIndex
                                    //             this.state.listTagsForMatchesInSemanticGroups[nIndexToUse1].Tags[nt].ID = event.target.value
                                    //             this.SaveMatchTags(this.state.listTagsForMatchesInSemanticGroups)
                                    //         }
                                    //         event.preventDefault()
                                    //     }
                                    // }}
                                    onChange={(event) => { 
                                        this.state.listTagsForMatchesInSemanticGroups[nIndexToUse1].Tags[nt].ID = parseInt(event.target.value)
                                        this.SaveMatchTags(this.state.listTagsForMatchesInSemanticGroups)
                                        }}>
                                        <option value={0}>None</option>
                                        {/* this.GetLetterForTagOptionNumber((nt2 + 1).toString()) */}
                                        {/* {this.state.listTagInventory.map((t2, nt2) => <option value={t2.ID}>
                                            {(t2.Shortcut === undefined || t2.Shortcut === '' ? '' : (t2.Shortcut + ' ')) + t2.Desc}
                                        </option>)} */}
                                {/* </div></select> */}
                                
                                    <div style={{margin:"15px", borderWidth: '1px', whiteSpace: "nowrap",
                                        borderStyle: arr.length > 1 && this.state.nCurrentlyHoveredSearchAndTagMatchIndex === nIndexToUse1 && 
                                        this.state.nTagIndexBeingEditedForCurrentSearchAndTag === nt ? 'solid' : 'none'}}>
                                        
                                        <div>
                                            {t.ID === 0 ? 'none' : oTagInInventory === undefined ? ('undefined tag ' + t.ID) : 
                                                (oTagInInventory.Shortcut === undefined || oTagInInventory.Shortcut === '' ? '' : 
                                                (oTagInInventory.Shortcut + ' ')) + oTagInInventory.Desc}
                                        </div>
                                        <div>
                                            {t.Attributes.map(nAttributeID => 
                                                !this.dictTagAttributesByID.has(nAttributeID) ? ('Invalid Attribute: ' + nAttributeID) : 
                                                this.dictTagAttributesByID.get(nAttributeID).Desc).join(' ')}
                                        </div>
                                    </div>
                                </div>
                            })}
                        </td>
                    </tr>})}
            </table>
        </div>
    }

    DrawSearchTaggedDataResults()
    {
        //{"SemanticGroupID":52,"MatchID":"1 John_5_4_21","Tags":[{"ID":2,"Attributes":[]}]}
        //{"SemanticGroupID":93,"TagList":[{"ID":1,"Desc":"God being awesome/holy/glorious/great/beautiful","Shortcut":"7"}]}
        //{"SemanticGroupID":93, "ID":1,"Desc":"God being awesome/holy/glorious/great/beautiful","Shortcut":"7"}
        //{"Attribute": true, "ID":3,"Desc":"forever"}

        var oSelected = this.state.listTagsSelectedForSearch[0]
        var listMatched = this.state.listTagsForMatchesInSemanticGroups
            .filter(o => o.Tags.some(t => t.ID === oSelected.ID))
            .sort((a,b) => 
                this.dictBSBTextSortOrderByVerseByID.get(a.MatchID.split('_').slice(0, -1).join('_')) - 
                this.dictBSBTextSortOrderByVerseByID.get(b.MatchID.split('_').slice(0, -1).join('_'))
            )

        return <div style={{display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px', fontFamily: "Calibri", fontSize: "18px"}}>
            <table style={{width: '70%', textAlign:"left", display: "inline-block", borderCollapse: "separate", borderSpacing: "0 0.3em"}}>
                {listMatched.map(o => {
                    var splitMatchID = o.MatchID.split('_')
                    var sVerseID = splitMatchID.slice(0, -1).join('_')
                    var nBSBWordIndex = parseInt(splitMatchID.slice(-1))

                    var oVerse = this.dictBSBTextByVerseByID.get(sVerseID)
                    // var blnContext = this.state.listSearchAndTagMatchIndexesWithContext.includes(nIndexToUse1)
                    var oContext = {Before: '', After: ''} //blnContext ? this.GetBSBVerseContext(oVerse) : {Before: '', After: ''}

                    return <tr style={{paddingBottom:"10px"}}>
                        <td style={{width: '10%'}}>{oVerse.VerseRef}</td>
                        <td >{this.GetSpansForSearchAndTag(oVerse, nBSBWordIndex, oContext)}</td>
                    </tr>})}
            </table>
        </div>
    }

    // GetLetterForTagOptionNumber(sNumber)
    // {
    //     var s = this.dictTagOptionIndexByKeyReverse[sNumber]
    //     return s === undefined ? '' : s + ' '
    // }

    SaveMatchTags(listToSet)
    {
        //save the objects that actually have been tagged, not the default empty ones
        this.setState({listTagsForMatchesInSemanticGroups: listToSet});
        //console.log(JSON.stringify(listToSet))
        localStorage.setItem("listTagsForMatchesInSemanticGroups", JSON.stringify(listToSet.filter(o => o.Tags[0].ID > 0)));	
    }

    SaveTagInventory(listToSet)
    {
        this.setState({listTagInventory: listToSet});
        //console.log(JSON.stringify(listToSet))
        localStorage.setItem("listTagInventory", JSON.stringify(listToSet));	
    }

    LoadMatchTags()
	{
        var locallyStored = localStorage.getItem("listTagsForMatchesInSemanticGroups");
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored)
	}

    LoadTagInventory()
	{
        var locallyStored = localStorage.getItem("listTagInventory");
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored)
	}

    GetSearchAndTagDataForTagInventory()
    {
        return localStorage.getItem("listTagInventory")
    }

    GetSearchAndTagDataForMatchTags()
    {
        return localStorage.getItem("listTagsForMatchesInSemanticGroups")
    }

    DrawAlignedClauses()
    {
        //["Conj", "Rela", "Subj", "Nega", "Pred", "PreO", "PreC", "Cmpl", "Time"];
        var listPFsInChapter = this.listTextWordsForChapter.map(w => this.GetPhraseFunction(w)); 

        var listAfterOnesAll = ["Objc", "Cmpl", "Adju", "Time", "Modi", "Loca", "Nega", "Intj", "Rela"];
        var listAfterOnes = listAfterOnesAll.filter(s => listPFsInChapter.includes(s));

        var listBeforeOnesAll = ["Ques", "Conj", "Voct"];
        var listBeforeOnes = listBeforeOnesAll.filter(s => listPFsInChapter.includes(s));

        return <div style={{textAlign:"center"}}>
			<table style={{paddingRight: "20px", display: "inline-block", borderCollapse: "collapse"}}>
				<thead>{listAfterOnes.reverse().map(s => <th style={{position: "sticky", top: 0}}>{s}</th>)}
                <th>V</th><th>S</th>
                {listBeforeOnes.reverse().map(s => <th>{s === "Objc" ? "O" : s}</th>)}
                </thead>
				{this.state.listLines
				.map(line => 
					<>
					<tr>
                    {listAfterOnes.map(s => this.GetAlignedClauseTD(line.Words.filter(w => this.GetPhraseFunction(w) === s)))}
                    {this.GetAlignedClauseTD(line.Words.filter(w => ['V', 'P', "Pred", "PreO"].includes(this.GetPhraseFunction(w))))}					
                    {this.GetAlignedClauseTD(line.Words.filter(w => ['S', "Subj", "PreC"].includes(this.GetPhraseFunction(w))))}	
                    {listBeforeOnes.map(s => this.GetAlignedClauseTD(line.Words.filter(w => this.GetPhraseFunction(w) === s)))}
                    </tr>
                    </>)}
			</table>
			</div>
    }

    GetWordWithTextIndexInChapter(textIndex)
    {
        return this.listTextWordsForChapter.find(w => w.TextIndex === textIndex);
    }

    GetWordsInTextIndexRangeInChapter(nTextIndexRangeBegin, nTextIndexRangeEnd)
    {
        return this.listTextWordsForChapter.filter(w => {
            var nTextIndex = parseInt(w.TextIndex)
            return nTextIndex >= nTextIndexRangeBegin && nTextIndex <= nTextIndexRangeEnd 
        })
    }

    GetLineWithStartAndEndIndexesInChapter(nTextIndexRangeBegin, nTextIndexRangeEnd, listLinesToUse)
    {
        return listLinesToUse.find(l => l.TextIndexRangeBegin == nTextIndexRangeBegin && l.TextIndexRangeEnd == nTextIndexRangeEnd)
    }

    DrawParticipantReferenceInteraction()
    {
        var listGroups = this.GetRepetitionLinkGroupsForCurrentChapter().filter(g => g.Type === 2);

        return <div style={{textAlign:"center"}}>
        <table style={{paddingRight: "20px", display: "inline-block", borderCollapse: "collapse"}}>
            <tr>{listGroups.map(g => {
               var listOtherGroups = listGroups.filter(g2 => g2 != g);

               return listOtherGroups.map(g2 => 
               <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left', borderStyle: "solid", borderWidth: "1px", paddingLeft: "5px", paddingRight: "5px"}}>        
                    {g2.ListWords.filter(n => g.ListWords.includes(n)).map(n => {
                        var w = this.GetWordWithTextIndexInChapter(n);
                        return <span class="TextWordDiv"
                        style={{ fontFamily: "SBL Hebrew", fontSize: "22px", color: this.GetTextColor(w)}}>
                            {w.FullText + (w.FullText.endsWith("־") ? "" : " ")}</span> })}   
                </td>)
            })}
            </tr>
        </table>
        </div>
    }

    GetWordSpanForTable(w)
    {
        return <span class="TextWordDiv" style={{ fontFamily: "SBL Hebrew", fontSize: "22px", color: this.GetTextColor(w)}}>
        {w.FullText + (w.FullText.endsWith("־") ? "" : " ")}</span>;
    }

    DrawParticipants()
    {
        var listGroups = this.GetRepetitionLinkGroupsForCurrentChapter().filter(g => g.Type === 2);

        return <div style={{textAlign:"center"}}>
        <table style={{paddingRight: "20px", display: "inline-block", borderCollapse: "collapse"}}>
            <th>Nouns</th><th>Verbs</th><th>Pronouns</th><th>Prepositions</th><th>Suffixed</th>
            
              {listGroups.map(g => {
               var listWords = g.ListWords.map(n => this.GetWordWithTextIndexInChapter(n));

               return <tr>
                <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left', borderStyle: "solid", borderWidth: "1px", paddingLeft: "5px", paddingRight: "5px"}}>        
                    {listWords.filter(w => w.WordType === "N" && !g.WordsForWhichParticipantRefIsForSuffix.includes(w.TextIndex)).map(w => this.GetWordSpanForTable(w))}   
                </td>
                <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left', borderStyle: "solid", borderWidth: "1px", paddingLeft: "5px", paddingRight: "5px"}}>        
                    {listWords.filter(w => w.WordType === "V" && !g.WordsForWhichParticipantRefIsForSuffix.includes(w.TextIndex)).map(w => this.GetWordSpanForTable(w))}   
                </td>
                <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left', borderStyle: "solid", borderWidth: "1px", paddingLeft: "5px", paddingRight: "5px"}}>        
                    {listWords.filter(w => w.WordType === "P" && !g.WordsForWhichParticipantRefIsForSuffix.includes(w.TextIndex)).map(w => this.GetWordSpanForTable(w))}   
                </td>
                <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left', borderStyle: "solid", borderWidth: "1px", paddingLeft: "5px", paddingRight: "5px"}}>        
                    {listWords.filter(w => w.WordType === "R" && !g.WordsForWhichParticipantRefIsForSuffix.includes(w.TextIndex)).map(w => this.GetWordSpanForTable(w))}   
                </td>
                <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left', borderStyle: "solid", borderWidth: "1px", paddingLeft: "5px", paddingRight: "5px"}}>        
                    {listWords.filter(w => g.WordsForWhichParticipantRefIsForSuffix.includes(w.TextIndex)).map(w => this.GetWordSpanForTable(w))}   
                </td>
                </tr>})}
        </table>
        </div>
    }

    DrawClausesByParticipant()
    {
        var blnTranslation = true;
        var listGroups = this.GetRepetitionLinkGroupsForCurrentChapter().filter(g => g.Type === 2);

        return listGroups.map(g => {
            var listClausesWithParticipant = this.listClauses.filter(c => c.Words.some(w => g.ListWords.includes(w.TextIndex)));

            return <div style={{textAlign:"center"}}>
                <table style={{paddingRight: "20px", display: "inline-block", borderCollapse: "collapse"}}>
                {listClausesWithParticipant.map(c => 
                    <tr><td style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left'}}>
                        {blnTranslation ?  this.listTranslationsImported.filter(o => c.Words.some(w => o.TextIndexList.includes(w.TextIndex))).
                            map(o => 
                                <span class="TextWordDiv" style={{ fontFamily: "Calibri", fontSize: "18px", 
                            color: g.ListWords.some(s => o.TextIndexList.includes(s)) ? "Red": "Black"}}>{o.Translation + " "}</span>) :
                        
                        c.Words.map(w =>
                        <span class="TextWordDiv" style={{ fontFamily: "SBL Hebrew", fontSize: "22px", 
                            color: g.ListWords.includes(w.TextIndex) ? "Red": "Black"}}>
                            {(w.FullText + (w.FullText.endsWith("־") ? "" : " "))}</span>)}
                    </td></tr>
                )}
                </table><br /><br />
            </div>
        });
    }

    SetSemanticOutline(nChapter)
    {
        var nDefaultMaxExpandedIndent = 1;
        var outlineForChapter = this.listSemanticOutlines.find(o => o.Chapter === nChapter);
        if(outlineForChapter === undefined) 
        {
            this.setState({semanticOutlineNodes: []});
            return;
        }

        var listNodes = outlineForChapter.Nodes.
            filter(s => s.trim() != "").
            map(s => { 
                var indentMatch = s.match(/^(\-)*/);
                var nIndentLevel = indentMatch[0].length;             
                s = s.replaceAll("-", "");
                return {IndentLevel: nIndentLevel, Text: s, InEditMode: false, Visible: nIndentLevel <= nDefaultMaxExpandedIndent}});

        this.SetSubnodes(listNodes);
        this.setState({semanticOutlineNodes: listNodes});
    }
    
    AddSemanticOutlineNodeInEditMode()
    {
        var listToSet = this.state.semanticOutlineNodes;
        listToSet.push({IndentLevel: 0, Text: "", InEditMode: true, Visible: true, Subnodes: []});
        this.setState({semanticOutlineNodes: listToSet});
    }

    SetSemanticOutlineSubnodeVisibility(parentNode, blnVisible)
    {
        var listToSet = this.state.semanticOutlineNodes;
        var parentNodeInList = listToSet.find(o => o === parentNode);
        parentNodeInList.Subnodes.forEach(o2 => o2.Visible = blnVisible);
        this.setState({semanticOutlineNodes: listToSet});
    }

    SetSemanticOutlineNodeInEditMode(node, blnInEditMode)
    {
        var listToSet = this.state.semanticOutlineNodes;
        var nodeInList = listToSet.find(o => o === node);
        nodeInList.InEditMode = blnInEditMode;
        this.setState({semanticOutlineNodes: listToSet});
    }

    // SetSemanticOutlineNodeText(node, sText)
    // {
    //     var listToSet = this.state.semanticOutlineNodes;
    //     var nodeInList = listToSet.find(o => o === node);
    //     nodeInList.Text = sText;
    //     this.setState({semanticOutlineNodes: listToSet});
    // }

    DrawSemanticOutline()
    {
        var nPixelsPerIndentLevel = 35;
        
        return <div>
            {this.state.semanticOutlineNodes.map(o => {
                return o.Visible && <div style={{
                    fontFamily: "Calibri", fontSize: "18px", 
                    marginLeft:(o.IndentLevel * nPixelsPerIndentLevel) + "px", 
                    marginBottom:"7px"}}>
                        {o.Subnodes.length > 0 && 
                        (o.Subnodes[0].Visible ?
                        <span onClick={(event) => {this.SetSemanticOutlineSubnodeVisibility(o, false)}}>-&nbsp;</span> :
                        <span onClick={(event) => {this.SetSemanticOutlineSubnodeVisibility(o, true)}}>+&nbsp;</span>)}
                        
                        {o.InEditMode ? 

                        <input type="text" variant="outlined"
                        defaultValue={o.Text}
                        onKeyDown={(event) => { if(event.key === "Enter") this.SetSemanticOutlineNodeInEditMode(o, false); }}
                        onChange={(event) => {o.Text = event.target.value}} /> :
                        
                        <span onDoubleClick={(event) => {this.SetSemanticOutlineNodeInEditMode(o, true)}}>{o.Text}</span>}
                </div>
            })}
        </div>
    }

    SplitTextIntoWordsForAssociation(s)
    {
		//split list by spaces - show each word as a autocomplete (which remains autocomplete) if it is a defined variable, otherwise as span. Can associate either with Hebrew words
		
		if(s === null) return [];
        return s.split(/\s+/); //s.split(/(?<!\bmy|your|his|a|o|the|to|of|for|with|by)\s+(?!me|him|her)/i);
    }

    GetFirstCurrentChapter()
    {
        return this.state.listCurrentChapters.length === 0 ? 0 : this.state.listCurrentChapters[0]
    }

    GetNodesFromTextData(sText)
    {
        var nDefaultMaxExpandedIndent = 1;
        var rootCoordinates = {x: 100, y: 100};

        var listNodes = sText.split("\n").map(s => s.trim()).filter(s => s != "").
            map(s => { 
                var indentMatch = s.match(/^(\-)*/);
                var nIndentLevel = indentMatch[0].length;             
                s = s.replaceAll("-", "");
                return {ListSplitWords: this.SplitTextIntoWordsForAssociation(s), ListHebrewWords: [], Text: s, IsMoving: false, Selected: false, Subnodes: [],
                    InEditMode: false, Position: rootCoordinates, Chapter: this.GetFirstCurrentChapter(),
                    IndentLevel: nIndentLevel, Visible: nIndentLevel <= nDefaultMaxExpandedIndent}});

        this.SetSubnodes(listNodes);
        
        var listToSet = this.state.listTags;
        listToSet = listToSet.concat(listNodes);
        this.SaveTags(listToSet);

        var listToSet = this.state.listTagTrees;
        listToSet.push({ListTags: listNodes, Chapter: this.GetFirstCurrentChapter()});
        this.SaveTagTrees(listToSet);
    }

    UpdateTagFieldValue(tag, sField, value)
	{
        var listToSet = this.state.listTags;
        var tagInList = listToSet.find(o => o === tag);
        tagInList[sField] = value;
        this.SaveTags(listToSet);
    }
   
	UpdateSubtagFieldValue(subtag, sField, value)
	{
		var listToSet = this.state.listTags;
        subtag[sField] = value;
        this.SaveTags(listToSet);
    }
	
	UpdateSubtagGroupFieldValue(subtagGroup, sField, value)
	{
		var listToSet = this.state.listTags;
        subtagGroup[sField] = value;
        this.SaveTags(listToSet);
	}
	
	ToggleSubtagSelection(subtag, blnOnlyOneCanBeSelectedAtaTime)
	{
		if(!subtag.Selected && blnOnlyOneCanBeSelectedAtaTime)
		{

			var listToSet = this.state.listTags;
			listToSet.filter(tag => tag.Chapter === this.GetFirstCurrentChapter()).
				forEach(tag => tag.SubtagGroups.forEach(subtagGroup => subtagGroup.Subtags.forEach(subtag => subtag.Selected = false)));
			this.SaveTags(listToSet);
		}

		var listSemanticDomains = subtag.VariableOption.split("^").length < 2 ? [] : subtag.VariableOption.split("^")[1];
		var listSubtagsToAssociateToUpdate = this.state.listSubtagsCurrentlyBeingAssociatedToWords;
		var listPossibleMappingsToUpdate = this.state.listWordsPossiblyMappingToCurrentSubtags;

		if(!subtag.Selected && blnOnlyOneCanBeSelectedAtaTime) 
		{
			listSubtagsToAssociateToUpdate = [subtag];
			listPossibleMappingsToUpdate = this.GetPossibleTextMappingsForTagVariable(listSemanticDomains);
		}
		else if (!subtag.Selected) 
		{
			listSubtagsToAssociateToUpdate = listSubtagsToAssociateToUpdate.push(subtag);
			listPossibleMappingsToUpdate = listPossibleMappingsToUpdate.concat(this.GetPossibleTextMappingsForTagVariable(listSemanticDomains));
		}
		else 
		{
			listSubtagsToAssociateToUpdate = [];
			listPossibleMappingsToUpdate = [];
		}

		this.setState({listSubtagsCurrentlyBeingAssociatedToWords: listSubtagsToAssociateToUpdate});
		this.setState({listWordsPossiblyMappingToCurrentSubtags: listPossibleMappingsToUpdate});

		this.UpdateSubtagFieldValue(subtag, "Selected", !subtag.Selected);
	}

    SetTagPosition(tag, coordinates)
    {
        var listToSet = this.state.listTags;
        var tagInList = listToSet.find(o => o === tag);
        tagInList.Position.x = coordinates.x;
        tagInList.Position.y = coordinates.y;
        this.SaveTags(listToSet);
    }

    SwapNodeWithTagAtOffsetIndex(tag, nOffset)
    {
        var listToSet = this.state.listTagTrees;
        var tree = this.GetTreeForTag(tag);
        var listTagsForTree = tree.ListTags;
        var nIndex1 = listTagsForTree.indexOf(tag);
        
        var nIndex2 = nIndex1 + nOffset;
        if(nIndex2 < 0) nIndex2 = 0;
        else if(nIndex2 > listTagsForTree.length - 1) nIndex2 = listTagsForTree.length - 1

        var node1 = listTagsForTree[nIndex1];
        var node2 = listTagsForTree[nIndex2];

        listTagsForTree[nIndex1] = node2;
        listTagsForTree[nIndex2] = node1;
        
        this.SaveTagTrees(listToSet);
    }

    MoveSelectionFromTagToOffsetIndex(tag, nOffset)
    {
        var tree = this.GetTreeForTag(tag);
        var listTagsForTree = tree.ListTags;
        var nIndexAtOffset = listTagsForTree.indexOf(tag) + nOffset;

        if(nIndexAtOffset >= 0 && nIndexAtOffset < listTagsForTree.length)
        {
            this.UpdateTagFieldValue(tag, "Selected", false);
            this.UpdateTagFieldValue(listTagsForTree[nIndexAtOffset], "Selected", true);
        }
    }

    SetTagSubnodeVisibility(parentNode, blnVisible)
    {
        var listToSet = this.state.listTags;
        var parentNodeInList = listToSet.find(o => o === parentNode);
        parentNodeInList.Subnodes.forEach(o2 => o2.Visible = blnVisible);
        this.SaveTags(listToSet);
    }

    DeleteSelectedTags()
    {
        var listSelectedTags = this.state.listTags.filter(tag => tag.Selected);
        if(listSelectedTags.length > 0 && window.confirm("Really delete selected tag(s)?" + listSelectedTags.length > 1 ? " (MULTIPLE TAGS SELECTED!)" : ""))
        {
            //delete it from both the tree and the list of tags
            var listToSet = this.state.listTags;
            var listTreesToSet = this.state.listTagTrees;

            listSelectedTags.forEach(selectedNode => {
                var nIndexToRemove = listToSet.indexOf(selectedNode);
				listToSet.splice(nIndexToRemove, 1);
				
                var tree = listTreesToSet.find(t => t === this.GetTreeForTag(selectedNode));
                var nIndexToRemoveInTree = tree.ListTags.indexOf(selectedNode);
                tree.ListTags.splice(nIndexToRemoveInTree, 1);
				if(tree.ListTags.length === 0)
				{
					//remove tree, too, if it no longer has any nodes
					var nIndexToRemove = listTreesToSet.indexOf(tree);
					listTreesToSet.splice(nIndexToRemove, 1);	
				}
            });

            this.SaveTags(listToSet);
            this.SaveTagTrees(listTreesToSet);
        }
    }

    SetSubnodes(listNodes)
    {
        listNodes.forEach((o,nIndex,arr) => {
            var nNextIndexAtSameIndentLevel = arr.findIndex((o2, nIndex2) => o2.IndentLevel <= o.IndentLevel && nIndex2 > nIndex);
            if(nNextIndexAtSameIndentLevel === -1) nNextIndexAtSameIndentLevel = arr.length;

            var listNodesInBetweenWithIndexLevelPlusOne = arr.filter((o2, nIndex2) => 
                nIndex2 > nIndex && nIndex2 < nNextIndexAtSameIndentLevel && o2.IndentLevel === o.IndentLevel + 1);
            o.Subnodes = listNodesInBetweenWithIndexLevelPlusOne; });
    }

    GetSubtagTextColor(subtag)
    {
        // for(var sWordIndex of subtag.ListHebrewWords) 
        // {
        //     //return the first color for any word that isn't black
        //     var colorOfWordInHebrewText = this.GetTextColor(this.GetWordWithTextIndexInChapter(sWordIndex));
        //     if(colorOfWordInHebrewText != "Black" && colorOfWordInHebrewText != "LightGray") return colorOfWordInHebrewText;
        // }

        return "Black";
    }

    GetTreeForTag(tag)
    {
        return this.state.listTagTrees.find(tree => tree.ListTags.includes(tag));
    }

    OffsetIndentLevel(o, nOffset)
    {
        var nNewValue = o.IndentLevel + nOffset;
        if(nNewValue < 0) nNewValue = 0;
        this.UpdateTagFieldValue(o, "IndentLevel", nNewValue);

        var listTagTreesToUpdate = this.state.listTagTrees;
        var treeToUpdate = this.GetTreeForTag(o);
        this.SetSubnodes(treeToUpdate.ListTags);
        this.SaveTagTrees(listTagTreesToUpdate);
    }

    GetEventCoordinates(event)
    {
        return {x: event.pageX - event.currentTarget.offsetLeft, y: event.pageY - event.currentTarget.offsetTop};
    }

    DistanceBetweenCoordinates(c1, c2)
    {
        return Math.sqrt(Math.pow(Math.abs(c1.x - c2.x), 2) + Math.pow(Math.abs(c1.y - c2.y), 2));
    }

    FindNearestTagTreeNodeAboveThisOne(tag)
    {
        if(this.state.listTagTrees.length === 0) return undefined;
        else
        {
            var listToCheck = this.state.listTagTrees.map(tree => tree.ListTags.filter(t => t.Position.y < tag.Position.y).
                map(t => { return {Tag: t, Tree: tree, Distance: this.DistanceBetweenCoordinates(t.Position, tag.Position)}})).flat(2).
                sort((a,b) => a.Distance - b.Distance);
            return listToCheck.length === 0 ? undefined : listToCheck[0]; 
        }
    }

    AddTagToATree(o, blnCreateNewTree)
    {
        var listTagTreesToUpdate = this.state.listTagTrees;
        var nearest = this.FindNearestTagTreeNodeAboveThisOne(o);

        if(nearest === undefined || blnCreateNewTree)
        {
            listTagTreesToUpdate.push({ListTags: [o], Chapter: this.GetFirstCurrentChapter()});
        }
        else
        {
            var nearestTreeNode = nearest.Tag;
            var nIndexToInsert = nearest.Tree.ListTags.indexOf(nearestTreeNode);
            nearest.Tree.ListTags.splice(nIndexToInsert + 1, 0, o);
            o.Position.x = nearestTreeNode.Position.x;
        }
        this.SaveTagTrees(listTagTreesToUpdate);
    }

	DoneEditingTagTextbox(o)
    {
        if(o.Text === "") o.Text = "..."; 
        this.UpdateTagFieldValue(o, "InEditMode", false);
    }

	DoneSelectingTagTemplate(tag, template)
	{
		//SubtagGroup: {TagVariable: undefined, InEditMode: true, Subtags:[{Text: "eat", ListHebrewWords: "123"}]}
		tag.TagTemplateName = template.Name;
		tag.SubtagGroups = template.Parts.map(s => { 
			var tagVariableForSubtag = this.listTagVariables.find(v => v.Name === s);
			return {TagVariable: tagVariableForSubtag, InEditMode: false, 
				Subtags: tagVariableForSubtag === undefined ? [{Text: s, VariableOption: undefined, SemanticDomains: "", ListHebrewWords: [], Selected: false}] : []}});
		this.UpdateTagFieldValue(tag, "InEditMode", false);	
	}
	
	ChangedSelectedValuesForSubtagGroup(subTagGroup, listSelectedValues)
	{	
		var listSubtagsToRemove = subTagGroup.Subtags.filter(o => !listSelectedValues.some(option => o.VariableOption === option));
		if(listSubtagsToRemove.some(o => o.ListHebrewWords.length > 0) && 
			!window.confirm("Warning - the option you deselected has Hebrew words mapped to it. Do you really want to remove it?")) return;

		//if(listNewValues != "" && listNewValues != null) 
		var listNewSubtags = listSelectedValues.filter(option => !subTagGroup.Subtags.some(o => o.VariableOption === option)).map(option => { 
			return {Text: option, VariableOption: option, SemanticDomains: "", ListHebrewWords: [], Selected: false}});

		this.UpdateSubtagGroupFieldValue(subTagGroup, "Subtags", subTagGroup.Subtags.filter(o => !listSubtagsToRemove.includes(o)).concat(listNewSubtags));		
	}

	DoneSelectingValuesForSubtagGroup(subTagGroup)
	{
		this.UpdateSubtagGroupFieldValue(subTagGroup, "InEditMode", false);
	}

	DoneSelectingTagDiscourseRelationship(tag, sValue)
	{
		this.UpdateTagFieldValue(tag, "DiscourseRelationshipName", sValue);	
	}
	
	GetSelectedTags()
	{
		return this.state.listTags.filter(tag => tag.SubtagGroups.some(g => g.Subtags.some(subtag => subtag.Selected)));
		//return this.state.listTags
		//SubtagGroups.Subtags.
	}

    AddTagInEditMode(coordinates)
    {
        var listToSet = this.state.listTags;

        var newTag = {TagTemplateName: undefined, DiscourseRelationshipName: undefined, SubtagGroups: [], 
            // ListHebrewWords: this.state.blnControlDown ? this.GetAllWordsInALensGroupWithCurrentHoveredWord().map(w => w.TextIndex) : [],  
            IsMoving: false, Subnodes: [], Chapter: this.GetFirstCurrentChapter(), Position: {x: coordinates.x, y: coordinates.y}, IndentLevel: 0, Visible: true};

        listToSet.push(newTag);       
        this.SaveTags(listToSet);

        if(this.state.blnTreeModeForTags) this.AddTagToATree(newTag, this.state.blnAltDown);
    }

    GetDivForTag(o, coordinates, blnForTree)
    {
		//return <div style={{position: "absolute", left: coordinates.x, top: coordinates.y, 
		//wordWrap: "break-word", borderStyle:  "solid", 
        return <tr><td style={{  
            fontFamily: "Calibri", fontSize: "18px", 
            borderWidth: "1px",
            userSelect: "none"}}
            onMouseDown={(event) => {
                if(!this.state.blnControlDown) this.UpdateTagFieldValue(o, "IsMoving", true);
			}}>
                
            {blnForTree && o.Subnodes.length > 0 && 
                (o.Subnodes[0].Visible ?
                <span onClick={(event) => {this.SetTagSubnodeVisibility(o, false)}}>-&nbsp;</span> :
                <span onClick={(event) => {this.SetTagSubnodeVisibility(o, true)}}>+&nbsp;</span>)}

			{/* {o.TagTemplateName != undefined && 
				<Autocomplete 
				options={["", "because", "although"]}
				onChange={(event, newValue) => {
					if(newValue != "" && newValue != null) this.DoneSelectingTagDiscourseRelationship(o, newValue);
				}} 
				style={{ width: 200 }}
				size="small"
				renderInput={(params) => (
					<TextField {...params} variant="outlined" autoFocus/>
				)} />	
			} */}

            {o.TagTemplateName === undefined ? 

			<Autocomplete 
			options={this.listTagTemplates}
			getOptionLabel={(option) => option.Desc}
			onChange={(event, newValue) => {
				if(newValue != "" && newValue != null) this.DoneSelectingTagTemplate(o, newValue);
			}} 
			style={{ width: 300 }}
			size="small"
			renderInput={(params) => (
				<TextField {...params} variant="outlined" autoFocus/>
			)} /> :

			o.SubtagGroups.map(subTagGroup => 
				<div style={{display: false ? "block" : "inline-block", marginLeft: "5px"}}
					onDoubleClick={(event) => { this.UpdateSubtagFieldValue(subTagGroup, "InEditMode", true)}}>

					{subTagGroup.TagVariable != undefined && subTagGroup.InEditMode ?

						<Autocomplete multiple disableCloseOnSelect
						options={subTagGroup.TagVariable.Options}
						//groupBy={(option) => option.firstLetter}
						value={subTagGroup.Subtags.map(subtag => subtag.VariableOption)}
						//defaultValue={[top100Films[13]]}
						onChange={(event, listNewValues) => {
							this.ChangedSelectedValuesForSubtagGroup(subTagGroup, listNewValues);
						}} 
						onClose={() => this.DoneSelectingValuesForSubtagGroup(subTagGroup)}
						//={(event) => this.handleKeyDown(event.key)} 
						style={{ width: 200 }}
						size="small"
						renderInput={(params) => (
							<TextField {...params} variant="outlined" autoFocus/>
						)} 
						renderOption={(option, { selected }) => (
							<>
							  <Checkbox
								icon={icon}
								checkedIcon={checkedIcon}
								style={{ marginRight: 8 }}
								checked={selected}
							  />
							  {option}
							</>
						  )}
						
						/> :
						
						subTagGroup.Subtags.length === 0 ? <span>___</span> :

						subTagGroup.Subtags.map((subtag, index, arr) => {
							return <span style={{ 
								color: this.GetSubtagTextColor(subtag), borderStyle: subtag.Selected ? "solid" : "none"}}
								onMouseDown={(event) => this.ToggleSubtagSelection(subtag, !this.state.blnAltDown)}
								onMouseEnter={(event) => this.setState({currentHoveredSubtag: subtag})}
								onMouseLeave={(event) => this.setState({currentHoveredSubtag: undefined})}>
									{subtag.Text + (index < arr.length - 1 ? ", " : "")}
							</span>})}

						{/* // !blnFixedSubTag && !subtag.InEditMode && subtag.SelectedValues.length > 0 ? 
						// 	subtag.SelectedValues.join(", ") : 
						// 	subtag.Text} */}
				</div>
			)}
        </td></tr>
    }

    DrawGeneralTags()
    {
        var nPixelsPerTreeIndentLevel = 35;
		//return <div style={{position: "relative"}}>   
		//style={{tableLayout: "fixed"}}> 
        return <table>        
            {this.state.listTagTrees.filter(tree => tree.Chapter === this.GetFirstCurrentChapter()).map(tree => {
                var rootPosition = tree.ListTags[0].Position;
                return tree.ListTags.filter(o => o.Visible).map((o, nTagIndex) => this.GetDivForTag(o, 
                    {x: rootPosition.x + o.IndentLevel * nPixelsPerTreeIndentLevel, 
                     y: rootPosition.y + nTagIndex * this.nYPixelsBetweenTreeNodes}, true));
            })}

			{this.state.listTags.filter(o => o.Visible && o.Chapter === this.GetFirstCurrentChapter() && 
				!this.state.listTagTrees.some(tree => tree.ListTags.includes(o))).
                map(o => this.GetDivForTag(o, 
                    {x: o.Position.x + o.IndentLevel * nPixelsPerTreeIndentLevel, y: o.Position.y}, false))}
        </table>
    }

    DrawSentenceDiagrams()
    {
        var nStartRightX = 600;
        var nStartTopY = 100;
        var listWordsInChapter = this.listTextWordsForChapter;

        var listDiagramSVGElements = [];
        var nFirstSentenceNumber = parseInt(listWordsInChapter[0].sentence_atom_number);
        var nLastSentenceNumber = parseInt(listWordsInChapter[listWordsInChapter.length - 1].sentence_atom_number);

        var nCurrentX = nStartRightX;
        var nCurrentY = nStartTopY;

        var nYOffsetPerClause = 25;
        var nXOffsetPerSubordinationLevel = 50;
        var nXOffsetPerPhrase = 50;
        var nXOffsetPerPhrasePart = 50;
        var nYOffsetPerPhrase = 25;
        var nYOffsetPerPhrasePart = 25;

        var listPhraseFunctionOrder = ["Conj", "Rela", "Subj", "Nega", "Pred", "PreO", "PreC", "Cmpl", "Time"];

        for(var nCurrentSentence = nFirstSentenceNumber; nCurrentSentence <= nLastSentenceNumber; nCurrentSentence++)
        {
            var listWordsInSentence = listWordsInChapter.filter(w => w.sentence_atom_number == nCurrentSentence);

            nCurrentX = nStartRightX;
            var nXOffsetAtCurrentSubordinationLevel = nCurrentX;
        
            var nFirstClauseNumber = parseInt(listWordsInSentence[0].ClauseID);
            var nLastClauseNumber = parseInt(listWordsInSentence[listWordsInSentence.length - 1].ClauseID);

            for(var nCurrentClause = nFirstClauseNumber; nCurrentClause <= nLastClauseNumber; nCurrentClause++)
            {
                //enforce certain word order
                var listWordsInClause = listWordsInSentence.filter(w => w.ClauseID == nCurrentClause)
                    .sort((a,b) => listPhraseFunctionOrder.indexOf(a.phrase_function) - listPhraseFunctionOrder.indexOf(b.phrase_function));

                // var nFirstPhraseNumber = Math.min(...listWordsInClause.map(w => parseInt(w.phrase_atom_number)));
                // var nLastPhraseNumber = Math.max(...listWordsInClause.map(w => parseInt(w.phrase_atom_number)));

                nCurrentX = nXOffsetAtCurrentSubordinationLevel;

                for(var nCurrentPhrase of [...new Set(listWordsInClause.map(w => parseInt(w.phrase_atom_number)))])
                {
                    var listWordsInPhrase = listWordsInClause.filter(w => w.phrase_atom_number == nCurrentPhrase);
                    
                    var nTextLength = 40;

                    for(var w of listWordsInPhrase)
                    {
                        if(w.phrase_type === "CP") 
                        {
                            nCurrentX -= nXOffsetPerSubordinationLevel;
                            nXOffsetAtCurrentSubordinationLevel = nCurrentX - nXOffsetPerPhrasePart;
                        }

                        var nYForUnderline = nCurrentY + 12;
                        //var sText = listWords.map(w => w.FullText + (w.FullText.endsWith("־") ? '' : ' '));
                        //"SeparatedText":"וּ/בְ/מוֹשַׁ֥ב"
                        listDiagramSVGElements.push(<text x={nCurrentX} y={nCurrentY} font-size="18" font-family="SBL Hebrew">{w.FullText}</text>);
                        listDiagramSVGElements.push(<line x1={nCurrentX} x2={nCurrentX + nTextLength} y1={nYForUnderline} y2={nYForUnderline} stroke={"black"} strokeWidth={1}/>);
                        nCurrentX -= nXOffsetPerPhrasePart;
                        nCurrentY += nYOffsetPerPhrasePart;
                    }

                    //this.DrawHebrewPhrase(listWordsInPhrase, nCurrentX, nCurrentY, listDiagramSVGElements);
                    // nCurrentX -= nXOffsetPerPhrase;
                    // nCurrentY += nYOffsetPerPhrase;
                }

                //nCurrentY += nYOffsetPerClause;
            }
        }

        return <svg style={{verticalAlign: "top"}} height={nCurrentY - nStartTopY} width={1000}>
			{listDiagramSVGElements}</svg>;
    }

	GetCenterOfWordList(listWords, xOffset, sForWhichColumnType)
	{
		var nLeft = 1000000;
		var nRight = 0;
		for(var w of listWords)
		{
			var rect = this.GetWordSpanRect(w, sForWhichColumnType);
			if(rect === null) return undefined;
			if(rect.right > nRight) nRight = rect.right;
			if(rect.left < nLeft) nLeft = rect.left;
        }
		return (nLeft - xOffset) + ((nRight - nLeft) / 2);
	}

	GetLinkLineSVG(listWords1, listWords2, linkColor, linkWidth, xOffsetOfBox, yHeight, sForWhichColumnType)
	{
		if(listWords1.length === 0 || listWords2.length === 0) return;
		
		var center1 = this.GetCenterOfWordList(listWords1, xOffsetOfBox, sForWhichColumnType);
		var center2 = this.GetCenterOfWordList(listWords2, xOffsetOfBox, sForWhichColumnType);
		if(center1 === undefined || center2 === undefined) return;
		return <line x1={center1} x2={center2} y1={0} y2={yHeight} stroke={linkColor} strokeWidth={linkWidth}/>;
	}

	MeasureLine(line, sForWhichColumnType)
	{
		var rectFirstWord = this.GetWordSpanRect(line.Words[0], sForWhichColumnType);
		var rectLastWord = this.GetWordSpanRect(line.Words[line.Words.length - 1], sForWhichColumnType);
        if(rectFirstWord === null || rectLastWord === null) return {Width: 1, XOffset: 0};
   
        return { 
            Width: Math.abs((sForWhichColumnType === 'translation' || sForWhichColumnType === 'glosses') ? (rectLastWord.right - rectFirstWord.left) : (rectFirstWord.right - rectLastWord.left)), 
            XOffset: (sForWhichColumnType === 'translation' || sForWhichColumnType === 'glosses') ? rectFirstWord.left : rectLastWord.left};
	}

	GetLinkLinesToShow(line, sForWhichColumnType, blnSectionBreak)
	{
		//sDomInfoForWordToSet = hoveredWordRectToSet.top + " " + rect.right+ " " + rect.bottom+ " " + rect.left;
		//<svg height={this.state.listLines.length * 33} width="500" style={{border:"1px solid black"}}>
		//if(this.state.listLines.length === 0) return;

		var nNextLineIndex = this.state.listLines.indexOf(line) + 1;
		if(nNextLineIndex >= this.state.listLines.length) return;
		var nextLine = this.state.listLines[nNextLineIndex];

		var listWordLinks = []; //[{Word1: line.Words[0], Word2: nextLine.Words[nextLine.Words.length -1]}];  //this.state.listUnitSimilaritiesToCurrentUnit.map(r => r.WordLinks).flat(1);
		
		//one link per pgroup that both lines have
		var repGroupLine1 = this.GetRepetitionGroupForLine(line);
		var repGroupLine2 = this.GetRepetitionGroupForLine(nextLine);

		if(repGroupLine1 != undefined && repGroupLine1 === repGroupLine2)
		{
			for(var s of repGroupLine1.ListPGroupValuesInLineGroup)
			{
				listWordLinks.push({Group1: line.Words.filter(w => this.GetPGroupForWord(w) == s), 
					Group2: nextLine.Words.filter(w => this.GetPGroupForWord(w) == s), Color: "Black"});
			}
		}

        //TODO: automatic links like same word, morpho-syntactic links, wordtype that aren't the same.

		//other hand-tagged links
		for(var w1 of line.Words)
            for(var w2 of nextLine.Words)
                for(var pair of this.state.listWordLinkPairs.filter(g => (g.Word1 === w1 && g.Word2 === w2) || (g.Word2 === w1 && g.Word1 === w2)))
                    listWordLinks.push({Group1: [w1], Group2: [w2], 
                        Color: pair.LinkType === "s" ? "Blue" : 
                        pair.LinkType === "p" ? "Goldenrod" :
                        pair.LinkType === "sp" ? "Green" : "Red"});

		if(listWordLinks.length === 0)
			return;
		else
		{
			//style= {{borderStyle: "solid"}} 
			var yHeight = blnSectionBreak ? 40 : 20;
			var line1Measure = this.MeasureLine(line, sForWhichColumnType);
            var line2Measure = this.MeasureLine(nextLine, sForWhichColumnType);
            
			return <svg style={{verticalAlign: "top"}} height={yHeight} width={Math.max(line1Measure.Width, line2Measure.Width)}>
			{listWordLinks.map(r => this.GetLinkLineSVG(r.Group1, r.Group2, r.Color, 1, Math.min(line1Measure.XOffset, line2Measure.XOffset), yHeight, sForWhichColumnType))}</svg>;
		}
	}

	//parents of leaves = 1, grandparents of leaves = 2, etc.
	GetParentLevel(discourseUnit)
	{
		if(discourseUnit.IsLeaf === "1")
		{
			return 0;
		}
		else 
		{
			var listChildren = this.state.listDiscourseUnits.filter(r => r.ParentUnitID === discourseUnit.ID);
			return 1 + listChildren.reduce((a, b) => Math.max(a, this.GetParentLevel(b)), 0);
		}
	}

	GetCenterYForLineContainingTextIndex(textIndex)
	{
		//return textIndex === "1" ? 20 : textIndex === "4" ? 60 : 0;

		var rect = this.GetWordSpanRectByTextIndex(textIndex, false);
		if(rect === null)
			return undefined;
		else
			return rect.top + ((rect.top - rect.bottom) / 2);
	}

	GetUnitNodeAndLines(discourseUnit)
	{
		var nPixelsPerIndentLevel = 50;
		var nLeafPadding = 0;
		var nNodeWidth = 40;
		var nNodeHeight = 15;

		var listChildren = this.state.listDiscourseUnits.filter(r => r.ParentUnitID === discourseUnit.ID);
		var firstChild = listChildren[0];
		var lastChild = listChildren[listChildren.length - 1];

		var yPositionOfFirstChild = 0;
		var yPositionOfLastChild = 0;

		if(discourseUnit.IsLeaf === "1")
		{
			yPositionOfFirstChild = firstChild.YCenter;
			yPositionOfLastChild = lastChild.YCenter;
		}
		else
		{
		 	yPositionOfFirstChild = this.GetCenterYForLineContainingTextIndex(firstChild.TextIndexStart);
			yPositionOfLastChild = this.GetCenterYForLineContainingTextIndex(lastChild.TextIndexStart);
		}
		
		//the x center is one indent level greater than the maximum x center of its children
		var nChildrenMaxXCenter = listChildren.reduce((a, b) => Math.max(a, b.IsLeaf === "1" ? nLeafPadding : b.XCenter), 0);
		discourseUnit.XCenter = nChildrenMaxXCenter + nPixelsPerIndentLevel;
		discourseUnit.YCenter = yPositionOfFirstChild + ((yPositionOfLastChild - yPositionOfFirstChild) / 2);

		//onclick={window.alert('You have clicked the box.')}  onClick={function() { alert('click'); }}
		//onmousemove={() => console.log('foo') }
		//onmousemove={() => console.log('foo') } onclick={() => alert('click')}

		return <>
		<rect x={discourseUnit.XCenter - (nNodeWidth / 2)} y={discourseUnit.YCenter - (nNodeHeight / 2)} width={nNodeWidth} height={nNodeHeight} rx="5" stroke="black" fill="transparent" stroke-width="1" />
		<text x={discourseUnit.XCenter} y={discourseUnit.YCenter} font-size="12" dominant-baseline="middle" text-anchor="middle">Label</text>
		<line x1={discourseUnit.XCenter} x2={discourseUnit.XCenter} y1={yPositionOfFirstChild} y2={yPositionOfLastChild} stroke="black" stroke-width="1" />
		{listChildren.map(r => <line x1={r.IsLeaf === "1" ? nLeafPadding : r.XCenter} x2={discourseUnit.XCenter} y1={this.GetCenterYForLineContainingTextIndex(r.TextIndexStart)} y2={this.GetCenterYForLineContainingTextIndex(r.TextIndexStart)} stroke="black" stroke-width="1"/>)}		
		</>
	}

	DrawDiscourseUnits()
	{
		//{"ID":"1","DiscourseAnalysisSchemeID":"1","ParentUnitID":"3",
		//"RelationshipToSiblings":"1","TextIndexStart":"1","TextIndexEnd":"3","IsLeaf":"1", "YCenter":0};
		
		//for each non-leaf (anything that has children) draw its box and the lines leading into it.
		if(this.state.listDiscourseUnits.length === 0)
			return null;
		else
		{
			return <div style={{display: "inline-block"}}><svg height="500" width="500" style={{border:"1px solid black"}}>
			{this.state.listDiscourseUnits.filter(r => r.IsLeaf !== "1").map(r => this.GetUnitNodeAndLines(r))}</svg></div>;
		}
	}

    //never do this unless you have a very good reason!!!
    // WipeOutLocalStorageForLinesForAllChapters()
    // {
    //     for(var nChapter = 1; nChapter <= 150; nChapter++)
	// 	{
    //         localStorage.removeItem("listColaFor19_" + nChapter.toString())
    //     }

    //     window.alert('done')
    // }

	GetJSONForLines()
	{
		var jsonForAllChapters = "";
		for(var nChapter = 1; nChapter <= 150; nChapter++)
		{
			var locallyStoredCola = this.LoadLines(19, nChapter);
			if(locallyStoredCola !== null)
			var listLinesToSave = locallyStoredCola;
			jsonForAllChapters += '{"Book": 19, "Chapter": ' + nChapter.toString() + ', "Lines": ' + JSON.stringify(this.GetObjectsForLines(listLinesToSave)) + "},";
		}
		return jsonForAllChapters;
	}

    UndefinedToFalse(value)
    {
        return value === undefined ? false : value;
    }

    UndefinedToNull(value)
    {
        return value === undefined ? "" : value;
    }

    GetLinesForDB()
	{
        var sLinesForAllChapters = "Book^Chapter^TextIndexRangeBegin^TextIndexRangeEnd^IndentLevel^StartsRepetitionGroup^StartsCluster^StartsClusterGroup^StartsLevel4Group^IsSuperscription^IsShortChangeFromPattern^FigurativeLanguage^LinkedLinesList^NotInGroup^RelationshipToPrevious^RelationshipToNext\n";
		for(var nChapter = 1; nChapter <= 150; nChapter++)
		{
			var locallyStoredCola = this.LoadLines(19, nChapter);
            if(locallyStoredCola !== null)
            {
                var listLinesToSave = locallyStoredCola;
                sLinesForAllChapters += listLinesToSave.map(o => o.Book + "^" + o.Chapter + "^" + 
                        o.TextIndexRangeBegin + "^" + o.TextIndexRangeEnd + "^" + o.IndentLevel + "^" +
						this.UndefinedToFalse(o.StartsRepetitionGroup) + "^" + this.UndefinedToFalse(o.StartsCluster) + "^" + 
						this.UndefinedToFalse(o.StartsClusterGroup) + "^" + this.UndefinedToFalse(o.StartsLevel4Group) + "^" + 
                        this.UndefinedToFalse(o.IsSuperscription) + "^" +
                        this.UndefinedToFalse(o.IsShortChangeFromPattern) + "^" +
                        this.UndefinedToFalse(o.FigurativeLanguage) + "^" + 
                        this.UndefinedToNull(o.LinkedLinesList) + "^" + this.UndefinedToFalse(o.NotInGroup) + "^" + 
                        this.UndefinedToNull(o.RelationshipToPrevious) + "^" + this.UndefinedToNull(o.RelationshipToNext)).join("\n") + "\n";
            }
		}
        return sLinesForAllChapters;
    }
    
	GetWordGroupsOverrideForDB()
	{
		return "TextIndex^PGroup^LinkedWords\n" + 
			this.state.listWordsOverride.sort((a,b) => parseInt(a.TextIndex) - parseInt(b.TextIndex))
            .map(o => o.TextIndex + "^" + o.PGroup + "^" + (o.LinkedWordsList === undefined ? [] : 
                o.LinkedWordsList.map(o2 => o2.TextIndex + "~" + o2.Type)).join(",")).join("\n");
	}

    //this.GetJSONForLines() -> split by chapter (MergeLineChanges.py)
    //this.GetRepetitionLinkGroupsForDB() -> put into one file
    //localStorage.getItem("listTranslationWordIndexLinks"): {"Original":"179","Translation":0,"LineIndex":5,"Chapter":"3"}
    //localStorage.getItem("listOurTranslationLines"): {"Chapter":"65","LineIndex":2,"Groups":[1]}
    //localStorage.getItem("listDevelopmentRepetitionDescsForGroupsByChapter"): {"Chapter":"42","DescsForGroups":[{"ID":2,"Desc":"Water"}]}
    //localStorage.getItem("listDevelopmentRepetitionGroupsByChapter")

    GetAllRepetitionGroups()
    {
        //return localStorage.getItem("listDevelopmentRepetitionGroupsByChapter")

        //TODO: expand this for other books when necessary
        var jsonForAllChapters = "";

        for(var nBook of [19])
        {
            for(var nChapter = 1; nChapter <= this.listMaxChaptersByBook.find(mxc => mxc.Book === nBook).MaxChapter; nChapter++)
            {   
                jsonForAllChapters += '{"Book": ' + nBook.toString() + ', "Chapter": ' + nChapter.toString() + 
                ', "RepetitionLinkGroupsByChapter": ' + JSON.stringify(this.LoadRepetitionLinkGroupsByChapter(nBook, nChapter)) + "},"
            }
        }

		return '{"CorrespondencesByBookAndChapter": [' + jsonForAllChapters + ']}'

        // return localStorage.getItem("listTranslationWordIndexLinks") + "\n\n" + localStorage.getItem("listOurTranslationLines") + 
        //     "\n\n" + this.GetRepetitionLinkGroupsForDB() + "\n\n" + localStorage.getItem("listDevelopmentRepetitionGroupsByChapter") + 
        //     "\n\n" + localStorage.getItem("listDevelopmentRepetitionDescsForGroupsByChapter") +
        //     "\n\n" + this.GetJSONForLines()
    }

    GetAllLines()
    {
        var listLinesForAllChapters = []

        for(var nBook of [19])
        {
            for(var nChapter = 1; nChapter <= this.listMaxChaptersByBook.find(mxc => mxc.Book === nBook).MaxChapter; nChapter++)
            {
                var listLinesToSave = []
                var locallyStoredCola = this.LoadLines(nBook, nChapter);
                if(locallyStoredCola !== null) listLinesToSave = locallyStoredCola;
                
                listLinesForAllChapters = listLinesForAllChapters.concat(listLinesToSave)
            }
        }

		return '{"Lines": ' + JSON.stringify(this.GetObjectsForLines(listLinesForAllChapters)) + "}"
    }

    GetEverythingForDB()
    {
        //return localStorage.getItem("listDevelopmentRepetitionGroupsByChapter")

        //TODO: expand this for other books when necessary
        var jsonForAllChapters = "";

        for(var nBook of [19,23])
        {
            for(var nChapter = 1; nChapter <= this.listMaxChaptersByBook.find(mxc => mxc.Book === nBook).MaxChapter; nChapter++)
            {
                var listLinesToSave = []
                var locallyStoredCola = this.LoadLines(nBook, nChapter);
                if(locallyStoredCola !== null) listLinesToSave = locallyStoredCola;
                
                jsonForAllChapters += '{"Book": ' + nBook.toString() + ', "Chapter": ' + nChapter.toString() + ', "Lines": ' + JSON.stringify(this.GetObjectsForLines(listLinesToSave)) +
                ', "OurTranslationLines": ' + JSON.stringify(this.LoadOurTranslationLines(nBook, nChapter)) + 
                ', "TranslationWordIndexLinks": ' + JSON.stringify(this.LoadTranslationWordIndexLinks(nBook, nChapter)) + 
                ', "DevelopmentRepetitionGroupsByChapter": ' + JSON.stringify(this.LoadDevelopmentRepetitionGroupsByChapter(nBook, nChapter)) + 
                ', "DevelopmentRepetitionDescsForGroupsByChapter": ' + JSON.stringify(this.LoadDevelopmentRepetitionDescsForGroupsByChapter(nBook, nChapter)) + 
                ', "MainWordInTranslationLinkGroupsByTextIndexDictionary": ' + JSON.stringify(Object.fromEntries(this.LoadMainWordInTranslationLinkGroupsByTextIndexDictionary(nBook, nChapter))) + 
                ', "MainPrepositionWordInTranslationLinkGroupsByTextIndexDictionary": ' + JSON.stringify(Object.fromEntries(this.LoadMainPrepositionWordInTranslationLinkGroupsByTextIndexDictionary(nBook, nChapter))) + 
                ', "MainSuffixWordInTranslationLinkGroupsByTextIndexDictionary": ' + JSON.stringify(Object.fromEntries(this.LoadMainSuffixWordInTranslationLinkGroupsByTextIndexDictionary(nBook, nChapter))) + 
                ', "RepetitionLinkGroupsByChapter": ' + JSON.stringify(this.LoadRepetitionLinkGroupsByChapter(nBook, nChapter)) + "},"
            }
        }

		return jsonForAllChapters

        // return localStorage.getItem("listTranslationWordIndexLinks") + "\n\n" + localStorage.getItem("listOurTranslationLines") + 
        //     "\n\n" + this.GetRepetitionLinkGroupsForDB() + "\n\n" + localStorage.getItem("listDevelopmentRepetitionGroupsByChapter") + 
        //     "\n\n" + localStorage.getItem("listDevelopmentRepetitionDescsForGroupsByChapter") +
        //     "\n\n" + this.GetJSONForLines()
    }

    GetOurTranslationTextForChapter()
    {
        return this.state.listOurTranslationLines.map(o => o.Translation).join('\n')

        // var sChapterTranslation = ''
        // for(var nl = 0; nl < this.state.listLines.length; nl++)
        // {
        //     let l = this.state.listLines[nl]
        //     for(var n = 0; n < l.Words.length; n++)
        //     {
        //         sChapterTranslation += this.GetOurTranslationForWord(l.Words[n]) + ' '
        //     }

        //     sChapterTranslation += '\n'
        // }

        // return sChapterTranslation
    }

    AddConnectionsFromSimilarOppositeTags()
    {
        if(this.state.listRepetitionLinkGroups.some(g => g.Type === 20))
        {
            window.alert('Links inside verses are already in this chapter, so no links were generated.')
            return
        }

        if(!window.confirm("Are you sure you want to add connections from similar/opposite tags?"))
        {
            return
        }

        var listToAdd = []

        let listSimilarOppositeTagCategories = [{ID: '28'}, {ID: '312'}, {ID: '310'}, 
            {ID: '74'}, {ID: '308'}, {ID: '66'}, {ID: '69'}, {ID: '304'}]

        let listSemanticGroups = this.state.listRepetitionLinkGroups
            .filter(g => g.ListWords.some(sTextIndex => this.listTextWordsForChapter.some(w => w.TextIndex === sTextIndex)) && 
            listSimilarOppositeTagCategories.some(cat => g.ListTags.some(t => t.CategoryID === cat.ID)))

        {/* <MenuItem value={20}>Inside Verses</MenuItem>
        <MenuItem value={21}>Inside Verse Groups</MenuItem>
        <MenuItem value={22}>Between Verse Groups</MenuItem>
        <MenuItem value={23}>Unit Level 3</MenuItem> */}

        {/* <MenuItem value={'StartsRepetitionGroup'}>1</MenuItem>
        <MenuItem value={'StartsCluster'}>2</MenuItem>
        <MenuItem value={'StartsClusterGroup'}>3</MenuItem>
        <MenuItem value={'StartsLevel4Group'}>4</MenuItem> */}

        var listWordsByLine = this.state.listLines.map(l => l.Words.map(w => w.TextIndex))
        var listWordsByVerse = this.GetLinesForSideBySideMode(this.state.listLines, 'StartsRepetitionGroup').map(g => g.Lines.flatMap(l => l.Words.map(w => w.TextIndex)))
    
        for(var g of listSemanticGroups)
        {
            for(let o of [{LinkGroupType: 20, WordsByGroup: listWordsByVerse, WordsBySubunitGroup: listWordsByLine}])
            {
                for(let listWordIndexes of o.WordsByGroup)
                {
                    //get the words in the repetition link group that occur inside this unit, 
                    //but only if at least one of the words occurs in a different subunit than the others
                    //(i.e. the number of subunit groups that words in the list occur in > 1)
                    var listWordsInsideGroup = g.ListWords.filter(sTextIndex => listWordIndexes.includes(sTextIndex))
                    var nNumberOfSubUnitGroupsIncludingWords = o.WordsBySubunitGroup.filter(listWordIndexesInSubunitGroup => 
                        listWordIndexesInSubunitGroup.some(sTextIndex => listWordsInsideGroup.includes(sTextIndex))).length
                    
                    if(listWordsInsideGroup.length > 0 && nNumberOfSubUnitGroupsIncludingWords > 1)
                    {
                        var groupToAdd = {ListWords: listWordsInsideGroup, 
                            ListSyllableIndexesByWord: listWordsInsideGroup.map(sTextIndex => -1), 
                            ListTags: g.ListTags, Comment: g.Comment, 
                            IsContrast: false, 
                            IsPreposition: false,
                            IsSuffix: false,
                            Type: o.LinkGroupType, 
                            WordsForWhichParticipantRefIsForSuffix: [],
                            GeneratedFromSimilarOppositeLinks: true}

                            listToAdd.push(groupToAdd)
                    }
                }
            }
        }

        // console.log(listToAdd)

        var listToSet = this.state.listRepetitionLinkGroups.concat(listToAdd)
        this.SaveRepetitionLinkGroupsAndSetState(listToSet)
    }

    //now that we have finished the connections for the chapters with semantic links of type 8, this function probably won't get used much anymore,
    //but GenerateConnectionsAboveCurrentMaximumConnectionLevelFromCurrentConnections probably will 
    GenerateConnectionsFromSemanticLinks()
    {
        var listToReturn = []
        let listSemanticGroups = this.state.listRepetitionLinkGroups
            .filter(g => g.Type === 8 && g.ListWords.some(sTextIndex => this.listTextWordsForChapter.some(w => w.TextIndex === sTextIndex)))

        {/* <MenuItem value={20}>Inside Verses</MenuItem>
        <MenuItem value={21}>Inside Verse Groups</MenuItem>
        <MenuItem value={22}>Between Verse Groups</MenuItem>
        <MenuItem value={23}>Unit Level 3</MenuItem> */}

        {/* <MenuItem value={'StartsRepetitionGroup'}>1</MenuItem>
        <MenuItem value={'StartsCluster'}>2</MenuItem>
        <MenuItem value={'StartsClusterGroup'}>3</MenuItem>
        <MenuItem value={'StartsLevel4Group'}>4</MenuItem> */}

        var listWordsByVerse = this.GetLinesForSideBySideMode(this.state.listLines, 'StartsRepetitionGroup').map(g => g.Lines.flatMap(l => l.Words.map(w => w.TextIndex)))
        var listWordsByVerseGroup = this.GetLinesForSideBySideMode(this.state.listLines, 'StartsCluster').map(g => g.Lines.flatMap(l => l.Words.map(w => w.TextIndex)))
        var listWordsByLevel3Unit = this.GetLinesForSideBySideMode(this.state.listLines, 'StartsClusterGroup').map(g => g.Lines.flatMap(l => l.Words.map(w => w.TextIndex)))
        var listWordsByLevel4Unit = this.GetLinesForSideBySideMode(this.state.listLines, 'StartsLevel4Group').map(g => g.Lines.flatMap(l => l.Words.map(w => w.TextIndex)))
        var listWordsByChapter = [this.listTextWordsForChapter.map(w => w.TextIndex)]
    
        for(var g of listSemanticGroups)
        {
            for(let o of [{LinkGroupType: 21, WordsByGroup: listWordsByVerseGroup, WordsBySubunitGroup: listWordsByVerse}, 
                        {LinkGroupType: 22, WordsByGroup: listWordsByLevel3Unit, WordsBySubunitGroup: listWordsByVerseGroup},
                        {LinkGroupType: 23, WordsByGroup: listWordsByLevel4Unit, WordsBySubunitGroup: listWordsByLevel3Unit},
                        {LinkGroupType: 24, WordsByGroup: listWordsByChapter, WordsBySubunitGroup: listWordsByLevel4Unit}])
            {
                for(let listWordIndexes of o.WordsByGroup)
                {
                    //get the words in the repetition link group that occur inside this unit, 
                    //but only if at least one of the words occurs in a different subunit than the others
                    //(i.e. the number of subunit groups that words in the list occur in > 1)
                    var listWordsInsideGroup = g.ListWords.filter(sTextIndex => listWordIndexes.includes(sTextIndex))
                    var nNumberOfSubUnitGroupsIncludingWords = o.WordsBySubunitGroup.filter(listWordIndexesInSubunitGroup => 
                        listWordIndexesInSubunitGroup.some(sTextIndex => listWordsInsideGroup.includes(sTextIndex))).length
                    
                    if(listWordsInsideGroup.length > 0 && nNumberOfSubUnitGroupsIncludingWords > 1)
                    {
                        var groupToAdd = {ListWords: listWordsInsideGroup, 
                            ListSyllableIndexesByWord: listWordsInsideGroup.map(sTextIndex => -1), 
                            ListTags: [], Comment: g.Comment, 
                            IsContrast: false, 
                            IsPreposition: false,
                            IsSuffix: false,
                            Type: o.LinkGroupType, 
                            WordsForWhichParticipantRefIsForSuffix: [],
                            GeneratedFromSemanticLinks: true}

                        listToReturn.push(groupToAdd)
                    }
                }
            }
        }

        return listToReturn
    }

    GetMaximumConnectionLevelForCurrentChapter()
    {
        return Math.max(...this.state.listRepetitionLinkGroups.map(g => g.Type).filter(n => n >= 21 && n <= 24))
    }

    //this is intended for chapters that have connections, but there are unit levels above the current maximum level
    GenerateConnectionsAboveCurrentMaximumConnectionLevelFromCurrentConnections()
    {
        var listToReturn = []
        let nCurrentMaximumConnectionType = this.GetMaximumConnectionLevelForCurrentChapter()
        // console.log("nCurrentMaximumConnectionType", nCurrentMaximumConnectionType)

        let listSemanticGroups = this.state.listRepetitionLinkGroups
            .filter(g => g.Type === nCurrentMaximumConnectionType && g.ListWords.some(sTextIndex => this.listTextWordsForChapter.some(w => w.TextIndex === sTextIndex)))

        {/* <MenuItem value={20}>Inside Verses</MenuItem>
        <MenuItem value={21}>Inside Verse Groups</MenuItem>
        <MenuItem value={22}>Between Verse Groups</MenuItem>
        <MenuItem value={23}>Unit Level 3</MenuItem> */}

        {/* <MenuItem value={'StartsRepetitionGroup'}>1</MenuItem>
        <MenuItem value={'StartsCluster'}>2</MenuItem>
        <MenuItem value={'StartsClusterGroup'}>3</MenuItem>
        <MenuItem value={'StartsLevel4Group'}>4</MenuItem> */}

        var listWordsByVerse = this.GetLinesForSideBySideMode(this.state.listLines, 'StartsRepetitionGroup').map(g => g.Lines.flatMap(l => l.Words.map(w => w.TextIndex)))
        var listWordsByVerseGroup = this.GetLinesForSideBySideMode(this.state.listLines, 'StartsCluster').map(g => g.Lines.flatMap(l => l.Words.map(w => w.TextIndex)))
        var listWordsByLevel3Unit = this.GetLinesForSideBySideMode(this.state.listLines, 'StartsClusterGroup').map(g => g.Lines.flatMap(l => l.Words.map(w => w.TextIndex)))
        var listWordsByLevel4Unit = this.GetLinesForSideBySideMode(this.state.listLines, 'StartsLevel4Group').map(g => g.Lines.flatMap(l => l.Words.map(w => w.TextIndex)))
        var listWordsByChapter = [this.listTextWordsForChapter.map(w => w.TextIndex)]
    
        for(var g of listSemanticGroups)
        {
            for(let o of [{LinkGroupType: 21, WordsByGroup: listWordsByVerseGroup, WordsBySubunitGroup: listWordsByVerse}, 
                        {LinkGroupType: 22, WordsByGroup: listWordsByLevel3Unit, WordsBySubunitGroup: listWordsByVerseGroup},
                        {LinkGroupType: 23, WordsByGroup: listWordsByLevel4Unit, WordsBySubunitGroup: listWordsByLevel3Unit},
                        {LinkGroupType: 24, WordsByGroup: listWordsByChapter, WordsBySubunitGroup: listWordsByLevel4Unit}])
            {
                if(o.LinkGroupType < nCurrentMaximumConnectionType) continue

                for(let listWordIndexes of o.WordsByGroup)
                {
                    //get the words in the repetition link group that occur inside this unit, 
                    //but only if at least one of the words occurs in a different subunit than the others
                    //(i.e. the number of subunit groups that words in the list occur in > 1)
                    var listWordsInsideGroup = g.ListWords.filter(sTextIndex => listWordIndexes.includes(sTextIndex))
                    var nNumberOfSubUnitGroupsIncludingWords = o.WordsBySubunitGroup.filter(listWordIndexesInSubunitGroup => 
                        listWordIndexesInSubunitGroup.some(sTextIndex => listWordsInsideGroup.includes(sTextIndex))).length
                    
                    if(listWordsInsideGroup.length > 0 && nNumberOfSubUnitGroupsIncludingWords > 1)
                    {
                        var groupToAdd = {ListWords: listWordsInsideGroup, 
                            ListSyllableIndexesByWord: listWordsInsideGroup.map(sTextIndex => -1), 
                            ListTags: [], Comment: g.Comment, 
                            IsContrast: false, 
                            IsPreposition: false,
                            IsSuffix: false,
                            Type: o.LinkGroupType, 
                            WordsForWhichParticipantRefIsForSuffix: [],
                            GeneratedFromCurrentConnections: true}

                        listToReturn.push(groupToAdd)
                    }
                }
            }
        }

        return listToReturn
    }

    DeleteConnectionsAddedFromSemanticLinksForCurrentChapter()
    {
        if(!window.confirm("Are you sure you want to delete connections generated from semantic links?"))
        {
            return
        }

        var listToSet = this.state.listRepetitionLinkGroups.filter(g => 
            !(g.GeneratedFromSemanticLinks && g.ListWords.some(sTextIndex => this.listTextWordsForChapter.some(w => w.TextIndex === sTextIndex))))

        // console.log(listToSet.length, this.state.listRepetitionLinkGroups.length, 
        //     this.state.listRepetitionLinkGroups.filter(g => 
        //         g.GeneratedFromSemanticLinks && g.ListWords.some(sTextIndex => this.listTextWordsForChapter.some(w => w.TextIndex === sTextIndex)))
        //         .flatMap(g => g.ListWords.map(sTextIndex => this.GetWordWithTextIndexInChapter(sTextIndex))))

        // for(var n = 0; n < listToSet.length; n++)
        // {
        //     if(listToSet[n].GeneratedFromSemanticLinks && listToSet[n].ListWords.some(sTextIndex => this.listTextWordsForChapter.some(w => w.TextIndex === sTextIndex)))
        //     {
        //         listToSet.splice(n, 1)
        //         nChanged++
        //     }

        //     //console.log(listToSet[n].ListWords.map(sTextIndex => this.GetWordWithTextIndexInChapter(sTextIndex)))
        // }
        // console.log(nChanged)
        // console.log(listToSet.filter(g => g.GeneratedFromSemanticLinks && g.ListWords.some(sTextIndex => this.GetWordWithTextIndexInChapter(sTextIndex))))
        
        this.SaveRepetitionLinkGroupsAndSetState(listToSet)
    }

    DeleteConnectionsAddedFromConnectionsForCurrentChapter()
    {
        if(!window.confirm("Are you sure you want to delete connections generated from connections?"))
        {
            return
        }

        var listToSet = this.state.listRepetitionLinkGroups.filter(g => 
            !(g.GeneratedFromCurrentConnections && g.ListWords.some(sTextIndex => this.listTextWordsForChapter.some(w => w.TextIndex === sTextIndex))))

        this.SaveRepetitionLinkGroupsAndSetState(listToSet)
    }

    AddConnectionsFromSemanticLinks()
    {
        if(this.state.listRepetitionLinkGroups.some(g => [21, 22, 23].includes(g.Type)))
        {
            window.alert('Connection links are already in this chapter, so no links were generated.')
            return
        }

        if(!window.confirm("Are you sure you want to add connections from semantic links?"))
        {
            return
        }

        // var nChanged = 0
        // var listToSet = this.state.listRepetitionLinkGroups
        // for(var n = 0; n < listToSet.length; n++)
        // {
        //     if(listToSet[n].GeneratedFromSemanticLinks)
        //     {
        //         listToSet[n].ListSyllableIndexesByWord = listToSet[n].ListWords.map(sTextIndex => -1)
        //         nChanged++
        //     }
        //     console.log(listToSet[n])
        // }
        // console.log(nChanged)

        var listToSet = this.state.listRepetitionLinkGroups.concat(this.GenerateConnectionsFromSemanticLinks())
        this.SaveRepetitionLinkGroupsAndSetState(listToSet)
    }
    
    AddConnectionsAboveCurrentMaximumConnectionLevelFromConnectionsAtCurrentMaximumConnectionLevel()
    {
        if(!window.confirm("Are you sure you want to AddConnectionsAboveCurrentMaximumConnectionLevelFromConnectionsAtCurrentMaximumConnectionLevel?"))
        {
            return
        }

        // var nChanged = 0
        // var listToSet = this.state.listRepetitionLinkGroups
        // for(var n = 0; n < listToSet.length; n++)
        // {
        //     if(listToSet[n].GeneratedFromSemanticLinks)
        //     {
        //         listToSet[n].ListSyllableIndexesByWord = listToSet[n].ListWords.map(sTextIndex => -1)
        //         nChanged++
        //     }
        //     console.log(listToSet[n])
        // }
        // console.log(nChanged)

        //console.log([...new Set(this.GenerateConnectionsAboveCurrentMaximumConnectionLevelFromCurrentConnections().map(g => g.Type))], this.GetMaximumConnectionLevelForCurrentChapter())

        //remove the ones at the nCurrentMaximumConnectionType level, since GenerateConnectionsAboveCurrentMaximumConnectionLevelFromCurrentConnections
        //will have changed the connections for nCurrentMaximumConnectionType to only be within that level

        let nCurrentMaximumConnectionType = this.GetMaximumConnectionLevelForCurrentChapter()

        //var listForCurrentMaximumConnectionType = this.state.listRepetitionLinkGroups.filter(g => g.Type === nCurrentMaximumConnectionType)

        var listToSet = this.state.listRepetitionLinkGroups.filter(g => g.Type !== nCurrentMaximumConnectionType)
           .concat(this.GenerateConnectionsAboveCurrentMaximumConnectionLevelFromCurrentConnections())

        //console.log([...new Set(listToSet.map(g => g.Type))], 
        //[...new Set(this.state.listRepetitionLinkGroups.filter(g => g.Type !== nCurrentMaximumConnectionType).map(g => g.Type))])

        this.setState({listRepetitionLinkGroups: listToSet}, this.GenerateDevelopmentDiagramForChapterIfShowing())

        //this.SaveRepetitionLinkGroupsAndSetState(listToSet)
    }

    GetHebrewMirrorTranslationFirstDraft()
    {
        var sChapterTranslation = ''

        //number the verses starting after the superscription
        let listSuperscriptionLines = this.state.listLines.filter(l => l.IsSuperscription && l.Words.length > 0)
        let nMaxSuperscriptionVerse = listSuperscriptionLines.length === 0 ? 0 : Math.max(...listSuperscriptionLines.map(l => parseInt(l.Words[0].Verse)))

        for(var nl = 0; nl < this.state.listLines.length; nl++)
        {
            let l = this.state.listLines[nl]
            let oPreviousLine = nl === 0 ? undefined : this.state.listLines[nl - 1]
            let blnFirstLineInVerse = oPreviousLine === undefined || 
                (oPreviousLine.Words.length > 0 && l.Words[0].Verse !== oPreviousLine.Words[0].Verse)
            
            if(blnFirstLineInVerse)
            {
                let nVerseNumber = (parseInt(l.Words[0].Verse) - nMaxSuperscriptionVerse)
                if(nVerseNumber > 0) 
                {
                    sChapterTranslation += nVerseNumber + ' '
                }
            }

            for(var n = 0; n < l.Words.length; n++)
            {
                let w = l.Words[n]
                let oPreviousWord = n === 0 ? undefined : l.Words[n - 1]

                var sTranslationForWord = this.GetOurTranslationForWord(w)
                
                if(!['3270', '456', '150', '1813'].includes(w.LexicalID))
                {
                    sTranslationForWord = sTranslationForWord.toLowerCase()
                }

                if(w.LexicalID === '3270')
                {
                    sTranslationForWord = sTranslationForWord.replaceAll('the LORD', 'YHWH').replaceAll('The LORD', 'YHWH')
                }

                if(w.LexicalID === '456' && w.ConstructState !== 'c')
                {
                    sTranslationForWord = sTranslationForWord.replaceAll('God', 'ELOHIM')
                }

                if(w.LexicalID === '3828' && sTranslationForWord.trim().length === 0)
                {
                    sTranslationForWord = 'for'
                }

                sTranslationForWord = (w.Waw === "1" && !sTranslationForWord.includes('and ') ? 'and ' : '') + 
                    (oPreviousWord != undefined && oPreviousWord.ConstructState === "c" && oPreviousWord.SuffixPerson === undefined && 
                        !sTranslationForWord.includes('of ') ? 'of ' : '') + sTranslationForWord
                
                //move suffix words to the end of the translation for the word
                // for(const sSuffixWord of ['my', 'your', 'his', 'our', 'their', 'her', 'its'])
                // {
                //     let sSuffixWordPlusSpace = sSuffixWord + ' '
                //     if(sTranslationForWord.startsWith(sSuffixWord) || sTranslationForWord.includes(' ' + sSuffixWordPlusSpace))
                //     {
                //         var sPunctuationToMoveToo = ''
                //         for(const sPunctuation of [',', '.', '?', '!'])
                //         {
                //             if(sTranslationForWord.endsWith(sPunctuation))
                //             {
                //                 sPunctuationToMoveToo = sPunctuation
                //                 sTranslationForWord = sTranslationForWord.slice(0, -sPunctuation.length)
                //                 break
                //             }
                //         }

                //         sTranslationForWord = sTranslationForWord.replaceAll(sSuffixWordPlusSpace, '') + ' ' + sSuffixWord + sPunctuationToMoveToo
                //     }
                // }

                sTranslationForWord = sTranslationForWord.replaceAll("i'll", 'I will').replaceAll("i've", 'I have')
                    .replaceAll("you'll", 'you will').replaceAll("he'll", 'he will').replaceAll("they'll", 'they will')
                    .replaceAll("he's", 'he has').replaceAll("you've", 'you have').replaceAll("we've", 'we have')

                sTranslationForWord = sTranslationForWord.replaceAll(' i ', ' I ')
                if(sTranslationForWord.startsWith('i '))
                {
                    sTranslationForWord = 'I' + sTranslationForWord.slice(1)
                }

                if(blnFirstLineInVerse && n === 0)
                {
                    //capitalize first letter
                    sTranslationForWord = sTranslationForWord.charAt(0).toUpperCase() + sTranslationForWord.slice(1)
                }

                // "Form": "v", "Person": "2", "Gender": "m", "Number": "p"
                if(w.Person === '2' && w.Number === 'p')
                {
                    sTranslationForWord += '(pl.)'
                }

                if(w.DefiniteArticle === '1' && !(sTranslationForWord.includes('the ') || sTranslationForWord.includes('The ')))
                {
                    sTranslationForWord += '[the?]'
                }
                else if(w.DefiniteArticle === '0' && (sTranslationForWord.includes('the ') || sTranslationForWord.includes('The ')))
                {
                    sTranslationForWord += '[!the?]'
                }

                if(w.Waw === '1' && !(sTranslationForWord.includes('and ') || sTranslationForWord.includes('And ')))
                {
                    sTranslationForWord += '[and?]'
                }
                else if(w.Waw === '0' && (sTranslationForWord.includes('and ') || sTranslationForWord.includes('And ')))
                {
                    sTranslationForWord += '[!and?]'
                }

                //console.log(w.FullText) //sTranslationForWord)
                sChapterTranslation += sTranslationForWord + (w.FullText.endsWith('־') ? '-' :  ' ')
            }

            if(sChapterTranslation.endsWith(' '))
            {
                sChapterTranslation = sChapterTranslation.slice(0, -1)
            }

            sChapterTranslation += '\n'
        }

        return sChapterTranslation
    }

	// FindIndexOfColonInLinesList(colonToFind, otherList)
	// {
	// 	return otherList.findIndex(r => 
	// 		parseInt(r.TextIndexRangeBegin) === parseInt(colonToFind.TextIndexRangeBegin) &&
	// 		parseInt(r.TextIndexRangeEnd) === parseInt(colonToFind.TextIndexRangeEnd))
	// }

	// GetNextWordLinkGroupValueInChapter()
	// {
	// 	return Math.max(...this.listTextWordsForChapter.flatMap(w => this.GetLinkedWordsListForWord(w).map(s => parseInt(s)))) + 1;
	// }

	// GetNextLineLinkGroupValueInChapter()
	// {
	// 	return Math.max(...this.state.listLines.flatMap(l => this.GetLinkedLinesListForLine(l).map(s => parseInt(s)))) + 1;
	// }

    GenerateRepetitionLinkGroupsFromPGroups()
    {
        var listRepetitionLinkGroupsGenerated = [];

        fetch("HebrewTextData/allpsalmschapters.json")
        .then(res => res.json())
        .then(data => 
        {
            this.listTextWordsForAllChapters = data.OSHB;

            var textWordsByChapter = this.GroupArrayByKey(this.listTextWordsForAllChapters, "Chapter");
            this.listClausesForAllChapters = new Map();
            for(var sChapterToDo of Object.keys(textWordsByChapter))
            {						
                this.listClausesForAllChapters.set(parseInt(sChapterToDo), this.CalculateClauses(textWordsByChapter[sChapterToDo]));
            }

            fetch("LineData/allpsalmslines.json")
            .then(res => res.json())
            .then(data => 
            {
                var listColasForAllChapters = data.Lines;					
                listColasForAllChapters = this.SortLines(listColasForAllChapters);	

                for(var sChapterToDo of Object.keys(this.GroupArrayByKey(listColasForAllChapters, "Chapter")))
                {							
                    var nChapterToDo = parseInt(sChapterToDo);

                    var locallyStoredColaForChapter = this.LoadLines(19, nChapterToDo);
                    var listLinesForChapterToDo = locallyStoredColaForChapter != null && locallyStoredColaForChapter.length > 0 ? locallyStoredColaForChapter :
                        listColasForAllChapters.filter(r => r.Chapter === sChapterToDo);

                    this.CalculateLines(listLinesForChapterToDo, textWordsByChapter[sChapterToDo]);
                    this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesForChapterToDo, true)

                    for(var g of this.listRepetitionGroups)
                    {
                        for(var pGroup of g.ListPGroupValuesInLineGroup)
                        {
                            var listWordsInGroup = [];
                            for(var l of g.Lines)
                                listWordsInGroup = listWordsInGroup.concat(l.Words.filter(w => this.GetPGroupForWord(w) == pGroup));

                            if(listWordsInGroup.length > 1)
                            {
                                var newGroup = {ListWords: listWordsInGroup, 
                                    ListTags: this.CalculateRepetitionLinkGroupCategoriesFromWords(listWordsInGroup, listLinesForChapterToDo, false, false), 
                                    Comment: '', Type: 1, WordsForWhichParticipantRefIsForSuffix: []};
                                listRepetitionLinkGroupsGenerated.push(newGroup);
                            }
                        }
                    }
                }
            })
            .catch(error => this.setState({ sInfoToShow: error }));
        })

        // var test2 = listRepetitionLinkGroupsGenerated;
        //this.SaveRepetitionLinkGroupsAndSetState(listRepetitionLinkGroupsGenerated);
    }

    GetWordPositionInLine(w, listLinesToUse, blnReturnIndexOnly)
    {
        var lineItIsIn = listLinesToUse.find(l => l.Words.some(w2 => w === w2));
        var nIndexInLine = lineItIsIn.Words.findIndex(w2 => w === w2);
        return blnReturnIndexOnly ? nIndexInLine : 
            nIndexInLine === 0 ? "Start" : nIndexInLine === lineItIsIn.Words.length - 1 ? "End" : nIndexInLine.toString();
    }

    CheckForPhraseFunctionPropertyToNoneInNextLine(listWordsSeparatedIntoLines, sPhraseFunction, blnReverse)
    {
        return blnReverse ? 

            listWordsSeparatedIntoLines.some((line, index, arr) => index < arr.length - 1 && 
                !line.some(w => this.GetPhraseFunction(w) === sPhraseFunction) && arr[index + 1].some(w => this.GetPhraseFunction(w) === sPhraseFunction)) :

            listWordsSeparatedIntoLines.some((line, index, arr) => index < arr.length - 1 && 
                line.some(w => this.GetPhraseFunction(w) === sPhraseFunction) && !arr[index + 1].some(w => this.GetPhraseFunction(w) === sPhraseFunction));
    }

    CheckForLexicalIDListToNoneInNextLine(listWordsSeparatedIntoLines, listLexicalIDs, blnReverse)
    {
        return blnReverse ? 

            listWordsSeparatedIntoLines.some((line, index, arr) => index < arr.length - 1 && 
                !line.some(w => listLexicalIDs.includes(w.LexicalID)) && arr[index + 1].some(w => listLexicalIDs.includes(w.LexicalID))) :

            listWordsSeparatedIntoLines.some((line, index, arr) => index < arr.length - 1 && 
                line.some(w => listLexicalIDs.includes(w.LexicalID)) && !arr[index + 1].some(w => listLexicalIDs.includes(w.LexicalID)));
    }

    CheckForLexicalIDListInConsecutiveLines(listWordsSeparatedIntoLines, listLexicalIDs)
    {
        return listWordsSeparatedIntoLines.some((line, index, arr) => index < arr.length - 1 && 
            line.some(w => listLexicalIDs.includes(w.LexicalID)) && arr[index + 1].some(w => listLexicalIDs.includes(w.LexicalID)));
    }

    ArePrepositionsSemanticallyOpposite(w1, w2)
    {
        // 903	בֽוֹ׃	117
        // 4926	עִמּ֑וֹ	67           
        // 3892	כְּמוֹ־	27
        // 877	אֶת־	23
        
        // 6361	עַל־	318   
        // 9233	תַֽחַת־	22 
        
        // 4077	לָֽמוֹ׃	297
        // 435	אֵלֵ֣ימוֹ	148
       
        // 6116	עַד־	80
        // 4790	מִמֶּ֣נּוּ	76

        // 333	אַ֭חֲרֶיהָ	8
        // 5393	מִנֶּגְדּ֑וֹ	35
		
		//if neither are prepositions and neither have attached preposition, return false.
        if(!(w1.WordType === "R" || w2.WordType === "R") && !(w1.Preposition != undefined ||  w2.Preposition != undefined)) return false;

        var listSemanticallyOppositePrepositions = [["5393", "333"], ["6361", "9233"], ["4790", "435"], ["4790", "6116"], 
            ["4790", "6361"], ["4790", "4077"]];
        var lexicalIDs = [w1.LexicalID, w2.LexicalID];
        var listToTypePrepositionsLexicalIDs = ["435", "6116", "6361", "4077"];

        return ((w1.Preposition === "l" || listToTypePrepositionsLexicalIDs.includes(w1.LexicalID)) && (w2.Preposition === "m" || w2.LexicalID === "4790")) || 
               ((w2.Preposition === "l" || listToTypePrepositionsLexicalIDs.includes(w2.LexicalID)) && (w1.Preposition === "m" || w1.LexicalID === "4790")) ||
            listSemanticallyOppositePrepositions.some(pair => lexicalIDs.includes(pair[0]) && lexicalIDs.includes(pair[1]));
    }

    ArePrepositionsSemanticallySimilar(w1, w2)
    {
        // 903	בֽוֹ׃	117
        // 4926	עִמּ֑וֹ	67           
        // 3892	כְּמוֹ־	27
        // 877	אֶת־	23
        
        // 6361	עַל־	318   
        // 9233	תַֽחַת־	22 
        
        // 4077	לָֽמוֹ׃	297
        // 435	אֵלֵ֣ימוֹ	148
       
        // 6116	עַד־	80
        // 4790	מִמֶּ֣נּוּ	76

        // 333	אַ֭חֲרֶיהָ	8
        // 5393	מִנֶּגְדּ֑וֹ	35
		
		//if neither are prepositions and neither have attached preposition, return false.
        if(!(w1.WordType === "R" || w2.WordType === "R") && !(w1.Preposition != undefined ||  w2.Preposition != undefined)) return false;

        var listToTypePrepositionsLexicalIDs = ["435", "6116", "6361", "4077"];
        var listFromTypePrepositionsLexicalIDs = ["4790"];
        var listAtTypePrepositionsLexicalIDs = ["903","4926","877","6361","5393","6934","333"];

        return (w1.Preposition === "l" && listToTypePrepositionsLexicalIDs.includes(w2.LexicalID)) || 
               (w1.Preposition === "m" && listFromTypePrepositionsLexicalIDs.includes(w2.LexicalID)) || 
               (w1.Preposition === "b" && listAtTypePrepositionsLexicalIDs.includes(w2.LexicalID)) ||
               (w2.Preposition === "l" && listToTypePrepositionsLexicalIDs.includes(w1.LexicalID)) || 
               (w2.Preposition === "m" && listFromTypePrepositionsLexicalIDs.includes(w1.LexicalID)) || 
               (w2.Preposition === "b" && listAtTypePrepositionsLexicalIDs.includes(w1.LexicalID)) ||
               (listToTypePrepositionsLexicalIDs.includes(w1.LexicalID) && listToTypePrepositionsLexicalIDs.includes(w2.LexicalID)) ||
               (listFromTypePrepositionsLexicalIDs.includes(w1.LexicalID) && listFromTypePrepositionsLexicalIDs.includes(w2.LexicalID)) ||
               (listAtTypePrepositionsLexicalIDs.includes(w1.LexicalID) && listAtTypePrepositionsLexicalIDs.includes(w2.LexicalID));
    }

    SamePreposition(w1, w2)
    {
        var lLexicalID = "4077"
        var mLexicalID = "4790"
        var bLexicalID = "903"
        var listAttachedPrepLexicalIDs = [lLexicalID, mLexicalID, bLexicalID]

        return (w1.Preposition === w2.Preposition) || 
        (w1.LexicalID === w2.LexicalID && listAttachedPrepLexicalIDs.includes(w1.LexicalID)) ||
        (w1.Preposition === "l" && lLexicalID === w2.LexicalID) || 
        (w1.Preposition === "m" && mLexicalID === w2.LexicalID) || 
        (w1.Preposition === "b" && bLexicalID === w2.LexicalID) ||
        (w2.Preposition === "l" && lLexicalID === w1.LexicalID) || 
        (w2.Preposition === "m" && mLexicalID === w1.LexicalID) || 
        (w2.Preposition === "b" && bLexicalID === w1.LexicalID)
    }

    AreWordsFirstAndSecondPersonComplement(w1, w2)
    {
        // 880	אַ֑תָּה	119
        // 612	וַ֭אֲנִי	70
        // 2016	וְה֗וּא	56
        // 2075	הֵֽמָּה׃	28
        // 2183	זֶ֭ה	21
        // 2158	זֹ֑את	21
        // 618	וְאָנֹכִ֣י	13
        // 610	וַאֲנַ֓חְנוּ ׀	8
        // 450	אֵ֑לֶּה	8
        
        if((w1.WordType != "P" || w2.WordType != "P") && 
           (w1.Person === undefined ||  w2.Person === undefined) && 
           (w1.SuffixPerson === undefined ||  w2.SuffixPerson === undefined)) return false;

        var listComplements = [["880", "612"], ["880", "618"], ["880", "610"]];
        var lexicalIDs = [w1.LexicalID, w2.LexicalID];

        return (w1.Person === "1" && w2.Person === "2") || (w2.Person === "1" && w1.Person === "2") ||
            (w1.SuffixPerson === "1" && w2.SuffixPerson === "2") || (w2.SuffixPerson === "1" && w1.SuffixPerson === "2") ||
            listComplements.some(pair => lexicalIDs.includes(pair[0]) && lexicalIDs.includes(pair[1]));
    }

    AreWordsSecondAndThirdPersonComplement(w1, w2)
    {
        // 880	אַ֑תָּה	119
        // 612	וַ֭אֲנִי	70
        // 2016	וְה֗וּא	56
        // 2075	הֵֽמָּה׃	28
        // 2183	זֶ֭ה	21
        // 2158	זֹ֑את	21
        // 618	וְאָנֹכִ֣י	13
        // 610	וַאֲנַ֓חְנוּ ׀	8
        // 450	אֵ֑לֶּה	8
        
        if((w1.WordType != "P" || w2.WordType != "P") && 
           (w1.Person === undefined ||  w2.Person === undefined) && 
           (w1.SuffixPerson === undefined ||  w2.SuffixPerson === undefined)) return false;

        var listComplements = [["880", "2016"], ["880", "2075"], ["880", "2183"], ["880", "2158"], ["880", "450"]];
        var lexicalIDs = [w1.LexicalID, w2.LexicalID];

        return (w1.Person === "2" && w2.Person === "3") || (w2.Person === "2" && w1.Person === "3") ||
            (w1.SuffixPerson === "3" && w2.SuffixPerson === "2") || (w2.SuffixPerson === "3" && w1.SuffixPerson === "2") ||
            listComplements.some(pair => lexicalIDs.includes(pair[0]) && lexicalIDs.includes(pair[1]));
    }

    AreWordsFirstAndThirdPersonComplement(w1, w2)
    {
        // 880	אַ֑תָּה	119
        // 612	וַ֭אֲנִי	70
        // 2016	וְה֗וּא	56
        // 2075	הֵֽמָּה׃	28
        // 2183	זֶ֭ה	21
        // 2158	זֹ֑את	21
        // 618	וְאָנֹכִ֣י	13
        // 610	וַאֲנַ֓חְנוּ ׀	8
        // 450	אֵ֑לֶּה	8
        
        if((w1.WordType != "P" || w2.WordType != "P") && 
           (w1.Person === undefined ||  w2.Person === undefined) && 
           (w1.SuffixPerson === undefined ||  w2.SuffixPerson === undefined)) return false;

        var listComplements = [["612", "2016"], ["612", "2075"], ["612", "2183"], ["612", "2158"], ["612", "450"],
            ["618", "2016"], ["618", "2075"], ["618", "2183"], ["618", "2158"], ["618", "450"],
            ["610", "2016"], ["610", "2075"], ["610", "2183"], ["610", "2158"], ["610", "450"]];
        var lexicalIDs = [w1.LexicalID, w2.LexicalID];

        return (w1.Person === "1" && w2.Person === "3") || (w2.Person === "1" && w1.Person === "3") ||
            (w1.SuffixPerson === "3" && w2.SuffixPerson === "1") || (w2.SuffixPerson === "3" && w1.SuffixPerson === "1") ||
            listComplements.some(pair => lexicalIDs.includes(pair[0]) && lexicalIDs.includes(pair[1]));
    }

    CanCompareWordWithWordType(w, sWordType)
    {
        return w.WordType === sWordType ||
            ((w.Form === "r" || w.Form === "s") && (sWordType === "V" || sWordType === "N")) ||
            (w.WordType === "N" && sWordType === "A") ||
            (w.WordType === "A" && sWordType === "N");
    }

	SameValueForFieldWithinGroup(listWordsInGroup, sFieldName)
	{
		
		return Object.values(this.GroupArrayByKey(listWordsInGroup, sFieldName)).length < listWordsInGroup.length;
	}

    CalculateRepetitionLinkGroupCategoriesFromWords(listWordsInRepetitionLinkGroup, listLinesToUse, blnForCorrespondenceLens, blnForSameDifferentLens)
    {
        if(listWordsInRepetitionLinkGroup.length < 2) return [];

        //var listCategories = [];
        
        //{"ID":"31","Group":"1","Desc":"initial rhyme"},{"ID":"108","Group":"1","Desc":"end rhyme"},{"ID":"109","Group":"1","Desc":"metathes rhyme"},{"ID":"122","Group":"1","Desc":"1 cons rhyme"},{"ID":"119","Group":"1","Desc":"2 cons rhyme"},{"ID":"120","Group":"1","Desc":"3 cons rhyme"},{"ID":"121","Group":"1","Desc":"c+v rhyme"},{"ID":"110","Group":"1","Desc":"other rhyme"},

        //only look at NVAPR, too exclude particles and negatives, etc.
        
        // if(listVerbsInGroup.length > 1)
        // {
            //if(this.GetPGN(listVerbsInGroup[0]) != this.GetPGN(listVerbsInGroup[1])) listCategories.push("32");
            
            // if(listVerbsInGroup.some(w => w.Stem === "p" || w.Stem === "P") && 
            //    listVerbsInGroup.some(w => w.Stem === "h" || w.Stem === "H")) listCategories.push("35"); //causative stem balance

            // if(listVerbsInGroup.some(w => w.Stem === "q" || w.Stem === "p" || w.Stem === "h" || w.Stem === "t") && 
            //    listVerbsInGroup.some(w => w.Stem === "Q" || w.Stem === "P" || w.Stem === "H" || w.Stem === "N")) 
            //    listCategories.push("36");  //active-passive stem balance

            //stem balance
            // if(listVerbsInGroup[0].Stem != listVerbsInGroup[1].Stem && (!listCategories.includes("35") || !listCategories.includes("36"))) 
            //    listCategories.push("33");

            // if(listVerbsInGroup[0].Form != listVerbsInGroup[1].Form) listCategories.push("34");  //form balance

            // if(listCategories.length === 0) listCategories.push("111"); //same morph
        // }
        // else if(listNAInGroup.length > 1 && Object.keys(this.GroupArrayByKey(listNAInGroup, "WordType")).length === 1)
        // {
        //     // if(listNAInGroup[0].Gender != listNAInGroup[1].Gender && listNAInGroup[0].Gender != undefined && listNAInGroup[1].Gender != undefined) listCategories.push("37");  //gender balance
        //     // if(listNAInGroup[0].Number != listNAInGroup[1].Number && listNAInGroup[0].Number != undefined && listNAInGroup[1].Number != undefined) listCategories.push("38");  //number balance

        //     if(listNAInGroup.length > 2)
        //     {
        //         if(listNAInGroup[0].ConstructState === "c" && listNAInGroup[2].ConstructState === "a") listCategories.push("85");  //construct chain -> single noun
        //         else if(listNAInGroup[0].ConstructState === "a" && listNAInGroup[1].ConstructState === "c") listCategories.push("86");  //single noun -> construct chain
        //     }
        // }

        // var sSuffixPGN1 = this.GetSuffixPGN(listWordsInGroup[0]);
        // var sSuffixPGN2 = this.GetSuffixPGN(listWordsInGroup[1]);

        // if(sSuffixPGN1 != "" && sSuffixPGN2 === "") listCategories.push("41"); //"suffix -> no suffix"
        // else if(sSuffixPGN1 === "" && sSuffixPGN2 != "") listCategories.push("42"); //"no suffix -> suffix"
        // else if(sSuffixPGN1 != sSuffixPGN2) listCategories.push("40");  //diff suffix
        // else if(sSuffixPGN1 != "" && sSuffixPGN1 === sSuffixPGN2) listCategories.push("29"); //same suffix

        // if(listWordsInGroup[0].Preposition != undefined && listWordsInGroup[1].Preposition != undefined)
        // { 
        //     if(listWordsInGroup[0].Preposition === listWordsInGroup[1].Preposition) listCategories.push("137");  //same prep, same sense
        //     else listCategories.push("48");  //diff prep, diff sense
        // }
        // else if(listWordsInGroup[0].Preposition != undefined && listWordsInGroup[1].Preposition === undefined) listCategories.push("50");  //preposition -> no preposition
        // else if(listWordsInGroup[1].Preposition != undefined && listWordsInGroup[0].Preposition === undefined) listCategories.push("51");  //no preposition -> preposition
        
        // if(listWordsInGroup[0].DefiniteArticle === "0" && listWordsInGroup.filter(w => w.DefiniteArticle === "1").length > 0) 
        // listSpecialCategories.push("130");  //"2nd line init waw"

        // if(listNAInGroup.length > 2)
        // {
        //     if(listNAInGroup[0].ConstructState === "c" && listNAInGroup[2].ConstructState === "a") listCategories.push("85");  //construct chain -> single noun
        //     else if(listNAInGroup[0].ConstructState === "a" && listNAInGroup[1].ConstructState === "c") listCategories.push("86");  //single noun -> construct chain
        // }

        var listToReturn = [];
        var listWordsSeparatedIntoLines = listLinesToUse.map(l => l.Words.filter(w => listWordsInRepetitionLinkGroup.includes(w))).filter(list => list.length > 0).sort((a,b) => a.Length - b.Length);
        
        //TODO: when there is only one line - group them similarly by word type within that line (N V N -> (N, N))   
        //if(listWordsSeparatedIntoLines.length === 1) blah

        //sort listWordsSeparatedIntoLines by length of the lists within it, and starting with the shortest until the next to last one,     
        //iterate over all the words, 
        
        var listWordsGroupedAcrossLinesByWordTypes = [];
        for(var nLine = 0; nLine < listWordsSeparatedIntoLines.length - 1; nLine++)
        {
            var listWordsInLine = listWordsSeparatedIntoLines[nLine];
            for(var sWordType of listWordsInLine.map(w => w.WordType))
            {
                var listWordsProcessedSoFar = listWordsGroupedAcrossLinesByWordTypes.flat();

                //and if the wordtype for that word has >= 1 matching wordtypes in the other lists, 
                var blnThisWordTypeOccursInOtherLines = listWordsSeparatedIntoLines.filter((line, index) => index > nLine).
                    some(line => line.some(w => !listWordsProcessedSoFar.includes(w) && this.CanCompareWordWithWordType(w, sWordType))); 
                if(blnThisWordTypeOccursInOtherLines)
                {
                    //extract from all the arrays into a list all the words with that wordtype
                    //[[V], [V N]] -> [V, V]
                    //[[N], [N0 N1], [N]] -> N0 is construct ? [N, N0, N] : [N, N0, N1, N]
                    // [N0, N1] -> [N0, N1]; [V0, V1] -> [V0, V1]

                    //if multiple words with compatible word types are in the same line, choose the first if it is construct, 
                    //or if the words are of different wordtypes. Revisit this criterion as necessary.

                    var listWordsByLineForWordType = listWordsSeparatedIntoLines.map(line => {
                        var listWordsWithWordTypeForLine = line.filter(w => this.CanCompareWordWithWordType(w, sWordType));
                        return (listWordsWithWordTypeForLine.length > 1 && 
                            (listWordsWithWordTypeForLine[0].ConstructState === "c" || Object.keys(this.GroupArrayByKey(listWordsWithWordTypeForLine, "WordType")).length > 1)) ? 
                            [listWordsWithWordTypeForLine[0]] : listWordsWithWordTypeForLine; }).filter(line => line.length > 0);

                    listWordsGroupedAcrossLinesByWordTypes.push(listWordsByLineForWordType.flat());
                }
            }
        }

        var blnCompareOnlyLimitedSet = false;

        //if there is only one word in each line and they are not comparable word types, at least compare some fields
        if(listWordsGroupedAcrossLinesByWordTypes.length === 0 && listWordsSeparatedIntoLines.every(line => line.length === 1))
        {
            blnCompareOnlyLimitedSet = true;
            listWordsGroupedAcrossLinesByWordTypes = [listWordsSeparatedIntoLines.flat()];
        }
        
        for(var listWordsInGroup of listWordsGroupedAcrossLinesByWordTypes)
        {
			if(listWordsInGroup.length === 0) continue;

            var listSameCategories = [];
            var listDifferentCategories = [];
            var listSpecialCategories = [];

			var listPropertiesToCompare = "";
			var listPropertiesToCompareEvenIfUndefined = ["Preposition", "SuffixType"];

			if(blnForCorrespondenceLens) 
			{
				listPropertiesToCompare = ["Waw", "DefiniteArticle", "Preposition", "SuffixPerson"];
				if(listWordsInGroup[0].WordType === "V") listPropertiesToCompare = listPropertiesToCompare.concat(["Stem", "Form", "PGN"]);
			}
            else if(blnForSameDifferentLens) 
			{
				listPropertiesToCompare = blnCompareOnlyLimitedSet ? 
				["Waw", "Preposition", "SuffixPerson", "SuffixGender", "SuffixNumber", "SuffixType"] :

				["Person", "Gender", "Number", "ConstructState", "Waw", 
				"DefiniteArticle", "Preposition", "SuffixPerson","SuffixGender","SuffixNumber", "SuffixType"]; 

				if(listWordsInGroup[0].WordType === "V" && !blnCompareOnlyLimitedSet) listPropertiesToCompare = listPropertiesToCompare.concat(["Stem", "Form"])
			}
			else
			{
				listPropertiesToCompare = blnCompareOnlyLimitedSet ? 
				["WordType", "Waw", "Preposition", "SuffixPerson","SuffixGender","SuffixNumber", "phrase_function", "phrase_type", "SuffixType"] :

				["WordType", "Person", "Gender", "Number", "ConstructState", "Waw", 
				"DefiniteArticle", "Preposition", "SuffixPerson","SuffixGender","SuffixNumber", "phrase_function", "phrase_type", "SuffixType"]; 

				if(listWordsInGroup[0].WordType === "V" && !blnCompareOnlyLimitedSet) listPropertiesToCompare = listPropertiesToCompare.concat(["Stem", "Form"]);
			}
			
            for(var sToCompare of listPropertiesToCompare)
            {
				var blnSame = false;
				
				if(sToCompare === "PGN")
                {
					var listOnesWithDefinedPGN = listWordsInGroup.filter(w => w.Person != undefined);
                    blnSame = [...new Set(listOnesWithDefinedPGN.map(w => this.GetPGN(w)))].length < listOnesWithDefinedPGN.length;
				}
				else
				{
					if(!listPropertiesToCompareEvenIfUndefined.includes(sToCompare) && listWordsInGroup.some(w => w[sToCompare] === undefined)) continue; //only compare where they both have values
					if(listWordsInGroup.every(w => w[sToCompare] === undefined)) continue; //neither same or different
					//if(sToCompare === "WordType" && listSameCategories.includes("Lexeme")) continue; //obviously they are the same word type

					if(sToCompare === "phrase_function")
						blnSame = listWordsInGroup.map(w => this.MapPhraseFunctionToLetter(w, true)).every((s, i, arr) => s === arr[0]);              
					else if(sToCompare === "ConstructState")
					{
						//suffixed words are marked as construct, and we are thinking of non-suffix construct state here, so exclude them from comparison
						blnSame = listWordsInGroup.filter(w => w.SuffixPerson === undefined).map(w => w.ConstructState).every((s, i, arr) => s === arr[0]);
					}
					else if(sToCompare === "Gender")
					{
						//c gender matches everything else, so exclude it
						blnSame = listWordsInGroup.filter(w => w.Gender != "b" && w.Gender != "c").map(w => w.Gender).every((s, i, arr) => s === arr[0]);
					}
					else if(sToCompare === "SuffixGender")
					{
						blnSame = listWordsInGroup.filter(w => w.Gender != "b" && w.SuffixGender != "c").map(w => w.SuffixGender).every((s, i, arr) => s === arr[0]);
					}
					else if(blnForCorrespondenceLens && (sToCompare === "Waw" || sToCompare === "DefiniteArticle"))
					{
						blnSame = listWordsInGroup.filter(w => w[sToCompare] === "1").length >= 2;
					}
                    else if(sToCompare === "Preposition")
					{
						blnSame = true
                        for(var w1 of listWordsInGroup)
                        {
                            for(var w2 of listWordsInGroup)
                            {
                                if(w1 === w2) continue
                                if(!this.SamePreposition(w1, w2))
                                {
                                    blnSame = false
                                    break
                                }
                            }

                            if(!blnSame) break
                        }
					}
					else blnSame = listWordsInGroup[0][sToCompare] != undefined && this.SameValueForFieldWithinGroup(listWordsInGroup, sToCompare);
				}

                if(blnSame) 
                {
                    listSameCategories.push(sToCompare);
                }

                if(!blnSame)
                {
                    listDifferentCategories.push(sToCompare);

                    if(sToCompare === "Stem")
                    {
                        if(listWordsInGroup.some(w => w.Stem === "p" || w.Stem === "P") && 
                        listWordsInGroup.some(w => w.Stem === "h" || w.Stem === "H")) listSpecialCategories.push("Causative Balance");

                        if(listWordsInGroup.some(w => w.Stem === "q" || w.Stem === "p" || w.Stem === "h" || w.Stem === "t") && 
                        listWordsInGroup.some(w => w.Stem === "Q" || w.Stem === "P" || w.Stem === "H" || w.Stem === "N")) 
                        listSpecialCategories.push("Active-Passive Balance");
                    }
                    else if(sToCompare === "Preposition")
                    {
                        if(listWordsInGroup.every(w => w.Preposition != undefined)) listSpecialCategories.push("All Have Prepositions");
                    }
                }
            }
			
			//groups can have 3, and if >= two of the three have the same property, we want to flag it.
            if(!blnForSameDifferentLens)
            {
                if(this.SameValueForFieldWithinGroup(listWordsInGroup, "LexicalID")) listSameCategories.push("Lexeme");
                else if(this.SameValueForFieldWithinGroup(listWordsInGroup, "ParentRoot")) listSameCategories.push("Root");
                else listDifferentCategories.push("Lexeme");
            }

            var blnSameLinePosition = true
            for(var w1 of listWordsInGroup)
            {
                var lineFor1 = listLinesToUse.find(l => l.Words.some(w => w === w1))
                var nIndexInLineFor1 = lineFor1.Words.findIndex(w => w === w1)
                var nIndexFromLastInLineFor1 = lineFor1.Words.length - nIndexInLineFor1 - 1

                for(var w2 of listWordsInGroup)
                {
                    if(w1 === w2) continue
                    var lineFor2 = listLinesToUse.find(l => l.Words.some(w => w === w2))
                    var nIndexInLineFor2 = lineFor2.Words.findIndex(w => w === w2)
                    var nIndexFromLastInLineFor2 = lineFor2.Words.length - nIndexInLineFor2 - 1

                    if(Math.abs(nIndexInLineFor1 - nIndexInLineFor2) >= 3 || Math.abs(nIndexFromLastInLineFor1 - nIndexFromLastInLineFor2) >= 3) 
                    {
                        blnSameLinePosition = false
                        break
                    }
                }
            }

            (blnSameLinePosition ? listSameCategories : listDifferentCategories).push("PositionInLine")

            // var listWordPositionsInLine = listWordsInGroup.map(w => this.GetWordPositionInLine(w, listLinesToUse, false));
            // var listWordPositionsInLineIndexesOnly = listWordsInGroup.map(w => this.GetWordPositionInLine(w, listLinesToUse, true));
            // if(listWordPositionsInLine.every(s => s === listWordPositionsInLine[0]) ||
            //     listWordPositionsInLineIndexesOnly.every(n => n === listWordPositionsInLineIndexesOnly[0])) listSameCategories.push("PositionInLine");
            // else listDifferentCategories.push("PositionInLine");

            // if(listWordPositionsInLine.some(s => s === "Start") && listWordPositionsInLine.some(s => s === "End")) 
            //     listSpecialCategories.push("OppositePositionInLine");

			if(!blnForCorrespondenceLens)
			{
				if(listSameCategories.includes("SuffixPerson") && listSameCategories.includes("SuffixNumber") && listSameCategories.includes("SuffixGender") &&
				listWordsInGroup[0].SuffixPerson === "3" && listWordsInGroup[0].SuffixNumber === "m" && listWordsInGroup[0].SuffixGender === "s" && 
				listWordsInGroup.reduce(function(rv, x) {
					(rv[x.SeparatedText.split("/")[0]] = rv[x.SeparatedText.split("/")[0]] || []).push(x);
					return rv;
					}, {}).length > 1) listDifferentCategories.push("3ms Suffix");
			}

            //{"ID":"158","Group":"1","Desc":"same word order"},{"ID":"169","Group":"8","Desc":"inverted word order"}
            //{"ID":"47","Group":"6","Desc":"cohortative suffix -> 3 he"},
            //{"ID":"124","Group":"3","Desc":"v -> v+adv"},{"ID":"125","Group":"3","Desc":"v+adv -> v"},{"ID":"126","Group":"3","Desc":"v -> v+pp"},
            //{"ID":"127","Group":"3","Desc":"v+pp -> v"},{"ID":"131","Group":"3","Desc":"v+do -> v"},{"ID":"132","Group":"3","Desc":"v -> v+do"},
            //{"ID":"133","Group":"3","Desc":"v -> v+io"},{"ID":"134","Group":"3","Desc":"v+io -> v"},{"ID":"135","Group":"3","Desc":"v+do -> v+io"},
            //{"ID":"136","Group":"3","Desc":"v+io -> v+do"}
            
            //this.GroupBySemanticDomain(listApplicableWords)
            //perhaps put ContainsInvertedWordOrder marker on lines?
            ////"Interrogative":"0","AttachedRelative":"0"

			var nRatioOfSameToDifferent = listSameCategories.length / (1.0 * listDifferentCategories.length);
			if(!isFinite(nRatioOfSameToDifferent)) nRatioOfSameToDifferent = listSameCategories.length; //approximate it

            listToReturn.push({Same: listSameCategories, Different: listDifferentCategories, Special: listSpecialCategories, 
				PrimaryWordType: listWordsInGroup[0].WordType, RatioOfSameToDifferent: nRatioOfSameToDifferent});
        }
        
        var blnContainsPrepositionsSemanticallyOpposite = false;
        var blnContainsWordsFirstAndSecondPerson = false;
        var blnContainsWordsSecondAndThirdPerson = false;
        var blnContainsWordsFirstAndThirdPerson = false;

        var listAllWordsToCompare = listWordsSeparatedIntoLines.flat();
        for(var w1 of listAllWordsToCompare)
        {
            if(listAllWordsToCompare.some(w2 => this.ArePrepositionsSemanticallyOpposite(w1, w2))) 
            {
                blnContainsPrepositionsSemanticallyOpposite = true; 
                break;
            }
        }

        for(var w1 of listAllWordsToCompare)
        {
            if(listAllWordsToCompare.some(w2 => this.AreWordsFirstAndSecondPersonComplement(w1, w2))) 
            {
                blnContainsWordsFirstAndSecondPerson = true; 
                break;
            }
        }

		if(!blnForCorrespondenceLens)
		{
			for(var w1 of listAllWordsToCompare)
			{
				if(listAllWordsToCompare.some(w2 => this.AreWordsSecondAndThirdPersonComplement(w1, w2))) 
				{
					blnContainsWordsSecondAndThirdPerson = true; 
					break;
				}
			}

			for(var w1 of listAllWordsToCompare)
			{
				if(listAllWordsToCompare.some(w2 => this.AreWordsFirstAndThirdPersonComplement(w1, w2))) 
				{
					blnContainsWordsFirstAndThirdPerson = true; 
					break;
				}
			}
		}

		var blnSingleNounToConstruct = listWordsSeparatedIntoLines.some((line, index, arr) => index < arr.length - 1 && 
				line.every(w => w.ConstructState === "a" || w.SuffixPerson != undefined) && arr[index + 1].some(w => w.ConstructState === "c" && w.SuffixPerson === undefined));

		var blnConstructToSingleNoun = listWordsSeparatedIntoLines.some((line, index, arr) => index < arr.length - 1 && 
			line.some(w => w.ConstructState === "c" && w.SuffixPerson === undefined) && arr[index + 1].every(w => w.ConstructState === "a" || w.SuffixPerson != undefined));

        var blnSameSuffixPGNBetweenVerbAndNonVerb = listWordsSeparatedIntoLines.some((line, index, arr) => {
            var blnToReturn = false

            if(index < arr.length - 1)
            {
                var nextLine = arr[index + 1]
                var listSuffixesForVerbsWithSuffixesInThisLine = line.filter(w => w.WordType === 'V' && w.SuffixPerson != undefined).map(w => this.GetSuffixPGN(w))
                blnToReturn = nextLine.some(w => w.WordType != 'V' && listSuffixesForVerbsWithSuffixesInThisLine.includes(this.GetSuffixPGN(w)))
            }
            if(!blnToReturn && index > 0)
            {
                var prevLine = arr[index - 1]
                var listSuffixesForVerbsWithSuffixesInThisLine = line.filter(w => w.WordType === 'V' && w.SuffixPerson != undefined).map(w => this.GetSuffixPGN(w))
                blnToReturn = prevLine.some(w => w.WordType != 'V' && listSuffixesForVerbsWithSuffixesInThisLine.includes(this.GetSuffixPGN(w)))
            }

            return blnToReturn
        })

        var blnDifferentPGN = false
        for(var listWordsInGroup of listWordsGroupedAcrossLinesByWordTypes)
        {
            var listOnesWithDefinedPGN = listWordsInGroup.filter(w => w.Person != undefined);
            if(listOnesWithDefinedPGN.length > 1 && [...new Set(listOnesWithDefinedPGN.map(w => this.GetPGN(w)))].length >= listOnesWithDefinedPGN.length)
            {
                blnDifferentPGN = true
                break
            }
        }
        
        var blnDifferentSuffixPGN = false
        for(var listWordsInGroup of listWordsGroupedAcrossLinesByWordTypes)
        {
            var listOnesWithDefinedSuffixPGN = listWordsInGroup.filter(w => w.SuffixPerson != undefined);
            if(listOnesWithDefinedSuffixPGN.length > 1 && [...new Set(listOnesWithDefinedSuffixPGN.map(w => this.GetSuffixPGN(w)))].length >= listOnesWithDefinedSuffixPGN.length)
            {
                blnDifferentSuffixPGN = true
                break
            }
        }

        //cstr:a | sfxp:[123] -- cstr:c & sfxp:[^123] l

        //e.g. Psa 2:5 יְדַבֵּ֣ר אֵלֵ֣ימוֹ to יְבַהֲלֵֽמוֹ
        // var blnSuffixAttachedToVerbToSameSuffixAttachedToPrepositionAfterVerb = listWordsSeparatedIntoLines.some((line, index, arr) => index < arr.length - 1 && 
        //     line.some(w => w.WordType === "Verb" && w.SuffixPerson === undefined) && arr[index + 1].some(w => listLexicalIDs.includes(w.LexicalID)))

        return {ComparisonsAndCalculationsByWordType: listToReturn, 
                // WordTypeFlow: listWordsSeparatedIntoLines.map(line => line.map(w => w.WordType).join(" ")).join(" -> "),
                // PhraseFunctionFlow: listWordsSeparatedIntoLines.map(line => line.map(w => this.MapPhraseFunctionToLetter(w, true)).join(" ")).join(" -> "),
                // NumberOfWordsIsDifferent: listWordsSeparatedIntoLines.reduce((acc, line) => acc + line.length, 0) / (1.0 * listWordsSeparatedIntoLines.length) != listWordsSeparatedIntoLines[0].length,
				SingleNounToConstruct: blnSingleNounToConstruct, 
				ConstructToSingleNoun: blnConstructToSingleNoun,

                DifferentPGN: blnDifferentPGN,
                DifferentSuffixPGN: blnDifferentSuffixPGN,
                SameSuffixPGNBetweenVerbAndNonVerb: blnSameSuffixPGNBetweenVerbAndNonVerb,

                AllToNoAll: this.CheckForLexicalIDListToNoneInNextLine(listWordsSeparatedIntoLines, ["3850"], false), 
                NoAllToAll: this.CheckForLexicalIDListToNoneInNextLine(listWordsSeparatedIntoLines, ["3850"], true), 
                //AllInBoth: this.CheckForLexicalIDListInConsecutiveLines(listWordsSeparatedIntoLines, ["3850"]),

                //DirectObjectMarkerToNone: this.CheckForLexicalIDListToNoneInNextLine(listWordsSeparatedIntoLines, ["879"], false), 
                //NoneToDirectObjectMarker: this.CheckForLexicalIDListToNoneInNextLine(listWordsSeparatedIntoLines, ["879"], true), 

                //RelativePronounToNone: this.CheckForPhraseFunctionPropertyToNoneInNextLine(listWordsSeparatedIntoLines, "Rela", false), 
				//NoneToRelativePronoun: this.CheckForPhraseFunctionPropertyToNoneInNextLine(listWordsSeparatedIntoLines, "Rela", true), 
				
                DifferentPolarity: this.CheckForPhraseFunctionPropertyToNoneInNextLine(listWordsSeparatedIntoLines, "Nega", true) || 
                    this.CheckForPhraseFunctionPropertyToNoneInNextLine(listWordsSeparatedIntoLines, "Nega", false),

                ContainsPrepositionsSemanticallyOpposite: blnContainsPrepositionsSemanticallyOpposite, 
                ContainsWordsFirstAndSecondPerson: blnContainsWordsFirstAndSecondPerson,
                ContainsWordsFirstAndThirdPerson: blnContainsWordsFirstAndThirdPerson,
                ContainsWordsSecondAndThirdPerson: blnContainsWordsSecondAndThirdPerson};
    }

    // RecalculateRepetitionLinkGroupCalculationsForCurrentChapter(repetitionLinkGroup)
    // {
    //     if(repetitionLinkGroup === undefined) return;

    //     repetitionLinkGroup.Calculations = this.CalculateRepetitionLinkGroupCategoriesFromWords(
    //         this.listTextWordsForChapter.filter(twic => repetitionLinkGroup.ListWords.includes(twic.TextIndex)), this.state.listLines, false, false); 
    // }

    // RecalculateAllRepetitionLinkGroups()
    // {
    //     //be sure to check the Search All Psalms option before running this
    //     //this.listClausesForAllChapters

    //     for(var repetitionLinkGroup of this.state.listRepetitionLinkGroups)
    //     {
    //         repetitionLinkGroup.Calculations = this.CalculateRepetitionLinkGroupCategoriesFromWords(
    //             this.listTextWordsForAllChapters.filter(twic => repetitionLinkGroup.ListWords.includes(twic.TextIndex)), this.dictLinesByChapter, false, false); 
    //     }  
    // }
    
    GetCategoryDescListForCurrentRepetitionLinkGroup()
    {
        var results = this.GetCurrentRepetitionLinkGroup().Calculations;
        
        if(results === undefined || results.Calculations === undefined) return "";

        var listFieldsSpeciallyShown = ["Calculations", "WordTypeFlow", "PhraseFunctionFlow"];
        return results.Calculations.map(r => r.PrimaryWordType + " - " + (r.Same.length > 0 ? "Same: " + r.Same.join(", ") : "") + 
            (r.Different.length > 0 ? "; Different: " + r.Different.join(", ") : "") + 
            (r.Special.length > 0 ? "; Special: " + r.Special.join(", ") : "")).join(" ~ ") + " " + 

            results.WordTypeFlow + " " + results.PhraseFunctionFlow + " " +
            //e[0] has the key, e[1] the value
            Object.entries(results).filter(e => e[1] && !listFieldsSpeciallyShown.includes(e[0])).map(e => e[0]).join(" ");

            // (results.SingleNounToConstruct ? "SingleNounToConstruct " : "") +
            // (results.ConstructToSingleNoun ? "ConstructToSingleNoun " : "") +
            // (results.AllToNoAll ? "AllToNoAll " : "") +
            // (results.NoAllToAll ? "NoAllToAll " : "") +
            // (results.DirectObjectMarkerToNone ? "DirectObjectMarkerToNone " : "") +
            // (results.NoneToDirectObjectMarker ? "NoneToDirectObjectMarker " : "") +
            // (results.RelativePronounToNone ? "RelativePronounToNone " : "") +
            // (results.NoneToRelativePronoun ? "NoneToRelativePronoun " : "") +
            // (results.DifferentPolarity ? "DifferentPolarity " : "") +
            // (results.ContainsPrepositionsSemanticallyOpposite ? "ContainsPrepositionsSemanticallyOpposite " : "") +
            // (results.ContainsWordsFirstAndSecondPerson ? "ContainsWordsFirstAndSecondPerson " : "") +
            // (results.NumberOfWordsIsDifferent ? "NumberOfWordsIsDifferent " : "");

        // return this.CalculateRepetitionLinkGroupCategoriesFromWords(
        //     this.listTextWordsForChapter.filter(twic => this.GetCurrentRepetitionLinkGroup().ListWords.includes(twic.TextIndex))).
        //     map(nCatID => this.GetDescForRepetitionLinkGroupCategoryID(nCatID)).join(", ");

        // this.GetCurrentRepetitionLinkGroup().ListTags.
        //     map(t => this.GetDescForRepetitionLinkGroupCategoryID(t.CategoryID)).join(", ");
    }

	GetWordsInSamePhraseAsWord(listAllWords, word)
	{
		return listAllWords.filter(w => w.phrase_atom_number === word.phrase_atom_number);
	}

	CalculatePhrases(listWords)
	{
		var listToReturn = [];
		
		var nLastPhraseNumber = undefined;
		for(const w of listWords)
		{
			if(w.phrase_atom_number === undefined) continue;
			if(w.phrase_atom_number !== nLastPhraseNumber)
			{
				listToReturn.push({Words: [w], PhraseType: w.phrase_type, PhraseFunction: this.GetPhraseFunction(w)});
				nLastPhraseNumber = w.phrase_atom_number;
			}
			else
				listToReturn[listToReturn.length - 1].Words.push(w);
		}

		return listToReturn;
	}

	CalculateSentences(listWords)
	{
		var listToReturn = [];
		
		var nLastSentenceNumber = undefined;
		for(const w of listWords)
		{
			if(w.sentence_atom_number === undefined) continue;
			if(w.sentence_atom_number !== nLastSentenceNumber)
			{
				listToReturn.push({Words: [w]});
				nLastSentenceNumber = w.sentence_atom_number;
			}
			else
				listToReturn[listToReturn.length - 1].Words.push(w);
		}

		for(var sentence of listToReturn)
			sentence.Clauses = this.CalculateClauses(sentence.Words);

		return listToReturn;
	}

	GetGDTag(sFirstTagName, listPhrases, parent, doc)
	{
		for(var p of listPhrases)
		{
			var lastNodeAdded = null;
			for(var w of p.Words)
			{
				var sTagName = lastNodeAdded === null ? sFirstTagName : "stairstep"
				var e = doc.createElement(sTagName);
				e.setAttribute("text", w.FullText);
				if(lastNodeAdded === null) 
					parent.appendChild(e);
				else
					lastNodeAdded.appendChild(e);
				lastNodeAdded = e;

				if(w.DefiniteArticle === "1")
				{
					//if there is a proposition with the definite article, show the preposition.
					var definiteArticleElement = doc.createElement("underslant");
					definiteArticleElement.setAttribute("text", "הָ");
					lastNodeAdded.appendChild(definiteArticleElement);
				}

				// if(w.Preposition != undefined)
				// {
				// 	var definiteArticleElement = doc.createElement("underslant");
				// 	definiteArticleElement.setAttribute("text", 
				// 	w.Preposition === "b" ? "ב" :
				// 	w.Preposition === "l" ? "ל" : 
				// 	w.Preposition === "k" ? "כּ" : 
				// 	w.Preposition === "m" ? "מ" : "?");
				// 	lastNodeAdded.appendChild(definiteArticleElement);
				// }

				if(w.SuffixPerson != undefined)
				{
					var definiteArticleElement = doc.createElement("stairstep");
					var listTextParts = w.SeparatedText.split("/");
					definiteArticleElement.setAttribute("text", listTextParts[listTextParts.length - 1]);
					lastNodeAdded.appendChild(definiteArticleElement);
				}
			}
		}
		//return listWords.map(w => ({type: sTagName, text: w.FullText}));
	}

	GetMarkupForClause(clause, parent, doc)
	{
		var listPhrases = this.CalculatePhrases(clause.Words);

		//var subjectHead = listWordsInSubjectSlot[0]
		//this.GetWordsInSamePhraseAsWord(listWordsInClause, subjectHead)
		//var negativesWithVerb = this.GetGDTag("underslant",
		//	this.GetWordsInSamePhraseAsWord(listWordsInClause, verbHead).filter(w => this.GetPhraseFunction(w) === "Nega")[0]}};

		//deal with "Conj", "Rela"
		var baseline = doc.createElement("baseline");
		parent.appendChild(baseline);
		this.GetGDTag("subjectSlot", listPhrases.filter(p => p.PhraseFunction === "Subj" || p.PhraseFunction === "PreC"), baseline, doc);
		this.GetGDTag("verbSlot", listPhrases.filter(w => w.PhraseType === "VP"), baseline, doc);
		this.GetGDTag("objectSlot", listPhrases.filter(w => w.PhraseFunction === "Objc"), baseline, doc);
		this.GetGDTag("underslantThenStraight", listPhrases.filter(w => w.PhraseFunction === "Time" || w.PhraseFunction === "Loca" || w.PhraseFunction === "Cmpl"), baseline, doc);
	}

	GetGrammaticalDiagramMarkup()
	{
		//var listWords = this.listTextWordsForChapter;

		// {"grammaticalDiagram": 
		// {"topword":{"gloss"="happiness", text="אשרי", 
		// {"stairstep": {gloss="man" text="איש", 
		// {"underslant": "gloss"="The" "text"="הָ"}}}}}}

		//"TextIndex":"231", "FullText":"לַמְנַצֵּ֥חַ",
		//"phrase_atom_number":"215","phrase_type":"PP","phrase_function":"PreC",
		//"ClauseID":"86","clause_rela":"NA","clause_typ":"NmCl","clause_txt":"'?'",
		//"sentence_atom_number":"57"}

		//Nega
		// return this.GetPhraseFunction(w) === "Pred" || this.GetPhraseFunction(w) === "PreO" ? "V" :
		// this.GetPhraseFunction(w) === "Subj" ? "S" :
		// this.GetPhraseFunction(w) === "Objc" ? "O" : "";

		//var diagram = {grammaticalDiagram: {word: {gloss: "happiness", text: "אשרי", stairstep: {gloss="man", text="איש", underslant: {"gloss":"The", "text":"הָ"}}}}};
		
		//for each clause, a baseline
		var doc = document.implementation.createDocument(null, "");
		var root = doc.createElement("grammaticalDiagram");
		doc.appendChild(root);

		// for(var clause of this.listClauses)
		// {
		// 	this.GetMarkupForClause(clause, root, doc);
		// }

		for(var sentence of this.CalculateSentences(this.listTextWordsForChapter))
		{
			var listClauseGroups = sentence.Clauses.reduce((acc, clause, nIndex) => {
				if(clause.Words[0].Waw === "1" && nIndex > 0)
					acc[acc.length - 1].push(clause)
				else 
					acc.push([clause])
				return acc; 
			}, [])

			for(var clauseGroup of listClauseGroups)
			{
				if(clauseGroup.length > 1)
				{
					var baselineGroup = doc.createElement("baselineGroup");
					for(var clause of clauseGroup)
					{
						this.GetMarkupForClause(clause, baselineGroup, doc);
					}
					
					root.appendChild(baselineGroup);
				}
				else
				{
					this.GetMarkupForClause(clauseGroup[0], root, doc);
				}
			}
		}

		var serializer = new XMLSerializer();
		return serializer.serializeToString(doc);
	}

    CalculateRepetitionLinkGroupStats()
    {
		fetch("HebrewTextData/allpsalmschapters.json")
		.then(res => res.json())
		.then(data => 
		{
			var listTextWordsForAllChapters = data.OSHB; //.filter(w => parseInt(w.TextIndex) > 16887 && parseInt(w.TextIndex) <= 17000);  

			//TODO before running: fix global line list - it doesn't correspond to what is in the individual files
			fetch("LineData/allpsalmslines.json")
			.then(res => res.json())
			.then(data => 
			{
                var listLinesToUse = this.SortLines(data.Lines);
				this.CalculateLines(listLinesToUse, listTextWordsForAllChapters)
                this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesToUse, true)

				fetch("CorrespondenceData/allpsalmscorrespondences.json")
				.then(res => res.json())
				.then(data => 
				{
					//filter out unsure
					var listCorrespondencesIncludingUnsure = data.Correspondences;
					var listCorrespondences = data.Correspondences.filter(corr => !corr.ListTags.some(tag => tag.CategoryID === "144"));
					var listWordsByRepetitionGroup = this.listRepetitionGroups.map(g => g.Lines.flatMap(l => l.Words));

					var nUnsure = data.Correspondences.filter(corr => corr.ListTags.some(tag => tag.CategoryID === "144"));

					listCorrespondences.forEach(o => o.Calculations = this.CalculateRepetitionLinkGroupCategoriesFromWords(o.ListWords.map(nTextIndex => listTextWordsForAllChapters.find(w => w.TextIndex === nTextIndex)), listLinesToUse, false, false));
					
                    // var dictCountByDifferences = new Map();
                    // for(var nDifferences = 0; nDifferences < 7; nDifferences++)
                    // {
                    //     dictCountByDifferences.set(nDifferences, listCorrespondences.filter(g => 
                    //         g.Calculations.ComparisonsAndCalculationsByWordType.some(c2 => this.CalculateDifferencesInCalcGroup(g.Calculations, c2) === nDifferences)).length)
                    // }

                    // navigator.clipboard.writeText(JSON.stringify(dictCountByDifferences))
                    // window.alert('done')
                    // return

                    
					//for each same/different autocalculated field, calculate what percent of group that field occurs as same, and what percent as different.
					//denominator for each field is number of groups it occurs in as same or different.
					//for autocalculated only compare ones that have the same PrimaryWordType

					var listAllCalculations = listCorrespondences.map(r => r.Calculations);

					var dictSameOccPercentsByField = new Map();
					var dictDifferentOccPercentsByField = new Map();
					var dictSameCountsByField = new Map();
					var dictDifferentCountsByField = new Map();
					var dictTotalCountsByField = new Map();

					for(var c of listAllCalculations)
					{
						for(var c2 of c.ComparisonsAndCalculationsByWordType)
						{
							for(var sSameField of c2.Same)
							{
								if(dictSameCountsByField.has(sSameField)) dictSameCountsByField.set(sSameField, dictSameCountsByField.get(sSameField) + 1);
								else dictSameCountsByField.set(sSameField, 0);

								if(dictTotalCountsByField.has(sSameField)) dictTotalCountsByField.set(sSameField, dictTotalCountsByField.get(sSameField) + 1);
								else dictTotalCountsByField.set(sSameField, 0);
							}

							for(var sDiffField of c2.Different)
							{
								if(dictDifferentCountsByField.has(sDiffField)) dictDifferentCountsByField.set(sDiffField, dictDifferentCountsByField.get(sDiffField) + 1);
								else dictDifferentCountsByField.set(sDiffField, 0);

								if(dictTotalCountsByField.has(sDiffField)) dictTotalCountsByField.set(sDiffField, dictTotalCountsByField.get(sDiffField) + 1);
								else dictTotalCountsByField.set(sDiffField, 0);
							}
						}
					}
					
					for(var sKey of dictSameCountsByField.keys())
						dictSameOccPercentsByField.set(sKey, dictSameCountsByField.get(sKey) / (1.0 * dictTotalCountsByField.get(sKey))); 
					
					for(var sKey of dictDifferentCountsByField.keys())
						dictDifferentOccPercentsByField.set(sKey, dictDifferentCountsByField.get(sKey) / (1.0 * dictTotalCountsByField.get(sKey))); 

                        
					var listMainTypesToCount = ["Similar", "Opposite", "Associated", "Discourse Relationship", "Rhyme"];

					//other calculations
					
					//ComparisonsAndCalculationsByWordType
					//calculate average ratio of number of same fields / number of same fields, 
					//1) for all groups, 2) for groups with inverted word order tag

					var listRatiosOfSameToDifferent = listAllCalculations.flatMap(c => c.ComparisonsAndCalculationsByWordType.map(c2 => c2.RatioOfSameToDifferent));
					var nAverageRatioOfSameToDifferent = listRatiosOfSameToDifferent.reduce((acc, n) => acc + n, 0) / (1.0 * listAllCalculations.length);
					
					var nAverageNumberOfSameFields = listAllCalculations.flatMap(c => c.ComparisonsAndCalculationsByWordType.map(c2 => c2.Same.length)).
						reduce((acc, n) => acc + n, 0) / (1.0 * listAllCalculations.length);
					var nAverageNumberOfDifferentFields = listAllCalculations.flatMap(c => c.ComparisonsAndCalculationsByWordType.map(c2 => c2.Different.length)).
						reduce((acc, n) => acc + n, 0) / (1.0 * listAllCalculations.length);

                    
                    //The number of groups that have zero different autocalculated fields (all are the same), categorized by “MainType”:
                    //var nAverageNumberOfDifferentFields = listAllCalculations.flatMap(c => c.ComparisonsAndCalculationsByWordType.map(c2 => c2.Different.length)).
					//	reduce((acc, n) => acc + n, 0) / (1.0 * listAllCalculations.length);

                    var listNumberOfGroupsWithZeroDifferentFieldsByMainType = listMainTypesToCount.map(sToCount => { 
                        return {Type: sToCount, Count: listCorrespondences.filter(corr => 
                        corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sToCount) &&
                        !corr.Calculations.ComparisonsAndCalculationsByWordType.some(o => o.Different.length > 0)).length}}); 

                    var listNumberOfGroupsWithSomeSameButZeroDifferentFieldsByMainType = listMainTypesToCount.map(sToCount => { 
                        return {Type: sToCount, Count: listCorrespondences.filter(corr => 
                        corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sToCount) &&
                        !corr.Calculations.ComparisonsAndCalculationsByWordType.some(o => o.Different.length > 0) &&
                        corr.Calculations.ComparisonsAndCalculationsByWordType.some(o => o.Same.length > 0)).length}}); 

                    var listNumberOfGroupsWithZeroSameFieldsByMainType = listMainTypesToCount.map(sToCount => { 
                        return {Type: sToCount, Count: listCorrespondences.filter(corr => 
                        corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sToCount) &&
                        !corr.Calculations.ComparisonsAndCalculationsByWordType.some(o => o.Same.length > 0)).length}}); 

                    var listNumberOfGroupsWithZeroSameAndZeroDifferentFieldsByMainType = listMainTypesToCount.map(sToCount => { 
                        return {Type: sToCount, Count: listCorrespondences.filter(corr => 
                        corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sToCount) &&
                        corr.Calculations.ComparisonsAndCalculationsByWordType.length === 0).length}}); 

                    // listMainTypesToCount.map(sToCount => { 
                    //     return {Type: sToCount, Instances: listCorrespondences.filter(corr => 
                    //     corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sToCount) &&
                    //     corr.Calculations.ComparisonsAndCalculationsByWordType.length === 0)}})

                    // listMainTypesToCount.map(sToCount => { 
                    //     return {Type: sToCount, Instances: listCorrespondences.filter(corr => 
                    //     corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sToCount) &&
                    //     !corr.Calculations.ComparisonsAndCalculationsByWordType.some(o => o.Same.length > 0))}}); 

					//var nAverageRatioOfSameToDifferentForInvertedWordOrder = listAllCalculations.filter(c => c.ContainsInvertedWordOrder).map(c => c.ComparisonsAndCalculationsByWordType.RatioOfSameToDifferent) / (1.0 * listAllCalculations.length);
				
					//calculate percent of time each field occurs with one of the other fields as both same or different (correlation).
					//which ones mostly commonly occur together?
					//especially check 1) rhyme correlation with same position in clause and 2) rhyme w/ semantic connection vs. rhyme w/o semantic connection
					//does the rhyme tend to be a stronger rhyme when there are less other connections?

					var nPercentOfTimesRhymeCooccursWithSamePositionInClause = listCorrespondences.filter(corr => 
						corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === "Rhyme") && 
						corr.Calculations.ComparisonsAndCalculationsByWordType.some(c => c.Same.includes("PositionInLine"))).length /
						(1.0 * this.state.listRepetitionLinkGroups.length);


					//var listCategoriesToCalculate = this.listRepetitionLinkGroupCategories.filter(cat => cat.LinkGroupTypes.includes("10"));

					//foreach repetition group category, calculate total occurrences
					var listCountsForCategories = this.listRepetitionLinkGroupCategories.map(cat => { 
						return {Type: this.GetDescForRepetitionLinkGroupCategoryID(cat.ID), Count: listCorrespondences.filter(corr => 
						corr.ListTags.some(tag => tag.CategoryID === cat.ID)).length}}); 

					//foreach repetition group main type, calculate total occurrences,
					var listCountsForMainTypes = listMainTypesToCount.map(sToCount => { 
						return {Type:sToCount, Count: listCorrespondences.filter(corr => 
						corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sToCount)).length}}); 

					var listCountsForMainTypesWithoutRelationalOpposite = listMainTypesToCount.map(sToCount => { 
						return {Type:sToCount, Count: listCorrespondences.filter(corr => 
						corr.ListTags.some(tag => tag.CategoryID != "309" && this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sToCount)).length}}); 

					//foreach directional (->) repetition group category, calculate how many times it occurs reversed and not reversed
					//"ListTags":[{"CategoryID":"310","RelationPairReversed":false}]
					var listDirectionalCategories = this.listRepetitionLinkGroupCategories.filter(cat => cat.Desc.includes("->"));

					var listCountsForDirectionalCategories = listDirectionalCategories.map(cat => { 
						return {Type: this.GetDescForRepetitionLinkGroupCategoryID(cat.ID), 
						CountUnreversed: listCorrespondences.filter(corr => corr.ListTags.some(tag => tag.CategoryID === cat.ID && !tag.RelationPairReversed)).length,
						CountReversed: listCorrespondences.filter(corr => corr.ListTags.some(tag => tag.CategoryID === cat.ID && tag.RelationPairReversed)).length}}); 

					//foreach MainType, calculate times that MainType occurs in every tag for a repetition group
					var listCountsForMainTypesOccurringInEveryTagForARepGroup = listMainTypesToCount.map(sMainType => { 
						return {Type: sMainType, Count: listWordsByRepetitionGroup.filter(listWords => 
							listCorrespondences.filter(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s))).
								every(corr => corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sMainType))).length}});

					//calculate number of pgrps that have both similar and opposite
					var nRepetitionGroupsWithSimilarAndOpposite = listWordsByRepetitionGroup.filter(listWords => 
						listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
							corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === "Similar")) &&
						listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
							corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === "Opposite"))).length; 
					
					var nRepetitionGroupsWithSimilarAndOppositeWithoutRelationalOpposite = listWordsByRepetitionGroup.filter(listWords => 
						listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
							corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === "Similar")) &&
						listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
							corr.ListTags.some(tag => tag.CategoryID != "309" && this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === "Opposite"))).length; 

					//calculate number of pgrps with one of the tags but no Similar or Opposite
					var nRepetitionGroupsWithATagButNoSimilarOrOpposite = listWordsByRepetitionGroup.filter(listWords => 
						listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
							corr.ListTags.some(tag => ["Associated", "Discourse Relationship", "Rhyme", "Other"].includes(this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID)))) &&

						!listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
							corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === "Similar")) &&

						!listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
							corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === "Opposite"))).length; 
							
					// var listRepetitionGroupsWithNoSimilarOrOpposite = listWordsByRepetitionGroup.filter(listWords => 
					// 	!listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
					// 		corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === "Similar")) &&
					// 	!listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
					// 		corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === "Opposite"))); 

					//TODO: add WithoutRelationalOpposite variant for the below three?
					//calculate number of pgrps with  each of "MainType":"Similar", Opposite, Associated, "Discourse Relationship", "Rhyme"
					var listCountsForMainTypesByRepetitionGroup = listMainTypesToCount.map(sToCount => 
						listWordsByRepetitionGroup.filter(listWords => 
							listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
								corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sToCount))).length); 

					//calculate number of pgrps with no correspondences
					var nRepetitionGroupsWithNoCorrespondences = listWordsByRepetitionGroup.filter(listWords => 
						!listCorrespondences.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)))).length;

					var nRepetitionGroupsWithNoCorrespondencesIncludingUnsure = listWordsByRepetitionGroup.filter(listWords => 
						!listCorrespondencesIncludingUnsure.some(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)))).length;

					//calculate average number of corr per pgrp ((acc, n) => acc + n, 0)
					var nAverageNumberOfAllCorrespondencesPerRepGroup = listWordsByRepetitionGroup.reduce((acc, listWords) => 
						acc + listCorrespondences.filter(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s))).length, 0) / 
						(1.0 * listWordsByRepetitionGroup.length);

					//calculate average number of maintype and particular corr per pgrp
					var nAverageNumberOfMainTypeCorrespondencesPerRepGroup = listMainTypesToCount.map(sMainType => { 
						return {Type: sMainType, Count: listWordsByRepetitionGroup.reduce((acc, listWords) => acc +
						listCorrespondences.filter(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
							corr.ListTags.some(tag => this.GetMainTypeForRepetitionLinkGroupCategoryID(tag.CategoryID) === sMainType)).length, 0) / 
							(1.0 * listWordsByRepetitionGroup.length)}});

					var nAverageNumberOfParticularCorrespondencesPerRepGroup = this.listRepetitionLinkGroupCategories.map(cat => { 
						return {Type: this.GetDescForRepetitionLinkGroupCategoryID(cat.ID), Count: listWordsByRepetitionGroup.reduce((acc, listWords) => acc +
							listCorrespondences.filter(corr => corr.ListWords.some(s => listWords.some(w => w.TextIndex === s)) && 
								corr.ListTags.some(tag => tag.CategoryID === cat.ID)).length, 0) / 
							(1.0 * listWordsByRepetitionGroup.length)}});

					var nTotalRepetitionGroups = listWordsByRepetitionGroup.length;

					var sResults = "PercentOfTimesRhymeCooccursWithSamePositionInClause" + nPercentOfTimesRhymeCooccursWithSamePositionInClause;

					// var sExcelToPaste = "Feature1$Feature2$CosineSimilarity$Feature1Occs$Feature2Occs$SameWord$SameClause$SameVerse$AdjacentVerse" + 
					// 	listCorrelations.map(c => c.Query1 + "$" + c.Query2 + "$" + c.CosineSimilarity + "$" + c.Feature1Occs + "$" + c.Feature2Occs + "$" + 
					// 	c.SameWord + "$" + c.SameClause + "$" + c.SameVerse + "$" + c.AdjacentVerse).join("\n"); 
					// //var jsonToPaste = JSON.stringify(listCorrelations);
					// navigator.clipboard.writeText(sExcelToPaste);
					
					//return nAverageRatioOfSameToDifferent + " " + nAverageRatioOfSameToDifferentForInvertedWordOrder; 

				})
			})
		})
    }

	GetWordsInSamePhraseAsWord(w)
	{
		//same phrase or negative before a verb
		if(!this.state.blnDragWordsInSamePhraseTogether)
			return [w];
		else
			return this.listTextWordsForChapter.filter(w2 => w2.phrase_atom_number === w.phrase_atom_number || 
				((((this.GetPhraseFunction(w) === "Pred" || this.GetPhraseFunction(w) === "PreO") && this.GetPhraseFunction(w2) == "Nega") ||
				((this.GetPhraseFunction(w2) === "Pred" || this.GetPhraseFunction(w2) === "PreO") && this.GetPhraseFunction(w) == "Nega")) && 
					Math.abs(parseInt(w.TextIndex) - parseInt(w2.TextIndex)) === 1));
	}

    GetLineContainingWord(w)
    {
        return this.state.listLines.find(r => r.Words.includes(w));
    }

	GetPropositionContainingWord(w)
    {
        return this.state.listPropositions.find(r => r.Words.includes(w));
    }

    GetLinkToolToUse(event)
    {
        var nToolToUse = this.state.nSelectedToolID;
        if(nToolToUse === this.nMarkCorrespondencesWithinLineGroupsToolID && event.shiftKey) nToolToUse = this.nWordLinkToolID;
        else if(nToolToUse === this.nWordLinkToolID && event.shiftKey) nToolToUse = this.nMarkCorrespondencesWithinLineGroupsToolID;
        else if((nToolToUse === this.nWordLinkToolID || nToolToUse === this.nMarkCorrespondencesWithinLineGroupsToolID) && event.ctrlKey) nToolToUse = this.nLineLinkToolID;
        return nToolToUse;
    }

	DragWordStart(w, event)
	{
		//this.listTouches.push(event.changedTouches);
        //.identifier

        var nToolToUse = this.GetLinkToolToUse(event);
        if(nToolToUse === this.nMarkCorrespondencesWithinLineGroupsToolID || nToolToUse === this.nWordLinkToolID || 
           nToolToUse === this.nRepetitionLinkGroupToolID || nToolToUse === this.nLinkTranslationToolID)
			this.setState({listWordsDraggedFrom: this.GetWordsInSamePhraseAsWord(w)});
		else if(nToolToUse === this.nLineLinkToolID)
			this.setState({listWordsDraggedFrom: this.LineWithWord(w).Words});
		else if(this.UsingAWordTagTool()) 
		{
			var tagForWord = this.GetWordTagForWord(w);
			if(tagForWord === this.state.currentWordTag) 
                this.setState({currentWordTagIsSticky: !this.state.currentWordTagIsSticky});      
			else this.setState({currentWordTag: tagForWord});
		}
	}

	DragWordMove(w, event)
	{
        //event.preventDefault();
        var nToolToUse = this.GetLinkToolToUse(event);
        if(this.state.listWordsDraggedFrom != undefined)
        {
            if(this.state.blnShiftDown) 
            {
                var listWordsHoveredWhileDraggingToSet = this.state.listWordsHoveredWhileDragging;
                if(!listWordsHoveredWhileDraggingToSet.includes(w)) 
                {
                    listWordsHoveredWhileDraggingToSet.push(w);
                    this.setState({listWordsHoveredWhileDragging: listWordsHoveredWhileDraggingToSet});
                }
            }
            else this.setState({listWordsHoveredWhileDragging: nToolToUse === this.nLineLinkToolID ? this.LineWithWord(w).Words : [w]});
        }
	}

    AddTranslationLink(listToSet, sTextIndex, nTranslationWordIndex, nLineIndex, sChapter)
    {
        var blnLinkAlreadyThere = listToSet.some(o => o.Original === sTextIndex && o.Translation === nTranslationWordIndex && 
            o.LineIndex === nLineIndex && o.Chapter === sChapter)

        if(!blnLinkAlreadyThere)
        {
            var oToAdd = {Original: sTextIndex, Translation: nTranslationWordIndex, LineIndex: nLineIndex, Chapter: sChapter}

            // if(this.state.blnADown) oToAdd.ForPreposition = true
            // else if(this.state.blnSDown) oToAdd.ForSuffix = true
            // else if(this.state.blnWDown) oToAdd.ForWaw = true
            // else if(this.state.blnDDown) oToAdd.ForPGN = true

            listToSet.push(oToAdd)
        }
    }

    DragTranslationEnd(nTranslationWordIndex, nLineIndex, sChapter, word, event)
	{
        var listWordsDraggedFrom = this.state.listWordsDraggedFrom

        if(this.state.nSelectedToolID === this.nLinkTranslationToolID)
        {
            var listToSet = this.state.listTranslationWordIndexLinks

            if(listWordsDraggedFrom === undefined || listWordsDraggedFrom.length === 0)
            {
                if(this.nTranslationWordIndexDraggedFrom > -1 && word != undefined)
                {
                    this.AddTranslationLink(listToSet, word.TextIndex, this.nTranslationWordIndexDraggedFrom, nLineIndex, sChapter)
                }
            }
            else
            {
                if(listWordsDraggedFrom.length === 1 && listWordsDraggedFrom[0] === word)
                {
                    var nIndexToRemove = listToSet.findIndex(o => o.Translation === nTranslationWordIndex && o.LineIndex === nLineIndex)
                    listToSet.splice(nIndexToRemove, 1)
                }
                else
                {
                    for(var w of listWordsDraggedFrom)
                    {
                        this.AddTranslationLink(listToSet, w.TextIndex, nTranslationWordIndex, nLineIndex, sChapter)
                        // var blnLinkAlreadyThere = listToSet.some(o => o.Original === w.TextIndex && o.Translation === nTranslationWordIndex && 
                        //     o.LineIndex === nLineIndex && o.Chapter === sChapter)

                        // if(!blnLinkAlreadyThere)
                        // {
                        //     var oToAdd = {Original: w.TextIndex, Translation: nTranslationWordIndex, LineIndex: nLineIndex, Chapter: sChapter}

                        //     if(this.state.blnADown) oToAdd.ForPreposition = true
                        //     else if(this.state.blnSDown) oToAdd.ForSuffix = true
                        //     else if(this.state.blnWDown) oToAdd.ForWaw = true
                        //     else if(this.state.blnDDown) oToAdd.ForPGN = true

                        //     listToSet.push(oToAdd)
                        // }
                    }
                }
            }
                
            this.SaveTranslationWordIndexLinks(listToSet)
        }
        else if(this.state.nSelectedToolID === this.nMainWordInTranslationLinkGroupsToolID)
        {
            if(word != undefined)
            {
                this.state.dictMainWordInTranslationLinkGroupsByTextIndex.set(word.TextIndex, nTranslationWordIndex)
                this.SaveMainWordInTranslationLinkGroupsByTextIndexDictionary()
            }
        }
        else if(this.state.nSelectedToolID === this.nMainPrepositionWordInTranslationLinkGroupsToolID)
        {
            if(word != undefined)
            {
                this.state.dictMainPrepositionWordInTranslationLinkGroupsByTextIndex.set(word.TextIndex, nTranslationWordIndex)
                this.SaveMainPrepositionWordInTranslationLinkGroupsByTextIndexDictionary()
            }
        }
        else if(this.state.nSelectedToolID === this.nMainSuffixWordInTranslationLinkGroupsToolID)
        {
            if(word != undefined)
            {
                this.state.dictMainSuffixWordInTranslationLinkGroupsByTextIndex.set(word.TextIndex, nTranslationWordIndex)
                this.SaveMainSuffixWordInTranslationLinkGroupsByTextIndexDictionary()
            }
        }
        else if(this.AnyLensIsEnabled())
        {
            if(word != undefined) this.ToggleWordInLenStickyWords(word)
        }

        this.setState({listWordsDraggedFrom: undefined})
    }

    DragEndForRepetitionLinkGroupTool(w, oSyllableDraggedTo)
    {
        //to use the tool: drag one word to another. 
        //if neither word is in a group, a new group will be formed with the two words.
        //if both words are already in groups, the groups will be merged.
        //otherwise, the dragged word will be added to the group of the word it is dropped on
        //if holding down 'a', the dragged word will be added to the group of the word it is dropped on, 
        //but will also still remain a part of all groups it is already part of.
        //if holding down 'ctrl', the dragged word will be removed from a group
        //if holding down 'shift', a new group will be formed with just the two words, 
        //even if they are part of other groups, too
        //'s' toggles participant reference as suffix

        var listWordsDraggedFrom = this.state.listWordsDraggedFrom
        var nSyllableIndexDraggedFrom = -1
        var nSyllableIndexDraggedTo = -1

        if(this.state.blnSyllableModeForRepetitionLinkGroupTool && this.state.oSyllableDraggedFrom !== null && oSyllableDraggedTo !== null)
        {
            // console.log(this.state.oSyllableDraggedFrom, oSyllableDraggedTo)
            nSyllableIndexDraggedFrom = this.state.oSyllableDraggedFrom.syllableIndex
            nSyllableIndexDraggedTo = oSyllableDraggedTo.syllableIndex
            listWordsDraggedFrom = [this.state.oSyllableDraggedFrom.word]
        }
	
        if(listWordsDraggedFrom != undefined)
        {		
            var listToSet = this.state.listRepetitionLinkGroups;    
            var listGroupsForCurrentGroupCategory = listToSet.filter(g => g.Type === this.state.nCurrentLinkGroupType && 
                (g.Type != 1 || g.ListTags.length === 0 || g.ListTags.some(t => this.IsGroupForRepetitionLinkGroupCategoryIDCurrentlySelected(t.CategoryID))));            
            var groupToChange = undefined;
            var blnRecalculateRepetitionLinkGroup = true;

            for(var wordDraggedFrom of listWordsDraggedFrom)
            {
                //if no groups exist containing the word dragged from or the w dragged to, or if shift is down,
                //create a new group for it and the word dragged to

                //issue -> words can be in multiple groups, so in the two lines below, how can the user select which group?
                //var groupForWordDraggedFrom = listGroupsForCurrentGroupCategory.find(g => g.ListWords.some(n => n === wordDraggedFrom.TextIndex))
                //var groupForWordDraggedTo = listGroupsForCurrentGroupCategory.find(g => g.ListWords.some(n => n === w.TextIndex))

                var groupForWordDraggedFrom = listGroupsForCurrentGroupCategory.find(g => {
                    let nIndexInListOfWords = g.ListWords.indexOf(wordDraggedFrom.TextIndex)
                    if(nIndexInListOfWords === -1) return false
                    return g.ListSyllableIndexesByWord[nIndexInListOfWords] === nSyllableIndexDraggedFrom
                })

                var groupForWordDraggedTo = listGroupsForCurrentGroupCategory.find(g => {
                    let nIndexInListOfWords = g.ListWords.indexOf(w.TextIndex)
                    if(nIndexInListOfWords === -1) return false
                    return g.ListSyllableIndexesByWord[nIndexInListOfWords] === nSyllableIndexDraggedTo
                })

                if(this.state.blnADown && this.state.listCurrentRepetitionLinkGroups != undefined && 
                    this.state.listCurrentRepetitionLinkGroups.length > 0)
                {
                    // groupToChange = this.state.listCurrentRepetitionLinkGroups[0];
                    // groupToChange.ListWords.push(wordDraggedFrom.TextIndex)
                    // groupToChange.ListSyllableIndexesByWord.push(nSyllableIndexDraggedFrom)
                }
                // else if(this.state.blnSDown && this.state.listCurrentRepetitionLinkGroups != undefined && 
                //         this.state.listCurrentRepetitionLinkGroups.length > 0 && this.InParticipantRefMode())
                // {
                //     //s toggles participant reference as suffix, after adding the word to the group if it's not already there
                //     groupToChange = this.state.listCurrentRepetitionLinkGroups[0];
                //     var sTextIndexToChange = wordDraggedFrom.TextIndex;

                //     if(!groupToChange.ListWords.includes(sTextIndexToChange))
                //     {
                //         groupToChange.ListWords.push(sTextIndexToChange)
                //         groupToChange.ListSyllableIndexesByWord.push(nSyllableIndexDraggedFrom)
                //     }

                //     if(groupToChange.WordsForWhichParticipantRefIsForSuffix.includes(sTextIndexToChange))
                //     {
                //         var nIndexToRemove = groupToChange.WordsForWhichParticipantRefIsForSuffix.findIndex(n => n === sTextIndexToChange);
                //         groupToChange.WordsForWhichParticipantRefIsForSuffix.splice(nIndexToRemove, 1);
                //     }
                //     else groupToChange.WordsForWhichParticipantRefIsForSuffix.push(sTextIndexToChange);
                // }
                else if(this.state.blnZDown || (groupForWordDraggedFrom === undefined && groupForWordDraggedTo != undefined && !this.state.blnShiftDown))
                {
                    groupToChange = groupForWordDraggedTo;
                    groupToChange.ListWords.push(wordDraggedFrom.TextIndex)
                    groupToChange.ListSyllableIndexesByWord.push(nSyllableIndexDraggedFrom)
                }
                else if(groupForWordDraggedFrom != undefined && groupForWordDraggedTo != undefined && groupForWordDraggedFrom != groupForWordDraggedTo && !this.state.blnShiftDown)
                {
                    //if(!this.state.blnControlDown)
                    //{
                        //if both words are already in groups, merge the groups
                        groupToChange = groupForWordDraggedTo
                        groupToChange.Notes = 'merged'
                        //console.log(groupToChange, groupForWordDraggedFrom, groupToChange.ListWords.concat(groupForWordDraggedFrom.ListWords))
                        groupToChange.ListWords = groupToChange.ListWords.concat(groupForWordDraggedFrom.ListWords)
                        groupToChange.ListSyllableIndexesByWord = groupToChange.ListSyllableIndexesByWord.concat(groupForWordDraggedFrom.ListSyllableIndexesByWord)

                        var nIndexToRemove = listToSet.findIndex(g => g === groupForWordDraggedFrom);
                        listToSet.splice(nIndexToRemove, 1)
                    //}
                }
                else 
                {
                    if(groupForWordDraggedFrom === undefined || this.state.blnShiftDown)
                    {
                        if(wordDraggedFrom.TextIndex != w.TextIndex)
                        {
                            //create a new group
                            groupToChange = {ListWords: [wordDraggedFrom.TextIndex, w.TextIndex], 
                                ListSyllableIndexesByWord: [nSyllableIndexDraggedFrom, nSyllableIndexDraggedTo], 
                                ListTags: [], Comment: this.state.sFromRepetitionLinkGroupNotesBox, 
                                IsContrast: this.state.blnConnectionIsContrast, 
                                IsPreposition: this.state.blnConnectionIsAttachedPreposition,
                                IsSuffix: this.state.blnConnectionIsPronominalSuffix,
                                Type: this.state.nCurrentLinkGroupType, WordsForWhichParticipantRefIsForSuffix: []}

                            //set things to blank or false so they won't accidentally be put into other new groups
                            this.setState({sFromRepetitionLinkGroupNotesBox: ''})
                            this.setState({blnConnectionIsContrast: false})
                            this.setState({blnConnectionIsAttachedPreposition: false})
                            this.setState({blnConnectionIsPronominalSuffix: false})

                            listToSet.push(groupToChange);
                            this.setState({currentRepetitionLinkGroupIsSticky: true});
                            this.setState({nCurrentRepetitionLinkGroupCategory: groupToChange.ListTags.length === 0 ? undefined : 
                                this.GetSelectionIndexForRepetitionLinkGroupCategoryID(groupToChange.ListTags[0].CategoryID)})
                        }
                    }
                    else 
                    {
                        groupToChange = groupForWordDraggedFrom;
                    
                        if(groupToChange.ListWords.some(n => n === w.TextIndex))
                        {
                            if(this.state.blnControlDown)
                            {
                                //if the groupToChange for the words dragged from already contain w, remove w from the group
                                //console.log("Removed");
                                var nIndexToRemove = groupToChange.ListWords.findIndex(n => n === w.TextIndex)

                                if(groupToChange.ListSyllableIndexesByWord === undefined || 
                                   (groupToChange.ListSyllableIndexesByWord[nIndexToRemove] === nSyllableIndexDraggedTo))
                                {
                                    groupToChange.ListWords.splice(nIndexToRemove, 1)

                                    if(groupToChange.ListSyllableIndexesByWord !== undefined)
                                    {
                                        groupToChange.ListSyllableIndexesByWord.splice(nIndexToRemove, 1)
                                    }

                                    //if there is only one word left in the group, delete the group
                                    if(groupToChange.ListWords.length < 2) 
                                    {
                                        var nIndexToRemove = listToSet.findIndex(g => g === groupToChange);
                                        listToSet.splice(nIndexToRemove, 1);
                                        groupToChange = undefined;
                                        blnRecalculateRepetitionLinkGroup = false;
                                    }
                                }
                            }
                            else 
                            {
                                blnRecalculateRepetitionLinkGroup = false;

                                // if(this.state.nCurrentLinkGroupTagID != undefined)
                                // {
                                // 	groupToChange.ListTags.push({CategoryID: this.state.nCurrentLinkGroupTagID, RelationPairReversed:false});
                                // 	this.SaveRepetitionLinkGroupsAndSetState(listToSet);
                                // }

                                this.setState({listCurrentRepetitionLinkGroups: [groupToChange]});
                                //this.setState({nCurrentRepetitionLinkGroupSelectedIndex: 0});
                                if(!this.state.currentRepetitionLinkGroupIsSticky) 
                                    this.setState({currentRepetitionLinkGroupIsSticky: true});
                                this.setState({lineClickedOnForRepetitionGroupLink: this.GetLineContainingWord(w)});
                                this.setState({listWordsDraggedFrom: undefined});
                                this.setState({listWordsHoveredWhileDragging: undefined});
                                
                                return;
                            }
                        }
                        else
                        {
                            groupToChange.ListWords.push(w.TextIndex)
                            groupToChange.ListSyllableIndexesByWord.push(nSyllableIndexDraggedTo)
                        }
                    }
                }
            }

            //commented out below because we don't need the calculations in the data itself!
            //if(blnRecalculateRepetitionLinkGroup) this.RecalculateRepetitionLinkGroupCalculationsForCurrentChapter(groupToChange);

            //console.log(groupToChange)
            this.SaveRepetitionLinkGroupsAndSetState(listToSet);
            
            if(groupToChange != undefined) 
            {
                this.setState({listCurrentRepetitionLinkGroups: [groupToChange]});
                //this.setState({nCurrentRepetitionLinkGroupSelectedIndex: 0});
            }
        }

        this.setState({listWordsDraggedFrom: undefined})
        this.setState({listWordsHoveredWhileDragging: undefined})
    }

	DragWordEnd(w, event, oSyllable)
	{
        var nToolToUse = this.GetLinkToolToUse(event);

        if(this.InThematicStatementsMode())
        {
            var listToAdd = this.listThematicStatements.filter(ots => w.ThematicStatementIDs.includes(ots.ID))
            this.setState({listThematicStatementsSelectedForSearch: this.state.blnShiftDown ? this.state.listThematicStatementsSelectedForSearch.concat(listToAdd) : listToAdd})
        }
		if(nToolToUse === this.nMarkCorrespondencesWithinLineGroupsToolID)
		{
			//set the pgroup to be the same as the word dragged to
			//if it is the same word on mousedown and mouseup, toggle between undefined and previous value.
			var listWordsToChange = this.state.listWordsDraggedFrom;
			var valueToSet = this.GetPGroupForWord(w);

			if(listWordsToChange.includes(w))
			{
				var currentValueForTargetFirstWord = this.GetPGroupForWord(listWordsToChange[0]);
				valueToSet = (currentValueForTargetFirstWord === null || currentValueForTargetFirstWord === undefined) ?
					this.GetNextPGroupValueWithinRepetitionGroupForLine(this.LineWithWord(w)) : null;
			}

			var listWordsOverrideToSet = this.state.listWordsOverride;
			for(var wordToChange of listWordsToChange)
			{
				var wordOverride = listWordsOverrideToSet.find(w2 => w2.TextIndex === wordToChange.TextIndex);
				if(wordOverride === undefined)
				{
					wordOverride = {TextIndex: wordToChange.TextIndex};
					listWordsOverrideToSet.push(wordOverride);
				}
				wordOverride.PGroup = valueToSet; //this.state.nCurrentPGroupForMarking === undefined || this.state.nCurrentPGroupForMarking === 0 ? undefined : this.state.nCurrentPGroupForMarking;
				wordToChange.PGroup = wordOverride.PGroup; //for updated view, even though it won't save to the DB
			}

			//console.log("Clicked on " + w.FullText + ":" + w.PGroup + ". " + listWordsToChange[0].PGroup + "->" + valueToSet);
			var listLinesToSet = this.state.listLines;
			listLinesToSet.filter(l => listWordsToChange.some(w2 => l.Words.includes(w2))) 
				.forEach(l => this.RecalculatePGroupOrderInLine(l));	
			this.setState({listLines: listLinesToSet});

			this.SaveWordOverrides(listWordsOverrideToSet);
		}
		else if(nToolToUse === this.nWordLinkToolID)
		{
			var listWordsToChange = this.state.listWordsDraggedFrom;			
			var listWordsOverrideToSet = this.state.listWordsOverride;
			for(var wordToChange of listWordsToChange)
			{
				var wordOverride = listWordsOverrideToSet.find(w2 => w2.TextIndex === wordToChange.TextIndex);
				if(wordOverride === undefined)
				{
					wordOverride = {TextIndex: wordToChange.TextIndex};
					listWordsOverrideToSet.push(wordOverride);
				}

				// console.log(wordOverride);
				// console.log(listWordsToChange);
				// console.log(w);
				if(wordOverride.LinkedWordsList === undefined) wordOverride.LinkedWordsList = [];

				if(wordOverride.LinkedWordsList.some(o => o.TextIndex === w.TextIndex))
				{
					//if the type is different, update the type, otherwise remove it.
					//console.log("Removed");
                    var nIndexToRemove = wordOverride.LinkedWordsList.findIndex(o => o.TextIndex === w.TextIndex);
                    if(wordOverride.LinkedWordsList[nIndexToRemove].Type != this.state.sWordLinkToolType)
                        wordOverride.LinkedWordsList[nIndexToRemove].Type = this.state.sWordLinkToolType;
					else wordOverride.LinkedWordsList.splice(nIndexToRemove, 1);
				}
				else if(listWordsToChange.includes(w))
				{
					//console.log("Reset");
					//if mouse up and down on the same word, remove everything in its list (TODO: is this too dangerous?)
					var currentValueForTargetFirstWord = this.GetLinkedWordsListForWord(listWordsToChange[0]);
					if(currentValueForTargetFirstWord != [] && currentValueForTargetFirstWord != undefined) 
						wordOverride.LinkedWordsList = [];
				}
				else
					wordOverride.LinkedWordsList.push({TextIndex: w.TextIndex, Type: this.state.sWordLinkToolType});

				//console.log(wordOverride);
			}

			this.SaveWordOverrides(listWordsOverrideToSet);
			this.setState({listWordLinkGroups: this.CalculateObjectLinkGroupsFromObjectList(this.listTextWordsForChapter, "word")}); //, () => console.log(this.state.listWordLinkGroups));
			this.setState({listWordLinkPairs: this.CalculateWordLinkPairs()});
		}
		else if(nToolToUse === this.nLineLinkToolID)
		{
			var thisLine = this.LineWithWord(w);
			var lineToChange = this.LineWithWord(this.state.listWordsDraggedFrom[0]);		
			var listLinesToSet = this.state.listLines;

			var line = listLinesToSet.find(l => l.TextIndexRangeEnd === lineToChange.TextIndexRangeEnd);
			if(line === undefined)
			{
				line = {TextIndexRangeEnd: lineToChange.TextIndexRangeEnd};
				listLinesToSet.push(line);
			}

            var listLinkedLinesListSplit = line.LinkedLinesList === undefined ? [] : line.LinkedLinesList.split(",");
			if(listLinkedLinesListSplit.includes(thisLine.TextIndexRangeEnd))
			{
				//remove it
				var nIndexToRemove = listLinkedLinesListSplit.findIndex(n => n === thisLine.TextIndexRangeEnd);
				listLinkedLinesListSplit.splice(nIndexToRemove, 1);
			}
			else
                listLinkedLinesListSplit.push(thisLine.TextIndexRangeEnd);

            line.LinkedLinesList = listLinkedLinesListSplit.join(",");

			this.SaveLines(listLinesToSet);
			this.setState({listLineLinkGroups: this.CalculateObjectLinkGroupsFromObjectList(this.state.listLines, "line")});
		}
        else if(nToolToUse === this.nRepetitionLinkGroupToolID)
		{
            this.DragEndForRepetitionLinkGroupTool(w, null)
		}
        else if(this.AnyLensIsEnabled())
        {
            if(this.SomeSyllableSpecificHoverLensIsEnabled())
            {
                this.ToggleSyllableInLenStickyWords(oSyllable)
            }
            else
            {
                this.ToggleWordInLenStickyWords(w)
            }
        }

		if(nToolToUse === this.nMarkCorrespondencesWithinLineGroupsToolID || 
           nToolToUse === this.nWordLinkToolID || nToolToUse === this.nLineLinkToolID)
		{
			this.setState({listWordsDraggedFrom: undefined});
			this.setState({listWordsHoveredWhileDragging: undefined});
		}
	}

    ToggleSelectedWordGroupInLineChart(oWordGroup)
    {
        if(this.state.blnShiftDown)
        {
            var listToSet = this.state.listSelectedWordGroupsInLineChart
            if(listToSet.includes(oWordGroup))
            {
                listToSet.splice(listToSet.findIndex(gs => gs === oWordGroup), 1)
            }
            else
            {
                listToSet.push(oWordGroup)
            }

            this.setState({listSelectedWordGroupsInLineChart: listToSet})
        }      
        else
        {
            this.setState({listSelectedWordGroupsInLineChart: [oWordGroup]})
        }
    }

    ToggleWordInLenStickyWords(w)
    {
        if(this.state.blnShiftDown) //this.state.listCurrentStickiedWordsForHoverLens.includes(w)
        {
            var listToSet = this.state.listCurrentStickiedWordsForHoverLens
            if(listToSet.includes(w))
            {
                listToSet.splice(listToSet.findIndex(ws => ws === w), 1)
            }
            else
            {
                listToSet.push(w)
            }

            this.setState({listCurrentStickiedWordsForHoverLens: listToSet})
        }      
        else
        {
            this.SetWordGroupsForCurrentHoverTypeLens(w)
            this.setState({listCurrentStickiedWordsForHoverLens: [w]})
        }
    }

    ToggleSyllableInLenStickyWords(syl)
    {
        if(this.state.blnShiftDown) //this.state.listCurrentStickiedSyllablesForHoverLens.includes(syl)
        {
            var listToSet = this.state.listCurrentStickiedSyllablesForHoverLens
            if(listToSet.includes(syl))
            {
                listToSet.splice(listToSet.findIndex(syls => syls === syl), 1)
            }
            else
            {
                listToSet.push(syl)
            }

            this.setState({listCurrentStickiedSyllablesForHoverLens: listToSet})
        }      
        else
        {
            //this.SetWordGroupsForCurrentHoverTypeLens(w)
            this.setState({listCurrentStickiedSyllablesForHoverLens: [syl]})
        }
    }

    SetWordGroupsForCurrentHoverTypeLens(wNewOne)
    {
        if(this.state.blnShowLenses)
        {
            var listWordGroupsForCurrentHoverTypeLensToSet = []
            this.listAllSimilaritiesByWordComparedToHoveredWord = []
            
            var listHoveredOrSelectedWords = this.state.listCurrentStickiedWordsForHoverLens //this.AllHoveredOrStickiedWordsForLens()
            if(wNewOne != undefined) listHoveredOrSelectedWords = listHoveredOrSelectedWords.concat(wNewOne)

            if(this.SemanticChainsLensAmongUnitsIsEnabled())
            {
                var listTextWordsToUse = this.listTextWordsForChapter
                var listSemanticGroups = this.GetSemanticChainsForCurrentChapter(listTextWordsToUse).map((g, n) => 
                    ({ListWords: g.ListWords, Color: this.listLinkGroupColors[n % this.listLinkGroupColors.length]}))

                var listWordsByBreakGroup = this.GetWordsByBreakGroup(this.state.listLines, this.state.sGroupLinesBy)

                for(var w of listHoveredOrSelectedWords)
                {
                    var listWordsInBreakGroupForWord = listWordsByBreakGroup.filter(listWordsInBreakGroup => listWordsInBreakGroup.includes(w)).flat()
                    var listWordsToCompare = listTextWordsToUse

                    if(this.state.sIntraOrInterUnitsLensScope === 'between')
                        listWordsToCompare = listWordsByBreakGroup.filter(lw => !lw.includes(w)).flat()
                    else if(this.state.sIntraOrInterUnitsLensScope === 'inside')
                        listWordsToCompare = listWordsByBreakGroup.filter(lw => lw.includes(w)).flat()

                    for(var w2 of listWordsInBreakGroupForWord)
                    {
                        var listGroupsWithWord = listSemanticGroups.filter(g => g.ListWords.includes(w2.TextIndex))
                        
                        for(var w3 of listWordsToCompare)
                        {
                            var listGroupsWithWord3 = listGroupsWithWord.filter(g => g.ListWords.includes(w3.TextIndex))
                            if(listGroupsWithWord3.length > 0)
                            {
                                listWordGroupsForCurrentHoverTypeLensToSet.push({ListWords: [w, w3], Color: listGroupsWithWord3[0].Color, SelectedWords: [w]})
                            }
                        }
                    }
                }

                //listWordGroupsForCurrentHoverTypeLensToSet.forEach((g, n) => g.Color = this.listLinkGroupColors[n % this.listLinkGroupColors.length])
            }
            else if(this.AllSimilarityLensIsEnabled())
            {
                var listWordsByBreakGroup = this.GetWordsByBreakGroup(this.state.listLines, this.state.sGroupLinesBy)

                for(var w of listHoveredOrSelectedWords)
                {
                    // var nLeftToGet = 1
                    var listWordsToCompare = this.listTextWordsForChapter

                    if(this.state.sIntraOrInterUnitsLensScope === 'between')
                        listWordsToCompare = listWordsByBreakGroup.filter(lw => !lw.includes(w)).flat()
                    else if(this.state.sIntraOrInterUnitsLensScope === 'inside')
                        listWordsToCompare = listWordsByBreakGroup.filter(lw => lw.includes(w)).flat()

                    //{"A": "19573", "L": [{"B": "19576", "N": 8.5, "S": "suffix pgn root emotion stem form"}, {"B": "19584", "N": 6.5, "S": "root emotion stem"}
                    var oForA = this.listAllSimilarityPairsForChapter.find(o => o.A === w.TextIndex)
                    var listAllSimilarity = oForA === undefined ? [] : oForA.L.filter(o => listWordsToCompare.includes(o.W2))
                        // listWordsToCompare.map(w2 => this.GetAllSimilarityAmountScoreNew(w, w2))

                    // var listOnesToGet = listOnesScoringAbovePreferred.length > 0 ? listOnesScoringAbovePreferred : 
                    //     listOnesScoringBelowPreferred.length > 0 ? listOnesScoringBelowPreferred : 
                    //     listAllSimilarity.filter(o => o.TextAlliteration)
                    
                    for(var o of listAllSimilarity.filter(o => o.N >= this.state.listAllSimilarityScoreThreshold))
                    {
                        listWordGroupsForCurrentHoverTypeLensToSet.push({ListWords: [w, o.W2], Color: this.GetAllSimilarityColorFromScore(o.N), SelectedWords: [w]})
                        // nLeftToGet -= sg.length
                        // if(nLeftToGet <= 0) break
                    }
                    
                    this.listAllSimilaritiesByWordComparedToHoveredWord = this.listAllSimilaritiesByWordComparedToHoveredWord.concat(
                        listAllSimilarity.map(o => ({Word: o.W2, ToShow: o.S + ' ' + o.N}))) // + '_' + o.Score
                }
            }
            else if(this.AllSimilarityForLinesLensIsEnabled())
            {
                var listLinesByBreakGroup = this.GetLinesByBreakGroup(this.state.listLines, this.state.sGroupLinesBy)

                for(var w of listHoveredOrSelectedWords)
                {
                    var l1 = this.GetLineContainingWord(w)
                    if(l1 === undefined) continue
                    
                    var listLinesToCompare = this.state.listLines.filter(l => l != l1)

                    if(this.state.sIntraOrInterUnitsLensScope === 'between')
                        listLinesToCompare = listLinesByBreakGroup.filter(listLines => !listLines.includes(l1)).flat()
                    else if(this.state.sIntraOrInterUnitsLensScope === 'inside')
                        listLinesToCompare = listLinesByBreakGroup.filter(listLines => listLines.includes(l1)).flat()

                    var oForLine1 = this.listAllSimilarityLinePairsForChapter.find(o => o.Line1 === l1)
                    var listAllSimilarity = oForLine1 === undefined ? [] : oForLine1.L.filter(o => listLinesToCompare.includes(o.Line2))
                       
                    for(var o of listAllSimilarity.filter(o => o.N >= this.state.listAllSimilarityScoreThreshold))
                    {
                        var nScore = o.N
                        var sColor = ''
                        
                        if(this.blnChapterIsHebrew) 
                        {
                            sColor = nScore < 2.3 ? "LightGray" : 
                                nScore < 4.6 ? "#239b56" : // #239b56 
                                nScore < 7 ? "CornflowerBlue" : //"#ca6f1e" : "
                                nScore < 9.2 ? "Red" : 
                                nScore < 11.5 ? "Purple" : "Black"
                        }
                        else
                        {
                            sColor = nScore < 10 ? "LightGray" : 
                                nScore < 20 ? "#239b56" : // #239b56 
                                nScore < 30 ? "CornflowerBlue" : //"#ca6f1e" : "
                                nScore < 40 ? "Red" : 
                                nScore < 50 ? "Purple" : "Black"
                        }

                        listWordGroupsForCurrentHoverTypeLensToSet.push({ListWords: l1.Words.concat(o.Line2.Words), 
                            Color: sColor, SelectedWords: l1.Words})

                        this.listAllSimilaritiesByWordComparedToHoveredWord = this.listAllSimilaritiesByWordComparedToHoveredWord.concat(
                            o.Line2.Words.map(w => ({Word: w, ToShow: o.S + ' ' + o.N})))
                    }
                }
            }
            else if(this.AllSimilarityForStanzasLensIsEnabled())
            {
                for(var w of listHoveredOrSelectedWords)
                {
                    var oFor1 = this.listAllSimilarityStanzaPairsForChapter.find(o => o.ListWords1.includes(w))
                    var listAllSimilarity = oFor1 === undefined ? [] : oFor1.L
                       
                    // console.log(oForLine1)
                    for(var o of listAllSimilarity.filter(o => o.N >= this.state.listAllSimilarityScoreThreshold))
                    {
                        var nScore = o.N
                        var sColor = nScore < 5 ? "LightGray" : 
                            nScore < 11 ? "#239b56" : // #239b56 
                            nScore < 16 ? "CornflowerBlue" : //"#ca6f1e" : "
                            nScore < 21 ? "Red" : 
                            nScore < 27 ? "Purple" : "Black"

                        listWordGroupsForCurrentHoverTypeLensToSet.push({ListWords: oFor1.ListWords1.concat(o.ListWords2), 
                            Color: sColor, SelectedWords: oFor1.ListWords1})

                        this.listAllSimilaritiesByWordComparedToHoveredWord = this.listAllSimilaritiesByWordComparedToHoveredWord.concat(
                            o.ListWords2.map(w => ({Word: w, ToShow: o.S + ' ' + o.N})))
                    }
                }
            }
            else if(this.RootCooccurrenceLensIsEnabled())
            {
                for(var w1 of listHoveredOrSelectedWords)
                {
                    for(var w2 of this.listTextWordsForChapter)
                    {
                        var sColor = ''
                        var listLocations = []

                        if(w1 === undefined || w2 === undefined) sColor = "Gray"
                        else if(!this.IncludeWordInRootCooccurrenceLens(w1) || !this.IncludeWordInRootCooccurrenceLens(w2)) sColor = 'LightGray'
                        else if(w1.ParentRoot === w2.ParentRoot && w1.ParentRoot != '') sColor = 'Black'
                        else
                        {
                            var nRootIndex1 = this.listRootCooccurrenceDataForChapter.RootList.indexOf(w1.ParentRoot)
                            var nRootIndex2 = this.listRootCooccurrenceDataForChapter.RootList.indexOf(w2.ParentRoot)

                            var sRoot1 = this.listRootCooccurrenceDataForChapter.RootList[nRootIndex1]
                            var sRoot2 = this.listRootCooccurrenceDataForChapter.RootList[nRootIndex2]

                            if(sRoot1 === '' || sRoot2 === '') sColor = "LightGray"
                            else
                            {
                                var listScores = this.listRootCooccurrenceDataForChapter.Scores.filter(o => (nRootIndex1 === o.R1 && nRootIndex2 === o.R2) || 
                                    (nRootIndex1 === o.R2 && nRootIndex2 === o.R1))

                                // console.log(this.listRootCooccurrenceDataForChapter.Scores)
                                //["Jos.1.8", 99694, 99697, 3], ["Psa.1.2", 18, 22, 4]
                                
                                if(this.dictTextForAllOTWords.size > 0)
                                {
                                    listLocations = listScores.flatMap(o => o.L.map(listOfStuff => {
                                        var nProximity = listOfStuff[2] - listOfStuff[1]
                                        var listTextForTextIndexesInRange = [...Array(nProximity + 1).keys()].map(n => this.dictTextForAllOTWords.get(listOfStuff[1] + n))
                                        // console.log(listOfStuff[1], listOfStuff[2], [...Array(nProximity + 1).keys()].map(n => listOfStuff[1] + n))
                                        return listOfStuff[0] + ' ' + listTextForTextIndexesInRange.join(' ')
                                    }))
                                }
                                else
                                {
                                    listLocations = listScores.flatMap(o => o.L.map(listOfStuff => listOfStuff[0] + ' ' + (listOfStuff[2] - listOfStuff[1]))).join('; ') //.sort((a,b) => a.localeCompare(b)).join('; ')
                                }

                                var nScore = listScores.length === 0 ? 0 : Math.max(...listScores.map(o => o.N))

                                sColor = nScore < 2 ? "LightGray" : 
                                    nScore < 5 ? "Gray" : 
                                    nScore < 10 ? "Green" : 
                                    nScore < 20 ? "Orange" : 
                                    nScore < 30 ? "Red" : 
                                    nScore < 50 ? "Purple" : 
                                    nScore >= 100 ? "Black" : "LightGray"
                            }
                        }

                        listWordGroupsForCurrentHoverTypeLensToSet.push({ListWords: [w1, w2], Color: sColor, SelectedWords: [w1]})
                        this.listAllSimilaritiesByWordComparedToHoveredWord.push({Word: w2, ListToShow: listLocations})
                    }
                }
            }
            
            // console.log(listWordGroupsForCurrentHoverTypeLensToSet)
            this.setState({listWordGroupsForCurrentHoverTypeLens: listWordGroupsForCurrentHoverTypeLensToSet})
        }
    }

    GetDisplayStringForAllSimilarityBetweenWordLists(o)
    {
        return o.W1.FullText + ' v ' + o.W2.FullText + ' w ' + o.Score + ' ' + o.ListSimilarities
    }

    GetAllSimilarityBetweenWordLists(listWords1, listWords2, blnUseEachW2OnlyOnce, listWordPairsForChapter)
    {
        var listOfScoresPerWord = listWords1.map(w1 => listWords2.map(w2 => {
            var oForA = listWordPairsForChapter.find(o => o.A === w1.TextIndex)
            var oForB = oForA === undefined ? undefined : oForA.L.find(o => o.B === w2.TextIndex)

            return oForB === undefined ? {W1: w1, W2: w2, Score: 0, ListSimilarities: ''} : 
                {W1: w1, W2: w2, Score: oForB.N, ListSimilarities: oForB.S}
            // this.GetAllSimilarityAmountScore(w1, w2)
        }).filter(o => o.Score > 0))

        for(var listObjects of listOfScoresPerWord)
        {
            listObjects.sort((a,b) => a.Score - b.Score)
        }

        var listObjectsDeleted = []
        if(blnUseEachW2OnlyOnce)
        {
            for(var w2 of listWords2)
            {
                //only keep the highest score for a given w2. A w2 should only match <= 1 times across all the w1s.
                var listScoresForWord2 = listOfScoresPerWord.flat().filter(o => o.W2 === w2).map(o => o.Score)
                if(listScoresForWord2.length > 0)
                {
                    var nMaxScoreForWord = Math.max(...listScoresForWord2)
                    for(var listObjects of listOfScoresPerWord)
                    {
                        var nIndexToDelete = listObjects.findIndex(o => o.W2 === w2 && o.Score != nMaxScoreForWord)
                        // if(listWords1.some(wt => wt.TextIndex === '7871') && w2.TextIndex === '7846') console.log(w2, listObjects[nIndexToDelete])
                        if(nIndexToDelete > -1) 
                        {
                            //log the deleted ones if they were the best score
                            if(nIndexToDelete === listObjects.length - 1) listObjectsDeleted.push(listObjects[nIndexToDelete])
                            listObjects.splice(nIndexToDelete, 1)
                        }
                    }
                }
            }
        }

        var listBestScores = listOfScoresPerWord.map(listObjects => listObjects.length === 0 ? null : listObjects[listObjects.length - 1])
        var listValidBestScores = listBestScores.filter(obs => obs != null)
        
        //sort so that best scores are first
        listValidBestScores.sort((a,b) => b.Score - a.Score)
        listObjectsDeleted.sort((a,b) => b.Score - a.Score)

        return {Score: listValidBestScores.reduce((acc, o) => acc + o.Score, 0), TotalPositiveScores: listValidBestScores.length,
            SimilaritiesAfterDeletion: listValidBestScores.map(o => this.GetDisplayStringForAllSimilarityBetweenWordLists(o)).join('; '), 
            SimilaritiesForDeletedObjects: listObjectsDeleted.map(o => this.GetDisplayStringForAllSimilarityBetweenWordLists(o)).join('; ')}
    }

    SimilarWordsGroupedTogetherLens(listTextWordsToUse, listLinesToUse)
    {
        var nScoreThreshold = 4
        var listToReturn = []
        var listWordsByBreakGroup = this.GetWordsByBreakGroup(listLinesToUse, this.state.sGroupLinesBy)

        for(var w of listTextWordsToUse)
        {
            var listWordsToCompare = listTextWordsToUse

            if(this.state.sIntraOrInterUnitsLensScope === 'between')
                listWordsToCompare = listWordsByBreakGroup.filter(lw => !lw.includes(w)).flat()
            else if(this.state.sIntraOrInterUnitsLensScope === 'inside')
                listWordsToCompare = listWordsByBreakGroup.filter(lw => lw.includes(w)).flat()

            var oForA = this.listAllSimilarityPairsForChapter.find(o => o.A === w.TextIndex)
            var listAllSimilarity = oForA === undefined ? [] : oForA.L.filter(o => listWordsToCompare.includes(o.W2))

            for(var o of listAllSimilarity.filter(o => o.N >= nScoreThreshold))
            {
                if(!listToReturn.some(or => or.ListWords.includes(w) && or.ListWords.includes(o.W2)))
                    listToReturn.push({ListWords: [w, o.W2], Name: w.FullText + ' ' + o.W2.FullText, 
                        Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
            }
        }

        return listToReturn
    }

    SimilarLinesGroupedTogetherLens(listLinesToUse)
    {
        var nScoreThreshold = 9
        var listToReturn = []
        var listLinesByBreakGroup = this.GetLinesByBreakGroup(listLinesToUse, this.state.sGroupLinesBy)

        for(var l1 of listLinesToUse)
        {
            var listWords1 = l1.Words
            var listLinesToCompare = listLinesToUse.filter(l => l != l1)

            if(this.state.sIntraOrInterUnitsLensScope === 'between')
                listLinesToCompare = listLinesByBreakGroup.filter(listLines => !listLines.includes(l1)).flat()
            else if(this.state.sIntraOrInterUnitsLensScope === 'inside')
                listLinesToCompare = listLinesByBreakGroup.filter(listLines => listLines.includes(l1)).flat()

            var oForLine1 = this.listAllSimilarityLinePairsForChapter.find(o => o.Line1 === l1)
            var listAllSimilarity = oForLine1 === undefined ? [] : oForLine1.L.filter(o => listLinesToCompare.includes(o.Line2))
            
            for(var o of listAllSimilarity)
            {
                //o.s
                if(o.N >= nScoreThreshold && !listToReturn.some(or => or.ListLines.includes(l1) && or.ListLines.includes(o.Line2))) 
                    listToReturn.push({ListWords: listWords1.concat(o.Line2.Words), ListLines: [l1, o.Line2], Name: '', 
                        Color: this.listLinkGroupColors[listToReturn.length % this.listLinkGroupColors.length]})
            }
        }

        return listToReturn
    }

    SimilarStanzasGroupedTogetherLens(listLinesToUse)
    {
        return []
    }

    AggregateAllSimilarityBetweenWordListsLens(sAggregateType)
    {
        // this.GetWordsByBreakGroup(this.state.listLines, this.GetSubUnitForTextUnit(this.state.sGroupLinesBy))
        var listToReturn = []
        var listLinesByBreakGroup = this.GetLinesByBreakGroup(this.state.listLines, this.state.sGroupLinesBy)

        for(var l1 of this.state.listLines)
        {
            var listWords1 = l1.Words
            var listLinesToCompare = this.state.listLines.filter(l => l != l1)

            if(this.state.sIntraOrInterUnitsLensScope === 'between')
                listLinesToCompare = listLinesByBreakGroup.filter(listLines => !listLines.includes(l1)).flat()
            else if(this.state.sIntraOrInterUnitsLensScope === 'inside')
                listLinesToCompare = listLinesByBreakGroup.filter(listLines => listLines.includes(l1)).flat()

            var oForLine1 = this.listAllSimilarityLinePairsForChapter.find(o => o.Line1 === l1)
            var listAllSimilarity = oForLine1 === undefined ? [] : oForLine1.L.filter(o => listLinesToCompare.includes(o.Line2))
            
            var nScore = 0
            for(var o of listAllSimilarity)
            {
                if(sAggregateType === 'sum') nScore += o.N
                else if(sAggregateType === 'max' && o.N > nScore) nScore = o.N
            }
            
            // var nNormalizedScore = nScore / (1.0 * this.state.listLines.length)

            listToReturn.push({ListWords: listWords1, Score: nScore})
        }

        var listScores = listToReturn.map(o => o.Score)
        // console.log(listScores)
        // console.log(this.Quantile(listScores, 0), this.Quantile(listScores, 0.25), this.Quantile(listScores, 0.5), this.Quantile(listScores, 0.75), this.Quantile(listScores, 1.0))

        var nQuantile1 = this.Quantile(listScores, 0.17)
        var nQuantile2 = this.Quantile(listScores, 0.34)
        var nQuantile3 = this.Quantile(listScores, 0.51)
        var nQuantile4 = this.Quantile(listScores, 0.68)
        var nQuantile5 = this.Quantile(listScores, 0.85)

        listToReturn.forEach(o => 
            o.Color = o.Score < nQuantile1 ? "LightGray" : 
                o.Score < nQuantile2 ? "#239b56" : // #239b56 
                o.Score < nQuantile3 ? "CornflowerBlue" : //"#ca6f1e" : "
                o.Score < nQuantile4 ? "Red" : 
                o.Score < nQuantile5 ? "Purple" : "Black"
        )

        // console.log(listToReturn)
        return listToReturn
    }

    Quantile(arr, q)
    {
        const sorted = arr.sort((a, b) => a - b)
        const pos = (sorted.length - 1) * q;
        const base = Math.floor(pos);
        const rest = pos - base;
        if (sorted[base + 1] !== undefined) {
            return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
        } else {
            return sorted[base];
        }
    }

    SetCurrentWordForHoverLens(w)
    {
        // if(w != undefined) console.log(w.SeparatedText)
        
        // console.log(this.state.listCurrentStickiedWordsForHoverLens)
        if(!this.state.listCurrentStickiedWordsForHoverLens.includes(w))
        {
            this.SetWordGroupsForCurrentHoverTypeLens(w)
            this.setState({currentWordForHoverLens: w})
        }
    }

    SetCurrentSyllableForHoverLens(syl)
    {
        // console.log(this.state.listCurrentStickiedWordsForHoverLens)
        if(!this.state.listCurrentStickiedSyllablesForHoverLens.includes(syl))
        {
            //this.SetWordGroupsForCurrentHoverTypeLens(w)
            this.setState({currentSyllableForHoverLens: syl})
        }
    }

    DeleteCurrentRepetitionLinkGroup()
    {
        if(this.state.listCurrentRepetitionLinkGroups != undefined && window.confirm("Really delete selected group?"))
        {
            var listToSet = this.state.listRepetitionLinkGroups;
            var nIndexToRemove = listToSet.findIndex(g => g === this.state.listCurrentRepetitionLinkGroups[0]);
            listToSet.splice(nIndexToRemove, 1);
            this.SaveRepetitionLinkGroupsAndSetState(listToSet);

            this.setState({listCurrentRepetitionLinkGroups: undefined});
            this.setState({currentRepetitionLinkGroupIsSticky: false});
        }
    }

	handleClickOnWord(event, TextWord)
	{
        //shift toggles the opposite tool
        var nToolToUse = this.state.nSelectedToolID

        if(nToolToUse === this.nColaSplitToolID && event.shiftKey) nToolToUse = this.nColaMergeToolID;
        else if(nToolToUse === this.nColaMergeToolID && event.shiftKey) nToolToUse = this.nColaSplitToolID;
        else if(nToolToUse === this.nColaIndentToolID && event.shiftKey) nToolToUse = this.nColaUnindentToolID;
        else if(nToolToUse === this.nColaUnindentToolID && event.shiftKey) nToolToUse = this.nColaIndentToolID;

		if(nToolToUse === this.nColaSplitToolID || nToolToUse === this.nColaMergeToolID ||
		   nToolToUse === this.nColaIndentToolID || nToolToUse === this.nColaUnindentToolID)
		{
			var listLinesToSet = this.state.listLines;
			var lineTextWordIsIn = listLinesToSet.find(l => l.Words.includes(TextWord));			
	
			// var listColaToSet = this.state.listCola;
			// var colaTextWordIsIn = listColaToSet.find(r => this.TextIndexIsInColon(TextWord.TextIndex, r));	

            if(event.altKey && (nToolToUse === this.nColaSplitToolID || nToolToUse === this.nColaMergeToolID))
            {
                lineTextWordIsIn.UnsureAboutDelineation = !lineTextWordIsIn.UnsureAboutDelineation
            }
            else if(nToolToUse === this.nColaSplitToolID && !this.state.blnMultipleChaptersSelected)
			{
				//all TextIndexes are already included in a colon, even if there is one colon for the whole chapter.
				//e.g. 1234, click on 2 -> 12 and 34
                let nCurrentChapter = this.GetFirstCurrentChapter()
                
                var newLine = null
                var nOldEndIndex = lineTextWordIsIn.TextIndexRangeEnd
                var nIndexOfWordInChapterWords = this.listTextWordsForChapter.indexOf(TextWord)
                if(this.blnChapterIsHebrew)
                {
                    if(nIndexOfWordInChapterWords < this.listTextWordsForChapter.length - 1)
                    {
                        lineTextWordIsIn.TextIndexRangeEnd = TextWord.TextIndex
                        newLine = {"Book": this.state.nCurrentBook, "Chapter": nCurrentChapter, 
                            "TextIndexRangeBegin": parseInt(this.listTextWordsForChapter[nIndexOfWordInChapterWords + 1].TextIndex), "TextIndexRangeEnd": parseInt(nOldEndIndex), 
                            "IndentLevel": 0}
                    }
                }
                else
                {
                    if(nIndexOfWordInChapterWords > 0)
                    {
                        lineTextWordIsIn.TextIndexRangeEnd = parseInt(this.listTextWordsForChapter[nIndexOfWordInChapterWords - 1].TextIndex)
                        newLine = {"Book": this.state.nCurrentBook, "Chapter": nCurrentChapter, 
                            "TextIndexRangeBegin": parseInt(TextWord.TextIndex ), "TextIndexRangeEnd": parseInt(nOldEndIndex), 
                            "IndentLevel": 0};
                    }
                }

                if(newLine != null)
                {
                    this.CalculateLine(lineTextWordIsIn, this.listTextWordsForChapter)
                    this.CalculateLine(newLine, this.listTextWordsForChapter)			
                    listLinesToSet.push(newLine);													
                    listLinesToSet = this.SortLines(listLinesToSet)
                }

                //add a new translation line at the same index of the line added for the split
                //{Chapter: sCurrentChapter, LineIndex: nLine, Translation: sLine}
                var sCurrentChapter = nCurrentChapter.toString()
                var listTranslationLinesToSet = this.state.listOurTranslationLines
                var listTranslationWordIndexLinksToSet = this.state.listTranslationWordIndexLinks

                let nIndexInLinesThatLineWasInsertedAt = listLinesToSet.indexOf(newLine)

                if(nIndexInLinesThatLineWasInsertedAt > -1)
                {
                    var nIndexInTranslationLinesToAddNewLineAt = listTranslationLinesToSet.findIndex(tl => tl.Chapter === sCurrentChapter && 
                        tl.LineIndex === nIndexInLinesThatLineWasInsertedAt)

                    if(nIndexInTranslationLinesToAddNewLineAt > -1)
                    {
                        listTranslationLinesToSet.splice(nIndexInTranslationLinesToAddNewLineAt, 0, {Chapter: sCurrentChapter, 
                            LineIndex: nIndexInTranslationLinesToAddNewLineAt, Translation: ''})
                        
                        //move all the following translation lines down one line
                        for(var nTranslationLineIndex = nIndexInTranslationLinesToAddNewLineAt + 1; 
                            nTranslationLineIndex < listTranslationLinesToSet.length; nTranslationLineIndex++)
                        {
                            listTranslationLinesToSet[nTranslationLineIndex].LineIndex += 1
                        }
                        
                        //the translation links also have line indexes matched to the line index of the translation lines,
                        //so change those, too
                        //{"Original": "47", "Translation": 1, "LineIndex": 10, "Chapter": "1"}
                        for(var nIndexOfTranslationWordIndexLink = 0; nIndexOfTranslationWordIndexLink < listTranslationWordIndexLinksToSet.length; 
                            nIndexOfTranslationWordIndexLink++)
                        {
                            if(listTranslationWordIndexLinksToSet[nIndexOfTranslationWordIndexLink].LineIndex >= nIndexInLinesThatLineWasInsertedAt)
                            {
                                listTranslationWordIndexLinksToSet[nIndexOfTranslationWordIndexLink].LineIndex += 1
                            }
                        }

                        this.SaveOurTranslationLines(listTranslationLinesToSet)
                        this.SaveTranslationWordIndexLinks(listTranslationWordIndexLinksToSet)
                    }
                }
			}
			else if(nToolToUse === this.nColaMergeToolID && !this.state.blnMultipleChaptersSelected)
			{
				//merge it into the previous colon - update the previous colon TextIndexRangeEnd to this one's and delete the extra colon		
				//user clicks on last word of previous colon or first word of colon to delete	
                let nCurrentChapter = this.GetFirstCurrentChapter()
				var listLinesInCurrentChapter = listLinesToSet.filter(r => parseInt(r.Book) === this.state.nCurrentBook && parseInt(r.Chapter) === nCurrentChapter);				
				var nIndexToDeleteInListForChapter = listLinesInCurrentChapter.findIndex(r => parseInt(r.TextIndexRangeBegin) === parseInt(TextWord.TextIndex));

				if(nIndexToDeleteInListForChapter === -1)
				{
					nIndexToDeleteInListForChapter = listLinesInCurrentChapter.findIndex(r => parseInt(r.TextIndexRangeEnd) === parseInt(TextWord.TextIndex));
					if(nIndexToDeleteInListForChapter === -1) return; //they clicked on some other word					 
					nIndexToDeleteInListForChapter += 1;
				}

				if(nIndexToDeleteInListForChapter === 0) return;

				var lineToDelete = listLinesInCurrentChapter[nIndexToDeleteInListForChapter];

                var nIndexInListForChapterToMergeInto = nIndexToDeleteInListForChapter - 1 //assumes ordering
				var lineToMergeItInto = listLinesInCurrentChapter[nIndexInListForChapterToMergeInto]		

                //merge the translations
                //{Chapter: sCurrentChapter, LineIndex: nLine, Translation: sLine}
                var sCurrentChapter = nCurrentChapter.toString()
                var listTranslationLinesToSet = this.state.listOurTranslationLines
                var listTranslationWordIndexLinksToSet = this.state.listTranslationWordIndexLinks

                var nIndexToDeleteInTranslationLines = listTranslationLinesToSet.findIndex(tl => tl.Chapter === sCurrentChapter && 
                    tl.LineIndex === nIndexToDeleteInListForChapter)

                var nIndexToMergeIntoInTranslationLines = listTranslationLinesToSet.findIndex(tl => tl.Chapter === sCurrentChapter && 
                    tl.LineIndex === nIndexInListForChapterToMergeInto)

                if(nIndexToDeleteInTranslationLines > -1 && nIndexToMergeIntoInTranslationLines > -1)
                {
                    let sToMerge = listTranslationLinesToSet[nIndexToDeleteInTranslationLines].Translation
                    
                    //the first letter in a line seems to be upper cased, so lower case it when merging
                    listTranslationLinesToSet[nIndexToMergeIntoInTranslationLines].Translation += ' ' + 
                        sToMerge.charAt(0).toLowerCase() + sToMerge.slice(1)                        

                    listTranslationLinesToSet.splice(nIndexToDeleteInTranslationLines, 1)
                    
                    //move all the following translation lines up one line
                    for(var nTranslationLineIndex = nIndexToDeleteInTranslationLines; nTranslationLineIndex < listTranslationLinesToSet.length; nTranslationLineIndex++)
                    {
                        listTranslationLinesToSet[nTranslationLineIndex].LineIndex -= 1
                    }

                    //delete the translation links for the merged line
                    listTranslationWordIndexLinksToSet = listTranslationWordIndexLinksToSet.filter(tl => tl.LineIndex !== nIndexToDeleteInTranslationLines)

                    //the translation links also have line indexes matched to the line index of the translation lines, so change those
                    for(var nIndexOfTranslationWordIndexLink = 0; nIndexOfTranslationWordIndexLink < listTranslationWordIndexLinksToSet.length; 
                        nIndexOfTranslationWordIndexLink++)
                    {
                        if(listTranslationWordIndexLinksToSet[nIndexOfTranslationWordIndexLink].LineIndex > nIndexToDeleteInTranslationLines)
                        {
                            listTranslationWordIndexLinksToSet[nIndexOfTranslationWordIndexLink].LineIndex -= 1
                        }
                    }

                    this.SaveOurTranslationLines(listTranslationLinesToSet)
                    this.SaveTranslationWordIndexLinks(listTranslationWordIndexLinksToSet)
                }

				// var nIndexToDeleteInWholeList = this.FindIndexOfColonInLinesList(lineToDelete, listLinesToSet);
				// var nIndexToMergeItIntoInWholeList = this.FindIndexOfColonInLinesList(lineToMergeItInto, listLinesToSet);

				var nIndexToDeleteInWholeList = listLinesToSet.indexOf(lineToDelete);
				var nIndexToMergeItIntoInWholeList = listLinesToSet.indexOf(lineToMergeItInto);

				listLinesToSet[nIndexToMergeItIntoInWholeList].TextIndexRangeEnd = parseInt(lineToDelete.TextIndexRangeEnd);
				this.CalculateLine(listLinesToSet[nIndexToMergeItIntoInWholeList], this.listTextWordsForChapter)				
				listLinesToSet.splice(nIndexToDeleteInWholeList, 1);	
			}
			else if(nToolToUse === this.nColaIndentToolID)
			{
				lineTextWordIsIn.IndentLevel = parseInt(lineTextWordIsIn.IndentLevel) + 1;	
			}
			else if(nToolToUse === this.nColaUnindentToolID)
			{
				lineTextWordIsIn.IndentLevel = lineTextWordIsIn.IndentLevel === 0 ? 0 : parseInt(lineTextWordIsIn.IndentLevel) - 1;
			}

			if(nToolToUse === this.nColaSplitToolID || nToolToUse === this.nColaMergeToolID) //&& !event.altKey)
			{		
				this.setState({listLines: listLinesToSet});
			}

			this.SaveLines(listLinesToSet);
		}
	}
	
	UpdateLineField(line, sField, value)
	{
		var listLinesToSet = this.state.listLines;
		var nIndexToUpdate = listLinesToSet.findIndex(l => l === line);
		listLinesToSet[nIndexToUpdate][sField] = value;
		this.setState({listLines: listLinesToSet});
		this.SaveLines(listLinesToSet);

		if(sField === "StartsRepetitionGroup" || sField === "NotInGroup" || sField === "StartsSequenceGroup")
			this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesToSet, true);
	}

    GetRepetitionLinkGroupsContainingWord(w) 
    {
        return this.GetRepetitionLinkGroupList().filter(g => g.ListWords.includes(w.TextIndex));
    }

    GetRepetitionLinkGroupsForCurrentChapter() 
    {
        return this.state.listRepetitionLinkGroups.filter(g => g.ListWords.some(nTextIndex => this.listTextWordsForChapter.some(w => w.TextIndex === nTextIndex)));
    }
	
	GetWordTagForWord(w)
	{
		return this.state.listWordTags.find(t => t.TextIndex === w.TextIndex);
	}

    FilterOutGlossStopwords(w)
    {
        var sToReturn = this.GetGlossForWord(w)

        for(var s2 of this.listGlossStopwords)
        {
            sToReturn = sToReturn.replace(s2, '')
        }

        return sToReturn.trim()
    }

    // GetSyllablesForWord(w)
    // {
    //     //return w['Syllables'].map(s => s.replaceAll(':', '').replaceAll('â', 'a').replaceAll('ô', 'o').replaceAll('û', 'u'))

    //     return w['Syllables'].map(s => s.replaceAll(':', '').replaceAll('ṣ', 'ts').replaceAll('š', 'sh').replaceAll('ḵ', 'kh')
    //         .replaceAll('iym', 'im').replaceAll('iyn', 'in').replaceAll('ê', 'ey').replaceAll('â', 'a')
    //         .replaceAll('ô', 'o').replaceAll('û', 'u').replaceAll('ah', 'a').replaceAll('ayw', 'av').replaceAll('iyw', 'iv'))
    // }

    SyllableHasFullAccent(s)
    {
        return s.includes('*') || s.includes('^') || s.includes('!')
    }

    SyllableHasSecondaryAccent(s)
    {
        return s.includes('|')
    }

    GetSyllableObjectsForWord(w)
    {
        if(this.blnChapterIsHebrew)
        {
            var listSyllables = w['Syllables'].map(s => s.replaceAll(':', '').replaceAll('iym', 'im').replaceAll('iyn', 'in')
                .replaceAll('ê', 'ey').replaceAll('â', 'a').replaceAll('ô', 'o').replaceAll('û', 'u')
                .replaceAll('ayw', 'av').replaceAll('iyw', 'iv'))

            return listSyllables.map((syl, nSyl, arrSyl) => ({'word': w, 'syllable': syl.replaceAll('ah', 'a').replaceAll('ṣ', 'ts').replaceAll('š', 'sh').replaceAll('ḵ', 'kh'), 
                'syllableWithSingleConsonants': syl.replaceAll('ah', 'a'), 'hasFullAccent': this.SyllableHasFullAccent(syl), 
                'hasSecondaryAccent': this.SyllableHasSecondaryAccent(syl), 'syllableIndex': nSyl, 'isLastSyllableInWord': nSyl === arrSyl.length - 1,
                'endsWithConsonantalHe': syl.includes('hh')}))
        }
        else
        {
            //ḵ = kh, Ḵ = Kh, θ = th, ŋ = ng
            return w['Syllables'].map((syl, nSyl, arrSyl) => ({'word': w, 'syllable': syl.replaceAll('ḵ', 'kh').replaceAll('Ḵ', 'Kh')
                .replaceAll('θ', 'th').replaceAll('Θ', 'Th').replaceAll('ŋ', 'ng').replaceAll('f', 'ph').replaceAll('F', 'Ph'), 
                'syllableWithSingleConsonants': syl, 'hasFullAccent': this.SyllableHasFullAccent(syl), 
                'hasSecondaryAccent': this.SyllableHasSecondaryAccent(syl), 'syllableIndex': nSyl, 'isLastSyllableInWord': nSyl === arrSyl.length - 1}))
        }
    }
    
    GetGlossForWord(w)
    {
        var sGloss = w.Gloss.replace(this.regexTakeOutGlossSeparator, ' ')

        if(sGloss === '')
        {
            var lexemeForThisWord = this.listLexemes.find(r => r.ID === w.LexicalID);
            sGloss = (lexemeForThisWord === undefined ? "" : lexemeForThisWord.Gloss)
        }

        return sGloss
    }

    GetOriginalWordsForWordAndLineIndexOfOurTranslation(sChapter, nLineIndex, nWordIndexInLine)
    {
        var listLinksForTranslationWord = this.state.listTranslationWordIndexLinks
        .filter(o => o.Chapter === sChapter && o.Translation === nWordIndexInLine && o.LineIndex === nLineIndex)
        
        return listLinksForTranslationWord.map(l => this.GetWordWithTextIndexInChapter(l.Original))
    }

    GetOurTranslationForWord(w)
    {
        if(w === undefined) return ''
        
        var listLinksForTranslationWord = this.GetOurTranslationLinksForTextIndexInOriginal(w.TextIndex)
        
        return listLinksForTranslationWord.sort((a,b) => a.Translation - b.Translation)
        .map(link => {
            var oTranslationForLine = this.state.listOurTranslationLines.find(o => o.Chapter === link.Chapter && o.LineIndex === link.LineIndex)
            if(oTranslationForLine === undefined) return ''

            var nWordIndexInTranslation = link.Translation
            var listWords = oTranslationForLine.Translation.split(' ')
            return nWordIndexInTranslation >= listWords.length ? '' : listWords[nWordIndexInTranslation]
        }).join(' ')
    }

	handleHoverWord(TextWord, target, sForWhichColumnType, oSyllable)
	{ 
		//this.CalculateAllSimilarities(TextWord);

        if(TextWord === undefined) return

		var sInfoToShow = ""
		var sInfoToShowText = sForWhichColumnType === 'translation' ? TextWord.FullText : 
            sForWhichColumnType === 'glosses' ? TextWord.FullText : 
            sForWhichColumnType === 'transliteration' ? TextWord.FullText + ' ' + this.GetOurTranslationForWord(TextWord) : 
            TextWord.Transliteration + ' ' + (TextWord.Book === '19' ? this.GetOurTranslationForWord(TextWord) : this.GetGlossForWord(TextWord))
        
		if(this.state.sLinkReportObjectType === "word" && 
			this.state.listUnitSimilaritiesToCurrentUnit.length > 0)
		{
			sInfoToShow = this.state.listUnitSimilaritiesToCurrentUnit.filter(r => 
				this.state.sLinkReportObjectType === "word" ? 
				(r.Unit1 === TextWord || r.Unit2 === TextWord) :
				(r.Unit1.includes(TextWord) || r.Unit2.includes(TextWord))).map(r =>
					r.Unit1.FullText + " "+ r.Unit2.FullText + ": " +	
					r.LinkDescriptionsList.join(", "));			
		}
		else if(this.state.sLinkReportObjectType === "line" && 
				this.state.listUnitSimilaritiesToCurrentUnit.length > 0)
		{
			var lineInList = this.state.listUnitSimilaritiesToCurrentUnit.find(r => 
				r.Unit2.includes(TextWord));
			if(lineInList === undefined) 
				sInfoToShow = "";
			else
				sInfoToShow = lineInList.WordLinks.filter(r => r.Unit1 === TextWord || r.Unit2 === TextWord).map(r => 
					r.Unit1.FullText + " "+ r.Unit2.FullText  + ": " + r.LinkDescriptionsList.join(", "));
		}
		else
		{
			if(this.blnDevView)
				sInfoToShow = TextWord.MorphCode + " " + TextWord.TextIndex + " " + TextWord.LexicalID + " " + TextWord.ParentRoot + " " + TextWord.Occurrences + ' ' + TextWord.ClauseID
			else
				sInfoToShow = (TextWord.Lemma === undefined ? '' : (TextWord.Lemma + ' ')) + TextWord.MorphCode
		}

		var sLensGroupNames = this.GetNameListForLensGroupsWordIsIn(TextWord);
		if(sLensGroupNames != "") sInfoToShow = sLensGroupNames + "; " + sInfoToShow;
		
		if(this.UsingAWordTagTool())
        {
			//, SemanticRoles:[{RoleID: 1, IsForSuffix: true}] 
			var tagForHoveredWord = this.GetWordTagForWord(TextWord);
			if(tagForHoveredWord != undefined)
			{
				sInfoToShow = tagForHoveredWord.SemanticRoles.map(o => {
					var role = this.listSemanticRoles.find(r => r.ID === o.RoleID);
					return role === undefined ? "" : (role.Desc + (o.IsForSuffix ? " (Suffix)": ""));
				}).join(", ") + "; " + sInfoToShow;

				if(!this.state.currentWordTagIsSticky)
					this.setState({currentWordTag: tagForHoveredWord});
			}
		}

        if(this.state.blnShowLenses && this.DifferenceAmountLensIsEnabled() && this.state.currentWordForHoverLens != undefined && 
            TextWord != this.state.currentWordForHoverLens && TextWord.InfoForDifferenceLens != '') 
            sInfoToShow += '; ' + TextWord.InfoForDifferenceLens

        if(this.state.blnShowLenses && TextWord.InfoForRepLens != '' && this.RepLensIsEnabled()) 
            sInfoToShow += '; ' + TextWord.InfoForRepLens

        if(this.state.blnShowLenses && TextWord.InfoForSoundChainLens != '' && (this.VowelChainLensIsEnabled() || this.ConsonantChainLensIsEnabled() || this.WordRhymeLensIsEnabled() || this.SyllableRhymeLensIsEnabled())) 
            sInfoToShow += '; ' + TextWord.InfoForSoundChainLens

        var listOtherLinesToShow = []
        if(this.listAllSimilaritiesByWordComparedToHoveredWord.length > 0)
        {
            var oAllSimilarityComparison = this.listAllSimilaritiesByWordComparedToHoveredWord.find(o => o.Word === TextWord)
            if(oAllSimilarityComparison != undefined) 
            {
                if(oAllSimilarityComparison.ListToShow != undefined)
                {
                    listOtherLinesToShow = oAllSimilarityComparison.ListToShow
                }
                else sInfoToShow += ' ' + oAllSimilarityComparison.ToShow
            }
        }

        if(this.state.blnShowBSBInHoverInfo)
        {
            var sBSBText = this.listThematicStatementIDsByVerse.filter(ots => ots.Book === parseInt(TextWord.Book) && 
                ots.Chapter === parseInt(TextWord.Chapter) && ots.Verse === parseInt(TextWord.Verse))
                .flatMap(ots => ots.Text).join(' ')

            sInfoToShow += '; ' + sBSBText
        }

        if(this.state.blnListOfChaptersEachRootOccursInInHoverInfo)
        {
            this.setState({listInfoShow: [this.dictListOfChaptersEachRootOccursIn.get(TextWord.ParentRoot)].concat( 
                TextWord.ThematicStatementIDs.map(nThematicStatementID => 
                    this.dictListOfChaptersEachThematicStatementOccursIn.get(nThematicStatementID.toString())))})
        }
        else
        {
		    this.setState({listInfoShow: [sInfoToShowText + ' ' + sInfoToShow].concat(listOtherLinesToShow)})
        }

		this.setState({listInfoShowTextIsEnglish: sForWhichColumnType === 'hebrew'})

		//this.setState({ anchorForWordHintPopover: target});
		//this.setState({ blnHintPopoverIsOpen: true});

		var hoveredWordRectToSet = this.GetWordSpanRect(TextWord, sForWhichColumnType);
        this.setState({hoveredWordRect: hoveredWordRectToSet})

        // this.setState({listInfoShowFontSize: blnHoveringOverTranslation ? (!this.blnChapterIsHebrew ? '20px' : "22px") : 'Calibri'})
        // this.setState({listInfoShowFontFamily: blnHoveringOverTranslation ? (!this.blnChapterIsHebrew ? 'SBL Greek' : 'SBL Hebrew') : 'Calibri'})

		if(this.state.listWordsDraggedFrom != undefined)
			this.setState({listWordsHoveredWhileDragging: this.state.nSelectedToolID === this.nLineLinkToolID ? 
                this.LineWithWord(TextWord).Words : [TextWord]});
                
        if(!this.state.currentRepetitionLinkGroupIsSticky)
        {
            var listGroupsContainingWord = this.GetRepetitionLinkGroupsContainingWord(TextWord);
            if(listGroupsContainingWord.length > 0)
            { 
                this.setState({listCurrentRepetitionLinkGroups: listGroupsContainingWord});
                //this.setState({nCurrentRepetitionLinkGroupSelectedIndex: 0});
            }
		}
		
        if(this.AnyLensIsEnabled())
        {
            if(this.SomeSyllableSpecificHoverLensIsEnabled())
            {
                this.SetCurrentSyllableForHoverLens(oSyllable)
            }
            else
            {
                this.SetCurrentWordForHoverLens(TextWord)
            }
        }

        if(this.state.listSubtagsCurrentlyBeingAssociatedToWords.length > 0)
        {
			var blnErase = this.state.blnControlDown;

            this.state.listSubtagsCurrentlyBeingAssociatedToWords.forEach(o => {         
                var listToUpdate = o.ListHebrewWords;
                if(this.state.blnShiftDown)
                {
                    var listWordsForWholeLine = this.GetLineContainingWord(TextWord).Words;
                    
                    if(blnErase) //listToUpdate.some(s => listWordsForWholeLine.some(w => w.TextIndex === s)))
                        listToUpdate = listToUpdate.filter(s => !listWordsForWholeLine.some(w => w.TextIndex === s));
                    else listToUpdate = listToUpdate.concat(listWordsForWholeLine.map(w => w.TextIndex));
                }
                else
                {
                    if(blnErase) //listToUpdate.includes(TextWord.TextIndex))
                    {
                        var nIndexToRemove = listToUpdate.indexOf(TextWord.TextIndex);
                        listToUpdate.splice(nIndexToRemove, 1);
                    }
                    else listToUpdate.push(TextWord.TextIndex);
                }
                this.UpdateSubtagFieldValue(o, "ListHebrewWords", listToUpdate);
            });
        }

        //added code
        // if(this.state.listWordsDraggedFrom != undefined)
        // {
        //     if(this.state.blnShiftDown) 
        //     {
        //         var listWordsHoveredWhileDraggingToSet = this.state.listWordsHoveredWhileDragging;
        //         if(!listWordsHoveredWhileDraggingToSet.includes(TextWord)) 
        //         {
        //             listWordsHoveredWhileDraggingToSet.push(TextWord);
        //             this.setState({listWordsHoveredWhileDragging: listWordsHoveredWhileDraggingToSet});
        //         }
        //     }
        //     else this.setState({listWordsHoveredWhileDragging: this.state.nSelectedToolID === this.nLineLinkToolID ? this.LineWithWord(TextWord).Words : [TextWord]});
        // }
        //end added code
	}

	handleHoverLeaveWord(TextWord, target)
	{
		// this.setState({ listUnitSimilaritiesToCurrentUnit: []});
		//this.setState({ anchorForWordHintPopover: null});
		//this.setState({ blnHintPopoverIsOpen: false});

        if(!this.RootCooccurrenceLensIsEnabled()) 
        {
		    this.setState({listInfoShow: [""]})   
        }

        if(!this.state.currentRepetitionLinkGroupIsSticky) this.setState({listCurrentRepetitionLinkGroups: undefined});
		if(this.UsingAWordTagTool() && !this.state.currentWordTagIsSticky) this.setState({currentWordTag: undefined});

        if(this.state.listWordsDraggedFrom != undefined)
        {
            // if(this.state.blnShiftDown) 
            // {
            //     var listWordsHoveredWhileDraggingToSet = this.state.listWordsHoveredWhileDragging;
            //     listWordsHoveredWhileDraggingToSet.splice(listWordsHoveredWhileDraggingToSet.indexOf(TextWord), 1);
            //     this.setState({listWordsHoveredWhileDragging: listWordsHoveredWhileDraggingToSet});
            // }
            // else 
            this.setState({listWordsHoveredWhileDragging: undefined});
        }

        if(this.AnyLensIsEnabled()) 
        {
            if(this.SomeSyllableSpecificHoverLensIsEnabled())
            {
                this.SetCurrentSyllableForHoverLens(undefined)
            }
            else
            {
                this.SetCurrentWordForHoverLens(undefined)
            }
        }
	}
    
    handleHoverRepetitionLinkGroup(hoveredRepetitionLinkGroup)
    {
        if(!this.state.currentRepetitionLinkGroupIsSticky) this.setState({listCurrentRepetitionLinkGroups: [hoveredRepetitionLinkGroup]});
    }

    handleHoverLeaveRepetitionLinkGroup(hoveredRepetitionLinkGroup)
    {
        if(!this.state.currentRepetitionLinkGroupIsSticky) this.setState({listCurrentRepetitionLinkGroups: undefined});
    }

    handleClickRepetitionLinkGroup(hoveredRepetitionLinkGroup, line)
    {
        this.setState({listCurrentRepetitionLinkGroups: [hoveredRepetitionLinkGroup]});
        this.setState({currentRepetitionLinkGroupIsSticky: true});
        this.setState({lineClickedOnForRepetitionGroupLink: line});
    }

    GetRepetitionGroupLinksForLine(line)
    {
        return this.GetRepetitionLinkGroupList().filter(g => g.ListWords.some(nWordIndex => line.Words.some(w => w.TextIndex === nWordIndex)));
    }

    SelectRepetitionLinkGroupByIncrement(nIncrement)
    {
        if(this.state.listCurrentRepetitionLinkGroups === undefined || this.state.listCurrentRepetitionLinkGroups.length === 0) return;
        var currentGroup = this.state.listCurrentRepetitionLinkGroups[0];
        var listGroupsInLine = this.GetRepetitionGroupLinksForLine(this.state.lineClickedOnForRepetitionGroupLink);

        var nCurrentIndexInList = listGroupsInLine.findIndex(g => g === currentGroup);
        var nNewIndex = nCurrentIndexInList + nIncrement;
        if(nNewIndex < 0) nNewIndex = 0;
        else if(nNewIndex > listGroupsInLine.length - 1) nNewIndex = listGroupsInLine.length - 1;

        this.setState({listCurrentRepetitionLinkGroups: [listGroupsInLine[nNewIndex]]});
    }

	ShowRepetitionGroupTags()
	{
        return false
		//return this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID; // && (this.state.nCurrentLinkGroupType === 1 || this.state.nCurrentLinkGroupType === 10);
	}

	InSemanticRoleMode()
	{
		return this.state.nSelectedToolID === this.nSemanticRolesToolID;
	}
	
    InThematicStatementsMode()
    {
        return this.state.nSelectedToolID === this.nThematicStatementsToolID
    }

    UseLensVisibilityGroups()
    {
        return this.state.sSelectedView === 'all' || this.state.sSelectedView === 'sound'
    }

    GetLensesForView()
    {
        return this.state.listLenses.filter(l => this.state.sSelectedView === 'all' || l.View === this.state.sSelectedView)
    }

    LensShouldBeShown(l)
    {
        return !l.Hide && l.View != undefined &&
            (!this.state.blnMultipleChaptersSelected || !l.OnlyForSingleChapter) &&
            (l.LanguageSpecific === undefined || (l.LanguageSpecific === 'h' && this.blnChapterIsHebrew) || 
            (l.LanguageSpecific === 'g' && !this.blnChapterIsHebrew))
    }

    GetLensesThatAreOn()
    {
        return this.state.listLenses.filter(l => l.Enabled || l.Sticky)
    }

    GetSpanForLens(l)
    {
        return <span title={l.Name} style={{
            marginLeft:"10px", 
            color: l.Enabled || l.Sticky ? 'hsl(0, 0%, 45%)' : 'hsl(0, 0%, 75%)',
            // borderStyle: l.Enabled || l.Sticky ? "solid" : "none",
            borderWidth: "1px",
            //fontFamily: this.state.sSelectedView === 'text' ? "SBL Hebrew" : "Calibri",
            //fontSize: this.state.sSelectedView === 'text' ? "26px" : "16px",
            userSelect: "none"}}
            
            onContextMenu={(event) => { 
                if(l.LensType === "corr")
                {
                    event.preventDefault();
                    this.setState({ blnCorrespondenceCategorySelectionPopoverIsOpen: true}); 
                    this.setState({ anchorForCorrespondenceCategorySelectionPopover: event.currentTarget});
                }
            }}
            onClick={(event) => {
                if(l.Sticky || event.shiftKey)
                {
                    this.ChangeLensSticky(l, !l.Sticky)
                }
                else
                {
                    this.EnableSingleLens(l)
                }
            }}
            onMouseEnter={(event) => this.ChangeLensEnabled(l, true)}
            onMouseLeave={(event) => this.ChangeLensEnabled(l, false)}
            >{l.Abbr}</span>
    }

    InSearchAndTagMode()
    {
        return this.state.nSelectedToolID === this.nSearchAndTagToolID
    }
    
    InSearchTaggedDataMode()
    {
        return this.state.nSelectedToolID === this.nSearchTaggedDataToolID
    }

	ShowSemanticCategoriesAutocomplete()
	{
		return this.state.nSelectedToolID === this.nSemanticCategoryToolID;
	}

	ShowSemanticSearchAutocomplete()
	{
		return this.state.blnShowSemanticSearchAutocomplete;
	}

	TagCurrentRepetitionLinkGroupsByKeyPressed(key)
	{
		if(this.state.listRepetitionLinkGroups === undefined || this.state.listCurrentRepetitionLinkGroups === undefined || 
		   !this.ShowRepetitionGroupTags()) return;
 
		var sTagID = "";
		
		if(this.state.nCurrentLinkGroupType === 2)
		{
			//participant reference
			sTagID = key === "g" ? "1000" : 
				key === "p" ? "1001" :
				key === "e" ? "1002" :
				key === "i" ? "1004" :
				key === "h" ? "1006" :
				key === "c" ? "1014" :
				key === "r" ? "1003" :
				key === "w" ? "1015" :
				undefined;
		}
		else
		{
			//correspondences
			sTagID = key === "s" ? "28" : 
				key === "o" ? "74" :
				key === "r" ? "26" :
				key === "i" ? "80" :
				key === "g" ? "66" :
				key === "p" ? "69" :
				key === "c" ? "306" :	
				key === "h" ? "110" :
				key === "b" ? "312" :
				key === "m" ? "313" :
				undefined;
		}

		if(sTagID != undefined)
		{
			var listToSet = this.state.listRepetitionLinkGroups;
			for(var groupToChange of this.state.listCurrentRepetitionLinkGroups)
				groupToChange.ListTags.push({CategoryID: sTagID, RelationPairReversed: false});
			this.SaveRepetitionLinkGroupsAndSetState(listToSet);
		}
	}

	AssignSemanticRoleToWordTagByKeyPressed(key)
	{
		if(!this.InSemanticRoleMode()) return;
 
		var currentWordTag = this.state.currentWordTag;
		if(currentWordTag === undefined) return;
		
		if(key === "[" || key === "]" || key === "\\" || key === "=")
		{
			var listPropositionsToSet = this.state.listPropositions;
			var currentWord = this.GetWordWithTextIndexInChapter(currentWordTag.TextIndex);
			var propositionToChange = this.GetPropositionContainingWord(currentWord);

			if(key === "[" || key === "]")
			{
				propositionToChange.IndentLevel += key === "]" ? -1 : 1;
				if(propositionToChange.IndentLevel < 0) propositionToChange.IndentLevel = 0;
			}
			else if(key === "\\")
			{
				var listNewPropositionWords = propositionToChange.Words.filter(w => parseInt(w.TextIndex) > parseInt(currentWord.TextIndex));

				propositionToChange.Words = propositionToChange.Words.filter(w => !listNewPropositionWords.includes(w));
				propositionToChange.TextIndexes = propositionToChange.Words.map(w => w.TextIndex)

				var nIndexToInsert = listPropositionsToSet.indexOf(propositionToChange);
				listPropositionsToSet.splice(nIndexToInsert + 1, 0, 
					{TextIndexes: listNewPropositionWords.map(w => w.TextIndex), IndentLevel: 0, RoleIDs: [], Words: listNewPropositionWords});
			}
			else if(key === "=")
			{
				var previousWord = this.GetWordWithTextIndexInChapter((parseInt(currentWordTag.TextIndex) - 1).toString());
				var previousProposition = this.GetPropositionContainingWord(previousWord);

				previousProposition.Words = previousProposition.Words.concat(propositionToChange.Words);
				previousProposition.TextIndexes = previousProposition.Words.map(w => w.TextIndex)

				var nIndexToRemove = listPropositionsToSet.indexOf(propositionToChange);
				listPropositionsToSet.splice(nIndexToRemove, 1);
			}

			this.SavePropositions(listPropositionsToSet);
			return;
		}

		var roleWithThatShortcut = this.listSemanticRoles.find(r => r.Shortcuts.includes(key.toLowerCase()));
		if(roleWithThatShortcut != undefined)
		{
			var sID = roleWithThatShortcut.ID;
			var listToSet = this.state.listWordTags;

			if(!currentWordTag.SemanticRoles.some(o => o.RoleID === sID))
				currentWordTag.SemanticRoles.push({RoleID: sID, 
					IsForSuffix: this.IsForSuffixModeForWordTags(this.GetWordWithTextIndexInChapter(currentWordTag.TextIndex))});
			this.SaveWordTags(listToSet);
		}
	}

	// SetCurrentLinkGroupTagID(key, blnKeyUp)
	// {
	// 	if(!this.ShowRepetitionGroupTags()) return;

	// 	if(blnKeyUp && ["s", "o", "r"].includes(key))
	// 	{
	// 		this.setState({nCurrentLinkGroupTagID: undefined});
	// 		return;
	// 	}

	// 	var sTagID = key === "s" ? "28" : 
	// 	key === "o" ? "74" :
	// 	key === "r" ? "26" :
	// 	undefined;

	// 	if(sTagID != undefined)
	// 		this.setState({nCurrentLinkGroupTagID: sTagID});
	// }

    // OffsetCurrentRepetitionLinkGroupSelectedIndex(nOffset)
    // {
    //     this.setState({nCurrentRepetitionLinkGroupSelectedIndex: (this.state.nCurrentRepetitionLinkGroupSelectedIndex + nOffset) % this.state.listCurrentRepetitionLinkGroups.length});
    // }

    ShowingDevelopmentDiagram()
    {
        return this.state.sViewBy === 'Development'
    }

    GenerateDevelopmentDiagramForChapterIfShowing()
    {
        if(this.ShowingDevelopmentDiagram())
        {
            this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
        }
    }

    ChangeViewByTo(sToChangeTo)
    {
        this.setState({sViewBy: sToChangeTo}, () => {
            if(sToChangeTo === 'Development')
            {
                this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
            }
        })
    }

    ToggleSearchAndTagAttribute(oAttribute)
    {
        var nExistingIndex = this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags[this.state.nTagIndexBeingEditedForCurrentSearchAndTag].Attributes.indexOf(oAttribute.ID)
        if(nExistingIndex >= 0)
        {
            this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags[this.state.nTagIndexBeingEditedForCurrentSearchAndTag].Attributes.splice(nExistingIndex,1)
        }
        else
        {
            this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags[this.state.nTagIndexBeingEditedForCurrentSearchAndTag].Attributes.push(oAttribute.ID)
        }

        this.SaveMatchTags(this.state.listTagsForMatchesInSemanticGroups)
    }

    handleKeyDown(event)
	{
        if(this.state.blnThematicStatementAutocompleteHasFocus || this.state.blnTaskSearchAutocompleteHasFocus || 
            this.state.blnTranslationEditBoxHasFocus || this.state.blnEditThemeNameHasFocus || 
            (this.state.blnConnectionsPresentationCommentEditBoxHasFocus && !['ArrowRight', 'ArrowLeft'].includes(event.key))) return

		var key = event.key;
		//console.log(key);

        if(key === "Shift")
		{
            this.setState({blnShiftDown: true});
            //if(this.state.nSelectedToolID === this.nMarkCorrespondencesWithinLineGroupsToolID) this.setState({sColorBy: "wordlinkgroup"});
            //else if(this.state.nSelectedToolID === this.nWordLinkToolID) this.setState({sColorBy: "pgrp"});
        }
        else if(key === "Control" || key === "Meta")
		{
            if(this.state.nSelectedToolID === this.nMarkCorrespondencesWithinLineGroupsToolID || 
               this.state.nSelectedToolID === this.nWordLinkToolID) this.setState({sColorBy: "linelinkgroup"});
            else
                this.setState({blnControlDown: true});
        }
        else if(key === "Alt")
		{
            this.setState({blnAltDown: true});
        } 

        if(this.SemanticChainsLensIsEnabled() && !this.InSearchAndTagMode())
        {
            if(key === ']')
            {
                if(this.state.nSemanticChainsLensCurrentBatch < this.GetSemanticChainsLensNumberOfBatches() - 1)
                {
                    this.setState({nSemanticChainsLensCurrentBatch: this.state.nSemanticChainsLensCurrentBatch + 1}, this.SetWordGroupsForEnabledLenses())
                }
            }
            else if(key === '[')
            {
                if(this.state.nSemanticChainsLensCurrentBatch > 0)
                {
                    this.setState({nSemanticChainsLensCurrentBatch: this.state.nSemanticChainsLensCurrentBatch - 1}, this.SetWordGroupsForEnabledLenses())
                }
            }
        }

        if(this.ShowingDevelopmentDiagram())
        {
            if((key === '+' || key === '='))
            {
                if(this.state.nMinDevelopmentDiagramLinkGroupLengthToShow < 10)
                {
                    this.setState({nMinDevelopmentDiagramLinkGroupLengthToShow: this.state.nMinDevelopmentDiagramLinkGroupLengthToShow + 1}, () => {
                        this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                    })
                }
            }
            else if(key === '-')
            {
                if(this.state.nMinDevelopmentDiagramLinkGroupLengthToShow > 0)
                {
                    this.setState({nMinDevelopmentDiagramLinkGroupLengthToShow: this.state.nMinDevelopmentDiagramLinkGroupLengthToShow - 1}, () => {
                        this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                    })
                }
            }
        }

        if(this.InSearchAndTagMode() && this.state.listSemanticGroupsForSearchAndTagSelectedForTagging.length > 0 && 
            !this.state.blnAddTagBoxHasFocus && !this.state.blnEditTagBoxHasFocus)
        {
            if((key === '+' || key === '=') && this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1)
            {
                this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags.push({ID: 0, Attributes: []})
                this.setState({nTagIndexBeingEditedForCurrentSearchAndTag: this.state.nTagIndexBeingEditedForCurrentSearchAndTag + 1})
            }
            // else if(key === 'c' && this.state.blnControlDown)
            // {
            //     if(this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1)
            //     {
            //         var nTagID = this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags[0].ID
            //         if(nTagID > 0)
            //         {
            //             var oTag = this.state.listTagInventory.find(t => t.ID === nTagID)
            //             if(oTag != undefined) navigator.clipboard.writeText(oTag.Desc)
            //         }
            //     }
            // }
            else if(key === '`' && this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1)
            {
                if(this.state.listSearchAndTagMatchIndexesWithContext.includes(this.state.nCurrentlyHoveredSearchAndTagMatchIndex))
                {
                    this.state.listSearchAndTagMatchIndexesWithContext.splice(this.state.listSearchAndTagMatchIndexesWithContext.indexOf(this.state.nCurrentlyHoveredSearchAndTagMatchIndex), 1)
                }
                else
                {
                    this.state.listSearchAndTagMatchIndexesWithContext.push(this.state.nCurrentlyHoveredSearchAndTagMatchIndex)
                }
            }
            else if(key === "~")
            {
                this.setState({blnCurrentlyHoveredSearchAndTagMatchIndexInOriginalText: !this.state.blnCurrentlyHoveredSearchAndTagMatchIndexInOriginalText})
            }
            else if(key === "-")
            {
                if(this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1)
                {
                    this.setState({blnNewTagInputIsVisible: !this.state.blnNewTagInputIsVisible})
                    this.setState({sSearchAndTagInventoryFilter: window.getSelection().toString()})
                }
            }
            else if(key === 'Enter' && this.state.blnNewTagInputIsVisible)
            {
                if(this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1)
                {
                    var nNewTagID = this.AddTagForCurrentlySelectedSemanticGroup(this.state.sSearchAndTagInventoryFilter)
                    this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags[this.state.nTagIndexBeingEditedForCurrentSearchAndTag].ID = nNewTagID
                    this.SaveMatchTags(this.state.listTagsForMatchesInSemanticGroups)
                    
                    this.setState({sSearchAndTagInventoryFilter: ''})
                    this.setState({blnNewTagInputIsVisible: false})
                }
            }
            else if(!this.state.blnNewTagInputIsVisible && this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1 && this.dictTagAttributesByShortcut.has(key))
            {
                //n: negative, g "much/greatly/intensely", f "forever", m "must/should/necessary/command",  c: "continually", 
                //b - reason/cause/motivation/grounds (because), w: time/circumstance (when/where), i: condition (if), z: conclusion, t: content (that), 
                //h: means/manner (how), r: result, p: purpose, l comparison(like), j: in/because of Jesus (in Christ)
                this.ToggleSearchAndTagAttribute(this.dictTagAttributesByShortcut.get(key))
            }
            else if(key === 'F16')
            {
                if(this.state.blnEnableTaggingWholeBatchPage && window.confirm('Tag all current match results?'))
                {
                    //mark all matches in the current page with the tag correlated with the 1 key
                    var oTagForShortcut1 = this.state.listTagInventory.find(t => t.Shortcut === '1')

                    if(oTagForShortcut1 != undefined)
                    {
                        var nTagIDToSet = oTagForShortcut1.ID

                        //backup data
                        //navigator.clipboard.writeText(this.GetSearchAndTagDataForMatchTags())

                        for(let o of this.state.listCurrentSearchAndTagMatchResults)
                        {
                            var nSearchAndTagMatchIndexToUse = this.state.listTagsForMatchesInSemanticGroups.findIndex(o2 => o2.MatchID === o.ID)
                            this.state.listTagsForMatchesInSemanticGroups[nSearchAndTagMatchIndexToUse].Tags[0].ID = nTagIDToSet
                            //console.log(nSearchAndTagMatchIndexToUse, this.state.listTagsForMatchesInSemanticGroups[nSearchAndTagMatchIndexToUse])
                        }

                        this.SaveMatchTags(this.state.listTagsForMatchesInSemanticGroups)
                    }
                }
            }
            else if(key === ']')
            {
                if(this.state.nSearchAndTagResultsCurrentBatchIndex < this.GetNumberOfSearchAndTagResultBatches() - 1)
                {
                    this.setState({nCurrentlyHoveredSearchAndTagMatchIndex: -1})
                    this.setState({nSearchAndTagResultsCurrentBatchIndex: this.state.nSearchAndTagResultsCurrentBatchIndex + 1})
                }
            }
            else if(key === '[')
            {
                if(this.state.nSearchAndTagResultsCurrentBatchIndex > 0)
                {
                    this.setState({nCurrentlyHoveredSearchAndTagMatchIndex: -1})
                    this.setState({nSearchAndTagResultsCurrentBatchIndex: this.state.nSearchAndTagResultsCurrentBatchIndex - 1})
                }
            }
            else if(key === '|')
            {
                if(this.state.nTagShortcutBatchNumber > 0)
                {
                    this.setState({nTagShortcutBatchNumber: this.state.nTagShortcutBatchNumber - 1})
                }
            }
            else if(key === '\\')
            {
                this.setState({nTagShortcutBatchNumber: 
                    //this.state.nTagShortcutBatchNumber * this.state.nTagShortcutBatchSize >= listTagsMatchingCurrentTyping.length ? 0 : 
                    this.state.nTagShortcutBatchNumber + 1})
            }
            else if(key === 'ArrowRight')
            {
                if(this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1)
                {
                    if(this.state.nTagIndexBeingEditedForCurrentSearchAndTag < 
                        this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags.length - 1)
                    {
                        this.setState({nTagIndexBeingEditedForCurrentSearchAndTag: this.state.nTagIndexBeingEditedForCurrentSearchAndTag + 1})
                    }
                }
            }
            else if(key === 'ArrowLeft')
            {
                if(this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1 && this.state.nTagIndexBeingEditedForCurrentSearchAndTag > 0)
                {
                    this.setState({nTagIndexBeingEditedForCurrentSearchAndTag: this.state.nTagIndexBeingEditedForCurrentSearchAndTag - 1})
                }
            }
            else if(['Shift', 'Control', 'Alt', 'PageUp', 'PageDown', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(key))
            {

            }
            else if(!this.state.blnNewTagInputIsVisible && this.state.blnShiftDown && ['!', '@', '#', '$'].includes(key))
            {
                if(this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1)
                {
                    //set the shortcut for that number to be the first tag for the current match
                    var nTagID = this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags[0].ID
                    if(nTagID > 0)
                    {
                        var sShortcut = key === '!' ? '1' : key === '@' ? '2' : key === '#' ? '3' : '4'

                        var nTagIndex = this.state.listTagInventory.findIndex(t => t.ID === nTagID)
                        if(nTagIndex > -1) 
                        {
                            this.state.listTagInventory.forEach((t,n) => 
                            {
                                if(t.Shortcut === sShortcut) this.state.listTagInventory[n].Shortcut = ''
                            })

                            this.state.listTagInventory[nTagIndex].Shortcut = sShortcut
                            this.SaveTagInventory(this.state.listTagInventory)
                        }
                    }
                }
            }
            else
            {
                //can tag either by holding down a tag key and hovering over a row, 
                //or pressing the tag key while hovering over the row.
                //tagging with . will copy the previous tag
                //var oSelectedSemanticGroup = this.GetSelectedSemanticGroupForSearchAndTag()
                var oTagWithShortcut = this.state.listTagInventory.find(t => t.Shortcut === key)
                var blnKeyIsNumeric = key >= '1' && key <= '9'
                var listTagsMatchingCurrentTyping = []

                if(oTagWithShortcut === undefined || this.state.blnNewTagInputIsVisible)
                {
                    var sSearchAndTagInventoryFilterToSet = this.state.sSearchAndTagInventoryFilter

                    if(key === 'Backspace')
                    {
                        if(sSearchAndTagInventoryFilterToSet.length > 0)
                        {
                            sSearchAndTagInventoryFilterToSet = sSearchAndTagInventoryFilterToSet.slice(0,-1)
                        }
                    }
                    else if(key === 'Delete')
                    {
                        sSearchAndTagInventoryFilterToSet = ''
                    }
                    else if(key === ' ')
                    {
                        event.preventDefault()
                        sSearchAndTagInventoryFilterToSet += ' '
                    }
                    // else if(key === 'v' && this.state.blnControlDown)
                    // {
                    //     //event.preventDefault()
                    //     var sTextToPaste = await navigator.clipboard.readText()
                    //     sSearchAndTagInventoryFilterToSet += sTextToPaste
                    // }
                    else if(!blnKeyIsNumeric || this.state.blnNewTagInputIsVisible)
                    {
                        sSearchAndTagInventoryFilterToSet += key
                    }

                    listTagsMatchingCurrentTyping = sSearchAndTagInventoryFilterToSet.length === 0 ? [] :
                        this.FilterTagInventoryBasedOnTyping(sSearchAndTagInventoryFilterToSet, false)
                        //this.state.listTagInventory.filter(o => o.Desc.toLowerCase().includes(sSearchAndTagInventoryFilterToSet))

                    //console.log(sSearchAndTagInventoryFilterToSet, listTagsMatchingCurrentTyping)
                }

                // var nTagOptionIndex = this.dictTagOptionIndexByKey[key]
                //789 789
                
                var nIndexSelectedByTagShortcut = !this.state.blnNewTagInputIsVisible && blnKeyIsNumeric ? 
                    parseInt(key) - this.nStartNumberForTagSearchAndSelect + (this.state.nTagShortcutBatchNumber * this.state.nTagShortcutBatchSize) : -1

                var nTagIDToSet = key === '0' ? 0 : //nTagOptionIndex === 0 ? 0 : 
                    oTagWithShortcut != undefined ? oTagWithShortcut.ID :

                    nIndexSelectedByTagShortcut > -1 && listTagsMatchingCurrentTyping.length >= nIndexSelectedByTagShortcut + 1 ? 
                        listTagsMatchingCurrentTyping[nIndexSelectedByTagShortcut].ID :

                    key === '.' && this.state.nCurrentlyHoveredSearchAndTagMatchIndex > 0 ? 10000000 : //10000000 doesn't mean anything here
                    //key === '-' && this.state.listTagInventory.length > 0 ? this.state.listTagInventory[this.state.listTagInventory.length - 1].ID :
                    listTagsMatchingCurrentTyping.length === 1 ? listTagsMatchingCurrentTyping[0].ID : -1
                    //nTagOptionIndex <= this.state.listTagInventory.length ? this.state.listTagInventory[nTagOptionIndex - 1].ID : -1

                if(this.state.blnNewTagInputIsVisible)
                {
                    if(this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1)
                    {
                        this.setState({sSearchAndTagInventoryFilter: sSearchAndTagInventoryFilterToSet})
                    }
                }
                else if(nTagIDToSet === -1)
                {
                    if(listTagsMatchingCurrentTyping.length > 0 || sSearchAndTagInventoryFilterToSet === '')
                    {
                        //if there are no matches, don't add this to the search string
                        this.setState({sSearchAndTagInventoryFilter: sSearchAndTagInventoryFilterToSet})
                    }
                }
                else
                {
                    if(this.state.nCurrentlyHoveredSearchAndTagMatchIndex > -1)
                    {
                        //console.log(this.state.nCurrentlyHoveredSearchAndTagMatchIndex, this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex])
                        
                        if(key === '.')
                        {
                            //copy all the tags (and their attributes),
                            //but make sure it is a copy and not an object assignment!

                            var listPossiblyFilteredMatchResults = this.state.listCurrentSearchAndTagMatchResults

                            var nCurrentIndexInPossiblyFilteredMatchResults = 
                                listPossiblyFilteredMatchResults.findIndex(r => r.ID === this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].MatchID)

                            if(nCurrentIndexInPossiblyFilteredMatchResults > 0)
                            {
                                //{"SemanticGroupID":492,"MatchID":"Colossians_4_7_17","Tags":[{"ID":38,"Attributes":[]}]}
                                var oPreviousMatch = listPossiblyFilteredMatchResults[nCurrentIndexInPossiblyFilteredMatchResults - 1]
                                var oTaggingObjectForPreviousMatch = this.state.listTagsForMatchesInSemanticGroups.find(o => o.MatchID === oPreviousMatch.ID)

                                if(oTaggingObjectForPreviousMatch != undefined)
                                {
                                    //console.log(oPreviousMatch, oTaggingObjectForPreviousMatch, listPossiblyFilteredMatchResults, nCurrentIndexInPossiblyFilteredMatchResults)

                                    this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags = []
                                    for(var t of oTaggingObjectForPreviousMatch.Tags)
                                    {
                                        this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags
                                            .push({"ID": t.ID, "Attributes": t.Attributes.map(attr => attr)})
                                    }
                                }
                            }
                        }
                        else
                        {
                            this.state.listTagsForMatchesInSemanticGroups[this.state.nCurrentlyHoveredSearchAndTagMatchIndex].Tags[this.state.nTagIndexBeingEditedForCurrentSearchAndTag].ID = nTagIDToSet
                        }

                        this.SaveMatchTags(this.state.listTagsForMatchesInSemanticGroups)
                    }

                    this.setState({sSearchAndTagInventoryFilter: ''})
                    if(key != '.') this.setState({nCurrentTagIDForSearchAndTag: nTagIDToSet})
                }
            }
            return
        }

	    if(key === "ArrowRight")
		{
            if(this.state.blnShiftDown) 
            {
                if(this.state.blnConnectionsPresentationMode)
                {
                    this.setState({nIndexOfSemanticGroupShowing: 0})
                }
                
                this.FetchChapters(this.state.listCurrentChapters.map(nChapter => ({Book: this.state.nCurrentBook, Chapter: nChapter + 1})))
            }
            else if(this.ShowingDevelopmentDiagram() && this.state.blnConnectionsPresentationMode)
            {
                let nCurrentValue = this.state.nIndexOfSemanticGroupShowing
                if(nCurrentValue < this.GetDevelopmentDiagramLinkGroupsForChapter().length - 1)
                {
                    this.SetCommentForCurrentConnectionsGroup(this.state.sCommentForCurrentConnectionsGroup)

                    this.setState({nIndexOfSemanticGroupShowing: nCurrentValue + 1}, () => {
                        this.GenerateDevelopmentDiagramForChapterIfShowing()
                        //this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                    })
                }
            }
            else
            {
                //if(this.state.blnShiftDown) this.SelectRepetitionLinkGroupByIncrement(1);

                if(this.AllSimilarityLensIsEnabled())
                {
                    var nNewValue = this.state.listAllSimilarityScoreThreshold >= 5 ? 5 : this.state.listAllSimilarityScoreThreshold + 1
                    this.setState({listAllSimilarityScoreThreshold: nNewValue}, this.SetWordGroupsForCurrentHoverTypeLens())
                }
                else
                {
                    if(this.state.currentWordTag != undefined) 
                    {
                        var nextWordIndex = (parseInt(this.state.currentWordTag.TextIndex) - 1).toString();
                        var tagToChangeTo = this.state.listWordTags.find(t => t.TextIndex === nextWordIndex);
                        this.setState({currentWordTag: tagToChangeTo});
                    }

                    this.GetSelectedTags().forEach(o => this.OffsetIndentLevel(o, 1))
                }
            }
        }
        else if(key === "ArrowLeft")
		{
            // if(this.state.blnShiftDown) this.SelectRepetitionLinkGroupByIncrement(-1);
			if(this.state.blnShiftDown) 
            {
                if(this.state.blnConnectionsPresentationMode)
                {
                    this.setState({nIndexOfSemanticGroupShowing: 0})
                }

                this.FetchChapters(this.state.listCurrentChapters.map(nChapter => ({Book: this.state.nCurrentBook, Chapter: nChapter - 1})))
            }
            else if(this.ShowingDevelopmentDiagram() && this.state.blnConnectionsPresentationMode)
            {
                let nCurrentValue = this.state.nIndexOfSemanticGroupShowing
                if(nCurrentValue > 0)
                {
                    this.SetCommentForCurrentConnectionsGroup(this.state.sCommentForCurrentConnectionsGroup)

                    this.setState({nIndexOfSemanticGroupShowing: nCurrentValue - 1}, () => {
                        this.GenerateDevelopmentDiagramForChapterIfShowing()
                        //this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                    })
                }
            }
            else
            {
                if(this.AllSimilarityLensIsEnabled())
                {
                    var nNewValue = this.state.listAllSimilarityScoreThreshold === 1 ? 1 : this.state.listAllSimilarityScoreThreshold - 1
                    this.setState({listAllSimilarityScoreThreshold: nNewValue}, this.SetWordGroupsForCurrentHoverTypeLens())
                }
                else
                {
                    if(this.state.currentWordTag != undefined) 
                    {
                        var previousWordIndex = (parseInt(this.state.currentWordTag.TextIndex) + 1).toString();
                        var tagToChangeTo = this.state.listWordTags.find(t => t.TextIndex === previousWordIndex);
                        this.setState({currentWordTag: tagToChangeTo});
                    }

                    this.GetSelectedTags().filter(o => o.Selected).forEach(o => this.OffsetIndentLevel(o, -1))
                }
            }
		}
        else if(key === 'Delete')
        {
            if(this.ShowingDevelopmentDiagram() && this.SemanticChainsLensIsEnabled() && this.state.blnEditingSemanticGroups)
            {
                let nSemanticGroupIndexToDelete = 
                    this.GetSemanticChainsForCurrentChapter(this.listTextWordsForChapter)[this.state.nIndexOfSemanticGroupShowing].IndexInFullList
            
                if(nSemanticGroupIndexToDelete >= 0)
                {
                    let listToSet = this.state.listRepetitionLinkGroups
                    listToSet.splice(nSemanticGroupIndexToDelete, 1)

                    this.setState({listRepetitionLinkGroups: listToSet}, this.SetWordGroupsForEnabledLenses())
                    this.SaveRepetitionLinkGroups(this.state.listRepetitionLinkGroups)
                }
            }
        }
        else if(key === "n" || key === "N")
        {
            if(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID)
            {
                this.setState({blnShowRepetitionLinkGroupCommentBox: !this.state.blnShowRepetitionLinkGroupCommentBox})
            }
            else
            {
                if(this.ShowingDevelopmentDiagram() && this.SemanticChainsLensIsEnabled() && this.state.blnEditingSemanticGroups)
                {
                    let nSemanticGroupIndexToAddAfter = 
                        this.GetSemanticChainsForCurrentChapter(this.listTextWordsForChapter)[this.state.nIndexOfSemanticGroupShowing].IndexInFullList
                
                    let listToSet = this.state.listRepetitionLinkGroups

                    listToSet.splice(nSemanticGroupIndexToAddAfter + 1, 0, 
                        {ListWords: [], ListTags: [], Comment: '', Type: 8})
                    
                    this.setState({listRepetitionLinkGroups: listToSet}, () => {
                        this.setState({nIndexOfSemanticGroupShowing: this.state.nIndexOfSemanticGroupShowing + 1})
                        this.SetWordGroupsForEnabledLenses()
                    })

                    //this.SaveRepetitionLinkGroups(this.state.listRepetitionLinkGroups)
                }

                // if(this.ShowingDevelopmentDiagram())
                // {
                //     this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 27
                // }
            }
        }
		else if(key === "/")
        {
			if(this.state.currentWordTag != undefined) 
			{
				event.preventDefault();

				var word = this.GetWordWithTextIndexInChapter(this.state.currentWordTag.TextIndex);
				var lineForWord = this.GetLineContainingWord(word);
				var nIndexWithinLineOfWord = lineForWord.Words.indexOf(word);

				var nIndexOfLineForWord = this.state.listLines.indexOf(lineForWord);
				if(nIndexOfLineForWord > 0)
				{
					var previousLine = this.state.listLines[nIndexOfLineForWord - 1];

					var nCorrespondingIndexInPreviousLine = (nIndexWithinLineOfWord > previousLine.Words.length - 1) ?  
						previousLine.Words.length - 1 : nIndexWithinLineOfWord;
					var wordAtCorrespondingIndexInPreviousLine = previousLine.Words[nCorrespondingIndexInPreviousLine];
					
					var tagToChangeTo = this.state.listWordTags.find(t => t.TextIndex === wordAtCorrespondingIndexInPreviousLine.TextIndex);
					this.setState({currentWordTag: tagToChangeTo});
				}
			}
		}
        else if(key === "\\")
        {
            this.setState({blnTextUnitSideBySideMode: !this.state.blnTextUnitSideBySideMode})
        }
		else if(key === "*")
        {
			if(this.state.currentWordTag != undefined) 
			{
				event.preventDefault();

				var word = this.GetWordWithTextIndexInChapter(this.state.currentWordTag.TextIndex);
				var lineForWord = this.GetLineContainingWord(word);
				var nIndexWithinLineOfWord = lineForWord.Words.indexOf(word);

				var nIndexOfLineForWord = this.state.listLines.indexOf(lineForWord);
				if(nIndexOfLineForWord < this.state.listLines.length - 1)
				{
					var previousLine = this.state.listLines[nIndexOfLineForWord + 1];

					var nCorrespondingIndexInPreviousLine = (nIndexWithinLineOfWord > previousLine.Words.length - 1) ?  
						previousLine.Words.length - 1 : nIndexWithinLineOfWord;
					var wordAtCorrespondingIndexInPreviousLine = previousLine.Words[nCorrespondingIndexInPreviousLine];

					var tagToChangeTo = this.state.listWordTags.find(t => t.TextIndex === wordAtCorrespondingIndexInPreviousLine.TextIndex);
					this.setState({currentWordTag: tagToChangeTo});
				}
			}
		}
		// else if(key === "Delete")
		// {
        //     if(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID) this.DeleteCurrentRepetitionLinkGroup();
		// 	this.DeleteSelectedTags();
			
		// 	if(this.state.currentWordTag != undefined) 
		// 	{
		// 		if(this.ShowSemanticCategoriesAutocomplete())
		// 		{
		// 			this.state.currentWordTag.SemanticCategoryIDs = [];
		// 			this.SaveWordTags(this.state.listWordTags);
		// 		}
		// 		else if(this.InSemanticRoleMode())
		// 		{
		// 			this.state.currentWordTag.SemanticRoles = [];
		// 			this.SaveWordTags(this.state.listWordTags);
		// 		}
		// 	}
		// }
		// else if(key === "-")
		// {
		// 	this.FetchChapters(this.state.listCurrentChapters.map(nChapter => ({Book: this.state.nCurrentBook, Chapter: nChapter - 1})))
		// }
		else if(key === "+")
		{
			this.FetchChapters(this.state.listCurrentChapters.map(nChapter => ({Book: this.state.nCurrentBook, Chapter: nChapter + 1})))
		}

		if(this.ShowSemanticCategoriesAutocomplete() || this.ShowSemanticSearchAutocomplete()) return;

		//console.log(key);
		//this.SetCurrentLinkGroupTagID(key, false);
		this.TagCurrentRepetitionLinkGroupsByKeyPressed(key);
		this.AssignSemanticRoleToWordTagByKeyPressed(key);

		// if (key === "Tab" && this.InSemanticRoleMode()) 
		// {
		// 	event.preventDefault();
		// 	return false;
		// }

		if(key === "z")
		{
            // if(this.ShowingDevelopmentDiagram())
            // {
            //     this.setState({blnExcludeLinkGroupsFoundInSelectedUnit: !this.state.blnExcludeLinkGroupsFoundInSelectedUnit})
            // }
            // else
            // {
                this.setState({blnZDown: true})
            //}
        }
        else if(key === "s")
		{
            if(this.ShowingDevelopmentDiagram())
            {
                this.setState({sShowLinksFromHoveredWhat: this.state.sShowLinksFromHoveredWhat === 'group' ? 'line' : 
                    this.state.sShowLinksFromHoveredWhat === 'line' ? 'word' : 'group'})
            }
            else
            {
                // if(this.state.blnShiftDown)
                // {
                //     this.state.listLines.forEach(l => this.UpdateLineField(l, "IsSuperscription", false))
                // }
                // else
                // {
                    // var listLevel4Groups = this.GetLinesByBreakGroup(this.state.listLines, 'StartsLevel4Group')
                    // listLevel4Groups[0].forEach(l => this.UpdateLineField(l, "IsSuperscription", true))
                //}

                this.setState({blnSDown: true})
            }
        }
        else if(key === "a")
		{
            if(this.ShowingDevelopmentDiagram())
            {
                this.setState({sDefaultNoHoveredModeForDevelopmentDiagram:
                    this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'unittounit' ? 'onelineperlinkgroup' : 
                    this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'onelineperlinkgroup' ? 'nolinks' : 'unittounit'})

                // this.setState({sWhichUnitToCompareWith: 
                //     this.state.sWhichUnitToCompareWith === 'selected' ? 'previoustohovered' : 
                //     this.state.sWhichUnitToCompareWith === 'previoustohovered' ? 'alllinksfromhovered' : 'selected'})
            }
        }
        else if(key === "g")
        {
            this.setState({sGroupLinesBy: this.state.sGroupLinesBy === 'StartsRepetitionGroup' ? 'StartsCluster' : 
                this.state.sGroupLinesBy === 'StartsCluster' ? 'StartsClusterGroup' : 
                this.state.sGroupLinesBy === 'StartsClusterGroup' ? 'StartsLevel4Group' : 'StartsRepetitionGroup'}, 
                () => {
                    if(this.ShowingDevelopmentDiagram())
                    {
                        this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                    }
                    else
                    {
                        this.SetWordGroupsForEnabledLenses()
                    }
                })
        }
        else if(key === "Escape" || key === '`')
		{
			this.setState({currentRepetitionLinkGroupIsSticky: false})
            this.setState({listCurrentStickiedWordsForHoverLens: []})
            this.setState({listCurrentStickiedSyllablesForHoverLens: []})
            this.setState({listSelectedWordGroupsInLineChart: []})
            // this.setState({listLockedLinesToShow: []})
            this.setState({currentWordTagIsSticky: false});
            this.setState({blnColorByItemIsSticky: false});
            this.setState({listInfoShow: [""]})

            if(this.GroupByUnitHeatmapIsEnabled())
            {
                this.setState({blnHoveredObjectForSoundGroupByUnitChartIsStickied: false})
                this.setState({oHoveredObjectForSoundGroupByUnitChart: null})
            }

            this.state.listTags.filter(o => o.InEditMode).
                forEach(o => this.DoneEditingTagTextbox(o));
        }
        
        // else if(key === "r")
		// {
        //     this.setState({blnRestrictTextToRepetitionGroupsWithOutlinedWords: !this.state.blnRestrictTextToRepetitionGroupsWithOutlinedWords});
        // }
        else if(key === "c")
		{
            if(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID)
            {
                this.setState({blnConnectionIsContrast: !this.state.blnConnectionIsContrast})
            }
            else if(this.state.blnConnectionsPresentationCommentEditMode && window.location.hostname.includes("localhost"))
            {
                let blnValue = !this.state.blnConnectionIsContrastForCurrentConnectionsGroup
                this.SetIsContrastForCurrentConnectionsGroup(blnValue)
                this.setState({blnConnectionIsContrastForCurrentConnectionsGroup: blnValue})
            }
            else if(!this.state.blnControlDown)
            {
                //if(this.state.nSelectedToolID === this.nColaMergeToolID) this.ChangeTool(this.nMarkCorrespondencesWithinLineGroupsToolID);
                this.setState({blnShowLineCharts: !this.state.blnShowLineCharts})
                //this.setState({blnShowUnitRelationshipCharts: !this.state.blnShowUnitRelationshipCharts})
            }
        }
        else if(key === "h")
		{
            if(this.ShowingDevelopmentDiagram())
            {
                let sDevelopmentDiagramLanguageToSet = this.state.sDevelopmentDiagramLanguage === 'original' ? 'transliteration' :
                    this.state.sDevelopmentDiagramLanguage === 'transliteration' ? 'translation' : 'original'

                this.setState({sDevelopmentDiagramLanguage: sDevelopmentDiagramLanguageToSet})
                this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), sDevelopmentDiagramLanguageToSet, this.GetLinesToDraw())
            }
            else
            {
                this.setState({blnShowHebrew: !this.state.blnShowHebrew})
            }
        }
        else if(isFinite(key) && key !== ' ')
		{
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = parseInt(key)
            }
        }
        else if(key === "q" || key === "Q")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                //this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 10

                // this.setState({sGroupLinesByForLens: 
                //     this.state.sGroupLinesByForLens === 'Line' ? 'StartsRepetitionGroup' : 
                //     this.state.sGroupLinesByForLens === 'StartsRepetitionGroup' ? 'StartsCluster' : 
                //     this.state.sGroupLinesByForLens === 'StartsCluster' ? 'StartsClusterGroup' : 
                //     this.state.sGroupLinesByForLens === 'StartsClusterGroup' ? 'StartsLevel4Group' : 
                //     this.state.sGroupLinesByForLens === 'StartsLevel4Group' ? 'ByChapter' : 'Line'}, () => {
                //         this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                // })

                this.setState({nMinDevelopmentDiagramLinkGroupLengthToShow: 
                    this.state.nMinDevelopmentDiagramLinkGroupLengthToShow === '2' ? '3' : 
                    this.state.nMinDevelopmentDiagramLinkGroupLengthToShow === '3' ? '4' : 
                    this.state.nMinDevelopmentDiagramLinkGroupLengthToShow === '4' ? '5' : '2'}, () => {
                        this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                })
            }
            else
            {
                if(this.state.nPatternLensWordGroupsToShowColorsForIndex > 0)
                    this.setState({nPatternLensWordGroupsToShowColorsForIndex: this.state.nPatternLensWordGroupsToShowColorsForIndex - 1})
            }
        }
        else if(key === "w" || key === "W")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.setState({nMaxLinesApartForChains: 
                    this.state.nMaxLinesApartForChains === '0' ? '1' : 
                    this.state.nMaxLinesApartForChains === '1' ? '2' : '0'}, () => {
                        this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                })

                // if(this.GroupByUnitHeatmapIsEnabled())
                // {
                //     let nCurrentValue = this.state.nTopNThresholdForGroupByUnitHeatmap
                //     this.setState({nTopNThresholdForGroupByUnitHeatmap: nCurrentValue === 8 ? 1 : (nCurrentValue + 1)}, () => {
                //         this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                //     })
                // }
                
                //this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 11
            }
            else
            {
                this.setState({blnWDown: true})
                this.setState({nPatternLensWordGroupsToShowColorsForIndex: this.state.nPatternLensWordGroupsToShowColorsForIndex + 1})
            }
        }
        else if(key === "e" || key === "E")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                if(this.GroupByUnitHeatmapIsEnabled())
                {
                    this.setState({sGroupLinesByForGroupByUnitHeatmap: this.state.sGroupLinesByForGroupByUnitHeatmap === 'Line' ? 'StartsRepetitionGroup' : 
                        this.state.sGroupLinesByForGroupByUnitHeatmap === 'StartsRepetitionGroup' ? 'StartsCluster' : 'Line'}, () => {
                            this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                    })

                }
                else
                {
                    this.setState({sModeForShowOnlyLinksAtLineEdges: 
                        this.state.sModeForShowOnlyLinksAtLineEdges === 'modeisoff' ? 'beginningtobeginningorendtoend' :
                        this.state.sModeForShowOnlyLinksAtLineEdges === 'beginningtobeginningorendtoend' ? 'beginningtobeginningorendtoendormiddletomiddle' :
                        this.state.sModeForShowOnlyLinksAtLineEdges === 'beginningtobeginningorendtoendormiddletomiddle' ? 'middletomiddle' :
                        this.state.sModeForShowOnlyLinksAtLineEdges === 'middletomiddle' ? 'beginningtoendorendtobeginning' : 
                        this.state.sModeForShowOnlyLinksAtLineEdges === 'beginningtoendorendtobeginning' ? 'sameline' : 'modeisoff'})
                }

                //this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 12
            }
        }
        else if(key === "r" || key === "R")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 14
            }
            else
            {
                var listLinesToLock = this.GetLinesForRepetitionGroupsWithOutlinedWords()

                // console.log(listLinesToLock.length, this.state.listLockedLinesToShow.length, listLinesToLock.every(l => this.state.listLockedLinesToShow.includes(l)))
    
                //only clear the lines if there are not changes to the list. If there are changes, we want to immediately change to those changes.
                if(this.state.listLockedLinesToShow.length > 0 && !this.state.blnShiftDown &&
                    listLinesToLock.length === this.state.listLockedLinesToShow.length && listLinesToLock.every(l => this.state.listLockedLinesToShow.includes(l)))
                {
                    this.setState({listLockedLinesToShow: []})
                }
                else
                {
                    this.setState({listLockedLinesToShow: listLinesToLock})
                }
            }
        }
        else if(key === "t" || key === "T")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 15
            }
            else
            {
                this.setState({blnShowTransliteration: !this.state.blnShowTransliteration})
                //this.setState({blnRestrictTextToVerseRangesToHighlight: !this.state.blnRestrictTextToVerseRangesToHighlight});
            }
        }
        else if(key === "y" || key === "Y")
        {
            if(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID)
            {
                this.setState({blnSyllableModeForRepetitionLinkGroupTool: !this.state.blnSyllableModeForRepetitionLinkGroupTool})
            }
            else
            {
                if(this.ShowingDevelopmentDiagram())
                {
                    this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 16
                }
            }
        }
        else if(key === "u" || key === "U")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 17
            }
        }
        else if(key === "o" || key === "O")
        {
            if(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID)
            {
                this.setState({blnConnectionIsPronominalSuffix: !this.state.blnConnectionIsPronominalSuffix})
            }
            else
            {
                if(this.ShowingDevelopmentDiagram())
                {
                    this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 18
                }
            }
        }
        else if(key === "p" || key === "P")
        {
            if(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID)
            {
                this.setState({blnConnectionIsAttachedPreposition: !this.state.blnConnectionIsAttachedPreposition})
            }
            else
            {
                if(this.ShowingDevelopmentDiagram())
                {
                    this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 19
                }
                else
                {
                    if(this.state.blnHideEverything)
                    {
                        this.setState({blnHideEverything: false})
                    }
                    else
                    {
                        if(this.state.nSelectedToolID === this.nMarkCorrespondencesWithinLineGroupsToolID || 
                        this.state.nSelectedToolID === this.nWordLinkToolID) this.setState({blnDragWordsInSamePhraseTogether: !this.state.blnDragWordsInSamePhraseTogether})
                    }
                }
            }
        }
        else if(key === "d" || key === "D")
        {
            // if(this.ShowingDevelopmentDiagram() && this.state.blnColorLinesByDevelopmentRepetitionGroup)
            // {
            //     this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 20
            // }
            // else
            // {

                event.preventDefault()
                this.setState({oLensSelectedFromTaskSearch: null})
                this.setState({blnTaskPopoverIsOpen: true})

                // this.setState({blnDDown: true})
                // this.setState({sIntraOrInterUnitsLensScope: this.state.sIntraOrInterUnitsLensScope === 'both' ? 'inside' : 
                //     this.state.sIntraOrInterUnitsLensScope === 'inside' ? 'between' : 'both'}, this.SetWordGroupsForEnabledLenses())
            //}
        }
        else if(key === "f" || key === "F")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 21
            }
        }
        else if(key === "j" || key === "J")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 22
            }
        }
        else if(key === "k" || key === "K")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 23
            }
        }


        else if(key === '-')
		{
            if(this.ShowingDevelopmentDiagram())
            {
                this.blnClearDevelopmentDiagramRepetitionGroup = true
            }
        }
        else if(key === "i" && !this.state.blnControlDown)
		{
            if(this.ShowingDevelopmentDiagram())
            {
                this.setState({sShowInternalLinkGroups: 
                    this.state.sShowInternalLinkGroups === 'both' ? 'externalonly' : 
                    this.state.sShowInternalLinkGroups === 'externalonly' ? 'internalonly' : 'both'})
            }
            else
            {
                this.setState({blnShowInterlinear: !this.state.blnShowInterlinear})
            }
        }
        else if(key === "x" || key === "X")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 24
            }
        }
        else if(key === "b" || key === "B")
        {
            this.setState({blnShowSubunitBreaksInDevelopmentDiagram: !this.state.blnShowSubunitBreaksInDevelopmentDiagram}, 
                this.GenerateDevelopmentDiagramForChapterIfShowing())
            
            // if(this.ShowingDevelopmentDiagram())
            // {
            //     this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 26
            // }
        }
        else if(key === "v" || key === "V")
        {
            // if(this.ShowingDevelopmentDiagram())
            // {
            //     this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 25
            // }
            // else
            // {
            
            this.setState({blnShowVerseNumbers: !this.state.blnShowVerseNumbers})
            
            //}
        }
        else if(key === "m" || key === "M")
		{
            if(this.ShowingDevelopmentDiagram())
            {
                this.setState({blnConnectionsPresentationMode: !this.state.blnConnectionsPresentationMode})

                //this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 28
            }
            else
            {
                if(this.state.nSelectedToolID === this.nMarkCorrespondencesWithinLineGroupsToolID) this.ChangeTool(this.nColaMergeToolID)
            }
        }
        else if(key === "," || key === "<")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 29
            }
        }
        else if(key === "." || key === ">")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 30
            }
        }
        else if(key === "/" || key === "?")
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = 31
            }
        }
        else if(key === "Enter" && !this.state.blnControlDown)
		{
            
        }
        else if(key === "'" && !this.state.blnControlDown)
		{
            this.setState({blnShowLineCheckboxes: !this.state.blnShowLineCheckboxes})
        }
        else if(key === "l" && !this.state.blnControlDown)
		{
            //this.ChangeViewByTo(this.state.sViewBy === 'Line' ? 'Development' : 'Line')
            this.ChangeView(this.state.sSelectedView !== 'composite' ? 'composite' : 'semantic')
        }
		else if(key === "ArrowUp")
        {
            this.GetSelectedTags().forEach(selectedNode => {
                if(this.state.blnShiftDown) this.SwapNodeWithTagAtOffsetIndex(selectedNode, -1);
                else this.MoveSelectionFromTagToOffsetIndex(selectedNode, -1)});

                // var nodeAboveIt = this.state.listTags.find(t => t.NodeBelowIt === selectedNode);
                // if(nodeAboveIt != undefined)
                // {
                //     if(this.state.blnShiftDown)
                //     {
                //         var nodeAboveNodeAboveIt = this.state.listTags.find(t => t.NodeBelowIt === nodeAboveIt);
                //         if(nodeAboveNodeAboveIt != undefined) 
                //             this.UpdateTagFieldValue(nodeAboveNodeAboveIt, "NodeBelowIt", selectedNode);
                //         this.UpdateTagFieldValue(nodeAboveIt, "NodeBelowIt", selectedNode.NodeBelowIt);                      
                //         this.UpdateTagFieldValue(selectedNode, "NodeBelowIt", nodeAboveIt);

                //         var newPosition = {x: nodeAboveIt.Position.x, y:nodeAboveIt.Position.y};
                //         this.SetTagPosition(nodeAboveIt, selectedNode.Position);
                //         this.SetTagPosition(selectedNode, newPosition);
                //     }
                //     else
                //     {
                //         this.UpdateTagFieldValue(selectedNode, "Selected", false);
                //         this.UpdateTagFieldValue(nodeAboveIt, "Selected", true);
                //     }
                // }
            //}
        }
        else if(key === "ArrowDown")
        {
            this.GetSelectedTags().filter(tag => tag.Selected).forEach(selectedNode => {
                if(this.state.blnShiftDown) this.SwapNodeWithTagAtOffsetIndex(selectedNode, 1);
                else this.MoveSelectionFromTagToOffsetIndex(selectedNode, 1)});

            // var selectedNode = this.state.listTags.find(o => o.Selected);
            // if(selectedNode != undefined && selectedNode.NodeBelowIt != undefined)
            // {
            //     if(this.state.blnShiftDown)
            //     {
            //         var nodeAboveIt = this.state.listTags.find(t => t.NodeBelowIt === selectedNode);
            //         var nodeBelowIt = selectedNode.NodeBelowIt;
            //         var nodeBelowNodeBelowIt = nodeBelowIt.NodeBelowIt;
            //         if(nodeAboveIt != undefined) 
            //             this.UpdateTagFieldValue(nodeAboveIt, "NodeBelowIt", nodeBelowIt);
            //         this.UpdateTagFieldValue(nodeBelowIt, "NodeBelowIt", selectedNode);                      
            //         this.UpdateTagFieldValue(selectedNode, "NodeBelowIt", nodeBelowNodeBelowIt);

            //         var newPosition = {x: nodeBelowIt.Position.x, y:nodeBelowIt.Position.y};
            //         this.SetTagPosition(nodeBelowIt, selectedNode.Position);
            //         this.SetTagPosition(selectedNode, newPosition);
            //     }
            //     else
            //     {
            //         this.UpdateTagFieldValue(selectedNode, "Selected", false);
            //         this.UpdateTagFieldValue(selectedNode.NodeBelowIt, "Selected", true);
            //     }
            // }
        }

        if(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID || this.ConnectionsLensIsEnabled())
        {
            if(key === "1")
            {
                this.setState({nCurrentLinkGroupType: 20})
            }
            else if(key === "2")
            {
                this.setState({nCurrentLinkGroupType: 21})
            }
            else if(key === "3")
            {
                this.setState({nCurrentLinkGroupType: 22})
            }
            else if(key === "4")
            {
                this.setState({nCurrentLinkGroupType: 23})
            }
            else if(key === "5")
            {
                this.setState({nCurrentLinkGroupType: 24})
            }
            else if(key === "7")
            {
                this.setState({nCurrentLinkGroupType: 27})
            }
            else if(key === "8")
            {
                this.setState({nCurrentLinkGroupType: 28})
            }
            else if(key === "9")
            {
                this.setState({nCurrentLinkGroupType: 29})
            }
            else if(key === "0")
            {
                this.setState({nCurrentLinkGroupType: 25})
            }

            if(/^[0-9]$/.test(key))
            {
                this.DoThingsAfterChangingCurrentLinkGroupType()
            }
        }
    }
    
    handleKeyUp(key)
	{
        if(this.state.blnThematicStatementAutocompleteHasFocus || this.state.blnTaskSearchAutocompleteHasFocus || 
            this.state.blnTranslationEditBoxHasFocus || this.state.blnConnectionsPresentationCommentEditBoxHasFocus) return

		if(this.ShowSemanticCategoriesAutocomplete() || this.ShowSemanticSearchAutocomplete()) return;

        if(this.InSearchAndTagMode())
        {
            this.setState({nCurrentTagIDForSearchAndTag: -1})
        }

		//this.SetCurrentLinkGroupTagID(key, true);

        if(key === "Shift") this.setState({blnShiftDown: false});
        else if(key === "Control") this.setState({blnControlDown: false});
        else if(key === "Alt") this.setState({blnAltDown: false});
        else if(key === "z") this.setState({blnZDown: false});
        else if(key === "s") this.setState({blnSDown: false})
        else if(key === "a") this.setState({blnADown: false})
        else if(key === "d") this.setState({blnDDown: false})
        else if(key === "w" || key === "W") 
        {
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = -1
            }
            else
            {
                this.setState({blnWDown: false})
            }
        }
        else if((isFinite(key) && key !== ' ') || key === "q" || key === "e" || key === "Q" || key === "E" ||
            key === "r" || key === "R" || key === "t" || key === "T" || key === "y" || key === "Y" || key === "u" || key === "U" ||
            key === "o" || key === "O" || key === "p" || key === "P" || key === "d" || key === "D" || key === "f" || key === "F" ||
            key === "j" || key === "J" || key === "k" || key === "K" || key === "x" || key === "X" || key === "v" || key === "V" ||
            key === "b" || key === "B" || key === "n" || key === "N" || key === "m" || key === "M" || 
            key === "," || key === "<" || key === "." || key === ">" || key === "/" || key === "?")
		{
            if(this.ShowingDevelopmentDiagram())
            {
                this.nCurrentDevelopmentDiagramRepetitionGroupForTagging = -1
            }
        }
        else if(key === '-')
		{
            if(this.ShowingDevelopmentDiagram())
            {
                this.blnClearDevelopmentDiagramRepetitionGroup = false
            }
        }

		//if(key === "Shift" || key === "Control") this.SetColorForToolID(this.state.nSelectedToolID);
    }

	GetWordSpanRect(w, sForWhichColumnType)
	{
		if(this.state.dictRefs)
		var refForWord = this.state.dictRefs.get(w.TextIndex)
		if(refForWord === undefined) return null

		var ref = sForWhichColumnType === 'transliteration' ? refForWord.Transliteration.current : 
            sForWhichColumnType === 'translation' ? refForWord.Translation.current : 
            sForWhichColumnType === 'glosses' ? refForWord.Glosses.current : 
            refForWord.Hebrew.current
        
        // console.log(ref, refForWord, blnForTranslation)
        
		return ref === null ? null : ref.getBoundingClientRect();
	}

	ScrollToWords(listWords)
	{
        if(listWords.length === 0) return;

		// var topOfElement = document.querySelector('#targetElement').offsetTop - XX;
		// window.scroll({ top: topOfElement, behavior: "smooth" });
		var wordSpanRect = this.GetWordSpanRect(listWords[0], 'hebrew');
		if(wordSpanRect != null)
			window.scroll({top: wordSpanRect.top - this.divHeaderRef.current.getBoundingClientRect().height, left: 0}); //, behavior: 'smooth'
	}

	SubstituteParameters(sToReplaceIn, listParametersToUse)
	{
		if(sToReplaceIn === undefined) return undefined;
		if(listParametersToUse === undefined) return sToReplaceIn;

		if(sToReplaceIn.includes("pgrporder"))
		{
			//TODO: substitute regular expressions for the quasi-regex language in it
			//characters are [A-Z] * + ? [1-9]
			if(listParametersToUse.length > 0)
			{
				var listBackreferenceIndexes = [...listParametersToUse[0].matchAll(/(\d)/g)].map(m => parseInt(m[1]) - 1);
				var listQuestionMarkIndexes = [...listParametersToUse[0].matchAll(/\?/g)].map(m => m.index);
				
				for(var n of listBackreferenceIndexes)
				{
					listParametersToUse[0] = listParametersToUse[0].slice(0, listQuestionMarkIndexes[n]) + "(?)" + 
						listParametersToUse[0].slice(listQuestionMarkIndexes[n] + 1);
					listQuestionMarkIndexes = [...listParametersToUse[0].matchAll(/\?/g)].map(m => m.index);
				}

				listParametersToUse[0] = listParametersToUse[0].replace(/\?/g, ".").replace(/\*/g, ".*").replace(/\+/g, ".+").replace(/([1-9])/g, "\\$1");				 
			}
		}

		for(var nParam = 0; nParam < listParametersToUse.length; nParam++)
			sToReplaceIn = sToReplaceIn.replace("$" + (nParam + 1), listParametersToUse[nParam]);	

		return sToReplaceIn;
	}

	WordSequencesIdentical(list1, list2)
	{
		return list1.length === list2.length && list1.every(w => list2.includes(w));
	}

	CalcSlidingPatternComparison()
	{
		var sWindowUnit = "w";
		var nWindowLength = 10;
		var sWordPreFilter = "type:V";
		var sFeature = "f";
		var sFeatureColumnName = "Form";
		var indexDistanceRangeBetweenTerms = new NumberRange(1,1);

		var dictResults = new Map();
		var nStartChapter = 1;
		var nEndChapter = 150;

		for(var nChapterToDo = nStartChapter; nChapterToDo <= nEndChapter; nChapterToDo++)
		{
			var listTextWordsInChapterToDo = this.listTextWordsForAllChapters.filter(w => w.Chapter === nChapterToDo.toString());					
			var listLinesToUse = this.dictLinesByChapter.get(nChapterToDo);
			var listClausesToUse = this.listClausesForAllChapters.get(nChapterToDo);

			if(sWindowUnit === "l")
			{
				for(var n = 0; n <= listLinesToUse.length - nWindowLength; n++)
				{
					var sWindowPattern = "";
					if(sFeature === "linesyl") 
					{
						sWindowPattern = listLinesToUse.slice(n, n + nWindowLength)
							.map(l => "linesyl:" + l.SyllableCount + "," + l.SyllableCount).join("-");
					}
				}
			}
			else if(sWindowUnit === "w")
			{
				//if there is a filter defined (e.g. verbs), use only those words 
				//for both the window pattern and what to match it against.

				var listWordsToUse = sWordPreFilter === undefined ? listTextWordsInChapterToDo :
					this.FindQueryMatches(listTextWordsInChapterToDo, sWordPreFilter, listLinesToUse).flat();
				
				for(var n = 0; n <= listWordsToUse.length - nWindowLength; n++)
				{
					var listWindowSlice = listWordsToUse.slice(n, n + nWindowLength);
					var sWindowPattern = listWindowSlice.map(w => sFeature + ":" + 
						(sFeature === "syl" ? parseInt(w.SyllableCount) + "," + parseInt(w.SyllableCount) : w[sFeatureColumnName])).join("-");

					//console.log(sWindowPattern + " " + nChapterToDo + " " + nChapterToDo2);
					if(dictResults.has(sWindowPattern)) continue;
					dictResults.set(sWindowPattern, [])

					//loop by chapters to keep from straddling chapter boundaries
					for(var nChapterToDo2 = nStartChapter; nChapterToDo2 <= nEndChapter; nChapterToDo2++)
					{
						var listTextWordsInChapterToDo2 = this.listTextWordsForAllChapters.filter(w => w.Chapter === nChapterToDo2.toString());														
						var listWordsToQuery2 = sWordPreFilter === undefined ? listTextWordsInChapterToDo2 :
							this.FindQueryMatches(listTextWordsInChapterToDo2, sWordPreFilter, listLinesToUse).flat();
						
						var listSequencesFound = this.FindQueryMatches(listWordsToQuery2, sWindowPattern, listLinesToUse)
							.filter(arr => !this.WordSequencesIdentical(arr, listWindowSlice));
						if(listSequencesFound.length > 0)
							dictResults.set(sWindowPattern, dictResults.get(sWindowPattern).concat(listSequencesFound));

						// var listResultsByTerm = [];
						// for(var nTerm = 0; nTerm < listTerms.length; nTerm++)
						// {
						// 	listResultsByTerm.push(listWordsToQuery2
						// 		.filter(w => this.TermMatches(undefined, w, listTerms[nTerm], listLinesToUse, listClausesToUse))
						// 		.map(w => ({Word: w, SuccessChain: nTerm === 0 ? [w] : []})));
						// }

						// for(var nTerm = 1; nTerm < listTerms.length; nTerm++)
						// {
						// 	//compare one row to the previous and enforce adjacency
						// 	//if no words for a term match previous, break early for efficiency.		
						// 	var blnAtLeastOneWordInThisTermIsAdjacentToPreviousTerm = false;			
						// 	for(var wThis of listResultsByTerm[nTerm])
						// 	{
						// 		var listPreviousOnesAdjacentToThis = listResultsByTerm[nTerm - 1].filter(wPrev => 
						// 			indexDistanceRangeBetweenTerms.IndexInRange(
						// 				(listWordsToQuery2.findIndex(w3 => w3.TextIndex === wThis.Word.TextIndex) - 
						// 				 listWordsToQuery2.findIndex(w3 => w3.TextIndex === wPrev.Word.TextIndex))));

						// 		if(!blnAtLeastOneWordInThisTermIsAdjacentToPreviousTerm)
						// 			blnAtLeastOneWordInThisTermIsAdjacentToPreviousTerm = listPreviousOnesAdjacentToThis.length > 0;

						// 		wThis.SuccessChain = listPreviousOnesAdjacentToThis.flatMap(o => o.SuccessChain.concat([wThis.Word]));
						// 	}

						// 	if(!blnAtLeastOneWordInThisTermIsAdjacentToPreviousTerm) break;
						// }

						// var listSequencesFound = listResultsByTerm[listResultsByTerm.length - 1]
						// 	.filter(o => o.SuccessChain.length == listTerms.length && !this.WordSequencesIdentical(o.SuccessChain, listWindowSlice))
						// 	.map(o => o.SuccessChain);

						// if(listSequencesFound.length > 0)
						// 	dictResults.set(sWindowPattern, dictResults.get(sWindowPattern).concat(listSequencesFound));
					}
				}
			}
			
			// else if(sWindowUnit === "c")
			// {
			// 	for(var nClause = 0; nClause <= listClausesToUse.length - nWindowLength; nClause++)
			// 	{
			// 		if(sFeature === "linesyl") 
			// 		{
			// 			// c.EndIndex = Math.max(...c.Words.map(w => parseInt(w.TextIndex)));
			// 			// c.PhraseFunctionOrder = this.GetPhraseFunctionOrdering(c.Words);
			// 			// if(c.PhraseFunctionOrder === "") c.PhraseFunctionOrder = "None";

			// 			var listValues = listClausesToUse.slice(nClause, nClause + nWindowLength).map(c =>)
			// 			sToFind = "syl:2,2-syl:4,4-syl:1,1";
			// 		}
			// 	}
			// }
		}

		var sForExcel = "Pattern^Count^References^Text\n";
		for(var [key, value] of dictResults.entries())
		{
			if(value.length > 1)
			{
				var sText = value.map(arr => arr.map(w => w.FullText).join(" ")).join("       ");
				var sRefs = value.map(arr => arr.map(w => w.Chapter)[0] + ":" + Math.min(...arr.map(w => w.Verse)) + "-" + Math.max(...arr.map(w => w.Verse))).join("  ");
				sForExcel += key + "^" + value.length + "^" + sRefs + "^" + sText + "\n";
			}
		}
		//var nMaxNumberForPattern = Math.max(...[...dictResults.values()].map(a => a.length));

		navigator.clipboard.writeText(sForExcel);
		return dictResults;
	}

    CalcPGroupTally()
	{
		var dictResults = new Map();
		var nStartChapter = 1;
		var nEndChapter = 150;

		for(var nChapterToDo = nStartChapter; nChapterToDo <= nEndChapter; nChapterToDo++)
		{
            var listLinesForChapter = this.dictLinesByChapter.get(nChapterToDo)
            var listRepetitionGroups = this.CalculateRepetitionGroups(listLinesForChapter);
            for(var g of listRepetitionGroups)
            {
                var sPGroupOrderOfLines = g.Lines.map(line => line.PGroupOrder).join("-");
                dictResults.set(sPGroupOrderOfLines, (!dictResults.has(sPGroupOrderOfLines) ? 1 : (dictResults.get(sPGroupOrderOfLines) + 1)));
            }

            // for(var line of listLinesForChapter)
            // {
            //     dictResults.set(line.PGroupOrder, (!dictResults.has(line.PGroupOrder) ? 1 : (dictResults.get(line.PGroupOrder) + 1)));
            // }
		}

		var sForExcel = "PGroupOrder^Count\n";
		for(var [key, value] of dictResults.entries())
		{
			sForExcel += key + "^" + value + "\n";
		}

		navigator.clipboard.writeText(sForExcel);
		return dictResults;
    }
    
    ParallelPhrasesTally()
	{
		var dictResults = new Map();
		var nStartChapter = 1;
		var nEndChapter = 150;

		for(var nChapterToDo = nStartChapter; nChapterToDo <= nEndChapter; nChapterToDo++)
		{
            var listLinesForChapter = this.dictLinesByChapter.get(nChapterToDo)
            var listRepetitionGroups = this.CalculateRepetitionGroups(listLinesForChapter);
            for(var g of listRepetitionGroups)
            {
                for(var pgroupvalue of g.ListPGroupValuesInLineGroup)
                {
                    var listRunsOfConsecutiveWords = [];
                    for(var line of g.Lines)
                    {
                        var listWordsWithPGroupValue = line.Words.filter(w => w.PGroup == pgroupvalue);

                        //group by consecutiveness
                        var listWordsInCurrentRun = [];
                        for(var nWord = 0; nWord < listWordsWithPGroupValue.length; nWord++)
                        {
                            var word = listWordsWithPGroupValue[nWord];

                            if(listWordsInCurrentRun.length === 0 || 
                              (parseInt(word.TextIndex) - parseInt(listWordsInCurrentRun[listWordsInCurrentRun.length - 1].TextIndex) === 1))
                            {
                                listWordsInCurrentRun.push(word);
                            }
                            else
                            {
                                listRunsOfConsecutiveWords.push(listWordsInCurrentRun.map(w => w.FullText).join(" "));
                                listWordsInCurrentRun = [];
                            }

                            if(nWord === (listWordsWithPGroupValue.length - 1))
                                listRunsOfConsecutiveWords.push(listWordsInCurrentRun.map(w => w.FullText).join(" "));
                        }
                    }

                    if(listRunsOfConsecutiveWords.length > 1)
                    {
                        var sParallelStrings = listRunsOfConsecutiveWords.join("...")
                        dictResults.set(sParallelStrings, (!dictResults.has(sParallelStrings) ? 1 : (dictResults.get(sParallelStrings) + 1)));
                    }
                }
            }
		}

		var sForExcel = "ParallelGroups^Count\n";
		for(var [key, value] of dictResults.entries())
		{
			sForExcel += key + "^" + value + "\n";
		}

		navigator.clipboard.writeText(sForExcel);
		return dictResults;
    }

    LinkedWordsTally()
	{
		var listWordPairs = [];
		var nStartChapter = 1;
		var nEndChapter = 150;

		for(var nChapterToDo = nStartChapter; nChapterToDo <= nEndChapter; nChapterToDo++)
		{
            var listWordsInChapter = this.listTextWordsForAllChapters.filter(w => w.Chapter === nChapterToDo.toString());
            
            for(var w of listWordsInChapter)
            {
                var listLinks = this.GetLinkedWordsListForWord(w);
                if(listLinks === undefined || listLinks.length === 0) continue;

                listWordPairs = listWordPairs.concat(
                    listLinks.map(link => ({Word1: w, Word2: listWordsInChapter.find(w2 => w2.TextIndex === link.TextIndex), LinkType: link.Type})));
            }
		}

		var sForExcel = "Word1^Word2\n" + listWordPairs.map(p => p.Word1.FullText + "^" + (p.Word2 === undefined ? "" : p.Word2.FullText)).join("\n");
		navigator.clipboard.writeText(sForExcel);
    }

	GetQueryResultsForCorr(sQuery)
	{
		var listResults = [];
		var nStartChapter = 1;
		var nEndChapter = 150

		for(var nChapterToDo = nStartChapter; nChapterToDo <= nEndChapter; nChapterToDo++)
		{
			var listTextWordsInChapterToDo = this.listTextWordsForAllChapters.filter(w => w.Chapter === nChapterToDo.toString());					
			var listLinesToUse = this.state.listLinesForAllChapters.get(nChapterToDo);
			var listClausesToUse = this.listClausesForAllChapters.get(nChapterToDo);

			for(let sToFind of sQuery.split(";"))
			{
				var sWithRepeated = "";
				var withRepeatedMatch = sToFind.match(/\s+(withrepeated:.+)$/);
				if(withRepeatedMatch !== null)
				{
					sWithRepeated = withRepeatedMatch[1];
					sToFind = sToFind.replace(withRepeatedMatch[0], "");
				}

				var listSequencesFound = this.FindQueryMatchesChaining(listTextWordsInChapterToDo, sToFind, listLinesToUse, listClausesToUse, this.listRepetitionGroups, this.listRepetitionGroupClusters).MatchingWords;
                
                if(sWithRepeated != "")
					listSequencesFound = this.GroupByRepeated(listSequencesFound.flat(), sWithRepeated);

				if(listSequencesFound != undefined)
					listResults = listResults.concat(listSequencesFound);
			}
		}

		return listResults;
	}

	CalcGlobalCorr()
	{
		var blnDoJustAgainstSectionBoundaries = true;
		
		var sStems = "qpPNhHQt";
		var sVerbForms = "pivcarswqjh";
		var sPerson = "123";
		var sGender = "mf";
		var sNumber = "sdp";
		var sSuffixType = "hnd";
		var sWordTypes = "NVATPRD";
		var sPreps = "bklm";
		var sPF = "SOV";
		var sPFOrder = "S,SV,SO,SVO,SOV|V,VS,VO,VSO,VOS|O,OV,OS,OVS,OSV";
		var sLexicalGroups = "1,2,3,4,5";
		var sLexicalIDs = "5937,6739";
		var sFigs = "1,2";
		var sSectionBoundaries = "any section:1,2~";

		var listMorphQueries = sStems.split("").map(s => "type:V & s:" + s)
			.concat(sVerbForms.split("").map(s => "type:V & f:" + s))
			.concat(sPerson.split("").map(s => "type:V & p:" + s))
			.concat(sGender.split("").map(s => "type:V & g:" + s))
			.concat(sNumber.split("").map(s => "n:" + s))
			.concat(sPerson.split("").map(s => "sfxp:" + s))
			.concat(sGender.split("").map(s => "sfxg:" + s))
			.concat(sNumber.split("").map(s => "sfxn:" + s))
			.concat(sSuffixType.split("").map(s => "sfxtype:" + s))
			.concat(sWordTypes.split("").map(s => "type:" + s))
			.concat(sPreps.split("").map(s => "prep:" + s))
			.concat(sPF.split("").map(s => "pf:" + s))
			.concat(sPFOrder.split("|").map(s => "clauses pforder:" + s))
			.concat(sLexicalGroups.split(",").map(s => "lexgrp:" + s))
			.concat(sLexicalIDs.split(",").map(s => "lex:" + s));
			//.concat(sFigs.split(",").map(s => "fig:" + s));

		//outdated: TODO find new ones
		// any-(any{1,$1})-chars:$2/
		// any-(any{1,$1})-rhyme:$2$3/
		// txt:[ץסק]
		// type:V@linestart - (any{0,}) - type/@lineend c=0
		// any@linestart | any@lineend
		// any--sem:$1/ l=0
		// any--any--sem:$1/2--sem:$1/1
		// any--any--sem:$1/1--sem:$1/2
		// any-(any{1,$1})-startconsrhyme/			
		// sem:$1,$2							

		//syl:0,2, wordsinline:$1,$2, linesyl:$1,$2
		var listOtherQueries = ["type:V & f:[^rs] pgn~", "any texttype~", "waw:1", "art:1", "posw:50", "posl:50", "occ:0,20",
			"any-({1,3})-startconsrhyme/", "any withrepeated:LexicalGroup,2", "any withrepeated:ParentRoot,2", 
			"type:[ANV] withrepeated:LexicalID,2", "f:[pi] f~", 
			"syl:0,2", "syl:3,5", "syl:6,8", "syl:9,", 
			"wordsinline:0,2", "wordsinline:3,5", "wordsinline:6,8", "wordsinline:9,",
			"linesyl:0,5", "linesyl:6,10", "linesyl:11,15", "linesyl:16,"];  //"any--semsyn/ c<=$1", "any--semopp/ c<=$1", 
		var listAllQueries = listOtherQueries.concat(listMorphQueries);
		var nTotalComparisons = (blnDoJustAgainstSectionBoundaries ? 1 : listAllQueries.length) * listAllQueries.length;

		var listCorrelations = [];
		for(var sq1 of (blnDoJustAgainstSectionBoundaries ? [sSectionBoundaries] : listAllQueries))
		{
			var listResults1 = this.GetQueryResultsForCorr(sq1);

			for(var nsq2 = 0; nsq2 < listAllQueries.length; nsq2++)
			{
				var sq2 = listAllQueries[nsq2];
				if(sq1 === sq2) continue;

				console.log(nsq2 + "/" + nTotalComparisons + " " + sq2);
				var listResults2 = this.GetQueryResultsForCorr(sq2);

				var corrInfo = this.GetCorrelationInfo([{Results: listResults1}, {Results: listResults2}], undefined, this.dictLinesByChapter).get("Total");
				corrInfo.Query1 = sq1;
				corrInfo.Query2 = sq2;
				listCorrelations.push(corrInfo);
			}
		}

		//listCorrelations.sort((a,b) => b.CosineSimilarity - a.PercentInSameClause);
        listCorrelations.sort((a,b) => b.CosineSimilarity - a.CosineSimilarity); //not sure - original was above.

		var sExcelToPaste = "Feature1$Feature2$CosineSimilarity$Feature1Occs$Feature2Occs$SameWord$SameClause$SameVerse$AdjacentVerse" + 
			listCorrelations.map(c => c.Query1 + "$" + c.Query2 + "$" + c.CosineSimilarity + "$" + c.Feature1Occs + "$" + c.Feature2Occs + "$" + 
			c.SameWord + "$" + c.SameClause + "$" + c.SameVerse + "$" + c.AdjacentVerse).join("\n"); 
		//var jsonToPaste = JSON.stringify(listCorrelations);
		navigator.clipboard.writeText(sExcelToPaste);
	}

	DoHighlightAndGraph()
	{
		this.PerformQueries();
		this.CalculateGraphDataForAllGraphs(this.state.sGraphCode);
	}

	PerformQueries()
	{
		//if we don't have all the data yet, before running the report, get and cache it for other reports
		if(this.state.blnGlobalDistributionForQueries && this.listTextWordsForAllChapters.length === 0)
		{
			//TODO: after download, compress and put in local storage.
			//npm i lz-string
			fetch("HebrewTextData/allpsalmschapters.json")
			.then(res => res.json())
			.then(data => 
			{
				this.listTextWordsForAllChapters = data.OSHB;

				var textWordsByChapter = this.GroupArrayByKey(this.listTextWordsForAllChapters, "Chapter");
				this.listClausesForAllChapters = new Map();
				for(var sChapterToDo of Object.keys(textWordsByChapter))
				{						
					this.listClausesForAllChapters.set(parseInt(sChapterToDo), this.CalculateClauses(textWordsByChapter[sChapterToDo]));
				}

				if(this.dictLinesByChapter.size === 0) 
				{
					fetch("LineData/allpsalmslines.json")
					.then(res => res.json())
					.then(data => 
					{
						var listColasForAllChapters = data.Lines;					
						listColasForAllChapters = this.SortLines(listColasForAllChapters);	

						this.dictLinesByChapter = new Map();
						for(var sChapterToDo of Object.keys(this.GroupArrayByKey(listColasForAllChapters, "Chapter")))
						{							
							var nChapterToDo = parseInt(sChapterToDo);

							var locallyStoredColaForChapter = this.LoadLines(19, nChapterToDo);
							var listLinesForChapterToDo = locallyStoredColaForChapter != null && locallyStoredColaForChapter.length > 0 ? locallyStoredColaForChapter :
								listColasForAllChapters.filter(r => r.Chapter === sChapterToDo);

							this.CalculateLines(listLinesForChapterToDo, textWordsByChapter[sChapterToDo])
                            this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesForChapterToDo, true)
							this.dictLinesByChapter.set(nChapterToDo, listLinesForChapterToDo);
						}

						this.PerformQueriesStepTwo();
					})
					.catch(error => this.setState({ sInfoToShow: error }));
				}
				else
				{
					this.PerformQueriesStepTwo();
				}
			})
			.catch(error => this.setState({ sInfoToShow: error }));
		}
		else
		{
			this.PerformQueriesStepTwo();
		}
	}

	GetQueryMorphString(query, blnNotTheFirst)
	{
		var sToReturn = this.SubstituteParameters((query.CustomQueryString != "" ? query.CustomQueryString : query.ThingToFind.MorphCode), query.ParameterValues);
		if(blnNotTheFirst) sToReturn = sToReturn.replace(/^\s*lines\b/, "");
		return sToReturn;
	}

	PerformQueriesStepTwo()
	{
		this.listForSemanticDebugging = [];
		var listQueriesToSet = this.state.listQueries;
		var sSeqMorphCode = "";

		if(this.state.sQueryGroupCooccurrenceRequirement === "Sequential")
		{
			//merge all the queries together in a string
			sSeqMorphCode = listQueriesToSet.map((q, i)  => this.GetQueryMorphString(q, i > 0)).join("-");				
		}

        var nTotalLinesInAllChapters = [...this.dictLinesByChapter].map(r => r[1].length).reduce((acc, n) => acc + n, 0);
        var nTotalClausesInAllChapters = [...this.listClausesForAllChapters].map(r => r[1].length).reduce((acc, n) => acc + n, 0);

		//clear all results first, not in the below loop, in case the constraint is sequential 
		//and the loop only runs for the first query
		listQueriesToSet.forEach(q => q.Results = []);

		for(var query of listQueriesToSet.filter(q => q.ThingToFind != null))
		{
			var sMorphCode = sSeqMorphCode != "" ? sSeqMorphCode : this.GetQueryMorphString(query, false);
			if(sMorphCode === "" || sMorphCode === undefined) continue;

			query.OutputField = undefined;
			var outputFieldMatch = sMorphCode.match(/\boutput\:(\w+)\b/);
			if(outputFieldMatch !== null)
			{
				query.OutputField = outputFieldMatch[1];
				sMorphCode = sMorphCode.replace(outputFieldMatch[0], "");
			}

			var nStartChapter = this.state.blnGlobalDistributionForQueries ? 1 : this.state.listCurrentChapters.length === 0 ? 0 : this.state.listCurrentChapters[0]
			var nEndChapter = this.state.blnGlobalDistributionForQueries ? 150 : this.state.listCurrentChapters.length === 0 ? 0 : this.state.listCurrentChapters[this.state.listCurrentChapters.length - 1]

			for(var nChapterToDo = nStartChapter; nChapterToDo <= nEndChapter; nChapterToDo++)
			{
				var listTextWordsInChapterToDo = !this.state.blnGlobalDistributionForQueries ? this.listTextWordsForChapter :
					this.listTextWordsForAllChapters.filter(w => w.Chapter === nChapterToDo.toString());
				
				var listLinesToUse = !this.state.blnGlobalDistributionForQueries ? this.state.listLines : 
					this.dictLinesByChapter.get(nChapterToDo);

				var listClausesToUse = !this.state.blnGlobalDistributionForQueries ? this.listClauses :
					 this.listClausesForAllChapters.get(nChapterToDo);

				for(let sToFind of sMorphCode.split(";"))
				{
					var sWithRepeated = "";
					var withRepeatedMatch = sToFind.match(/\s+(withrepeated:.+)$/);
					if(withRepeatedMatch !== null)
					{
						sWithRepeated = withRepeatedMatch[1];
						sToFind = sToFind.replace(withRepeatedMatch[0], "");
					}

					var results = this.FindQueryMatchesChaining(listTextWordsInChapterToDo, sToFind, listLinesToUse, listClausesToUse, this.listRepetitionGroups, this.listRepetitionGroupClusters);
                    var listSequencesFound = results.MatchingWords;
                    query.MainObjectType = results.MainObjectType;

                    if(sWithRepeated != "")
						listSequencesFound = this.GroupByRepeated(listSequencesFound.flat(), sWithRepeated);

					if(listSequencesFound != undefined)
                        query.Results = query.Results.concat(listSequencesFound);
				}
			}

            if(query.MainObjectType === "word")
                query.TotalObjects = !this.state.blnGlobalDistributionForQueries ? this.listTextWordsForChapter.length : this.listTextWordsForAllChapters.length;				
            else if(query.MainObjectType === "line")
                query.TotalObjects = !this.state.blnGlobalDistributionForQueries ? this.state.listLines.length : nTotalLinesInAllChapters;
			else if(query.MainObjectType === "clause")
                query.TotalObjects = !this.state.blnGlobalDistributionForQueries ? this.listClauses.length : nTotalClausesInAllChapters;
                     
			if(sSeqMorphCode != "") break;
		}

		if(this.state.sQueryGroupCooccurrenceRequirement != "" && this.state.sQueryGroupCooccurrenceRequirement != "Sequential")
		{
			var sConstrainedUnitType = 
				this.state.sQueryGroupCooccurrenceRequirement === "SameWord" ? "w" :
				this.state.sQueryGroupCooccurrenceRequirement === "SameClause" ? "c" : "v"; 
			var nConstrainedUnitValue = this.state.sQueryGroupCooccurrenceRequirement === "AdjacentVerse" ? 1 : 0;

			// listQueriesToSet[0].Results.filter(arrofwords => listQueriesToSet.map(q => q.Results.map(arr => arr[0]))
			// 	.every(arr => arr.some(w => this.SatisfiesConstraint(sConstrainedUnitType, "=", nConstrainedUnitValue, [w, arrofwords[0]], listLinesToUse))));

			//for each sequence's first word in each of the query results, make sure it is within the constraint of 
			//some sequence's first word in each of the other query results

			listQueriesToSet.forEach((q, i) => 
				q.Results = q.Results.filter(arrofwords => 
					listQueriesToSet.filter((q2, i2) => i2 != i).map(q2 => q2.Results.map(arr => arr[0]))
					.every(arr => arr.some(w => this.SatisfiesConstraint(sConstrainedUnitType, "=", nConstrainedUnitValue, 
						[w, arrofwords[0]], listLinesToUse, "word", this.listRepetitionGroups)))));
		}

		this.setState({ listQueries: listQueriesToSet });
	}

	GroupByForLensQuery(listResultsByWord, key) 
	{
		//examples for key: rgrp, Stem, Stem+Form

		if(key.startsWith("rgrp"))
		{
			var nType = parseInt(key.split(":")[1]);
			var listRGroups = this.state.listRepetitionLinkGroups.filter(g => g.Type === nType);
			return listResultsByWord.reduce((acc, w) =>
			{
				var currentValue = listRGroups.findIndex(g => g.ListWords.includes(w.TextIndex));
				if (!acc[currentValue]) acc[currentValue] = [];
				acc[currentValue].push(w);
				return acc;
			}, {});
		}
		else if(key.startsWith("corr"))
		{
			return listResultsByWord.reduce((acc, w) =>
			{
				var currentValue = this.listCorrespondencesForChapter.findIndex(g => g.ListWords.includes(w.TextIndex));
				if (!acc[currentValue]) acc[currentValue] = [];
				acc[currentValue].push(w);
				return acc;
			}, {});
		}
		else if(key.startsWith("semanticrole"))
		{
			return listResultsByWord.reduce((acc, w) =>
			{
				var listRolesForWord = this.GetWordTagForWord(w).SemanticRoles;
				for(var role of listRolesForWord)
				{
					var sRoleName = this.listSemanticRoles.find(r2 => r2.ID === role.RoleID).Desc;
					if (!acc[sRoleName]) acc[sRoleName] = [];
					acc[sRoleName].push(w);
				}
				return acc;
			}, {});
		}
		else
		{		
			var listFields = key.split("+").map(s => s.trim());
			return listResultsByWord.reduce((acc, w) =>
			{
				var currentValue = listFields.map(fieldName =>  w[fieldName]).join("+");
				if (!acc[currentValue]) acc[currentValue] = [];
				acc[currentValue].push(w);
				return acc;
			}, {});
		}
	};

    PerformLensQueries(listQueries, sQueryGroupCooccurrenceRequirement, blnReturnOneGroup)
	{
		this.listForSemanticDebugging = [];
		var sSeqMorphCode = "";

		if(sQueryGroupCooccurrenceRequirement === "Sequential")
		{
			//merge all the queries together in a string
            sSeqMorphCode = listQueries.map((q, i) => i > 0 ? query.Query.replace(/^\s*lines\b/, ""): query.Query).join("-");		
		}

        //clear all results first, not in the below loop, in case the constraint is sequential 
		//and the loop only runs for the first query
        listQueries.forEach(q => q.Results = []);
        
		for(var query of listQueries)
		{
			var sMorphCode = query.Query;

            var nStartChapter = this.state.listCurrentChapters.length === 0 ? 0 : this.state.listCurrentChapters[0]
			var nEndChapter = this.state.listCurrentChapters.length === 0 ? 0 : this.state.listCurrentChapters[this.state.listCurrentChapters.length - 1]

			for(var nChapterToDo = nStartChapter; nChapterToDo <= nEndChapter; nChapterToDo++)
			{
				var listTextWordsInChapterToDo = this.listTextWordsForChapter;
				var listLinesToUse = this.state.listLines;
				var listClausesToUse = this.listClauses;

				for(let sToFind of sMorphCode.split(";"))
				{
					var sWithRepeated = "";
					var withRepeatedMatch = sToFind.match(/\s+(withrepeated:.+)$/);
					if(withRepeatedMatch !== null)
					{
						sWithRepeated = withRepeatedMatch[1];
						sToFind = sToFind.replace(withRepeatedMatch[0], "");
					}

					var results = this.FindQueryMatchesChaining(listTextWordsInChapterToDo, sToFind, listLinesToUse, listClausesToUse, this.listRepetitionGroups, this.listRepetitionGroupClusters);
                    var listSequencesFound = results.MatchingWords;
                    query.MainObjectType = results.MainObjectType;

                    if(sWithRepeated != "")
						listSequencesFound = this.GroupByRepeated(listSequencesFound.flat(), sWithRepeated);

					if(listSequencesFound != undefined)
                        query.Results = query.Results.concat(listSequencesFound);
				}
			}

            if(query.MainObjectType === "word")
                query.TotalObjects = this.listTextWordsForChapter.length;			
            else if(query.MainObjectType === "line")
                query.TotalObjects = this.state.listLines.length;
			else if(query.MainObjectType === "clause")
                query.TotalObjects = this.listClauses.length;
                     
			if(sSeqMorphCode != "") break;
		}
 
		if(sQueryGroupCooccurrenceRequirement != "" && sQueryGroupCooccurrenceRequirement != "Sequential")
		{
			var sConstrainedUnitType = 
				sQueryGroupCooccurrenceRequirement === "SameWord" ? "w" :
				sQueryGroupCooccurrenceRequirement === "SameClause" ? "c" :
				sQueryGroupCooccurrenceRequirement === "SameLine" ? "l" :
				sQueryGroupCooccurrenceRequirement === "SameRepetitionGroup" ? "repgrp" : "v"; 

			var nConstrainedUnitValue = sQueryGroupCooccurrenceRequirement === "AdjacentVerse" ? 1 : 0;

			//for each sequence's first word in each of the query results, make sure it is within the constraint of 
			//some sequence's first word in each of the other query results

			listQueries.forEach((q, i) => 
				q.Results = q.Results.filter(arrofwords => 
					listQueries.filter((q2, i2) => i2 != i).map(q2 => q2.Results.map(arr => arr[0]))
					.every(arr => arr.some(w => this.SatisfiesConstraint(sConstrainedUnitType, "=", nConstrainedUnitValue, 
						[w, arrofwords[0]], listLinesToUse, "word", this.listRepetitionGroups)))));
		}

        var listToReturn = [];

        if(blnReturnOneGroup)
        {
            listToReturn = [{ListWords: listQueries.flatMap(q => q.Results.flat()), Name: '', Color: 'Blue'}]
        }
        else
        {
            for(var q of listQueries)
            {
                var nIndex = 0;

                if(q.GroupBy != undefined)
                {
                    for(var entry of Object.entries(this.GroupByForLensQuery(q.Results.flat(), q.GroupBy)))
                    {
                        var blnAppendKeyToName = !q.GroupBy.startsWith("rgrp");
                        listToReturn.push({ListWords: entry[1], Name: q.Name + (!blnAppendKeyToName ? "" : "-" + entry[0]), 
                            Color: this.listLinkGroupColors[nIndex % this.listLinkGroupColors.length]});
                        nIndex++;
                    }
                }
                else
                {
                    for(var resultsGroup of q.Results)
                    {
                        listToReturn.push({ListWords: resultsGroup, Name: q.Name, Color: this.listLinkGroupColors[nIndex % this.listLinkGroupColors.length]});
                        nIndex++;
                    }
                }
            }
        }

        return listToReturn;

        //listQueries.forEach(q => q.FlatResults = []);
        //listQueries.flatMap(q => q.Results)
        // return listQueries.map(q => {return {Name: q.Name, Results: q.Results.flat()}}).map((o,index) => 
        //     {return {ListWords: o.Results, Name: o.Name, Color: this.listLinkGroupColors[index % this.listLinkGroupColors.length]}});

        // return listQueries.map((q,index) => {
        //     return {ListWords: q.Results.flat(), Color: this.listLinkGroupColors[index % this.listLinkGroupColors.length]}});   
    }
    
	GetParameterControl(sParameterSpec, nIndexInParameterList, query)
	{
		var specSplit = sParameterSpec.split("^");
		var sControlType = specSplit[0]; 
		var sLabel = specSplit[1];
		var initialValue = specSplit[2];

		if(sControlType === "s")
		{
			return <input type="text" 
				style ={{height:'1%', margin:"15px"}}
				label={sLabel}
				variant="outlined"
				defaultValue={initialValue}
				//value = {query.ParameterValues[nIndexInParameterList]}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = event.target.value;  
					this.DoHighlightAndGraph(); }}/>
					
			// return <TextField 
			// 	style ={{width: '18%', height:'1%', margin:"5px"}}
			// 	label={sLabel}
			// 	variant="outlined"
			// 	value = {this.state.listParameters[nIndexInParameterList]}
			// 	onChange={(event) => { 
			// 		var listToSet = this.state.listParameters; 
			// 		listToSet[nIndexInParameterList] = event.target.value; 
			// 		this.setState({ listParameters: listToSet}); 
			// 		this.DoHighlightAndGraph(); }}/>
		}
		else if(sControlType === "customquery")
		{
			return <input type="text" 
				style ={{height:'1%', margin:"15px"}}
				label={sLabel}
				defaultValue={initialValue}
				variant="outlined"
				// value = {query.CustomQueryString}
				onChange={(event) => { 
					query.CustomQueryString = event.target.value;  
					this.DoHighlightAndGraph(); }}/>
		}
		else if(sControlType === "n")
		{
			return <FormControlLabel label={sLabel} style ={{marginLeft:"15px"}} labelPlacement="start" control={			
			<input type="number" style ={{height:'1%', margin:"10px"}} size="3"
			defaultValue={initialValue}
			//value={query.ParameterValues[nIndexInParameterList]}
			onChange={(event) => { 
				var filteredValue = event.target.value; //.replace(/\D/ig, '');
				query.ParameterValues[nIndexInParameterList] = filteredValue;  
				this.DoHighlightAndGraph(); }} />} />

			// <Slider			
			// style={{marginLeft:"15px"}}
			// //getAriaValueText={valuetext}
			// aria-labelledby="discrete-slider-small-steps"
			// step={1}
			// marks
			// min={0}
			// max={100}
			// valueLabelDisplay="auto"
			// value = {query.ParameterValues[nIndexInParameterList]}
			// onChange={(event, newValue) => { 
			// 	query.ParameterValues[nIndexInParameterList] = event.target.value;  
			// 	this.DoHighlightAndGraph(); }}
			// />} />
		}
		else if(sControlType === "bln")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
			<Checkbox style={{marginLeft:"15px"}}
			checked = {query.ParameterValues[nIndexInParameterList]}
			onChange={(event) => { 
				query.ParameterValues[nIndexInParameterList] = event.target.value; 
				this.DoHighlightAndGraph(); }}
			/>} />
		}
		else if(sControlType === "wordtype")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple style={{margin:"15px"}}
				//defaultValue={initialValue}
				//value={query.ParameterValues[nIndexInParameterList]}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = "[" + [...event.target.options].filter(o => o.selected).map(o => o.value).join("") + "]";  
					this.DoHighlightAndGraph(); }}>
					<option value={'N'}>Noun</option>
					<option value={'V'}>Verb</option>
					<option value={'A'}>Adjective/Numeral</option>
					<option value={'P'}>Pronoun</option>
					<option value={'T'}>Particle</option>
					<option value={'D'}>Adverb</option>
					<option value={'R'}>Preposition</option>
				</select>} />

			// return <FormControlLabel label={sLabel} labelPlacement="start" control={
			// 	<Select
			// 	//native
			// 	//multiple 
			// 	//style ={{width: '10%', height:'5%', margin:"15px"}}
			// 	//input={<Input />}
			// 	value = {query.ParameterValues[nIndexInParameterList]}
			// 	// value = {this.state.listParameters[nIndexInParameterList] === undefined ? [] : 
			// 	// 	this.state.listParameters[nIndexInParameterList].split("")}
			// 	//input={<Input />}
			// 	//renderValue={(selected) => selected.join(",")}
			// 	// 	<div>
			// 	// 	{selected.map((value) => (
			// 	// 		<Chip key={value} label={value} />
			// 	// 	))}
			// 	// 	</div>
			// 	//)}
			// 	onChange={(event) => { 
			// 		query.ParameterValues[nIndexInParameterList] = event.target.value;  
			// 		this.DoHighlightAndGraph(); }}>
			// 		{/* <option value={'N'}>Noun</option>
			// 		<option value={'V'}>Verb</option> */}
			// 		{/* <MenuItem value={'NVAPTDR'}>All</MenuItem> */}
			// 		<MenuItem value={'N'}>Noun</MenuItem>
			// 		<MenuItem value={'V'}>Verb</MenuItem>
			// 		<MenuItem value={'A'}>Adjective/Numeral</MenuItem>
			// 		<MenuItem value={'P'}>Pronoun</MenuItem>
			// 		<MenuItem value={'T'}>Particle</MenuItem>
			// 		<MenuItem value={'D'}>Adverb</MenuItem>
			// 		<MenuItem value={'R'}>Preposition</MenuItem>
			// 	</Select>} />
		}
		else if(sControlType === "wordfield")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple style={{margin:"15px"}}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = [...event.target.options].filter(o => o.selected).map(o => o.value).join(",");  
					this.DoHighlightAndGraph(); }}>
					
					<option value={'WordType'}>WordType</option>
					<option value={'Stem'}>Stem</option>
					<option value={'Form'}>Form</option>
					<option value={'Person'}>Person</option>
					<option value={'Gender'}>Gender</option>
					<option value={'Number'}>Number</option>
					<option value={'ConstructState'}>ConstructState</option>
					<option value={'SuffixPerson'}>SuffixPerson</option>
					<option value={'SuffixGender'}>SuffixGender</option>
					<option value={'SuffixNumber'}>SuffixNumber</option>
					<option value={'FullText'}>FullText</option>
					<option value={'OtherMarkings'}>OtherMarkings</option>
					<option value={'SyllableCount'}>SyllableCount</option>
					<option value={'LexicalID'}>LexicalID</option>
					<option value={'Waw'}>Waw</option>
					<option value={'DefiniteArticle'}>DefiniteArticle</option>
					<option value={'Interrogative'}>Interrogative</option>
					<option value={'AttachedRelative'}>AttachedRelative</option>
					<option value={'Preposition'}>Preposition</option>
					<option value={'HebrewAramaic'}>HebrewAramaic</option>
					<option value={'WordSubtype'}>WordSubtype</option>
					<option value={'SuffixType'}>SuffixType</option>
					<option value={'Occurrences'}>Occurrences</option>
					<option value={'ParentRoot'}>ParentRoot</option>
					<option value={'TextualNote'}>TextualNote</option>
					<option value={'phrase_type'}>phrase_type</option>
					<option value={'phrase_function'}>phrase_function</option>
					<option value={'clause_rela'}>clause_rela</option>
					<option value={'clause_typ'}>clause_typ</option>
					<option value={'clause_txt'}>clause_txt</option>

					{/* <option value={'phrase_atom_number'}>phrase_atom_number</option>
					<option value={'ClauseID'}>ClauseID</option>					
					<option value={'sentence_atom_number'}>sentence_atom_number</option> */}

					<option value={'PhraseFunctionOrder'}>ClausePhraseFunctionOrder</option>
					<option value={'LineWordCount'}>LineWordCount</option>
					<option value={'SyllableCount'}>LineSyllableCount</option>
					<option value={'PGroupOrder'}>LinePGroupOrder</option>
					<option value={'PGroupLineCount'}>RepetitionGroupLineCount</option>
					<option value={'GroupsInCluster'}>GroupsInCluster</option>
					<option value={'ClusterLineCount'}>ClusterLineCount</option>
				</select>} />
		}
		// else if(sControlType === "linefield")
		// {
		// 	return <FormControlLabel label={sLabel} labelPlacement="start" control={
		// 		<select multiple style={{margin:"15px"}}
		// 		onChange={(event) => { 
		// 			query.ParameterValues[nIndexInParameterList] = [...event.target.options].filter(o => o.selected).map(o => o.value).join(",");  
		// 			this.DoHighlightAndGraph(); }}>
					
		// 			<option value={''}></option>
					
		// 		</select>} />
		// }
		else if(sControlType === "stem")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple style={{margin:"15px"}}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = "[" + [...event.target.options].filter(o => o.selected).map(o => o.value).join("") + "]";  
					this.DoHighlightAndGraph(); }}>
					
					<option value={'q'}>Qal</option>
					<option value={'p'}>Piel</option>
					<option value={'P'}>Pual</option>
					<option value={'N'}>Niphal</option>
					<option value={'h'}>Hiphil</option>
					<option value={'H'}>Hophal</option>
					<option value={'Q'}>Qal Passive</option>
					<option value={'t'}>Hithpael</option>

					<option value={'o'}>Polel</option>
					<option value={'m'}>Poel</option>
					<option value={'O'}>Polal</option>
					<option value={'L'}>Polpal</option>
					<option value={'K'}>Pulal</option>
					<option value={'M'}>Poal</option>
					<option value={'k'}>Palel</option>
					<option value={'j'}>Pealal</option>
					<option value={'i'}>Pilel</option>
					<option value={'l'}>Pilpel</option>
									
					<option value={'c'}>Tiphil</option>
					<option value={'u'}>Hothpaal</option>
					<option value={'r'}>Hithpolel</option>
					<option value={'f'}>Hithpalpel</option>
					<option value={'v'}>Hishtaphel</option>
					<option value={'D'}>Nithpael</option>
					<option value={'w'}>Nithpalel</option>
					<option value={'y'}>Nithpoel</option>
					<option value={'z'}>Hithpoel</option>
				</select>} />
		}
		else if(sControlType === "verbform")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple style={{margin:"15px"}}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = "[" + [...event.target.options].filter(o => o.selected).map(o => o.value).join("") + "]";  
					this.DoHighlightAndGraph(); }}>
					
				<option value={'p'}>Perfect</option>
				<option value={'i'}>Imperfect</option>		
				<option value={'w'}>Wayyiqtol</option>
				<option value={'q'}>Weqatal</option>
				<option value={'v'}>Imperative</option>			
				<option value={'j'}>Jussive</option>
				<option value={'h'}>Cohortative</option>
				<option value={'c'}>Infinitive Construct</option>
				<option value={'a'}>Infinitive Absolute</option>
				<option value={'r'}>Active Participle</option>
				<option value={'s'}>Passive Participle</option>	
				</select>} />
		}
		else if(sControlType === "pgn")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple style={{margin:"15px"}}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = [...event.target.options].filter(o => o.selected).map(o => o.value).join(",");  
					this.DoHighlightAndGraph(); }}>
				
				<option value={'1cs'}>1s</option>
				<option value={'2ms'}>2ms</option>			
				<option value={'2fs'}>2fs</option>
				<option value={'3ms'}>3ms</option>		
				<option value={'3fs'}>3fs</option>

				<option value={'1cp'}>1p</option>
				<option value={'2mp'}>2mp</option>
				<option value={'2fp'}>2fp</option>
				<option value={'3mp'}>3mp</option>
				<option value={'3fp'}>3fp</option>
				</select>} />
		}
		else if(sControlType === "rhymetypes")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple style={{margin:"15px"}}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = [...event.target.options].filter(o => o.selected).map(o => o.value).join("");  
					this.DoHighlightAndGraph(); }}>
					<option value={'cons'}>Consonants</option>
					<option value={'vowel'}>Vowels</option>
				</select>} />
		}
		else if(sControlType === "rhymepositions")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple style={{margin:"15px"}}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = [...event.target.options].filter(o => o.selected).map(o => o.value).join("");  
					this.DoHighlightAndGraph(); }}>
					<option value={'start'}>Beginning</option>
					<option value={'end'}>End</option>
				</select>} />
		}
		else if(sControlType === "phrasefunction")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple style={{margin:"15px"}}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = "[" + [...event.target.options].filter(o => o.selected).map(o => o.value).join("") + "]";  
					this.DoHighlightAndGraph(); }}>
					<option value={'S'}>Subject</option>
					<option value={'V'}>Verb</option>
					<option value={'O'}>Object</option>
				</select>} />
		}
		else if(sControlType === "phrasefunctionorder")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple style={{margin:"15px"}}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = [...event.target.options].filter(o => o.selected).map(o => o.value).join(",");  
					this.DoHighlightAndGraph(); }}>
						
					<option value={'S'}>S</option>
					<option value={'SV'}>SV</option>
					<option value={'SO'}>SO</option>
					<option value={'SVO'}>SVO</option>
					<option value={'SOV'}>SOV</option>

					<option value={'V'}>V</option>
					<option value={'VS'}>VS</option>
					<option value={'VO'}>VO</option>
					<option value={'VSO'}>VSO</option>
					<option value={'VOS'}>VOS</option>

					<option value={'O'}>O</option>
					<option value={'OV'}>OV</option>
					<option value={'OS'}>OS</option>
					<option value={'OVS'}>OVS</option>
					<option value={'OSV'}>OSV</option>
				</select>} />
		}
		else if(sControlType === "bibleversion")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple style={{margin:"15px"}}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = [...event.target.options].filter(o => o.selected).map(o => o.value).join(",");  
					this.DoHighlightAndGraph(); }}>
						
					<option value={'1'}>ESV</option>
					<option value={'2'}>NIV</option>
				</select>} />
		}
		// else if(sControlType === "unittype")
		// {
		// 	return <FormControlLabel label={sLabel} labelPlacement="start" control={
		// 		<select multiple style={{margin:"15px"}}
		// 		onChange={(event) => { 
		// 			query.ParameterValues[nIndexInParameterList] = [...event.target.options].filter(o => o.selected).map(o => o.value).join(",");  
		// 			this.DoHighlightAndGraph(); }}>
						
		// 			<option value={'word'}>Word</option>
		// 			<option value={'line'}>Line</option>
		// 			<option value={'pgrp'}>Repetition Group</option>
		// 			<option value={'cluster'}>Group Cluster</option>
		// 		</select>} />
		// }
		else if(sControlType === "semanticnode")
		{
			return <FormControlLabel label={sLabel} labelPlacement="start" control={
				<select multiple size={20} style={{margin:"15px"}}
				onChange={(event) => { 
					query.ParameterValues[nIndexInParameterList] = "[" + [...event.target.options].filter(o => o.selected).map(o => o.value).join(",") + "]";  
					this.DoHighlightAndGraph(); }}>
					{this.state.listSemanticNodes.map(n => <option value={n.ID}>{n.Names}</option>)}
				</select>} />
		}
	}
	
	AddNewToQueryList()
	{
		var listQueriesToSet = this.state.listQueries;
		listQueriesToSet.push({ThingToFind: null, CustomQueryString: "", ControlMarkup: [], ParameterValues: [], 
			Color: this.distinguishingColors[listQueriesToSet.length], Results: []});
		this.setState({listQueries: listQueriesToSet});
	}

	ChangeThingToFindInQuery(query, thingToFind)
	{
		// var listQueriesToSet = this.state.listQueries;
		// var queryToSet = listQueriesToSet.find(q => q === query);
		query.ThingToFind = thingToFind;
		if(thingToFind.Parameters != undefined)
		{
			var listParametersSplit = thingToFind.Parameters.split(",").map(s => s.trim());
			query.ControlMarkup = listParametersSplit.map((s, index) => this.GetParameterControl(s, index, query));
			query.ParameterValues = listParametersSplit.map(s => s.split("^")[0] === "wordtype" ? [] : s.split("^")[2]);
		}
		//this.setState({listQueries: listQueriesToSet});
		this.PerformQueries();
	}

	RemoveFromQueryList(query)
	{
		var listQueriesToSet = this.state.listQueries;
		var nIndexToRemove = listQueriesToSet.indexOf(query);
		listQueriesToSet.splice(nIndexToRemove, 1);
		this.setState({listQueries: listQueriesToSet});
		if(query.ThingToFind != null) this.PerformQueries();
	}

	DealWithMorphCode(sMorph)
	{
		// var listQueriesToSet = this.state.listQueries;
		// var customThing = this.listThingsToFind.find(t => t.Desc === "Custom");
		// var listParametersSplit = customThing.Parameters.split(",").map(s => s.trim());
		// var controlMarkup = listParametersSplit.map((s, index) => this.GetParameterControl(s, index, query));
		// var parameterValues = listParametersSplit.map(s => s.split("^")[0] === "wordtype" ? [] : s.split("^")[2]);

		// listQueriesToSet.push({ThingToFind: customThing, CustomQueryString: sMorph, ControlMarkup: controlMarkup, ParameterValues: parameterValues, 
		// 	Color: this.distinguishingColors[listQueriesToSet.length], Results: []});
		// this.setState({listQueries: listQueriesToSet});
		// this.PerformQueries();
	}

    SetColorForToolID(nID)
    {
		if(nID === this.nMarkCorrespondencesWithinLineGroupsToolID) this.setState({ sColorBy: "pgrp"});
		else if(nID === this.nWordLinkToolID) this.setState({ sColorBy: "wordlinkgroup"});
        else if(nID === this.nLineLinkToolID) this.setState({ sColorBy: "linelinkgroup"});
        else if(nID === this.nRepetitionLinkGroupToolID) this.setState({ sColorBy: "rgrp"});
    }

	ChangeTool(nID)
	{
        this.setState({nSelectedToolID: nID});	
        this.SetColorForToolID(nID);
	}

    ChangeView(sView)
    {
        this.setState({sSelectedView: sView}, () => {
            if(sView === 'composite')
            {
                this.ChangeViewByTo('Development')
            }
            else
            {
                this.ChangeViewByTo('Line')
            }

            this.GenerateDevelopmentDiagramForChapterIfShowing()
        })

        let blnSoundOrRhythm = sView === 'sound' || sView === 'rhythm'

        if(blnSoundOrRhythm)
        {
            this.setState({sShowLinksFromHoveredWhat: 'line'})
        }

        //this.setState({blnShowTransliteration: blnSoundOrRhythm})
        this.setState({sDevelopmentDiagramLanguage: blnSoundOrRhythm ? 'transliteration' : 'translation'})
    }

	ChangeSpecialGraph(nID)
	{
		this.setState({listGraphTextIndicesToHighlight: []});
		this.setState({nSelectedSpecialGraphID: nID}, () => { if(this.NetworkShouldBeVisible()) this.ShowNetworkGraph()});

		//TestNodeArranging()
		var selectedSpecialGraphToSet = this.listSpecialGraphs.find(r => r.ID === nID);
		if(selectedSpecialGraphToSet !== undefined)
		{			
			this.setState({sGraphCode: selectedSpecialGraphToSet.GraphCode});
			this.CalculateGraphDataForAllGraphs(selectedSpecialGraphToSet.GraphCode, []);  //listDefaultParameters
		}
	}

	// GetTextWordsCurrentlySelected()
	// {
	//     var selection = window.getSelection();
	// 	return this.listTextWordsForChapter.filter(r => selection.containsNode(this.state.dictRefs.get(r.TextIndex).Hebrew.current, true));
	// }

	FigureContainsTextIndex(figure, textIndex)
	{
		return parseInt(textIndex) >= parseInt(figure.TextIndexRangeBegin) && parseInt(textIndex) <= parseInt(figure.TextIndexRangeEnd);
	}

	GetFiguresContainingTextIndex(textIndex)
	{
		return this.state.listFigures.filter(r => this.FigureContainsTextIndex(r, textIndex));
	}

	GetTypeOfFirstFigureContainingTextIndex(textIndex)
	{
		var listFiguresContainingIt = this.GetFiguresContainingTextIndex(textIndex);
		if(listFiguresContainingIt.length === 0) return undefined;
		else return listFiguresContainingIt[0].FigureTypeID;	
	}

	// MarkSelectedTextAsFigure()
	// {
	// 	var listToSet = this.state.listFigures;
	// 	var listTextIndexesSelected = this.GetTextWordsCurrentlySelected().map(r => parseInt(r.TextIndex));
	// 	listToSet.push({"TextIndexRangeBegin": Math.min(...listTextIndexesSelected), "TextIndexRangeEnd": Math.max(...listTextIndexesSelected), "FigureTypeID": this.state.nSelectedFigurativeSpeechTypeID});
	// 	this.SaveFigures(listToSet);
	// }

	ResetLinesForChapter(nBook, nChapter)
	{
        if(!this.state.blnMultipleChaptersSelected)
        {
            //ignore the local storage ones, get the original, then save it immediately to overwrite.
            fetch("LineData/lines_" + nBook + '_' + nChapter + ".json")
            .then(res => res.json())
            .then(data => 
            {
                var listLinesToSet = this.SortLines(data.Lines);
                this.SaveLines(listLinesToSet);
                this.CalculateLines(listLinesToSet, this.listTextWordsForChapter)
                this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesToSet, true)				
                this.setState({listLines: listLinesToSet});		
                // this.DoHighlightAndGraph();
                // this.CalculateColorChart(this.state.sColorBy);
            })
        }
	}

    FetchChapters(listRefs)
    {
        this.listTextWordsForChapter = []
        this.listAllSimilarityPairsForChapter = []
        this.listAllSimilarityLinePairsForChapter = []
        this.listAllSimilarityStanzaPairsForChapter = []
        this.listRootCooccurrenceDataForChapter = []
        this.listSimScoreDataForChapter = []
        this.listCorrespondencesForChapter = [] 
                
        this.setState({listLines: []})
        
        for(var nRef = 0; nRef < listRefs.length; nRef++)
        {
            var r = listRefs[nRef]
            this.FetchChapter(r.Book, r.Chapter, listRefs.length > 1, nRef === listRefs.length - 1)
        }

        if(listRefs.length > 0)
        {
            var nSelectedBook = listRefs[0].Book
            this.setState({nCurrentBook: nSelectedBook})
            this.setState({blnShowBSB: nSelectedBook === 19})
        }
        
        this.setState({listCurrentChapters: listRefs.map(r => r.Chapter).sort((a,b) => a - b)})
        this.setState({blnMultipleChaptersSelected: listRefs.length > 1})
    }

    SetLines(listLinesToSet)
    {
        this.CalculateLines(listLinesToSet, this.listTextWordsForChapter)
        this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesToSet, true)

        var listLinesToSetCombinedWithPreviousChapters = this.state.listLines.concat(listLinesToSet)
        this.setState({listLines: listLinesToSetCombinedWithPreviousChapters})

        if(this.blnAutomaticallySetGroupLinesByWhenChapterChanges)
        {
            this.setState({sGroupLinesBy: this.GetMaximumGroupLevelInLines(listLinesToSet)})
        }

        for(var w of this.listTextWordsForChapter)
        {
            w.IsFirstInLine = listLinesToSetCombinedWithPreviousChapters.some(l => l.Words.length > 0 && l.Words[0] === w)
        }

        // this.setState({listWordLinkGroups: this.CalculateObjectLinkGroupsFromObjectList(this.listTextWordsForChapter, "word")});
        // this.setState({listLineLinkGroups: this.CalculateObjectLinkGroupsFromObjectList(listLinesToSet, "line")});
        // this.setState({listWordLinkPairs: this.CalculateWordLinkPairs()});
        
        // var listPropositionsToSet = this.LoadPropositions(nChapter);
        // listPropositionsToSet.forEach(p => p.Words = p.TextIndexes.map(nID => this.listTextWordsForChapter.find(w => w.TextIndex === nID)));
        // this.setState({listPropositions: listPropositionsToSet});

        //this.SetSemanticOutline(nChapter);
        //this.ConvertSemanticOutlineForChapterIntoTags(nChapter);
        
        this.DoHighlightAndGraph();
        //this.CalculateColorChart(this.state.sColorBy);
        if(this.NetworkShouldBeVisible()) this.ShowNetworkGraph();
    }

    FetchChapter(nBook, nChapter, blnMultipleChaptersAreBeingFetched, blnIsLastChapterBeginFetched)
	{
		//put whatever you want reset before the fetch here.
		if(this.state.sColorBy === "pforder") this.setState({ ColorBy: ""});  //so it won't give a chart error b/c listClauses is not populated yet.

        var sFileBasicName = nBook + '_' + nChapter
        // console.log(sFileBasicName)

        fetch("HebrewTextData/" + sFileBasicName + ".json")
		//.then(res => console.log(res))
		.then(res => res.json())
		.then(data => 
		{
			this.listTextWordsForChapter = this.listTextWordsForChapter.concat(data.OSHB) //.filter(w => parseInt(w.TextIndex) > 16887 && parseInt(w.TextIndex) <= 17000);  
            this.blnChapterIsHebrew = nBook < 40

            this.listSyllablesForChapter = []
            for(var w of this.listTextWordsForChapter)
            {
                var listSyllableObjectsForWord = this.GetSyllableObjectsForWord(w)
                this.listSyllablesForChapter = this.listSyllablesForChapter.concat(listSyllableObjectsForWord)

                w.SyllableObjects = listSyllableObjectsForWord
                w.Transliteration = listSyllableObjectsForWord.map(syl => syl.syllable).join('')
                w.HasFullAccent = listSyllableObjectsForWord.some(syl => syl.hasFullAccent)
                w.MainAccentedSyllable = listSyllableObjectsForWord.find(syl => syl.hasFullAccent)
                w.HasSecondaryAccent = listSyllableObjectsForWord.some(syl => syl.hasSecondaryAccent)
                w.HasFinalAccent = listSyllableObjectsForWord.some(syl => syl.hasFullAccent && syl.isLastSyllableInWord)
                w.HasPenultimateAccent = listSyllableObjectsForWord.some((syl, n, arr) => syl.hasFullAccent && syl.syllableIndex === arr.length - 2)
            }
        
            //console.log([...new Set(this.listTextWordsForChapter.map(w => this.GetBasicVowelsInTransliteration(this.ReplaceThingsInTransliterationBeforeGettingSounds(this.RemoveNonVowelsAndNonConsonants(w.Syllables.join('')))).join('')))])
        
            // console.log(this.listTextWordsForChapter)
			// console.log(data);
            // console.log(sFileBasicName)
			if(blnIsLastChapterBeginFetched) this.FillChapters()

            // this.listVersesForEnglishVersionOnlyForDevForCurrentBook = this.listAllVersesForEnglishVersionOnlyForDev.filter(av => av.BookIndex === nBook.toString() && av.Chapter === nChapter.toString())

            fetch("LineData/lines_" + sFileBasicName + ".json")
            .then(res => res.json())
            .then(data => 
            {
                var listLinesToSet = this.SortLines(data.Lines)
                var locallyStoredCola = this.LoadLines(nBook, nChapter);
                if(locallyStoredCola !== null && locallyStoredCola.length > 0) listLinesToSet = locallyStoredCola;

                if(nBook === 19)
                {
                    fetch("OtherData/otherdata_" + sFileBasicName + ".json")
                    .then(res => res.json())
                    .then(data => 
                    {
                        //by the way, it's MergeLineChanges.py that we use to process locally stored data into data for the public folder
                        var listOurTranslationLinesToSet = data.OurTranslationLines
                        var listTranslationWordIndexLinksToSet = data.TranslationWordIndexLinks
                        var listDevelopmentRepetitionGroupsByChapterToSet = data.DevelopmentRepetitionGroupsByChapter
                        var listDevelopmentRepetitionDescsForGroupsByChapterToSet = data.DevelopmentRepetitionDescsForGroupsByChapter
                        var dictMainWordInTranslationLinkGroupsByTextIndexToSet = this.ChangeDictionarySavedInJSONToMap(data.MainWordInTranslationLinkGroupsByTextIndexDictionary, false)
                        var dictMainPrepositionWordInTranslationLinkGroupsByTextIndexToSet = this.ChangeDictionarySavedInJSONToMap(data.MainPrepositionWordInTranslationLinkGroupsByTextIndexDictionary, false)
                        var dictMainSuffixWordInTranslationLinkGroupsByTextIndexToSet = this.ChangeDictionarySavedInJSONToMap(data.MainSuffixWordInTranslationLinkGroupsByTextIndexDictionary, false)

                        var locallyStoredOurTranslationLines = this.LoadOurTranslationLines(nBook, nChapter)
                        var locallyStoredTranslationWordIndexLinks = this.LoadTranslationWordIndexLinks(nBook, nChapter)
                        var locallyStoredDevelopmentRepetitionGroupsByChapter = this.LoadDevelopmentRepetitionGroupsByChapter(nBook, nChapter)
                        var locallyStoredDevelopmentRepetitionDescsForGroupsByChapterForThisChapter = this.LoadDevelopmentRepetitionDescsForGroupsByChapter(nBook, nChapter)
                        var locallyStoredMainWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter = this.LoadMainWordInTranslationLinkGroupsByTextIndexDictionary(nBook, nChapter)
                        var locallyStoredMainPrepositionWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter = this.LoadMainPrepositionWordInTranslationLinkGroupsByTextIndexDictionary(nBook, nChapter)
                        var locallyStoredMainSuffixWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter = this.LoadMainSuffixWordInTranslationLinkGroupsByTextIndexDictionary(nBook, nChapter)

                        if(locallyStoredTranslationWordIndexLinks !== null && locallyStoredTranslationWordIndexLinks.length > 0)
                        {
                            listTranslationWordIndexLinksToSet = locallyStoredTranslationWordIndexLinks
                        }

                        if(locallyStoredOurTranslationLines !== null && locallyStoredOurTranslationLines.length > 0)
                        {
                            listOurTranslationLinesToSet = locallyStoredOurTranslationLines
                        }

                        if(locallyStoredDevelopmentRepetitionGroupsByChapter !== null && locallyStoredDevelopmentRepetitionGroupsByChapter.length > 0)
                        {
                            listDevelopmentRepetitionGroupsByChapterToSet = locallyStoredDevelopmentRepetitionGroupsByChapter
                        }

                        if(locallyStoredDevelopmentRepetitionDescsForGroupsByChapterForThisChapter !== null && locallyStoredDevelopmentRepetitionDescsForGroupsByChapterForThisChapter.length > 0)
                        {
                            listDevelopmentRepetitionDescsForGroupsByChapterToSet = locallyStoredDevelopmentRepetitionDescsForGroupsByChapterForThisChapter
                        }

                        if(locallyStoredMainWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter !== null && 
                            locallyStoredMainWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter.size > 0)
                        {
                            dictMainWordInTranslationLinkGroupsByTextIndexToSet = locallyStoredMainWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter
                        }

                        if(locallyStoredMainPrepositionWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter !== null && 
                            locallyStoredMainPrepositionWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter.size > 0)
                        {
                            dictMainPrepositionWordInTranslationLinkGroupsByTextIndexToSet = locallyStoredMainPrepositionWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter
                        }

                        if(locallyStoredMainSuffixWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter !== null && 
                            locallyStoredMainSuffixWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter.size > 0)
                        {
                            dictMainSuffixWordInTranslationLinkGroupsByTextIndexToSet = locallyStoredMainSuffixWordInTranslationLinkGroupsByTextIndexDictionaryForThisChapter
                        }

                        this.setState({listTranslationWordIndexLinks: listTranslationWordIndexLinksToSet})
                        this.setState({listOurTranslationLines: listOurTranslationLinesToSet})
                        this.setState({listDevelopmentRepetitionGroupsByChapter: listDevelopmentRepetitionGroupsByChapterToSet})
                        this.setState({listDevelopmentRepetitionDescsForGroupsByChapter: listDevelopmentRepetitionDescsForGroupsByChapterToSet})
                        this.setState({dictMainWordInTranslationLinkGroupsByTextIndex: dictMainWordInTranslationLinkGroupsByTextIndexToSet})
                        this.setState({dictMainPrepositionWordInTranslationLinkGroupsByTextIndex: dictMainPrepositionWordInTranslationLinkGroupsByTextIndexToSet})
                        this.setState({dictMainSuffixWordInTranslationLinkGroupsByTextIndex: dictMainSuffixWordInTranslationLinkGroupsByTextIndexToSet})

                        fetch("CorrespondenceData/correspondences_" + sFileBasicName + ".json")
                        .then(res => res.json())
                        .then(data => 
                        {
                            var listCorrespondencesForChapterToSet = data.Correspondences
                            var locallyStoredCorrespondences = this.LoadRepetitionLinkGroupsByChapter(nBook, nChapter)

                            if(locallyStoredCorrespondences !== null && locallyStoredCorrespondences.length > 0)
                            {
                                listCorrespondencesForChapterToSet = locallyStoredCorrespondences
                            }

                            this.listCorrespondencesForChapter = listCorrespondencesForChapterToSet
                            this.setState({listRepetitionLinkGroups: listCorrespondencesForChapterToSet})
                            //this.setState({blnShowInterlinear: false})
                            //this.setState({blnShowOurTranslation: true})

                            this.SetLines(listLinesToSet)
                            this.SetWordGroupsForEnabledLenses()

                            //must do this after SetWordGroupsForEnabledLenses
                            if(this.ShowingDevelopmentDiagram())
                            {
                                this.GenerateDevelopmentDiagramForChapter(nChapter.toString(), this.state.sDevelopmentDiagramLanguage, listLinesToSet)
                            }
                        })
                    })
                }
                else
                {
                    this.setState({listTranslationWordIndexLinks: []})
                    this.setState({listOurTranslationLines: []})
                    this.setState({listDevelopmentRepetitionGroupsByChapter: []})
                    this.setState({listDevelopmentRepetitionDescsForGroupsByChapter: []})
                    this.setState({listRepetitionLinkGroups: []})
                    this.setState({blnShowInterlinear: true})
                    this.setState({blnShowOurTranslation: false})

                    this.SetLines(listLinesToSet)
                    this.SetWordGroupsForEnabledLenses()

                    //must do this after SetWordGroupsForEnabledLenses
                    if(this.ShowingDevelopmentDiagram())
                    {
                        this.GenerateDevelopmentDiagramForChapter(nChapter.toString(), this.state.sDevelopmentDiagramLanguage, listLinesToSet)
                    }
                }

                // if(this.blnChapterIsHebrew && sFileBasicName != "19_119") //remove this constraint once we get everything updated for renaming of these files
                // {
                //     //all the following are links inside of one chapter - they don't make sense in between chapters
                //     if(!blnMultipleChaptersAreBeingFetched)
                //     {
                //         fetch("AllSimilarityData/allsim_" + sFileBasicName + ".json")
                //         .then(res => res.json())
                //         .then(data => 
                //         {
                //             this.listAllSimilarityPairsForChapter = data.Pairs
                //             for(var ospa of this.listAllSimilarityPairsForChapter)
                //             {
                //                 ospa.L.forEach(ospb => ospb.W2 = this.GetWordWithTextIndexInChapter(ospb.B))
                //             }

                //             if(nBook === 19)
                //             {
                //                 fetch("AllSimilarityLinesData/allsimlines_" + sFileBasicName + ".json")
                //                 .then(res => res.json())
                //                 .then(data => 
                //                 {
                //                     this.listAllSimilarityLinePairsForChapter = data.Pairs
                //                     for(var oslpa of this.listAllSimilarityLinePairsForChapter)
                //                     {
                //                         oslpa.Line1 = this.GetLineWithStartAndEndIndexesInChapter(oslpa.A0, oslpa.AE, listLinesToSet)
                //                         oslpa.L.forEach(oslpb => oslpb.Line2 = this.GetLineWithStartAndEndIndexesInChapter(oslpb.B0, oslpb.BE, listLinesToSet))
                //                     }
                                    
                //                     fetch("AllSimilarityStanzasData/allsimstanzas_" + sFileBasicName + ".json")
                //                     .then(res => res.json())
                //                     .then(data => 
                //                     {
                //                         this.listAllSimilarityStanzaPairsForChapter = data.Pairs
                //                         for(var osspa of this.listAllSimilarityStanzaPairsForChapter)
                //                         {
                //                             osspa.ListWords1 = this.GetWordsInTextIndexRangeInChapter(osspa.A0, osspa.AE)
                //                             osspa.L.forEach(osspb => osspb.ListWords2 = this.GetWordsInTextIndexRangeInChapter(osspb.B0, osspb.BE))
                //                         }
                                        
                //                         if(nBook === 19) //remove this constraint if we generate these files
                //                         {
                //                             fetch("RootCooccurrencesData/rootcooccs_" + sFileBasicName + ".json")
                //                             .then(res => res.json())
                //                             .then(data => 
                //                             {
                //                                 this.listRootCooccurrenceDataForChapter = data.Data

                //                                 fetch("SimilarityScoreData/simscores_" + sFileBasicName + ".json")
                //                                 .then(res => res.json())
                //                                 .then(data => 
                //                                 {
                //                                     this.listSimScoreDataForChapter = data.Data
                //                                 })
                //                             })
                //                         }
                //                     })
                //                 })
                //             }
                //         })
                //     }
                // }
                // }
                // else 
                // {
                //     // this.setState({listLines: []})
                //     this.setState({listWordLinkGroups: []})
                //     this.setState({listLineLinkGroups: []})
                //     this.setState({listWordLinkPairs: []})
                //     this.setState({listPropositions: []})
                //     this.setState({listCorrespondencesForChapter: []})
                //     this.setState({listSimScoreDataForChapter: []})
                //     this.setState({listRootCooccurrenceDataForChapter: []})
                // }
            })
		})
		.catch(error => this.setState({ sInfoToShow: error }));
	}

	ShouldConnectSameClauseWordsInNetwork(w1, w2)
	{
		return (this.IsSubject(w1) && this.IsPredicate(w2)) || 
		(this.IsPredicate(w1) && this.IsSubject(w2)) || 
		(this.IsPredicate(w1) && this.IsObject(w2)) || 
		(this.IsObject(w1) && this.IsPredicate(w2)) || 
		(this.IsPredicate(w1) && this.IsPredicateAdjunct(w2)) || 
		(this.IsPredicateAdjunct(w1) && this.IsPredicate(w2)) ||  
		(w1.phrase_function === w2.phrase_function)
	}

	GetSDBHAssociationsText(sType)
	{
		//sType = l, c, or 
		var listAssociations = [];
		var blnUseSDBHDomainsForNodes = false;
		var listClausesToUse = this.listClauses;

		for(var c of listClausesToUse)
		{
			var listWords = c.Words;
			for (var nWord1 = 0; nWord1 < listWords.length - 1; nWord1++)
			{
				var word1 = listWords[nWord1];
				for (var nWord2 = nWord1 + 1; nWord2 < listWords.length; nWord2++)
				{
					var word2 = listWords[nWord2];

					if(this.ShouldConnectSameClauseWordsInNetwork(word1, word2))
					{
						if(blnUseSDBHDomainsForNodes)
						{
							for(var domainForWord1 of this.FindSDBHDomainsForWord(word1, sType))
							{
								for(var domainForWord2 of this.FindSDBHDomainsForWord(word2, sType))
								{
									var existingOne = listAssociations.find(n => n.Domains.includes(domainForWord1.Name) && n.Domains.includes(domainForWord2.Name));
									if(existingOne != undefined)
									{
										existingOne.Words.push(word1);
										existingOne.Words.push(word2);
										existingOne.Count += 1;
									}
									else
										listAssociations.push({Domains: [domainForWord1.Name, domainForWord2.Name], Words: [word1, word2], Count: 1});
								}
							}

							// for(var nodeForWord of this.FindSDBHDomainsForWord(w, this.state.sSDBHDomainTypeForNetwork))
							// {
							// 	var existingNode = listNodes.find(n => n.label === nodeForWord.Name);
							// 	if(existingNode != undefined)
							// 		existingNode.Words.push(w);
							// 	else
							// 		listNodes.push({id: nCurrentNodeID, label: nodeForWord.Name, SemanticNode: nodeForWord, Words: [w]});
							// 	nCurrentNodeID++;
							// }
						}
						else
						{
							var wordTag1 = this.GetWordTagForWord(word1)
							var wordTag2 = this.GetWordTagForWord(word2)

							for(var nodeForWord1 of this.state.listSemanticNodes.filter(n => wordTag1.SemanticCategoryIDs.includes(n.ID)))
							{
								for(var nodeForWord2 of this.state.listSemanticNodes.filter(n => wordTag2.SemanticCategoryIDs.includes(n.ID)))
								{
									var existingOne = listAssociations.find(n => n.Domains.includes(nodeForWord1.Names) && n.Domains.includes(nodeForWord2.Names));
									if(existingOne != undefined)
									{
										existingOne.Words.push(word1);
										existingOne.Words.push(word2);
										existingOne.Count += 1;
									}
									else
										listAssociations.push({Domains: [nodeForWord1.Names, nodeForWord2.Names], Words: [word1, word2], Count: 1});
								}
							}

							// for(var nodeForWord of this.state.listSemanticNodes.filter(n => wordTag.SemanticCategoryIDs.includes(n.ID)))
							// {
							// 	var existingNode = listNodes.find(n => n.label === nodeForWord.Names);
							// 	if(existingNode != undefined)
							// 		existingNode.Words.push(w);
							// 	else
							// 		listNodes.push({id: nCurrentNodeID, label: nodeForWord.Names, SemanticNode: nodeForWord, Words: [w]});
							// 	nCurrentNodeID++;
							// }
						}
					}
				}
			}
		}

		return listAssociations.map(o => o.Domains.join(" - ") + " " + o.Count).join("\n")


		// sSyntacticConnections = listSyntacticConnections.length === 0 ? "" : 
		// 	'Same Clause: ' + listSyntacticConnections.map(c => 
		// 		c.Words.map(w => w.FullText).join(" ") + 
		// 		c.Words.map(w => this.GetTranslationForWord(w, " ")).join(" ")).join(", ");
	}

	NetworkShouldBeVisible()
	{
		return this.state.blnShowNetwork //this.state.nSelectedSpecialGraphID === this.nSpecialGraphIDForNetwork;
	}

	TagCheckboxesShouldBeDisabled()
	{
		return !this.state.blnShowLineCheckboxes //!(this.blnDevView && this.state.blnShowLineCheckboxes) || this.state.nSelectedToolID === null || this.state.nSelectedToolID === 0;
	}

	TestNodeArranging()
	{
		var listNodes = [];
		
		var nY = 20;
		var n = 1;
		for(var l of this.state.listLines)
		{
			var nX = 100;
			for(var w of l.Words)
			{
				listNodes.push(({id: n, label: w.FullText, Words: [w], x: nX, y: nY}));
				nX -= 60;
				n++;
			}
			nY += 30;
		}

		var listEdges = this.state.listWordLinkGroups.map(o => ({
			from: listNodes.find(n => n.Words.includes(o.Objects[0])).id, 
			to: listNodes.find(n => n.Words.includes(o.Objects[1])).id, color: "blue"}));

		var options = { physics: false, nodes: {shape: 'box', borderWidth: 0, color: 'white', font: {face: "SBL Hebrew", size: 22, strokeColor: 'black', bold: "true"}}};
		var NetworkGraphData = { nodes: new DataSet(listNodes), edges: new DataSet(listEdges) };
		this.network = new Network(this.networkDivRef.current, NetworkGraphData, options);
		
		this.network.on('afterDrawing', (obj) => {
			console.log(obj);
		});
	}

    ShowNetworkGraph()
	{
        if(!this.NetworkShouldBeVisible()) return

		var sMode = this.state.networkMode

		var options = sMode === "semanticnode" ? { interaction: { multiselect: true, selectConnectedEdges: true}, physics: {barnesHut: {avoidOverlap: 3}}} :
			{ interaction: { multiselect: true, selectConnectedEdges: false}, physics: true,
			nodes: {shape: 'box', borderWidth: 0, color: 'white', font: {face: "Calibri" , size: 16, strokeColor: 'black', bold: "true"}},
			layout: {hierarchical: {enabled: true, sortMethod: "directed", levelSeparation: 40 }}};  //hubsize
			
        var listLinesByBreakGroup = this.GetLinesByBreakGroup(this.state.listLines, this.state.sGroupLinesBy)

        var listNodes = listLinesByBreakGroup.map((listLines, n) => ({id: n, Lines: listLines, label: n.toString()}))
        var listEdges = []
        // var listEdges = listLinesByBreakGroup.map((listLines, n, arr) => ({from: n, to: n === arr.length - 1 ? 0 : (n + 1), color: 'blue'}))
        
        for(var nUnit1 = 0; nUnit1 < listLinesByBreakGroup.length; nUnit1++)
        {
            for(var nUnit2 = 0; nUnit2 < listLinesByBreakGroup.length; nUnit2++)
            {
                if(nUnit1 === nUnit2 || listEdges.some(o => o.from === nUnit2 && o.to === nUnit1)) continue

                var listLinesUnit1 = listLinesByBreakGroup[nUnit1]
                var listLinesUnit2 = listLinesByBreakGroup[nUnit2]

                var listWordPairs = this.WordPairsAcrossLists(listLinesUnit1.flatMap(l => l.Words), listLinesUnit2.flatMap(l => l.Words), '', '', -1, '')
                listEdges.push({from: nUnit1, to: nUnit2, color: 'green', value: listWordPairs.length})
                // listEdges = listEdges.concat(listWordPairs.map(o => ({from: nUnit1, to: nUnit2, color: 'green', Words: o.ListWords})))
            }
        }
        
        // console.log(listNodes, listEdges)
            // AllUnitLinksLens(blnShowRepeatedWordsNotIncludedHere)
            
            // var listWordPairs = this.WordPairsAcrossLists(o.BeginningWords, o.EndingWords, 'Blue', 'Intraunit Bookends')
            
        // var listNodes = this.listClauses.map((c, index) => ({id: index, Words: c.Words,
        //     label: (index + 1) + " " + this.GetTextForListOfWordsWithTranslationOrNot(c.Words, blnTranslated), 
        //     title: this.GetTextForListOfWordsWithTranslationOrNot(c.Words, !blnTranslated)}))

        // listEdges.push({from: n1.id, to: n2.id, color: "blue",
        //     title: nSemanticScore, 
        //     value: nSemanticScore, length: nSemanticScore * nEdgeLengthScalingFactorForSemantic, scaling: { min: 1, max: 8}})

        var NetworkGraphData = {nodes: new DataSet(listNodes), edges: new DataSet(listEdges)};
        this.network = new Network(this.networkDivRef.current, NetworkGraphData, options);
        
        // this.network.on("selectNode", 
        //     (obj) => { this.setState({listGraphTextIndicesToHighlight: 
        //         obj.nodes.map(nID => listNodes.find(n2 => n2.id === nID).Words
        //         .map(w => ({ TextIndex: w.TextIndex, BorderColor: "black"}))).flat()}) });	

        // this.network.on("selectEdge", 
        //     (obj) => { 
        //         var fromNodes = obj.edges.map(nID => listEdges.find(n2 => n2.id === nID).from).map(nodeID => listNodes.find(lni => lni.id === nodeID));
        //         var toNodes = obj.edges.map(nID => listEdges.find(n2 => n2.id === nID).to).map(nodeID => listNodes.find(lni => lni.id === nodeID));
                
        //         this.setState({listGraphTextIndicesToHighlight: fromNodes.concat(toNodes).map(n => n.Words
        //         .map(w => ({ TextIndex: w.TextIndex, BorderColor: "black"}))).flat()}) });

        this.network.on("stabilizationIterationsDone", () => this.network.setOptions( { physics: false }))
    }

	ShowNetworkGraphOld()
	{
		var sMode = this.state.networkMode; //semanticnode, clause, line, pgrp, cluster
		var blnTranslated = this.state.blnTranslateNetworkNodes;
		var blnUseSDBHDomainsForNodes = false;
		var blnUseUserAddedSemanticNodes = true;

		var blnShowSemanticLinks = this.state.listNetworkConnectionsToShow.includes("sem");
		var blnShowSyntacticLinks = this.state.listNetworkConnectionsToShow.includes("syn");
		var blnShowMorphologicalLinks = false;
		var blnShowPhonologicalLinks = this.state.listNetworkConnectionsToShow.includes("phon");
		var blnShowPGroupLinks = this.state.listNetworkConnectionsToShow.includes("pgrp");
		var blnShowWordandLineLinks = this.state.listNetworkConnectionsToShow.includes("links");
		var blnShowSameParticipantLinks = this.state.listNetworkConnectionsToShow.includes("sameparticipant");

		var nMaxLinkDistance = this.state.nMaxLinkDistanceForNetworkSemanticLink;
		var nEdgeLengthScalingFactorForSemantic = 100;
		var nEdgeLengthScalingFactorForSyntactic = 500;
		var nEdgeValueScalingFactorForSyntactic = 0.1;
		//var nEdgeLengthScalingFactorForPhonological = 10;
		var nComparingWordListsSemanticScoreCutoff = 0.4;
		var nMinSameConsonantsForALink = this.state.nMinSameConsonantsForNetworkPhonoLink;

		var listNodes = [];
		var listEdges = [];

		var options = sMode === "semanticnode" ? { interaction: { multiselect: true, selectConnectedEdges: true}, physics: {barnesHut: {avoidOverlap: 0.5}}} :
			{ interaction: { multiselect: true, selectConnectedEdges: false}, physics: true,
			nodes: {shape: 'box', borderWidth: 0, color: 'white', font: {face: blnTranslated ? "Calibri" : "SBL Hebrew", size: blnTranslated ? 16 : 22, strokeColor: 'black', bold: "true"}},
			layout: {hierarchical: {enabled: true, sortMethod: "directed", levelSeparation: 40 }}};  //hubsize
			
		if(sMode === "clause")
		{
			var listNodes = this.listClauses.map((c, index) => ({id: index, Words: c.Words,
				label: (index + 1) + " " + this.GetTextForListOfWordsWithTranslationOrNot(c.Words, blnTranslated), 
				title: this.GetTextForListOfWordsWithTranslationOrNot(c.Words, !blnTranslated)}));
		}
		else if(sMode === "line")
		{
			var listNodes = this.state.listLines.map((l, index) => ({id: index, Words: l.Words,
				label: (index + 1) + " " + this.GetTextForListOfWordsWithTranslationOrNot(l.Words, blnTranslated), 
				title: this.GetTextForListOfWordsWithTranslationOrNot(l.Words, !blnTranslated)}));
		}
		else if(sMode === "pgrp")
		{
			var listNodes = this.listRepetitionGroups.map((g, index) => ({id: index, Words: g.Lines.flatMap(l => l.Words), 
				label: (index + 1) + " " + this.GetTextForListOfWordsWithTranslationOrNot(g.Lines[0].Words, blnTranslated), 
				title: this.GetTextForListOfWordsWithTranslationOrNot(g.Lines[0].Words, !blnTranslated)}));
		}
		else if(sMode === "semanticnode")
		{
			var nCurrentNodeID = 1;
			for (var nWord = 0; nWord < this.listTextWordsForChapter.length - 1; nWord++)
			{
				var w = this.listTextWordsForChapter[nWord];

				if(blnUseSDBHDomainsForNodes)
				{
					for(var nodeForWord of this.FindSDBHDomainsForWord(w, this.state.sSDBHDomainTypeForNetwork))
					{
						var existingNode = listNodes.find(n => n.label === nodeForWord.Name);
						if(existingNode != undefined)
							existingNode.Words.push(w);
						else
							listNodes.push({id: nCurrentNodeID, label: nodeForWord.Name, SemanticNode: nodeForWord, Words: [w]});
						nCurrentNodeID++;
					}
				}
				else if(blnUseUserAddedSemanticNodes)
				{
					var wordTag = this.GetWordTagForWord(w)
					for(var nodeForWord of this.state.listSemanticNodes.filter(n => wordTag.SemanticCategoryIDs.includes(n.ID)))
					{
						var existingNode = listNodes.find(n => n.label === nodeForWord.Names);
						if(existingNode != undefined)
							existingNode.Words.push(w);
						else
							listNodes.push({id: nCurrentNodeID, label: nodeForWord.Names, SemanticNode: nodeForWord, Words: [w]});
						nCurrentNodeID++;
					}
				}
				else
				{
					for(var nodeForWord of this.FindNodesForWord(w))
					{
						var existingNode = listNodes.find(n => n.label === nodeForWord.Names);
						if(existingNode != undefined)
							existingNode.Words.push(w);
						else
							listNodes.push({id: nCurrentNodeID, label: nodeForWord.Names, SemanticNode: nodeForWord, Words: [w]});
						nCurrentNodeID++;
					}
				}
			}

			listNodes.forEach(n => {n.value = n.Words.length; 
				n.title = n.Words.map(w => this.GetGraphPopoverHintForWord(w, false)).join(" ");
				n.scaling = {label: {enabled: true, min: 20, max: 50}}});
		}

		//put an invisible link between lines so the hierarchical arranger includes them all.
		if(sMode != "semanticnode")
			for (var nNode = 0; nNode < listNodes.length - 1; nNode++)
				listEdges.push({from: listNodes[nNode].id, to: listNodes[nNode + 1].id, color: "white"});
		
		for (var nNode1 = 0; nNode1 < listNodes.length - 1; nNode1++)
		{
			var n1 = listNodes[nNode1];
			for (var nNode2 = nNode1 + 1; nNode2 < listNodes.length; nNode2++)
			{
				var n2 = listNodes[nNode2];

				var listCharLinks = [];
				if(blnShowPhonologicalLinks)
				{
					for(var w1 of n1.Words)
					{
						for(var w2 of n2.Words)
						{
							if(w1 === w2) continue;

							//TODO: distinguish mater lectiones from consonant uses of waw and yod?
							//do vowels, too, and have separate thresholds nMinSameVowelsForALink (count mater lectiones as vowels)
							var w1Consonants = [...new Set(Array.from(w1.FullText).filter(c => this.IsConsonant(c)))]; // && c != "י" && c != "ו");
							var w2Consonants = [...new Set(Array.from(w2.FullText).filter(c => this.IsConsonant(c)))]; //&& c != "י" && c != "ו");				
							var nNumberOfSameChars = w1Consonants.filter(c => w2Consonants.includes(c)).length;

							if(nNumberOfSameChars >= nMinSameConsonantsForALink)
								listCharLinks.push({Word1: w1, Word2: w2, SharedLetters: nNumberOfSameChars, 
									Distance: Math.abs(parseInt(w1.TextIndex) - parseInt(w2.TextIndex))});
						}
					}

					if(listCharLinks.length > 0)
					{
						//var nAverageDistanceInWords = listCharLinks.reduce((acc, l) => acc + l.Distance, 0) / listCharLinks.length;
						// var nTotalDistanceFactor = listCharLinks
						// 	.reduce((acc, l) => acc + (1.0 - (l.Distance / this.listTextWordsForChapter.length)), 0);
						var nTotalDistanceFactor = listCharLinks
							.reduce((acc, l) => acc + (this.listTextWordsForChapter.length / l.Distance), 0);
						listEdges.push({from: n1.id, to: n2.id, color: "hsl(43, 80%, 40%)", 
							title: listCharLinks.map(l => this.GetGraphPopoverHintForWord(l.Word1) + " - " + this.GetGraphPopoverHintForWord(l.Word2) + " " + l.Distance).join(", "), 
							value: 1 + nTotalDistanceFactor, scaling: { min: 1, max: 8}});
					}
				}

				var listSyntacticConnections = [];
				var sSyntacticConnections = "";
				if(sMode != "semanticnode")
				{
					nEdgeValueScalingFactorForSyntactic = 0.3;
					var sPF1 = this.GetPhraseFunctionOrdering(n1.Words);
					var sPF2 = this.GetPhraseFunctionOrdering(n2.Words);

					if(sPF1 === sPF2)
						listSyntacticConnections.push(1);
				}
				else
				{
					//s-v, v-o, same phrase, v-time, v-loca
					listSyntacticConnections = !blnShowSyntacticLinks ? [] : 
					this.listClauses.filter(c => {
						var listWordsInClauseForNode1 = c.Words.filter(cw => n1.Words.includes(cw));
						var listWordsInClauseForNode2 = c.Words.filter(cw => n2.Words.includes(cw));
						
						return listWordsInClauseForNode1.some(cw1 => listWordsInClauseForNode2.some(cw2 => cw1 != cw2 &&
								this.ShouldConnectSameClauseWordsInNetwork(cw1, cw2)))
					});
						// n1.Words.some(w1 => c.Words.includes(w1) && this.IsMainPhraseFunction(w1)) && 
						// n2.Words.some(w2 => c.Words.includes(w2) && this.IsMainPhraseFunction(w2)));
				
					sSyntacticConnections = listSyntacticConnections.length === 0 ? "" : 
						'Same Clause: ' + listSyntacticConnections.map(c => 
							c.Words.map(w => w.FullText).join(" ") + 
							c.Words.map(w => this.GetTranslationForWord(w, " ")).join(" ")).join(", ");
				}

				if(blnShowSemanticLinks)
				{
					if(sMode != "semanticnode")
					{
						nEdgeLengthScalingFactorForSemantic = 10;
						var nSemanticScore = 0;
						for(var w1 of n1.Words)
						{
							for(var w2 of n2.Words)
							{
								if(w1 === w2) continue;
								nSemanticScore += this.CalculateSemanticSimilarity(w1, w2, nMaxLinkDistance).Score;
							}
						}

						nSemanticScore /= Math.min(n1.Words.length, n2.Words.length);
						if(nSemanticScore > nComparingWordListsSemanticScoreCutoff)
							listEdges.push({from: n1.id, to: n2.id, color: "blue",
								title: nSemanticScore, 
								value: nSemanticScore, length: nSemanticScore * nEdgeLengthScalingFactorForSemantic, scaling: { min: 1, max: 8}});
					}
					else
					{
						var result = this.SemanticDistanceBetweenNodes(n1.SemanticNode, n2.SemanticNode, nMaxLinkDistance, true);
						var nLinkDistance = result === undefined ? undefined : result.CurrentLinkDistance;

						if(nLinkDistance != undefined && nLinkDistance <= nMaxLinkDistance)
							listEdges.push({from: n1.id, to: n2.id, color: "blue",
								title: result.LinksTraversed.map(l => this.FindNodeByID(l.node1).Names + "-" + l.type + "-" + this.FindNodeByID(l.node2).Names).join(", ") + " (" + nLinkDistance + ")", 
								value: 1.0 - (nLinkDistance * 0.2), length: nLinkDistance * nEdgeLengthScalingFactorForSemantic, scaling: { min: 1, max: 8}});
					}
				}

				if(blnShowSyntacticLinks)
				{
					if(listSyntacticConnections.length > 0)
						listEdges.push({from: n1.id, to: n2.id, color: "green", title: sSyntacticConnections, 
							value: 0.2 + (listSyntacticConnections.length * nEdgeValueScalingFactorForSyntactic), length: listSyntacticConnections.length * nEdgeLengthScalingFactorForSyntactic, scaling: { min: 1, max: 8}});
				}

				if(blnShowSameParticipantLinks)
				{
					var nParticipantLinksConnections = 0;
					for(var w1 of n1.Words)
					{
						for(var w2 of n2.Words)
						{
							if(w1 === w2) continue;
							
							//connect nodes with words that occur in the same participant repetition group
							nParticipantLinksConnections += this.state.listRepetitionLinkGroups.
								filter(g => g.Type === 2 && g.ListWords.includes(w1.TextIndex) && g.ListWords.includes(w2.TextIndex)).length;
						}
					}

					if(nParticipantLinksConnections > 0)
						listEdges.push({from: n1.id, to: n2.id, color: "purple", title: "Corresponding",
							value: nParticipantLinksConnections, scaling: { min: 1, max: 8}});
				}

				if(blnShowPGroupLinks)
				{
					var nPGroupConnections = 0;
					for(var w1 of n1.Words)
					{
						for(var w2 of n2.Words)
						{
							if(w1 === w2) continue;
							
							//connect nodes with words that occur with the same PGroup value in the same repetition group
							if(this.GetPGroupForWord(w1) != undefined && this.GetPGroupForWord(w1) === this.GetPGroupForWord(w2) &&
							   w1.phrase_atom_number != w2.phrase_atom_number &&
							   this.GetRepetitionGroupForWord(w1, this.state.listLines) === this.GetRepetitionGroupForWord(w2, this.state.listLines))
								nPGroupConnections += 1;
						}
					}

					if(nPGroupConnections > 0)
						listEdges.push({from: n1.id, to: n2.id, color: "purple", title: "Corresponding",
							value: nPGroupConnections, scaling: { min: 1, max: 8}});
				}

				if(blnShowWordandLineLinks)
				{
					var listWordLinkGroupsContainingBoth = this.state.listWordLinkGroups
						.filter(g => g.Objects.some(w => n1.Words.includes(w)) && g.Objects.some(w => n2.Words.includes(w)));

					var listLineLinkGroupsContainingBoth = this.state.listLineLinkGroups
						.filter(g => g.Objects.some(l => l.Words.some(w => n1.Words.includes(w))) && g.Objects.some(l => l.Words.some(w => n2.Words.includes(w))));

					if(listWordLinkGroupsContainingBoth.length > 0)
					{
						listEdges.push({from: n1.id, to: n2.id, color: "purple", //shadow: {enabled: true, size: 3}, smooth: { type: "curvedCW", roundness: 1.0 },
							title: listWordLinkGroupsContainingBoth.map(g => g.Objects.filter(w => n1.Words.includes(w) || n2.Words.includes(w)).map(w => w.FullText).join("-")).join(", "), 
							value: 0.2 + listWordLinkGroupsContainingBoth.length, scaling: { min: 1, max: 10}});
					}

					if(listLineLinkGroupsContainingBoth.length > 0)
					{
						listEdges.push({from: n1.id, to: n2.id, color: "magenta", 
							title: listLineLinkGroupsContainingBoth.map(g => g.Objects.filter(l => l.Words.some(w => n1.Words.includes(w)) || l.Words.some(w => n2.Words.includes(w))).flatMap(l => l.Words.map(w => w.FullText)).join("-")).join(", "), 
							value: 0.2 + listLineLinkGroupsContainingBoth.length, scaling: { min: 1, max: 10}});
					}
				}
			}
		}

		var NetworkGraphData = {nodes: new DataSet(listNodes), edges: new DataSet(listEdges)};
		this.network = new Network(this.networkDivRef.current, NetworkGraphData, options);
		
		this.network.on("selectNode", 
			(obj) => { this.setState({listGraphTextIndicesToHighlight: 
				obj.nodes.map(nID => listNodes.find(n2 => n2.id === nID).Words
				.map(w => ({ TextIndex: w.TextIndex, BorderColor: "black"}))).flat()}) });	

		this.network.on("selectEdge", 
			(obj) => { 
				var fromNodes = obj.edges.map(nID => listEdges.find(n2 => n2.id === nID).from).map(nodeID => listNodes.find(lni => lni.id === nodeID));
				var toNodes = obj.edges.map(nID => listEdges.find(n2 => n2.id === nID).to).map(nodeID => listNodes.find(lni => lni.id === nodeID));
				
				this.setState({listGraphTextIndicesToHighlight: fromNodes.concat(toNodes).map(n => n.Words
				.map(w => ({ TextIndex: w.TextIndex, BorderColor: "black"}))).flat()}) });

		this.network.on("stabilizationIterationsDone", () => this.network.setOptions( { physics: false }));
		// this.network.on("click", (obj) => { 
			
		// });
	}

	// neighbourhoodHighlight(params) {
    //     // if something is selected:
    //     if (params.nodes.length > 0) {
    //       highlightActive = true;
    //       var i, j;
    //       var selectedNode = params.nodes[0];
    //       var degrees = 2;

    //       // mark all nodes as hard to read.
    //       for (var nodeId in allNodes) {
    //         allNodes[nodeId].color = "rgba(200,200,200,0.5)";
    //         if (allNodes[nodeId].hiddenLabel === undefined) {
    //           allNodes[nodeId].hiddenLabel = allNodes[nodeId].label;
    //           allNodes[nodeId].label = undefined;
    //         }
    //       }
    //       var connectedNodes = this.network.getConnectedNodes(selectedNode);
    //       var allConnectedNodes = [];

    //       // get the second degree nodes
    //       for (i = 1; i < degrees; i++) {
    //         for (j = 0; j < connectedNodes.length; j++) {
    //           allConnectedNodes = allConnectedNodes.concat(
    //             this.network.getConnectedNodes(connectedNodes[j])
    //           );
    //         }
    //       }

    //       // all second degree nodes get a different color and their label back
    //       for (i = 0; i < allConnectedNodes.length; i++) {
    //         allNodes[allConnectedNodes[i]].color = "rgba(150,150,150,0.75)";
    //         if (allNodes[allConnectedNodes[i]].hiddenLabel !== undefined) {
    //           allNodes[allConnectedNodes[i]].label =
    //             allNodes[allConnectedNodes[i]].hiddenLabel;
    //           allNodes[allConnectedNodes[i]].hiddenLabel = undefined;
    //         }
    //       }

    //       // all first degree nodes get their own color and their label back
    //       for (i = 0; i < connectedNodes.length; i++) {
    //         allNodes[connectedNodes[i]].color = undefined;
    //         if (allNodes[connectedNodes[i]].hiddenLabel !== undefined) {
    //           allNodes[connectedNodes[i]].label =
    //             allNodes[connectedNodes[i]].hiddenLabel;
    //           allNodes[connectedNodes[i]].hiddenLabel = undefined;
    //         }
    //       }

    //       // the main node gets its own color and its label back.
    //       allNodes[selectedNode].color = undefined;
    //       if (allNodes[selectedNode].hiddenLabel !== undefined) {
    //         allNodes[selectedNode].label = allNodes[selectedNode].hiddenLabel;
    //         allNodes[selectedNode].hiddenLabel = undefined;
    //       }
    //     } else if (highlightActive === true) {
    //       // reset all nodes
    //       for (var nodeId in allNodes) {
    //         allNodes[nodeId].color = undefined;
    //         if (allNodes[nodeId].hiddenLabel !== undefined) {
    //           allNodes[nodeId].label = allNodes[nodeId].hiddenLabel;
    //           allNodes[nodeId].hiddenLabel = undefined;
    //         }
    //       }
    //       highlightActive = false;
    //     }

    //     // transform the object into an array
    //     var updateArray = [];
    //     for (nodeId in allNodes) {
    //       if (allNodes.hasOwnProperty(nodeId)) {
    //         updateArray.push(allNodes[nodeId]);
    //       }
    //     }
    //     nodesDataset.update(updateArray);
	// }

	GetObjectsForLines(listLinesToUse)
	{
		return listLinesToUse.map(l => ({Book: l.Book, Chapter: l.Chapter, IndentLevel: l.IndentLevel, HadRangeGap: l.HadRangeGap,
			TextIndexRangeBegin: l.TextIndexRangeBegin, TextIndexRangeEnd: l.TextIndexRangeEnd, 
			RelationshipToPrevious: l.RelationshipToPrevious, RelationshipToNext: l.RelationshipToNext,
			StartsRepetitionGroup: l.StartsRepetitionGroup, StartsSequenceGroup: l.StartsSequenceGroup,
			NotInGroup: l.NotInGroup, StartsCluster: l.StartsCluster, StartsClusterGroup: l.StartsClusterGroup, StartsLevel4Group: l.StartsLevel4Group,
            IsSuperscription: l.IsSuperscription, IsShortChangeFromPattern: l.IsShortChangeFromPattern,
			FigurativeLanguage: l.FigurativeLanguage, LinkedLinesList: l.LinkedLinesList, UnsureAboutDelineation: l.UnsureAboutDelineation}));
	}

	SaveLines(listLinesToUpdateWith)
	{
		if(!this.state.blnMultipleChaptersSelected) localStorage.setItem("listColaFor" + this.state.nCurrentBook + '_' + this.GetFirstCurrentChapter(), JSON.stringify(this.GetObjectsForLines(listLinesToUpdateWith)));	
	}

	LoadLines(nBook, nChapter)
	{
        var locallyStoredCola = localStorage.getItem("listColaFor" + nBook+ '_' + nChapter);
		if(locallyStoredCola === null) return [];
		else return JSON.parse(locallyStoredCola)
	}

	SortLines(listLinesToSort)
	{
		listLinesToSort.sort((a, b) => parseInt(a.TextIndexRangeEnd) - parseInt(b.TextIndexRangeEnd));
		return listLinesToSort;	
	}

	GetPropositionsForLines(listPropositionsToUse)
	{
		return listPropositionsToUse.map(p => ({IndentLevel: p.IndentLevel, TextIndexes: p.TextIndexes, RoleIDs: p.RoleIDs}));
	}

	SavePropositions(listPropositionsToUpdateWith)
	{
        if(!this.state.blnMultipleChaptersSelected)
        {
            this.setState({listPropositions: listPropositionsToUpdateWith});
            localStorage.setItem("listPropositionsForChapter" + this.GetFirstCurrentChapter(), 
                JSON.stringify(this.GetPropositionsForLines(listPropositionsToUpdateWith)))
        }	
	}

	LoadPropositions(nChapter)
	{
        var locallyStoredCola = localStorage.getItem("listPropositionsForChapter" + nChapter);
		if(locallyStoredCola === null) return [];
		else return JSON.parse(locallyStoredCola);
	}

    LoadTranslations()
	{
        var locallyStoredCola = localStorage.getItem("listTranslations");
		if(locallyStoredCola === null) return [];
		else return JSON.parse(locallyStoredCola);
    }
    
    SaveTranslations(listToSet)
    {
        this.setState({listTranslations: listToSet});
        localStorage.setItem("listTranslations", JSON.stringify(listToSet));	
    }

    // ClearTranslations()
    // {
    //     localStorage.removeItem("listTranslations");	
    // }

    SaveTags(listToSet)
    {
        this.setState({listTags: listToSet});
        //localStorage.setItem("listTags", JSON.stringify(listToSet));	
    }
    
    SaveTagTrees(listToSet)
    {
        this.setState({listTagTrees: listToSet});
        //localStorage.setItem("listTagTrees", JSON.stringify(listToSet));	
    }

	SaveFigures(listToUpdateWith)
	{
		this.setState({ listFigures: listToUpdateWith});
		localStorage.setItem("listFigures", JSON.stringify(listToUpdateWith));	
	}

	LoadFigures()
	{
		var locallyStored = localStorage.getItem("listFigures");
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored);
	}
	
	SaveWordOverrides(listToUpdateWith)
	{
		this.setState({ listWordsOverride: listToUpdateWith});
		localStorage.setItem("listPGroups", JSON.stringify(listToUpdateWith));	
	}

	LoadWordOverrides()
	{
        var locallyStored = localStorage.getItem("listPGroups");
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored);
	}
  
	LoadRepetitionLinkGroupsByChapter(sBook, sChapter)
	{
        ///////localStorage.removeItem("listRepetitionLinkGroups");
        var locallyStored = localStorage.getItem("listRepetitionLinkGroupsFor" + sBook+ '_' + sChapter);
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored);
    }
    
    SaveRepetitionLinkGroupsAndSetState(listToUpdateWith)
	{
		this.setState({listRepetitionLinkGroups: listToUpdateWith}, this.GenerateDevelopmentDiagramForChapterIfShowing())
        this.SaveRepetitionLinkGroups(listToUpdateWith)
	}
	
    SaveRepetitionLinkGroups(listToUpdateWith)
	{
		localStorage.setItem("listRepetitionLinkGroupsFor" + this.state.nCurrentBook + '_' + this.GetFirstCurrentChapter(), JSON.stringify(listToUpdateWith));	
	}

    LoadDevelopmentRepetitionGroupsByChapter(sBook, sChapter)
	{
        ///////localStorage.removeItem("listDevelopmentRepetitionGroupsByChapter");
        var locallyStored = localStorage.getItem("listDevelopmentRepetitionGroupsByChapterFor" + sBook+ '_' + sChapter);
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored);
    }
    
    SaveDevelopmentRepetitionGroupsByChapter(listToUpdateWith)
	{
		this.setState({listDevelopmentRepetitionGroupsByChapter: listToUpdateWith});
		localStorage.setItem("listDevelopmentRepetitionGroupsByChapterFor" + this.state.nCurrentBook + '_' + this.GetFirstCurrentChapter(), JSON.stringify(listToUpdateWith));	
	}
    
    LoadDevelopmentRepetitionDescsForGroupsByChapter(sBook, sChapter)
	{
        ///////localStorage.removeItem("listDevelopmentRepetitionDescsForGroupsByChapter");
        var locallyStored = localStorage.getItem("listDevelopmentRepetitionDescsForGroupsByChapterFor" + sBook+ '_' + sChapter);
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored);
    }
    
    SaveDevelopmentRepetitionDescsForGroupsByChapter(listToUpdateWith)
	{
		this.setState({listDevelopmentRepetitionDescsForGroupsByChapter: listToUpdateWith});
		localStorage.setItem("listDevelopmentRepetitionDescsForGroupsByChapterFor" + this.state.nCurrentBook + '_' + this.GetFirstCurrentChapter(), JSON.stringify(listToUpdateWith));	
	}
    
    LoadTranslationWordIndexLinks(sBook, sChapter)
	{
        //////////localStorage.removeItem("listTranslationWordIndexLinks");
        var locallyStored = localStorage.getItem("listTranslationWordIndexLinksFor" + sBook + '_' + sChapter);
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored);
    }

    SaveTranslationWordIndexLinks(listToUpdateWith)
	{
		this.setState({listTranslationWordIndexLinks: listToUpdateWith});
		localStorage.setItem("listTranslationWordIndexLinksFor" + this.state.nCurrentBook + '_' + this.GetFirstCurrentChapter(), JSON.stringify(listToUpdateWith));	
	}
    
    ChangeDictionarySavedInJSONToMap(o, blnIsJSON)
    {
        if(o === null || o === undefined) 
        {
            return new Map()
        }
        else if(blnIsJSON)
        {
            if(o.length <= 2)
            {
                return new Map()
            }
            else
            {
                return new Map(Object.entries(JSON.parse(o)))
            }
        }
		else 
        {
            return new Map(Object.entries(o))
        }
    }

    LoadMainWordInTranslationLinkGroupsByTextIndexDictionary(sBook, sChapter)
	{
        ///////////localStorage.removeItem("dictMainWordInTranslationLinkGroupsByTextIndexFor" + sBook + '_' + sChapter)
        var locallyStored = localStorage.getItem("dictMainWordInTranslationLinkGroupsByTextIndexFor" + sBook + '_' + sChapter);
        return this.ChangeDictionarySavedInJSONToMap(locallyStored, true)
    }

    SaveMainWordInTranslationLinkGroupsByTextIndexDictionary()
	{
		this.setState({dictMainWordInTranslationLinkGroupsByTextIndex: this.state.dictMainWordInTranslationLinkGroupsByTextIndex});
		localStorage.setItem("dictMainWordInTranslationLinkGroupsByTextIndexFor" + this.state.nCurrentBook + '_' + this.GetFirstCurrentChapter(), JSON.stringify(Object.fromEntries(this.state.dictMainWordInTranslationLinkGroupsByTextIndex)));	
	}

    LoadMainPrepositionWordInTranslationLinkGroupsByTextIndexDictionary(sBook, sChapter)
	{
        ///////////localStorage.removeItem("dictMainPrepositionWordInTranslationLinkGroupsByTextIndexFor" + sBook + '_' + sChapter)
        var locallyStored = localStorage.getItem("dictMainPrepositionWordInTranslationLinkGroupsByTextIndexFor" + sBook + '_' + sChapter);
        return this.ChangeDictionarySavedInJSONToMap(locallyStored, true)
    }

    SaveMainPrepositionWordInTranslationLinkGroupsByTextIndexDictionary()
	{
		this.setState({dictMainPrepositionWordInTranslationLinkGroupsByTextIndex: this.state.dictMainPrepositionWordInTranslationLinkGroupsByTextIndex});
		localStorage.setItem("dictMainPrepositionWordInTranslationLinkGroupsByTextIndexFor" + this.state.nCurrentBook + '_' + this.GetFirstCurrentChapter(), JSON.stringify(Object.fromEntries(this.state.dictMainPrepositionWordInTranslationLinkGroupsByTextIndex)));	
	}

    LoadMainSuffixWordInTranslationLinkGroupsByTextIndexDictionary(sBook, sChapter)
	{
        ///////////localStorage.removeItem("dictMainSuffixWordInTranslationLinkGroupsByTextIndexFor" + sBook + '_' + sChapter)
        var locallyStored = localStorage.getItem("dictMainSuffixWordInTranslationLinkGroupsByTextIndexFor" + sBook + '_' + sChapter);
		return this.ChangeDictionarySavedInJSONToMap(locallyStored, true)
    }

    SaveMainSuffixWordInTranslationLinkGroupsByTextIndexDictionary()
	{
		this.setState({dictMainSuffixWordInTranslationLinkGroupsByTextIndex: this.state.dictMainSuffixWordInTranslationLinkGroupsByTextIndex});
		localStorage.setItem("dictMainSuffixWordInTranslationLinkGroupsByTextIndexFor" + this.state.nCurrentBook + '_' + this.GetFirstCurrentChapter(), JSON.stringify(Object.fromEntries(this.state.dictMainSuffixWordInTranslationLinkGroupsByTextIndex)));	
	}

    LoadOurTranslationLines(sBook, sChapter)
	{
        //////////localStorage.removeItem("listOurTranslationLines");
        var locallyStored = localStorage.getItem("listOurTranslationLinesFor" + sBook+ '_' + sChapter);
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored);
    }

    SaveOurTranslationLines(listToUpdateWith)
	{
		this.setState({listOurTranslationLines: listToUpdateWith});
		localStorage.setItem("listOurTranslationLinesFor" + this.state.nCurrentBook + '_' + this.GetFirstCurrentChapter(), JSON.stringify(listToUpdateWith));	
	}

	LoadWordTags()
	{
        var locallyStored = localStorage.getItem("listWordTags");
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored);
	}
	
	SaveWordTags(listToUpdateWith)
	{
		this.setState({listWordTags: listToUpdateWith});
		localStorage.setItem("listWordTags", JSON.stringify(listToUpdateWith));	
	}

	LoadUserAddedSemanticNodes()
	{
        var locallyStored = localStorage.getItem("listUserAddedSemanticNodes");
		if(locallyStored === null) return [];
		else return JSON.parse(locallyStored);
	}

	AddSemanticNodesAndSave(addedNodes)
	{
		this.listUserAddedSemanticNodes = this.listUserAddedSemanticNodes.concat(addedNodes);
		this.setState({listSemanticNodes: this.state.listSemanticNodes.concat(addedNodes)});
		localStorage.setItem("listUserAddedSemanticNodes", JSON.stringify(this.listUserAddedSemanticNodes));	
	}

    GetRepetitionLinkGroupsForDB()
    {
		//use the below code between --- to get the correspondences broken down by chapters, and then put it through the 
		//SplitCorrespondencesIntoChapters() function in the c# project XMLToJsonConverter
		//-----start
		// fetch("HebrewTextData/allpsalmschapters.json")
		// .then(res => res.json())
		// .then(data => 
		// {
		// 	this.listTextWordsForAllChapters = data.OSHB;

		// 	// var locallyStored = localStorage.getItem("listRepetitionLinkGroups");
		// 	// if(locallyStored === null) return "";
		// 	//var listAllGroups = JSON.parse(locallyStored).filter(o => o.Type === 10);

		// 	var listAllGroups = JSON.parse(locallyStored).filter(o => o.Type === 10);

		// 	var listToReturn = [];
		// 	var textWordsByChapter = this.GroupArrayByKey(this.listTextWordsForAllChapters, "Chapter");
		// 	this.listClausesForAllChapters = new Map();
		// 	for(var sChapterToDo of Object.keys(textWordsByChapter))
		// 	{						
		// 		var listWordIndexesForChapter = textWordsByChapter[sChapterToDo].map(w => w.TextIndex);
		// 		var listGroupsInChapter = listAllGroups.filter(o => o.ListWords.some(s1 => listWordIndexesForChapter.some(s2 => s1 === s2)));

		// 		listToReturn.push("Chapter" + sChapterToDo);
		// 		listToReturn.push(JSON.stringify(listGroupsInChapter));
		// 	}

		// 	//just copy listToReturn.join("\n") from the watch console!
		// })
		//------end

        return localStorage.getItem("listRepetitionLinkGroups");

        // return "ListWords^ListTags^Comment\n" + 
        // this.state.listRepetitionLinkGroups.sort((a,b) => parseInt(a.TextIndex) - parseInt(b.TextIndex))
        // .map(o => o.TextIndex + "^" + o.PGroup + "^" + (o.LinkedWordsList === undefined ? [] : 
        //     o.LinkedWordsList.map(o2 => o2.TextIndex + "~" + o2.Type)).join(",")).join("\n");
    }

    // RestoreRepetitionLinkGroupsFromBackup()
    // {
    //     var RepetitionLinkGroupDataObjects = RepetitionLinkGroupData;
    //     localStorage.setItem("listRepetitionLinkGroups", JSON.stringify(RepetitionLinkGroupDataObjects.RepetitionLinkGroups));
    // }

    // RemoveAllAutoAddedRepetitionLinkGroups()
    // {
    //     var listToChange = this.state.listRepetitionLinkGroups;
    //     listToChange = listToChange.filter(g => !(g.Type === 4 || g.Type === 5));
    //     this.SaveRepetitionLinkGroupsAndSetState(listToChange);
    // }

    AutoAddRepetitionLinkGroups()
    {
        // for(var nChapterToDo of [30])
        // {	
        //     fetch("HebrewTextData/chapter" + nChapterToDo + ".json")
        //     .then(res => res.json())
        //     .then(data => 
        //     {

        var listTextWordsToUse = this.listTextWordsForChapter; //data.OSHB;     
        var listToAddTo = this.state.listRepetitionLinkGroups;
        
        var blnAlreadyHasAutoAdded = listToAddTo.some(g => g.ListWords.some(n => listTextWordsToUse.some(w => w.TextIndex === n)) && (g.Type === 2 || g.Type === 3 || g.Type === 10)); //g.Type === 2 || g.Type === 3 || 
        if(!blnAlreadyHasAutoAdded) 
        {   
			var listWordsForGod = [];
			var listWordsInSameSemanticDomain = [];

            for(var d of this.listMainSemanticDomains)
            {
                //775^אֹ֫רֶךְ^length^95
                var sDomainName = d.Name
                var listLexicalIDsForNode = d.LexicalIDs

                var listWordsForNodeInChapter = listTextWordsToUse.filter(w => listLexicalIDsForNode.some(sID => w.LexicalID === sID)).map(w => w.TextIndex);
                if(listWordsForNodeInChapter.length > 1)
                {
                    var groupToAdd = {ListWords: listWordsForNodeInChapter, ListTags: [{CategoryID: "28", RelationPairReversed: false}], Comment: sDomainName, Type: 3, WordsForWhichParticipantRefIsForSuffix: []};     
                    //listToAddTo.push(groupToAdd);
					listWordsInSameSemanticDomain.push(listWordsForNodeInChapter);

                    if(sDomainName === "God")
                        listWordsForGod = listTextWordsToUse.filter(w => listLexicalIDsForNode.some(sID => w.LexicalID === sID)).map(w => w.TextIndex);
                }
            }

            //1st person is usually Psalmist, 2nd person is usually God, so this will save a lot of clicking, but be sure to check carefully, 
            //since 2nd person is sometimes enemies, and 1st person is sometimes God
			
			//comment the below back in to put participant refs back in.

            // var listFirstPersonWords = listTextWordsToUse.filter(w => w.Person === "1" || w.LexicalID === "612" || w.LexicalID === "618").map(w => w.TextIndex);  
            // var listFirstPersonSuffixWords = listTextWordsToUse.filter(w => w.SuffixPerson === "1").map(w => w.TextIndex);            
            // var groupToAdd = {ListWords: listFirstPersonWords.concat(listFirstPersonSuffixWords), ListTags: [], Comment: sDomainName, Type: 2, WordsForWhichParticipantRefIsForSuffix: listFirstPersonSuffixWords};             
            // listToAddTo.push(groupToAdd);

            // var listSecondPersonWords = listTextWordsToUse.filter(w => w.Person === "2" || w.LexicalID === "880").map(w => w.TextIndex);  
            // var listSecondPersonSuffixWords = listTextWordsToUse.filter(w => w.SuffixPerson === "2").map(w => w.TextIndex);            
            // var groupToAdd = {ListWords: listSecondPersonWords.concat(listSecondPersonSuffixWords).concat(listWordsForGod), ListTags: [], Comment: sDomainName, Type: 2, WordsForWhichParticipantRefIsForSuffix: listSecondPersonSuffixWords};             
            // listToAddTo.push(groupToAdd);

			console.log(listWordsInSameSemanticDomain);

			for(var repgrp of this.listRepetitionGroups)
            {
                for(var sPGroupValue of repgrp.ListPGroupValuesInLineGroup.map(n => n.toString()))
                {
                    //more than one word in group, in more than one line
                    var listLinesThePGroupSpans = repgrp.Lines.filter(l => l.Words.some(w => w.PGroup === sPGroupValue));
					var listWordsInPGroup = repgrp.Lines.flatMap(l => l.Words).filter(w => w.PGroup === sPGroupValue).map(w => w.TextIndex);
					//var listDomainsAcrossLines = repgrp.Lines.map(l => l.Words.flatMap(w => listWordsInSameSemanticDomain.find(g => g.includes(w.TextIndex)))).filter(w => w.PGroup === sPGroupValue).map(w => w.TextIndex);
					
					if(listWordsInPGroup.length > 1 && listLinesThePGroupSpans.length > 1)
                    {
						var listGroupTags = [];
						var blnSameDomain = listWordsInSameSemanticDomain.some(s1 => listWordsInPGroup.filter(s2 => s1 === s2).length > 1);
						if(blnSameDomain) listGroupTags.push({CategoryID:"28", RelationPairReversed:false});

                        var groupToAdd = {ListWords: listWordsInPGroup, ListTags: listGroupTags, Comment: "", Type: 10, WordsForWhichParticipantRefIsForSuffix: []};             
                        listToAddTo.push(groupToAdd);
                    }
                }
            }

            // var listNodesToAdd = ["Measurements: number, degree, size, age, value, new, old","Location: location, direction","Time: timespan, time","creation","human",
            //     "trueGod","idol","eat, drink","body","life, death","government","help","faithfulness","worship, offering","holy","pray","inimity","wellbeing","Bad Being: badbeing, captivity",
            //     "society","statusinsociety","behavior","forgiveness, repentance","Movement and Position: go, enter, exit, stand, sit, seat, takestand",
            //     "Violence: break, tear, cut, hit, trample","material","Mental State: know, rest, sleep, awake","perception","speak","emotion","work","building"];

            // // var listNodesToAdd = ["Location: location, direction","Time: timespan, time","creation",
            // //     "trueGod","idol","behavior","Mental State: know, rest, sleep, awake","perception","speak","emotion"];

            // for(var sNodeName of listNodesToAdd)
            // {
            //     var sDomainName = sNodeName.split(":").length < 2 ? sNodeName : sNodeName.split(":")[0].trim();
            //     var listNodesToSearch = (sNodeName.split(":").length < 2 ? sNodeName : sNodeName.split(":")[1]).trim().split(",").flatMap(s => this.FindNodesByName(s.trim()).map(n => n.ID));
            //     var listNodeIDsToExclude = sNodeName === "creation" ? [this.FindNodesByName("human").map(n => n.ID)] : [];

            //     var listResultingLexicalIDs = [];
            //     for(var node of listNodesToSearch)
            //     {
            //         listResultingLexicalIDs = listResultingLexicalIDs.concat(this.GetAllNodesThatAreTypesOrPartsOfNode(node, listNodeIDsToExclude, [], []));
            //     }

            //     var listLexicalIDsForNode = listResultingLexicalIDs.flat();

            //     var listWordsForNodeInChapter = listTextWordsToUse.filter(w => listLexicalIDsForNode.some(nID => parseInt(w.LexicalID) === nID));
            //     if(listWordsForNodeInChapter.length > 1)
            //     {
            //         var groupToAdd = {ListWords: listWordsForNodeInChapter, ListTags: [{CategoryID: "28", RelationPairReversed: false}], Comment: sDomainName, Type: 5, WordsForWhichParticipantRefIsForSuffix: []};
            //         // groupToAdd.Calculations = this.CalculateRepetitionLinkGroupCategoriesFromWords(
            //         //     listTextWordsToUse.filter(twic => groupToAdd.ListWords.includes(twic.TextIndex)), this.state.listLines); 
                                
            //         listToAddTo.push(groupToAdd);
            //     }
            // }

            // for(var node of this.state.listSemanticNodes)
            // {
            //     var listWordsForNodes = listTextWordsToUse.filter(w => node.LexicalIDs.some(o => o.ID === parseInt(w.LexicalID)));
            //     var listSubnodesToExplore = this.listSemanticLinks.filter(l => l.node1 === node.ID).map(l => this.FindNodeByID(l.node2));

            //     for(var node2 of listSubnodesToExplore)
            //     {
            //         listWordsForNodes = listWordsForNodes.concat(listTextWordsToUse.filter(w => node2.LexicalIDs.some(o => o.ID === parseInt(w.LexicalID))));
            //     }

            //     if(listWordsForNodes.length > 1)
            //     {
            //         var groupToAdd = {ListWords: listWordsForNodes.map(w => w.TextIndex), ListTags: [{CategoryID: "28", RelationPairReversed: false}], Comment: node.Names, Type: 5, WordsForWhichParticipantRefIsForSuffix: []};
            //         // groupToAdd.Calculations = this.CalculateRepetitionLinkGroupCategoriesFromWords(
            //         //     listTextWordsToUse.filter(twic => groupToAdd.ListWords.includes(twic.TextIndex)), this.state.listLines); 
                                
            //         listToAddTo.push(groupToAdd);
            //     }
            // }

            this.SaveRepetitionLinkGroupsAndSetState(listToAddTo);
        }
        //     })
        // }
    }

	CreateWordTagsForChapter()
	{
		if(this.listTextWordsForAllChapters.length === 0) return;
		
		var listTextWordsToUse = this.listTextWordsForChapter;     
        var listToAddTo = this.state.listWordTags;
        
		var blnAlreadyAdded = listToAddTo.some(o => listTextWordsToUse.some(w => w.TextIndex === o.TextIndex));
		if(!blnAlreadyAdded)
        {   
			for(var w of listTextWordsToUse)
			{
				//{TextIndex: , SemanticRoles:[{RoleID: 1, IsForSuffix: true}] , SemanticCategoryIDs: [1]}
				//"LexicalIDs":[{"ID":4262},{"ID":1478}]
				//var listSemanticRoles = [];

				//check the other word tag for the lexicalid for the word and associate the most frequent one of that instead of the semantic node. 
				var listSemanticIDsFromTagsGrouped = this.state.listWordTags.filter(tag => 
					this.listTextWordsForAllChapters.find(w => w.TextIndex === tag.TextIndex).LexicalID === w.LexicalID).
					flatMap(tag => tag.SemanticCategoryIDs).
					reduce((acc, n) =>
					{
						var currentValue = n;
						if (!acc[currentValue]) acc[currentValue] = [];
						acc[currentValue].push(n);
						return acc;
					}, {});
					
				var listSemanticIDsFromTagsGroupedAndSortedByFrequency = 
					Object.keys(listSemanticIDsFromTagsGrouped).filter(n => n !== "null").sort((a,b) => 
						listSemanticIDsFromTagsGrouped[b][0].length - listSemanticIDsFromTagsGrouped[a][0].length);

				var listSemanticIDs = listSemanticIDsFromTagsGroupedAndSortedByFrequency.length === 0 ? [] : 
					[parseInt(listSemanticIDsFromTagsGroupedAndSortedByFrequency[0])];

				//if there are none, check the semantic nodes 
				if(listSemanticIDs.length === 0)
					listSemanticIDs = this.state.listSemanticNodes.filter(node => node.LexicalIDs.some(o => o.ID === parseInt(w.LexicalID))).map(node => node.ID);

				//if it isn't there or in the semantic nodes, check for same ParentRoot
				// if(listSemanticIDs.length === 0)
				// 	listSemanticIDs = this.state.listWordTags.filter(tag => 
				// 		this.listTextWordsForAllChapters.find(w => w.TextIndex === tag.TextIndex).ParentRoot === w.ParentRoot).flatMap(tag => tag.SemanticCategoryIDs);
			
				listToAddTo.push({TextIndex: w.TextIndex, SemanticRoles: [], SemanticCategoryIDs: [...new Set(listSemanticIDs)]});
			}

			this.SaveWordTags(listToAddTo);

			// var listPropositionsToUse = this.state.listPropositions;
			// this.listClauses.forEach(c => listPropositionsToUse.push({TextIndexes: c.Words.map(w => w.TextIndex), IndentLevel: 0, RoleIDs: [], Words: c.Words}));
			// this.SavePropositions(listPropositionsToUse);
		}
	}

    // UpdatePGroupAlreadySavedToNewStructure()
    // {
    //     var locallyStored = localStorage.getItem("listPGroups");
    //     if(locallyStored === null) return;
        
    //     var listToFix = JSON.parse(locallyStored);
    //     for(var o of listToFix.filter(o2 => o2.LinkedWordsList != undefined))
    //     {
    //         var listTextIndicesLinked = o.LinkedWordsList;
    //         o.LinkedWordsList = listTextIndicesLinked.map(sTextIndex => ({TextIndex: sTextIndex, Type: "?"}));
    //     }
    //     localStorage.setItem("listPGroups", JSON.stringify(listToFix));	
    // }

	GetPGroupForWord(w)
	{
        //to disable local override, uncomment the line below and comment the rest of the function
        //return w.PGroup;

        //to restore local override, uncomment below
		var localOverride = this.state.listWordsOverride.find(w2 => w2.TextIndex === w.TextIndex);
		return (localOverride === undefined || localOverride.PGroup === undefined) ? w.PGroup : localOverride.PGroup;	
	}	

	GetLinkedWordsListForWord(w)
	{
        //to disable local override, uncomment the line below and comment the rest of the function
        //return w.LinkedWords === undefined ? undefined : w.LinkedWords.split(",").map(s => ({TextIndex: s.split("~")[0], Type: "" }));

        //to restore local override, uncomment below
		var localOverride = this.state.listWordsOverride.find(w2 => w2.TextIndex === w.TextIndex);
        return localOverride === undefined ? 
         (w.LinkedWords === undefined ? undefined : w.LinkedWords.split(",").map(s => ({TextIndex: s.split("~")[0], Type: "" }))) : 
         localOverride.LinkedWordsList;	
	}	
	
	GetLinkedLinesListForLine(l)
	{
        var localOverride = this.state.listLines.find(l2 => l2.TextIndexRangeEnd === l.TextIndexRangeEnd);
        var sListLines = localOverride === undefined ? (l.LinkedLinesList === undefined ? "" : l.LinkedLinesList) : localOverride.LinkedLinesList;
		return sListLines === undefined ? undefined : sListLines.split(",");
	}	

    CalculateWordLinkPairs()
    {
        var listWords = this.listTextWordsForChapter;
        var listToReturn = [];
        for(var w of listWords)
        {
            var listLinks = this.GetLinkedWordsListForWord(w);
			if(listLinks === undefined || listLinks.length === 0) continue;

            listToReturn = listToReturn.concat(
                listLinks.map(link => ({Word1: w, Word2: listWords.find(w2 => w2.TextIndex === link.TextIndex), LinkType: link.Type})));
        }
        return listToReturn;
    }

	CalculateObjectLinkGroupsFromObjectList(listObjects, objType)
	{
		var listToReturn = [];
		var nColorIndex = 0;
		for(var o1 of listObjects)
		{
			var groupWithObject1 = listToReturn.find(o => o.Objects.includes(o1));

			var listLinks = objType === "line" ? this.GetLinkedLinesListForLine(o1) : this.GetLinkedWordsListForWord(o1);
			if(listLinks === undefined || listLinks.length === 0) continue;

            // if(objType === "line")
            // {
            // console.log("Links");
            // console.log(listLinks);
            // }

			var listLinkedObjects = 
				listLinks.map(link => listObjects.find(o2 => objType === "line" ? o2.TextIndexRangeEnd === link : o2.TextIndex === link.TextIndex));

			for(var o2 of listLinkedObjects)
			{
				if(o2 === undefined) continue;
				var groupWithObject2 = listToReturn.find(o => o.Objects.includes(o2));

				if(groupWithObject1 === undefined && groupWithObject2 === undefined)
					listToReturn.push({Objects: [o1, o2], Color: this.listLinkGroupColors[nColorIndex % this.listLinkGroupColors.length]});
				else if(groupWithObject1 === undefined)
					groupWithObject2.Objects.push(o1);
				else if(groupWithObject2 === undefined)
					groupWithObject1.Objects.push(o2);
			}

			nColorIndex++;
		}
		return listToReturn;
	}

	FillChapters()
	{
		this.listClauses = this.CalculateClauses(this.listTextWordsForChapter);

		var nLastVerse = this.listTextWordsForChapter[0].Verse;
		var nLastPhraseNumber = this.listTextWordsForChapter[0].phrase_atom_number;
		var nLastSentenceNumber = this.listTextWordsForChapter[0].sentence_atom_number;

		var listVerseBeginNumbersAndWordsToSet = [{Word: this.listTextWordsForChapter[0], VerseNumber: 1}]
		var listVerseEndIndexesToSet = [];
		var listSentenceEndIndexesToSet = [];
		var listPhraseEndIndexesToSet = [];

		for(const w of this.listTextWordsForChapter)
		{
			if(w.Verse !== nLastVerse)
			{
				listVerseEndIndexesToSet.push(parseInt(w.TextIndex) - 1);
				listVerseBeginNumbersAndWordsToSet.push({ Word: w, VerseNumber: parseInt(w.Verse)});
				nLastVerse = w.Verse;
			}

			if(w.sentence_atom_number !== nLastSentenceNumber)
			{
				listSentenceEndIndexesToSet.push(parseInt(w.TextIndex) - 1);
				nLastSentenceNumber = w.sentence_atom_number;
			}
			if(w.phrase_atom_number !== nLastPhraseNumber)
			{
				listPhraseEndIndexesToSet.push(parseInt(w.TextIndex) - 1);
				nLastPhraseNumber = w.phrase_atom_number;
			}
		}
		
		this.listVerseBeginNumbersAndWords = listVerseBeginNumbersAndWordsToSet;
		this.listVerseEndIndexes = listVerseEndIndexesToSet;
		this.listPhraseEndIndexes = listPhraseEndIndexesToSet;
		this.listSentenceEndIndexes = listSentenceEndIndexesToSet;

		var dictRefsToSet = new Map();
		for(const w of this.listTextWordsForChapter)
		{
			dictRefsToSet.set(w.TextIndex, {Hebrew: React.createRef(), Translation: React.createRef(), Transliteration: React.createRef(), Glosses: React.createRef()});
		}
		this.setState({dictRefs: dictRefsToSet});
	}

	GroupByPGroupTemp(xs)
	{
		return xs.reduce((rv, o) => {
			(rv[o.PGroup] = rv[o.PGroup] || []).push(o);
			return rv;
		  }, {});
	}
	
	GetRepetitionGroupClusterForWord(w, listLinesToUse)
	{
		return this.GetRepetitionGroupClusterForLine(this.LineWithWord(w, listLinesToUse));
	}

	GetRepetitionGroupForWord(w, listLinesToUse)
	{
		return this.GetRepetitionGroupForLine(this.LineWithWord(w, listLinesToUse != undefined ? listLinesToUse : this.state.listLines));
	}
	
	GetRepetitionGroupIndexForWord(w, listLinesToUse)
	{
		return this.GetRepetitionGroupIndexForLine(this.LineWithWord(w, listLinesToUse));
	}

	GetPGroupValueIndexForWord(w, listLinesToUse)
	{
		var repetitionGroupLineIsIn = this.GetRepetitionGroupForWord(w, listLinesToUse);
		return repetitionGroupLineIsIn === undefined ? undefined : repetitionGroupLineIsIn.ListPGroupValuesInLineGroup.indexOf(parseInt(this.GetPGroupForWord(w)));
	}

    DoesPGroupValueIndexForWordOccurOnlyOnce(w, listLinesToUse)
	{
		var repetitionGroupLineIsIn = this.GetRepetitionGroupForWord(w, listLinesToUse);
		return repetitionGroupLineIsIn === undefined ? undefined : repetitionGroupLineIsIn.ListPGroupValuesThatOccurOnlyOnce.includes(this.GetPGroupForWord(w));
    }
    
    GroupPGroupValuesInLineGroup(repetitionGroup)
    {
        return this.GroupByPGroupTemp(repetitionGroup.Lines.map(l => l.Words.map(w => 
            ({TextIndex: parseInt(w.TextIndex), PGroup: this.GetPGroupForWord(w)}))).flat(Infinity));
    }

	CalculatePGroupValuesInLineGroup(repetitionGroup)
	{
		//A-D is calculated by sorted PGroup within repetition groups, A=index 0, etc. be able to query by ABC, CABD, etc
		//sort by the first time the PGroup occurs in the group, so the first line always starts with A.
		//code assumes listTextWordsToUse is sorted ascending by TextIndex
		//124 123 -> abd abc

		var groupedPGroupValuesInLineGroup = this.GroupPGroupValuesInLineGroup(repetitionGroup);
		return Object.keys(groupedPGroupValuesInLineGroup).map(s => parseInt(s)).filter(n => !isNaN(n))
			.sort((a, b) => groupedPGroupValuesInLineGroup[a][0].TextIndex - groupedPGroupValuesInLineGroup[b][0].TextIndex);
	}

    CalculatePGroupValuesThatOccurOnlyOnce(repetitionGroup)
    {
        var groupedPGroupValuesInLineGroup = this.GroupPGroupValuesInLineGroup(repetitionGroup);   
        return Object.keys(groupedPGroupValuesInLineGroup).filter(s => groupedPGroupValuesInLineGroup[s].length < 2)
    }

	CalculatePGroupOrderInLine(line, repetitionGroupLineIsIn)
	{
		if(line.NotInGroup == true) 
			line.PGroupOrder = "";
		else if(repetitionGroupLineIsIn === undefined)
			line.PGroupOrder = "";
		else
		{	
			var nCodeForA = "A".charCodeAt(0);
			line.PGroupOrder = this.MergeConsecutiveDuplicateChars(line.Words.map(w => 
				this.GetPGroupForWord(w) === undefined || this.GetPGroupForWord(w) === null ? "" : 
				String.fromCharCode(nCodeForA + repetitionGroupLineIsIn.ListPGroupValuesInLineGroup.indexOf(parseInt(this.GetPGroupForWord(w))))).join(""));
		}	
	}
    
    CalculateLevel4Groups(listLinesToUse)
	{
		var listToReturn = [];
		var blnRepetitionGroupMode = false;
		for (var l of listLinesToUse)
		{
			if(l.StartsLevel4Group == true) 
			{
				blnRepetitionGroupMode = true;
				listToReturn.push({Lines: []});
			}
			else if(l.NotInGroup == true)
				blnRepetitionGroupMode = false;

			if(blnRepetitionGroupMode && listToReturn.length > 0)
				listToReturn[listToReturn.length - 1].Lines.push(l);
		}

		return listToReturn;
	}

    CalculateRepetitionGroupClusterGroups(listLinesToUse)
	{
		var listToReturn = [];
		var blnRepetitionGroupMode = false;
		for (var l of listLinesToUse)
		{
			if(l.StartsClusterGroup == true) 
			{
				blnRepetitionGroupMode = true;
				listToReturn.push({Lines: []});
			}
			else if(l.NotInGroup == true)
				blnRepetitionGroupMode = false;

			if(blnRepetitionGroupMode && listToReturn.length > 0)
				listToReturn[listToReturn.length - 1].Lines.push(l);
		}

		return listToReturn;
	}

	CalculateRepetitionGroupClusters(listLinesToUse)
	{
		var listToReturn = [];
		var blnRepetitionGroupMode = false;
		for (var l of listLinesToUse)
		{
			if(l.StartsCluster == true) 
			{
				blnRepetitionGroupMode = true;
				listToReturn.push({Lines: []});
			}
			else if(l.NotInGroup == true)
				blnRepetitionGroupMode = false;

			if(blnRepetitionGroupMode && listToReturn.length > 0)
				listToReturn[listToReturn.length - 1].Lines.push(l);
		}

		return listToReturn;
	}

	CalculateRepetitionGroups(listLinesToUse)
	{
		var listRepetitionGroups = [];
		var blnRepetitionGroupMode = false;
		for (var l of listLinesToUse)
		{
			if(l.StartsRepetitionGroup == true) 
			{
				blnRepetitionGroupMode = true;
				listRepetitionGroups.push({Lines: []});
			}
			else if(l.NotInGroup == true)
				blnRepetitionGroupMode = false;

			if(blnRepetitionGroupMode && listRepetitionGroups.length > 0)
				listRepetitionGroups[listRepetitionGroups.length - 1].Lines.push(l);
		}

        for(var g of listRepetitionGroups)
        {
            g.ListPGroupValuesInLineGroup = this.CalculatePGroupValuesInLineGroup(g);
            g.ListPGroupValuesThatOccurOnlyOnce = this.CalculatePGroupValuesThatOccurOnlyOnce(g);
        }

		return listRepetitionGroups;
	}

	GetRepetitionGroupClusterGroupForLine(line)
	{
		return this.listRepetitionGroupClusterGroups.find(g => g.Lines.includes(line));
	}

	GetRepetitionGroupClusterForLine(line)
	{
		return this.listRepetitionGroupClusters.find(g => g.Lines.includes(line));
	}

	GroupsInCluster(cluster)
	{
		//each group that >=1 line that the cluster includes
		return this.listRepetitionGroups.filter(g => g.Lines.some(l => cluster.Lines.includes(l)));
	}

	GetRepetitionGroupForLine(line)
	{
		return this.listRepetitionGroups.find(g => g.Lines.includes(line));
	}

	GetRepetitionGroupIndexForLine(line)
	{
		return this.listRepetitionGroups.findIndex(g => g.Lines.includes(line));
	}

	LineIsFirstInItsRepetitionGroup(line)
	{
		var repetitionGroupLineIsIn = this.GetRepetitionGroupForLine(line);
		if(repetitionGroupLineIsIn != undefined)
			return repetitionGroupLineIsIn.Lines[0] === line;
		else
			return false;
	}

	LineIsLastInItsRepetitionGroup(line)
	{
		var repetitionGroupLineIsIn = this.GetRepetitionGroupForLine(line);
		if(repetitionGroupLineIsIn != undefined)
			return repetitionGroupLineIsIn.Lines[repetitionGroupLineIsIn.Lines.length - 1] === line;
		else
			return false;
	}

	PropositionEndsARepetitionGroup(proposition)
	{
		var lastWordOfProposition = proposition.Words[proposition.Words.length - 1];
		var repetitionGroupItIsIn = this.GetRepetitionGroupForWord(lastWordOfProposition);
		if(repetitionGroupItIsIn != undefined)
			return repetitionGroupItIsIn.Lines[repetitionGroupItIsIn.Lines.length - 1].Words.includes(lastWordOfProposition);
		else
			return false;
	}

	GetNextPGroupValueWithinRepetitionGroupForLine(line)
	{
		var repetitionGroupLineIsIn = this.GetRepetitionGroupForLine(line);
		if(repetitionGroupLineIsIn != undefined)
			return Math.max(...repetitionGroupLineIsIn.ListPGroupValuesInLineGroup) + 1;
		else
			return undefined;
	}

	RecalculatePGroupOrderInLine(line)
	{
		var repetitionGroupLineIsIn = this.GetRepetitionGroupForLine(line);
		if(repetitionGroupLineIsIn != undefined)
		{
			repetitionGroupLineIsIn.ListPGroupValuesInLineGroup = this.CalculatePGroupValuesInLineGroup(repetitionGroupLineIsIn);
			this.CalculatePGroupOrderInLine(line, repetitionGroupLineIsIn);
		}
	}

	CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesForAChapter, blnCalculatePGroupOrder)
	{
		this.listRepetitionGroups = this.CalculateRepetitionGroups(listLinesForAChapter);
		this.listRepetitionGroupClusters = this.CalculateRepetitionGroupClusters(listLinesForAChapter);
        this.listRepetitionGroupClusterGroups = this.CalculateRepetitionGroupClusterGroups(listLinesForAChapter)
        this.listLevel4Groups = this.CalculateLevel4Groups(listLinesForAChapter)

        if(blnCalculatePGroupOrder)
        {
            for(var l of listLinesForAChapter)
            {
                var repetitionGroupLineIsIn = this.listRepetitionGroups.find(g => g.Lines.includes(l));
                if(repetitionGroupLineIsIn != undefined)
                    this.CalculatePGroupOrderInLine(l, repetitionGroupLineIsIn);
            }
        }
	}

	CalculateLine(line, listTextWordsToUse)
	{
		var listWordsInLine = listTextWordsToUse.filter(r =>
			parseInt(r.TextIndex) >= line.TextIndexRangeBegin &&
			parseInt(r.TextIndex) <= line.TextIndexRangeEnd);

		line.Words = listWordsInLine
        line.SyllableObjects = listWordsInLine.flatMap(w => w.SyllableObjects)
		line.SyllableCount = line.SyllableObjects.length //listWordsInLine.reduce((acc, w) => acc + parseInt(w.SyllableCount), 0);
	}

	CalculateLines(listLinesForAChapter, listTextWordsToUse)
	{
		for (var l of listLinesForAChapter)
			this.CalculateLine(l, listTextWordsToUse)
	}

	CalculateClauses(listTextWordsToUse)
	{
		// var listToReturn = [];
		
		// var nLastClauseNumber = undefined;
		// for(const w of listTextWordsToUse)
		// {
		// 	if(w.ClauseID === undefined) continue;
		// 	if(w.ClauseID !== nLastClauseNumber)
		// 	{
		// 		listToReturn.push({Words: [w]});
		// 		nLastClauseNumber = w.ClauseID;
		// 	}
		// 	else
		// 		listToReturn[listToReturn.length - 1].Words.push(w);
		// }
		
        //var listToReturn = this.listClauseData
        var listToReturn = [...new Set(listTextWordsToUse.map(w => w.clause_atom_number))].map(n => ({ID: n}))
		for(var c of listToReturn)
		{
            //TODO: investigate what the ClauseID was for and what generated the Clauses.json - was it from macula?
            c.Words = listTextWordsToUse.filter(w => w.clause_atom_number === c.ID)
            //c.Words = listTextWordsToUse.filter(w => w.ClauseID === c.ID)
            c.Chapter = c.Words.length === 0 ? '0' : c.Words[0].Chapter
			c.EndIndex = Math.max(...c.Words.map(w => parseInt(w.TextIndex)));
			c.PhraseFunctionOrder = this.GetPhraseFunctionOrdering(c.Words);
			if(c.PhraseFunctionOrder === "") c.PhraseFunctionOrder = "None";
		}
		
		return listToReturn.filter(clause => clause.Words.length > 0)
	}

	GetPGN(textWord)
	{
		return textWord.Person === undefined ? "" : 
            (textWord.Person + (textWord.Gender === "c" ? "m" : textWord.Gender) + textWord.Number)
	}

	GetSuffixPGN(textWord)
	{
        return textWord.SuffixPerson === undefined ? "" : 
            (textWord.SuffixPerson + (textWord.SuffixGender === "c" ? "m" : textWord.SuffixGender) + textWord.SuffixNumber)
	}
    
    GetPN(textWord)
	{
		return textWord.Person === undefined ? "" : (textWord.Person + textWord.Number)
	}

	dotProduct(vecA, vecB)
	{
		let product = 0;
		for(let i=0;i<vecA.length;i++){
			product += vecA[i] * vecB[i];
		}
		return product;
	}
	
	magnitudeOfVector(vec)
	{
		let sum = 0;
		for (let i = 0;i<vec.length;i++){
			sum += vec[i] * vec[i];
		}
		return Math.sqrt(sum);
	}
	
	cosineSimilarity(vecA,vecB)
	{
		return this.dotProduct(vecA,vecB)/ (this.magnitudeOfVector(vecA) * this.magnitudeOfVector(vecB));
	}

	PearsonsCorrelation(listDataPoints)
	{
		var n = listDataPoints.length;
		var sumX = listDataPoints.reduce((acc, p) => acc + p.x, 0);
		var sumY = listDataPoints.reduce((acc, p) => acc + p.y, 0);
		var sumXY = listDataPoints.reduce((acc, p) => acc + (p.x * p.y), 0);
		var sumX2 = listDataPoints.reduce((acc, p) => acc + Math.pow(p.x, 2), 0);
		var sumY2 = listDataPoints.reduce((acc, p) => acc + Math.pow(p.y, 2), 0);

		return ((n * sumXY) - (sumX*sumY)) / (Math.sqrt((n * sumX2) - Math.pow(sumX, 2)) * Math.sqrt((n * sumY2) - Math.pow(sumY, 2)));
	}

	CalculateCorrelationObject(listForFeature1, listForFeature2, listLinesToUse)
	{
		//cosine similarity requires the lists to be equal length, so do 0 or 1 for all the text indexes in the results.
		var listTextIndexes1 = listForFeature1.map(w => parseInt(w.TextIndex));
		var listTextIndexes2 = listForFeature2.map(w => parseInt(w.TextIndex));
		var listTextIndexes = listTextIndexes1.concat(listTextIndexes2);
		var nFirstTextIndexInResults = Math.min(...listTextIndexes);
		var nLastTextIndexInResults = Math.max(...listTextIndexes);
		var listForComparison1 = [];
		var listForComparison2 = [];
		for(var n = nFirstTextIndexInResults; n <= nLastTextIndexInResults; n++)
		{
			listForComparison1.push(listTextIndexes1.includes(n) ? 1 : 0);		
			listForComparison2.push(listTextIndexes2.includes(n) ? 1 : 0);
		}
		var nCosineSimilarity = this.cosineSimilarity(listForComparison1, listForComparison2);

		var nDenominator = 1.0 * listForFeature1.length;
		var nTimesInSameWord = 0;
		var nTimesInSameClause = 0;
		var nTimesInSameVerse = 0;
		var nTimesInAdjacentVerse = 0;

		for(var w1 of listForFeature1)
		{
			nTimesInSameWord += listForFeature2.some(w2 => this.SatisfiesConstraint("w", "=", 0, [w1, w2], listLinesToUse, "word")) ? 1 : 0;
			nTimesInSameClause += listForFeature2.some(w2 => this.SatisfiesConstraint("c", "=", 0, [w1, w2], listLinesToUse, "word")) ? 1 : 0;
			nTimesInSameVerse += listForFeature2.some(w2 => this.SatisfiesConstraint("v", "=", 0, [w1, w2], listLinesToUse, "word")) ? 1 : 0;
			nTimesInAdjacentVerse += listForFeature2.some(w2 => this.SatisfiesConstraint("v", "=", 1, [w1, w2], listLinesToUse, "word")) ? 1 : 0;
		}

		return {Feature1Occs: listForFeature1.length, Feature2Occs: listForFeature2.length, 
			SameWord: nTimesInSameWord, //Math.round(100 * nTimesInSameWord / nDenominator),
			SameClause: nTimesInSameClause,
			SameVerse: nTimesInSameVerse,
			AdjacentVerse: nTimesInAdjacentVerse,
			CosineSimilarity: nCosineSimilarity};

		//sExtraText += "Correlation: " + this.PearsonsCorrelation(graphData);
	}

	GetCorrelationInfo(listQueries, listChaptersToBreakOutBy, listLinesToUse)
	{
		if(listQueries.length < 2) return undefined;

		var listForFeature1All = listQueries[0].Results.flat();
		var listForFeature2All = listQueries[1].Results.flat();

		var dictToReturn = new Map();
		dictToReturn.set("Total", this.CalculateCorrelationObject(listForFeature1All, listForFeature2All, listLinesToUse));
		if(listChaptersToBreakOutBy != undefined)
		{
			for(var sChapter of listChaptersToBreakOutBy)
			{
				var listForFeature1ForChapter = listForFeature1All.filter(w => w.Chapter === sChapter);
				var listForFeature2ForChapter = listForFeature2All.filter(w => w.Chapter === sChapter);
				dictToReturn.set(sChapter, this.CalculateCorrelationObject(listForFeature1ForChapter, listForFeature2ForChapter, listLinesToUse));
			}
		}
		return dictToReturn;
	}

	MapTextIndicesToWordToHighlight(listTextIndices)
	{
		return listTextIndices.map(ti => ({TextIndex: ti, BorderColor: "black"}));
	}

	ShowQueryTextOutput()
	{
		var listQueriesWithTextOutput = this.state.listQueries.filter(q => q.OutputField != undefined);
		if(listQueriesWithTextOutput.length === 0) return;

		var listClauseFields = ["PhraseFunctionOrder"];
		var listLineFields = ["LineWordCount", "SyllableCount", "PGroupOrder"];
		var listRepetitionGroupFields = ["PGroupLineCount"];
		var listClusterFields = ["GroupsInCluster", "ClusterLineCount"];

		return listQueriesWithTextOutput.map(q => {
				var words = q.Results.flat();
				var listObjects = 
					listClauseFields.includes(q.OutputField) ? this.listClauses.filter(c => words.some(w => c.Words.includes(w))) :				
					listLineFields.includes(q.OutputField) ? this.state.listLines.filter(l => l.Words.some(w => words.includes(w))) :
					listRepetitionGroupFields.includes(q.OutputField) ? this.listRepetitionGroups.filter(g => words.some(w => g.Lines.some(l => l.Words.includes(w)))) :
					listClusterFields.includes(q.OutputField) ? this.listRepetitionGroupClusters.filter(g => words.some(w => g.Lines.some(l => l.Words.includes(w)))) :
					words;
					
				return <textarea rows="3" cols="100">
					{listObjects.map(o => 
					(q.OutputField === "LineWordCount" ? o.Words.length :
					 (q.OutputField === "PGroupLineCount" || q.OutputField === "ClusterLineCount") ? o.Lines.length :
					 q.OutputField === "GroupsInCluster" ? this.GroupsInCluster(o).length :
					 o[q.OutputField] === undefined ? "" : o[q.OutputField]) + 
					((q.OutputField === "PGroupOrder" && this.LineIsLastInItsRepetitionGroup(o)) ? " " : "-")).join("")} 
					</textarea>});
	}

	ShowYesNoForFindQuery()
	{
		//we don't have a corresponding calculate function because it is based off the query results.
		var graphData = [];
		var correlationGraphData = [];
		var nGraphWidth = 1000;	
		var nGraphHeight = 100;
        var nGraphLeftMargin = 450;
        var nHeatmapHeight = 75;
		var sGraphUniqueName = "YesNoForFindQuery";
		var sExtraText = "";
		var nYTickLabelFontSize = 12;
		var nYTickTotal = undefined;
		var listYTickKeys = []; 
		var nQueries = this.state.listQueries.length;

		if(this.listTextWordsForChapter.length === 0 || nQueries === 0) return;

		var listChapters = !this.state.blnGlobalDistributionForQueries ? this.state.listCurrentChapters : 
			Object.keys(this.GroupArrayByKey(this.state.listQueries.map(q => q.Results.flat()).flat(), "Chapter"))
			.sort((a,b) => parseInt(a) - parseInt(b));

		if(this.state.blnGlobalDistributionForQueries)
		{
			nGraphHeight = nQueries * 4000;
			nGraphWidth = 1000;

			for(var nChapter of listChapters)
			{
				for(var nQuery = 0; nQuery < nQueries; nQuery++)
				{
					var query = this.state.listQueries[nQuery];
					listYTickKeys.push(nChapter + " " + (query.ThingToFind === null ? "" : query.ThingToFind.Desc) + " " + (nQuery + 1));
				}
				if(nQueries > 1)
				{
					listYTickKeys.push(""); //for spacing between chapters
					listYTickKeys.push(""); 
				}
			}
		}
		else listYTickKeys = this.state.listQueries.map(m => m.ThingToFind === null ? "" : m.ThingToFind.Desc); 

		var nFirstTextIndexInChapter = this.listTextWordsForChapter[0].TextIndex;
		var nWordsInChapter = this.listTextWordsForChapter.length;
		//var nLastTextIndexInChapter = this.listTextWordsForChapter[this.listTextWordsForChapter.length - 1].TextIndex;

		for(var nQuery = 0; nQuery < nQueries; nQuery++)
		{
			//var sYValue = this.state.blnGlobalDistributionForQueries ? 
			var query = this.state.listQueries[nQuery];
			var results = query.Results.flat();
			
			if(this.state.blnGlobalDistributionForQueries)
			{
				//0 1  2 3  4 5    ((key - 1) * nQueries) + nQuery
				var groupedByChapter = this.GroupArrayByKey(results, "Chapter");
				for(var k of Object.keys(groupedByChapter).sort((a,b) => parseInt(a) - parseInt(b)))
				{
					var listTextWordsInThisChapter = this.listTextWordsForAllChapters.filter(w => w.Chapter === k);
					var nFirstTextIndexInThisChapter = parseInt(listTextWordsInThisChapter[0].TextIndex);
					
					//listYTickKeys.push(k);
					//var nYTickKeyIndex = listYTickKeys.length - 1;
					var nYTickKeyIndex = listYTickKeys.indexOf(k + " " + (query.ThingToFind === null ? "" : query.ThingToFind.Desc) + " " + (nQuery + 1));

					var resultsInChapter = groupedByChapter[k];
					if(resultsInChapter.length === 0)
						graphData.push({x: nFirstTextIndexInThisChapter, y: nYTickKeyIndex, HebrewTextForHint: "", WordsToHighlight: [], opacity: 0, IgnoreInHeatMap: true});
					else
						graphData = graphData.concat(resultsInChapter.map(w => ({
							HebrewTextForHint: this.GetGraphPopoverHintForWord(w, true), 
							WordsToHighlight: [w], 
							x: (parseInt(w.TextIndex) - nFirstTextIndexInThisChapter) / (1.0 * listTextWordsInThisChapter.length), 
							y: nYTickKeyIndex, color: this.distinguishingColors[nQuery]})));
				}
			}
			else
			{
				if(results.length === 0) //get the y-axis label to show
					graphData.push({x: parseInt(nFirstTextIndexInChapter), y: nQuery, HebrewTextForHint: "", WordsToHighlight: [], opacity: 0, IgnoreInHeatMap: true});
				else
					graphData = graphData.concat(results.map(w => ({
						HebrewTextForHint: this.GetGraphPopoverHintForWord(w, false), 
						WordsToHighlight: [w], 
						x: (parseInt(w.TextIndex) - parseInt(nFirstTextIndexInChapter)) / (1.0 * nWordsInChapter), 
						y: nQuery, color: this.distinguishingColors[nQuery]})));
			}
		}

		if(graphData.length === 0) return;
		
		if(this.state.blnShowCorrelationStats && this.state.listQueries.length > 1)
		{
			var corrResults = this.GetCorrelationInfo(this.state.listQueries, listChapters, undefined);
			var corr = corrResults.get("Total");
			if(!isNaN(corr.CosineSimilarity))
				sExtraText = <><p>{this.state.listQueries[0].Desc + " Occurrences: " + corr.Feature1Occs}</p>
					<p>{this.state.listQueries[1].Desc + " Occurrences: " + corr.Feature2Occs} </p>
					<p>{"SameWord: " + corr.SameWord}</p>
					<p>{"SameClause: " + corr.SameClause}</p>
					<p>{"SameVerse: " + corr.SameVerse}</p>
					<p>{"AdjacentVerse: " + corr.AdjacentVerse}</p>
					<p>{"CosineSimilarity: " + corr.CosineSimilarity}</p></>;

			for(var sChapter of listChapters)
			{
				var corrForChapter = corrResults.get(sChapter);
				if(!isNaN(corrForChapter.CosineSimilarity))
					correlationGraphData.push({x: parseInt(sChapter), y: corrForChapter.CosineSimilarity, HebrewTextForHint: sChapter, WordsToHighlight: []});
			}
		}
        
		//cosineSimilarity(a, b) - how to re-sort the ys

		//make sure the whole textindex range of the chapter is shown, not just the bounds of the results		
		graphData.push({x: 0.0, y: 0, HebrewTextForHint: "", WordsToHighlight: [], opacity: 0, IgnoreInHeatMap: true});
        graphData.push({x: 1.0, y: 0, HebrewTextForHint: "", WordsToHighlight: [], opacity: 0, IgnoreInHeatMap: true});

        //color value is percent of queried features at that word percent, nearby features are taken into account 
        var heatMapData = [];
        var nHeatMapXMaxDistanceThreshold = this.state.nHeatMapXMaxWordDistanceThreshold / (1.0 * nWordsInChapter);

        var pointsToUse = graphData.filter(o => o.IgnoreInHeatMap === undefined);
        for(var nHeatMapX = 0; nHeatMapX <= 1.0; nHeatMapX += this.state.nHeatMapXInterval)
        {
            var nFeaturesPresent = pointsToUse.reduce((acc, o) => acc + Math.max(nHeatMapXMaxDistanceThreshold - Math.abs(o.x - nHeatMapX), 0), 0)
            heatMapData.push({x: nHeatMapX, y: 0, color: nFeaturesPresent});
        }
        
		return (
			<div style={{backgroundColor:"white", marginTop:"15px"}}>
			
			{sExtraText != "" && <div>{sExtraText}</div>}
			{this.state.blnShowCorrelationStats && 
			<XYPlot width={1500} height={200} margin={{left: 100}}>
				<VerticalGridLines />
				<HorizontalGridLines />
				<VerticalBarSeries colorType="literal" data={correlationGraphData} />
				<XAxis tickTotal={listChapters.length / 5} />
				<YAxis />

				{/* <Hint value={this.state.hintLocation}>
					<div style={{ 
						background: 'black',
						color: "white", 
						fontSize:"12px",          
					}}>
					<p>{this.state.sHintText}</p>
					</div>
				</Hint>					 */}
			</XYPlot>}

			<XYPlot width={nGraphWidth} height={nGraphHeight} margin={{left: nGraphLeftMargin, bottom: 10}}>
				<YAxis tickFormat={v => listYTickKeys === undefined ? v : listYTickKeys[v]}
					tickTotal = {listYTickKeys === undefined ? nYTickTotal : listYTickKeys.length} 
					style={{ text: {fontSize: nYTickLabelFontSize}}}  />
				
				<VerticalGridLines />
				<HorizontalGridLines />

				<MarkSeries 
				colorType="literal" data={graphData} 
				
				onValueClick={(value, {index}) => {	
					this.setState({listGraphTextIndicesToHighlight: value.WordsToHighlight}); 
					this.ScrollToWords(value.WordsToHighlight);
				}}

				onNearestXY={(value, {index}) => {	
					this.setState({hintLocation: value});					
					this.setState({sHintText: value.HebrewTextForHint});											
					this.setState({sGraphUniqueNameCurrentlyShowingHint: sGraphUniqueName});}}
				/>

				{this.state.sGraphUniqueNameCurrentlyShowingHint === sGraphUniqueName && 
				<Hint value={this.state.hintLocation}>
					<div style={{ background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px",
						fontFamily: "SBL Hebrew", fontSize:"22px"}}>
					{this.state.sHintText}
					</div>
				</Hint>}					
			</XYPlot>

            <XYPlot width={nGraphWidth} height={nHeatmapHeight} margin={{left: nGraphLeftMargin, bottom: 0}}>			
				<HeatmapSeries data={heatMapData} colorRange={["black", "white"]} />	
			</XYPlot>

            <FormControlLabel label={"Threshold in Words"} style ={{marginLeft:"15px", marginBottom:"20px"}} labelPlacement="start" control={			
			<input type="number" style ={{height:'1%', marginLeft:"10px"}} size="3"
			defaultValue={this.state.nHeatMapXMaxWordDistanceThreshold}
			onChange={(event) => this.setState({nHeatMapXMaxWordDistanceThreshold: event.target.value})} />} />

			</div>
		)
	}

	CalculateGraphData(sGraphCode, sGraphUniqueName)
	{
		//y= is something numerical
		//yesno has yval = 1 if constraint is satisfied, else 0
		//colorby is a vertical bar chart series, all yval=1, colored by the parameter

		//yesno=lexgrp:1
		//yesno=type:[CDT]
		//yesno=occ:0,25 showclauseboundaries showlineboundaries
		//numerical=occ
		//type:V colorby=s
		//type:V numerical=clausepositionpercent|linepositionpercent
		//numerical=groupcount groupby=ClauseID  (number of words per clause)
		//colorby=phraseorder groupby=ClauseID
		//special=semanticdomains
		//numerical=hasrhyme:1:start end cons vowel (or none of these which looks for them all)
		//numerical=soundcorrespondences:3
		//numerical=semanticdomains

		var graphData = [];
		var listOtherLinesToShow = [];
		var listXTickKeys = undefined
		var listYTickKeys = undefined;
		var listLegendItems = undefined;
		var sExtraText = undefined;

		var sGraphType = "";
		var nTickLabelAngle = 0;
		var nXTickLabelFontSize = 12;
		var nYTickLabelFontSize = 12;
		var nXTickTotal = undefined;
		var nYTickTotal = undefined;
		var nGraphWidth = 800;	
		var nMaxGraphWidth = 1200;
		var nGraphHeight = 100;
		var nGraphLeftMargin = 50;

		if(sGraphCode === "" || sGraphCode === undefined) return undefined;

		//extract the various graph parameters
		var sYesNo = "";
		var sNumerical = "";
		var sGlobalDistribution = "";
		var sCorrelationFeature1 = "";
		var sCorrelationFeature2 = "";
		var correlationConstraint = "v=0";
		var sSpecial = "";
		var sGroupBy = "";
		var listBoundariesToShow = undefined;
		var blnShowLinesDownFromPoints = false;
		//var clauseBoundariesData = [];

		// var showclauseboundariesMatch = sGraphCode.match(/showclauseboundaries/)
		// if(showclauseboundariesMatch !== null)
		// {
		// 	listBoundariesToShow = this.listClauses.map(c => c.EndIndex); 		
		// 	sGraphCode = sGraphCode.replace(showclauseboundariesMatch[0], "");
		// }

		// var showlineboundariesMatch = sGraphCode.match(/showlineboundaries/)
		// if(showlineboundariesMatch !== null)
		// {
		// 	var listBoundaryTextIndices = this.state.listLines
		// 	.filter(r => parseInt(r.Book) === this.state.nCurrentBook && parseInt(r.Chapter) === this.GetFirstCurrentChapter())
		// 	.map(c => parseInt(c.TextIndexRangeEnd) + 1);

		// 	listOtherLinesToShow.push({"MarkerName":"Line Boundaries", "Color": "#e6e6e6", "MatchingTextIndexes": listBoundaryTextIndices}); 
		// 	sGraphCode = sGraphCode.replace(showlineboundariesMatch[0], "");
		// }

		// var showBoundariesAtVersesMatch = sGraphCode.match(/sb\s?=\s?([\w,]+)/)
		// if(showBoundariesAtVersesMatch !== null)
		// {
		// 	var listBoundariesAtVerses = showBoundariesAtVersesMatch[1].split(",").map(s => parseInt(s.trim()));
		// 	sGraphCode = sGraphCode.replace(showBoundariesAtVersesMatch[0], "");

		// 	var listBoundaryTextIndices = this.listVerseBeginNumbersAndWords
		// 	.filter(r => listBoundariesAtVerses.includes(r.VerseNumber))
		// 	.map(r => parseInt(r.TextIndex));

		// 	listOtherLinesToShow.push({"MarkerName":"Provisional Section Boundaries", "Color": "#e6e6e6", "MatchingTextIndexes": listBoundaryTextIndices}); 			
		// }

		// var showLinesDownFromPointsMatch = sGraphCode.match(/droplines/)
		// if(showLinesDownFromPointsMatch !== null)
		// {
		// 	blnShowLinesDownFromPoints = true;			
		// 	sGraphCode = sGraphCode.replace(showLinesDownFromPointsMatch[0], "");
		// }

		// var colorByMatch = sGraphCode.match(/colorby\s?=\s?(\w+)/)
		// if(colorByMatch !== null)
		// {
		// 	sColorBy = colorByMatch[1];
		// 	sGraphCode = sGraphCode.replace(colorByMatch[0], "");
		// }

		// var yesNoMatch = sGraphCode.match(/yesno\s?=\s?(\S+)/)
		// if(yesNoMatch !== null)
		// {
		// 	sYesNo = yesNoMatch[1];
		// 	sGraphCode = sGraphCode.replace(yesNoMatch[0], "");
		// }

		var groupByMatch = sGraphCode.match(/groupby\s?=\s?(\S+)/)
		if(groupByMatch !== null)
		{
			sGroupBy = groupByMatch[1];
			sGraphCode = sGraphCode.replace(groupByMatch[0], "");
		}

		var numericalMatch = sGraphCode.match(/numerical\s?=\s?(\S+)/)
		if(numericalMatch !== null)
		{
			sNumerical = numericalMatch[1];
			sGraphCode = sGraphCode.replace(numericalMatch[0], "");
		}

		var gbMatch = sGraphCode.match(/globaldistribution\s?=\s?(\S+)/)
		if(gbMatch !== null)
		{
			sGlobalDistribution = gbMatch[1];
			sGraphCode = sGraphCode.replace(gbMatch[0], "");
		}
		
		// var specialMatch = sGraphCode.match(/special\s?=\s?(\S+)/)
		// if(specialMatch !== null)
		// {
		// 	sSpecial = specialMatch[1];
		// 	sGraphCode = sGraphCode.replace(specialMatch[0], "");
		// }

		//treat everything left as a filter
		var sFilter = sGraphCode.replace(/\s+/g, "");
		var listWordsForGraph = this.listTextWordsForChapter;
		//this.listTextWordsForChapter.filter(w => this.TermMatches(undefined, w, sFilter));
		
		if(listWordsForGraph.length === 0) return undefined;

		var nFirstTextIndexInChapter = this.listTextWordsForChapter[0].TextIndex;
		
		if(sNumerical.startsWith("semanticpatterns"))
		{
			//ABCABC - correlated repetition of at least two different elements; the second or more repetitions follow the same order
			//ABCCBA - correlated repetition of at least two different elements; the second or more repetitions follow the inverted order

			//for each word, compare all words after it to it, and the words that are sufficiently similar to it,
			//put in that word's group. 
			sGraphType = "SemanticPatterns";

			var split2 = sNumerical.split(":");
			var nMaxLevels = split2.length === 1 || isNaN(parseInt(split2[1])) ? 3 : parseInt(split2[1]);		

			var dictSemanticGroupsByWord = new Map();
			for (var nWord1 = 0; nWord1 < this.listTextWordsForChapter.length - 1; nWord1++)
			{
				var w1 = this.listTextWordsForChapter[nWord1];
				dictSemanticGroupsByWord.set(w1, [w1]);

				for (var nWord2 = nWord1 + 1; nWord2 < this.listTextWordsForChapter.length; nWord2++)
				{
					var w2 = this.listTextWordsForChapter[nWord2];
					if(this.WordsSemanticallySimilarEnough(w1, w2, nMaxLevels, true))
					{
						dictSemanticGroupsByWord.get(w1).push(w2);
					}
				}
			}

			//filter out too small and duplicate groups
			var nMinMembersToBeDisplayed = 2;
			var listKeys = Array.from(dictSemanticGroupsByWord.keys());
			var listKeysToUse = listKeys.filter(k => dictSemanticGroupsByWord.get(k).length >= nMinMembersToBeDisplayed);
			var listAllWordGroupsToUse = listKeysToUse.map(k => dictSemanticGroupsByWord.get(k));
			var listKeysToRemove = [];
			
			for(var nKey = 0; nKey < listKeysToUse.length; nKey++)
			{
				var theKey = listKeysToUse[nKey];
				var listWordsForKey = dictSemanticGroupsByWord.get(theKey);
				
				//if all the words in one group are contained in another group, keep the larger group.
				//e.g. for Psalms 1, nKey=14 is contained in nKey=3			
				if(listAllWordGroupsToUse.some(wordGroup => wordGroup != listWordsForKey && listWordsForKey.every(w => wordGroup.find(w2 => w === w2) != undefined)))
					listKeysToRemove.push(theKey);
			}

			listKeysToUse = listKeysToUse.filter(k => !listKeysToRemove.includes(k));

			//Display on the graph all groups with length > nMinMembersToBeDisplayed. 
			//One axis is the textword indexes, the other is the word group index (LineMarkSeries)
			//See if there is a way to put orthogonal lines, too.

			var graphDataBySeries = [];
			nGraphHeight = 400;
			nGraphWidth = 1000;
			for(var nKey = 0; nKey < listKeysToUse.length; nKey++)
			{
				//var graphDataForThisSeries = [];
				var listGroupMembersForKey = dictSemanticGroupsByWord.get(listKeysToUse[nKey]);
				for(var groupMember of listGroupMembersForKey)
				{ 
					graphData.push({
						HebrewTextForHint: listGroupMembersForKey.map(w => this.GetGraphPopoverHintForWord(w)).join(" "), 
						WordsToHighlight: this.MapTextIndicesToWordToHighlight(listGroupMembersForKey.map(w => w.TextIndex)), 
						x: parseInt(groupMember.TextIndex), 
						y: nKey});
				}
				//graphDataBySeries.push(graphDataForThisSeries);
			}
			
			//#f2f2f2
			// 	var listSemanticDomainGroups = this.GroupBySemanticDomain(listWordsForGraph);
			// 	return (
			// 		<>
			// 		<DiscreteColorLegend
			// 		orientation="horizontal" 
			// 		width={800}
			// 		items={Object.keys(listSemanticDomainGroups)}
			// 		// items={[{title: "q", color: "Blue"}]}
			// 		/>

			// 		<XYPlot width={800} height={150}>
			// 			<VerticalGridLines />
			// 			<HorizontalGridLines />
			// 			<XAxis />
			// 			<YAxis />
						
			// 			{Object.keys(listSemanticDomainGroups).filter(k => k !== "undefined" && k !== "").map((sSemanticDomain, nDomainIndex) => {
			// 				var graphData = listWordsForGraph.map((w, nIndex) => 
			// 					({HebrewTextForHint: "", TextIndices: [w.TextIndex], x:nIndex, 
			// 					y: nDomainIndex, 
			// 					color: this.GetSemanticDomainsForWord(w)[0] === sSemanticDomain ? "red" : "blue"}))
			// 				return <HeatmapSeries 
			// 				colorType="literal" data={graphData} 
			// 				// onNearestXY={(value, {index}) => {	
			// 				// 	this.setState({hintLocation: value});					
			// 				// 	this.setState({sHintText: this.dictGraphDataByGraphUniqueName[sGraphUniqueName][index].HebrewTextForHint});											
			// 				// 	this.setState({sGraphUniqueNameCurrentlyShowingHint: sGraphUniqueName});
			// 				// 	this.setState({listGraphTextIndicesToHighlight: this.dictGraphDataByGraphUniqueName[sGraphUniqueName][index].TextIndices});}}
			// 			/>})}
	
			// 			{this.state.sGraphUniqueNameCurrentlyShowingHint === sGraphUniqueName && 
			// 			<Hint value={this.state.hintLocation}>
			// 				<div style={{ 
			// 					background: 'black',
			// 					fontFamily: "SBL Hebrew", 
			// 					color: "white", 
			// 					fontSize:"22px",
			// 					//width: this.state.listSelectedWords.includes(w) ? "750px" : "default", borderStyle: "solid"           
			// 				}}>
			// 				<p>{this.state.sHintText}</p>
			// 				</div>
			// 			  </Hint>}	
	
			// 			{blnShowClauseBoundaries && this.listClauseEndIndexes.map(n => <LineSeries color="black" data={[{x:n-nFirstTextIndexInChapter, y:0}, {x:n-nFirstTextIndexInChapter, y:nMaxValue}]}/>)}
			// 		</XYPlot>
			// 		</>
			// 	)
		}
		else if(sGraphCode.match(/globalcorr/)) 
		{
			this.CalcGlobalCorr();
		}
		else if(sGraphCode.match(/slide/)) 
		{
			this.CalcSlidingPatternComparison();
        }
        else if(sGraphCode.match(/pgroupordertally/)) 
		{
			this.CalcPGroupTally();
        }
        else if(sGraphCode.match(/parallelphrasestally/)) 
		{
			this.ParallelPhrasesTally();
        }
        else if(sGraphCode.match(/linkedwordstally/)) 
		{
			this.LinkedWordsTally();
        }

		// else if(sGlobalDistribution != "")
		// {
		// 	var nChaptersToDo = 150;
		// 	sGraphType = "Numerical";
		// 	nGraphHeight = 4000;
		// 	nGraphWidth = 1000;
		// 	nYTickTotal = nChaptersToDo;

		// 	//regression-js 
		// 	//npm i regression + LineSeries
		// 	//show where the user-selected feature occurs across all the chapters
		// 	var listGlobalDistribution = [];
		// 	for(var nChapterToDo = 1; nChapterToDo <= nChaptersToDo; nChapterToDo++)
		// 	{
		// 		var listTextWordsInChapterToDo = this.listTextWordsForAllChapters.filter(w => w.Chapter === nChapterToDo.toString());
		// 		var nTextWordsInChapterToDo = 1.0 * listTextWordsInChapterToDo.length;
		// 		for (var nWord = 0; nWord < listTextWordsInChapterToDo.length; nWord++)
		// 		{
		// 			var w = listTextWordsInChapterToDo[nWord];
		// 			if(this.TermMatches(undefined, w, sGlobalDistribution))
		// 				listGlobalDistribution.push({Chapter: nChapterToDo, Word: w, PercentPosition: Math.round(100 * (nWord / nTextWordsInChapterToDo))});
		// 		}
		// 	}

		// 	sExtraText = "Standard Deviation of Distance Between Occurrences: ";
		// 	//var listGlobalDistributionCorrelated = listGlobalDistribution.sort((a,b) => a correlates b);
		// 	for(var nChapterToDo = 1; nChapterToDo <= nChaptersToDo; nChapterToDo++)
		// 	{
		// 		for(var r of listGlobalDistribution.filter(r => r.Chapter === nChapterToDo))
		// 			graphData.push({
		// 				HebrewTextForHint: r.Word.FullText, 
		// 				WordsToHighlight: [], 
		// 				x: r.PercentPosition, 
		// 				y: nChapterToDo});
		// 	}

		// 	for(var nPercent = 0; nPercent <= 100; nPercent++)
		// 	{
		// 		// graphData.push({
		// 		// 	HebrewTextForHint: "", 
		// 		// 	WordsToHighlight: [], 
		// 		// 	x: nPercent, 
		// 		// 	y: listGlobalDistribution.filter(r => r.PercentPosition === nPercent).length});
		// 	}
		// }
		else if(sNumerical !== "")
		{
			sGraphType = "Numerical";

			//occs|clausepositionpercent|linepositionpercent|groupcount
			var nLastTextIndexInChapter = this.listTextWordsForChapter[this.listTextWordsForChapter.length - 1].TextIndex;
			if(sNumerical === "hebrewconsonants" || sNumerical === "hebrewvowels" || sNumerical === "hebrewchars")
			{
				nGraphHeight = 300;
				nGraphWidth = 1000;
				nGraphLeftMargin = 400;
				nXTickLabelFontSize = 18;
				var dictWordsByLetters = this.GroupByLetters(listWordsForGraph, sNumerical);
				var listKeysLetters = Array.from(dictWordsByLetters.keys())
					.sort((a, b) => dictWordsByLetters.get(b).length - parseInt(dictWordsByLetters.get(a).length));			
				listXTickKeys = listKeysLetters;
				for(var k2 of listKeysLetters)
				{
					var listWordsWithChar = dictWordsByLetters.get(k2);
					graphData.push({HebrewTextForHint: listWordsWithChar.map(w => this.GetGraphPopoverHintForWord(w)).join(" "), 
						WordsToHighlight: this.MapTextIndicesToWordToHighlight(listWordsWithChar.map(w => w.TextIndex)), 
						x: listKeysLetters.indexOf(k2), y: listWordsWithChar.length});
				}
			}
			else if(sNumerical.includes("phoneticdistribution"))
			{
				//todo: calculate correlation between each pair of chars, graph that pair (x-axis) 
				//by correlation score (y-axis) in descending order
				//break sin and shin out separately, merge final forms with medial, merge by similar sound groups
				//exclude yod and i when they are mater lectionis
				nGraphHeight = 650;
				nGraphWidth = 1000;
				nYTickLabelFontSize = 18;		
				nGraphLeftMargin = 300;

				var sMode = 
					sNumerical.includes("consonant") ? "consonant" : 
					sNumerical.includes("vowel") ? "vowel" : "all";

				//call GroupByLetters to get frequency counts to sort the chars.
				var dictWordsByLetters = this.GroupByLetters(listWordsForGraph, sNumerical);
				var listYTickKeys = Array.from(dictWordsByLetters.keys())
					.sort((a, b) => dictWordsByLetters.get(b).length - parseInt(dictWordsByLetters.get(a).length));	
					//sort((a,b) => a.localeCompare(b)) for alphanumeric sort
					
				for(var c of listYTickKeys)
				{
					var regexForChar = new RegExp(c, 'g');
					for(var w of listWordsForGraph.filter(w2 => w2.FullText.includes(c)))
					{
						//darkpurple = contains >=4
						//red = contains 3
						//yellow = contains 2
						//blue = 1
						var nTimesCharOccursInWord = [...w.FullText.matchAll(regexForChar)].length;

						graphData.push({
							HebrewTextForHint: this.GetGraphPopoverHintForWord(w), 
							WordsToHighlight: this.MapTextIndicesToWordToHighlight([w.TextIndex]), 
							x: parseInt(w.TextIndex),
							y: listYTickKeys.indexOf(c),

							color: (nTimesCharOccursInWord >= 4 ? "darkpurple" :
							nTimesCharOccursInWord === 2 ? "green" :
							nTimesCharOccursInWord === 3 ? "red" : "darkcyan")});
					}
				}
			}
			else if(sNumerical.startsWith("importantsemanticnodesdistribution"))
			{
				nGraphLeftMargin = 300;

				var listDomainsToShow = "direction, location, time, number, polarity, trueGod, falsegod, creation, sky, land" + 
				"sea, livingthing, plant, animal, bird, fish, human, family, body, material, life, death, wellbeing, badbeing," + 
				"vulnerablehuman, help, captivity, refuge, statusinsociety, goodhumanrelationship, badhumanrelationship, fighting," + 
				"doingright, doingwrong, go, do, work, begin, end, perception, know, speak, emotion, government, law, societyplace," + 
				"holy, pray, worship, sacrifice";
				
				var listYTickKeys = [];	
				for(var s of listDomainsToShow.split(",").map(s => s.trim()))
				{
					var semanticNode = this.FindNodesByName(s)[0];
					for(var w of listWordsForGraph.filter(w2 => this.WordIsASemanticTypeOrPartOfNode(semanticNode.ID, w2)))
					{
						if(!listYTickKeys.includes(s))
							listYTickKeys.push(s);

						graphData.push({
							HebrewTextForHint: this.GetGraphPopoverHintForWord(w), 
							WordsToHighlight: this.MapTextIndicesToWordToHighlight([w.TextIndex]), 
							x: parseInt(w.TextIndex),
							sortName: s});
					}
				}

				nGraphHeight = 100 + (15 * listYTickKeys.length);				
				nGraphWidth = nGraphLeftMargin + 100 + (10 * listWordsForGraph.length);
				if(nGraphWidth > nMaxGraphWidth) 
					nGraphWidth = nMaxGraphWidth;

				var groupedValuesObject = this.GroupArrayByKey(graphData, "sortName");
				listYTickKeys.sort((a,b) => groupedValuesObject[a].length - groupedValuesObject[b].length);
				graphData.forEach(d => d.y = listYTickKeys.indexOf(d.sortName));
			}
			else if(sNumerical.startsWith("nontaxonomicsemanticnodesdistribution"))
			{
				nGraphLeftMargin = 300;
				var listLinkTypesAllowed = this.listSemanticLinkTypes.filter(s => !["types", "parts", "doneby"].includes(s));
				var listYTickKeys = [];

				for(var w of listWordsForGraph)
				{
					for(var n1 of this.FindNodesForWord(w))
					{
						for(var n2 of this.listSemanticLinks.filter(l => l.node1 === n1.ID && listLinkTypesAllowed.includes(l.type)))
						{
							var nodeFound = this.state.listSemanticNodes.find(n => n.ID === n2.node2);

							if(!listYTickKeys.includes(nodeFound.Names))
								listYTickKeys.push(nodeFound.Names);

							graphData.push({
								HebrewTextForHint: this.GetGraphPopoverHintForWord(w) + " " + n2.type, 
								WordsToHighlight: this.MapTextIndicesToWordToHighlight([w.TextIndex]), 
								x: parseInt(w.TextIndex),
								sortName: nodeFound.Names});
						}
					}
				}

				nGraphHeight = 100 + (15 * listYTickKeys.length);				
				nGraphWidth = nGraphLeftMargin + 100 + (10 * listWordsForGraph.length);
				if(nGraphWidth > nMaxGraphWidth) 
					nGraphWidth = nMaxGraphWidth;

				var groupedValuesObject = this.GroupArrayByKey(graphData, "sortName");
				listYTickKeys.sort((a,b) => groupedValuesObject[a].length - groupedValuesObject[b].length);
				graphData.forEach(d => d.y = listYTickKeys.indexOf(d.sortName));
			}
			else if(sNumerical.startsWith("repetitionpatterns"))
			{
				//for each word, check forward within range 1 to see if anything repeats it.
				//If so, then check all words forward within range 2 for both words to see which correspond.
				//Find as many as possible. If found > 1 word in this manner, add a row to the graph
				//that show all the textindex points involved, matching colors like A-A, B-B, C-C.

				nGraphHeight = 800;
				nGraphWidth = 1000;
				var nMaxLinkDistance = 4;
				var sRangeForA = "v<=3";
				var sRangeForRest = "v<1";
				var split2 = sNumerical.split(":");
				if(split2.length >= 2) sRangeForA = split2[1];
				if(split2.length >= 3) sRangeForRest = split2[2];
				if(split2.length >= 4) nMaxLinkDistance = parseInt(split2[3]);

				var listLinesToUse = this.state.listLines;
				var constraintForA = this.ParseConstraintString("v<=" + sRangeForA);
				var constraintForRest = this.ParseConstraintString("v<=" + sRangeForRest);

				listWordsForGraph = listWordsForGraph.filter(w => ["A","N","V"].includes(w.WordType));
				for (var nWord1 = 0; nWord1 < listWordsForGraph.length - 1; nWord1++)
				{
					var w1 = listWordsForGraph[nWord1];
					var yValue = parseInt(w1.TextIndex);
					var listForYValue = [];

					for (var nWord2 = nWord1 + 1; nWord2 < listWordsForGraph.length; nWord2++)
					{
						var w2 = listWordsForGraph[nWord2];
						if(!this.SatisfiesConstraint(constraintForA.UnitType, constraintForA.Operator, constraintForA.Value, [w1, w2], listLinesToUse)) continue;

						// var wordComparison = this.WordsSemanticallySimilarEnough(w1, w2, nMaxLinkDistance);
						// var nScore = wordComparison.SimilarityScore;

						if(this.WordsSemanticallySimilarEnough(w1, w2, nMaxLinkDistance, true))
						{
							for (var nWord3 = nWord1 + 1; nWord3 < listWordsForGraph.length; nWord3++)
							{
								var w3 = listWordsForGraph[nWord3];
								if(!this.SatisfiesConstraint(constraintForRest.UnitType, constraintForRest.Operator, constraintForRest.Value, [w1, w3], listLinesToUse)) continue;

								for (var nWord4 = nWord2 + 1; nWord4 < listWordsForGraph.length; nWord4++)
								{
									var w4 = listWordsForGraph[nWord4];
									if(!this.SatisfiesConstraint(constraintForRest.UnitType, constraintForRest.Operator, constraintForRest.Value, [w2, w4], listLinesToUse)) continue;
									// var wordComparison = this.WordsSemanticallySimilarEnough(w3, w4, nMaxLinkDistance);
									// var nScore = wordComparison.SimilarityScore;
			
									if(this.WordsSemanticallySimilarEnough(w3, w4, nMaxLinkDistance, true))
									{
										if(!listForYValue.some(d => d.x === parseInt(w1.TextIndex) && d.y === yValue))
										{
											listForYValue.push({  
												Test: "w1",
												HebrewTextForHint: w1.FullText,
												x: parseInt(w1.TextIndex), 
												y: yValue, 
												color: "red"});
										}
										if(!listForYValue.some(d => d.x === parseInt(w2.TextIndex) && d.y === yValue))
										{
											listForYValue.push({ 
												Test: "w2",
												HebrewTextForHint: w2.FullText,
												x: parseInt(w2.TextIndex), 
												y: yValue, 
												color: "blue"});
										}
										if(!listForYValue.some(d => d.x === parseInt(w3.TextIndex) && d.y === yValue))
										{
											listForYValue.push({
												Test: "w3",
												HebrewTextForHint: w3.FullText,
												x: parseInt(w3.TextIndex), 
												y: yValue, 
												color: "darkcyan"});
										}

										listForYValue.push({
											Test: "w4", 
											HebrewTextForHint: w4.FullText,
											x: parseInt(w4.TextIndex), 
											y: yValue, 
											color: "lightgray"});
									}
								}
							}
						}
					}

					if(listForYValue.length > 0)
					{
						// var sHebrewHintForRow = listForYValue.map(r => r.HebrewTextForHint).join("-");
						var listTextIndicesForRow = listForYValue.map(r => ({TextIndex: r.x.toString(), BorderColor: r.color}));
						// listForYValue.forEach(r => r.HebrewTextForHint = sHebrewHintForRow);
						listForYValue.forEach(r => r.WordsToHighlight = listTextIndicesForRow);
						graphData = graphData.concat(listForYValue);
					}
				}
			}
			else if(sNumerical.startsWith("wordlinkdistribution"))
			{
				//both axes are textindex - calculate similarity between them and if it is above a certain threshold,
				//display a point colored by intensity of the link

				nGraphHeight = 800;
				nGraphWidth = 1000;
				var nSimilarityScoreThresholdToDisplay = 0.4;
				//var split2 = sNumerical.split(":");
				//var nMaxLevels = split2.length === 1 || isNaN(parseInt(split2[1])) ? 3 : parseInt(split2[1]);		

				for (var nWord1 = 0; nWord1 < this.listTextWordsForChapter.length - 1; nWord1++)
				{
					var w1 = this.listTextWordsForChapter[nWord1];
					for (var nWord2 = nWord1 + 1; nWord2 < this.listTextWordsForChapter.length; nWord2++)
					{
						var w2 = this.listTextWordsForChapter[nWord2];
						var wordComparison = this.CalculateWordSimilarity(w1, w2, true, true, true, false);
						var nScore = wordComparison.SimilarityScore;

						if(nScore >= nSimilarityScoreThresholdToDisplay)
						{
							graphData.push({
								HebrewTextForHint: this.GetGraphPopoverHintForWord(w1) + " " + this.GetGraphPopoverHintForWord(w2) + wordComparison.LinkDescriptionsList, 
								WordsToHighlight: this.MapTextIndicesToWordToHighlight([w1.TextIndex, w2.TextIndex]), 
								x: parseInt(w2.TextIndex), 
								y: parseInt(w1.TextIndex), 
								color: (nScore >= 0.85 ? "darkpurple" :
								nScore > 0.7 ? "green" :
								nScore > 0.55 ? "red" : "darkcyan")});
						}
					}
				}
			}
			else if(sNumerical.startsWith("breakmarkerdistribution"))
			{
				//x-axis textindexes, y-axis each tick a category of things that is known to occur at section breaks, 
				//like speech boundaries, discourse markers, pronouns, subject changes, negative, lexical ID repetition 
				//(if the word at textindex has occurred previously). Also chart what is suspected around discourse breaks, 
				//like intensity of links between words (show ranges where the link density is high?), semantic shifts
				//non standard word order

			    nGraphHeight = 350;
			    nGraphWidth = 1100;
				nGraphLeftMargin = 150;

			    listOtherLinesToShow = listOtherLinesToShow.concat([
					{"MarkerName":"Speech Boundary", "Color": "Black"}, 
					{"MarkerName":"Selah", "Color": "Black"},
					{"MarkerName":"Weatah", "Color": "Black"}]);

				var listMarkersToShow = [
					{"Name":"Speech Boundary", "Query":"texttype:Q"}, /*texttype:[^Q] - texttype:Q */
					{"Name":"Pronoun", "Query":"type:P"}, 
					{"Name":"Discourse Marker", "Query":"lexgrp:3"}, 
					{"Name":"Question Words", "Query":"lexgrp:4"}, 
					{"Name":"Verb Subject Change", "Query":"type:V & f:[^rsc]"}, 
					{"Name":"Negative", "Query":"lexgrp:1"},
					{"Name":"Words For God", "Query":"lexgrp:2"},
					{"Name":"Selah", "Query":"lex:5937"},
					{"Name":"Weatah", "Query":"lex:6739"},
					{"Name":"Rare Words", "Query":"occ:0,20"},
					{"Name":"Emotion Exclamations", "Query":"lexgrp:5"}, 
					{"Name":"SV", "Query":"clauses pforder:SV"},
					{"Name":"VS", "Query":"clauses pforder:VS"},
					{"Name":"OV", "Query":"clauses pforder:OV"},
					{"Name":"Repeated Words", "Query":"type:[ANV]--lex/"},
					{"Name":"Semantic Disjunction", "Query": undefined},
					{"Name":"Alliteration", "Query":"all-(all{1,3})-startconsrhyme/"}];

				var listYTickKeys = listMarkersToShow.map(m => m.Name); 
				var nMaxYValue = listMarkersToShow.length - 1;

				for(var marker of listMarkersToShow)
				{
					var listMatchResults = marker.Query === undefined ? [] : this.FindQueryMatchesChaining(listWordsForGraph, marker.Query, this.state.listLines, this.listClauses, this.listRepetitionGroups, this.listRepetitionGroupClusters).MatchingWords.flat();	

					if(marker.Name === "Speech Boundary")
					{
						//find discontinuities
						marker.MatchingTextIndexes = listMatchResults.sort((a,b) => parseInt(a) - parseInt(b))
						.filter((r, i, list) => i === 0 || (i === list.length - 1) || (parseInt(list[i]) - parseInt(list[i - 1])) > 1);
					}
					else if(marker.Name === "Verb Subject Change")
					{
						//find discontinuities in pgn
						marker.MatchingTextIndexes = listWordsForGraph.filter(w => listMatchResults.includes(w.TextIndex))
						.sort((a,b) => parseInt(a.TextIndex) - parseInt(b.TextIndex))
						.filter((r, i, list) => i != 0 && (this.GetPGN(list[i]) != this.GetPGN(list[i - 1])))
						.map(w => w.TextIndex);
					}
					else if(marker.Name === "Semantic Disjunction")
					{
						//removing words like adverbs and particles, group the words into groups of 5 words so they are equal.
						//if any group does not have > nDisjunctionThreshold number of semantically equivalent words with the
						//previous group, put all members of that group into this array.
						
						var nSemanticDisjunctionThreshold = 1;
						var nSemanticDisjunctionGroupSize = 3;
						var nSemanticDisjunctionMaxLevels = 5;
						marker.MatchingTextIndexes = [];
						var listWordsForSemanticDisjunction = listWordsForGraph.filter(w => ["A","N","V"].includes(w.WordType));

						for(var i = nSemanticDisjunctionGroupSize; i < listWordsForSemanticDisjunction.length; i += nSemanticDisjunctionGroupSize)
						{
							var listPreviousGroup = listWordsForSemanticDisjunction.slice(i - nSemanticDisjunctionGroupSize, i);
							var listThisGroup = listWordsForSemanticDisjunction.slice(i, i + nSemanticDisjunctionGroupSize);

							var nCorrespondencesBetweenTheseGroups = 0;
							for(var w1 of listThisGroup)
							{
								for(var w2 of listPreviousGroup)
								{
									if(this.WordsSemanticallySimilarEnough(w1, w2, nSemanticDisjunctionMaxLevels, true))
									{
										nCorrespondencesBetweenTheseGroups++;
										if(nCorrespondencesBetweenTheseGroups >= nSemanticDisjunctionThreshold) break;
									}
								}
									
								if(nCorrespondencesBetweenTheseGroups >= nSemanticDisjunctionThreshold) break;
							}

							if(nCorrespondencesBetweenTheseGroups < nSemanticDisjunctionThreshold)
								marker.MatchingTextIndexes = marker.MatchingTextIndexes.concat(listThisGroup.map(w => w.TextIndex));
						}
					}
					else
					{
						marker.MatchingTextIndexes = listMatchResults;	
					}
					
					var lineToShowMatchingMarker = listOtherLinesToShow.find(l => l.MarkerName === marker.Name);
					if(lineToShowMatchingMarker != undefined)
						lineToShowMatchingMarker.MatchingTextIndexes = marker.MatchingTextIndexes;
				}

				//TODO: for repeated words, exclude words that already occur in the other lines in the graph, like negatives, discourse
				var listMarkersToFilterFromRepeated = ["Pronoun", "Discourse Marker", "Question Words", "Negative", "Words For God", "Selah", "Weatah", "Rare Words", "Emotion Exclamations"];
				var listWordIndexesToFilterOutOfRepeated = listMarkersToShow.filter(m => listMarkersToFilterFromRepeated.includes(m.Name)).map(m => m.MatchingTextIndexes).flat();				
				var repeatedWordObject = listMarkersToShow.find(m => m.Name === "Repeated Words");
				repeatedWordObject.MatchingTextIndexes = repeatedWordObject.MatchingTextIndexes.filter(n => !listWordIndexesToFilterOutOfRepeated.includes(n));

				for (var nWord1 = 0; nWord1 < this.listTextWordsForChapter.length; nWord1++)
				{
					var w1 = this.listTextWordsForChapter[nWord1];

					for(var nMarker = 0; nMarker < listMarkersToShow.length; nMarker++)
					{
						var marker = listMarkersToShow[nMarker];

						if(marker.MatchingTextIndexes.includes(w1.TextIndex))
							graphData.push({
								HebrewTextForHint: w1.TextIndex + " " + w1.FullText, 
								WordsToHighlight: this.MapTextIndicesToWordToHighlight([w1.TextIndex]), 
								x: parseInt(w1.TextIndex), 
								y: nMarker});
					}
				}
			}
			// else
			// {
			// 	graphData = listWordsForGraph.map((w, nIndex) => {
			// 		var nValue = 0;
			// 		var sHebrewTextForHint = w.FullText;
			// 		var listTextIndices = [w.TextIndex];

			// 		if(sNumerical === "occs")
			// 			nValue = w.Occurrences;
			// 		else if(sNumerical.includes("hasrhyme"))
			// 		{
			// 			var split = sNumerical.split(":");
			// 			var nWithinNWords = parseInt(split[1]);
			// 			var listWordsToCompare = listWordsForGraph.filter(w2 => { 
			// 				var nWordDistance = Math.abs(parseInt(w.TextIndex)-parseInt(w2.TextIndex)); 
			// 				return nWordDistance > 0 && nWordDistance <= nWithinNWords; });
			// 			for(var w2 of listWordsToCompare)
			// 			{
			// 				if(this.WordRhymesWithOtherWord(w, w2, split.length < 3 ? "" : split[2]))
			// 				{
			// 					nValue += 1;
			// 					sHebrewTextForHint += " " + w2.FullText;
			// 					listTextIndices.push(w2);
			// 				}
			// 			}
			// 		}
			// 		else if(sNumerical.includes("PhonologicalSimilarity"))
			// 		{
			// 			var split2 = sNumerical.split(":");
			// 			var nWithinNWords2 = parseInt(split2[1]);
			// 			var listWordsToCompare2 = listWordsForGraph.filter(w2 => { 
			// 				var nWordDistance = Math.abs(parseInt(w.TextIndex)-parseInt(w2.TextIndex)); 
			// 				return nWordDistance > 0 && nWordDistance <= nWithinNWords2; });
			// 			for(var w3 of listWordsToCompare2)
			// 			{
			// 				nValue += this.CalculatePhonologicalSimilarity(w, w3).Score;
			// 				sHebrewTextForHint += " " + w3.FullText;
			// 				listTextIndices.push(w3);
			// 			}
			// 		}
			// 		else if(sNumerical === "clausepositionpercent")
			// 		{
			// 			var clauseForWord = this.GetClauseForWord(w, listClausesToUse);
			// 			nValue = 100 * (clauseForWord.Words.indexOf(w) / (1.0 * clauseForWord.Words.length));
			// 		}
			// 		else if(sNumerical === "linepositionpercent")
			// 		{
			// 			var listWordsInSameLineAsWord = this.state.listLines.filter(r => r.Words.includes(w))[0];
			// 			var nWordIndexInClause = listWordsInSameLineAsWord.indexOf(w);
			// 			nValue = (nWordIndexInClause / (1.0 * listWordsInSameLineAsWord.length)) * 100;
			// 		}
			// 		return {HebrewTextForHint: sHebrewTextForHint, WordsToHighlight: this.MapTextIndicesToWordToHighlight(listTextIndices), x: nIndex, y: nValue}})
			// }
		}

		return {"Name": sGraphUniqueName, "Data": graphData, "GraphType": sGraphType, "OtherLinesToShow": listOtherLinesToShow, 
		"XTickKeys": listXTickKeys, "YTickKeys": listYTickKeys, XTickTotal: nXTickTotal, YTickTotal: nYTickTotal,
		"TickLabelAngle": nTickLabelAngle, "XTickLabelFontSize": nXTickLabelFontSize, "YTickLabelFontSize": nYTickLabelFontSize,
		"GraphWidth": nGraphWidth, "GraphHeight": nGraphHeight, "GraphLeftMargin": nGraphLeftMargin,
		"LegendItems": listLegendItems, "ExtraText": sExtraText };
	}

	CalculateGraphDataForAllGraphs(sGraphQuery, listParametersToUse)
	{
		sGraphQuery = this.SubstituteParameters(sGraphQuery, listParametersToUse);
		var listGraphDataAndSettingsToSet = [];
		
		if(sGraphQuery != undefined) 
		{
			//if we don't have all the data yet, before running the report, get and cache it for other reports
			if(sGraphQuery.includes("global") && this.listTextWordsForAllChapters.length === 0)
			{
				//TODO: after download, compress and put in local storage.
				//npm i lz-string
				fetch("HebrewTextData/allpsalmschapters.json")
				//.then(res => console.log(res))
				.then(res => res.json())
				.then(data => 
				{
					this.listTextWordsForAllChapters = data.OSHB;
					listGraphDataAndSettingsToSet = sGraphQuery.split(";").map(s => this.CalculateGraphData(s));					
					this.setState({ listGraphDataAndSettings: listGraphDataAndSettingsToSet });
				})
				.catch(error => this.setState({ sInfoToShow: error }));
			}
			else
			{
				listGraphDataAndSettingsToSet = sGraphQuery.split(";").map(s => this.CalculateGraphData(s));			
				this.setState({ listGraphDataAndSettings: listGraphDataAndSettingsToSet });
			}
		}
	}

	ShowGraphFromData(dataAndSettings)
	{
		this.listForSemanticDebugging = [];
		if(dataAndSettings === undefined) return '';

		var graphData = dataAndSettings.Data;
		var listOtherLinesToShow = dataAndSettings.OtherLinesToShow;
		var listXTickKeys = dataAndSettings.XTickKeys;
		var listYTickKeys = dataAndSettings.YTickKeys;
		var listLegendItems = dataAndSettings.LegendItems;
		var sExtraText = dataAndSettings.ExtraText;

		var sGraphUniqueName = dataAndSettings.Name;
		var sGraphType = dataAndSettings.GraphType;
		var nTickLabelAngle = dataAndSettings.TickLabelAngle;
		var nXTickLabelFontSize = dataAndSettings.XTickLabelFontSize;
		var nYTickLabelFontSize = dataAndSettings.YTickLabelFontSize;
		var nXTickTotal = dataAndSettings.XTickTotal;
		var nYTickTotal = dataAndSettings.YTickTotal;

		var nGraphWidth = dataAndSettings.GraphWidth;
		var nGraphHeight = dataAndSettings.GraphHeight;
		var nGraphLeftMargin = dataAndSettings.GraphLeftMargin;
		var nMaxYValue = Math.max(...graphData.map(r => r.y));

		if(sGraphType === "SemanticPatterns")
		{
			return (
				<>
				{sExtraText != undefined && <div>{sExtraText}</div>}
				<XYPlot width={nGraphWidth} height={nGraphHeight} margin={{left: nGraphLeftMargin}}> 
					<VerticalGridLines tickValues ={[0,1,2,3,4,5,6,7]} />
					<HorizontalGridLines />

					<XAxis tickFormat={v => listXTickKeys === undefined ? v : listXTickKeys[v]}
					tickTotal = {listXTickKeys === undefined ? undefined : listXTickKeys.length} 
					tickLabelAngle = {nTickLabelAngle} 
					style={{ text: {fontSize: nXTickLabelFontSize}}} />

					<YAxis tickFormat={v => listYTickKeys === undefined ? v : listYTickKeys[v]}
					tickTotal = {listYTickKeys === undefined ? undefined : listYTickKeys.length} 
					style={{ text: {fontSize: nYTickLabelFontSize}}} />

					{/* {graphDataBySeries.map(d =>  */}
					<MarkSeries 
					colorType="literal" data={graphData} //{d}
					
					onValueClick={(value, {index}) => {	
						this.setState({listGraphTextIndicesToHighlight: value.WordsToHighlight});
						this.ScrollToWords(value.WordsToHighlight);
					}}

					onNearestXY={(value, {index}) => {	
						this.setState({hintLocation: value});					
						this.setState({sHintText: value.HebrewTextForHint});											
						this.setState({sGraphUniqueNameCurrentlyShowingHint: sGraphUniqueName});
					}}
					/>
					{/* )} */}

					{this.state.sGraphUniqueNameCurrentlyShowingHint === sGraphUniqueName && 
					<Hint value={this.state.hintLocation}>
						<div style={{ 
							background: 'black',
							fontFamily: "SBL Hebrew", 
							color: "white", 
							fontSize:"22px",
							//width: this.state.listSelectedWords.includes(w) ? "750px" : "default", borderStyle: "solid"           
						}}>
						<p>{this.state.sHintText}</p>
						</div>
						</Hint>}	
					
					{/* -parseInt(nFirstTextIndexInChapter) */}
					{/* {blnShowLinesDownFromPoints && graphData.map(d => <LineSeries color="#e6e6e6" data={[{x: d.x, y:0}, {x: d.x, y: d.y}]}/>)}  						 */}
					{listOtherLinesToShow.map(l => l.MatchingTextIndexes != undefined && l.MatchingTextIndexes.map(n => <LineSeries color={l.Color} data={[{x:parseInt(n), y:0}, {x:parseInt(n), y:nMaxYValue}]}/>))}
				</XYPlot>
				</>
			)
		}
		else if(sGraphType === "Numerical")
		{
			return (
				<>
				{sExtraText != undefined && <div>{sExtraText}</div>}
				<XYPlot width={nGraphWidth} height={nGraphHeight} margin={{left: nGraphLeftMargin}}> 
					<VerticalGridLines tickValues ={[0,1,2,3,4,5,6,7]} />
					<HorizontalGridLines />

					<XAxis tickFormat={v => listXTickKeys === undefined ? v : listXTickKeys[v]}
					tickTotal = {listXTickKeys === undefined ? nXTickTotal : listXTickKeys.length} 
					tickLabelAngle = {nTickLabelAngle} 
					style={{ text: {fontSize: nXTickLabelFontSize}}}/>

					<YAxis  tickFormat={v => listYTickKeys === undefined ? v : listYTickKeys[v]}
					tickTotal = {listYTickKeys === undefined ? nYTickTotal : listYTickKeys.length} 
					style={{ text: {fontSize: nYTickLabelFontSize}}} />

					<MarkSeries 
					colorType="literal" data={graphData} 
					
					onValueClick={(value, {index}) => {	
						this.setState({listGraphTextIndicesToHighlight: value.WordsToHighlight});
						this.ScrollToWords(value.WordsToHighlight);
					}}

					onNearestXY={(value, {index}) => {	
						this.setState({hintLocation: value});					
          				this.setState({sHintText: value.HebrewTextForHint});											
						this.setState({sGraphUniqueNameCurrentlyShowingHint: sGraphUniqueName});
					}}
					/>

					{this.state.sGraphUniqueNameCurrentlyShowingHint === sGraphUniqueName && 
					<Hint value={this.state.hintLocation}>
						<div style={{ 
							background: 'black',
							fontFamily: "SBL Hebrew", 
							color: "white", 
							fontSize:"22px",
							//width: this.state.listSelectedWords.includes(w) ? "750px" : "default", borderStyle: "solid"           
						}}>
						<p>{this.state.sHintText}</p>
						</div>
				  	</Hint>}	

					{listOtherLinesToShow.map(l => l.MatchingTextIndexes != undefined && l.MatchingTextIndexes.map(n => <LineSeries color={l.Color} data={[{x:parseInt(n), y:0}, {x:parseInt(n), y:nMaxYValue}]}/>))}
				</XYPlot>
				</>
			)
		}
	}

	GetTranslationForWord(w, sToPrepend)
	{
		if(!this.state.blnShowTranslation) return "";

		var value = this.listTranslationsImported.find(o => o.TextIndexList.includes(w.TextIndex));
		return value === undefined ? "" : sToPrepend + value.Translation;
	}

	GetWordTextWithTranslationOrNot(w, blnTranslate)
	{
		if(!blnTranslate) return w.FullText;
		var value = this.listTranslationsImported.find(o => o.TextIndexList.includes(w.TextIndex));
		return value === undefined ? "" : value.Translation;
	}

	GetTextForListOfWordsWithTranslationOrNot(listWords, blnTranslate)
	{
		if(blnTranslate)
		{
			return this.listTranslationsImported.filter(o => listWords.some(w => o.TextIndexList.includes(w.TextIndex)))
				.map(o => o.Translation).join(" ");
		}
		else
			return listWords.map(w => w.FullText).join(" ");
	}

    GetGraphPopoverHintForWord(w, blnShowContextFromAllChapters)
	{
        if(blnShowContextFromAllChapters)
        {
            var listLinesToUse = this.state.blnGlobalDistributionForQueries ? 
                this.dictLinesByChapter.get(parseInt(w.Chapter)) : this.state.listLines;

            var nPlusMinusNumberOfLinesForContext = 2;
            var lineIndex = listLinesToUse.findIndex(l => l.Words.includes(w));
            var nStartIndex = Math.max(0, lineIndex - nPlusMinusNumberOfLinesForContext);
            var nEndIndex = Math.min(lineIndex + nPlusMinusNumberOfLinesForContext, listLinesToUse.length - 1);

            return listLinesToUse.slice(nStartIndex, nEndIndex + 1)
                .map(l => <div>{l.Words.map(w2 => <span style={{color: w2 === w ? "red" : "black"}}>{w2.FullText} </span>)}</div>);
        }
        else
		    return w.FullText + this.GetTranslationForWord(w, " ") //<p>{w.FullText + this.GetTranslationForWord(w, " ")}</p>;
    }

    GetRepetitionLinkGroupCategory(nGroupID)
    {
        return this.listRepetitionLinkGroupCategoryGroups.find(catgrp => catgrp.ID === nGroupID);
    }

    RepetitionLinkGroupCategoryIDIsCurrentlySelected(nGroupID)
    {
        return this.state.nCurrentRepetitionLinkGroupCategory === undefined || 
            this.listRepetitionLinkGroupCategoryGroups.findIndex(catgrp => catgrp.ID === nGroupID) === this.state.nCurrentRepetitionLinkGroupCategory;
    }

    GetSelectionIndexForRepetitionLinkGroupCategoryID(nCategoryID)
    {
        var category = this.listRepetitionLinkGroupCategories.find(cat => cat.ID === nCategoryID);
        return category === undefined ? -1 : this.listRepetitionLinkGroupCategoryGroups.findIndex(catgrp => catgrp.ID === category.Group);
    }

    IsGroupForRepetitionLinkGroupCategoryIDCurrentlySelected(nCategoryID)
    {
        //console.log(nCategoryID);
        var category = this.listRepetitionLinkGroupCategories.find(cat => cat.ID === nCategoryID);
        return  category === undefined ? false : this.RepetitionLinkGroupCategoryIDIsCurrentlySelected(category.Group);
    }

    GetDescForRepetitionLinkGroupCategoryID(nCategoryID)
    {
        var category = this.listRepetitionLinkGroupCategories.find(cat => cat.ID === nCategoryID);
        return category === undefined ? "" : category.Desc;
    }

	GetMainTypeForRepetitionLinkGroupCategoryID(nCategoryID)
    {
        var category = this.listRepetitionLinkGroupCategories.find(cat => cat.ID === nCategoryID);
        return category === undefined ? "" : category.MainType;
	}
	
    GetCurrentRepetitionLinkGroup()
    {
        if(this.state.listCurrentRepetitionLinkGroups === undefined || (this.AnyLensIsEnabled() && this.state.blnShowLenses) ||
            !(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID || this.state.sColorBy === "rgrp")) return undefined;
           
        var group = this.state.listCurrentRepetitionLinkGroups[this.state.nCurrentRepetitionLinkGroupSelectedIndex];
        return group.Type === this.state.nCurrentLinkGroupType ? group : undefined;
    }

	UsingAWordTagTool()
	{
		return this.state.nSelectedToolID === this.nSemanticRolesToolID || this.state.nSelectedToolID === this.nSemanticCategoryToolID;
	}

	GetCurrentWordTag()
	{
		if(!this.UsingAWordTagTool()) return undefined;
		return this.state.currentWordTag;
	}

	IsForSuffixModeForWordTags(w)
	{
		if(w === undefined) return false;

		return w.SuffixPerson != undefined && (this.state.blnZDown || w.WordType === "R");
	}

    GetRepetitionLinkGroupList()
    {
        if(this.state.listRepetitionLinkGroups === undefined) return undefined;
        return this.state.listRepetitionLinkGroups.filter(g => g.Type === this.state.nCurrentLinkGroupType);
    }

    DoesCurrentRepetitionLinkGroupIncludeWord(w)
    {
        var group = this.GetCurrentRepetitionLinkGroup();
        return group === undefined ? false : group.ListWords.includes(w.TextIndex) && 
            (group.ListTags.length === 0 || group.ListTags.some(t => this.IsGroupForRepetitionLinkGroupCategoryIDCurrentlySelected(t.CategoryID)));
    }

    DoesSelectedCurrentRepetitionLinkGroupIncludeWord(w)
    {
        if(w === undefined) return false

        var selected = this.GetCurrentRepetitionLinkGroup();
        return selected != undefined && selected.ListWords.includes(w.TextIndex);
    }

    IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(w)
    {
        var selected = this.GetCurrentRepetitionLinkGroup();
        return selected != undefined && selected.WordsForWhichParticipantRefIsForSuffix.includes(w.TextIndex);
    }

    InParticipantRefMode()
    {
        return this.state.nCurrentLinkGroupType === 2;
    }

    SetTagRelationPairReversed(tag, blnToSet)
    {
        if(tag === undefined) return;
        tag.RelationPairReversed = blnToSet;
        this.SaveRepetitionLinkGroupsAndSetState(this.state.listRepetitionLinkGroups);
    }

    GetRepetitionLinkGroupWordsForWhichParticipantRefIsForSuffix(repetitionLinkGroup)
    {
        return repetitionLinkGroup === undefined ? false : repetitionLinkGroup.WordsForWhichParticipantRefIsForSuffix;
    }

    SetRepetitionLinkGroupWordsForWhichParticipantRefIsForSuffix(repetitionLinkGroup, listToSet)
    {
        if(repetitionLinkGroup === undefined) return;
        repetitionLinkGroup.WordsForWhichParticipantRefIsForSuffix = listToSet;
        this.SaveRepetitionLinkGroupsAndSetState(this.state.listRepetitionLinkGroups);
    }

    RelationPairTagsForRepetitionLinkGroup(repetitionLinkGroup)
    {
        return repetitionLinkGroup === undefined ? [] : repetitionLinkGroup.ListTags.filter(t => this.GetDescForRepetitionLinkGroupCategoryID(t.CategoryID).includes("->"));
    }

    GetTagRelationPairText(tag)
    {
        var sText = this.GetDescForRepetitionLinkGroupCategoryID(tag.CategoryID);
        return !tag.RelationPairReversed ? sText : sText.split("->").reverse().join(" -> ");
    }

    IsWordBeingHoveredOn(w)
    {
        return this.state.listWordsHoveredWhileDragging != undefined && this.state.listWordsHoveredWhileDragging.includes(w);
    }

    IsWordBeingDragged(w)
    {
        return this.state.listWordsDraggedFrom != undefined && this.state.listWordsDraggedFrom.includes(w);
    }
    
    MergeTranslationsForEdit(listWords)
    {
        //{"ListHebrewWords":["123","234"],"Translation":"Blessings on1-3 the man2"}
        //TODO: keep them in the right order
        var listToMerge = this.state.listTranslations.filter(o => listWords.some(w => o.ListHebrewWords.includes(w.TextIndex)));
        return listToMerge.map(o => {
            var sIndexes = o.ListHebrewWords.map(s => listWords.findIndex(w => w.TextIndex === s) + 1).join("-");
            return o.Translation + sIndexes;
        }).join(" ");
    }

    SplitAndSaveEditedTranslation(listWords, sTranslation)
    {
        //TODO: how to overwrite
        var listToSet = this.state.listTranslations;
        var listToReplace = this.state.listTranslations.filter(o => listWords.some(w => o.ListHebrewWords.includes(w.TextIndex)));

		//[,.!?\-":;]?

		//split by space if there is digit in the word before the space
		var listTranslationSplitByNumber = [];
		var sNextToPush = "";
		for(var s of sTranslation.split(/\s+/))
		{
			//test1 
			//asd 
			//sdsd2
			
			sNextToPush += " " + s;
			if(s.match(/\d/) != null) 
			{
				listTranslationSplitByNumber.push(sNextToPush);
				sNextToPush = "";
			}
		}

        var listToInsert = listTranslationSplitByNumber.map(s => s.trim()).filter(s => s.length > 0).
            map(s => { 
                var match = s.match(/(\D+)([\d-]+)(\D+)?/);
                if(match != null) 
                {
                    var sTranslationPart = match[1] + (match[3] === undefined ? "" : match[3]);
                    var sNumberPart = match[2];
                    var listIndexesInString = sNumberPart.split("-").map(s => parseInt(s.trim()) - 1);
                    var listHebrewTextIndexes = listWords.filter((w, nIndex) => listIndexesInString.includes(nIndex)).map(w => w.TextIndex);
                    return {ListHebrewWords: listHebrewTextIndexes, Translation: sTranslationPart}
                }

                return undefined;
            }).filter(o => o != undefined);
        
        listToReplace.forEach(o => {
            var nIndexToRemove = listToSet.findIndex(o2 => o2 === o);
            listToSet.splice(nIndexToRemove, 1);
        })

        listToSet = listToSet.concat(listToInsert);

        this.SaveTranslations(listToSet);
    }

    GetTextIndexRangeForVerseRange(range)
    {
        var listWordsForRangeBegin = this.listTextWordsForChapter.filter(w => w.Verse === range.Begin)
        var listWordsForRangeEnd = this.listTextWordsForChapter.filter(w => w.Verse === range.End)

        if(listWordsForRangeBegin.length === 0 || listWordsForRangeEnd.length === 0) return undefined

        return {Begin: parseInt(listWordsForRangeBegin[0].TextIndex), End: parseInt(listWordsForRangeEnd[listWordsForRangeEnd.length - 1].TextIndex)}
    }

    ParseVerseRangesFromText(s)
    {
        return s.split(',').map(s => {
            var listRangeBounds = s.trim().split('-')
            return {Begin: listRangeBounds[0], End: listRangeBounds[listRangeBounds.length - 1]}
        })
    }

    GetTextIndexRangesForCurrentVerseRangesString()
    {
        if(this.state.sVerseRangesToHighlight.length === 0) return []

        //this.state.sVerseRangesToHighlight 2-3, 10-11, 20
        // console.log(this.ParseVerseRangesFromText(this.state.sVerseRangesToHighlight))
        return this.ParseVerseRangesFromText(this.state.sVerseRangesToHighlight).map(r => this.GetTextIndexRangeForVerseRange(r)).filter(rh => rh != undefined)
    }

    GetLineIndexRangeForVerseRange(range)
    {
        var listLinesForRangeBegin = this.state.listLines.filter(l => l.Words.some(w => w.Verse === range.Begin))
        var listLinesForRangeEnd = this.state.listLines.filter(l => l.Words.some(w => w.Verse === range.End))

        if(listLinesForRangeBegin.length === 0 || listLinesForRangeEnd.length === 0) return undefined

        return {Begin: this.state.listLines.indexOf(listLinesForRangeBegin[0]), End: this.state.listLines.indexOf(listLinesForRangeEnd[listLinesForRangeEnd.length - 1])}
    }

    GetLineIndexRangesForCurrentVerseRangesString()
    {
        if(this.state.sVerseRangesToHighlight.length === 0) return []
        return this.ParseVerseRangesFromText(this.state.sVerseRangesToHighlight).map(r => this.GetLineIndexRangeForVerseRange(r)).filter(rh => rh != undefined)
    }

    PossiblyRestrictWordGroupsToVerseRanges(listWordGroups, listTextIndexRanges)
    {
        if(this.state.blnRestrictTextToVerseRangesToHighlight)
        {
            return listWordGroups.filter((g,n) => g.ListWords.some(w => {
                var nTextIndex = parseInt(w.TextIndex)
                return listTextIndexRanges.some(r => nTextIndex >= r.Begin && nTextIndex <= r.End)}))
        }
        else return listWordGroups
    }
    
    CompareVersesLikeLineCharts()
    {
        var listVersesInChapter = [...new Set(this.listTextWordsForChapter.map(w => w.Verse))]

        var listWordGroupsForConsonants = this.GetConsonantGroupsToUse().map(g => 
            ({ListWords: this.listTextWordsForChapter.filter(w => this.GetCharsInWord(w.FullText, []).some(c => g.ListChars.includes(c))), Name: g.Name}))

        var listWordGroupsForSemanticDomains = this.MainSemanticDomainsLens()

        var listWordGroupsForRepeatedRoots = this.RepeatedRootsLens(false).filter(g => g.ListWords.some(w => ['N', 'V', 'A', 'P'].includes(w.WordType)))
        listWordGroupsForRepeatedRoots.forEach(g => g.Name = g.ListWords[0].FullText)

        var listScoresByPair = []
        for(var v1 of listVersesInChapter)
        {
            for(var v2 of listVersesInChapter)
            {
                if(v1 === v2 || listScoresByPair.some(osp => osp.V1 === v2 && osp.V2 === v1)) continue

                //count the number of occurrences within the ranges and multiply by the percent of occurrence outside the ranges.
                var listRanges = [this.GetTextIndexRangeForVerseRange({Begin: v1, End: v1}), this.GetTextIndexRangeForVerseRange({Begin: v2, End: v2})]
                var listAllValidScoresForPairs = []

                for(var listWordGroups of [listWordGroupsForSemanticDomains, listWordGroupsForConsonants])
                {
                    for(var g of listWordGroups)
                    {
                        // if(v1 === '1' && v2 === '3') console.log(g)
                        // if(v1 === '1' && v2 === '3') console.log(v1, v2, listWithinRanges)

                        var listWords = g.ListWords.map(w => ({Word: w, Index: parseInt(w.TextIndex)}))
                        var blnAllRangesHaveAWordWithinRange = listRanges.every(r => listWords.some(o => o.Index >= r.Begin && o.Index <= r.End))
            
                        if(blnAllRangesHaveAWordWithinRange)
                        {
                            var listWithinRanges = listWords.filter(o => listRanges.some(r => o.Index >= r.Begin && o.Index <= r.End))

                            if(listWordGroups === listWordGroupsForSemanticDomains)
                            {
                                //add to the score depending on how many of the parent roots are the same
                                var listWithinRangesGroupedByRoot = new Set(listWithinRanges.map(o => o.Word.ParentRoot))
                                var nPercentWithinRangesWithSameRoot = 1 - (listWithinRangesGroupedByRoot.size / (1.0 * listWithinRanges.length))
                                var nScore = (listWithinRanges.length / (1.0 * listWords.length)) * (1 + nPercentWithinRangesWithSameRoot)

                                if(v1 === '1' && v2 === '3') console.log(v1, v2, listWithinRanges)

                                listAllValidScoresForPairs.push({Name: g.Name, TextIndexesWithinRange: listWithinRanges, Score: nScore, ScoreType: 'Semantic'})
                            }
                            else if(listWordGroups === listWordGroupsForConsonants)
                            {
                                //add the percent if the percent of this consonant within range reaches a threshold
                                var nPercentWithinRange = (listWithinRanges.length / (1.0 * listWords.length))
                                var nScore = nPercentWithinRange >= 0.5 ? nPercentWithinRange : 0

                                listAllValidScoresForPairs.push({Name: g.Name, TextIndexesWithinRange: listWithinRanges, Score: nScore, ScoreType: 'Consonants'})
                            }
                        }
                    }
                }

                listScoresByPair.push({V1: v1, V2: v2, Scores: listAllValidScoresForPairs, 
                    TotalSemanticScore: Math.round(listAllValidScoresForPairs.filter(o => o.ScoreType === 'Semantic').reduce((acc, o) => acc + o.Score, 0), 2),
                    TotalConsonantsScore: Math.round(listAllValidScoresForPairs.filter(o => o.ScoreType === 'Consonants').reduce((acc, o) => acc + o.Score, 0), 2),
                })
            }
        }

        listScoresByPair.sort((a,b) => b.TotalSemanticScore - a.TotalSemanticScore)
        navigator.clipboard.writeText(listScoresByPair.map(o => o.V1 + ',' +  o.V2 + ' ' +  o.TotalSemanticScore + ' ' +  o.TotalConsonantsScore).join('\n'))

        // console.log(listScoresByPair)
        
        // listScoresByPair.sort((a,b) => b.TotalConsonantsScore - a.TotalConsonantsScore)
        // console.log(listScoresByPair)

        window.alert('done with CompareVersesLikeLineCharts!')
    }

    GetMinDistanceToRanges(listWords, listTextIndexRanges)
    {
        //the minimum closeness the closest point in the group is to the range
        return Math.min(...listTextIndexRanges.map(r => Math.min(...listWords.map(w => {
            var nTextIndex = parseInt(w.TextIndex)
            return (nTextIndex >= r.Begin && nTextIndex <= r.End) ? 0 : Math.min(Math.abs(nTextIndex - r.Begin), Math.abs(nTextIndex - r.End))
        })))) 
    }

    GetWithinRangeSortValue(listWords, listTextIndexRanges)
    {
        var listTextIndexes = listWords.map(w => parseInt(w.TextIndex))

        var listTextIndexRangesToUse = listTextIndexRanges.filter(r => r != undefined)

        var blnAllRangesHaveAllWordWithinRange = listTextIndexRangesToUse.every(r => listTextIndexes.every(n => n >= r.Begin && n <= r.End))
        if(blnAllRangesHaveAllWordWithinRange) return 0

        var blnAllRangesHaveAWordWithinRange = listTextIndexRangesToUse.every(r => listTextIndexes.some(n => n >= r.Begin && n <= r.End))
        if(blnAllRangesHaveAWordWithinRange) return 5

        var nTolerance = 5
        var blnAllRangesHaveAWordCloseToRange = listTextIndexRangesToUse.every(r => listTextIndexes.some(n => n >= r.Begin - nTolerance && n <= r.End + nTolerance))
        if(blnAllRangesHaveAWordCloseToRange) return 10 

        nTolerance = 10
        blnAllRangesHaveAWordCloseToRange = listTextIndexRangesToUse.every(r => listTextIndexes.some(n => n >= r.Begin - nTolerance && n <= r.End + nTolerance))
        if(blnAllRangesHaveAWordCloseToRange) return 15

        return 100
    }

    GetLinkGroupByUnitFrequencies(listLinkGroups, listLineGroups)
    {
        var listData = []
        var listTopLinkGroupsWordsSyllableIndexesAndColorsToSet = []
        var listAllGroupsWordsToSet = []
        
        for(var nLineGroup = 0; nLineGroup < listLineGroups.length; nLineGroup++)
        {
            let listWordsInLineGroup = listLineGroups[nLineGroup].Lines.flatMap(l => l.Words)
            for(var nLinkGroup = 0; nLinkGroup < listLinkGroups.length; nLinkGroup++)
            {
                let oLinkGroup = listLinkGroups[nLinkGroup]
                let listWordsInLinkGroup = oLinkGroup.ListWords
                let nNumberOfWordsInLineGroupWithThisLinkGroup = listWordsInLinkGroup.filter(w => listWordsInLineGroup.includes(w)).length
                let nPercentageOfWordsInLineGroupWithThisLinkGroup = nNumberOfWordsInLineGroupWithThisLinkGroup / (1.0 * listWordsInLineGroup.length)

                listData.push({x: nLineGroup, y: nLinkGroup, LinkGroup: oLinkGroup, NumberOfWordsInLineGroupWithThisLinkGroup: nNumberOfWordsInLineGroupWithThisLinkGroup, 
                    color: nPercentageOfWordsInLineGroupWithThisLinkGroup})
            }

            var listDataForLineGroup = listData.filter(o => o.x === nLineGroup && o.NumberOfWordsInLineGroupWithThisLinkGroup > 1)
            listDataForLineGroup.sort((a,b) => b.color - a.color)
        
            //[ "Blue", "Red", "Fuchsia", "Green", "DarkMagenta", "DarkOrange", "Maroon", "CornflowerBlue", "Indigo", "Salmon",  
	        //"Brown", "hsl(43, 80%, 40%)", "Black", "Crimson", "Olive"]
            
            let listAllDataForTextHighlighting = listDataForLineGroup.flatMap(o => 
                o.LinkGroup.ListWords.filter(w => listWordsInLineGroup.includes(w))
                .map(w => ({Word: w, Name: o.LinkGroup.Name})))

            let listDataForTextHighlightingTopGroups = listDataForLineGroup
                .slice(0, Math.min(this.state.nTopNThresholdForGroupByUnitHeatmap, listDataForLineGroup.length))
                .flatMap((o, n) => o.LinkGroup.ListWords.filter(w => listWordsInLineGroup.includes(w))
                .map(w => ({Word: w, Name: o.LinkGroup.Name,
                    Color: n === 0 ? 'Blue' : 
                    n === 1 ? 'CornflowerBlue' : 
                    n === 2 ? 'Salmon' : 
                    n === 3 ? 'Crimson' : 
                    n === 4 ? 'DarkMagenta' : 
                    n === 5 ? 'Fuchsia' : 
                    n === 6 ? 'Maroon' : 
                    n === 7 ? 'Olive' : 
                    n === 8 ? 'Indigo' : 'Black'})))

            listTopLinkGroupsWordsSyllableIndexesAndColorsToSet = listTopLinkGroupsWordsSyllableIndexesAndColorsToSet.concat(
                listDataForTextHighlightingTopGroups)
            listAllGroupsWordsToSet = listAllGroupsWordsToSet.concat(
                listAllDataForTextHighlighting)
        }

        return {ChartData: listData, TopGroupsWordsAndColors: listTopLinkGroupsWordsSyllableIndexesAndColorsToSet,
            AllGroupsWords: listAllGroupsWordsToSet}
    }

    FindOutliersWithIQR(data) 
    {
        // Sort the data in ascending order
        const sortedData = [...data].sort((a, b) => a - b);
        const n = sortedData.length;
      
        // Calculate the first quartile (Q1)
        const q1 = sortedData[Math.floor(n / 4)];
      
        // Calculate the third quartile (Q3)
        const q3 = sortedData[Math.ceil(n * 3 / 4) - 1];
        
        // Calculate the Interquartile Range (IQR)
        const iqr = q3 - q1;
      
        // Define the upper boundary for outliers
        const upperBoundary = q3 + 1.5 * iqr;
      
        // Filter for and return the outliers
        return sortedData.filter(number => number > upperBoundary);
    }
    
    ListOfPointsSatisfiesCriteria(listPointsInCurrentSequence, nMinConsecutivePoints)
    {
        return listPointsInCurrentSequence.length >= nMinConsecutivePoints || 
            (listPointsInCurrentSequence.length >= nMinConsecutivePoints - 1 && 
                listPointsInCurrentSequence.reduce((acc, o) => acc + o.NumberOfWordsInLineGroupWithThisSoundGroup, 0) >= nMinConsecutivePoints + 1)
    }

    FilterConsecutivePoints(listPoints, nMinConsecutivePoints) 
    {
        let listYValues = [...new Set(listPoints.map(o => o.y))]

        var listLongEnoughSequences = []
        for(var nY of listYValues)
        {
            let listPointsForThisY = listPoints.filter(o => o.y === nY)
            listPointsForThisY.sort((a,b) => a.x - b.x)

            var listPointsInCurrentSequence = []
            for(var n = 0; n < listPointsForThisY.length; n++)
            {
                let oCurrentPoint = listPointsForThisY[n]
                if(oCurrentPoint.NumberOfWordsInLineGroupWithThisSoundGroup >= 1)
                {
                    listPointsInCurrentSequence.push(oCurrentPoint)
                }
                else
                {
                    if(this.ListOfPointsSatisfiesCriteria(listPointsInCurrentSequence, nMinConsecutivePoints))
                    {
                        listLongEnoughSequences.push(...listPointsInCurrentSequence)
                    }

                    listPointsInCurrentSequence = []
                }
            }

            if(this.ListOfPointsSatisfiesCriteria(listPointsInCurrentSequence, nMinConsecutivePoints))
            {
                listLongEnoughSequences.push(...listPointsInCurrentSequence)
            }
        }

        //console.log(listLongEnoughSequences)
        return listLongEnoughSequences

        // 1. Sort the points by y, then by x.
        // points.sort((a, b) => 
        // {
        //     if (a.y !== b.y) 
        //     {
        //         return a.y - b.y
        //     }

        //     return a.x - b.x
        // })
        
        // var filteredData = []
        // var currentSequence = []
        
        // console.log(points.filter(o => o.SoundGroup.Name === 'l').map(o => ({x: o.x, y: o.y, n: o.NumberOfWordsInLineGroupWithThisSoundGroup})))
        // for (let i = 0; i < points.length; i++) 
        // {
        //     const currentPoint = points[i];
        //     const prevPoint = points[i - 1];
        
        //     // Check if the current point is a continuation of the sequence
        //     if(prevPoint &&
        //         currentPoint.y === prevPoint.y &&
        //         currentPoint.x === prevPoint.x + 1 &&
        //         currentPoint.NumberOfWordsInLineGroupWithThisSoundGroup >= 1) 
        //     {
        //         // If the sequence just started (first continuation), add the previous point
        //         if (currentSequence.length === 0) 
        //         {
        //             currentSequence.push(prevPoint);
        //         }
                
        //         currentSequence.push(currentPoint);
        //     } 
        //     else 
        //     {
        //         // If the sequence is broken or the condition is not met
        //         // Check if the previous sequence met the length requirement (>= nMinConsecutivePoints)
        //         if (currentSequence.length >= nMinConsecutivePoints) 
        //         {
        //             filteredData.push(...currentSequence);
        //         }
                
        //         // Reset the current sequence, considering the current point if it meets the n condition
        //         currentSequence = currentPoint.NumberOfWordsInLineGroupWithThisSoundGroup >= 1 ? [currentPoint] : [];
        //     }
        // }
        
        // // Final check for the last sequence after the loop finishes
        // if (currentSequence.length >= nMinConsecutivePoints) 
        // {
        //     filteredData.push(...currentSequence);
        // }
        
        // // Optional: Remove duplicate points if a single point was part of multiple valid sequences (e.g., overlapping sequences, though unlikely with consecutive x)
        // //const uniqueFilteredData = Array.from(new Set(filteredData));
        // return filteredData
    }

    GetSoundGroupByUnitFrequencies(listSoundGroups, listLineGroups, blnSoundsPerLineNotWordsWithSound)
    {
        var listData = []
        var listTopSoundGroupNames = []
        var listTopSoundGroupsWordsSyllableIndexesAndColorsToSet = []
        var listAllSoundGroupsWordsSyllableIndexesToSet = []

        for(var nLineGroup = 0; nLineGroup < listLineGroups.length; nLineGroup++)
        {
            let listWordsInLineGroup = listLineGroups[nLineGroup].Lines.flatMap(l => l.Words)
            for(var nSoundGroup = 0; nSoundGroup < listSoundGroups.length; nSoundGroup++)
            {
                let oSoundGroup = listSoundGroups[nSoundGroup]
                let listWordsInSoundGroup = oSoundGroup.ListWords
                let nNumberOfWordsInLineGroupWithThisSoundGroup = listWordsInSoundGroup.filter(w => listWordsInLineGroup.includes(w)).length
                //let nNumberOfOccurrencesOfSoundGroupInLineGroup =
                let nPercentageOfWordsInLineGroupWithThisSoundGroup = nNumberOfWordsInLineGroupWithThisSoundGroup / (1.0 * listWordsInLineGroup.length)

                listData.push({x: nLineGroup, y: nSoundGroup, ListWordsInLineGroup: listWordsInLineGroup, SoundGroup: oSoundGroup, 
                    NumberOfWordsInLineGroupWithThisSoundGroup: nNumberOfWordsInLineGroupWithThisSoundGroup, 
                    size: nNumberOfWordsInLineGroupWithThisSoundGroup}) //color: nPercentageOfWordsInLineGroupWithThisSoundGroup
            }

            var listDataForLineGroup = listData.filter(o => o.x === nLineGroup && o.SoundGroup.Name !== 'a' && o.NumberOfWordsInLineGroupWithThisSoundGroup > 1)
            listDataForLineGroup.sort((a,b) => b.color - a.color)
            //console.log(listDataForLineGroup.map(o => o.color.toFixed(2)), this.FindOutliersWithIQR(listDataForLineGroup.map(o => o.color)))

            let listAllDataForTextHighlighting = listDataForLineGroup.flatMap(o => 
                o.SoundGroup.ListWordsAndSyllableIndexesInWords.filter(o2 => listWordsInLineGroup.includes(o2.Word))
                .map(o2 => ({Word: o2.Word, SyllableIndexes: o2.SyllableIndexes, Name: o.SoundGroup.Name})))

            let listDataForLineGroupForTopGroups = listDataForLineGroup
                .slice(0, Math.min(this.state.nTopNThresholdForGroupByUnitHeatmap, listDataForLineGroup.length))

            let listDataForTextHighlightingTopGroups = listDataForLineGroupForTopGroups
                .filter(o => o.color >= 0.4)
                .flatMap((o, n) => o.SoundGroup.ListWordsAndSyllableIndexesInWords.filter(o2 => listWordsInLineGroup.includes(o2.Word))
                .map(o2 => ({Word: o2.Word, SyllableIndexes: o2.SyllableIndexes, Name: o.SoundGroup.Name,
                    Color: n === 0 ? 'Blue' : 
                    n === 1 ? 'CornflowerBlue' : 
                    n === 2 ? 'Salmon' : 
                    n === 3 ? 'Crimson' : 
                    n === 4 ? 'DarkMagenta' : 
                    n === 5 ? 'Fuchsia' : 
                    n === 6 ? 'Maroon' : 
                    n === 7 ? 'Olive' : 
                    n === 8 ? 'Indigo' : 'Black'})))

            listTopSoundGroupNames.push(listDataForLineGroupForTopGroups.map(o => o.SoundGroup.Name).join('.'))
            
            listTopSoundGroupsWordsSyllableIndexesAndColorsToSet = listTopSoundGroupsWordsSyllableIndexesAndColorsToSet.concat(
                listDataForTextHighlightingTopGroups)
            listAllSoundGroupsWordsSyllableIndexesToSet = listAllSoundGroupsWordsSyllableIndexesToSet.concat(
                listAllDataForTextHighlighting)
        }

        return {ChartData: listData, TopGroupNameString: listTopSoundGroupNames.join(', '), 
            TopGroupsWordsSyllableIndexesAndColors: listTopSoundGroupsWordsSyllableIndexesAndColorsToSet,
            AllSoundGroupsWordsSyllableIndexes: listAllSoundGroupsWordsSyllableIndexesToSet}
    }

    GetSoundGroupByUnitHeatmap(blnSoundsPerLineNotWordsWithSound)
    {
        let sUnitToGroupBy = this.state.sGroupLinesByForGroupByUnitHeatmap //'Line' //'StartsRepetitionGroup' //this.state.sGroupLinesByForLens
        let listLines1 = this.state.listLines.filter(l => !l.IsSuperscription)
        let listLineGroups = sUnitToGroupBy === 'Line' ? listLines1.map(l => ({Lines: [l]})) : 
            this.GetLinesForSideBySideMode(listLines1, sUnitToGroupBy)
            //this.GetLineGroupsForDevelopmentDiagram(listLines1)

        let listSoundGroups = this.WordsBySoundGroupLens(this.listTextWordsForChapter, 'anywhere')
            .filter(g => g.Name !== 'a' && g.Name !== 'i') //!g.Group.IsVowel
            
        let oData = this.GetSoundGroupByUnitFrequencies(listSoundGroups, listLineGroups, blnSoundsPerLineNotWordsWithSound)
        let listData = (this.state.blnFilterSoundGroupsByUnitBySameSoundInConsecutiveLineGroups ? 
            this.FilterConsecutivePoints(oData.ChartData, this.state.nMinDevelopmentDiagramLinkGroupLengthToShow) : oData.ChartData)
            .filter(o => o.NumberOfWordsInLineGroupWithThisSoundGroup > 0)
        
        let listSoundGroupsNames = [...new Set(listData.map(o => o.SoundGroup.Group.Name))]
        let listAllSoundGroupsWordsSyllableIndexes1 = listSoundGroups.flatMap(g => {
            let nSoundGroupIndex = listSoundGroupsNames.indexOf(g.Name)
            let sColor = nSoundGroupIndex === -1 ? 'Black' : this.listLinkGroupColors[nSoundGroupIndex % this.listLinkGroupColors.length]
            return g.ListWordsAndSyllableIndexesInWords.map(o2 => ({Name: g.Name, Color: sColor, Word: o2.Word, SyllableIndexes: o2.SyllableIndexes}))
        })

        this.listTopSoundGroupsWordsSyllableIndexesAndColors = listAllSoundGroupsWordsSyllableIndexes1
            .filter(o => listData.some(o2 => o2.SoundGroup.Name === o.Name && o2.ListWordsInLineGroup.includes(o.Word)))

        //this.listTopSoundGroupsWordsSyllableIndexesAndColors = oData.TopGroupsWordsSyllableIndexesAndColors
        //console.log(this.listAllSoundGroupsWordsSyllableIndexes)
        this.listAllSoundGroupsWordsSyllableIndexes = listAllSoundGroupsWordsSyllableIndexes1

        //recalculate y in case some sound groups have been removed by the above filtering
        for(var nSoundGroupName = 0; nSoundGroupName < listSoundGroupsNames.length; nSoundGroupName++)
        {
            listData.filter(o => o.SoundGroup.Name === listSoundGroupsNames[nSoundGroupName]).forEach(o => o.y = nSoundGroupName)
        }

        //console.log(listSoundGroups.flatMap(g => 
        //    g.ListWordsAndSyllableIndexesInWords.map(o2 => ({Name: g.Name, Word: o2.Word, SyllableIndexes: o2.SyllableIndexes}))))

        //console.log(listSoundGroups.filter(o => o.Name === 't'))
        //console.log([...new Set(oData.AllSoundGroupsWordsSyllableIndexes.map(o => parseInt(o.Word.TextIndex)))].sort())
        // console.log(oData.ChartData.filter(o2 => o2.ListWordsInLineGroup.some(o => o.TextIndex === "6097")),
        //     listData.filter(o2 => o2.ListWordsInLineGroup.some(o => o.TextIndex === "6097")),
        //     oData.AllSoundGroupsWordsSyllableIndexes.filter(o => o.Word.TextIndex === "6097"),
        //     this.listTopSoundGroupsWordsSyllableIndexesAndColors.filter(o => o.Word.TextIndex === "6097"))

        // .map(o2 => ({Word: o2.Word, SyllableIndexes: o2.SyllableIndexes, Name: o.SoundGroup.Name,
        //     Color: n === 0 ? 'Blue' : 
        //     n === 1 ? 'CornflowerBlue' : 
        //     n === 2 ? 'Salmon' : 
        //     n === 3 ? 'Crimson' : 
        //     n === 4 ? 'DarkMagenta' : 
        //     n === 5 ? 'Fuchsia' : 
        //     n === 6 ? 'Maroon' : 
        //     n === 7 ? 'Olive' : 
        //     n === 8 ? 'Indigo' : 'Black'})))
            
        //o.SoundGroup.Name === 'a'
        //console.log(listData.filter(o => o.NumberOfWordsInLineGroupWithThisSoundGroup > 0))
        //console.log(this.FilterConsecutivePoints(listData))

        return this.state.blnShowLineCharts && 
        <XYPlot width={1100} height={listSoundGroupsNames.length * 30} 
        margin={{left: 300 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 10}}>			
            {/* <HeatmapSeries data={listData} colorRange={['blue', 'green']} /> */}
            <MarkSeries data={listData} sizeRange={[5, 10]} 
                onValueMouseOver={(oHoveredData, event) => {
                    if(!this.state.blnHoveredObjectForSoundGroupByUnitChartIsStickied)
                    {
                        this.setState({oHoveredObjectForSoundGroupByUnitChart: oHoveredData})
                    }
                }}
                
                onValueMouseOut={() => {
                    if(!this.state.blnHoveredObjectForSoundGroupByUnitChartIsStickied)
                    {
                        this.setState({oHoveredObjectForSoundGroupByUnitChart: null})
                    }
                }}

                onValueClick={(oHoveredData, event) => {
                    if(oHoveredData === this.state.oHoveredObjectForSoundGroupByUnitChart)
                    {
                        this.setState({blnHoveredObjectForSoundGroupByUnitChartIsStickied: false})
                        this.setState({oHoveredObjectForSoundGroupByUnitChart: null})
                    }
                    else
                    {
                        this.setState({blnHoveredObjectForSoundGroupByUnitChartIsStickied: true})
                        this.setState({oHoveredObjectForSoundGroupByUnitChart: oHoveredData})
                    }
                }}
            />
            
            <YAxis orientation='right' position='start' 
                tickFormat={v => listSoundGroupsNames[v]}
                tickTotal = {listSoundGroupsNames.length}  
                style={{text: {fontFamily: 'Calibri', fontSize: 20}}} />
            {/* <XAxis tickTotal = {listLineGroups.length} /> */}
        </XYPlot>
    }

    GetSemanticGroupByUnitHeatmap(blnByRoot)
    {
        let sUnitToGroupBy = this.state.sGroupLinesByForGroupByUnitHeatmap //'StartsRepetitionGroup' //this.state.sGroupLinesByForLens
        let listLineGroups = sUnitToGroupBy === 'Line' ? this.state.listLines.map(l => ({Lines: [l]})) : 
            this.GetLinesForSideBySideMode(this.state.listLines, sUnitToGroupBy)
        let listLinkGroups = blnByRoot ? this.RepeatedRootsLens(this.listTextWordsForChapter, false) : this.SemanticChainsLens(this.listTextWordsForChapter)

        let oData = this.GetLinkGroupByUnitFrequencies(listLinkGroups, listLineGroups)
        let listLinkGroupsNames = listLinkGroups.map(g => g.ListWords.length === 0 ? '' : this.GetOurTranslationForWord(g.ListWords[0]))
        let listData = oData.ChartData

        this.listTopGroupsWordsAndColors = oData.TopGroupsWordsAndColors
        this.listAllGroupsWords = oData.AllGroupsWords

        return this.state.blnShowLineCharts && <>
        <XYPlot width={1100} height={listLinkGroupsNames.length * 30} margin={{left: 300 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 5}}>			
            <HeatmapSeries data={listData} colorRange={['blue', 'green']} />
            <YAxis orientation='right' position='start' 
                tickFormat={v => listLinkGroupsNames[v]}
                tickTotal = {listLinkGroupsNames.length}  
                style={{text: {fontFamily: 'Calibri', fontSize: 20}}} />
            <XAxis tickTotal = {listLineGroups.length} />
        </XYPlot>
        </>
    }

    // GetSoundGroupsForSyllableRhyme()
    // {
    //     let listSoundGroups = this.WordsBySoundGroupLens(this.listTextWordsForChapter, 'anywhere')
    //     this.listSoundGroupsForSyllableRhyme = listSoundGroups

    //     // return this.state.blnShowLineCharts && <>
    //     // <XYPlot width={1100} height={600} margin={{left: 300 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 5}}>			
    //     //     <HeatmapSeries data={listData} colorRange={['blue', 'green']} />
    //     //     <YAxis orientation='right' position='start' 
    //     //         tickFormat={v => listSoundGroupsNames[v]}
    //     //         tickTotal = {listSoundGroups.length}  
    //     //         style={{text: {fontFamily: 'Calibri', fontSize: 20}}} />
    //     //     <XAxis tickTotal = {listLineGroups.length} />
    //     // </XYPlot>
    //     // <div>{oData.TopGroupNameString}</div>
    //     // </>
    // }

    GetSoundLineChart()
    {
        var listTextIndexRangesToHighlight = this.GetTextIndexRangesForCurrentVerseRangesString()

        var listLensWordGroups = []
        var listYTickKeys = []

        listLensWordGroups = this.WordsBySoundGroupLens(this.listTextWordsForChapter, 'anywhere').map((g, ng) => 
            ({ListWords: g.ListWords, Name: g.Name, Y: ng, Color: 'LightGray'}))

        listLensWordGroups = this.PossiblyRestrictWordGroupsToVerseRanges(listLensWordGroups, listTextIndexRangesToHighlight)
        listLensWordGroups.forEach((g, ng) => g.ID = 'letters_' + ng.toString())

        listLensWordGroups.sort((a,b) => a.Y - b.Y)

        //listYTickKeys must come after the sort to keep the orders synchronized!
        listYTickKeys = listLensWordGroups.map(g => g.Name)
        //console.log(listLensWordGroups)
       
        var nMaxY = listYTickKeys.length
        var nHeight = 25 * nMaxY

        var listTextIndexesInChapter = this.listTextWordsForChapter.map(w => parseInt(w.TextIndex))
        var nMinTextIndexForChapter = Math.min(...listTextIndexesInChapter)
        var nMaxTextIndexForChapter = Math.max(...listTextIndexesInChapter)

        return <XYPlot width={1000} height={nHeight < 100 ? 100 : nHeight} margin={{left: 275 + this.state.nLeftChartAlignmentOffset, right: 100, top: 5, bottom: 10}}
            onMouseEnter={() => this.setState({blnLetterLineChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnLetterLineChartPopupIsVisible: false})}>

            {this.GetGroupBreakLines(nMaxY, false, this.state.sGroupLinesBy)}
            {this.GetVerseBreakLines(nMaxY)}

            {listTextIndexRangesToHighlight.map(rh => 
                <VerticalRectSeries data={[{x0: rh.Begin, x: rh.End, y0: 0, y: nMaxY}]} color={'WhiteSmoke'} />)}

            {listLensWordGroups.map(g => {
                var blnGroupIsSelected = this.state.listSelectedWordGroupsInLineChart.some(gs => gs.ID === g.ID)

                return <LineMarkSeries colorType="literal" color={blnGroupIsSelected ? 'Black' : 'LightGray'} data={g.ListWords.map(w => 
                    ({x: parseInt(w.TextIndex), y: g.Y, word: w, 
                        color: this.state.sLocationRestrictionForSyllableRhyme === 'all' ? 'LightGray' : g.WordsMatchingAtRightLocation.includes(w) ? 'DarkGray' : 'LightGray'}))}

                    onValueClick={(value, {index}) => {	
                        if(g.ID === this.state.oCurrentGroupIDForLetterLineChartPopup)
                        {
                            this.ToggleSelectedWordGroupInLineChart(g)
                            this.setState({hintLocationForLetterLineChart: value})
                        }
                    }}

                    onSeriesMouseOver={(datapoint, event) => this.setState({oCurrentGroupIDForLetterLineChartPopup: g.ID})}
                />
            })}

            <LineSeries color='LightGray' data={[{x: nMinTextIndexForChapter, y: 0}, {x: nMinTextIndexForChapter, y: nMaxY}]} />
            <LineSeries color='LightGray' data={[{x: nMaxTextIndexForChapter, y: 0}, {x: nMaxTextIndexForChapter, y: nMaxY}]} />

            <YAxis orientation='right' position='start'
                tickFormat={v => listYTickKeys[v]}
                tickTotal = {listYTickKeys.length}
                style={{text: {fontSize: 20, fontFamily: 'Calibri'}}} />

            {this.state.blnLetterLineChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForLetterLineChart}>
                {/* <div style={{ background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", fontFamily: "SBL Hebrew", fontSize:"24px"}}>
                    {this.state.sForLetterLineChartPopup}
                </div> */}
                {this.GetChartPopupDiv()}
            </Hint>}
        </XYPlot>
    }

    GetLetterLineChart(blnHebrewConsonants)
    {   
        var listTextIndexRangesToHighlight = this.GetTextIndexRangesForCurrentVerseRangesString()

        var listLensWordGroups = []
        var listYTickKeys = []

        //if(blnHebrewConsonants)
        //{
            listLensWordGroups = this.GetConsonantGroupsToUse().map((g, ng) => 
                ({ListWords: this.listTextWordsForChapter.filter(w => this.GetCharsInWord(w.FullText, []).some(c => g.ListChars.includes(c))), 
                    Name: g.Name, Y: ng, Color: 'LightGray'}))

            listLensWordGroups = this.PossiblyRestrictWordGroupsToVerseRanges(listLensWordGroups, listTextIndexRangesToHighlight)
            listLensWordGroups.forEach((g, ng) => g.ID = 'letters_' + ng.toString())

            listLensWordGroups.sort((a,b) => a.Y - b.Y)
            // listLensWordGroups.sort((a,b) => (this.state.blnSortLineChartsBy === 'ClosenessToRange' ? this.GetWithinRangeSortValue(b.ListWords, listTextIndexRangesToHighlight) - 
            //     this.GetWithinRangeSortValue(a.ListWords, listTextIndexRangesToHighlight) : 0) || 
            //     (b.ListWords.length - a.ListWords.length)) //b.Name.localeCompare(a.Name)
            
            //listYTickKeys must come after the sort to keep the orders synchronized!
            listYTickKeys = listLensWordGroups.map(g => g.Name)
            //console.log(listLensWordGroups)
        // }
        // else
        // {
        //     var listVowelGroups = [{"Name": "a" , "ListChars": ["a", "â"], "StringsToExclude": ["ay"]},
        //         {"Name": "e" , "ListChars": ["e"], "StringsToExclude": ["ey"]},
        //         {"Name": "ē" , "ListChars": ["ē", "ê", "ey"], "StringsToExclude": []},
        //         {"Name": "ay" , "ListChars": ["ay"], "StringsToExclude": []},
        //         {"Name": "i" , "ListChars": ["i"], "StringsToExclude": []},
        //         {"Name": "o" , "ListChars": ["o", "ô"], "StringsToExclude": []},
        //         {"Name": "u" , "ListChars": ["u", "û"], "StringsToExclude": []},
                
        //         {"Name": "k", "ListChars": ["k", "q", "g"], "StringsToExclude": []},
        //         {"Name": "ḥ", "ListChars": ["ḵ", "ḥ"], "StringsToExclude": []},
        //         {"Name": "h", "ListChars": ["h"], "StringsToExclude": []},
        //         {"Name": "s", "ListChars": ["s", "z"], "StringsToExclude": []},
        //         {"Name": "š", "ListChars": ["š"], "StringsToExclude": []},
        //         {"Name": "ṣ", "ListChars": ["ṣ"], "StringsToExclude": []},
        //         {"Name": "p", "ListChars": ["b", "p"], "StringsToExclude": []},
        //         {"Name": "t", "ListChars": ["t", "d"], "StringsToExclude": []},
        //         {"Name": "f", "ListChars": ["f", "v"], "StringsToExclude": []},
        //         {"Name": "ʿ", "ListChars": ["ʿ"], "StringsToExclude": []},
        //         {"Name": "ʾ", "ListChars": ["ʾ"], "StringsToExclude": []},
        //         {"Name": "l", "ListChars": ["l"], "StringsToExclude": []},
        //         {"Name": "r", "ListChars": ["r"], "StringsToExclude": []},
        //         {"Name": "m", "ListChars": ["m"], "StringsToExclude": []},
        //         {"Name": "n", "ListChars": ["n"], "StringsToExclude": []},
        //         {"Name": "y", "ListChars": ["y"], "StringsToExclude": []}]

        //     listVowelGroups.reverse()
        //     for(var g of listVowelGroups)
        //     {
        //         var listWordsInGroup = []
        //         var listWordsInGroupMatchingAtRightLocation = []
        //         for(var w of this.listTextWordsForChapter)
        //         {
        //             //only include y at the beginning of the syllable because we are looking for the consonant version here
        //             var listSyllableObjectsMatchingGroup = w.SyllableObjects.filter(oSyllable => 
        //                 g.ListChars.some(c => 
        //                     (g.ListChars.includes('y') ? oSyllable.syllableWithSingleConsonants.startsWith('y') : 
        //                     g.ListChars.includes('h') ? (oSyllable.syllableWithSingleConsonants.startsWith('h') || oSyllable.endsWithConsonantalHe) :
        //                     oSyllable.syllableWithSingleConsonants.includes(c)) && 
        //                 !g.StringsToExclude.some(s => oSyllable.syllableWithSingleConsonants.includes(s))))

        //             if(listSyllableObjectsMatchingGroup.length > 0)
        //             {
        //                 if(listSyllableObjectsMatchingGroup.some(oSyllable => this.SyllableIsInRightLocation(oSyllable)))
        //                 {
        //                     listWordsInGroupMatchingAtRightLocation.push(w)
        //                 }

        //                 listWordsInGroup.push(w)
        //             }
        //         }
                
        //         if(this.state.blnDoChainFilter)
        //         {
        //             var listChains = this.FilterWordGroupsForChains(listWordsInGroup.map(w => 
        //                 ({LineIndex: this.state.listLines.findIndex(l => l.Words.includes(w)), Verse: parseInt(w.Verse), Word: w})), this.state.nChainCutoffValue, 0, true)
                        
        //             for(var listWordsInChain of listChains)
        //             {
        //                 listLensWordGroups.push({ListWords: listWordsInChain, WordsMatchingAtRightLocation: listWordsInGroupMatchingAtRightLocation, 
        //                     Name: g.Name, Y: listYTickKeys.length, Color: 'LightGray'})
        //             }

        //             if(listChains.length > 0) listYTickKeys.push(g.Name)
        //         }
        //         else
        //         {
        //             listLensWordGroups.push({ListWords: listWordsInGroup, WordsMatchingAtRightLocation: listWordsInGroupMatchingAtRightLocation, 
        //                 Name: g.Name, Y: listYTickKeys.length, Color: 'LightGray'})

        //             listYTickKeys.push(g.Name)
        //         }
        //     }
        // }

        //console.log(listLensWordGroups, listYTickKeys)
        // this.setState({listWordGroupsForEnabledLenses: this.state.listWordGroupsForEnabledLenses.concat([{
        //     Lens: this.state.listLenses.find(l => (l.Enabled || l.Sticky) && l.LensType === "consonantlinechart"), 
        //     ListGroups: listLensWordGroups}])})

        var sYAxisFontSize = 22 
        var sYAxisFontFamily = 'SBL Hebrew'
        var nMaxY = listYTickKeys.length
        var nHeight = 25 * nMaxY

        var listTextIndexesInChapter = this.listTextWordsForChapter.map(w => parseInt(w.TextIndex))
        var nMinTextIndexForChapter = Math.min(...listTextIndexesInChapter)
        var nMaxTextIndexForChapter = Math.max(...listTextIndexesInChapter)

        return <XYPlot width={1000} height={nHeight < 100 ? 100 : nHeight} margin={{left: 275 + this.state.nLeftChartAlignmentOffset, right: 100, top: 5, bottom: 10}}
            onMouseEnter={() => this.setState({blnLetterLineChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnLetterLineChartPopupIsVisible: false})}>

            {this.GetGroupBreakLines(nMaxY, false, this.state.sGroupLinesBy)}
            {this.GetVerseBreakLines(nMaxY)}

            {listTextIndexRangesToHighlight.map(rh => 
                <VerticalRectSeries data={[{x0: rh.Begin, x: rh.End, y0: 0, y: nMaxY}]} color={'WhiteSmoke'} />)}

            {listLensWordGroups.map(g => {
                var blnGroupIsSelected = this.state.listSelectedWordGroupsInLineChart.some(gs => gs.ID === g.ID)

                return <LineMarkSeries colorType="literal" color={blnGroupIsSelected ? 'Black' : 'LightGray'} data={g.ListWords.map(w => 
                    ({x: parseInt(w.TextIndex), y: g.Y, word: w, 
                        color: this.state.sLocationRestrictionForSyllableRhyme === 'all' ? 'LightGray' : g.WordsMatchingAtRightLocation.includes(w) ? 'DarkGray' : 'LightGray'}))}

                    // onNearestXY={(value, {index}) => {
                    //     if(g.ID === this.state.oCurrentGroupIDForLetterLineChartPopup)
                    //     {
                    //         this.setState({listSelectedWordGroupsInLineChart: [g]})
                    //         this.setState({hintLocationForLetterLineChart: value});

                    //         // this.setState({hintLocationForLetterLineChart: value});					
                    //         // this.setState({sForLetterLineChartPopup: value.word.FullText + ' v' + value.word.Verse})
                    //     }
                    // }}

                    onValueClick={(value, {index}) => {	
                        if(g.ID === this.state.oCurrentGroupIDForLetterLineChartPopup)
                        {
                            this.ToggleSelectedWordGroupInLineChart(g)
                            this.setState({hintLocationForLetterLineChart: value})
                        }
                    }}

                    onSeriesMouseOver={(datapoint, event) => this.setState({oCurrentGroupIDForLetterLineChartPopup: g.ID})}
                />
            })}

            <LineSeries color='LightGray' data={[{x: nMinTextIndexForChapter, y: 0}, {x: nMinTextIndexForChapter, y: nMaxY}]} />
            <LineSeries color='LightGray' data={[{x: nMaxTextIndexForChapter, y: 0}, {x: nMaxTextIndexForChapter, y: nMaxY}]} />

            <YAxis orientation='right' position='start'
                tickFormat={v => listYTickKeys[v]}
                tickTotal = {listYTickKeys.length}
                style={{text: {fontSize: sYAxisFontSize, fontFamily: sYAxisFontFamily}}} />

            {this.state.blnLetterLineChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForLetterLineChart}>
                {/* <div style={{ background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", fontFamily: "SBL Hebrew", fontSize:"24px"}}>
                    {this.state.sForLetterLineChartPopup}
                </div> */}
                {this.GetChartPopupDiv()}
            </Hint>}
        </XYPlot>
    }

    GetHSLArrayForColorName(sColorName)
    {
        // Brown, GreenYellow, Orange, Gold, Fuchsia, hsl(43, 80%, 40%), DarkCyan, Maroon, Indigo, DarkMagenta, CornflowerBlue, LightGreen, Olive
        return sColorName === 'Red' ? ['0', '100%', '50%'] :
        sColorName === 'Purple' ? ['300', '100%', '25%'] :
        sColorName === 'DarkOrange' ? ['33', '100%', '50%'] :
        sColorName === 'Green' ? ['120', '100%', '25%'] :
        sColorName === 'Blue' ? ['240', '100%', '50%'] :
        sColorName === 'Black' ? ['0', '0%', '0%'] :
        sColorName === 'Brown' ? ['0', '59%', '41%'] :
        sColorName === 'GreenYellow' ? ['84', '100%', '59%'] :
        sColorName === 'Orange' ? ['39', '100%', '50%'] :
        sColorName === 'Gold' ? ['51', '100%', '50%'] :
        sColorName === 'Fuchsia' ? ['300', '100%', '50%'] :
        sColorName === 'hsl(43, 80%, 40%)' ? ['43', '89%', '38%'] :
        sColorName === 'DarkCyan' ? ['180', '100%', '27%'] :
        sColorName === 'Maroon' ? ['0', '100%', '25%'] :
        sColorName === 'Indigo' ? ['275', '100%', '25%'] :
        sColorName === 'DarkMagenta' ? ['300', '100%', '27%'] :
        sColorName === 'CornflowerBlue' ? ['219', '79%', '66%'] :
        sColorName === 'LightGreen' ? ['120', '73%', '75%'] :
        sColorName === 'Olive' ? ['60', '100%', '25%'] : undefined
    }

    LightenColor(sColorName, nPercentOfLightness)
    {
        // hsl(120, 100%, 25%)
        var listHSLValues = this.GetHSLArrayForColorName(sColorName)
        if(listHSLValues === undefined) return sColorName

        return 'hsl(' + listHSLValues[0] + ', ' + listHSLValues[1] + ', ' + Math.floor((parseInt(listHSLValues[2].replace('%', '')) * nPercentOfLightness)) + '%)'
    }

    GetPatternLineChart()
    {
        var listTextIndexRangesToHighlight = this.GetTextIndexRangesForCurrentVerseRangesString()

        // ['s', 'f', 'f_no_participles', 'preposition', 'pgn', 'sfxpgn']
        var listFieldOrders = ['preposition', 'f', 's', 'pgn', 'sfxpgn']
        var colorsByField = {preposition: "Fuchsia", f: "Red", s: "DarkOrange", pgn: "Green", sfxpgn: "Blue"}
        var nPercentOfColorLightness = 1.75
        // [ "Blue", "Red", "Fuchsia", "Green", "DarkMagenta", "DarkOrange", "Maroon", "CornflowerBlue", "Indigo", "DarkCyan",  
        // "Brown", "hsl(43, 80%, 40%)", "Black", "Crimson", "Olive"]

        var oWordGroupObjectForLens = this.state.listWordGroupsForEnabledLenses.find(o => o.Lens.LensType === 'patterninfield')
        if(oWordGroupObjectForLens === undefined) return

        oWordGroupObjectForLens.ListGroups = this.PossiblyRestrictWordGroupsToVerseRanges(oWordGroupObjectForLens.ListGroups, listTextIndexRangesToHighlight)

        oWordGroupObjectForLens.ListGroups.forEach((g, ng) => g.ID = 'patterninfield_' + ng.toString())

        oWordGroupObjectForLens.ListGroups.sort((a,b) => (this.state.blnSortLineChartsBy === 'ClosenessToRange' ? this.GetWithinRangeSortValue(b.ListWords, listTextIndexRangesToHighlight) - 
            this.GetWithinRangeSortValue(a.ListWords, listTextIndexRangesToHighlight) : 0) || 
            (listFieldOrders.indexOf(a.Field) - listFieldOrders.indexOf(b.Field)) || 
            (parseInt(a.ListWords[0].TextIndex) - parseInt(b.ListWords[0].TextIndex)))
  
        //oWordGroupObjectForLens.ListGroups.sort((a,b) => (listFieldOrders.indexOf(a.Field) - listFieldOrders.indexOf(b.Field)) || (parseInt(a.ListWords[0].TextIndex) - parseInt(b.ListWords[0].TextIndex)))
        
        var nMaxY = oWordGroupObjectForLens.ListGroups.length
        var nHeight = 20 * nMaxY

        var listTextIndexesInChapter = this.listTextWordsForChapter.map(w => parseInt(w.TextIndex))
        var nMinTextIndexForChapter = Math.min(...listTextIndexesInChapter)
        var nMaxTextIndexForChapter = Math.max(...listTextIndexesInChapter)

        return <XYPlot width={900} height={nHeight < 100 ? 100 : nHeight} margin={{left: 350 + this.state.nLeftChartAlignmentOffset, right: 0, top: 5, bottom: 10}}
            onMouseEnter={() => this.setState({blnPatternLineChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnPatternLineChartPopupIsVisible: false})}>
    
            {this.GetGroupBreakLines(nMaxY, false, this.state.sGroupLinesBy)}
            {this.GetVerseBreakLines(nMaxY)}

            {listTextIndexRangesToHighlight.map(rh => 
                <VerticalRectSeries data={[{x0: rh.Begin, x: rh.End, y0: 0, y: nMaxY}]} color={'WhiteSmoke'} />)}
        
            {oWordGroupObjectForLens.ListGroups.map((g, ng) => {
                // var listWordIndexes = g.ListWords.map(w => parseInt(w.TextIndex))
                // return <LineSeries data={[{x: Math.min(...listWordIndexes), y: ng}, {x: Math.max(...listWordIndexes), y: ng}]}
                //     color={colorsByField[g.Field]}

                //this.LightenColor(colorsByField[g.Field], nPercentOfColorLightness)
                var sSeriesColor = this.state.listSelectedWordGroupsInLineChart.some(gs => gs.ID === g.ID) ? 'DarkGray' : 'LightGray'
                var colorArrayForValues = this.GetColorArrayForLensType(g.Field)

                return <LineMarkSeries lineStyle={{stroke: sSeriesColor}} colorType="literal" //markStyle={{fill: "red"}} //color={colorsByField[g.Field]} 
                    data={g.ListWords.map(w => {
                        var sFieldValue = this.GetValueForLensType(w, g.Field)
                        var sMarkColor = this.LightenColor(colorArrayForValues[sFieldValue], nPercentOfColorLightness)

                        return ({x: parseInt(w.TextIndex), y: ng, color: sMarkColor, word: w, fieldvalue: sFieldValue})} //fill: colorArray[sFieldValue]
                    )}

                    onNearestXY={(value, {index}) => {
                        if(g.ID === this.state.oCurrentGroupIDForPatternLineChartPopup)
                        {
                            this.setState({hintLocationForPatternLineChart: value})					
                            this.setState({sForPatternLineChartPopup: g.Name + ' ' + value.fieldvalue + ' ' + value.word.FullText + ' v' + value.word.Verse})
                        }
                    }}
                    
                    onValueClick={(value, {index}) => {	
                        if(g.ID === this.state.oCurrentGroupIDForPatternLineChartPopup)
                        {
                            this.ToggleSelectedWordGroupInLineChart(g)
                            // if(value.word === this.state.currentWordForHoverLens) this.ToggleWordInLenStickyWords(value.word)
                            // else this.SetCurrentWordForHoverLens(value.word) 
                            // this.ScrollToWords([value.word]);
                        }
                    }}

                    onSeriesMouseOver={(datapoint, event) => this.setState({oCurrentGroupIDForPatternLineChartPopup: g.ID})}
                />
            })}

            <LineSeries color='LightGray' data={[{x: nMinTextIndexForChapter, y: 0}, {x: nMinTextIndexForChapter, y: nMaxY}]} />
            <LineSeries color='LightGray' data={[{x: nMaxTextIndexForChapter, y: 0}, {x: nMaxTextIndexForChapter, y: nMaxY}]} />
        
            {this.state.blnPatternLineChartPopupIsVisible && <Hint value={this.state.hintLocationForPatternLineChart}>
                <div style={{ background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", fontFamily: "SBL Hebrew", fontSize:"20px"}}>
                    <span>{this.state.sForPatternLineChartPopup}</span>
                </div>
                {/* {this.GetChartPopupDiv()} */}
            </Hint>}
        </XYPlot>
    }

    GetWordsInRepetitionGroup(rg)
    {
        return rg.Lines.flatMap(l => l.Words)
    }

    GetUnitRelationshipChart()
    {
        if(this.state.listWordGroupsForEnabledLenses.length === 0) return

        var listLinesByBreakGroup = this.GetLinesByBreakGroup(this.state.listLines, this.state.sGroupLinesBy)

        var listLensWordGroups = this.state.listWordGroupsForEnabledLenses.flatMap(o => o.ListGroups.map((g, ng) => 
            ({ID: o.Lens.LensType + '_' + ng.toString(), Name: g.Name, ListWords: g.ListWords, LensType: o.Lens.LensType, LensName: o.Lens.Name})))

        listLensWordGroups = this.PossiblyRestrictWordGroupsToVerseRanges(listLensWordGroups, this.GetTextIndexRangesForCurrentVerseRangesString())

        var heatMapData = []

        for(var nUnit1 = 0; nUnit1 < listLinesByBreakGroup.length; nUnit1++)
        {
            for(var nUnit2 = 0; nUnit2 < listLinesByBreakGroup.length; nUnit2++)
            {
                if(nUnit1 === nUnit2) 
                {
                    heatMapData.push({x: nUnit1, y: nUnit2, color: 0})
                    continue
                }

                var listWordsUnit1 = listLinesByBreakGroup[nUnit1].flatMap(l => l.Words)
                var listWordsUnit2 = listLinesByBreakGroup[nUnit2].flatMap(l => l.Words)

                var nGroupsInCommon = listLensWordGroups.filter(g => 
                    g.ListWords.some(w => listWordsUnit1.includes(w)) && 
                    g.ListWords.some(w => listWordsUnit2.includes(w))).length

                // var listWordPairs = this.WordPairsAcrossLists(listWordsUnit1, listWordsUnit2, '', '', -1, '')
                heatMapData.push({x: nUnit1, y: nUnit2, color: nGroupsInCommon}) //listWordPairs.length
            }
        }

        //margin={{left: 275, right: 100, top: 5, bottom: 50}}
        return <XYPlot width={690} height={200} margin={{left: 490}}>			
            <HeatmapSeries data={heatMapData} colorRange={["black", "white"]} 
                // onValueClick={(value, {index}) => {	
                //     if(g.ID === this.state.oCurrentGroupIDForRepeatedRootLineChartPopup)
                //     {
                //         this.ToggleSelectedWordGroupInLineChart(g)
                //         // if(value.word === this.state.currentWordForHoverLens) this.ToggleWordInLenStickyWords(value.word)
                //         // else this.SetCurrentWordForHoverLens(value.word) 
                //         // this.ScrollToWords([value.word]);
                //     }
                // }}
            />	
            <XAxis tickTotal={listLinesByBreakGroup.length} />
            <YAxis />
        </XYPlot>
    }

    GetLensLineChart()
    {   
        //var listWordGroupsForLens = this.state.listWordGroupsForEnabledLenses.find(o => o.Lens === lens)
        if(this.state.listWordGroupsForEnabledLenses.length === 0) return

        var listTextIndexesInChapter = this.listTextWordsForChapter.map(w => parseInt(w.TextIndex))
        var nMinTextIndexForChapter = Math.min(...listTextIndexesInChapter)
        var nMaxTextIndexForChapter = Math.max(...listTextIndexesInChapter)

        var listWordsByBreakGroup = this.GetWordsByBreakGroup(this.state.listLines, this.state.sGroupLinesBy) 

        // var dictWordsByRepetitionGroupIndex = new Map()
        // var nRepetitionGroupIndex = 0
        // for(var rg of this.listRepetitionGroups)
        // {
        //     dictWordsByRepetitionGroupIndex.set(nRepetitionGroupIndex, this.GetWordsInRepetitionGroup(rg))
        //     nRepetitionGroupIndex++
        // }

        var listLensWordGroups = this.state.listWordGroupsForEnabledLenses.flatMap(o => o.ListGroups.map((g, ng) => 
            ({ID: o.Lens.LensType + '_' + ng.toString(), Name: g.Name, 
            AxisText: g.AxisLabel != undefined ? g.AxisLabel : this.LensIsRepLens(o.Lens) ? g.ListWords[0].FullText : g.Name, 
            Color: g.Color, ListWords: g.ListWords, LensType: o.Lens.LensType, LensName: o.Lens.Name, MarkObjects: []})))

        listLensWordGroups.forEach(g => g.KeyForAxisTextSort = g.LensType + '_' + g.AxisText)
        
        var blnIncludesThematicStatementsLens = this.state.listWordGroupsForEnabledLenses.some(o => o.Lens.LensType === "thematicstatements")

        // var oLens = this.state.listWordGroupsForEnabledLenses[0].Lens
        // var blnYTickKeysAreHebrew = this.LensIsRepLens(oLens)

            // sLensType === 'mysem' ? this.MainSemanticDomainsLens() : 
            // sLensType === 'sdbhlex' ? this.SDBHLens("l") : 
            // sLensType === 'sdbhcomposite' ? this.SDBHLens("composite") : this.RepeatedRootsLens(false)

        var sYAxisFontSize = 20 //blnYTickKeysAreHebrew ? 22 : 16
        var sYAxisFontFamily = 'SBL Hebrew' //blnYTickKeysAreHebrew ? 'SBL Hebrew' : 'Calibri'

        var listTextIndexRangesToHighlight = this.GetTextIndexRangesForCurrentVerseRangesString()

        listLensWordGroups = this.PossiblyRestrictWordGroupsToVerseRanges(listLensWordGroups, listTextIndexRangesToHighlight)
        listLensWordGroups.forEach(g => g.ListWords.sort((a,b) => parseInt(a.TextIndex) - parseInt(b.TextIndex)))

        var listYTickKeys = []
        var listBins = []

        if(this.state.blnBinAndSortWordGroupsForLineCharts)
        {
            //put the word groups in bins so that we can bin by range start but also sort by range length
            // var listBins = []
            // var nBinSize = 7

            // for(var nTextIndexStartForWordGroupBin = nMinTextIndexForChapter; 
            //     nTextIndexStartForWordGroupBin < nMaxTextIndexForChapter - nBinSize; 
            //     nTextIndexStartForWordGroupBin += nBinSize)
            // {
            //     listBins.push({StartTextIndex: nTextIndexStartForWordGroupBin, EndTextIndex: nTextIndexStartForWordGroupBin + nBinSize - 1, Groups: [], GroupsFiltered: []})
            // }

            // var nEndIndexForLastBin = listBins[listBins.length - 1].EndTextIndex
            // if(nMaxTextIndexForChapter - nEndIndexForLastBin > 0)
            //     listBins.push({StartTextIndex: nEndIndexForLastBin + 1, EndTextIndex: nMaxTextIndexForChapter, Groups: [], GroupsFiltered: []})
            
            var blnBinAndSortWordGroupsMultiple = true
            var blnBinsFilteredForCommon = false
            var nMinNumberGroupsOverlapping = 2

            listBins = listWordsByBreakGroup.map(rg => {
                var listTextIndexes = rg.map(w => parseInt(w.TextIndex))
                return {StartTextIndex: Math.min(...listTextIndexes), EndTextIndex: Math.max(...listTextIndexes), Groups: [], GroupsFiltered: []}
            })
    
            for(var oBin of listBins)
            {
                if(blnBinAndSortWordGroupsMultiple)
                {
                    //this will add the same group multiple times, once to each bin it occurs in.
                    //this is to cluster occurrences together.

                    // oBin.Groups = listLensWordGroups.map(g => ({Name: g.Name, Color: g.Color, ListWords: g.ListWords.filter(w => 
                    //     parseInt(w.TextIndex) >= oBin.StartTextIndex && 
                    //     parseInt(w.TextIndex) <= oBin.EndTextIndex)})).filter(g => g.ListWords.length > 0)

                    oBin.Groups = listLensWordGroups.filter(g => 
                        g.ListWords.some(w => 
                            parseInt(w.TextIndex) >= oBin.StartTextIndex && 
                            parseInt(w.TextIndex) <= oBin.EndTextIndex)).
                        map(g => ({ID: g.ID, Name: g.Name, AxisText: g.AxisText, Color: g.Color, ListWords: g.ListWords, 
                            LensType: g.LensType, LensName: g.LensName, Bin: oBin, MarkObjects: []}))
                }
                else
                {
                    oBin.Groups = listLensWordGroups.filter(g => 
                        parseInt(g.ListWords[0].TextIndex) >= oBin.StartTextIndex &&
                        parseInt(g.ListWords[0].TextIndex) <= oBin.EndTextIndex)
                }
            }

            if(blnBinsFilteredForCommon)
            {
                //only show bins that have at least a certain number of groups in common with at least one other bin
                //only show groups that occur in at least one other bin
                
                var listBinsFilteredForCommon = []
                for(var b1 of listBins)
                {
                    for(var b2 of listBins)
                    {
                        if(b1 == b2) continue

                        var listGroupsInCommon = b1.Groups.filter(g => b2.Groups.some(g2 => g2.ID === g.ID))
                        if(listGroupsInCommon.length >= nMinNumberGroupsOverlapping)
                        {
                            b1.GroupsFiltered = b1.GroupsFiltered.concat(listGroupsInCommon)
                            if(!listBinsFilteredForCommon.includes(b1)) listBinsFilteredForCommon.push(b1)
                        }
                    }

                    b1.GroupsFiltered = [...new Set(b1.GroupsFiltered)]
                    
                    //sort by the lens type and group in common
                    b1.GroupsFiltered.sort((a,b) => a.LensName.localeCompare(b.LensName) || 
                        (b1.GroupsFiltered.indexOf(a) - b1.GroupsFiltered.indexOf(b)) || 
                        (b.ListWords.length - a.ListWords.length) || 
                        (parseInt(a.ListWords[a.ListWords.length - 1].TextIndex) - parseInt(b.ListWords[b.ListWords.length - 1].TextIndex)))

                    // b1.GroupsFiltered.sort((a,b) => a.LensName.localeCompare(b.LensName) || (b.ListWords.length - a.ListWords.length) || 
                    //     (parseInt(a.ListWords[a.ListWords.length - 1].TextIndex) - parseInt(b.ListWords[b.ListWords.length - 1].TextIndex)))

                    b1.GroupsFiltered.push({Name: '', AxisText: '', Color: 'White', ListWords: [], Bin: oBin}) //spacer
                }

                listLensWordGroups = []
                for(var oBin of listBinsFilteredForCommon)
                {
                    oBin.MinY = listLensWordGroups.length                
                    listLensWordGroups = listLensWordGroups.concat(oBin.GroupsFiltered)
                    oBin.MaxY = listLensWordGroups.length - 1 //-1 per spacer
                }
            }
            else
            {
                listLensWordGroups = []
                for(var oBin of listBins)
                {
                    //get the words in the bin groups that occur outside this current bin
                    // var listBinGroupWordsOutside = oBin.Groups.flatMap(bg => bg.ListWords.map(w => ({Group: bg, TextIndex: parseInt(w.TextIndex)}))).
                    //     filter(obw => obw.TextIndex < oBin.StartTextIndex || obw.TextIndex > oBin.EndTextIndex)
                    // console.log(listBinGroupWordsOutside)

                    // for(var ng = 1; ng < listWordsByBreakGroup.length - 1; ng++)
                    // {
                    //     //if more than one group from this bin occurs this range of repetition groups and in the bin
                    //     //mark all words that occur in both this range of repetition groups and in the bin
                    //     // var listTextIndexesInRange = dictWordsByRepetitionGroupIndex.get(ng - 1).map(w => parseInt(w.TextIndex)).
                    //     //     concat(dictWordsByRepetitionGroupIndex.get(ng).map(w => parseInt(w.TextIndex))).
                    //     //     concat(dictWordsByRepetitionGroupIndex.get(ng + 1).map(w => parseInt(w.TextIndex)))

                    //     var listTextIndexesInRange = listWordsByBreakGroup[ng].map(w => parseInt(w.TextIndex))

                    //     var listOverlapping = listBinGroupWordsOutside.filter(obw => listTextIndexesInRange.includes(obw.TextIndex))
                    //     var listOverlappingGroups = listOverlapping.map(oo => oo.Group)
                    //     var listOverlappingTextIndexes = listOverlapping.map(oo => oo.TextIndex)

                    //     if(new Set(listOverlappingGroups).size >= nMinNumberGroupsOverlapping)
                    //     {
                    //         // console.log(listOverlappingGroups, listOverlappingTextIndexes)
                    //         listOverlappingGroups.forEach(go => go.MarkObjects.push({TextIndexesToMark: listOverlappingTextIndexes, Color: this.listLinkGroupColors[ng]}))
                    //     }
                    // }

                    oBin.Groups.sort((a,b) => a.LensName.localeCompare(b.LensName) || (b.ListWords.length - a.ListWords.length) || 
                        (parseInt(a.ListWords[a.ListWords.length - 1].TextIndex) - parseInt(b.ListWords[b.ListWords.length - 1].TextIndex)))

                    oBin.Groups.push({Name: '', AxisText: '', Color: 'White', ListWords: [], Bin: oBin})

                    oBin.MinY = listLensWordGroups.length                
                    listLensWordGroups = listLensWordGroups.concat(oBin.Groups)
                    oBin.MaxY = listLensWordGroups.length - 1 //-1 per spacer
                }
            }

            // console.log(listBins, listBinsFilteredForCommon)

            // listBins.forEach(b => b.Groups = b.Groups.filter(g => listBins.filter(b2 => b2 != b).some(b2 => b2.Groups.some(g2 => g2.ID === g.ID))))
            // var listBinsToShow = listBins.filter(b => b.Groups.length >= nMinNumberGroupsOverlappingWithSomeOtherBin)

            // listLensWordGroups = listWordGroupsBinnedAndSorted.filter(g => listBinsFilteredForCommon.includes(g.Bin) && g.Bin.GroupsFiltered.includes(g))
        }
        else
        {
            //console.log(listLensWordGroups)
            //sort by how close the closest point in the group is to the range to highlight, then by the first text index in each group
            if(this.state.blnSortLineChartsBy === 'ClosenessToRange')
            {
                listLensWordGroups.sort((a,b) => (this.GetWithinRangeSortValue(b.ListWords, listTextIndexRangesToHighlight) - 
                this.GetWithinRangeSortValue(a.ListWords, listTextIndexRangesToHighlight)) || 
                    ((a.ListWords.length === 0 ? 0 : parseInt(a.ListWords[0].TextIndex)) - 
                    (b.ListWords.length === 0 ? 0 : parseInt(b.ListWords[0].TextIndex))))
            }
            else if(this.state.blnSortLineChartsBy === 'NumberOfOccurrences')
            {
                listLensWordGroups.sort((a,b) => a.ListWords.length - b.ListWords.length)
            }
            else if(this.state.blnSortLineChartsBy === 'AxisText')
            {
                //listLensWordGroups.sort((a,b) => a.AxisText.localeCompare(b.AxisText))
                //group by AxisText by setting Y to be the same for a given AxisText
                var listYTickKeys1 = [...new Set(listLensWordGroups.map(g => g.KeyForAxisTextSort))].sort((a,b) => b.localeCompare(a))
                listLensWordGroups.forEach(g => g.Y = listYTickKeys1.indexOf(g.KeyForAxisTextSort))

                listYTickKeys = listYTickKeys1.map(s => s.split('_')[1])
            }
            else
            {
                listLensWordGroups.sort((a,b) => (b.ListWords.length === 0 ? 0 : parseInt(b.ListWords[0].TextIndex)) - 
                    (a.ListWords.length === 0 ? 0 : parseInt(a.ListWords[0].TextIndex)))
            }
        }

        //listYTickKeys must come after the sort to keep the orders synchronized!
        //sorting by AxisText has a special way to calculate the y ticks
        if(this.state.blnBinAndSortWordGroupsForLineCharts || this.state.blnSortLineChartsBy != 'AxisText')
        { 
            listLensWordGroups.forEach((g, ng) => g.Y = ng)
            listYTickKeys = listLensWordGroups.map(g => g.AxisText) //listBins.indexOf(g.Bin) + ' ' + 
        }

        var nMaxY = listYTickKeys.length
        var nHeight = 25 * nMaxY

        // console.log(listLensWordGroups)

        return <XYPlot width={blnIncludesThematicStatementsLens ? 1225 : 925} height={nHeight < 100 ? 100 : nHeight} 
            margin={{left: 275 + this.state.nLeftChartAlignmentOffset, right: blnIncludesThematicStatementsLens ? 500 : 200, top: 5, bottom: 10}}
            onMouseEnter={() => this.setState({blnRepeatedRootLineChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnRepeatedRootLineChartPopupIsVisible: false})}>

            {listBins.map(oBin => <VerticalRectSeries data={[{x0: oBin.StartTextIndex, x: oBin.EndTextIndex, y0: oBin.MinY, y: oBin.MaxY}]} color={'WhiteSmoke'} />)}

            {this.GetGroupBreakLines(nMaxY, false, this.state.sGroupLinesBy)}
            {this.GetVerseBreakLines(nMaxY)}

            {listTextIndexRangesToHighlight.map(rh => 
                <VerticalRectSeries data={[{x0: rh.Begin, x: rh.End, y0: 0, y: nMaxY}]} color={'WhiteSmoke'} />)}

            {listLensWordGroups.map(g => {
                var sSeriesColor = this.state.listSelectedWordGroupsInLineChart.some(gs => gs.ID === g.ID) ? g.Color : 'LightGray'
                    // g.ListWords.some(w => ['N', 'V', 'A', 'P'].includes(w.WordType)) ? 'LightGray' : 'WhiteSmoke'

                return <LineMarkSeries lineStyle={{stroke: sSeriesColor}} colorType="literal" data={g.ListWords.map(w => {
                    var nTextIndex = parseInt(w.TextIndex)
                    //this.LightenColor('Purple', 3.5)
                    var oMarkObject = g.MarkObjects.find(mo => mo.TextIndexesToMark.includes(nTextIndex))
                    var sMarkColor = oMarkObject != undefined ? oMarkObject.Color : 'LightGray'
                    return {x: nTextIndex, y: g.Y, color: sMarkColor, word: w}
                })}

                    // onNearestXY={(value, {index}) => {
                    //     if(g.ID === this.state.oCurrentGroupIDForRepeatedRootLineChartPopup) //this.state.blnShiftDown && 
                    //     {
                    //         this.setState({listSelectedWordGroupsInLineChart: [g]})
                    //         this.setState({hintLocationForRepeatedRootLineChart: value});					
                    //         // this.setState({sForRepeatedRootLineChartPopup: value.word.FullText + ' v' + value.word.Verse})
                    //     }
                    // }}

                    onValueClick={(value, {index}) => {	
                        if(g.ID === this.state.oCurrentGroupIDForRepeatedRootLineChartPopup)
                        {
                            this.ToggleSelectedWordGroupInLineChart(g)
                            // if(value.word === this.state.currentWordForHoverLens) this.ToggleWordInLenStickyWords(value.word)
                            // else this.SetCurrentWordForHoverLens(value.word) 
                            // this.ScrollToWords([value.word]);

                            this.setState({hintLocationForRepeatedRootLineChart: value})
                            // this.setState({sForRepeatedRootLineChartPopup: }) //value.word.FullText + ' v' + value.word.Verse
                        }
                    }}

                    onSeriesMouseOver={(datapoint, event) => this.setState({oCurrentGroupIDForRepeatedRootLineChartPopup: g.ID})}
                />
            })}

            <LineSeries color='LightGray' data={[{x: nMinTextIndexForChapter, y: 0}, {x: nMinTextIndexForChapter, y: nMaxY}]} />
            <LineSeries color='LightGray' data={[{x: nMaxTextIndexForChapter, y: 0}, {x: nMaxTextIndexForChapter, y: nMaxY}]} />

            <YAxis orientation='right' position='start'
                tickFormat={v => listYTickKeys[v]}
                tickTotal = {listYTickKeys.length} 
                style={{text: {fontSize: sYAxisFontSize, fontFamily: sYAxisFontFamily}}} />

            {this.state.blnRepeatedRootLineChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForRepeatedRootLineChart}>
                {this.GetChartPopupDiv()}
            </Hint>}
        </XYPlot>
    }

    GetPsalmsThematicComparisonChart()
    {
        // this.listThematicStatementIDsByVerse.filter(o => 
        //     this.state.listThematicStatementsSelectedForSearch.every(o2 => o.IDs.includes(o2.ID) || 
        //         (o2.C != undefined && o2.C.some(nChildID => o.IDs.includes(nChildID)))

        var listYTickKeys = this.listThematicStatements.map(o => o.Name)
        var nHeight = 25 * listYTickKeys.length

        return <XYPlot width={1225} height={nHeight < 100 ? 100 : nHeight} 
            margin={{left: 275 + this.state.nLeftChartAlignmentOffset, right: 500, top: 5, bottom: 10}}>

            {this.listThematicStatements.map((ots, nTsIndex) => {
                return <LineMarkSeries lineStyle={{stroke: 'LightGray'}} colorType="literal" data={
                    [...new Set(this.listThematicStatementIDsByVerse.filter(o => o.IDs.includes(ots.ID) ||
                        (ots.C != undefined && ots.C.some(nChildID => o.IDs.includes(nChildID)))).map(o => o.Chapter))].map(nChapter => {
                    return {x: nChapter, y: nTsIndex, color: 'LightGray'}
                })}/>
            })}

            <YAxis orientation='right' position='start'
                tickFormat={v => listYTickKeys[v]}
                tickTotal = {listYTickKeys.length} 
                style={{text: {fontSize: 20, fontFamily: 'Calibri'}}} />
        </XYPlot>
    }

    GetConnectionLensChart()
    {
        //a bar chart with one bar for each unit at the current selected unit level (x being the unit index), 
        //the bar containing the percentages of which unit the repetition groups in that unit first occur in
        //(to go with handtaggedconnectionsunitoffirstoccurrence) 

        var listDataBySeriesForBarGraph = []
        let listLineGroups = this.GetLineGroupsForConnectionsLens()

        let listConnectionsGroups = this.ConnectionsLens(this.listTextWordsForChapter, 'unitoffirstoccurrence')

        let listGroupIndexesForWords = listConnectionsGroups.flatMap(g => g.ListWords.flatMap(w => ({Word: w, FirstLineGroupIndex: g.FirstLineGroupIndex, 
            GroupIndex: listLineGroups.findIndex(lg => lg.Lines.includes(this.GetLineContainingWord(w)))})))

        let listTextWordsInConnectionGroups = listGroupIndexesForWords.map(o => o.Word)
        let listTextWordsNotInConnectionGroups = this.listTextWordsForChapter.filter(w => !listTextWordsInConnectionGroups.includes(w))

        let listGroupIndexesForWordsNotInConnectionGroups = listTextWordsNotInConnectionGroups.map(w => ({Word: w, FirstLineGroupIndex: -1, 
            GroupIndex: listLineGroups.findIndex(lg => lg.Lines.includes(this.GetLineContainingWord(w)))}))

        listGroupIndexesForWords = listGroupIndexesForWords.concat(listGroupIndexesForWordsNotInConnectionGroups)

        let listLineGroupIndexAndTotalWordsInLineGroup = []
        for(var nLineGroup = 0; nLineGroup < listLineGroups.length; nLineGroup++)
        {
            listLineGroupIndexAndTotalWordsInLineGroup.push({LineGroup: nLineGroup, TotalWords: 1.0 * listGroupIndexesForWords.filter(g => g.GroupIndex === nLineGroup).length})
        }

        var listAllFirstLineGroupIndexes = [...new Set(listGroupIndexesForWords.map(o => o.FirstLineGroupIndex))].toSorted()
        
        for(var nFirstLineGroup of listAllFirstLineGroupIndexes)
        {
            if(nFirstLineGroup === -1) continue
            
            var sColor = nFirstLineGroup === -1 ? 'LightGray' : this.listLinkGroupColors[nFirstLineGroup % this.listLinkGroupColors.length]

            var listDataForThisBarSeries = []
            for(var nLineGroup = 0; nLineGroup < listLineGroups.length; nLineGroup++)
            {
                let nWordsInThisLineGroupInConnectionGroupWithThisFirstLineIndex = listGroupIndexesForWords
                .filter(o => o.GroupIndex === nLineGroup && o.FirstLineGroupIndex === nFirstLineGroup).length

                let nTotalWordsInLineGroup = listLineGroupIndexAndTotalWordsInLineGroup.find(o => o.LineGroup === nLineGroup).TotalWords

                listDataForThisBarSeries.push({x: nLineGroup, y: nWordsInThisLineGroupInConnectionGroupWithThisFirstLineIndex / nTotalWordsInLineGroup})
            }

            listDataBySeriesForBarGraph.push({listData: listDataForThisBarSeries, color: sColor})
        }

        // console.log(listDataBySeriesForBarGraph)

        return <XYPlot width={1300} height={100} stackBy="y" margin={{left: 100 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 5}}>
          <VerticalGridLines />
          <HorizontalGridLines />
          <XAxis />
          <YAxis />

          {listDataBySeriesForBarGraph.map(d => <VerticalBarSeries data={d.listData} color={d.color}/>)}
        </XYPlot>
    }

    GetCadenceChart()
    {
        var listDataForBarGraph = []
        var nXForFirstSyllableInLine = 0
        for(var line of this.state.listLines.filter(l => !l.IsSuperscription))
        {
            let listSyllablesWithFullAccent = line.SyllableObjects.filter(oSyl => oSyl.hasFullAccent)

            listDataForBarGraph = listDataForBarGraph.concat(listSyllablesWithFullAccent.map((oSyl, nSyl) => {
                var nDistanceToPreviousAccentedSyllable = this.CalculateSyllableDistanceToPreviouslyAccentedSyllable(oSyl, false)
                return {x: nXForFirstSyllableInLine + nSyl, y: nDistanceToPreviousAccentedSyllable, 
                    color: this.GetColorForCadenceSyllableDistance(nDistanceToPreviousAccentedSyllable, true), 
                    sText: oSyl.word.Transliteration + ' v' + oSyl.word.Verse + ' ' + nDistanceToPreviousAccentedSyllable.toString()}
            }).filter(o => o.y > -1))
            
            nXForFirstSyllableInLine += listSyllablesWithFullAccent.length
            listDataForBarGraph.push({x: nXForFirstSyllableInLine, y: 0, sText: ''})
            nXForFirstSyllableInLine += 1
        }

        return <XYPlot width={1300} height={100} margin={{left: 100 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 5}}
            onMouseEnter={() => this.setState({blnCadenceChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnCadenceChartPopupIsVisible: false})}>

                <VerticalBarSeries colorType="literal" data={listDataForBarGraph}
                    onNearestXY={(value, {index}) => {
                        this.setState({hintLocationForCadenceChart: value})					
                        this.setState({sCadenceChartPopup: value.sText})
                    }} 
                />
                {/* <XAxis tickTotal={listDistinctXs.length} /> */}
                {/* <XAxis /> */}
                <YAxis />
                {this.state.blnCadenceChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForCadenceChart}>
                    <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "Calibri", fontSize:"18px"}}>
                        {this.state.sCadenceChartPopup}
                    </div>
                </Hint>}
            </XYPlot>
    }

    GetLineByLineLinkChart()
    {
        let listDevelopmentDiagramLinkGroupsForChapter = this.state.listDevelopmentDiagramLinkGroups.filter(o => o.Chapter === this.GetFirstCurrentChapter().toString() && 
            this.state.blnShowLinksForLensThatIsColoredBy || o.Lens !== this.GetLensToColorBy())
        let listLineGroups = this.GetLineGroupsForDevelopmentDiagram(this.state.listLines)

        // console.log(listDevelopmentDiagramLinkGroupsForChapter)
        let listDataForBarGraph = []
        let nXCorrectionForLineGroupGaps = 0
        let nLastLineGroupIndex = 0

        for(var nLine = 0; nLine < this.state.listLines.length; nLine++)
        {
            let line = this.state.listLines[nLine]
            if(line.IsSuperscription) continue

            var listLinkGroupsSharedWithNearbyLinesForLine = []
            for(var nLine2 = nLine - this.state.nMaxLinesAwayForDefaultNoHoveredMode; nLine2 < nLine; nLine2++)
            {
                let listLinkGroupsSharedBetweenLines = []
                
                if(nLine === nLine2)
                {
                    //include it only if more than one word in the line is in the group
                    listLinkGroupsSharedBetweenLines = listDevelopmentDiagramLinkGroupsForChapter
                    .filter(o => o.LineAndWordIndexes.filter(lwi => lwi.LineIndex === nLine).length > 1)
                }
                else
                {
                    let nLine2ToUse = nLine2 > 0 && this.LineIsSelah(this.state.listLines[nLine2]) ? (nLine2 - 1) : nLine2

                    listLinkGroupsSharedBetweenLines = listDevelopmentDiagramLinkGroupsForChapter
                    .filter(o => o.LineAndWordIndexes.some(lwi => lwi.LineIndex === nLine) &&
                        o.LineAndWordIndexes.some(lwi => lwi.LineIndex === nLine2ToUse))
                }

                listLinkGroupsSharedWithNearbyLinesForLine = listLinkGroupsSharedWithNearbyLinesForLine.concat(
                    listLinkGroupsSharedBetweenLines.filter(lg => !listLinkGroupsSharedWithNearbyLinesForLine.includes(lg)))

                // if(nLine === 15)
                // {
                //     console.log(listLinesToUse[nLine].Words.map(w => w.Transliteration).join(' '), nLine2, listDevelopmentDiagramLinkGroupsForChapter
                //         .filter(o => o.LineAndWordIndexes.some(lwi => lwi.LineIndex === nLine) &&
                //             o.LineAndWordIndexes.some(lwi => lwi.LineIndex === nLine2)))
                // }
            }

            if(this.state.blnShowGapsInBarChartBetweenSubunits)
            {
                let nLineGroupIndex = listLineGroups.findIndex(lg => lg.Lines.includes(line))
                if(nLineGroupIndex !== nLastLineGroupIndex)
                {
                    listDataForBarGraph.push({x: nLine + nXCorrectionForLineGroupGaps, y: 0, Gap: true, sText: ''})
                    nXCorrectionForLineGroupGaps += 1
                    nLastLineGroupIndex = nLineGroupIndex
                }
            }

            let nTotalLinkGroupsSharedWithNearbyLinesForLine = listLinkGroupsSharedWithNearbyLinesForLine.length
            listDataForBarGraph.push({x: nLine + nXCorrectionForLineGroupGaps, y: nTotalLinkGroupsSharedWithNearbyLinesForLine, color: 'Silver',
                sVerse: line.Words[0].Verse, IsFirstLineInVerse: false,  Gap: false, 
                sText: line.Words.map(w => w.Transliteration).join(' ') + ' v' + line.Words[0].Verse + ' ' + nTotalLinkGroupsSharedWithNearbyLinesForLine.toString()})
        }

        // console.log(listDataForBarGraph)
        var listVerseDivisions = []
        if(this.state.listShowVerseDivisionsInBarChart)
        {
            var sCurrentVerse = '0'
            var nIndexOfPreviousFirstLine = 0
            for(var nDataIndex = 0; nDataIndex < listDataForBarGraph.length; nDataIndex++)
            {
                var o = listDataForBarGraph[nDataIndex]
                if(o.Gap) continue

                if(o.sVerse != sCurrentVerse)
                {
                    if(nDataIndex > 0) 
                    {
                        listDataForBarGraph[nIndexOfPreviousFirstLine].lastLineInVerseY = listDataForBarGraph[nDataIndex - 1].y
                    }

                    nIndexOfPreviousFirstLine = nDataIndex
                    listDataForBarGraph[nDataIndex].IsFirstLineInVerse = true
                }
                else if(nDataIndex === listDataForBarGraph.length - 1)
                {
                    listDataForBarGraph[nIndexOfPreviousFirstLine].lastLineInVerseY = listDataForBarGraph[nDataIndex].y
                }

                if(o.sVerse != sCurrentVerse)
                {
                    listVerseDivisions.push({x: o.x, y: o.y}) //, color: o.color
                    sCurrentVerse = o.sVerse
                }
            }
        }

        return <XYPlot width={1100 + this.state.nChartWidthOffset} height={100} 
            margin={{left: this.state.nChartLeft + this.state.nLeftChartAlignmentOffset, top: 10, bottom: 5}}
            onMouseEnter={() => this.setState({blnCadenceChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnCadenceChartPopupIsVisible: false})}>

                <VerticalBarSeries colorType="literal" data={listDataForBarGraph}
                    onNearestXY={(value, {index}) => {
                        this.setState({hintLocationForCadenceChart: value})					
                        this.setState({sCadenceChartPopup: value.sText})
                    }} 
                />

                {this.state.listShowVerseDivisionsInBarChart && <LineSeries color='hsl(0, 0%, 80%)' data={listVerseDivisions} />}
                {this.state.listShowVerseDivisionsInBarChart && listVerseDivisions.map(oVerseDivision => <MarkSeries color='hsl(0, 0%, 80%)' data={[{x: oVerseDivision.x, y: oVerseDivision.y}]} />)}
                
                {/* <XAxis tickTotal={listDistinctXs.length} /> */}
                {/* <XAxis /> */}
                {this.state.blnShowChartYAxis && <YAxis />}

                {this.state.blnCadenceChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForCadenceChart}>
                    <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "Calibri", fontSize:"18px"}}>
                        {this.state.sCadenceChartPopup}
                    </div>
                </Hint>}
            </XYPlot>
    }

    CalculateSyllableDistanceBetweenAccentedSyllablesInWords(w1, w2, listTextWordsToUse)
    {
        let nTextIndex1 = parseInt(w1.TextIndex)
        let nTextIndex2 = parseInt(w2.TextIndex)
        
        let listWordsInBetween = listTextWordsToUse.filter(w => {
            let nTextIndex = parseInt(w.TextIndex)
            return nTextIndex > nTextIndex1 && nTextIndex < nTextIndex2
        })

        let nSyllablesInWordsInBetween = listWordsInBetween.map(w => w.SyllableObjects.length).reduce((acc, n) => acc + n, 0)
        let nIndexOfAccentedSyllable1 = w1.SyllableObjects.findIndex(oSyl => oSyl.hasFullAccent)
        let nIndexOfAccentedSyllable2 = w2.SyllableObjects.findIndex(oSyl => oSyl.hasFullAccent)

        return w1.SyllableObjects.length - (nIndexOfAccentedSyllable1 === -1 ? w1.SyllableObjects.length : nIndexOfAccentedSyllable1) + 
            (nIndexOfAccentedSyllable2 === -1 ? 0 : nIndexOfAccentedSyllable2) + nSyllablesInWordsInBetween
        
        // w.SyllableObjects = listSyllableObjectsForWord
        // w.Transliteration = listSyllableObjectsForWord.map(syl => syl.syllable).join('')
        // w.HasFullAccent = listSyllableObjectsForWord.some(syl => syl.hasFullAccent)
        // w.MainAccentedSyllable = listSyllableObjectsForWord.find(syl => syl.hasFullAccent)
        // w.HasSecondaryAccent = listSyllableObjectsForWord.some(syl => syl.hasSecondaryAccent)
        // w.HasFinalAccent = listSyllableObjectsForWord.some(syl => syl.hasFullAccent && syl.isLastSyllableInWord)
        // w.HasPenultimateAccent = listSyllableObjectsForWord.some((syl, n, arr) => syl.hasFullAccent && syl.syllableIndex === arr.length - 2)
    }

    GetMomentumChart()
    {
        var listDataForBarGraph = []
        // let listLinkGroups = this.GetDevelopmentDiagramLinkGroupsForChapter()
        // .filter(oLinkGroup => {
        //     let nGroupLength = oLinkGroup.LineAndWordIndexes.length

        //     return nGroupLength >= this.state.nMinDevelopmentDiagramLinkGroupLengthToShow && 
        //     nGroupLength <= this.state.nMaxDevelopmentDiagramLinkGroupLengthToShow
        // })

        var listLinkGroups = this.WordsBySoundGroupLens(this.listTextWordsForChapter, 'SameAccentedVowelWithNoOrCompatibleFinalConsonantOrInitialSoundGroup')
        listLinkGroups.forEach(o => o.ListWordsSorted = o.ListWords.sort((a,b) => parseInt(a.TextIndex) - parseInt(b.TextIndex)))

        //console.log(listLinkGroups)

        // for each word, for each syllable:
        // nCurrentSyllableMomentum = -0.25 - 2/(current syllable index - last syllable index in lens sound group)
        // x:syllable index, y: nCurrentSyllableMomentum 
        // if oSyllable.syllableIndex === 0, use ‘SameInitialSoundGroup’ 
        // if oSyllable.hasFullAccent, use ‘SameAccentedVowelWithNoOrCompatibleFinalConsonant’

        let nSyllablesUntilZeroMomentum = 2.5
        let nDecreaseValuePerSyllable = 1.0 / nSyllablesUntilZeroMomentum

        var nCurrentSyllableMomentum = 0
        var nCurrentX = 0
        for(var w of this.listTextWordsForChapter)
        {
            let oForAccentedSyllable = listLinkGroups.find(o => o.CategoryForLinkFiltering === 'SameAccentedVowelWithNoOrCompatibleFinalConsonant' && 
                o.ListWords.includes(w))

            let nSyllableDistanceFromAccentedSyllableInThisWordToPreviousWordInGroup = 0
            if(oForAccentedSyllable !== undefined)
            {
                let nIndexOfCurrentWordInGroup = oForAccentedSyllable.ListWordsSorted.indexOf(w)
                //console.log(w.Transliteration, oForAccentedSyllable.ListWordsSorted, nIndexOfCurrentWordInGroup)

                if(nIndexOfCurrentWordInGroup > 0)
                {
                    let oPreviousWord = oForAccentedSyllable.ListWordsSorted[nIndexOfCurrentWordInGroup - 1]
                    nSyllableDistanceFromAccentedSyllableInThisWordToPreviousWordInGroup = this.CalculateSyllableDistanceBetweenAccentedSyllablesInWords(oPreviousWord, w, this.listTextWordsForChapter)
                    //console.log(w.Transliteration, oPreviousWord.Transliteration, nSyllableDistanceFromAccentedSyllableInThisWordToPreviousWordInGroup)
                }
            }

            for(var nSyllableIndex = 0; nSyllableIndex < w.SyllableObjects.length; nSyllableIndex++)
            {
                let oSyllable = w.SyllableObjects[nSyllableIndex]
                // if(oSyllable.syllableIndex === 0)
                // {
                // }
                
                // console.log(nCurrentSyllableMomentum, w.Transliteration, nSyllableDistanceFromAccentedSyllableInThisWordToPreviousWordInGroup, 
                //     (oSyllable.hasFullAccent && nSyllableDistanceFromAccentedSyllableInThisWordToPreviousWordInGroup > 0 ? 
                //         (2.0 / nSyllableDistanceFromAccentedSyllableInThisWordToPreviousWordInGroup) : 0))

                nCurrentSyllableMomentum += (oSyllable.hasFullAccent ? 1.0 : 0.0) - nDecreaseValuePerSyllable //+ 
                    // (oSyllable.hasFullAccent && nSyllableDistanceFromAccentedSyllableInThisWordToPreviousWordInGroup > 0 ? 
                    // (5.0 / nSyllableDistanceFromAccentedSyllableInThisWordToPreviousWordInGroup) : 0)
                
                listDataForBarGraph.push({x: nCurrentX, y: nCurrentSyllableMomentum, color: this.GetColorForLinksInLineCount(nCurrentSyllableMomentum, true),
                    sVerse: w.Verse,
                    sText: w.Transliteration + ' v' + w.Verse + ' ' + nCurrentSyllableMomentum.toString()})

                nCurrentX += 1
            }
        }

        //console.log(listDataForBarGraph)
        let nMaxX = Math.max(...listDataForBarGraph.map(o => o.x))
        let nAverageValue = listDataForBarGraph.map(o => o.y).reduce((acc, n) => acc + n, 0) / (1.0 * listDataForBarGraph.length)

        return <XYPlot width={1100 + this.state.nChartWidthOffset} height={100} 
            margin={{left: this.state.nChartLeft + this.state.nLeftChartAlignmentOffset, top: 10, bottom: 5}}
            onMouseEnter={() => this.setState({blnCadenceChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnCadenceChartPopupIsVisible: false})}>

                <VerticalBarSeries colorType="literal" data={listDataForBarGraph}
                    onNearestXY={(value, {index}) => {
                        this.setState({hintLocationForCadenceChart: value})					
                        this.setState({sCadenceChartPopup: value.sText})
                    }} 
                />

                {this.state.blnShowAverageLineInBarChart && <LineSeries color='hsl(0, 0%, 80%)' 
                    data={[{x: 0, y: nAverageValue}, {x: nMaxX, y: nAverageValue}]} />}

                {/* {this.state.listShowVerseDivisionsInBarChart && <LineSeries color='hsl(0, 0%, 80%)' data={listVerseDivisions} />}
                {this.state.listShowVerseDivisionsInBarChart && listVerseDivisions.map(oVerseDivision => <MarkSeries color='hsl(0, 0%, 80%)' data={[{x: oVerseDivision.x, y: oVerseDivision.y}]} />)} */}
                
                {/* <XAxis tickTotal={listDistinctXs.length} /> */}
                {/* <XAxis /> */}
                {this.state.blnShowChartYAxis && <YAxis />}

                {this.state.blnCadenceChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForCadenceChart}>
                    <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "Calibri", fontSize:"18px"}}>
                        {this.state.sCadenceChartPopup}
                    </div>
                </Hint>}
            </XYPlot>
    }

    GetDistanceForEachWordInAnyLinkGroupFromLastWordInAnyLinkGroupChart(blnSeparateLinkGroups)
    {
        //console.log(this.GetDevelopmentDiagramLinkGroupsForChapter().filter(o => o.Name === 'a-t'))

        var listDataForBarGraph = []
        let listLinkGroups = this.GetDevelopmentDiagramLinkGroupsForChapter()
        .filter(oLinkGroup => {
            let nGroupLength = oLinkGroup.LineAndWordIndexes.length

            return nGroupLength >= this.state.nMinDevelopmentDiagramLinkGroupLengthToShow && 
            nGroupLength <= this.state.nMaxDevelopmentDiagramLinkGroupLengthToShow
        })

        if(blnSeparateLinkGroups)
        {
            var nCurrentX = 0

            for(var oLinkGroup of listLinkGroups
                .sort((a,b) => parseInt(a.LineAndWordIndexes[0].Word.TextIndex) - parseInt(b.LineAndWordIndexes[0].Word.TextIndex)))
            {
                let nGroupLength = oLinkGroup.LineAndWordIndexes.length
                if(nGroupLength > 2)
                {
                    for(var n = 1; n < oLinkGroup.LineAndWordIndexes.length; n++)
                    {
                        let lwiCurrent = oLinkGroup.LineAndWordIndexes[n]
                        let lwiPrevious = oLinkGroup.LineAndWordIndexes[n - 1]
                        let oCurrentWord = lwiCurrent.Word
                        let nSyllableDistance = this.CalculateSyllableDistanceBetweenAccentedSyllablesInWords(lwiPrevious.Word, oCurrentWord, this.listTextWordsForChapter)
            
                        listDataForBarGraph.push({x: nCurrentX, y: nSyllableDistance, color: this.GetColorForLinksInLineCount(nSyllableDistance, true),
                            sVerse: oCurrentWord.Verse,
                            sText: oCurrentWord.Transliteration + ' v' + oCurrentWord.Verse + ' ' + nSyllableDistance.toString()})

                        nCurrentX += 1
                    }

                    nCurrentX += 1
                }
            }
        }
        else
        {
            var listWordsPerLineGroup = this.GetLineGroupsForDevelopmentDiagram(this.state.listLines)
            .map(oLineGroup => oLineGroup.Lines.flatMap(l => l.Words))

            let listAllWordsInLinkGroups = listLinkGroups
            .flatMap(o => o.LineAndWordIndexes.map(lwi => lwi.Word).filter(w => o.WordsToNotColor === undefined || !o.WordsToNotColor.includes(w)))
            .sort((a,b) => parseInt(a.TextIndex) - parseInt(b.TextIndex))

            var nXForFirstWordInGroup = 0
            for(var n = 1; n < listAllWordsInLinkGroups.length; n++)
            {
                let oCurrentWord = listAllWordsInLinkGroups[n]
                let oPreviousWord = listAllWordsInLinkGroups[n - 1]
                let oPreviousWordForDistanceCalculation = oPreviousWord

                let blnExperiment = true
                if(blnExperiment)
                {
                    let listElementsOfLinkGroupForCurrentWord = listLinkGroups.find(oLinkGroup => oLinkGroup.LineAndWordIndexes.some(lwi => lwi.Word === oCurrentWord))
                        .LineAndWordIndexes.sort((a,b) => parseInt(a.Word.TextIndex) - parseInt(b.Word.TextIndex))

                    //console.log(oCurrentWord.Transliteration, listElementsOfLinkGroupForCurrentWord)
                    let nIndexForCurrentWord = listElementsOfLinkGroupForCurrentWord.findIndex(lwi => lwi.Word === oCurrentWord)
                    if(nIndexForCurrentWord > 0)
                    {
                        oPreviousWordForDistanceCalculation = listElementsOfLinkGroupForCurrentWord[nIndexForCurrentWord - 1].Word
                        //console.log(oPreviousWordForDistanceCalculation.Transliteration, oCurrentWord.Transliteration)
                    }
                }
                
                let nSyllableDistance = this.CalculateSyllableDistanceBetweenAccentedSyllablesInWords(oPreviousWordForDistanceCalculation, oCurrentWord, this.listTextWordsForChapter)

                if(this.state.blnShowGapsInBarChartBetweenSubunits && 
                    listWordsPerLineGroup.find(l => l.includes(oPreviousWord)) !== listWordsPerLineGroup.find(l => l.includes(oCurrentWord)))
                {
                    listDataForBarGraph.push({x: nXForFirstWordInGroup, y: 0, Gap: true, sText: ''})
                    nXForFirstWordInGroup += 1
                }

                listDataForBarGraph.push({x: nXForFirstWordInGroup + n, y: nSyllableDistance, color: this.GetColorForLinksInLineCount(nSyllableDistance, true),
                    sVerse: oCurrentWord.Verse,
                    sText: oCurrentWord.Transliteration + ' v' + oCurrentWord.Verse + ' ' + nSyllableDistance.toString()})
            }
        }
        
        let nMaxX = Math.max(...listDataForBarGraph.map(o => o.x))
        let nAverageSyllableDistance = listDataForBarGraph.map(o => o.y).reduce((acc, n) => acc + n, 0) / (1.0 * listDataForBarGraph.length)

        // let blnInvertYAxisValues = false
        // var nMaxY = Math.max(...listDataForBarGraph.map(o => o.y))
        // if(blnInvertYAxisValues) 
        // {
        //     listDataForBarGraph.forEach(o => o.y = nMaxY - o.y)
        //     //<YAxis tickFormat={v => nMaxY - v} />
        // }
        
        return <XYPlot width={1100 + this.state.nChartWidthOffset} height={100} 
            margin={{left: this.state.nChartLeft + this.state.nLeftChartAlignmentOffset, top: 10, bottom: 5}}
            onMouseEnter={() => this.setState({blnCadenceChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnCadenceChartPopupIsVisible: false})}>

                <VerticalBarSeries colorType="literal" data={listDataForBarGraph}
                    onNearestXY={(value, {index}) => {
                        this.setState({hintLocationForCadenceChart: value})					
                        this.setState({sCadenceChartPopup: value.sText})
                    }} 
                />

                {this.state.blnShowAverageLineInBarChart && <LineSeries color='hsl(0, 0%, 80%)' 
                    data={[{x: 0, y: nAverageSyllableDistance}, {x: nMaxX, y: nAverageSyllableDistance}]} />}

                {/* {this.state.listShowVerseDivisionsInBarChart && <LineSeries color='hsl(0, 0%, 80%)' data={listVerseDivisions} />}
                {this.state.listShowVerseDivisionsInBarChart && listVerseDivisions.map(oVerseDivision => <MarkSeries color='hsl(0, 0%, 80%)' data={[{x: oVerseDivision.x, y: oVerseDivision.y}]} />)} */}
                
                {/* <XAxis tickTotal={listDistinctXs.length} /> */}
                {/* <XAxis /> */}
                {this.state.blnShowChartYAxis && <YAxis />}

                {this.state.blnCadenceChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForCadenceChart}>
                    <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "Calibri", fontSize:"18px"}}>
                        {this.state.sCadenceChartPopup}
                    </div>
                </Hint>}
            </XYPlot>
    }

    GetNumberOfLinksPerLineChart()
    {
        let listLinkGroupsToUse = this.GetDevelopmentDiagramLinkGroupsForChapter()

        //the +1 in oLineGroup.Lines.length + 1 is to include the first line in the next group, so any links to it are counted
        var listLineIndexesPerGroup = this.GetLinesForSideBySideMode(this.state.listLines, this.state.sGroupLinesByForLens)
            .map(oLineGroup => 
                Array.from({length: oLineGroup.Lines.length + 1}, (_, i) => i)
                .map(n => oLineGroup.AbsoluteIndexOfFirstLineInGroup + n))

        var listDataForBarGraph = []
        var nXForFirstLineInGroup = 0
        this.dictLinksPerWord = new Map()
        this.dictClosestDistanceFromLastWordInSameLinkGroupsPerWord = new Map()
        this.listWordsStartingLinkGroups = []

        for(var listLineIndexesInGroup of listLineIndexesPerGroup)
        {
            let listAllLinkGroupElementsInLineGroup = []
            
            for(var oLinkGroup of listLinkGroupsToUse)
            {
                let listLinkGroupElementsInLineGroup = oLinkGroup.LineAndWordIndexes
                    .filter(lwi => listLineIndexesInGroup.includes(lwi.LineIndex))
                    
                let nGroupLength = listLinkGroupElementsInLineGroup.length
                if(nGroupLength >= this.state.nMinDevelopmentDiagramLinkGroupLengthToShow && 
                    nGroupLength <= this.state.nMaxDevelopmentDiagramLinkGroupLengthToShow)
                {

                    let listLinkGroupElementsInLineGroupSorted = listLinkGroupElementsInLineGroup.sort((a, b) => {
                        let nLineIndexComparison = a.LineIndex - b.LineIndex
                        return nLineIndexComparison !== 0 ? nLineIndexComparison : (parseInt(a.Word.TextIndex) - parseInt(b.Word.TextIndex))
                    })

                    let listLineIndexesInLinkGroup = [...new Set(listLinkGroupElementsInLineGroup.map(o => o.LineIndex))]
                    let nGroupLineSpan = Math.max(...listLineIndexesInLinkGroup) - Math.min(...listLineIndexesInLinkGroup)

                    this.listWordsStartingLinkGroups.push({Word: listLinkGroupElementsInLineGroupSorted[0].Word, 
                        GroupType: 
                        nGroupLength === 2 && nGroupLineSpan === 1 ? 1 :
                        nGroupLength === 3 && nGroupLineSpan === 2 ? 2 :
                        nGroupLength === 3 && nGroupLineSpan === 5 ? 3 :
                        nGroupLength > 3 && nGroupLineSpan > 4 ? 4 :
                        nGroupLength <= 3 && nGroupLineSpan > 5 ? 5 : 6
                    })

                    listAllLinkGroupElementsInLineGroup = listAllLinkGroupElementsInLineGroup.concat(listLinkGroupElementsInLineGroupSorted.slice(1))
                }
            }

            for(var nLine of listLineIndexesInGroup)
            {
                let line = this.state.listLines[nLine]
                if(nLine >= this.state.listLines.length) continue

                let listGroupsForLine = listAllLinkGroupElementsInLineGroup.filter(lwi => lwi.LineIndex === nLine)
                let nGroupsForLine = listGroupsForLine.length

                for(var w of line.Words)
                {
                    let listGroupsInLineForWord = listGroupsForLine.filter(lwi => lwi.Word === w)
                    this.dictLinksPerWord.set(w, listGroupsInLineForWord.length)

                    let listDistancesFromLastWordInSameLinkGroupsPerWord = 
                        listLinkGroupsToUse.filter(oLinkGroup => oLinkGroup.LineAndWordIndexes.some(lwi => lwi.Word === w))
                        .flatMap(oLinkGroup => oLinkGroup.LineAndWordIndexes.map(lwi => lwi.LineIndex))
                        .filter(n => n < nLine && listLineIndexesInGroup.includes(n))
                        .map(nPreviousLineIndex => nLine - nPreviousLineIndex)

                    //console.log(nLine, listGroupsForWord, Math.min(...listGroupsForWord.map(lwi => nLine - lwi.LineIndex).filter(n => n >= 0)))
                    this.dictClosestDistanceFromLastWordInSameLinkGroupsPerWord.set(w, 
                        listDistancesFromLastWordInSameLinkGroupsPerWord.length === 0 ? undefined : Math.min(...listDistancesFromLastWordInSameLinkGroupsPerWord))
                }

                //if(this.LineIsSelah(line)) continue
                //console.log(nLine, listAllLinkGroupElementsInLineGroup, listAllLinkGroupElementsInLineGroup.filter(lwi => lwi.LineIndex === nLine))
                
                listDataForBarGraph.push({x: nXForFirstLineInGroup + nLine, y: nGroupsForLine, color: this.GetColorForLinksInLineCount(nGroupsForLine, true),
                    IsFirstLineInVerse: false,  sVerse: line.Words[0].Verse, Gap: false,
                    sText: line.Words.map(w => w.Transliteration).join(' ') + ' v' + line.Words[0].Verse + ' ' + nGroupsForLine.toString()})
            }

            //nXForFirstLineInGroup += listLineIndexesInGroup.length

            if(this.state.blnShowGapsInBarChartBetweenSubunits)
            {
                listDataForBarGraph.push({x: nXForFirstLineInGroup, y: 0, Gap: true, sText: ''})
                nXForFirstLineInGroup += 1
            }
        }

        // console.log(listDataForBarGraph)

        var listVerseDivisions = []
        if(this.state.listShowVerseDivisionsInBarChart)
        {
            var sCurrentVerse = '0'
            var nIndexOfPreviousFirstLine = 0
            for(var nDataIndex = 0; nDataIndex < listDataForBarGraph.length; nDataIndex++)
            {
                var o = listDataForBarGraph[nDataIndex]
                if(o.Gap) continue

                if(o.sVerse != sCurrentVerse)
                {
                    if(nDataIndex > 0) 
                    {
                        listDataForBarGraph[nIndexOfPreviousFirstLine].lastLineInVerseY = listDataForBarGraph[nDataIndex - 1].y
                    }

                    nIndexOfPreviousFirstLine = nDataIndex
                    listDataForBarGraph[nDataIndex].IsFirstLineInVerse = true
                }
                else if(nDataIndex === listDataForBarGraph.length - 1)
                {
                    listDataForBarGraph[nIndexOfPreviousFirstLine].lastLineInVerseY = listDataForBarGraph[nDataIndex].y
                }

                if(o.sVerse != sCurrentVerse)
                {
                    listVerseDivisions.push({x: o.x, y: o.y}) //, color: o.color
                    sCurrentVerse = o.sVerse
                }
            }
        }

        return <XYPlot width={1100 + this.state.nChartWidthOffset} height={100} 
            margin={{left: this.state.nChartLeft + this.state.nLeftChartAlignmentOffset, top: 10, bottom: 5}}
            onMouseEnter={() => this.setState({blnCadenceChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnCadenceChartPopupIsVisible: false})}>

                <VerticalBarSeries colorType="literal" data={listDataForBarGraph}
                    onNearestXY={(value, {index}) => {
                        this.setState({hintLocationForCadenceChart: value})					
                        this.setState({sCadenceChartPopup: value.sText})
                    }} 
                />

                {this.state.listShowVerseDivisionsInBarChart && <LineSeries color='hsl(0, 0%, 80%)' data={listVerseDivisions} />}
                {this.state.listShowVerseDivisionsInBarChart && listVerseDivisions.map(oVerseDivision => <MarkSeries color='hsl(0, 0%, 80%)' data={[{x: oVerseDivision.x, y: oVerseDivision.y}]} />)}
                
                {/* <XAxis tickTotal={listDistinctXs.length} /> */}
                {/* <XAxis /> */}
                {this.state.blnShowChartYAxis && <YAxis />}

                {this.state.blnCadenceChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForCadenceChart}>
                    <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "Calibri", fontSize:"18px"}}>
                        {this.state.sCadenceChartPopup}
                    </div>
                </Hint>}
            </XYPlot>
    }
    
    GetNumberOfSyllablesInLineChart(sCountBy)
    {
        var listDataForBarGraph = []
        var nXForFirstLineInGroup = 0
        for(var oLineGroup of this.GetLineGroupsForDevelopmentDiagram(this.state.listLines))
        {
            listDataForBarGraph = listDataForBarGraph.concat(oLineGroup.Lines.filter(l => !l.IsSuperscription && l.Words.length > 0).map((line, nLine) => {
                let nCount = sCountBy === 'syllables' ? line.SyllableCount : line.Words.length
                return {x: nXForFirstLineInGroup + nLine, y: nCount, color: this.GetColorForLineSyllableCount(nCount, true),
                    IsFirstLineInVerse: false,  sVerse: line.Words[0].Verse, Gap: false,
                    sText: line.Words.map(w => w.Transliteration).join(' ') + ' v' + line.Words[0].Verse + ' ' + nCount.toString()}
            }))

            nXForFirstLineInGroup += oLineGroup.Lines.length

            if(this.state.blnShowGapsInBarChartBetweenSubunits)
            {
                listDataForBarGraph.push({x: nXForFirstLineInGroup, y: 0, Gap: true, sText: ''})
                nXForFirstLineInGroup += 1
            }
        }

        var listVerseDivisions = []
        if(this.state.listShowVerseDivisionsInBarChart)
        {
            var sCurrentVerse = '0'
            var nIndexOfPreviousFirstLine = 0
            for(var nDataIndex = 0; nDataIndex < listDataForBarGraph.length; nDataIndex++)
            {
                var o = listDataForBarGraph[nDataIndex]
                if(o.Gap) continue

                if(o.sVerse != sCurrentVerse)
                {
                    if(nDataIndex > 0) 
                    {
                        listDataForBarGraph[nIndexOfPreviousFirstLine].lastLineInVerseY = listDataForBarGraph[nDataIndex - 1].y
                    }

                    nIndexOfPreviousFirstLine = nDataIndex
                    listDataForBarGraph[nDataIndex].IsFirstLineInVerse = true
                }
                else if(nDataIndex === listDataForBarGraph.length - 1)
                {
                    listDataForBarGraph[nIndexOfPreviousFirstLine].lastLineInVerseY = listDataForBarGraph[nDataIndex].y
                }

                if(o.sVerse != sCurrentVerse)
                {
                    listVerseDivisions.push({x: o.x, y: o.y}) //, color: o.color
                    sCurrentVerse = o.sVerse
                }
            }
        }

        //let nChartWidth = 1000 + this.state.nChartWidthOffset
        //let nChartCenteringOffset = window.innerWidth / 2 - nChartWidth / 2

        //nChartCenteringOffset + this.state.nLeftChartAlignmentOffset
        //nChartCenteringOffset - this.state.nLeftChartAlignmentOffset, top: 10, bottom: 5}

        return <XYPlot width={1100 + this.state.nChartWidthOffset} height={100} 
            margin={{left: this.state.nChartLeft + this.state.nLeftChartAlignmentOffset, top: 10, bottom: 5}}
            onMouseEnter={() => this.setState({blnCadenceChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnCadenceChartPopupIsVisible: false})}>

                <VerticalBarSeries colorType="literal" data={listDataForBarGraph}
                    onNearestXY={(value, {index}) => {
                        this.setState({hintLocationForCadenceChart: value})					
                        this.setState({sCadenceChartPopup: value.sText})
                    }} 
                />

                {this.state.listShowVerseDivisionsInBarChart && <LineSeries color='hsl(0, 0%, 80%)' data={listVerseDivisions} />}
                {this.state.listShowVerseDivisionsInBarChart && listVerseDivisions.map(oVerseDivision => <MarkSeries color='hsl(0, 0%, 80%)' data={[{x: oVerseDivision.x, y: oVerseDivision.y}]} />)}
                
                {/* <XAxis tickTotal={listDistinctXs.length} /> */}
                {/* <XAxis /> */}
                {this.state.blnShowChartYAxis && <YAxis />}

                {this.state.blnCadenceChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForCadenceChart}>
                    <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "Calibri", fontSize:"18px"}}>
                        {this.state.sCadenceChartPopup}
                    </div>
                </Hint>}
            </XYPlot>
    }

    GetAverageInterstressLengthPerLineChart()
    {
        var listLinesToUse = this.state.listLines.filter(line => !line.IsSuperscription && !(line.Words.length === 1 && line.Words[0].LexicalID === '5937'))

        var listDataForBarGraph = listLinesToUse.map((line, nLine) => {
            let nAverageInterstressLengthForLine = line.Words.map(w => this.GetSyllableDistanceToPreviouslyAccentedSyllableForWord(w))
                .reduce((acc, n) => acc + n, 0) / (1.0 * line.Words.length)

            return {x: nLine, y: nAverageInterstressLengthForLine, color: 'hsl(0, 0%, 90%)', IsFirstLineInVerse: false,
                sVerse: line.Words[0].Verse, sText: line.Words[0].Verse + ' ' + line.Words.map(w => w.Transliteration).join(' ') + ' ' + nAverageInterstressLengthForLine.toString()}
        }).filter(o => o.y > -1)

        //var nMaxY = Math.max(...listDataForBarGraph.map(o => o.y)) + 1
        //listDataForBarGraph.forEach(o => o.y = nMaxY - o.y)

        var listVerseDivisions = []
        var sCurrentVerse = '0'
        var nIndexOfPreviousFirstLine = 0
        for(var nDataIndex = 0; nDataIndex < listDataForBarGraph.length; nDataIndex++)
        {
            var o = listDataForBarGraph[nDataIndex]

            if(o.sVerse != sCurrentVerse)
            {
                if(nDataIndex > 0) 
                {
                    listDataForBarGraph[nIndexOfPreviousFirstLine].lastLineInVerseY = listDataForBarGraph[nDataIndex - 1].y
                }

                nIndexOfPreviousFirstLine = nDataIndex
                listDataForBarGraph[nDataIndex].IsFirstLineInVerse = true
            }
            else if(nDataIndex === listDataForBarGraph.length - 1)
            {
                listDataForBarGraph[nIndexOfPreviousFirstLine].lastLineInVerseY = listDataForBarGraph[nDataIndex].y
            }

            if(o.sVerse != sCurrentVerse)
            {
                listVerseDivisions.push({x: o.x, y: o.y})
                sCurrentVerse = o.sVerse
            }
        }

        //console.log(listDataForBarGraph)
        
        return <>
        <XYPlot width={1300} height={125} margin={{left: 100 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 5}}
            onMouseEnter={() => this.setState({blnCadenceChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnCadenceChartPopupIsVisible: false})}>

                <VerticalBarSeries colorType="literal" data={listDataForBarGraph}
                    onNearestXY={(value, {index}) => {
                        this.setState({hintLocationForCadenceChart: value})					
                        this.setState({sCadenceChartPopup: value.sText})
                    }} 
                />

                <LineSeries color='hsl(0, 0%, 80%)' data={listVerseDivisions} />
                {listVerseDivisions.map(oVerseDivision => <MarkSeries color={'hsl(0, 0%, 80%)'} data={[{x: oVerseDivision.x, y: oVerseDivision.y}]} />)}

                <YAxis />
                {/* <YAxis tickFormat={v => nMaxY - v} /> */}

                {this.state.blnCadenceChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForCadenceChart}>
                    <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "Calibri", fontSize:"18px"}}>
                        {this.state.sCadenceChartPopup}
                    </div>
                </Hint>}
            </XYPlot>
        </>
    }

    GetChartForDevelopmentDiagram()
    {
        if(this.state.listWordGroupsForEnabledLenses.length === 0 || this.GroupByUnitHeatmapIsEnabled()) return

        let blnShowNumberOfSyllablesInLineChart = this.LensTypeIsEnabled('NumberOfSyllablesInLine') || 
            this.LensTypeIsEnabled('FindLineSyllableCountThemes') ||
            this.LensTypeIsEnabled('NumberOfWordsInLine') || 
            this.LensTypeIsEnabled('NumberOfSyllablesInLineIncreaseOrDecreaseChainsAllLines') || 
            this.LensTypeIsEnabled('NumberOfSyllablesInLineIncreaseOrDecreaseChainsLevel1UnitBoundaries')

        if(this.AverageInterstressLengthPerLineIsEnabled())
        {
            return this.GetAverageInterstressLengthPerLineChart()
        }
        else if(this.NumberOfLinksPerLineChartIsEnabled())
        {
            return this.GetNumberOfLinksPerLineChart()
        }
        else if(this.DistanceForEachWordInAnyLinkGroupFromLastWordInAnyLinkGroupChartIsEnabled())
        {
            return this.GetDistanceForEachWordInAnyLinkGroupFromLastWordInAnyLinkGroupChart(false)
        }
        else if(this.DistanceForEachWordInALinkGroupFromLastWordInThatLinkGroupChartIsEnabled())
        {
            return this.GetDistanceForEachWordInAnyLinkGroupFromLastWordInAnyLinkGroupChart(true)
        }
        else if(this.MomentumChartIsEnabled())
        {
            return this.GetMomentumChart()
        }
        else if(this.ConnectionsLensIsEnabled())
        {
            return this.GetConnectionLensChart()
        }
        else
        {
            return <>
            {blnShowNumberOfSyllablesInLineChart && this.GetNumberOfSyllablesInLineChart(this.LensTypeIsEnabled('NumberOfWordsInLine') ? 'words' : 'syllables')}
            {(!blnShowNumberOfSyllablesInLineChart || this.state.listWordGroupsForEnabledLenses.length > 1) && this.GetLineByLineLinkChart()}
            </>
        }
    }


    GetPaceChart(sCountBy)
    {
        //line.Words = listWordsInLine
        //line.SyllableObjects = listWordsInLine.flatMap(w => w.SyllableObjects)
		//line.SyllableCount = line.SyllableObjects.length
        //5937 = sela

        var listLinesToUse = this.state.listLines.filter(line => !line.IsSuperscription && !(line.Words.length === 1 && line.Words[0].LexicalID === '5937'))

        var listDataForBarGraph = listLinesToUse.map((line, nLine) => {
            //var nSyllablesWithDoubledConsonantsInLine = 0 //line.Words.flatMap(w => w.SyllableObjects.filter(oSyl => this.DoesSyllableHaveDoubledConsonant(oSyl))).length
            //console.log(line.Words.flatMap(w => w.SyllableObjects.filter(oSyl => this.DoesSyllableHaveDoubledConsonant(oSyl))))
            return {x: nLine, y: sCountBy === 'words' ? line.Words.length : line.SyllableCount, color: 'hsl(0, 0%, 90%)', IsFirstLineInVerse: false,
                sVerse: line.Words[0].Verse, sText: line.Words[0].Verse + ' ' + line.Words.map(w => w.Transliteration).join(' ')}
        }).filter(o => o.y > -1)

        var nMaxX = Math.max(...listDataForBarGraph.map(o => o.x)) + 1
        var nMaxY = Math.max(...listDataForBarGraph.map(o => o.y)) + 1
        listDataForBarGraph.forEach(o => o.y = nMaxY - o.y)

        var listVerseDivisions = []
        var sCurrentVerse = '0'
        var nIndexOfPreviousFirstLine = 0
        for(var nDataIndex = 0; nDataIndex < listDataForBarGraph.length; nDataIndex++)
        {
            var o = listDataForBarGraph[nDataIndex]

            if(o.sVerse != sCurrentVerse)
            {
                if(nDataIndex > 0) 
                {
                    listDataForBarGraph[nIndexOfPreviousFirstLine].lastLineInVerseY = listDataForBarGraph[nDataIndex - 1].y
                }

                nIndexOfPreviousFirstLine = nDataIndex
                listDataForBarGraph[nDataIndex].IsFirstLineInVerse = true
            }
            else if(nDataIndex === listDataForBarGraph.length - 1)
            {
                listDataForBarGraph[nIndexOfPreviousFirstLine].lastLineInVerseY = listDataForBarGraph[nDataIndex].y
            }

            // if(listVerseDivisions.length > 0)
            // {
            //     if(o.sVerse != sCurrentVerse)
            //     {
            //         listVerseDivisions[listVerseDivisions.length - 1].lastLineInVerseY = listDataForBarGraph[nDataIndex - 1].y
            //     }
            //     else if(nDataIndex === listDataForBarGraph.length - 1)
            //     {
            //         listVerseDivisions[listVerseDivisions.length - 1].lastLineInVerseY = listDataForBarGraph[nDataIndex].y
            //     }
            // }

            if(o.sVerse != sCurrentVerse)
            {
                listVerseDivisions.push({x: o.x, y: o.y})
                sCurrentVerse = o.sVerse
            }
        }

        //console.log(listDataForBarGraph)
        //listDataForBarGraph.forEach(o => o.color = listVerseDivisions.some(o2 => o2.x === o.x) ? 'hsl(0, 0%, 80%)' : o.color)

        var listRhymeRepetitionGroups = this.state.listRepetitionLinkGroups.filter(g => g.Type === 5)

        var listDataForBarGraphTaggedRhymeGroups = listLinesToUse.map((line, nLine, arr) => {
            var sVerse = line.Words[0].Verse
            var sHoverText = line.Words[0].Verse + ' ' + line.Words.map(w => w.Transliteration).join(' ')

            var listWordsForRhymeGroupsBetweenThisAndPreviousLine = listRhymeRepetitionGroups.filter(g => {
                var nForGroupInCurrentLine = g.ListWords.filter(ti => line.Words.some(w => w.TextIndex === ti)).length
                var nForGroupInPreviousLine = nLine === 0 ? 0 : g.ListWords.filter(ti => arr[nLine - 1].Words.some(w => w.TextIndex === ti)).length
                //var nForGroupInPreviousToPreviousLine = nLine === 0 ? 0 : g.ListWords.filter(ti => arr[nLine - 2].Words.some(w => w.TextIndex === ti)).length

                return nForGroupInCurrentLine > 1 || (nForGroupInCurrentLine > 0 && nForGroupInPreviousLine > 0)
            }).map(g => g.ListWords.sort((a,b) => parseInt(a) - parseInt(b)))

            //exclude the first word in the group to accurately count words when multiple words from the same group are in the same line
            var nWordsInVerseWithinARhymeGroupWithPreviousLine = line.Words.filter(w => 
                listWordsForRhymeGroupsBetweenThisAndPreviousLine.some(listWords => listWords.includes(w.TextIndex) && listWords[0] != w.TextIndex)).length

            return {x: nLine, y: nWordsInVerseWithinARhymeGroupWithPreviousLine, yNormalized: nWordsInVerseWithinARhymeGroupWithPreviousLine / (1.0 * line.Words.length), 
                color: 'hsl(0, 0%, 90%)', sVerse: sVerse, sText: sHoverText}
        })

        var nMaxYForRhymeGroups = Math.max(...listDataForBarGraphTaggedRhymeGroups.map(o => o.y))
        
        var listDataForBarGraphTaggedRhymeGroupsNormalized = listDataForBarGraphTaggedRhymeGroups.map(o => ({x: o.x, y: o.yNormalized, color: o.color, sVerse: o.sVerse, sText: o.sText}))
        var nMaxYForRhymeGroupsNormalized = Math.max(...listDataForBarGraphTaggedRhymeGroupsNormalized.map(o => o.y))

        return <>
        <XYPlot width={1300} height={125} margin={{left: 100 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 5}}
            onMouseEnter={() => this.setState({blnCadenceChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnCadenceChartPopupIsVisible: false})}>

                <VerticalBarSeries colorType="literal" data={listDataForBarGraph}
                    onNearestXY={(value, {index}) => {
                        this.setState({hintLocationForCadenceChart: value})					
                        this.setState({sCadenceChartPopup: value.sText})
                    }} 
                />

                {/* <LineSeries color='hsl(0, 0%, 80%)' data={listDataForBarGraph} /> */}
                {/* <LineMarkSeries color='hsl(0, 0%, 80%)' data={listDataForBarGraph} /> */}

                <LineSeries color='hsl(0, 0%, 80%)' data={listVerseDivisions} />

                {listVerseDivisions.map(oVerseDivision => <MarkSeries color={'hsl(0, 0%, 80%)'} data={[{x: oVerseDivision.x, y: oVerseDivision.y}]} />)}

                {/* {listVerseDivisions.map(x => <LineSeries color={'hsl(0, 0%, 92%)'} data={[{x: x, y: 0}, {x: x, y: nMaxY}]} />)} */}

                {/* <XAxis tickTotal={listDistinctXs.length} /> */}
                {/* <XAxis /> */}
                <YAxis tickFormat={v => nMaxY - v} />
                {/* <YAxis /> */}
                {this.state.blnCadenceChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForCadenceChart}>
                    <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "Calibri", fontSize:"18px"}}>
                        {this.state.sCadenceChartPopup}
                    </div>
                </Hint>}
            </XYPlot>

            
            <XYPlot width={1300} height={100} margin={{left: 100, right: 200, top: 10, bottom: 5}}>
                <VerticalBarSeries color={'hsl(0, 0%, 90%)'} data={listDataForBarGraph.map(o => ({x: o.x, y: o.IsFirstLineInVerse ? o.lastLineInVerseY - o.y : 0.05}))} />
                {/* <LineSeries color={'hsl(0, 0%, 92%)'} data={[{x: 0, y: 0}, {x: nMaxX, y: 0}]} /> */}
                <YAxis tickFormat={v => -v} />
            </XYPlot>

            {nMaxYForRhymeGroupsNormalized > 0 && 
            <XYPlot width={1300} height={70} margin={{left: 100, right: 200, top: 10, bottom: 5}}>
                <VerticalBarSeries colorType="literal" data={listDataForBarGraphTaggedRhymeGroupsNormalized} />
                {/* <YAxis /> */}
                <YAxis tickTotal={2} />
            </XYPlot>}

            {/* <XYPlot width={1300} height={70} margin={{left: 100, right: 200, top: 10, bottom: 5}}>
                <VerticalBarSeries colorType="literal" data={listDataForBarGraphTaggedRhymeGroups} />
                <YAxis tickTotal={nMaxYForRhymeGroups} />
            </XYPlot> */}
        </>
    }

    GetVersesInChapter()
    {
        return [...new Set(this.listTextWordsForChapter.map(w => w.Verse))]
    }

    GetAverageCadenceValuesByVerseChart()
    {
        var listVersesForChapter = this.GetVersesInChapter()

        var listDataForBarGraphCadence = listVersesForChapter.map(sVerse => {
            var listScoresForAccentedSyllablesInVerse = this.listSyllablesForChapter.filter(oSyl => oSyl.hasFullAccent && oSyl.word.Verse === sVerse)
                .map(oSyl => this.CalculateSyllableDistanceToPreviouslyAccentedSyllable(oSyl, false))
                
            var nAverageScoreForVerse = listScoresForAccentedSyllablesInVerse.reduce((acc, n) => acc + n, 0) / (1.0 * listScoresForAccentedSyllablesInVerse.length)

            return {x: parseInt(sVerse), y: nAverageScoreForVerse, color: 'LightGray'}
        })
        
        var listDataForBarGraphCombinedRhyme = listVersesForChapter.map(sVerse => {
            var listScoresForAccentedSyllablesInVerse = this.listTextWordsForChapter.filter(w => w.Verse === sVerse)
                .map(w => this.GetCombinedRhymeMaximumAmount(w, this.listTextWordsForChapter, this.state.sLocationRestrictionForSyllableRhyme))
                
            var nAverageScoreForVerse = listScoresForAccentedSyllablesInVerse.reduce((acc, n) => acc + n, 0) / (1.0 * listScoresForAccentedSyllablesInVerse.length)

            return {x: parseInt(sVerse), y: nAverageScoreForVerse, color: 'LightGray'}
        })

        // var listSimilarOppositeTags = [{ID: '28'}, {ID: '312'}, {ID: '310'}, 
        //     {ID: '74'}, {ID: '308'}, {ID: '66'}, {ID: '69'}, {ID: '304'}, {ID: '75'}]

        // var listVersesForSimilarOppositeGroupsForChapter = 
        //     this.listCorrespondencesForChapter.filter(g => listSimilarOppositeTags.some(cat => g.ListTags.some(t => t.CategoryID === cat.ID)))
        //         .map(c => c.ListWords.map(sTextIndex => this.GetWordWithTextIndexInChapter(sTextIndex) === undefined ? '' : this.GetWordWithTextIndexInChapter(sTextIndex).Verse))
                
        // var listDataForBarGraphSimilarOppositeGroups = listVersesForChapter.map(sVerse => {
        //     var nGroupsWithWordsInThisVerse = listVersesForSimilarOppositeGroupsForChapter.filter(listVerses => listVerses.includes(sVerse)).length
        //     return {x: parseInt(sVerse), y: nGroupsWithWordsInThisVerse, color: 'LightGray'}
        // })

        //console.log(this.ChainsBetweenLinesLens(this.listTextWordsForChapter, this.state.listLines))

        var listVersesForChainGroupsForChapter = this.MorphologicalChainsBetweenLinesLens(this.listTextWordsForChapter, this.state.listLines, this.state.nChainCutoffValue)
            .concat(this.SemanticChainsBetweenLinesLens(this.listTextWordsForChapter, this.state.listLines)).
            map(o => o.ListWords.map(w => w.Verse))
    
        //console.log(listVersesForChainGroupsForChapter)

        var listDataForBarGraphChainGroups = listVersesForChapter.map(sVerse => {
            var nGroupsWithWordsInThisVerse = listVersesForChainGroupsForChapter.filter(listVerses => listVerses.includes(sVerse)).length
            return {x: parseInt(sVerse), y: nGroupsWithWordsInThisVerse, color: 'LightGray'}
        })

        //will need to update this.state.listRepetitionLinkGroups to saved json once it goes live
        var listDataForBarGraphTaggedRhymeGroups = listVersesForChapter.map(sVerse => {
            var listWordsInVerse = this.listTextWordsForChapter.filter(w => w.Verse === sVerse)
            var nWordsInVerseWithinARhymeGroup = listWordsInVerse.filter(w => 
                this.state.listRepetitionLinkGroups.some(g => g.Type === 5 && g.ListWords.includes(w.TextIndex))).length

            return {x: parseInt(sVerse), y: nWordsInVerseWithinARhymeGroup / (1.0 * listWordsInVerse.length), color: 'LightGray'}
        })

        //console.log(listVersesForSimilarOppositeGroupsForChapter.filter(listVerses => listVerses.includes('5')).length)

        var nMaxForCadence = 1.0 * Math.max(...listDataForBarGraphCadence.map(d => d.y))
        var nMaxForCombinedRhyme = 1.0 * Math.max(...listDataForBarGraphCombinedRhyme.map(d => d.y))
        var nMaxForChainGroups = 1.0 * Math.max(...listDataForBarGraphChainGroups.map(d => d.y))

        var listDataForBarGraphOverall = listVersesForChapter.map(sVerse => {
            var nVerse = parseInt(sVerse)
            var nScore1 = listDataForBarGraphCadence.find(d => d.x === nVerse).y / nMaxForCadence
            var nScore2 = listDataForBarGraphChainGroups.find(d => d.x === nVerse).y / nMaxForChainGroups
            var nScore3 = listDataForBarGraphCombinedRhyme.find(d => d.x === nVerse).y / nMaxForCombinedRhyme
            
            return {x: nVerse, y: nScore1 + nScore2, color: 'LightGray'}
        })

        return <>
            <XYPlot width={1100} height={130} margin={{left: 300 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 50}}>
                <VerticalBarSeries colorType="literal" data={listDataForBarGraphCadence}/>
                <XAxis tickTotal={listVersesForChapter.length} />
                <YAxis />
            </XYPlot>

            <XYPlot width={1100} height={130} margin={{left: 300 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 50}}>
                <VerticalBarSeries colorType="literal" data={listDataForBarGraphTaggedRhymeGroups}/>
                <XAxis tickTotal={listVersesForChapter.length} />
                <YAxis />
            </XYPlot>

            {/* <XYPlot width={1100} height={130} margin={{left: 300, right: 200, top: 10, bottom: 50}}>
                <VerticalBarSeries colorType="literal" data={listDataForBarGraphChainGroups}/>
                <XAxis tickTotal={listVersesForChapter.length} />
                <YAxis />
            </XYPlot> */}

            {/* <XYPlot width={1100} height={130} margin={{left: 300, right: 200, top: 10, bottom: 50}}>
                <VerticalBarSeries colorType="literal" data={listDataForBarGraphCombinedRhyme}/>
                <XAxis tickTotal={listVersesForChapter.length} />
                <YAxis />
            </XYPlot> */}
            
            {/* <XYPlot width={1100} height={130} margin={{left: 300, right: 200, top: 10, bottom: 50}}>
                <VerticalBarSeries colorType="literal" data={listDataForBarGraphSimilarOppositeGroups}/>
                <XAxis tickTotal={listVersesForChapter.length} />
                <YAxis />
            </XYPlot> */}

            {/* <XYPlot width={1100} height={130} margin={{left: 300, right: 200, top: 10, bottom: 50}}>
                <VerticalBarSeries colorType="literal" data={listDataForBarGraphOverall}/>
                <XAxis tickTotal={listVersesForChapter.length} />
                <YAxis />
            </XYPlot> */}
        </>
    }

    GetSemanticChainsCharts()
    {
        var listTextWordsToUse = this.listTextWordsForChapter
        var listGroups = this.GetSemanticChainsForCurrentChapter(listTextWordsToUse)

        // if(this.state.sIntraOrInterUnitsLensScope === 'between')
        //     listWordsToCompare = listWordsByBreakGroup.filter(lw => !lw.includes(w)).flat()
        // else if(this.state.sIntraOrInterUnitsLensScope === 'inside')
        //     listWordsToCompare = listWordsByBreakGroup.filter(lw => lw.includes(w)).flat()

        var listLinesByBreakGroup = this.GetLinesByBreakGroup(this.state.listLines, this.state.sGroupLinesBy)
        .map(listLinesInGroup => 
        {
            return {LinesInGroup: listLinesInGroup, LengthOfLongestLineInGroup: Math.max(...listLinesInGroup.map(l => l.Words.length))}
        })

        var listGraphSeries = []

        var nMaxChartWidth = 1300
        var nXPerWordInLine = 5
        var nYPerLine = 2
        var nSpaceBetweenBreakGroups = 15
        var nSemanticGroup = 0
        var blnWithinBreakGroupOnly = this.state.sIntraOrInterUnitsLensScope === 'inside'
        var blnOnePerBreakGroupOnly = this.state.sIntraOrInterUnitsLensScope === 'between'
        var blnShowWithGapBetweenBreakGroups = true
        var nGapBetweenBreakGroupsToShow = 2

        var nMaxY = Math.max(...listLinesByBreakGroup.map(o => o.LinesInGroup.length)) * nYPerLine

        for(var g of listGroups)
        {
            var listDataForSeries = []
            var sGroupColor = this.listLinkGroupColors[nSemanticGroup % this.listLinkGroupColors.length]
            var listWordsInGroup = g.ListWords.map(n => this.GetWordWithTextIndexInChapter(n))

            for(var w of listWordsInGroup)
            {
                var nBreakGroupStartIndex = listDataForSeries.length === 0 ? 0 :
                    blnWithinBreakGroupOnly ? listDataForSeries[0].BreakGroup :
                    blnOnePerBreakGroupOnly ? (listDataForSeries[listDataForSeries.length - 1].BreakGroup + 1) : 0
                    
                var nBreakGroupEndIndex = listDataForSeries.length === 0 ? listLinesByBreakGroup.length :
                    //blnBetweenConsecutiveBreakGroupsOnly ? Math.min(listLinesByBreakGroup.length, (listDataForSeries[listDataForSeries.length - 1].BreakGroup + 2)) : 
                    blnWithinBreakGroupOnly ? (listDataForSeries[0].BreakGroup + 1) :
                    blnOnePerBreakGroupOnly ? listLinesByBreakGroup.length :
                    listLinesByBreakGroup.length

                var nBreakGroupIndexToShow = listDataForSeries.length === 0 ? 0 : Math.min(listLinesByBreakGroup.length, (listDataForSeries[listDataForSeries.length - 1].BreakGroup + nGapBetweenBreakGroupsToShow + 1))
                //if(listDataForSeries.length > 0) console.log(listDataForSeries.slice(-1), nBreakGroupStartIndex, nBreakGroupEndIndex)
                
                for(var nBreakGroup = nBreakGroupStartIndex; nBreakGroup < nBreakGroupEndIndex; nBreakGroup++)
                {
                    //if(nBreakGroup > nBreakGroupStartIndex && blnShowWithGapBetweenBreakGroups && nBreakGroup != nBreakGroupIndexToShow) continue

                    var o = listLinesByBreakGroup[nBreakGroup]
                    var nLineWithTheWord = o.LinesInGroup.findIndex(l => l.Words.includes(w))

                    if(nLineWithTheWord > -1)
                    {
                        var lineWithTheWord = o.LinesInGroup[nLineWithTheWord]
                        var nLengthInCurrentBreakGroup = lineWithTheWord.Words.indexOf(w) * nXPerWordInLine

                        var nLengthOfPreviousBreakGroups = listLinesByBreakGroup.slice(0, nBreakGroup)
                            .map(o2 => o2.LengthOfLongestLineInGroup * nXPerWordInLine + nSpaceBetweenBreakGroups)
                            .reduce((acc, n) => acc + n, 0)

                        listDataForSeries.push({x: nLengthInCurrentBreakGroup + nLengthOfPreviousBreakGroups, 
                            y: nMaxY - nLineWithTheWord * nYPerLine, 
                            color: sGroupColor, word: w, BreakGroup: nBreakGroup})
                        break
                    }
                }
            }

            listGraphSeries.push({Data: listDataForSeries, Color: sGroupColor})
            nSemanticGroup += 1
        }

        var nChartWidth = Math.min(nMaxChartWidth, listLinesByBreakGroup.length * 300)

        return <XYPlot width={nChartWidth} height={nMaxY * 20} 
            margin={{left: (1500 - nChartWidth) / 2 + this.state.nLeftChartAlignmentOffset, top: 20, bottom: 20}}
            onMouseEnter={() => this.setState({blnSemanticChainChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnSemanticChainChartPopupIsVisible: false})}>
            
            {listGraphSeries.map((d, nSeries) => 
            <LineMarkSeries lineStyle={{stroke: d.Color}} strokeStyle="dashed" strokeWidth={0.5} colorType="literal" data={d.Data} 
                onValueClick={(value, {index}) => {	
                    if(nSeries === this.state.nCurrentSeriesIDForSemanticChainChartPopup)
                    {
                        //this.ToggleSelectedWordGroupInLineChart(g)
                        this.setState({hintLocationForSemanticChainChart: value})
                        this.setState({sSemanticChainChartPopupText: value.word.FullText})
                    }
                }}

                 onNearestXY={(value, {index}) => {
                    if(this.state.blnShowHint && nSeries === this.state.nCurrentSeriesIDForSemanticChainChartPopup)
                    {
                        this.setState({hintLocationForSemanticChainChart: value})
                        this.setState({sSemanticChainChartPopupText: value.word.FullText})
                    }
                }}

                onSeriesMouseOver={(datapoint, event) => this.setState({nCurrentSeriesIDForSemanticChainChartPopup: nSeries})}
            />)}

            {this.state.blnShowHint && this.state.blnSemanticChainChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForSemanticChainChart}>
                <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", 
                    fontFamily: "SBL Hebrew", fontSize:"24px"}}>
                    {this.state.sSemanticChainChartPopupText}
                </div>
            </Hint>}
        </XYPlot>

        // fontFamily: "SBL Hebrew", fontSize:"24px"
        //.Gloss.replaceAll('^', ' ')
        // return <div style={{fontFamily: "SBL Hebrew", fontSize:"24px"}}>
        //     {listGroups.map(g => <div>
        //         {[...new Set(g.ListWords.map(sTextIndex => listTextWordsToUse.find(w => w.TextIndex === sTextIndex))
        //             .filter(w => w != undefined)
        //             .map(w => w.Lexeme))].join(" ")}
        //     </div>)}
        // </div>
    }

    GetVowelDistributionForRhymeGroupsChart()
    {
        //will need to update this.state.listRepetitionLinkGroups to saved json once it goes live
        var listVowels = [['a', 'â'], ['e'], ["ē", "ê", 'ey'], ['i'], ['ay'], ["o", "ô"], ["u", "û"]]
        var listStringsToExclude = [['ay'], ['ey'], [], [], [], [], []]

        var listAccentedSyllablesInARhymeGroup = this.listSyllablesForChapter.filter(oSyl => oSyl.hasFullAccent && 
            this.state.listRepetitionLinkGroups.some(g => g.Type === 5 && g.ListWords.includes(oSyl.word.TextIndex)))

        var listDataForBarGraph = listVowels.map((listCharsForVowel, nVowelIndex) => {
            return {x: nVowelIndex, y: listAccentedSyllablesInARhymeGroup.filter(oSyl => 
                listCharsForVowel.some(s => oSyl.syllable.includes(s)) &&
                !listStringsToExclude[nVowelIndex].some(s => oSyl.syllable.includes(s))).length, color: 'LightGray'}
        })
        
        //show distribution of the vowels by verse
        var listVersesForChapter = this.GetVersesInChapter()
        var listHeatMapData = []
        for(var sVerse of listVersesForChapter)
        {
            for(var nVowelIndex = 0; nVowelIndex < listVowels.length; nVowelIndex++)
            {
                var listCharsForVowel = listVowels[nVowelIndex]

                var nAccentedSyllablesWithVowelInVerse = listAccentedSyllablesInARhymeGroup.filter(oSyl => 
                    oSyl.word.Verse === sVerse &&
                    listCharsForVowel.some(s => oSyl.syllable.includes(s)) &&
                    !listStringsToExclude[nVowelIndex].some(s => oSyl.syllable.includes(s))).length

                listHeatMapData.push({x: parseInt(sVerse), y: nVowelIndex, color: nAccentedSyllablesWithVowelInVerse})
            }
        }

        return <>
        <XYPlot width={1100} height={130} margin={{left: 300 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 50}}>
            <VerticalBarSeries colorType="literal" data={listDataForBarGraph}/>
            <XAxis tickFormat={v => listVowels[v][0]}
                tickTotal = {listVowels.length}  
                style={{ text: {fontSize: 12}}} />
            <YAxis />
        </XYPlot>
        <XYPlot width={1100} height={200} margin={{left: 300 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 50}}>			
            <HeatmapSeries data={listHeatMapData} colorRange={["black", "white"]} />
            <YAxis tickFormat={v => listVowels[v][0]}
                tickTotal = {listVowels.length}  
                style={{ text: {fontSize: 12}}} />
            <XAxis tickTotal = {listVersesForChapter.length} />
        </XYPlot>
        </>
    }

    GetSyllableRhymeMaximumAmountByVerseChart()
    {
        var listVersesForChapter = this.GetVersesInChapter()
        
        var listDataForBarGraph = listVersesForChapter.map(sVerse => {
            var listScoresForAccentedSyllablesInVerse = this.listSyllablesForChapter.filter(oSyl => oSyl.word.Verse === sVerse)
                .map(oSyl => this.GetSyllableRhymeMaximumAmount(oSyl, this.listSyllablesForChapter, this.state.sLocationRestrictionForSyllableRhyme))
                
            var nAverageScoreForVerse = listScoresForAccentedSyllablesInVerse.reduce((acc, n) => acc + n, 0) / (1.0 * listScoresForAccentedSyllablesInVerse.length)

            return {x: parseInt(sVerse), y: nAverageScoreForVerse, color: 'LightGray', sText: nAverageScoreForVerse.toString()}
        })
        
        return <XYPlot width={1100} height={130} margin={{left: 300, right: 200, top: 10, bottom: 50}}>
            {/* onMouseEnter={() => this.setState({blnCadenceChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnCadenceChartPopupIsVisible: false})}> */}

                <VerticalBarSeries colorType="literal" data={listDataForBarGraph}
                    // onNearestXY={(value, {index}) => {
                    //     this.setState({hintLocationForCadenceChart: value})					
                    //     this.setState({sCadenceChartPopup: value.sText})
                    // }} 
                />
                <XAxis tickTotal={listVersesForChapter.length} />
                <YAxis />
                {/* {this.state.blnCadenceChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForCadenceChart}>
                    <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "Calibri", fontSize:"18px"}}>
                        {this.state.sCadenceChartPopup}
                    </div>
                </Hint>} */}
            </XYPlot>
    }

    GetCombinedRhymeMaximumAmountByVerseChart()
    {
        var listVersesForChapter = this.GetVersesInChapter()
        
        var listDataForBarGraph = listVersesForChapter.map(sVerse => {
            var listScoresForAccentedSyllablesInVerse = this.listTextWordsForChapter.filter(w => w.Verse === sVerse)
                .map(w => this.GetCombinedRhymeMaximumAmount(w, this.listTextWordsForChapter, this.state.sLocationRestrictionForSyllableRhyme))
                
            var nAverageScoreForVerse = listScoresForAccentedSyllablesInVerse.reduce((acc, n) => acc + n, 0) / (1.0 * listScoresForAccentedSyllablesInVerse.length)

            return {x: parseInt(sVerse), y: nAverageScoreForVerse, color: 'LightGray', sText: nAverageScoreForVerse.toString()}
        })
        
        return <XYPlot width={1100} height={130} margin={{left: 300 + this.state.nLeftChartAlignmentOffset, right: 200, top: 10, bottom: 50}}>
            {/* onMouseEnter={() => this.setState({blnCadenceChartPopupIsVisible: true})}
            onMouseLeave={() => this.setState({blnCadenceChartPopupIsVisible: false})}> */}

                <VerticalBarSeries colorType="literal" data={listDataForBarGraph}
                    // onNearestXY={(value, {index}) => {
                    //     this.setState({hintLocationForCadenceChart: value})					
                    //     this.setState({sCadenceChartPopup: value.sText})
                    // }} 
                />
                <XAxis tickTotal={listVersesForChapter.length} />
                <YAxis />
                {/* {this.state.blnCadenceChartPopupIsVisible && <Hint style={{zIndex:"200"}} value={this.state.hintLocationForCadenceChart}>
                    <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "Calibri", fontSize:"18px"}}>
                        {this.state.sCadenceChartPopup}
                    </div>
                </Hint>} */}
            </XYPlot>
    }

    GetChartPopupDiv()
    {
        return <div style={{background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px", paddingRight: "5px", paddingLeft: "2px", fontFamily: "SBL Hebrew", fontSize:"24px"}}>
            {/* {this.state.sForRepeatedRootLineChartPopup} */}

            {this.state.listLines.filter(l => {
                if(l.Words.length === 0) return false
                var listWordsInSameVerse = this.listTextWordsForChapter.filter(w => w.Verse === l.Words[0].Verse)
                return listWordsInSameVerse.some(w => this.WordShouldBeIncludedInLinesLocking(w))
            }).map(line => 
                <tr>
                    <td dir={this.blnChapterIsHebrew ? 'rtl' : 'ltr'} style={{textAlign: this.blnChapterIsHebrew ? 'right' : 'left'}}>
                        {Array(parseInt(line.IndentLevel) * this.nSpacesPerLineIndent).fill(<span>&nbsp;</span>)}				
                        {this.GetSpansForWords(line.Words, false, true, false, false)}
                    </td>
                    <td style={{paddingLeft: "5px", userSelect: "none"}}>
                        {this.state.blnShowVerseNumbers && this.listVerseBeginNumbersAndWords != undefined && 
                        (!this.listVerseBeginNumbersAndWords.some(r => line.Words.includes(r.Word)) ? '' :
                            this.listVerseBeginNumbersAndWords.find(r => line.Words.includes(r.Word)).VerseNumber)}
                    </td>
                    {this.state.blnShowGlossesInChartPopup && <td style={{textAlign:"left", paddingLeft: "5px", userSelect: "none"}}>
                        {Array(parseInt(line.IndentLevel) * this.nSpacesPerLineIndent).fill(<span>&nbsp;</span>)}				
                        {this.GetSpansForWords(line.Words, false, true, true, false)}
                    </td>}
                </tr>
            )}
        </div>
    }

    SaveCurrentGraph()
    {
        var visNetworkNodes = document.getElementsByClassName("vis-network");
        var theVisNetworkNode = visNetworkNodes[0]; // If you only have on graph vis element on the page
        var canvas = document.getElementsByTagName("svg")[0]; //The canvas

        console.log(document.getElementsByTagName("svg"))
        var img    = canvas.toDataURL("image/png");
        window.open(img, '_blank');
    }

    SomeHoverCompareLensIsEnabled()
    {
        return this.RhymeLensIsEnabled() || this.SemanticSimilarityLensIsEnabled() || this.RootCooccurrenceLensIsEnabled() || 
            this.DifferenceAmountLensIsEnabled() || this.AlltLensIsEnabled() || this.PatternLensIsEnabled() || 
            this.VowelChainLensIsEnabled() || this.ConsonantChainLensIsEnabled() || this.WordRhymeLensIsEnabled()
            //|| this.AllSimilarityForLinesLensIsEnabled()
            //|| this.AllSimilarityLensIsEnabled() 
    }

    SomeSyllableSpecificHoverLensIsEnabled()
    {
        return this.SyllableRhymeLensIsEnabled() || this.SyllableAtSameIndexInLineLensIsEnabled()
    }

    GetMaximumGroupLevelInLines(listLines)
    {
        //get the maximum level that is not superscription and is not the first non-superscription line
        let listToLookIn = listLines.filter(l => !l.IsSuperscription).slice(1)

        for(let sGroupLinesByToUse of ['StartsLevel4Group', 'StartsClusterGroup', 'StartsCluster', 'StartsRepetitionGroup'])
        {
            if(listToLookIn.some(l => this.LineStartsNewUnitAtCurrentLevel(l, sGroupLinesByToUse))) return sGroupLinesByToUse
        }

        return 'StartsClusterGroup'
    }

    LineStartsNewUnitAtCurrentLevel(line, sGroupLinesByToUse)
    {
        //'StartsLevel4Group', 'StartsClusterGroup', 'StartsCluster', 'StartsRepetitionGroup'
        return (sGroupLinesByToUse === 'StartsLevel4Group' && (line.StartsLevel4Group === '1' || line.StartsLevel4Group === true)) ||
            (sGroupLinesByToUse === 'StartsClusterGroup' && (line.StartsClusterGroup === '1' || line.StartsClusterGroup === true)) || 
            (sGroupLinesByToUse === 'StartsCluster' && (line.StartsCluster === '1' || line.StartsCluster === true)) || 
            (sGroupLinesByToUse === 'StartsRepetitionGroup' && (line.StartsRepetitionGroup === '1' || line.StartsRepetitionGroup === true))
    }

    BreakBeforeLine(line, nLineIndex, sGroupLinesByToUse)
    {
        return nLineIndex > 0 && this.LineStartsNewUnitAtCurrentLevel(line, sGroupLinesByToUse)
    }

    GetSpacerForWordDotGroups(line, nLineIndex, listLines)
    {
        if(this.state.sGroupLinesBy === 'ByChapter')
        {
            return nLineIndex > 0 && line.Chapter != listLines[nLineIndex - 1].Chapter
        }
        else return this.BreakBeforeLine(line, nLineIndex, this.state.sGroupLinesBy) ? 1 : 0
    }
    
    GetGroupBreakLines(nMaxY, blnXIsLineIndex, sGroupLinesByToUse)
    {
        var listByUnitLevel = []

        if(this.state.sVerticalBreakLinesToShowInLineCharts === 'allgroups')
        {
            for(var sLevel of ['StartsCluster', 'StartsClusterGroup', 'StartsLevel4Group']) //'StartsRepetitionGroup', 
            {
                listByUnitLevel = listByUnitLevel.concat(this.state.listLines.map((line, nLineIndex) => {
                    if(line.Words.length === 0) return false
                    
                    var x = blnXIsLineIndex ? nLineIndex : parseInt(line.Words[0].TextIndex)
                    var sLightness = sLevel === 'StartsLevel4Group' ? '85' : sLevel === 'StartsClusterGroup' ? '91' : sLevel === 'StartsCluster' ? '95' : '98'

                    return this.BreakBeforeLine(line, nLineIndex, sLevel) && 
                        <LineSeries color={'hsl(0, 0%, ' + sLightness + '%)'} data={[{x: x, y: 0}, {x: x, y: nMaxY}]} />
                }))
            }
        }
        else if(this.state.sVerticalBreakLinesToShowInLineCharts === 'somegroups')
        {
            listByUnitLevel = this.state.listLines.map((line, nLineIndex) => {
                if(line.Words.length === 0) return false
                var x = blnXIsLineIndex ? nLineIndex : parseInt(line.Words[0].TextIndex)
                return this.BreakBeforeLine(line, nLineIndex, sGroupLinesByToUse) && 
                    <LineSeries color='hsl(0, 0%, 91%)' data={[{x: x, y: 0}, {x: x, y: nMaxY}]} />
            })
        }

        return listByUnitLevel
    }

    GetVerseBreakLines(nMaxY)
    {
        if(this.state.sVerticalBreakLinesToShowInLineCharts != 'verses') return []

        var listVersesInChapter = [...new Set(this.listTextWordsForChapter.map(w => w.Verse))]

        return listVersesInChapter.map(sVerse => {
            var nFirstTextIndexInVerse = parseInt(this.listTextWordsForChapter.filter(w => w.Verse === sVerse)[0].TextIndex)
            return <LineSeries color='hsl(0, 0%, 91%)' data={[{x: nFirstTextIndexInVerse, y: 0}, {x: nFirstTextIndexInVerse, y: nMaxY}]} />
        })
    }

    GetBeginningMiddleEnd(listSubunitsInUnit)
    {
        // var listUnitStartProperties = ['StartsLevel4Group', 'StartsClusterGroup', 'StartsCluster', 'StartsRepetitionGroup', 'Line']
        // var nCurrentProperty = listUnitStartProperties.indexOf(sUnitStartProperty)
        // if(nCurrentProperty + 1 >= listUnitStartProperties.length) return {}

        // var sSubPropertyToGet = listUnitStartProperties[nCurrentProperty + 1]
        // var listLinesSubgroups = this.GetLinesByBreakGroup(listLinesInUnit, sSubPropertyToGet)

        // console.log(listLinesSubgroups, sSubPropertyToGet)

        var oResult = {'Beginning': [], 'Middle': [], 'End': []}
        if(listSubunitsInUnit.length === 1)
        {
            oResult = {'Beginning': listSubunitsInUnit, 'Middle': [], 'End': []}
        }
        else if(listSubunitsInUnit.length === 2)
        {
            oResult = {'Beginning': [listSubunitsInUnit[0]], 'Middle': [], 'End': [listSubunitsInUnit[1]]}
        }
        else if(listSubunitsInUnit.length === 3)
        {
            oResult = {'Beginning': [listSubunitsInUnit[0]], 'Middle': [listSubunitsInUnit[1]], 'End': [listSubunitsInUnit[2]]}
        }
        else if(listSubunitsInUnit.length === 4)
        {
            oResult = {'Beginning': [listSubunitsInUnit[0]], 'Middle': listSubunitsInUnit.slice(1,3), 'End': [listSubunitsInUnit[3]]}
        }
        // else if(listSubunitsInUnit.length % 2 === 0)
        // {
        //     var nSizePerGroup = listSubunitsInUnit.length / 3
        //     oResult = {'Beginning': listSubunitsInUnit.slice(0, nSizePerGroup), 
        //         'Middle': listSubunitsInUnit.slice(nSizePerGroup, nSizePerGroup * 3), 
        //         'End': listSubunitsInUnit.slice(nSizePerGroup * 3, listSubunitsInUnit.length)}
        // }
        else
        {
            var nAddToMiddleFactor = listSubunitsInUnit.length % 2 === 0 || listSubunitsInUnit.length % 3 === 0 ? 0 : 1
            var nSizePerGroup = Math.floor(listSubunitsInUnit.length / 3)
            oResult = {'Beginning': listSubunitsInUnit.slice(0, nSizePerGroup), 
                'Middle': listSubunitsInUnit.slice(nSizePerGroup, (nSizePerGroup * 2) + nAddToMiddleFactor), 
                'End': listSubunitsInUnit.slice((nSizePerGroup * 2) + nAddToMiddleFactor, listSubunitsInUnit.length)}
        }
        
        // console.log(listSubunitsInUnit, oResult)
        return {Beginning: oResult.Beginning, Middle: oResult.Middle, End: oResult.End}
    }

    GetUnitPartLines(listLinesInUnit, sUnitStartProperty, sPartType, nOffsetOfSubSubUnit)
    {
        //get the lines until the first next subsubunit
        var listUnitStartProperties = ['StartsLevel4Group', 'StartsClusterGroup', 'StartsCluster', 'StartsRepetitionGroup', 'Line']
        var nCurrentProperty = listUnitStartProperties.indexOf(sUnitStartProperty)
        if(nCurrentProperty + 2 >= listUnitStartProperties.length) return []

        var sSubSubPropertyToGet = listUnitStartProperties[nCurrentProperty + 2]
        var sSubPropertyToGet = listUnitStartProperties[nCurrentProperty + 1]
        var listLinesSubgroups = this.GetLinesByBreakGroup(listLinesInUnit, sSubPropertyToGet)

        var oSubgroupToUse = sPartType === 'beginning' ? listLinesSubgroups[0] : 
            sPartType === 'ending' ? listLinesSubgroups[listLinesSubgroups.length - 1] : [] 

        if(sSubSubPropertyToGet === 'Line')
        {
            return oSubgroupToUse.length <= nOffsetOfSubSubUnit ? [] : 
                sPartType === 'beginning' ? [oSubgroupToUse[nOffsetOfSubSubUnit]] : 
                [oSubgroupToUse[oSubgroupToUse.length - 1 - nOffsetOfSubSubUnit]]
        }

        var listSubSubLines = this.GetLinesByBreakGroup(oSubgroupToUse, sSubSubPropertyToGet)
        return listSubSubLines.length <= nOffsetOfSubSubUnit ? [] : 
            sPartType === 'beginning' ? listSubSubLines[nOffsetOfSubSubUnit] : 
            listSubSubLines[listSubSubLines.length - 1 - nOffsetOfSubSubUnit]

        // var listToReturn = []
        // for(var listSubgroup of listLinesSubgroups)
        // {
        //     var listSubSubLines = this.GetLinesByBreakGroup(listSubgroup, sSubSubPropertyToGet)
        //     if(listSubSubLines.length > 0) 
        //     {
        //         listToReturn = listToReturn.concat(sPartType === 'beginning' ? listSubSubLines[0] : 
        //             sPartType === 'ending' ? listSubSubLines[listSubSubLines.length - 1] : [])
        //     }
        // }

        // return listToReturn
    }

    // MarkFirstLevel4UnitOfChapterAsSuperscription()
    // {
    //     var listLevel4Groups = this.GetLinesByBreakGroup(this.state.listLines, 'StartsLevel4Group')
    //     listLevel4Groups[0].forEach(l => l.IsSuperscription = true)
    //     console.log(listLevel4Groups)
    //     // var nLevel3GroupsInFirstOne = this.GetLinesByBreakGroup(listLevel4Groups[0], 'StartsClusterGroup') 
    //     // console.log(listLevel4Groups, nLevel3GroupsInFirstOne, listLevel4Groups.slice(1).flat() )
    //     // return nLevel3GroupsInFirstOne === 1 ? listLevel4Groups.slice(1).flat() : listLines
    // }

    GetSubUnitForTextUnit(sTextUnit)
    {
        var listUnitTypes = ['StartsRepetitionGroup', 'StartsCluster', 'StartsClusterGroup', 'StartsLevel4Group']
        var nCurrentOne = listUnitTypes.indexOf(sTextUnit)
        return nCurrentOne === 0 ? sTextUnit : listUnitTypes[nCurrentOne - 1]
    }

    GetLinesByBreakGroup(listLinesToDivide, sGroupLinesByToUse)
    {
        if(sGroupLinesByToUse === 'ByChapter')
        {
            var listChaptersInLines = [...new Set(listLinesToDivide.map(l => parseInt(l.Chapter)))]
            return listChaptersInLines.map(nChapter => listLinesToDivide.filter(l => parseInt(l.Chapter) === nChapter))
        }
        else
        {
            var listLinesByBreakGroup = []
            var listLinesInCurrentGroup = []
            var nLineIndex = 0
            for(var line of listLinesToDivide)
            {
                if(this.BreakBeforeLine(line, nLineIndex, sGroupLinesByToUse))
                {
                    listLinesByBreakGroup.push(listLinesInCurrentGroup)
                    listLinesInCurrentGroup = [line]
                }
                else listLinesInCurrentGroup.push(line)

                nLineIndex++
            }

            if(listLinesInCurrentGroup.length > 0) listLinesByBreakGroup.push(listLinesInCurrentGroup)

            return listLinesByBreakGroup
        }
    }

    GetWordsByBreakGroup(listLinesToDivide, sGroupLinesByToUse)
    {
        return this.GetLinesByBreakGroup(listLinesToDivide, sGroupLinesByToUse).map(g => g.flatMap(l => l.Words))
    }

    GetWordsInSameSubUnitOfCurrentUnit(w)
    {
        var listWordsByBreakGroup = this.GetWordsByBreakGroup(this.state.listLines, this.GetSubUnitForTextUnit(this.state.sGroupLinesBy))
        var listWordsInSameGroup = listWordsByBreakGroup.find(lw => lw.includes(w))
        return listWordsInSameGroup === undefined ? [] : listWordsInSameGroup
    }

    GetWordDotChartGraphDataForWordGroups(listLinesToUse, listWordGroupsForLens, lens, blnSomeWordsAreOutlined, blnAllChaptersMode)
    {
        var nSpacer = 0
        return listLinesToUse.flatMap((line, nLineIndex) => {
            nSpacer += this.GetSpacerForWordDotGroups(line, nLineIndex, listLinesToUse)
            
            return line.Words.map((w, nWordIndex, wArr) => {
                var sColor = 'Black'
                var blnWordIsOutlined = this.WordIsOutlined(w, [w.TextIndex], false)

                if(!blnAllChaptersMode && (lens.LensType === "consonantlinechart" || lens.LensType === 'soundlinechart' || 
                    lens.LensType === 'SoundGroupByUnitHeatmap') && this.SomeWordGroupIsSelectedInLineChart())
                {
                    sColor = this.WordIsInAGroupSelectedInLineChart(w) ? 'Black' : 'LightGray'
                }
                else if(listWordGroupsForLens.length > 0)
                {
                    var listLensWordGroupsForWordSorted = listWordGroupsForLens.filter(g => lens.LensType === "localdensity" ? (g.ListWords[0] === w) : g.ListWords.includes(w)).
                        sort((a,b) => b.ColorPriority - a.ColorPriority)

                    sColor = listLensWordGroupsForWordSorted.length === 0 || 
                        (!blnWordIsOutlined && !blnAllChaptersMode && (this.SomeWordIsStickiedOrHovered() || this.SomeWordGroupIsSelectedInLineChart())) ? "DarkGray" : 
                        listLensWordGroupsForWordSorted.some(g => g.SelectedWords != undefined && g.SelectedWords.includes(w)) ? 'Black' : 
                        listLensWordGroupsForWordSorted[0].Color
                }

                //sColor = this.GetTextColor(w)
                if(sColor === 'Gray' || sColor === 'DarkGray') sColor = '#E8E8E8'
                else if(sColor === 'LightGray') sColor = '#E8E8E8'
                
                var listSpanTexts = []
                var nIndexToHighlight = nWordIndex

                if(!blnAllChaptersMode && (blnWordIsOutlined || !blnSomeWordsAreOutlined))
                {
                    if(listWordGroupsForLens.length === 0)
                    {
                        listSpanTexts = [this.GetGlossForWord(w)]
                        nIndexToHighlight += listSpanTexts.length
                        listSpanTexts = listSpanTexts.concat(wArr.map(lw => lw.FullText))
                        nIndexToHighlight = nWordIndex + 1
                    }
                    else
                    {
                        var listWordGroupsWithWord = listWordGroupsForLens.filter(g => g.ListWords.includes(w))
                        var sWordGroupInfo = [...new Set(listWordGroupsWithWord.map(g => g.Name))].join(", ")
                        var listSpanTexts = []
                        
                        if(listWordGroupsWithWord.length > 0) 
                        {
                            listSpanTexts = [sWordGroupInfo + (sWordGroupInfo === '' ? '' : ';'), this.GetGlossForWord(w), 'v' + w.Verse]
                            nIndexToHighlight += listSpanTexts.length
                            listSpanTexts = listSpanTexts.concat(wArr.map(lw => lw.FullText))
                        }
                    }
                }

                return {x: nLineIndex + nSpacer, y: wArr.length - nWordIndex - 1, word: w, ObjectForWordDotChartPopup: {Texts: listSpanTexts, IndexToHighlight: nIndexToHighlight}, color: sColor,
                size: blnWordIsOutlined ? 4 : 4}})
        })  //|| w.WordType === 'N'
    }

    GetWordDotChartGraphObject(graphData, sLensName, listLineIndexRangesToHighlight)
    {
        var sGraphUniqueName = 'WordDotChart' + (sLensName === '' ? 'All' : sLensName)
        var nMaxY = Math.max(...graphData.map(gd => gd.y))

        return <XYPlot width={1000} height={100} style={{marginLeft: '125px'}}
            onMouseEnter={() => this.setState({sWordDotChartUniqueNameCurrentlyShowingHint: sGraphUniqueName})}
            onMouseLeave={() => this.setState({sWordDotChartUniqueNameCurrentlyShowingHint: ''})}>

        {/* <VerticalGridLines />
        <HorizontalGridLines />
        <XAxis />
        <YAxis /> */}

        {!this.state.blnRestrictTextToVerseRangesToHighlight && listLineIndexRangesToHighlight.map(rh => 
            <VerticalRectSeries data={[{x0: rh.Begin, x: rh.End, y0: 0, y: nMaxY}]} color={'hsl(0, 0%, 85%)'} />)}

        <MarkSeries
            colorType="literal"
            sizeRange={[1, 5]}

            onValueClick={(value, {index}) => {	
                // this.setState({listGraphTextIndicesToHighlight: [value.word]});
                if(value.word === this.state.currentWordForHoverLens) this.ToggleWordInLenStickyWords(value.word)
                else this.SetCurrentWordForHoverLens(value.word) 
                this.ScrollToWords([value.word]);
            }}

            onNearestXY={(value, {index}) => {	
                this.setState({hintLocationForWordDotChart: value});					
                this.setState({oForWordDotChartPopup: value.ObjectForWordDotChartPopup})
                // console.log(value.ObjectForWordDotChartPopup)
                // if(this.AnyLensIsEnabled()) this.SetCurrentWordForHoverLens(value.word)
            }}

            data={graphData}
        />

        {this.state.sWordDotChartUniqueNameCurrentlyShowingHint === sGraphUniqueName && 
        this.state.oForWordDotChartPopup.Texts != undefined && this.state.oForWordDotChartPopup.Texts.length > 0 &&
            !this.PatternLensIsEnabled() &&
            <Hint value={this.state.hintLocationForWordDotChart}>
            <div style={{ background: 'white', color: "black", borderStyle: "solid", borderWidth: "1px",
                fontFamily: "SBL Hebrew", fontSize:"20px"}}>
            {this.state.oForWordDotChartPopup.Texts.map((s, n) => 
                <span style={{marginLeft: s.endsWith("־") || s.endsWith(';') ? '0px' : '7px', color: n === this.state.oForWordDotChartPopup.IndexToHighlight ? 'Red' : 'Black'}}>{s}</span>)}
            </div>
        </Hint>}
      </XYPlot>
    }

    GetWordDotChart()
    {
        {/* display only the first one as a dot chart because of space issues */}
        var lens = this.state.listLenses.filter(l => l.Sticky).length === 0 ? null : this.state.listLenses.filter(l => l.Sticky)[0]

        var graphData = []
        var blnSomeWordsAreOutlined = this.GetAllWordsInALensGroupWithCurrentHoveredWord().length > 0        
        var listLineIndexRangesToHighlight = this.GetLineIndexRangesForCurrentVerseRangesString()

        var nSpacer = 0

        if(lens === null || this.SomeHoverCompareLensIsEnabled())
        {
            // this.GetLinesToDraw()
            graphData = this.state.listLines.flatMap((line, nLineIndex) => {
                nSpacer += this.GetSpacerForWordDotGroups(line, nLineIndex, this.state.listLines)

                return line.Words.map((w, nWordIndex, wArr) => {
                    var sColor = this.state.currentWordForHoverLens === w ? 'Black' : this.GetTextColor(w)
                    if(sColor === 'Gray' || sColor === 'DarkGray') sColor = '#E8E8E8'
                    else if(sColor === 'LightGray') sColor = 'WhiteSmoke'

                    var sNameListForLensGroupsWordIsIn = this.GetNameListForLensGroupsWordIsIn(w)
                    var blnWordIsOutlined = this.WordIsOutlined(w, [w.TextIndex], false)

                    var listSpanTexts = []

                    if(((blnWordIsOutlined || !blnSomeWordsAreOutlined) && sNameListForLensGroupsWordIsIn != '') || 
                        this.SomeHoverCompareLensIsEnabled())
                    {
                        listSpanTexts = [sNameListForLensGroupsWordIsIn + (sNameListForLensGroupsWordIsIn != '' ? ';' : ''), this.GetGlossForWord(w), 'v' + w.Verse]
                        listSpanTexts = listSpanTexts.concat(wArr.map(lw => lw.FullText))
                    }

                    return {x: nLineIndex + nSpacer, y: wArr.length - nWordIndex - 1, word: w, ObjectForWordDotChartPopup: {Texts: listSpanTexts, IndexToHighlight: nWordIndex + 2}, color: sColor,
                    size: this.WordIsOutlined(w, [w.TextIndex], false) ? 4 : 3}})
            })

            // console.log(this.state.listLines)
            // graphData = graphData.concat(this.state.listLines.map((line, nLineIndex) => {
            //     var sColorForGroup = (line.StartsClusterGroup === '1' || line.StartsClusterGroup) ? 'Purple' : line.StartsCluster === '1' ? 'Red' : 'White'
            //     return {x: nLineIndex, y: -1, ObjectForWordDotChartPopup: {Texts: [], IndexToHighlight: -1}, color: sColorForGroup, size: 3}
            // }))
        }
        else
        {
            var listWordGroupsForLens = []
            if(this.state.listWordGroupsForCurrentHoverTypeLens.length > 0) 
                listWordGroupsForLens = this.state.listWordGroupsForCurrentHoverTypeLens
            else
            {
                var oForLens = this.state.listWordGroupsForEnabledLenses.find(o => o.Lens === lens)
                if(oForLens != undefined) listWordGroupsForLens = oForLens.ListGroups
            } 

            //for specific lens
            graphData = this.GetWordDotChartGraphDataForWordGroups(this.state.listLines, listWordGroupsForLens, lens, blnSomeWordsAreOutlined, false)
        }

        // console.log(graphData)
        return this.GetWordDotChartGraphObject(graphData, lens === null ? '' : lens.Name, listLineIndexRangesToHighlight)
    }

    WordIsOutlined(word, listTextIndexes, blnIsCurrentWordTag)
    {
        return this.state.listGraphTextIndicesToHighlight.some(gti => listTextIndexes.includes(gti.TextIndex)) ||
            this.IsWordBeingDragged(word) || this.IsWordBeingHoveredOn(word) || (this.WordIsInALensGroupWithCurrentHoveredWord(word)) ||
            (this.state.currentHoveredSubtag != undefined && this.state.currentHoveredSubtag.ListHebrewWords.includes(word.TextIndex)) ||
            (this.state.listSubtagsCurrentlyBeingAssociatedToWords.some(t => t.ListHebrewWords.includes(word.TextIndex))) ||
            blnIsCurrentWordTag || 
            (this.state.listWordsHoveredWhileDragging === undefined && this.DoesCurrentRepetitionLinkGroupIncludeWord(word))
    }

    FetchGlobalData()
    {
        if(this.listTextWordsForAllChapters.length === 0)
        {        
            fetch("HebrewTextData/allpsalmschapters.json")
            .then(res => res.json())
            .then(data => 
            {
                this.listTextWordsForAllChapters = data.OSHB
                this.textWordsByChapter = this.GroupArrayByKey(this.listTextWordsForAllChapters, "Chapter");
                
                this.listClausesForAllChapters = new Map()
                for(var sChapterToDo of Object.keys(this.textWordsByChapter))
                {						
                    this.listClausesForAllChapters.set(parseInt(sChapterToDo), this.CalculateClauses(this.textWordsByChapter[sChapterToDo]));
                }

                if(this.listLinesForAllChapters.length === 0)
                {
                    fetch("LineData/allpsalmslines.json")
                    .then(res => res.json())
                    .then(data => 
                    {
                        var listLinesForAllChaptersToSet = data.Lines
                        this.listLinesForAllChapters = this.SortLines(listLinesForAllChaptersToSet)
                        for(var sChapterToDo of Object.keys(this.GroupArrayByKey(this.listLinesForAllChapters, "Chapter")))
                        {
                            this.CalculateLines(this.listLinesForAllChapters.filter(r => r.Chapter === sChapterToDo), this.textWordsByChapter[sChapterToDo])
                        }

                        if(this.dictTextForAllOTWords.size === 0)
                        {
                            fetch("HebrewTextData/TextForAllOTWords.json")
                            .then(res => res.json())
                            .then(data => 
                            {
                                this.dictTextForAllOTWords = new Map() //Object.entries(data.Words))
                                // console.log('here 1')
                                for(var o of data.Words)
                                {
                                    this.dictTextForAllOTWords.set(o.N, o.T)   
                                }
                                
                                
                                // console.log(Object.keys(this.dictTextForAllOTWords)
                                // console.log(this.dictTextForAllOTWords)
                                // console.log('here 2')

                                // console.log(this.dictTextForAllOTWords)
                            })
                        }
                    })
                }
            })
        }
    }

    NumberOfRepetitionsByPositionInLine()
    {
        var blnBarChart = true
        var listData = [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]
        var sFieldToCheck = 'LexicalID' //'ParentRoot' //LexicalID
        for(var sChapterToDo of Object.keys(this.textWordsByChapter))
        {
            var listLinesTouse = this.listLinesForAllChapters.filter(r => r.Chapter === sChapterToDo)
            this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesTouse, false)
            // var listByBME = listLinesTouse.map(l => this.GetBeginningMiddleEnd(l.Words)) 

            // console.log(listByBME)
            var listTextWordsToUse = this.textWordsByChapter[sChapterToDo]
            var groupedByField = this.GroupArrayByKey(listTextWordsToUse, sFieldToCheck);
            for(var k of Object.keys(groupedByField))
            {
                var listInstancesOfWord = groupedByField[k].filter(w => ['N', 'V', 'A'].includes(w.WordType) && !['3270'].includes(w[sFieldToCheck]))
                if(listInstancesOfWord.length > 1)
                {
                    for(var w of listInstancesOfWord)
                    {
                        var lineWordIsIn = listLinesTouse.find(l => l.Words.includes(w))
                        if(lineWordIsIn != undefined) 
                        {
                            var nLineLength = lineWordIsIn.Words.length
                            if(nLineLength <= listData.length) listData[nLineLength - 1].push({y: listInstancesOfWord.length, x: lineWordIsIn.Words.indexOf(w)})
                        }
                    }
                    
                    // console.log(listInstancesOfWord.filter(w => !(listByBME.some(ol => ol.Beginning.includes(w)) ||
                    //     listByBME.some(ol => ol.Middle.includes(w)) ||
                    //     listByBME.some(ol => ol.End.includes(w)))))

                    // listData = listData.concat(listInstancesOfWord.map(w => ({y: listInstancesOfWord.length, 
                    //     x: listByBME.some(ol => ol.Beginning.includes(w)) ? 0 : 
                    //     listByBME.some(ol => ol.Middle.includes(w)) ? 1 : 
                    //     listByBME.some(ol => ol.End.includes(w)) ? 2 : 3})))
                }
            }
        }
 
        // console.log(listData.filter(o => o.x === 0).length, listData.filter(o => o.x === 1).length, 
        //     listData.filter(o => o.x === 2).length, listData.filter(o => o.x === 3).length, listData.filter(o => o.x === 4).length, 
        //     listData.filter(o => o.x > 4).length, listData.length)

        if(blnBarChart)
        {
            return listData.map(listDataForLineLength => {
                var listDistinctXs = [...new Set(listDataForLineLength.map(o => o.x))]
                var listDataForBarGraph = listDistinctXs.map(nX => ({x: nX, y: listDataForLineLength.filter(o => o.x === nX).length}))
                return <XYPlot width={400} height={200} margin={{bottom: 50}}>
                    <VerticalBarSeries color='LightGray' data={listDataForBarGraph} />
                    <XAxis tickTotal={listDistinctXs.length} />
                    <YAxis />
                </XYPlot>
            })
        }
        else 
        {
            return listData.map(listDataForLineLength => {
                return <XYPlot width={400} height={200} margin={{bottom: 50}}>			
                    <MarkSeries data={listDataForLineLength} />
                    <XAxis />
                    <YAxis />
                </XYPlot>
            })
        }
    }

    MaxDistanceVsMinDifferencesChartForAllPsalms()
    {
        var listData = []
        var sFieldToCheck = 'LexicalID' //'ParentRoot' //LexicalID
        for(var sChapterToDo of Object.keys(this.textWordsByChapter))
        {
            var listLinesTouse = this.listLinesForAllChapters.filter(r => r.Chapter === sChapterToDo)
            this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesTouse, false)

            var listTextWordsToUse = this.textWordsByChapter[sChapterToDo]
            var groupedByField = this.GroupArrayByKey(listTextWordsToUse, sFieldToCheck);
            for(var k of Object.keys(groupedByField))
            {
                var listInstancesOfWord = groupedByField[k].filter(w => ['N', 'V', 'A'].includes(w.WordType) && !['3270'].includes(w[sFieldToCheck]))
                if(listInstancesOfWord.length > 1)
                {
                    //calculate max distance
                    var listTextIndexesOfAllInstances = listInstancesOfWord.map(w1 => parseInt(w1.TextIndex))
                    var nMaxDistance = Math.max(...listTextIndexesOfAllInstances) - Math.min(...listTextIndexesOfAllInstances)
                    var nMaxDistanceScore = nMaxDistance / (1.0 * listTextWordsToUse.length)

                    //calculate min difference
                    var nMinDifferenceScoreSoFar = 10
                    for(var w1 of listInstancesOfWord)
                    {
                        for(var w2 of listInstancesOfWord)
                        {
                            if(w1 === w2) continue

                            var calcs = this.CalculateRepetitionLinkGroupCategoriesFromWords([w1, w2], listLinesTouse, false, true)
                            var nCompareGroups = calcs.ComparisonsAndCalculationsByWordType.length
                            var nDifferenceScore = (calcs.ComparisonsAndCalculationsByWordType.map(c2 => c2.Different.length).reduce((acc, n) => acc + n, 0) / (1.0 * nCompareGroups)) + 
                                (calcs.DifferentPolarity ? 1 : 0) + ((calcs.ConstructToSingleNoun || calcs.SingleNounToConstruct) ? 1 : 0)

                            if(nDifferenceScore < nMinDifferenceScoreSoFar) nMinDifferenceScoreSoFar = nDifferenceScore
                        }
                    }

                    listData.push({x: nMaxDistanceScore, y: nMinDifferenceScoreSoFar})
                }
            }
        }

        // console.log(listData)
        //margin={{left: 275, right: 100, top: 5, bottom: 50}} 
        // colorType="literal" 
        return <XYPlot width={500} height={500} margin={{bottom: 50}}>			
            <MarkSeries data={listData} />
            <XAxis />
            <YAxis />
        </XYPlot>
    }

    BMEUnitDistributionChart()
    {
        // this.state.listLines
        // Object.keys(this.textWordsByChapter).map(sChapterToDo => {
        //     var listLinesForChapter = this.listLinesForAllChapters.filter(r => r.Chapter === sChapterToDo)
        //     this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesForChapter, false)
        //     this.textWordsByChapter[sChapterToDo], listLinesForChapter
        // })

        var blnFilterIsForLinesNotWords = false
        var blnExcludeParticlesInLine = true

        var listCountsByPositionByGroup = []
        var nGroupBy = 0
        var listGroupsToUse = blnFilterIsForLinesNotWords ? ['StartsRepetitionGroup', 'StartsCluster', 'StartsClusterGroup', 'StartsLevel4Group', 'ByChapter'] : 
            ['Line', 'StartsRepetitionGroup', 'StartsCluster', 'StartsClusterGroup', 'StartsLevel4Group', 'ByChapter']

        for(var sGroupByToUse of listGroupsToUse)
        {
            var listByPosition = [[], [], []]
            for(var sChapterToDo of Object.keys(this.textWordsByChapter))
            {
                var listLinesForChapter = this.listLinesForAllChapters.filter(r => r.Chapter === sChapterToDo)
                this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesForChapter, false)

                var listByBME = sGroupByToUse === 'ByChapter' ? [this.GetBeginningMiddleEnd(listLinesForChapter)] :
                    sGroupByToUse === 'Line' ? listLinesForChapter.map(l => 
                        this.GetBeginningMiddleEnd(blnExcludeParticlesInLine ? l.Words.filter(w => !['T', 'R', 'C'].includes(w.WordType)) : l.Words)) :
                    this.GetLinesByBreakGroup(listLinesForChapter, sGroupByToUse).map(listLinesInGroup => this.GetBeginningMiddleEnd(listLinesInGroup))

                if(blnFilterIsForLinesNotWords || sGroupByToUse === 'Line')
                {
                    listByPosition[0] = listByPosition[0].concat(listByBME.flatMap(o => o.Beginning))
                    listByPosition[1] = listByPosition[1].concat(listByBME.flatMap(o => o.Middle))
                    listByPosition[2] = listByPosition[2].concat(listByBME.flatMap(o => o.End))
                }
                else
                {
                    listByPosition[0] = listByPosition[0].concat(listByBME.flatMap(o => o.Beginning.flatMap(l => l.Words)))
                    listByPosition[1] = listByPosition[1].concat(listByBME.flatMap(o => o.Middle.flatMap(l => l.Words)))
                    listByPosition[2] = listByPosition[2].concat(listByBME.flatMap(o => o.End.flatMap(l => l.Words)))
                }
            }
            
            //snip it and name it something like 'vocative bme unit distribution in psalms.png'
            //w.Waw === '1'
            //w.phrase_function === 'Voct'
            //['n', 'h', 'd'].includes(w.SuffixType)
            //l => !l.Words.some(w => w.WordType === 'V')

            //blnFilterIsForLinesNotWords above should be true for line filters, false for word filters
            //lcbp.filter(w => ['n', 'h', 'd'].includes(w.SuffixType))
            //lcbp.filter(l => !l.Words.some(w => w.WordType === 'V'))
            listCountsByPositionByGroup.push(listByPosition.map((lcbp, n) => ({x: n + (nGroupBy * 3), y: lcbp.filter(w => w.SuffixPerson === '3').length})))
            nGroupBy += 1
        }

        //margin={{left: 275, bottom: 20}}>  
        // console.log(listCountsByPositionByGroup)
        return listCountsByPositionByGroup.map(listCountsByPosition => {
            return <XYPlot width={500} height={75} margin={{bottom: 10}}> 
                <VerticalBarSeries color='LightGray' data={listCountsByPosition} />
                {/* {listCountsByPositionByGroup.map(listCountsByPosition => <VerticalBarSeries color='LightGray' data={listCountsByPosition} />)}        */}
                {/* <VerticalBarSeries colorType="literal" data={correlationGraphData} /> */}
                <XAxis tickTotal={0} /> 
                {/* <YAxis /> */}
                {/* <VerticalGridLines />
                <HorizontalGridLines /> */}
            </XYPlot>
        })
    }

    GetDotChartForAllPsalms()
    {
        // console.log(this.textWordsByChapter)
        // this.setState({listWordGroupsForEnabledLenses: []})

        return Object.keys(this.textWordsByChapter).map(sChapterToDo => {
            var listLinesForChapter = this.listLinesForAllChapters.filter(r => r.Chapter === sChapterToDo)
            this.CalculateRepetitionGroupsAndPGroupOrderInLines(listLinesForChapter, false)

            var listWordGroupsForLenses = this.GetWordGroupsForEnabledLenses(listLinesForChapter) //TODO: , this.listSyllablesByChapter[sChapterToDo]
            if(listWordGroupsForLenses.length > 0)
            {
                var lens = listWordGroupsForLenses[0].Lens
                var graphData = this.GetWordDotChartGraphDataForWordGroups(listLinesForChapter, listWordGroupsForLenses[0].ListGroups, lens, false, false)
                
                console.log(sChapterToDo, listLinesForChapter, graphData, listWordGroupsForLenses[0].ListGroups)
                return this.GetWordDotChartGraphObject(graphData, lens.Name + '_chapter' + sChapterToDo, [])
            }
            else return this.GetWordDotChartGraphObject([], '', [])
        })
    }

    GetCommandPalette()
    {
        return <Autocomplete autoComplete clearOnBlur selectOnFocus freeSolo 
            options={this.state.listLenses.filter(l => this.LensShouldBeShown(l) && !(l.View === 'text' && l.LensType === 'letter'))}
            value={this.state.oLensSelectedFromTaskSearch}
            getOptionLabel={(option) => option.Help === undefined ? "?" : option.Help}
            groupBy={(option) => option.View === undefined ? "?" : option.View}
            onChange={(event, oSelectedLens) => {
                this.setState({oLensSelectedFromTaskSearch: oSelectedLens})

                if(oSelectedLens != null)
                {
                    // this.ChangeView(oSelectedLens.View)
                    // if(this.state.sViewBy !== 'Line')
                    // {
                    //     this.ChangeViewByTo('Line')
                    // }

                    if(this.ShowingDevelopmentDiagram())
                    {
                        if(oSelectedLens.View === 'sound' || oSelectedLens.View === 'rhythm')
                        {
                            this.setState({sDevelopmentDiagramLanguage: 'transliteration'}) //original, transliteration, translation
                        }
                        else if(oSelectedLens.View === 'text')
                        {
                            this.setState({sDevelopmentDiagramLanguage: 'original'})
                        }
                    }

                    this.EnableSingleLens(oSelectedLens)

                    var listRecentLensesToSet = this.state.listRecentLenses
                    listRecentLensesToSet.push(oSelectedLens)

                    if(listRecentLensesToSet.length > this.state.nMaxRecentLensesToShow)
                    {
                        listRecentLensesToSet = listRecentLensesToSet.slice(1)
                    }

                    this.setState({listRecentLenses: listRecentLensesToSet})
                    this.setState({blnTaskPopoverIsOpen: false})
                }
            }} 
            style={{width: this.nTaskPopoverWidth, height: this.nTaskPopoverHeight, marginLeft: "10px", marginRight: "10px"}}
            size="small"
            onFocus={(e) => this.setState({blnTaskSearchAutocompleteHasFocus: true})}
            onBlur={(e) => this.setState({blnTaskSearchAutocompleteHasFocus: false})}
            renderInput={(params) => (
                <TextField {...params} variant="outlined" autoFocus />
            )}
            ListboxProps={
                {
                    style:{
                        maxHeight: '500px',
                        //border: '1px solid red'
                    }
                }
            }
        />
    }

    SyllableShouldBeBolded(oSyllable)
    {
        var sSyllableWithAccent = oSyllable['syllable']
        var blnIsLightlyAccented = sSyllableWithAccent.includes('|')
        var blnIsFullAccented = sSyllableWithAccent.includes('*') || sSyllableWithAccent.includes('^')
        
        return this.state.blnBoldAccentedSyllables && blnIsFullAccented && (this.state.blnShowAccentOnLastSyllable || !oSyllable['isLastSyllableInWord'])
    }

    GetSpansForSyllables(listSyllables, blnLineMode)
    {
        var blnSomeWordIsSelected = this.SomeWordIsStickiedOrHovered()

        return listSyllables.map(oSyllable => {
            var word = oSyllable['word']
            var sSyllableWithAccent = oSyllable['syllable']

            // return listSyllables.map((syl, nSyl, arrSyl) => ({'word': w, 'syllable': syl.replaceAll('ah', 'a').replaceAll('ṣ', 'ts').replaceAll('š', 'sh').replaceAll('ḵ', 'kh'), 
            //     'syllableWithSingleConsonants': syl.replaceAll('ah', 'a'), 'hasFullAccent': this.SyllableHasFullAccent(syl), 
            //     'hasSecondaryAccent': this.SyllableHasSecondaryAccent(syl), 'syllableIndex': nSyl, 'isLastSyllableInWord': nSyl === arrSyl.length - 1,
            //     'endsWithConsonantalHe': syl.includes('hh')}))
            
            //stressed = ^
            //oSyllable['hasFullAccent'] ? '–' : '˘' 
            var sSyllable = sSyllableWithAccent.replaceAll('*', '').replaceAll('|', '').replaceAll('^', '')

            var listTextIndexes = [word.TextIndex]
            var blnIsCurrentWordTag = this.state.currentWordTag != undefined && this.state.currentWordTag.TextIndex === word.TextIndex;
            var blnWordIsOutlined = this.WordIsOutlined(word, listTextIndexes, blnIsCurrentWordTag)
            
            //var sAccentDiacritic = oSyllable['hasFullAccent'] ? '\u0300' : '\u030C'

            var sColor = this.SomeSyllableSpecificLensIsEnabled() ? this.GetTextColorForSyllable(oSyllable) : this.GetTextColor(word)
            if(blnSomeWordIsSelected && !blnWordIsOutlined && !this.SomeHoverCompareLensIsEnabled()) sColor = 'DarkGray' //this.LightenColor(sWordColor, 1.8)

            //var blnShowAccentOnLastSyllable = this.CadenceChangesLensIsEnabled() && oSyllable['isLastSyllableInWord'] && sColor != 'Black'

            //<span style="white-space: nowrap">
            return <>
            <span class="TextWordDiv" //title={blnTranslation ? "test2" : }
            style={{ 
                fontFamily: "Calibri",
                fontWeight: this.SyllableShouldBeBolded(oSyllable) ? 'bold' : 'normal', //blnIsLightlyAccented ? 'semibold' :
                WebkitTextStroke: this.blnIsIOSSafari ? "0.5px" : "",
                color: sColor,
                //bold: true,
                borderStyle: "none", //blnWordIsOutlined && !this.AllSimilarityLensIsEnabled() ? "dotted" : "none", //dashed, dotted, inset, solid
                
                display: 'inline-block',
                borderColor: (this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ? "red" :
                    (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word)) ? "red" : 	
                    (this.state.listWordsHoveredWhileDragging === undefined && this.DoesSelectedCurrentRepetitionLinkGroupIncludeWord(word) && this.GetRepetitionLinkGroupsContainingWord(word).length > 1) ? "blue" :		
                    !this.state.listGraphTextIndicesToHighlight.some(gti => listTextIndexes.includes(gti.TextIndex) && gti.BorderColor != undefined) ? "black" :
                    this.state.listGraphTextIndicesToHighlight.find(gti => listTextIndexes.includes(gti.TextIndex)).BorderColor,
                    
                borderWidth:((this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ||
                    (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word))) ? "4px" : "1px",

                fontSize: "18px",
                userSelect: (this.state.nSelectedToolID === null || this.state.nSelectedToolID == 0) && !this.state.blnShiftDown ? "" : "none"  
            }}               
            key={word.TextIndex}
            onClick={(event) => {
                if(event.altKey)
                {
                    //if there is no translation for a line, it cannot be alt+clicked on to edit it, 
                    //so also allow alt+click on the transliteration to edit it
                    let nLineClickedOn = this.state.listLines.findIndex(r => r.Words.includes(word))
                    if(nLineClickedOn > -1)
                    {
                        var listLineIndexesBeingEditedForOurTranslationToSet = this.state.listLineIndexesBeingEditedForOurTranslation
                        listLineIndexesBeingEditedForOurTranslationToSet.push(nLineClickedOn)
                        this.setState({listLineIndexesBeingEditedForOurTranslation: listLineIndexesBeingEditedForOurTranslationToSet})
                    }
                }
                else
                {
                    if(this.state.nSelectedToolID === this.nColaSplitToolID || this.state.nSelectedToolID === this.nColaMergeToolID)
                    {
                        this.handleClickOnWord(event, word)
                    }
                }
            }}
            onMouseDown={(event) => this.DragWordStart(word, event)}
            onMouseUp={(event) => this.DragWordEnd(word, event, oSyllable)}
            onMouseEnter={(event) => this.handleHoverWord(word, event.currentTarget, 'transliteration', oSyllable)}
            onTouchStart={(event) => this.handleHoverWord(word, event.currentTarget, 'transliteration', oSyllable)}
            onMouseLeave={(event) => this.handleHoverLeaveWord(word, event)}
            onTouchEnd={(event) => this.handleHoverLeaveWord(word, event)} 
            //onTouchMove={(event) => this.DragWordMove(word, event)}

            ref={this.state.dictRefs.get(word.TextIndex) === undefined ? undefined :
				this.state.dictRefs.get(word.TextIndex).Transliteration}>

			{blnLineMode || !this.state.blnShowVerseNumbers || this.listVerseBeginNumbersAndWords === undefined ? '' :
			!this.listVerseBeginNumbersAndWords.some(r => listTextIndexes.includes(r.Word.TextIndex)) ? '' :
			this.listVerseBeginNumbersAndWords.find(r => listTextIndexes.includes(r.Word.TextIndex)).VerseNumber + ' '}
			
            {this.state.blnEllipsisMode && <span style={{borderStyle: "solid", borderColor:"blue", borderWidth: "1px"}}>&nbsp;</span>}

            {sSyllable + ''}

			{/* {this.VowelChainLensIsEnabled() ? this.GetBasicVowelsInTransliteration(sSyllable) :  */}
             {/* this.ConsonantChainLensIsEnabled() ? this.GetConsonantsInTransliteration(sSyllable) : sSyllable} */}

			{!oSyllable['isLastSyllableInWord'] ? '' : !word.HasFullAccent && this.blnChapterIsHebrew ? <span>-</span>: <span>&nbsp;</span>} 

			{!blnLineMode && 
			(
                // this.state.sViewBy === "Clause" ? 
				// (this.listClauses.some(c => listTextIndexes.includes(c.EndIndex.toString())) ? <br />: '') :
			this.state.sViewBy === "Verse" ? 
				(this.listVerseEndIndexes.some(n => listTextIndexes.includes(n.toString())) ? <br />: '') : 
			this.state.sViewBy === "Sentence" ? 
				(this.listSentenceEndIndexes.some(n => listTextIndexes.includes(n.toString())) ? <br />: '') : 
			this.state.sViewBy === "Phrase" ? 
				(this.listPhraseEndIndexes.some(n => listTextIndexes.includes(n.toString())) ? <br />: '') : '')}

            </span>
            </>
        })
    }

    GetSpansForBSB(listBSBsForVerse, listOriginalTextWordsInVerse)
    {
        if(listBSBsForVerse.length === 0) return
        //console.log(listBSBsForVerse[0], listOriginalTextWordsInVerse)
        var listWords = listBSBsForVerse[0].split(' ')

        var blnSomeWordIsSelected = this.SomeWordIsStickiedOrHovered()
        var blnALensIsActive = this.state.blnShowLenses && (this.state.listWordGroupsForEnabledLenses.length > 0 || 
            (blnSomeWordIsSelected && this.SomeHoverCompareLensIsEnabled()))

        return listWords.map((sWordToShow, nWordIndex) => {
            var listOriginalWordsForBSBWord = listOriginalTextWordsInVerse.filter(w => w.BSB.includes(nWordIndex + 1))

            if(listOriginalWordsForBSBWord.length === 0)
            {
                var sWordColor = blnALensIsActive ? 'DarkGray' : 'Black'
                var listTextIndexes = []
    
                return <>
                <span class="TextWordDiv" //title={blnTranslation ? "test2" : }
                style={{ 
                    fontFamily: "Calibri", 
                    WebkitTextStroke: this.blnIsIOSSafari ? "0.5px" : "",
                    color: sWordColor, 
                    borderStyle: "none", //blnWordIsOutlined && !this.AllSimilarityLensIsEnabled() ? "dotted" : "none", //dashed, dotted, inset, solid
                    
                    display: 'inline-block',
                    borderColor: (this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ? "red" :
                        (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word)) ? "red" : 	
                        (this.state.listWordsHoveredWhileDragging === undefined && this.DoesSelectedCurrentRepetitionLinkGroupIncludeWord(word) && this.GetRepetitionLinkGroupsContainingWord(word).length > 1) ? "blue" :		
                        !this.state.listGraphTextIndicesToHighlight.some(gti => listTextIndexes.includes(gti.TextIndex) && gti.BorderColor != undefined) ? "black" :
                        this.state.listGraphTextIndicesToHighlight.find(gti => listTextIndexes.includes(gti.TextIndex)).BorderColor,
                        
                    borderWidth:((this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ||
                        (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word))) ? "4px" : "1px",
    
                    fontSize: "18px",
                    userSelect: (this.state.nSelectedToolID === null || this.state.nSelectedToolID == 0) && !this.state.blnShiftDown ? "" : "none"  
                }}>
    
                {sWordToShow}
                <span>&nbsp;</span>
                </span>
                </>
            }
            else
            {
                var word = listOriginalWordsForBSBWord[0]

                var listTextIndexes = word === null ? [] : [word.TextIndex]
                var blnIsCurrentWordTag = this.state.currentWordTag != undefined && this.state.currentWordTag.TextIndex === word.TextIndex
                var blnWordIsOutlined = this.WordIsOutlined(word, listTextIndexes, blnIsCurrentWordTag)

                var sWordColor = this.GetTextColor(word)
                if(blnSomeWordIsSelected && !blnWordIsOutlined && !this.SomeHoverCompareLensIsEnabled()) sWordColor = 'DarkGray'

                return <>
                <span class="TextWordDiv" //title={blnTranslation ? "test2" : }
                style={{ 
                    fontFamily: "Calibri", 
                    WebkitTextStroke: this.blnIsIOSSafari ? "0.5px" : "",
                    color: sWordColor, 
                    borderStyle: "none", //blnWordIsOutlined && !this.AllSimilarityLensIsEnabled() ? "dotted" : "none", //dashed, dotted, inset, solid
                    
                    display: 'inline-block',
                    borderColor: (this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ? "red" :
                        (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word)) ? "red" : 	
                        (this.state.listWordsHoveredWhileDragging === undefined && this.DoesSelectedCurrentRepetitionLinkGroupIncludeWord(word) && this.GetRepetitionLinkGroupsContainingWord(word).length > 1) ? "blue" :		
                        !this.state.listGraphTextIndicesToHighlight.some(gti => listTextIndexes.includes(gti.TextIndex) && gti.BorderColor != undefined) ? "black" :
                        this.state.listGraphTextIndicesToHighlight.find(gti => listTextIndexes.includes(gti.TextIndex)).BorderColor,
                        
                    borderWidth:((this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ||
                        (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word))) ? "4px" : "1px",
    
                    fontSize: "18px",
                    userSelect: (this.state.nSelectedToolID === null || this.state.nSelectedToolID == 0) && !this.state.blnShiftDown ? "" : "none"  
                }}               
                key={word.TextIndex}
                // onClick={(event) => {if(!blnTranslation || blnGlossed) this.handleClickOnWord(event, word)}}
                onMouseDown={(event) => this.DragWordStart(word, event)}
                onMouseUp={(event) => this.DragWordEnd(word, event, undefined)}
                onMouseEnter={(event) => this.handleHoverWord(word, event.currentTarget, 'translation', undefined)}
                onMouseLeave={(event) => this.handleHoverLeaveWord(word, event)} 
                onTouchStart={(event) => this.handleHoverWord(word, event.currentTarget, 'translation', undefined)}
                // onTouchMove={(event) => this.DragWordMove(word, event)}
                onTouchEnd={(event) => this.handleHoverLeaveWord(word, event)}
    
                ref={this.state.dictRefs.get(word.TextIndex) === undefined ? undefined :
                    this.state.dictRefs.get(word.TextIndex).Translation}>
    
                {sWordToShow}
                <span>&nbsp;</span>
                </span>
                </>
            }
        })
    }

    CurrentToolIsAMainWordInTranslationLinkGroupsTool()
    {
        return this.state.nSelectedToolID === this.nMainWordInTranslationLinkGroupsToolID || 
            this.state.nSelectedToolID === this.nMainPrepositionWordInTranslationLinkGroupsToolID || 
            this.state.nSelectedToolID === this.nMainSuffixWordInTranslationLinkGroupsToolID
    }

    GetSpansForTranslationOfLine(nLineIndex, line)
    {
        //console.log(this.state.listWordGroupsForEnabledLenses)
        
        if(line.Words.length === 0) return

        var sChapter = line.Words[0].Chapter
        var oTranslationForLine = this.state.listOurTranslationLines.find(o => o.Chapter === sChapter && o.LineIndex === nLineIndex)
        if(oTranslationForLine === undefined) return

        var sTranslationForLine = oTranslationForLine.Translation
        var listWords = sTranslationForLine.split(' ')

        var listOriginalTextIndexesLinkedToLineThatNeedMainWordTagged = []
        if(this.CurrentToolIsAMainWordInTranslationLinkGroupsTool())
        {
            let listTranslationWordIndexLinksForLine = this.state.listTranslationWordIndexLinks
            .filter(o => o.Chapter === sChapter && o.LineIndex === nLineIndex)

            listOriginalTextIndexesLinkedToLineThatNeedMainWordTagged = [...new Set(listTranslationWordIndexLinksForLine.map(o => o.Original))]
            .filter(sOriginalTextIndex => listTranslationWordIndexLinksForLine.filter(o => o.Original === sOriginalTextIndex).length > 1)

            if(this.state.nSelectedToolID === this.nMainPrepositionWordInTranslationLinkGroupsToolID)
            {
                listOriginalTextIndexesLinkedToLineThatNeedMainWordTagged = listOriginalTextIndexesLinkedToLineThatNeedMainWordTagged
                .filter(sOriginalTextIndex => this.GetWordWithTextIndexInChapter(sOriginalTextIndex).Preposition !== undefined)
            }
            else if(this.state.nSelectedToolID === this.nMainSuffixWordInTranslationLinkGroupsToolID)
            {
                listOriginalTextIndexesLinkedToLineThatNeedMainWordTagged = listOriginalTextIndexesLinkedToLineThatNeedMainWordTagged
                .filter(sOriginalTextIndex => this.GetWordWithTextIndexInChapter(sOriginalTextIndex).SuffixPerson !== undefined)
            }
        } 
        
        var blnSomeWordIsSelected = this.SomeWordIsStickiedOrHovered()
        var blnALensIsActive = this.state.blnShowLenses && (this.state.listWordGroupsForEnabledLenses.length > 0 || 
            (blnSomeWordIsSelected && this.SomeHoverCompareLensIsEnabled()))

        if(this.state.listLineIndexesBeingEditedForOurTranslation.includes(nLineIndex))
        {
            return <input type="text" variant="outlined" size={40} autoFocus 
                defaultValue={sTranslationForLine}
                onFocus={(e) => this.setState({blnTranslationEditBoxHasFocus: true})}
                onBlur={(e) => this.setState({blnTranslationEditBoxHasFocus: false})}
                onKeyDown={(event) => {
                    if(event.key === "Enter")
                    {
                        //{Chapter: '4', LineIndex: 5, Translation: ''}
                        var listTranslationLinesToSet = this.state.listOurTranslationLines
                        var nIndexToEdit = listTranslationLinesToSet.findIndex(tl => tl.Chapter === sChapter && tl.LineIndex === nLineIndex)
                        if(nIndexToEdit > -1)
                        {
                            listTranslationLinesToSet[nIndexToEdit].Translation = event.target.value
                            this.SaveOurTranslationLines(listTranslationLinesToSet)
                        }

                        //done editing, save the translation, reset the links, and remove the line from editing
                        this.setState({listTranslationWordIndexLinks: this.state.listTranslationWordIndexLinks.filter(o => !(o.Chapter === sChapter && o.LineIndex === nLineIndex))})

                        var listToSet = this.state.listLineIndexesBeingEditedForOurTranslation
                        listToSet.splice(listToSet.indexOf(nLineIndex), 1)
                        this.setState({listLineIndexesBeingEditedForOurTranslation: listToSet})

                        this.setState({blnTranslationEditBoxHasFocus: false})
                    }}}/>
        }
        else
        {
            return listWords.map((sWordToShow, nWordIndex) => {
                var listLinksForTranslationWord = this.state.listTranslationWordIndexLinks
                    .filter(o => o.Chapter === sChapter && o.Translation === nWordIndex && o.LineIndex === nLineIndex)

                if(listLinksForTranslationWord.length === 0)
                {
                    var sWordColor = blnALensIsActive ? 'DarkGray' : 'Black'
                    var listTextIndexes = []
        
                    return <>
                    <span class="TextWordDiv" //title={blnTranslation ? "test2" : }
                    style={{ 
                        fontFamily: "Calibri", 
                        WebkitTextStroke: this.blnIsIOSSafari ? "0.5px" : "",
                        color: sWordColor, 
                        borderStyle: "none", //blnWordIsOutlined && !this.AllSimilarityLensIsEnabled() ? "dotted" : "none", //dashed, dotted, inset, solid
                        
                        display: 'inline-block',
                        borderColor: (this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ? "red" :
                            (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word)) ? "red" : 	
                            (this.state.listWordsHoveredWhileDragging === undefined && this.DoesSelectedCurrentRepetitionLinkGroupIncludeWord(word) && this.GetRepetitionLinkGroupsContainingWord(word).length > 1) ? "blue" :		
                            !this.state.listGraphTextIndicesToHighlight.some(gti => listTextIndexes.includes(gti.TextIndex) && gti.BorderColor != undefined) ? "black" :
                            this.state.listGraphTextIndicesToHighlight.find(gti => listTextIndexes.includes(gti.TextIndex)).BorderColor,
                            
                        borderWidth:((this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ||
                            (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word))) ? "4px" : "1px",
        
                        fontSize: "18px",
                        userSelect: (this.state.nSelectedToolID === null || this.state.nSelectedToolID == 0) && !this.state.blnShiftDown ? "" : "none"  
                    }}

                    onMouseDown={(event) => {
                        if(event.altKey)
                        {
                            var listToSet = this.state.listLineIndexesBeingEditedForOurTranslation
                            listToSet.push(nLineIndex)
                            this.setState({listLineIndexesBeingEditedForOurTranslation: listToSet})
                        }
                        else
                        {
                            this.nTranslationWordIndexDraggedFrom = nWordIndex
                        }
                    }}
                    onMouseUp={(event) => this.DragTranslationEnd(nWordIndex, nLineIndex, sChapter, undefined, event)}
                    >
        
                    {sWordToShow}
                    <span>&nbsp;</span>
                    </span>
                    </>
                }
                else
                {
                    //var listOriginalWordsForTranslationWord = listLinksForTranslationWord.map(o => this.GetWordWithTextIndexInChapter(o.Original))
                    var oFirstLink = listLinksForTranslationWord[0]
                    var word = this.GetWordWithTextIndexInChapter(oFirstLink.Original)

                    var listTextIndexes = word === null || word === undefined ? [] : [word.TextIndex]
                    var blnIsCurrentWordTag = this.state.currentWordTag != undefined && this.state.currentWordTag.TextIndex === word.TextIndex

                    var blnWordIsOutlined = this.WordIsOutlined(word, listTextIndexes, blnIsCurrentWordTag)
                    
                    var blnWordHasBorder = (this.state.nSelectedToolID === this.nMainWordInTranslationLinkGroupsToolID && this.state.dictMainWordInTranslationLinkGroupsByTextIndex.get(word.TextIndex) === nWordIndex) ||
                        (this.state.nSelectedToolID === this.nMainPrepositionWordInTranslationLinkGroupsToolID && this.state.dictMainPrepositionWordInTranslationLinkGroupsByTextIndex.get(word.TextIndex) === nWordIndex) ||
                        (this.state.nSelectedToolID === this.nMainSuffixWordInTranslationLinkGroupsToolID && this.state.dictMainSuffixWordInTranslationLinkGroupsByTextIndex.get(word.TextIndex) === nWordIndex)
                        

                    // if(word.TextIndex === "2")
                    // {
                    //     console.log(this.state.dictMainWordInTranslationLinkGroupsByTextIndex, this.state.dictMainWordInTranslationLinkGroupsByTextIndex.get("2"), this.state.dictMainWordInTranslationLinkGroupsByTextIndex.get(parseInt(word.TextIndex)) === nWordIndex)
                    // }

                    //TranslationWordIndexLinks: [{"Original": "47", "Translation": 1, "LineIndex": 10, "Chapter": "1", "ForPreposition": true}
                    var sWordColor = this.CurrentToolIsAMainWordInTranslationLinkGroupsTool() ? 
                        this.listLinkGroupColors[listOriginalTextIndexesLinkedToLineThatNeedMainWordTagged.indexOf(oFirstLink.Original) % this.listLinkGroupColors.length] :
                        this.state.nSelectedToolID != this.nLinkTranslationToolID ? this.GetTextColor(word) :
                        oFirstLink.ForPreposition ? 'Red' : 
                        oFirstLink.ForSuffix ? 'Blue' : 
                        oFirstLink.ForPGN ? 'Purple' : 
                        oFirstLink.ForWaw ? 'Orange' : 'Green'

                    if(blnSomeWordIsSelected && !blnWordIsOutlined && !this.SomeHoverCompareLensIsEnabled()) 
                    {
                        sWordColor = 'DarkGray'
                    }
                    else if(blnSomeWordIsSelected && blnWordIsOutlined && this.LensTypeIsEnabled("morphologicalchainsbetweenlines"))
                    {
                        var sSelectedChainType = 'pgn'
                        if(oFirstLink.ForPGN && sSelectedChainType === 'pgn')
                        {
                            sWordColor = 'Blue'
                        }
                    }

                    return <>
                    <span class="TextWordDiv" //title={blnTranslation ? "test2" : }
                    style={{ 
                        fontFamily: "Calibri", 
                        WebkitTextStroke: this.blnIsIOSSafari ? "0.5px" : "",
                        color: sWordColor, 
                        borderStyle: blnWordHasBorder ? "solid" : "none", //&& !this.AllSimilarityLensIsEnabled()  dashed, dotted, inset, solid
                        
                        display: 'inline-block',
                        borderColor: (this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ? "red" :
                            (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word)) ? "red" : 	
                            (this.state.listWordsHoveredWhileDragging === undefined && this.DoesSelectedCurrentRepetitionLinkGroupIncludeWord(word) && this.GetRepetitionLinkGroupsContainingWord(word).length > 1) ? "blue" :		
                            !this.state.listGraphTextIndicesToHighlight.some(gti => listTextIndexes.includes(gti.TextIndex) && gti.BorderColor != undefined) ? "black" :
                            this.state.listGraphTextIndicesToHighlight.find(gti => listTextIndexes.includes(gti.TextIndex)).BorderColor,
                            
                        borderWidth:((this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ||
                            (blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word))) ? "4px" : "1px",
        
                        fontSize: "18px",
                        userSelect: (this.state.nSelectedToolID === null || this.state.nSelectedToolID == 0) && !this.state.blnShiftDown ? "" : "none"  
                    }}               
                    key={word === undefined ? '0' : word.TextIndex}
                    // onClick={(event) => {if(!blnTranslation || blnGlossed) this.handleClickOnWord(event, word)}}
                    onMouseDown={(event) => {
                        if(event.altKey)
                        {
                            var listToSet = this.state.listLineIndexesBeingEditedForOurTranslation
                            listToSet.push(nLineIndex)
                            this.setState({listLineIndexesBeingEditedForOurTranslation: listToSet})
                        }
                        else
                        {
                            this.DragWordStart(word, event)
                            this.nTranslationWordIndexDraggedFrom = nWordIndex
                        }
                    }}
                    onMouseUp={(event) => this.DragTranslationEnd(nWordIndex, nLineIndex, sChapter, word, event)}
                    onMouseEnter={(event) => this.handleHoverWord(word, event.currentTarget, 'translation', undefined)}
                    onMouseLeave={(event) => this.handleHoverLeaveWord(word, event)} 
                    onTouchStart={(event) => this.handleHoverWord(word, event.currentTarget, 'translation', undefined)}
                    onTouchEnd={(event) => this.handleHoverLeaveWord(word, event)}
                    // onTouchMove={(event) => this.DragWordMove(word, event)}
        
                    ref={(word === undefined || this.state.dictRefs.get(word.TextIndex) === undefined) ? undefined : 
                        this.state.dictRefs.get(word.TextIndex).Translation}>
        
                    {sWordToShow}
                    <span>&nbsp;</span>
                    </span>
                    </>
                }
            })
        }
    }

	GetSpansForWords(listWords, blnTranslation, blnLineMode, blnGlossed, blnTransliteration)
	{
        var listToUse = listWords;
		if(blnTranslation)
			listToUse = this.state.listTranslations.filter(o => listWords.some(w => o.ListHebrewWords.includes(w.TextIndex)));

        var blnSomeWordIsSelected = this.SomeWordIsStickiedOrHovered()

        if(blnTransliteration) 
        {
            return this.GetSpansForSyllables(this.listSyllablesForChapter.filter(oSyl => listWords.includes(oSyl.word)), blnLineMode)
        }

		return listToUse.map(o => {
			var word = blnTranslation ? listWords.find(w2 => w2.TextIndex === o.ListHebrewWords[0]) : o;
			var listTextIndexes = blnTranslation ? o.ListHebrewWords : [o.TextIndex];

			var blnIsCurrentWordTag = this.state.currentWordTag != undefined && this.state.currentWordTag.TextIndex === word.TextIndex;

            var sTextToShow = blnTranslation || blnGlossed ? this.GetGlossForWord(word) : word.FullText //o.Translation
            var blnWordIsOutlined = this.WordIsOutlined(word, listTextIndexes, blnIsCurrentWordTag)

            var sWordColor = this.GetTextColor(word)
            if(blnSomeWordIsSelected && !blnWordIsOutlined && !this.SomeHoverCompareLensIsEnabled()) sWordColor = 'DarkGray' //this.LightenColor(sWordColor, 1.8)
            
            // console.log(this.state.sViewBy, listTextIndexes, this.listClauses.some(c => listTextIndexes.includes(c.EndIndex.toString())), this.listClauses)

			return <>
			<span class="TextWordDiv" //title={blnTranslation ? "test2" : }
			style={{ 
				fontFamily: (blnTranslation || blnGlossed || blnTransliteration) ? "Calibri" : !this.blnChapterIsHebrew ? 'SBL Greek' : "SBL Hebrew", 
				WebkitTextStroke: this.blnIsIOSSafari ? "0.5px" : "",
                color: sWordColor, 
				borderStyle: "none", //blnWordIsOutlined && !this.AllSimilarityLensIsEnabled() ? "dotted" : "none", //dashed, dotted, inset, solid
                
                display: 'inline-block',
                borderColor: (this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ? "red" :
					(blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word)) ? "red" : 	
					(this.state.listWordsHoveredWhileDragging === undefined && this.DoesSelectedCurrentRepetitionLinkGroupIncludeWord(word) && this.GetRepetitionLinkGroupsContainingWord(word).length > 1) ? "blue" :		
                    !this.state.listGraphTextIndicesToHighlight.some(gti => listTextIndexes.includes(gti.TextIndex) && gti.BorderColor != undefined) ? "black" :
                    this.state.listGraphTextIndicesToHighlight.find(gti => listTextIndexes.includes(gti.TextIndex)).BorderColor,
                    
				borderWidth:((this.state.listWordsHoveredWhileDragging === undefined && this.InParticipantRefMode() && this.IsAParticipantRefSuffixInCurrentRepetitionLinkGroup(word)) ||
					(blnIsCurrentWordTag && this.IsForSuffixModeForWordTags(word))) ? "4px" : "1px",

				fontSize: (blnTranslation || blnGlossed || blnTransliteration) ? "18px" : !this.blnChapterIsHebrew ? '20px' : "22px",
				userSelect: (this.state.nSelectedToolID === null || this.state.nSelectedToolID == 0) && !this.state.blnShiftDown ? "" : "none"  
			}}               
			key={word.TextIndex}
			onClick={(event) => {if(!blnTranslation || blnGlossed) this.handleClickOnWord(event, word)}}
			onMouseDown={(event) => this.DragWordStart(word, event)}
			onMouseUp={(event) => this.DragWordEnd(word, event, undefined)}
			onMouseEnter={(event) => this.handleHoverWord(word, event.currentTarget, blnGlossed ? 'glosses' : 'hebrew', undefined)}
			onMouseLeave={(event) => this.handleHoverLeaveWord(word, event)} 
			onTouchStart={(event) => this.handleHoverWord(word, event.currentTarget, blnGlossed ? 'glosses' : 'hebrew', undefined)}
			// onTouchMove={(event) => this.DragWordMove(word, event)}
			onTouchEnd={(event) => this.handleHoverLeaveWord(word, event)}

            //navigator.clipboard.writeText(e.target.innerText + ' test')
            //e.clipboardData.setData('text/plain', e.target.innerText + ' test')
            //this.GetAllWordsInALensGroupWithCurrentHoveredWord(word)

            // onCopy={(e) => {
            //     navigator.clipboard.writeText(blnWordIsOutlined ? 
            //     (this.GetNameListForLensGroupsWordIsIn(word) + ': ' + this.GetAllWordsInALensGroupWithCurrentHoveredWord(word).map(wig => wig.FullText  + ' (v. ' + wig.Verse + ')').join('; ')) : 
            //     (word.FullText + ' (v. ' + word.Verse + ')' + this.GetLineContainingWord(word).Words.map(wil => wil.FullText).join(' ')))
            // }}

			ref={this.state.dictRefs.get(word.TextIndex) === undefined ? undefined :
				(blnGlossed) ? this.state.dictRefs.get(word.TextIndex).Glosses : 
				this.state.dictRefs.get(word.TextIndex).Hebrew}>

			{blnLineMode || !this.state.blnShowVerseNumbers || this.listVerseBeginNumbersAndWords === undefined ? '' :
			!this.listVerseBeginNumbersAndWords.some(r => listTextIndexes.includes(r.Word.TextIndex)) ? '' :
			this.listVerseBeginNumbersAndWords.find(r => listTextIndexes.includes(r.Word.TextIndex)).VerseNumber + ' '}
			
            {this.state.blnEllipsisMode && <span style={{borderStyle: "solid", borderColor:"blue", borderWidth: "1px"}}>&nbsp;</span>}
			{sTextToShow} 
			{blnTranslation || blnGlossed ? <span>&nbsp;</span> : sTextToShow.endsWith("־") ? '' : <span>&nbsp;</span>} 

			{!blnLineMode && 
			(
			this.state.sViewBy === "Sentence" ? 
				(this.listSentenceEndIndexes.some(n => listTextIndexes.includes(n.toString())) ? <br />: '') : 
			this.state.sViewBy === "Phrase" ? 
				(this.listPhraseEndIndexes.some(n => listTextIndexes.includes(n.toString())) ? <br />: '') : '')}
			</span>
			</>
		});
	}

    CanvasMouseMove(event)
    {
        var x = event.pageX - this.nXOffsetForDevelopmentDiagram
        var y = event.pageY - this.nYOffsetForDevelopmentDiagram
        
        if(this.nDevelopmentDiagramLineIndexBeingEdited > -1)
        {
            var oLineToEdit = this.state.listDevelopmentDiagramLines[this.nDevelopmentDiagramLineIndexBeingEdited]
            oLineToEdit.X2 = x
            oLineToEdit.Y2 = y
            
            this.setState({listDevelopmentDiagramLines: this.state.listDevelopmentDiagramLines})
        }
        else if(this.state.listDevelopmentDiagramBoxesBeingMoved.length > 0)
        {
            var sChapter = this.GetFirstCurrentChapter().toString()
            for(var oBoundingBox of this.state.listDevelopmentDiagramBoxesBeingMoved)
            {
                //move all the lines in a group together
                var oDiagramBoxClickedOn = this.GetDevelopmentDiagramBoxForLineIndex(sChapter, oBoundingBox.LineIndex)
                var nXDisplacement = x - oDiagramBoxClickedOn.x
                var nYDisplacement = y - oDiagramBoxClickedOn.y

                var oDiagramBoxGroup = this.GetDevelopmentDiagramBoxGroupForLineIndex(sChapter, oBoundingBox.LineIndex)
                if(oDiagramBoxGroup != undefined)
                {
                    for(var nLineIndex of oDiagramBoxGroup.LineIndexes)
                    {
                        var oDiagramBox = this.GetDevelopmentDiagramBoxForLineIndex(sChapter, nLineIndex)
                        if(oDiagramBox != undefined)
                        {
                            oDiagramBox.x += nXDisplacement //- oBoundingBox.width / 2
                            oDiagramBox.y += nYDisplacement //+ oBoundingBox.height / 2
                            this.setState({listDevelopmentDiagramBoxes: this.state.listDevelopmentDiagramBoxes})
                        }
                    }
                }
            }
        }
        else if(this.nCurrentDevelopmentDiagramRepetitionGroupForTagging > -1 || this.blnClearDevelopmentDiagramRepetitionGroup)
        {
            var oHoveredOn = this.GetDevelopmentDiagramBoundingBoxAtCoordinate(event.pageX, event.pageY)
            if(oHoveredOn.BoundingBox != undefined)
            {
                var sChapter = this.GetFirstCurrentChapter().toString()
                if(event.getModifierState("Control"))
                {
                    this.RemoveDevelopmentRepetitionGroupFromLine(oHoveredOn.BoundingBox.LineIndex, 
                        this.nCurrentDevelopmentDiagramRepetitionGroupForTagging, sChapter)
                }
                else
                {
                    this.SetDevelopmentRepetitionGroupForLine(oHoveredOn.BoundingBox.LineIndex, 
                        this.nCurrentDevelopmentDiagramRepetitionGroupForTagging, sChapter, 
                        event.getModifierState("CapsLock"), this.blnClearDevelopmentDiagramRepetitionGroup)
                }
            }
        }
        else
        {
            var oHoveredOn = this.GetDevelopmentDiagramBoundingBoxAtCoordinate(event.pageX, event.pageY)
            if(oHoveredOn.BoundingBox != undefined)
            {
                if(oHoveredOn.WordIndexInLine > -1)
                {
                    this.setState({oDevelopmentDiagramHoveredObject: 
                        {LineIndex: oHoveredOn.BoundingBox.LineIndex, WordIndex: oHoveredOn.WordIndexInLine, 
                            OriginalWord: oHoveredOn.WordIndexInLine >= oHoveredOn.BoundingBox.OriginalWordsInOrderForLine.length ? undefined :
                                oHoveredOn.BoundingBox.OriginalWordsInOrderForLine[oHoveredOn.WordIndexInLine],
                            OriginalSyllable: (oHoveredOn.SyllableIndexInLine < 0 || 
                                oHoveredOn.SyllableIndexInLine >= oHoveredOn.BoundingBox.OriginalSyllablesInOrderForLine.length) ? undefined :
                                oHoveredOn.BoundingBox.OriginalSyllablesInOrderForLine[oHoveredOn.SyllableIndexInLine]}})
                }
            }
            else
            {
                if(this.state.oDevelopmentDiagramHoveredObject != null) 
                {
                    this.setState({oDevelopmentDiagramHoveredObject: null})
                }
            }
        }
    }

    CanvasMouseDown(event)
    {
        //{BoundingBox: oBox, WordIndexInLine: nWordIndexInLine}
        var oClickedOn = this.GetDevelopmentDiagramBoundingBoxAtCoordinate(event.pageX, event.pageY)
        if(oClickedOn.BoundingBox != undefined)
        {
            var sChapter = this.GetFirstCurrentChapter().toString()

            if(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID)
            {
                if(this.state.blnSyllableModeForRepetitionLinkGroupTool)
                {
                    if(oClickedOn.SyllableIndexInLine >= 0 && oClickedOn.SyllableIndexInLine < oClickedOn.BoundingBox.OriginalSyllablesInOrderForLine.length)
                    {
                        this.setState({oSyllableDraggedFrom: oClickedOn.BoundingBox.OriginalSyllablesInOrderForLine[oClickedOn.SyllableIndexInLine]})
                    }
                }
                else
                {
                    if(oClickedOn.WordIndexInLine >= 0 && oClickedOn.WordIndexInLine < oClickedOn.BoundingBox.OriginalWordsInOrderForLine.length)
                    {
                        this.setState({listWordsDraggedFrom: [oClickedOn.BoundingBox.OriginalWordsInOrderForLine[oClickedOn.WordIndexInLine]]})
                    }
                }
            }
            else if(event.shiftKey)
            {
                this.setState({listDevelopmentDiagramBoxesBeingMoved: [oClickedOn.BoundingBox]})
            }
            else if(event.altKey)
            {
                //free hand line
                var oNewLine = {Chapter: sChapter, X1: event.pageX - this.nXOffsetForDevelopmentDiagram, X2: event.pageX - this.nXOffsetForDevelopmentDiagram, 
                    Y1: event.pageY - this.nYOffsetForDevelopmentDiagram, Y2: event.pageY - this.nYOffsetForDevelopmentDiagram, Width: 1, Color: "Black"}

                this.nDevelopmentDiagramLineIndexBeingEdited = this.state.listDevelopmentDiagramLines.length
                this.setState({listDevelopmentDiagramLines: this.state.listDevelopmentDiagramLines.concat([oNewLine])})
            }
            else
            {
                if(this.state.blnAddingLinksToDevelopmentDiagramEnabled)
                {
                    if(oClickedOn.WordIndexInLine > -1)
                    {
                        this.listDevelopmentDiagramLink1 = 
                            {LineIndex: oClickedOn.BoundingBox.LineIndex, WordIndex: oClickedOn.WordIndexInLine}
                    }
                }
                else if(this.state.blnEditingSemanticGroups)
                {
                    if(oClickedOn.WordIndexInLine >= 0 && oClickedOn.WordIndexInLine < oClickedOn.BoundingBox.OriginalWordsInOrderForLine.length)
                    {
                        let oWordClickedOn = oClickedOn.BoundingBox.OriginalWordsInOrderForLine[oClickedOn.WordIndexInLine]
                        let nSemanticGroupIndexToEdit = 
                            this.GetSemanticChainsForCurrentChapter(this.listTextWordsForChapter)[this.state.nIndexOfSemanticGroupShowing].IndexInFullList
                    
                        if(nSemanticGroupIndexToEdit >= 0)
                        {
                            // console.log(oWordClickedOn, this.state.listRepetitionLinkGroups[nSemanticGroupIndexToEdit].ListWords)
                            let listToSet = this.state.listRepetitionLinkGroups
                            let sTextIndexClickedOn = oWordClickedOn.TextIndex
                            let nWordIndexInGroup = listToSet[nSemanticGroupIndexToEdit].ListWords
                            .findIndex(sTextIndex => sTextIndex === sTextIndexClickedOn)

                            if(nWordIndexInGroup > -1)
                            {
                                listToSet[nSemanticGroupIndexToEdit].ListWords.splice(nWordIndexInGroup, 1)
                            }
                            else
                            {
                                listToSet[nSemanticGroupIndexToEdit].ListWords.push(sTextIndexClickedOn)
                            }

                            this.setState({listRepetitionLinkGroups: listToSet}, this.SetWordGroupsForEnabledLenses())
                            this.SaveRepetitionLinkGroups(this.state.listRepetitionLinkGroups)
                            
                        }
                    }
                }
                else
                {
                    var oDiagramBoxGroup = this.GetDevelopmentDiagramBoxGroupForLineIndex(sChapter, oClickedOn.BoundingBox.LineIndex)
                    if(oDiagramBoxGroup != undefined)
                    {
                        this.setState({oDevelopmentDiagramBoxGroupSelectedToCompareWith: 
                            this.state.oDevelopmentDiagramBoxGroupSelectedToCompareWith === oDiagramBoxGroup ? null : oDiagramBoxGroup})
                    }
                }
            }
        }
        // else
        // {
        //     var oBoxForColorKeyClickedOn = this.GetDevelopmentDiagramBoundingBoxForColorKeyAtCoordinate(event.pageX, event.pageY)
        //     if(oBoxForColorKeyClickedOn != undefined)
        //     {
        //         this.setState({nDevelopmentDiagramColorKeyGroupIDBeingEdited: oBoxForColorKeyClickedOn.GroupID})
        //     }
        // }
    }

    CanvasMouseUp(event)
    {
        if(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID)
        {
            var oClickedOn = this.GetDevelopmentDiagramBoundingBoxAtCoordinate(event.pageX, event.pageY)
            if(oClickedOn.BoundingBox != undefined)
            {
                if(this.state.blnSyllableModeForRepetitionLinkGroupTool)
                {
                    if(oClickedOn.SyllableIndexInLine >= 0 && oClickedOn.SyllableIndexInLine < oClickedOn.BoundingBox.OriginalSyllablesInOrderForLine.length)
                    {
                        let oSyllableClickedOn = oClickedOn.BoundingBox.OriginalSyllablesInOrderForLine[oClickedOn.SyllableIndexInLine]
                        this.DragEndForRepetitionLinkGroupTool(oSyllableClickedOn.word, oSyllableClickedOn)
                    }
                }
                else
                {
                    if(oClickedOn.WordIndexInLine >= 0 && oClickedOn.WordIndexInLine < oClickedOn.BoundingBox.OriginalWordsInOrderForLine.length)
                    {
                        let oWordClickedOn = oClickedOn.BoundingBox.OriginalWordsInOrderForLine[oClickedOn.WordIndexInLine]
                        this.DragEndForRepetitionLinkGroupTool(oWordClickedOn, null)
                    }
                }
            }
        }
        else if(this.state.listDevelopmentDiagramBoxesBeingMoved.length > 0)
        {
            this.setState({listDevelopmentDiagramBoxesBeingMoved: []})
        }
        else if(event.altKey)
        {
            this.nDevelopmentDiagramLineIndexBeingEdited = -1
        }
        else
        {
            var oClickedOn = this.GetDevelopmentDiagramBoundingBoxAtCoordinate(event.pageX, event.pageY)
            if(oClickedOn.BoundingBox != undefined)
            {
                if(this.state.blnAddingLinksToDevelopmentDiagramEnabled && oClickedOn.WordIndexInLine > -1 && this.listDevelopmentDiagramLink1 != null)
                {
                    var oNewLink = {Chapter: this.GetFirstCurrentChapter().toString(), LineAndWordIndexes:
                        [{LineIndex: this.listDevelopmentDiagramLink1.LineIndex, WordIndex: this.listDevelopmentDiagramLink1.WordIndex}, 
                        {LineIndex: oClickedOn.BoundingBox.LineIndex, WordIndex: oClickedOn.WordIndexInLine}]}

                    this.setState({listDevelopmentDiagramLinkGroups: this.state.listDevelopmentDiagramLinkGroups.concat([oNewLink])})
                    this.listDevelopmentDiagramLink1 = null
                }
            }
        }
    }
    
	render() {
		return (
		<div className="App" tabIndex={0} 
            onKeyDown={(event) => this.handleKeyDown(event)} onKeyUp={(event) => this.handleKeyUp(event.key)}>
            {this.state.blnShowHint && this.state.hoveredWordRect != null && 
            <div tabIndex={this.RootCooccurrenceLensIsEnabled() ? 0 : undefined} 
                onKeyDown={(event) => this.handleKeyDown(event)} onKeyUp={(event) => this.handleKeyUp(event.key)}
                style={{position: "fixed", backgroundColor:"white", zIndex:"10", borderStyle: "solid", borderWidth:1, textAlign: 'center',
                overflowY: this.RootCooccurrenceLensIsEnabled() ? 'scroll' : 'hidden',
                maxHeight: this.RootCooccurrenceLensIsEnabled() ? '200px' : 'none', 
                left: this.state.hoveredWordRect.left, top: this.state.hoveredWordRect.bottom, 
                fontFamily: this.state.listInfoShowTextIsEnglish && !this.RootCooccurrenceLensIsEnabled() ? 'Calibri' : (!this.blnChapterIsHebrew ? 'SBL Greek' : 'SBL Hebrew'), 
                fontSize: this.state.listInfoShowTextIsEnglish && !this.RootCooccurrenceLensIsEnabled() ? "18px" : (!this.blnChapterIsHebrew ? '20px' : "22px")}}>
                    {this.state.listInfoShow.map(ti => <div>{ti}</div>)}</div>}
			
			<div style={{
				position: this.state.blnStickyHeader ? "-webkit-sticky" : "", 
				position: this.state.blnStickyHeader ? "sticky" : "", 
				backgroundColor:"white", zIndex:"100" , width:"100%", top:"0%", left: "1%"}} ref={this.divHeaderRef}>

            {this.InSearchAndTagMode() && <div align="center" style={{display: "inline-block", verticalAlign:"middle"}}>
                    <Autocomplete multiple autoComplete clearOnBlur selectOnFocus 
                        options={this.listSemanticGroupsForSearchAndTag.map(o => o.BSG)}
                        value={this.state.listSemanticGroupsForSearchAndTagSelectedForTagging}
                        getOptionLabel={(option) => option}
                        // groupBy={(option) => option.MainType}
                        onChange={(event, listSelected) => {
                            this.setState({nSearchAndTagResultsCurrentBatchIndex: 0})
                            this.setState({listSemanticGroupsForSearchAndTagSelectedForTagging: listSelected}, 
                                () => {this.setState({listCurrentSearchAndTagMatchResults: this.GetSearchAndTagMatchResults()})})
                            this.setState({listSelectedSemanticGroupsForTagInventory: listSelected})
                        }} 
                        style={{width: 250, marginLeft: "10px", marginRight: "10px"}}
                        size="small"
                        onFocus={(e) => this.setState({blnThematicStatementAutocompleteHasFocus: true})}
                        onBlur={(e) => this.setState({blnThematicStatementAutocompleteHasFocus: false})}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                        )}
                    />
                </div>
            }

            {this.InSearchAndTagMode() && this.state.listSemanticGroupsForSearchAndTagSelectedForTagging.length > 0 &&
                <div align="center" style={{display: "inline-block", verticalAlign:"middle"}}>
                
                <input size='1' value={this.state.nSearchAndTagResultsCurrentBatchIndex + 1} onChange={(event) => {
                    var nBatchIndexToSet = parseInt(event.target.value)
                    if(!isNaN(nBatchIndexToSet)) this.setState({nSearchAndTagResultsCurrentBatchIndex: nBatchIndexToSet - 1})
                }}/>
                <span style={{marginLeft: '3px'}}>of {this.GetNumberOfSearchAndTagResultBatches()}</span>

                <input size='5' style={{marginLeft: '5px'}} onKeyDown={(event) => {
                    if(event.key === 'Enter') 
                    {
                        this.setState({sSearchAndTagMatchFilterByLemma: event.target.value}, 
                            () => {this.setState({listCurrentSearchAndTagMatchResults: this.GetSearchAndTagMatchResults()})})
                        
                        this.setState({nSearchAndTagResultsCurrentBatchIndex: 0})
                    }}}
                    onFocus={(e) => this.setState({blnAddTagBoxHasFocus: true})}
                    onBlur={(e) => this.setState({blnAddTagBoxHasFocus: false})}    
                />
                
                <span style={{marginLeft: '5px', marginRight: '5px'}} onClick={() => this.setState({blnShowTagEditingControls: !this.state.blnShowTagEditingControls})}>Edit</span>
                </div>        
            }

            {!this.state.blnHideEverything && !this.InSearchAndTagMode() && <>
                {/* <FormControlLabel label="Book" labelPlacement="start" control={  */}
                <Select
                style={{marginLeft:"10px"}}
                value={this.state.nCurrentBook}
                onChange={ (event) => this.FetchChapters([{Book: event.target.value, Chapter: 1}])}
                >
                {[...this.dictBookNamesByIndex.keys()].map(n => <MenuItem value={n}>{this.GetBookNameForID(n)}</MenuItem>)}
                </Select>
                {/* } /> */}

                <FormControlLabel label="Chapters" style={{userSelect: "none"}} labelPlacement="start" control={ 
                <Autocomplete multiple autoComplete clearOnBlur blurOnSelect selectOnFocus freeSolo
                    options={[...Array(this.listMaxChaptersByBook.length === 0 ? 1 : this.listMaxChaptersByBook.find(mxc => mxc.Book === this.state.nCurrentBook).MaxChapter).keys()].map(n => n + 1)}
                    value={this.state.listCurrentChapters}
                    getOptionLabel={(option) => option.toString()}
                    // groupBy={(option) => option.MainType}
                    onChange={(event, listSelected) => {
                        this.FetchChapters(listSelected.map(sChapter => ({Book: this.state.nCurrentBook, Chapter: parseInt(sChapter)})))
                    }} 
                    style={{width: 100, marginLeft: "10px", marginRight: "10px"}}
                    size="small"
                    renderInput={(params) => (
                        <TextField {...params} variant="standard" />
                    )}
                    renderTags={(values) => 
                        values
                        .map(value => value)
                        .join(', ')
                      }
                    // renderValue={(selectedOptions, getTagProps) => (
                    // selectedOptions.map((option, index) => (
                    //     <Chip
                    //     key={option.value}
                    //     label={"test"}
                    //     {...getTagProps({ index })}
                    //     />
                    // ))
                    // )}
                    // renderOption={(props, option) => (
                    //     <li {...props} style={{ backgroundColor: option.color, color: 'white' }}>
                    //       {option.label}
                    //     </li>
                    // )}
                    // sx={{
                    //     '& + .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected="true"]': {
                    //       backgroundColor: 'white', // Selected color
                    //     },
                    //   }}
                    // ListboxProps={
                    // {
                    //     style:{
                    //         maxHeight: '500px',
                    //         border: '1px solid red'
                    //     }
                    // }}
                />}/>
            </>
            }

			{this.blnDevView &&
			<>
			{/* <span style={{ margin:"15px", fontFamily: "SBL Hebrew"}}>{this.state.listInfoShow}</span> */}

			{/* <TextField 
				id="txtMorphCode"
				style ={{width: '18%', height:'1%', margin:"5px"}}
				//height="100%"
     			//inputStyle ={{width: '100%'}}
				//className={classes.textField}
				label="Morph Query"
				variant="outlined"
				value = {this.state.sMorphCode}
				onChange={(event) => { this.setState({ sMorphCode: event.target.value}); this.DealWithMorphCode(event.target.value); }}
			/> */}

			{/* <TextField 
				id="txtGraphCode"
				style ={{width: '5%', height:'1%', margin:"5px"}}
				//height="100%"
     			//inputStyle ={{width: '100%'}}
				//className={classes.textField}
				label="Graph"
				variant="outlined"
				value = {this.state.sGraphCode === undefined ? "" : this.state.sGraphCode}
				onChange={(event) => { this.setState({ sGraphCode: event.target.value}); this.CalculateGraphDataForAllGraphs(event.target.value); }}
			/> */}

				{this.state.nSelectedToolID === this.nColaSplitToolID && 
				<Button variant="contained" onClick={() => this.ResetLinesForChapter(this.state.nCurrentBook, this.GetFirstCurrentChapter())}>Reset Lines For Chapter</Button>} 
			</>
			}

			{ (this.state.nSelectedToolID === this.nMarkFigurativeLanguageToolID) &&
			<>
			
			<Button variant="contained" onClick={() => this.MarkSelectedTextAsFigure()}>Mark Selection as</Button> 

			<Select
			label="FigureType"
			id="SelectFigureType"
			style={{ margin:"20px"}}
			value={this.state.nSelectedFigurativeSpeechTypeID}
			onChange={(event) => this.setState({ nSelectedFigurativeSpeechTypeID: event.target.value})}
			>
			{ this.listFigurativeSpeechTypes.map(r => <MenuItem value={r.ID}>{r.Description}</MenuItem>)}
			</Select>
			</>
			}

			{/* <FormControlLabel label="Special" labelPlacement="start" control={ 
			<Select
			style={{ margin:"10px"}}
			value={this.state.nSelectedSpecialGraphID == null ? 0 : this.state.nSelectedSpecialGraphID}
			onChange={(event) => this.ChangeSpecialGraph(event.target.value)}>
			<MenuItem value={0}>None</MenuItem>
			{ this.listSpecialGraphs.filter(r => r.HideInProduction === "0" || this.blnDevView).map(r => <MenuItem value={r.ID}>{r.Desc}</MenuItem>)}
			</Select>} /> */}

            {!this.state.blnHideEverything && !this.state.blnConnectionsPresentationMode && <Select
			style={{ marginLeft:"10px", marginRight:"10px"}}
			value={this.state.sSelectedView}
            onChange={(event) => this.ChangeView(event.target.value)}>
                <MenuItem value={'composite'}>Composite</MenuItem>
                <MenuItem value={'lexical'}>Lexical</MenuItem>
                <MenuItem value={'semantic'}>Semantic</MenuItem>
                <MenuItem value={'sound'}>Sound</MenuItem>
                <MenuItem value={'rhythm'}>Rhythm</MenuItem>
                <MenuItem value={'grammatical'}>Grammatical</MenuItem>
                <MenuItem value={'discourse'}>Discourse</MenuItem>
                <MenuItem value={'text'}>Text</MenuItem>
                {/* <MenuItem value={'thematic'}>Thematic</MenuItem> */}
                {this.blnDevView && <MenuItem value={'all'}>All</MenuItem>}
			</Select>}

            {/* {!this.state.blnHideEverything && this.state.sSelectedView !== 'composite' && this.state.sSelectedView !== 'all' && 
                <Select
					value={this.state.sViewBy}
                    title='(toggle Lines/Links with L key)'
					style ={{marginLeft:"10px"}}
					onChange={(event) => this.ChangeViewByTo(event.target.value)}
				>
					<MenuItem value={'Line'}>Lines</MenuItem>
                    <MenuItem value={'Development'}>Links</MenuItem>
                    {this.state.sSelectedView === 'discourse' && <MenuItem value={'Diagram'}>Discourse Chart</MenuItem>}                    
                </Select>} */}

					{/* <MenuItem value={'Verse'}>Verses</MenuItem> */}
					{/* <MenuItem value={'Clause'}>Clause</MenuItem> */}
					{/* <MenuItem value={'Proposition'}>Proposition</MenuItem> */}
					{/* <MenuItem value={'Phrase'}>Phrase</MenuItem>
					<MenuItem value={'Sentence'}>Sentence</MenuItem> */}
                    {/* <MenuItem value={'Participants'}>Participants</MenuItem> */}
                    {/* <MenuItem value={'ParticipantReferenceInteraction'}>Participant Interaction</MenuItem> */}
                    {/* <MenuItem value={'ClausesByParticipant'}>Clauses by Participant</MenuItem>
                    <MenuItem value={'SemanticOutline'}>Semantic Outline</MenuItem> */}

            {!this.state.blnHideEverything && !this.state.blnConnectionsPresentationMode && this.ShowingDevelopmentDiagram() && 
            <>
            <FormControlLabel label="By" style={{userSelect: "none"}} title='Hovered unit type to show links from (cycle through with S key)' labelPlacement="start"  control={ 
            <Select
                value={this.state.sShowLinksFromHoveredWhat}
                style ={{marginLeft:"10px"}}
                onChange={(event) => this.setState({sShowLinksFromHoveredWhat: event.target.value}, () => {
                    if(this.ShowingDevelopmentDiagram())
                    {
                        this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                    }
                })}
            >
                <MenuItem value={'group'}>Group</MenuItem>
                <MenuItem value={'line'}>Line</MenuItem>
                <MenuItem value={'word'}>Word</MenuItem>
            </Select>} /> 

            <FormControlLabel label="" style={{userSelect: "none"}} title='diagram language (cycle through with H key)' labelPlacement="start"  control={ 
            <Select
                value={this.state.sDevelopmentDiagramLanguage}
                style ={{marginLeft:"10px"}}
                onChange={(event) => this.setState({sDevelopmentDiagramLanguage: event.target.value}, 
                    this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), event.target.value, this.GetLinesToDraw()))}>
                <MenuItem value={'original'}>Hebrew</MenuItem>
                <MenuItem value={'transliteration'}>Transliteration</MenuItem>
                <MenuItem value={'translation'}>Translation</MenuItem>
            </Select>} />

            {this.WordsBySoundGroupLensIsEnabled() &&
                <>
                {/* <FormControlLabel label="" style={{userSelect: "none"}} title='maximum distance (in lines from hovered line) for sound links to show' labelPlacement="start"  control={            
                <Select
                    value={this.state.nMaxDevelopmentDiagramLinesAwayFromHoveredToShowForSound}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nMaxDevelopmentDiagramLinesAwayFromHoveredToShowForSound: event.target.value})}>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={10000}>Max</MenuItem>
                </Select> }/> */}

                <FormControlLabel label="Rev" style={{userSelect: "none"}} title='Look for reverse sound sequences' control={ <Checkbox style={{marginLeft:"10px"}}
                onChange={(event) => this.setState({blnLookForReverseSoundSequencesInDiagram: event.target.checked}, 
                    this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw()))} 
                checked={this.state.blnLookForReverseSoundSequencesInDiagram} /> }/>
            </>    
            }

            <FormControlLabel title='show only link groups with at least this number of words. cycle through the choices with the Q key.' labelPlacement="start"  control={ 
                <Select
                    value={this.state.nMinDevelopmentDiagramLinkGroupLengthToShow}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nMinDevelopmentDiagramLinkGroupLengthToShow: event.target.value}, this.GenerateDevelopmentDiagramForChapterIfShowing())}>

                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    {/* {this.state.listDevelopmentDiagramLinkGroupLengths.map(n => <MenuItem value={n}>{n}</MenuItem>)} */}
            </Select>} />

            {this.state.blnBreakLinkGroupsIntoChains && <FormControlLabel title='the maximum number of lines between elements in a chain. cycle through some of the choices with the W key.' labelPlacement="start"  control={ 
                <Select
                    value={this.state.nMaxLinesApartForChains}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nMaxLinesApartForChains: event.target.value}, this.GenerateDevelopmentDiagramForChapterIfShowing())}>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={10000}>Max</MenuItem>
                </Select>} />}

            {/* <FormControlLabel label="" title='the unit level to use for the chart/text color/links. cycle through the choices with the Q key.' labelPlacement="start"  control={ 
            <Select
                value={this.state.sGroupLinesByForLens}
                style ={{marginLeft:"10px"}}
                onChange={(event) => this.setState({sGroupLinesByForLens: event.target.value}, () => {
                    if(this.ShowingDevelopmentDiagram())
                    {
                        this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                    }
                })}>
                <MenuItem value={'Line'}>Line</MenuItem>
                <MenuItem value={'StartsRepetitionGroup'}>1</MenuItem>
                <MenuItem value={'StartsCluster'}>2</MenuItem>
                <MenuItem value={'StartsClusterGroup'}>3</MenuItem>
                <MenuItem value={'StartsLevel4Group'}>4</MenuItem>
                <MenuItem value={'ByChapter'}>Chapter</MenuItem>
            </Select>} /> */}

            {this.GroupByUnitHeatmapIsEnabled() && 
                <>
                <FormControlLabel label="" title='the number of top sound groups to show (e.g. 2 = show the top 2 groups).' labelPlacement="start"  control={ 
                <Select
                    value={this.state.nTopNThresholdForGroupByUnitHeatmap}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nTopNThresholdForGroupByUnitHeatmap: event.target.value}, () => {
                        if(this.ShowingDevelopmentDiagram())
                        {
                            this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                        }
                    })}>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                </Select>} />

                <FormControlLabel label="" title='the unit level to use. cycle through the choices with the E key.' labelPlacement="start"  control={ 
                <Select
                    value={this.state.sGroupLinesByForGroupByUnitHeatmap}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({sGroupLinesByForGroupByUnitHeatmap: event.target.value}, () => {
                        if(this.ShowingDevelopmentDiagram())
                        {
                            this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                        }
                    })}>
                    <MenuItem value={'Line'}>Line</MenuItem>
                    <MenuItem value={'StartsRepetitionGroup'}>1</MenuItem>
                    <MenuItem value={'StartsCluster'}>2</MenuItem>
                    <MenuItem value={'StartsClusterGroup'}>3</MenuItem>
                    <MenuItem value={'StartsLevel4Group'}>4</MenuItem>
                    <MenuItem value={'ByChapter'}>Chapter</MenuItem>
                </Select>} />
                </>}

                {this.state.blnConnectionsPresentationMode &&
                    <>
                    {/* <FormControlLabel label="" title='Index of semantic group' style ={{marginLeft:"15px", marginBottom:"20px"}} labelPlacement="start" control={			
                    <input type="number" style ={{height:'1%', marginLeft:"10px"}} size="3"
                    defaultValue={this.state.nIndexOfSemanticGroupShowing}
                    onChange={(event) => this.setState({nIndexOfSemanticGroupShowing: event.target.value})} />} /> */}
                    <span style={{marginLeft: '17px'}}>{this.state.nIndexOfSemanticGroupShowing + 1} of {this.GetDevelopmentDiagramLinkGroupsForChapter().length}</span>
                    </>
                }
            </>}
            
            {/* {this.state.nSelectedToolID === this.nWordLinkToolID && <FormControlLabel label="" labelPlacement="start" control={ 
            <Select
			style={{ marginRight:"10px"}}
			value={this.state.sWordLinkToolType}
			onChange={(event) => this.setState({sWordLinkToolType: event.target.value})}>
				<MenuItem value={'s'}>Semantic</MenuItem>
				<MenuItem value={'p'}>Phonological</MenuItem>
                <MenuItem value={'sp'}>Sem-Phon</MenuItem>
				<MenuItem value={'m'}>Morpho-Syntactic</MenuItem>
            </Select>} /> } */}

            {/* {!this.state.blnShowLenses && <FormControlLabel label="Color By" labelPlacement="start" control={
			<Select
			style={{ marginLeft:"10px", marginRight:"10px"}}
			value={this.state.sColorBy}
			onChange={(event) => { this.setState({sColorBy: event.target.value}); }} //this.CalculateColorChart(event.target.value);
			>
				<MenuItem value={''}>None</MenuItem>
				<MenuItem value={'s'}>Stem</MenuItem>
				<MenuItem value={'f'}>Form</MenuItem>
				<MenuItem value={'g'}>Gender</MenuItem>
				<MenuItem value={'n'}>Number</MenuItem>
				<MenuItem value={'pgn'}>Person-Gender-Number</MenuItem>
				<MenuItem value={'sfxpgn'}>Suffix Person-Gender-Number</MenuItem>
				<MenuItem value={'sfxtype'}>Suffix Type</MenuItem>
				<MenuItem value={'wordtype'}>Word Type</MenuItem>
				<MenuItem value={'preposition'}>Attached Preposition</MenuItem>			
                <MenuItem value={'rgrp'}>Repetition Links</MenuItem>
                <MenuItem value={'rgrpdensity'}>Repetition Link Density</MenuItem>
                <MenuItem value={'rhyme'}>Rhyme</MenuItem>
				<MenuItem value={'pf'}>Phrase Function</MenuItem>
				<MenuItem value={'pforder'}>Phrase Function Order</MenuItem>
                <MenuItem value={'pgrp'}>Correspondence Group</MenuItem>
				</Select>} />} */}
				
				{/* <select multiple onChange={(event) => 
					this.setState({ sColorBy: event.target.value})}>
						<option value="s">1</option><option value="f">2</option></select> */}

			{/* {this.blnDevView && this.state.nSelectedToolID === this.nMarkCorrespondencesWithinLineGroupsToolID && 
			<FormControlLabel label="Mark as PGroup" labelPlacement="start" control={
				<input type="number" style ={{width:'15%', height:'1%', margin:"5px"}}
				defaultValue={0}
				value={this.state.nCurrentPGroupForMarking}
				onChange={(event) => this.setState({ nCurrentPGroupForMarking: event.target.value})} />} />} */}

			{this.CurrentToolIsAMainWordInTranslationLinkGroupsTool() && 
                <>
                <Button variant="contained" style={{ marginLeft:"15px"}}
				onClick={(event) => this.FetchChapters(this.state.listCurrentChapters.map(nChapter => ({Book: this.state.nCurrentBook, Chapter: nChapter - 1})))}>Previous</Button>

                <Button variant="contained" style={{ marginLeft:"15px"}}
				onClick={(event) => this.FetchChapters(this.state.listCurrentChapters.map(nChapter => ({Book: this.state.nCurrentBook, Chapter: nChapter + 1})))}>Next</Button>
                </>
            }

            <Popover
                anchorReference="anchorPosition"
                anchorPosition={this.taskPopoverPosition}
                //anchorReference="none"
                //anchorPosition={this.centerScreenPosition} //{top: 300, left: 300}
				//anchorEl={this.state.anchorForTaskPopover}
				open={this.state.blnTaskPopoverIsOpen}
                // anchorReference={"none"}
                // classes={{
                //     root: {
                //     display: 'flex',
                //     justifyContent: 'center',
                //     alignItems: 'center',
                //   }
                // }}

                //style={{backgroundColor: 'transparent'}}
                // PaperProps={{
                //     sx: {
                //       backgroundColor: 'transparent', // Make the background transparent
                //       boxShadow: 'none', // Optionally remove the shadow for a cleaner look
                //     },
                //   }}

				onClose={() => this.setState({blnTaskPopoverIsOpen: false})}>

                {this.GetCommandPalette()}
            </Popover>

            {this.state.blnShowAlignmentAndSizeControls && 
            <>
                <FormControlLabel label="Text Offset" title='use this to change the left alignment offset of text' labelPlacement="start" control={ 
                <Box sx={{width: 100}}>
                    <Slider 
                    //aria-label="Small steps"
                    //defaultValue={0}
                    // getAriaValueText={`${value}`}
                    step={1}
                    //marks
                    min={-300}
                    max={300}
                    valueLabelDisplay="auto"
                    value={this.state.nLeftTextAlignmentOffset} 
                    onChange={(event, newValue) => 
                        this.setState({nLeftTextAlignmentOffset: newValue}, this.GenerateDevelopmentDiagramForChapterIfShowing())}
                    />
                </Box>  
                }/>
            
            <FormControlLabel label="Chart Offset" title='use this to change the left alignment offset of charts' labelPlacement="start" control={ 
                <Box sx={{width: 100}}>
                    <Slider 
                    step={1}
                    min={-300}
                    max={300}
                    valueLabelDisplay="auto"
                    value={this.state.nLeftChartAlignmentOffset} 
                    onChange={(event, newValue) => 
                        this.setState({nLeftChartAlignmentOffset: newValue})}
                    />
                </Box>  
                }/>

            <FormControlLabel label="Chart Width" title='use this to change the width offset of charts' labelPlacement="start" control={ 
                <Box sx={{width: 100}}>
                    <Slider 
                    step={1}
                    min={-300}
                    max={300}
                    valueLabelDisplay="auto"
                    value={this.state.nChartWidthOffset} 
                    onChange={(event, newValue) => {
                        //console.log(newValue)
                        this.setState({nChartWidthOffset: newValue})}}
                    />
                </Box>  
                }/>
            </>}

            {(this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID || this.ConnectionsLensIsEnabled()) && 
			// <FormControlLabel label="Words In Same Phrase Together" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => { this.setState({ blnDragWordsInSamePhraseTogether: event.target.checked});}} checked={this.state.blnDragWordsInSamePhraseTogether} /> }/>}
            
            // <FormControlLabel label="Participant Ref Mode" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => { this.setState({ blnParticipantRefMode: event.target.checked});}} checked={this.state.blnParticipantRefMode} /> }/>}
            <FormControlLabel label="View By" labelPlacement="start"  control={ 
            <Select
                value={this.state.nCurrentLinkGroupType}
                style ={{marginLeft:"10px"}}
                onChange={(event) => this.setState({nCurrentLinkGroupType: event.target.value}, () => {
                    this.DoThingsAfterChangingCurrentLinkGroupType()
                })}>
                {/* <MenuItem value={1}>Tags</MenuItem>
                <MenuItem value={2}>Participant Ref</MenuItem>
                <MenuItem value={5}>Rhyme</MenuItem>
                <MenuItem value={8}>Semantic Chains</MenuItem> */}
                {/* <MenuItem value={3}>Semantic Domains</MenuItem> */}

                {/* <MenuItem value={10}>Old Lines</MenuItem> */}
                <MenuItem value={20}>Inside Verses</MenuItem>
				<MenuItem value={21}>Inside Verse Groups</MenuItem>
                <MenuItem value={22}>Between Verse Groups</MenuItem>
                <MenuItem value={23}>Unit Level 3</MenuItem>
                <MenuItem value={24}>Unit Level 4</MenuItem>
                <MenuItem value={25}>Inside Lines</MenuItem>
                <MenuItem value={27}>Sound Inside Lines</MenuItem>
                <MenuItem value={28}>Sounds Inside Verses</MenuItem>
                <MenuItem value={29}>Sounds Inside Verse Groups</MenuItem>

				{/* <MenuItem value={14}>Semantic Group Level 1</MenuItem>
				<MenuItem value={15}>Semantic Group Level 2</MenuItem> */}
            </Select>} />}

            {this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID &&
            <>
            <FormControlLabel label="Syl" title='Connect Syllables (toggle with Y key)' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnSyllableModeForRepetitionLinkGroupTool: event.target.checked})} checked={this.state.blnSyllableModeForRepetitionLinkGroupTool} /> }/>												
            <FormControlLabel label="C" title='the relationship is a contrast (toggle with C key)' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnConnectionIsContrast: event.target.checked})} checked={this.state.blnConnectionIsContrast} /> }/>												
            <FormControlLabel label="P" title='the group is attached prepositions (toggle with P key)' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnConnectionIsAttachedPreposition: event.target.checked})} checked={this.state.blnConnectionIsAttachedPreposition} /> }/>												
            <FormControlLabel label="S" title='the group is pronominal suffixes (toggle with S key)' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnConnectionIsPronominalSuffix: event.target.checked})} checked={this.state.blnConnectionIsPronominalSuffix} /> }/>												
            </>
            }

            {this.MainConnectionsLensIsEnabled() &&
            <>
            <FormControlLabel label="Syl" title='Show Syllable Groups' control={ <Checkbox style={{marginLeft:"15px"}} 
            onChange={(event) => this.setState({blnColorIndividualSyllablesForRepetitionLinkGroups: event.target.checked}, this.GenerateDevelopmentDiagramForChapterIfShowing())} 
            checked={this.state.blnColorIndividualSyllablesForRepetitionLinkGroups} /> }/>												
            </>
            }

            {this.state.blnConnectionsPresentationMode && this.state.blnConnectionsPresentationCommentEditMode && window.location.hostname.includes("localhost") && 
                <FormControlLabel label="C" title='the relationship is a contrast (toggle with C key)' control={ 
                    <Checkbox style={{marginLeft:"15px"}} 
                    onChange={(event) => {
                        let blnValue = event.target.checked
                        this.SetIsContrastForCurrentConnectionsGroup(blnValue)
                        this.setState({blnConnectionIsContrastForCurrentConnectionsGroup: blnValue})
                    }} 
                    checked={this.state.blnConnectionIsContrastForCurrentConnectionsGroup} /> }/>}


                {/* {window.location.hostname.includes("localhost") && 
                <FormControlLabel label="Tool" labelPlacement="start" control={ 
                <Select
                style={{ marginLeft:"10px", marginRight:"10px"}}
                value={this.state.nSelectedToolID == null ? 0 : this.state.nSelectedToolID}
                onChange={(event) => this.ChangeTool(event.target.value)}>
                <MenuItem value={0}>None</MenuItem>
                { this.listTools.filter(r => r.HideInProduction === "0" || this.blnDevView).map(r => <MenuItem value={r.ID}>{r.Desc}</MenuItem>)}
                </Select>} />} */}


            {!this.state.blnHideEverything && <Button variant="text" //color="primary" 
				style={{ marginLeft:"10px"}}
				onClick={(event) => { 
				this.setState({ blnOptionsPopoverIsOpen: true}); 
				this.setState({ anchorForOptionsPopover: event.currentTarget}); }}>More</Button>}

			<Popover
				anchorEl={this.state.anchorForOptionsPopover}
				open={this.state.blnOptionsPopoverIsOpen}
				onClose={() => this.setState({blnOptionsPopoverIsOpen: false})}>

                <FormControlLabel label="Task" labelPlacement="start" control={this.GetCommandPalette()} />
                
                <br />
				{this.blnDevView && <FormControlLabel label="Search All Psalms" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnGlobalDistributionForQueries: event.target.checked})} checked={this.state.blnGlobalDistributionForQueries} /> }/>}
				
                <FormControlLabel label="Verse Numbers/Markers" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowVerseNumbers: event.target.checked})} checked={this.state.blnShowVerseNumbers} /> }/>								
				
                {this.state.sViewBy === 'Line' &&
                <>
				
                <FormControlLabel label="Original" title='(toggle with H key)' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowHebrew: event.target.checked})} checked={this.state.blnShowHebrew} /> }/>												
                <FormControlLabel label="Interlinear" title='(toggle with I key)' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowInterlinear: event.target.checked})} checked={this.state.blnShowInterlinear} /> }/>								
				<FormControlLabel label="Transliteration" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowTransliteration: event.target.checked})} checked={this.state.blnShowTransliteration} /> }/>								
				<FormControlLabel label="Translation" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowOurTranslation: event.target.checked})} checked={this.state.blnShowOurTranslation} /> }/>								
				<FormControlLabel label="Syllable Counts" title='syllable counts by line' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowSyllableCounts: event.target.checked})} checked={this.state.blnShowSyllableCounts} /> }/>								
				
                {/* <FormControlLabel label="Th" title='Show Thematic Statements Inline' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowThematicStatementsInline: event.target.checked})} checked={this.state.blnShowThematicStatementsInline} /> }/>								 */}
				
                {/* <FormControlLabel label="BSB" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowBSB: event.target.checked})} checked={this.state.blnShowBSB} /> }/>								 */}
                
                <FormControlLabel label="Hover Info" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowHint: event.target.checked})} checked={this.state.blnShowHint} /> }/>
				{/* <FormControlLabel label="Breaks After Repetition Groups" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnBreakAfterRepetitionGroupEnd: event.target.checked})} checked={this.state.blnBreakAfterRepetitionGroupEnd} /> }/>				 */}
				{/* <FormControlLabel label="Sticky Header" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnStickyHeader: event.target.checked})} checked={this.state.blnStickyHeader} /> }/> */}
				{/* <FormControlLabel label="Translation" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowTranslation: event.target.checked})} checked={this.state.blnShowTranslation} /> }/> */}
				{/* <FormControlLabel label="Links" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowSVGLineLinks: event.target.checked})} checked={this.state.blnShowSVGLineLinks} /> }/>								
				<FormControlLabel label="Network" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowNetwork: event.target.checked})} checked={this.state.blnShowNetwork} /> }/>								 */}
				
				{this.blnDevView && <FormControlLabel label="Line Boxes" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowLineCheckboxes: event.target.checked})} checked={this.state.blnShowLineCheckboxes} /> }/>}							
                
                <FormControlLabel label="Notes" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowTranslationEditBox: event.target.checked})} checked={this.state.blnShowTranslationEditBox} /> }/>								
				
				<FormControlLabel label="Lenses" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowLenses: event.target.checked})} checked={this.state.blnShowLenses} /> }/>								
				<FormControlLabel label="Dots" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowWordDotChart: event.target.checked})} checked={this.state.blnShowWordDotChart} /> }/>								
				
                {this.blnDevView && <FormControlLabel label="BSB in Hover" title='show BSB verse when hovering text' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowBSBInHoverInfo: event.target.checked})} checked={this.state.blnShowBSBInHoverInfo} /> }/>}							
				
                {this.state.sLensHoverCombineMode === 'allbutonethesame' && <FormControlLabel label="Constraint" labelPlacement="start"  control={ 
                    <Select
                        value={this.state.sLensHoverCombineMode}
                        style ={{marginLeft:"10px"}}
                        onChange={(event) => this.setState({sAllButOneTheSameConstraint: event.target.value})}>
                        <MenuItem value={'contiguous'}>Contiguous Line</MenuItem>
                        <MenuItem value={'parallelpair'}>|| Pair</MenuItem>
                    </Select>}/>}

                {/* <FormControlLabel label="Lens Breaks" title='group the text into lines ending with words matching the lens' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnBreakLinesByWordsMatchingLenses: event.target.checked})} checked={this.state.blnBreakLinesByWordsMatchingLenses} /> }/>								 */}
			
                </>}

                {/* <FormControlLabel label="Tags" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowGeneralTags: event.target.checked})} checked={this.state.blnShowGeneralTags} /> }/>	
                <FormControlLabel label="Tags Into Trees" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnTreeModeForTags: event.target.checked})} checked={this.state.blnTreeModeForTags} /> }/>								 */}
				{/* <FormControlLabel label="Color || By Type" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnColorCorrespondenceLensByMainType: event.target.checked})} checked={this.state.blnColorCorrespondenceLensByMainType} /> }/>								 */}
				
                {/* <FormControlLabel label="Chains" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnDoChainFilter: event.target.checked})} checked={this.state.blnDoChainFilter} /> }/>								
			
                <FormControlLabel label="N in Chain" labelPlacement="start"  control={ 
                <Select
                    value={this.state.nChainCutoffValue}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nChainCutoffValue: event.target.value})}>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                </Select>} /> */}


                {this.InSearchAndTagMode() && <FormControlLabel label="Context Verses when Tagging" labelPlacement="start"  control={ 
                <Select
                    value={this.state.nSearchAndTagVerseContextVersesBeforeAndAfter}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nSearchAndTagVerseContextVersesBeforeAndAfter: event.target.value})}>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                </Select>} />}
                
                
                {this.InSearchAndTagMode() && <FormControlLabel label="Use Tags For These Semantic Groups Only" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnOnlyUseTagInventoryForCurrentSemanticGroup: event.target.checked})} checked={this.state.blnOnlyUseTagInventoryForCurrentSemanticGroup} /> }/>}
                
                {this.InSearchAndTagMode() && <div align="center" style={{display: "inline-block", verticalAlign:"middle"}}>
                    <Autocomplete multiple autoComplete clearOnBlur selectOnFocus 
                        options={this.listSemanticGroupsForSearchAndTag.map(o => o.BSG)}
                        value={this.state.listSelectedSemanticGroupsForTagInventory}
                        getOptionLabel={(option) => option}
                        // groupBy={(option) => option.MainType}
                        onChange={(event, listSelected) => {
                            this.setState({listSelectedSemanticGroupsForTagInventory: listSelected})
                        }} 
                        style={{width: 250, marginLeft: "10px", marginRight: "10px"}}
                        size="small"
                        onFocus={(e) => this.setState({blnThematicStatementAutocompleteHasFocus: true})}
                        onBlur={(e) => this.setState({blnThematicStatementAutocompleteHasFocus: false})}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                        )}
                    />
                </div>
                }

                {/* {this.InSearchAndTagMode() && <FormControlLabel label="Edit Tags" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowTagEditingControls: event.target.checked})} checked={this.state.blnShowTagEditingControls} /> }/>}								 */}
			
                <FormControlLabel label="Align" title='show/hide controls to align text/charts and size charts' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowAlignmentAndSizeControls: event.target.checked})} checked={this.state.blnShowAlignmentAndSizeControls} /> }/>								
				<FormControlLabel label="Root Chapter List in Hover" title='show ListOfChaptersEachRootOccursIn when hovering text' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnListOfChaptersEachRootOccursInInHoverInfo: event.target.checked})} checked={this.state.blnListOfChaptersEachRootOccursInInHoverInfo} /> }/>							
				
                <br />
                <FormControlLabel label="Charts" title='(toggle with C key)' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowLineCharts: event.target.checked})} checked={this.state.blnShowLineCharts} /> }/>								
				
                {this.state.blnShowLineCharts &&
                <>
                <FormControlLabel label="Chart Divisions" labelPlacement="start"  control={ 
                <Select
                    value={this.state.sVerticalBreakLinesToShowInLineCharts}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({sVerticalBreakLinesToShowInLineCharts: event.target.value})}>
                    <MenuItem value={'none'}>None</MenuItem>
                    <MenuItem value={'allgroups'}>All Unit Levels</MenuItem>
                    <MenuItem value={'somegroups'}>Some Unit Levels</MenuItem>
                    <MenuItem value={'verses'}>Verses</MenuItem>
                </Select>} />

                <FormControlLabel label="Gaps" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowGapsInBarChartBetweenSubunits: event.target.checked})} checked={this.state.blnShowGapsInBarChartBetweenSubunits} /> }/>								
				<FormControlLabel label="Verse Line" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({listShowVerseDivisionsInBarChart: event.target.checked})} checked={this.state.listShowVerseDivisionsInBarChart} /> }/>								
				<FormControlLabel label="Average Line" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowAverageLineInBarChart: event.target.checked})} checked={this.state.blnShowAverageLineInBarChart} /> }/>									
                <FormControlLabel label="Y Axis" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowChartYAxis: event.target.checked})} checked={this.state.blnShowChartYAxis} /> }/>								
				
                {this.WordsBySoundGroupLensIsEnabled() && <FormControlLabel label="Line Chart" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowLineChartWhenSoundGroupLensIsEnabled: event.target.checked})} checked={this.state.blnShowLineChartWhenSoundGroupLensIsEnabled} /> }/>}								
				
                {/* <FormControlLabel label="Bins" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnBinAndSortWordGroupsForLineCharts: event.target.checked})} checked={this.state.blnBinAndSortWordGroupsForLineCharts} /> }/>								 */}
				<FormControlLabel label="Chart Popup Glosses" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowGlossesInChartPopup: event.target.checked})} checked={this.state.blnShowGlossesInChartPopup} /> }/>								
				
                {/* <FormControlLabel label="Heatmap" title='(toggle with C key)' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowUnitRelationshipCharts: event.target.checked})} checked={this.state.blnShowUnitRelationshipCharts} /> }/>								 */}
				<FormControlLabel label="Sort Line Charts By" labelPlacement="start"  control={ 
                <Select
                    value={this.state.blnSortLineChartsBy}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({blnSortLineChartsBy: event.target.value})}>
                    <MenuItem value={'ClosenessToRange'}>Closeness to Range</MenuItem>
                    <MenuItem value={'NumberOfOccurrences'}>Occurrences</MenuItem>
                    <MenuItem value={'AxisText'}>Y Axis Labels</MenuItem>
                    <MenuItem value={'Index'}>Index</MenuItem>
                </Select>} />
                </>}

                {window.location.hostname.includes("localhost") && 
                <>
                <FormControlLabel label="Tool" labelPlacement="start" control={ 
                <Select
                style={{ marginLeft:"10px", marginRight:"10px"}}
                value={this.state.nSelectedToolID == null ? 0 : this.state.nSelectedToolID}
                onChange={(event) => this.ChangeTool(event.target.value)}>
                <MenuItem value={0}>None</MenuItem>
                { this.listTools.filter(r => r.HideInProduction === "0" || this.blnDevView).map(r => <MenuItem value={r.ID}>{r.Desc}</MenuItem>)}
                </Select>} />

                <FormControlLabel label="RLG Comment Box" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowRepetitionLinkGroupCommentBox: event.target.checked})} checked={this.state.blnShowRepetitionLinkGroupCommentBox} />} />					
                </>
                }

                <br />
                <FormControlLabel label="Group Lines Into Units By Level" title='(cycle through with G key)' labelPlacement="start"  control={ 
                <Select
                    value={this.state.sGroupLinesBy}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({sGroupLinesBy: event.target.value}, () => {
                        if(this.ShowingDevelopmentDiagram())
                        {
                            this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                        }
                        else
                        {
                            this.SetWordGroupsForEnabledLenses()
                        }
                    })}>
                    <MenuItem value={'StartsRepetitionGroup'}>1</MenuItem>
                    <MenuItem value={'StartsCluster'}>2</MenuItem>
                    <MenuItem value={'StartsClusterGroup'}>3</MenuItem>
                    <MenuItem value={'StartsLevel4Group'}>4</MenuItem>
                    {/* <MenuItem value={'ByChapter'}>Chapter</MenuItem> */}
                </Select>} />

                {this.ShowingDevelopmentDiagram() && 
                    <FormControlLabel label="Subunit Breaks" control={ <Checkbox style={{marginLeft:"15px"}} 
                    onChange={(event) => this.setState({blnShowSubunitBreaksInDevelopmentDiagram: event.target.checked}, this.GenerateDevelopmentDiagramForChapterIfShowing())} 
                    checked={this.state.blnShowSubunitBreaksInDevelopmentDiagram} />} />}					

                {this.state.sViewBy === 'Line' &&
                <>
                <FormControlLabel label="Side by Side" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnTextUnitSideBySideMode: event.target.checked})} checked={this.state.blnTextUnitSideBySideMode} /> }/>								
				{this.state.blnTextUnitSideBySideMode && <FormControlLabel label="Subunit Breaks in Side by Side" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnSubunitBreaksInSideBySideMode: event.target.checked})} checked={this.state.blnSubunitBreaksInSideBySideMode} /> }/>}                
                </>}

                {/* <FormControlLabel label="Lens Scope" title='(cycle through with D key)' labelPlacement="start"  control={ 
                <Select
                    value={this.state.sIntraOrInterUnitsLensScope}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({sIntraOrInterUnitsLensScope: event.target.value}, this.SetWordGroupsForEnabledLenses())}>
                    <MenuItem value={'both'}>Inside and Between Units</MenuItem>
                    <MenuItem value={'inside'}>Inside Units Only</MenuItem>
                    <MenuItem value={'between'}>Between Units Only</MenuItem>
                </Select>} /> */}

                
                {this.ShowingDevelopmentDiagram() && 
                <>
                <br />
                
                {/* <FormControlLabel label="" title='' labelPlacement="start"  control={ 
				<Select
					value={this.state.sLineTopographyForDevelopmentDiagram}
					style ={{marginLeft:"10px"}}
					onChange={(event) => this.setState({sLineTopographyForDevelopmentDiagram: event.target.value}, this.GenerateDevelopmentDiagramForChapterIfShowing())}
				>
					<MenuItem value={'onelineperlinkgroup'}>One Line Per Link Group</MenuItem>
                    <MenuItem value={'radiatinglines'}>Radiating Lines From Hovered Unit</MenuItem>
				</Select>} /> */}

                <FormControlLabel label="When Nothing is Hovered, Show" title='toggle between some of the choices with the A key' labelPlacement="start"  control={ 
				<Select
					value={this.state.sDefaultNoHoveredModeForDevelopmentDiagram}
					style ={{marginLeft:"10px"}}
					onChange={(event) => this.setState({sDefaultNoHoveredModeForDevelopmentDiagram: event.target.value}, this.GenerateDevelopmentDiagramForChapterIfShowing())}
				>
                    <MenuItem value={'unittounit'}>Unit to Unit</MenuItem>
                    <MenuItem value={'onelineperlinkgroup'}>One Line Per Link Group</MenuItem>
                    {this.SemanticChainsLensIsEnabled() && <MenuItem value={'selectedindexoflinkgroup'}>Selected Index of Group</MenuItem>}
                    <MenuItem value={'bookendingsubunits'}>Bookending Subunits</MenuItem>
                    <MenuItem value={'bookendingchapter'}>Bookending Chapter</MenuItem>
                    <MenuItem value={'firstlineofsubunitsnotfirst'}>First Lines of Subunits (except for the first subunit)</MenuItem>
                    <MenuItem value={'nolinks'}>No Links</MenuItem>
				</Select>} />
                
                <FormControlLabel label="Filter Links By Position" title='cycle through the choices with the E key' labelPlacement="start"  control={ 
				<Select
					value={this.state.sModeForShowOnlyLinksAtLineEdges}
					style ={{marginLeft:"10px"}}
					onChange={(event) => this.setState({sModeForShowOnlyLinksAtLineEdges: event.target.value}, this.GenerateDevelopmentDiagramForChapterIfShowing())}
				>
					<MenuItem value={'modeisoff'}>All</MenuItem>
                    <MenuItem value={'beginningtobeginningorendtoend'}>Beginning to Beginning or End to End</MenuItem>
                    <MenuItem value={'beginningtobeginningorendtoendormiddletomiddle'}>Beginning to Beginning, Middle to Middle, or End to End</MenuItem>
                    <MenuItem value={'middletomiddle'}>Middle to Middle</MenuItem>
                    <MenuItem value={'beginningtoendorendtobeginning'}>Beginning to End or End to Beginning</MenuItem>
                    <MenuItem value={'sameline'}>Same Line</MenuItem>
				</Select>} />

                <br />
                <FormControlLabel label="Max Recent Lenses To Show" style={{userSelect: "none"}} title='' labelPlacement="start"  control={ 
                <Select
                    value={this.state.nMaxRecentLensesToShow}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nMaxRecentLensesToShow: event.target.value})}>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                </Select>} />

                <br />
                {this.state.sDefaultNoHoveredModeForDevelopmentDiagram === 'unittounit' && 
                <FormControlLabel label="Line to Line Distance When Not Hovered" style={{userSelect: "none"}} title='distance between links in unit to unit non-hovered mode' labelPlacement="start"  control={ 
                <Select
                    value={this.state.nMaxLinesAwayForDefaultNoHoveredMode}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nMaxLinesAwayForDefaultNoHoveredMode: event.target.value})}>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={10000}>Max</MenuItem>
                </Select>} />}
                
                <FormControlLabel label="Max Group Length" labelPlacement="start"  control={ 
                <Select
                    value={this.state.nMaxDevelopmentDiagramLinkGroupLengthToShow}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nMaxDevelopmentDiagramLinkGroupLengthToShow: event.target.value}, this.GenerateDevelopmentDiagramForChapterIfShowing())}>

                    {this.state.listDevelopmentDiagramLinkGroupLengths.map(n => <MenuItem value={n}>{n}</MenuItem>)}
                </Select>} />

                <FormControlLabel label="As Chains" title='' control={ <Checkbox style={{marginLeft:"15px"}} 
                onChange={(event) => this.setState({blnBreakLinkGroupsIntoChains: event.target.checked}, this.GenerateDevelopmentDiagramForChapterIfShowing())} checked={this.state.blnBreakLinkGroupsIntoChains} /> }/>								
				
                {this.state.blnBreakLinkGroupsIntoChains && <FormControlLabel label="Don't Color First Word in Chain" title='' control={ <Checkbox style={{marginLeft:"15px"}} 
                onChange={(event) => this.setState({blnDoNotColorFirstWordInChain: event.target.checked}, this.GenerateDevelopmentDiagramForChapterIfShowing())} checked={this.state.blnDoNotColorFirstWordInChain} /> }/>}								
				
                <br />
                <FormControlLabel label="Color by" title='active lens to color the text by in composite view' labelPlacement="start"  control={ 
				<Select
					value={this.state.oLensToColorTextBy}
					style ={{marginLeft:"10px"}}
					onChange={(event) => this.setState({oLensToColorTextBy: event.target.value}, this.GenerateDevelopmentDiagramForChapterIfShowing())}
				>
                    <MenuItem value={{NoneOption: true}}>None</MenuItem>
                    {this.GetLensesThatAreOn().map(l => <MenuItem value={l}>{l.Name}</MenuItem>)}
				</Select>} />
                
                <FormControlLabel label="Show Links For This Lens" control={<Checkbox style={{marginLeft:"15px"}} 
                    onChange={(event) => this.setState({blnShowLinksForLensThatIsColoredBy: event.target.checked}, this.GenerateDevelopmentDiagramForChapterIfShowing())} checked={this.state.blnShowLinksForLensThatIsColoredBy} /> }/>
				
                {/* <FormControlLabel label="Unit To Compare With" title='(toggle with A key)' labelPlacement="start"  control={ 
				<Select
					value={this.state.sWhichUnitToCompareWith}
					style ={{marginLeft:"10px"}}
					onChange={(event) => this.setState({sWhichUnitToCompareWith: event.target.value})}
				>
					<MenuItem value={'selected'}>Selected</MenuItem>
                    <MenuItem value={'previoustohovered'}>Previous To Hovered</MenuItem>
                    <MenuItem value={'alllinksfromhovered'}>All From Hovered</MenuItem>
				</Select>} /> */}

                {/* <FormControlLabel label="Show Link Groups Internal to Units" title='(toggle with I key)' labelPlacement="start"  control={ 
				<Select
					value={this.state.sShowInternalLinkGroups}
					style ={{marginLeft:"10px"}}
					onChange={(event) => this.setState({sShowInternalLinkGroups: event.target.value})}
				>
					<MenuItem value={'both'}>Both</MenuItem>
                    <MenuItem value={'externalonly'}>External Only</MenuItem>
                    <MenuItem value={'internalonly'}>Internal Only</MenuItem>
				</Select>} /> */}

                {this.blnDevView && <FormControlLabel label="Show Thematic Color Groups" title='' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnColorLinesByDevelopmentRepetitionGroup: event.target.checked})} checked={this.state.blnColorLinesByDevelopmentRepetitionGroup} /> }/>}												
                {/* <FormControlLabel label="Exclude First Unit Link Groups" title='(toggle with Z key)' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnExcludeLinkGroupsFoundInSelectedUnit: event.target.checked})} checked={this.state.blnExcludeLinkGroupsFoundInSelectedUnit} /> }/>								 */}
				
                </>}

                {/* <FormControlLabel label="Lens Combining Mode" labelPlacement="start"  control={ 
                <Select
                    value={this.state.sLensHoverCombineMode}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({sLensHoverCombineMode: event.target.value})}>
                    <MenuItem value={'any'}>Any</MenuItem>
                    <MenuItem value={'all'}>All</MenuItem>
                    <MenuItem value={'allbutonethesame'}>All But One the Same</MenuItem>
                </Select>} /> */}
               
                {/* <FormControlLabel label="All Score Cutoff" labelPlacement="start"  control={ 
                <Select
                    value={this.state.listAllSimilarityScoreThreshold}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({listAllSimilarityScoreThreshold: event.target.value})}>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                </Select>} /> */}

                {/* <FormControlLabel label="SylRBE" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnSyllableRhymeOnlyWhenBothAtWordBeginningOrEnd: event.target.checked})} checked={this.state.blnSyllableRhymeOnlyWhenBothAtWordBeginningOrEnd} /> }/>								
				<FormControlLabel label="Rhyme with Only Previous" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnOnlyLookAtPreviousSyllablesForRhyme: event.target.checked})} checked={this.state.blnOnlyLookAtPreviousSyllablesForRhyme} /> }/>								
				
                <FormControlLabel label="RS Location" labelPlacement="start"  control={ 
                <Select
                    value={this.state.sLocationRestrictionForSyllableRhyme}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({sLocationRestrictionForSyllableRhyme: event.target.value})}>
                    <MenuItem value={'mostfrequent'}>Most Frequently Rhymed</MenuItem>
                    <MenuItem value={'accented'}>Accented</MenuItem>
                    <MenuItem value={'all'}>All</MenuItem>
                    <MenuItem value={'beginning or end'}>Beginning or End</MenuItem>
                    <MenuItem value={'beginning'}>Beginning</MenuItem>
                    <MenuItem value={'end'}>End</MenuItem>
                    <MenuItem value={'middle'}>Middle</MenuItem>
                </Select>} />

                <FormControlLabel label="Rhyme Max Distance" labelPlacement="start"  control={ 
                <Select
                    value={this.state.nMaxTextIndexDistanceForRhymeMaximumAmountCalcs}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nMaxTextIndexDistanceForRhymeMaximumAmountCalcs: event.target.value})}>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100000}>Max</MenuItem>
                </Select>} /> */}

                {this.InSearchAndTagMode() && <FormControlLabel label="Basic Attributes?" title='Highlight A Few Words Potentially Indicating Tag Attributes' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnHighlightBasicMaybeAttributeWordsInSearchAndTag: event.target.checked})} checked={this.state.blnHighlightBasicMaybeAttributeWordsInSearchAndTag} /> }/>}											
                {this.InSearchAndTagMode() && <FormControlLabel label="Attributes?" title='Highlight Words Potentially Indicating Tag Attributes' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnHighlightMaybeAttributeWordsInSearchAndTag: event.target.checked})} checked={this.state.blnHighlightMaybeAttributeWordsInSearchAndTag} /> }/>}								
				    
                {this.InSearchAndTagMode() && <FormControlLabel label="Tagging Batch Size" labelPlacement="start"  control={ 
                <Select
                    value={this.state.nSearchAndTagResultsBatchSize}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nSearchAndTagResultsBatchSize: event.target.value})}>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={35}>35</MenuItem>
                    <MenuItem value={40}>40</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={60}>60</MenuItem>
                    <MenuItem value={70}>70</MenuItem>
                    <MenuItem value={80}>80</MenuItem>
                    <MenuItem value={90}>90</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                </Select>} />}

                {/* {this.SemanticChainsLensIsEnabled() && <FormControlLabel label="Semantic Chains Batch Size" labelPlacement="start"  control={ 
                <Select
                    value={this.state.nSemanticChainsLensBatchSize}
                    style ={{marginLeft:"10px"}}
                    onChange={(event) => this.setState({nSemanticChainsLensBatchSize: event.target.value}, this.SetWordGroupsForEnabledLenses())}>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                    <MenuItem value={1000}>1000</MenuItem>
                </Select>} />} */}

                <br />
                {this.SemanticChainsLensIsEnabled() && window.location.hostname.includes("localhost") &&
                 <FormControlLabel label="Edit Semantic Groups" title="" control={ <Checkbox style={{marginLeft:"15px"}} 
                 onChange={(event) => {
                    this.setState({blnEditingSemanticGroups: event.target.checked})
                    this.setState({sDefaultNoHoveredModeForDevelopmentDiagram: 'selectedindexoflinkgroup'})}} checked={this.state.blnEditingSemanticGroups} /> }/>
                }

                <FormControlLabel label="Line Spacing Y" title='use this to change the Y distance between lines' labelPlacement="start" control={ 
                <Box sx={{width: 100}}>
                    <Slider 
                    step={1}
                    min={10}
                    max={50}
                    valueLabelDisplay="auto"
                    value={this.state.nYDistanceBetweenLines} 
                    onChange={(event, newValue) => {
                        this.setState({nYDistanceBetweenLines: newValue}, this.GenerateDevelopmentDiagramForChapterIfShowing())}}
                    />
                </Box>  
                }/>

                <br />
                <FormControlLabel label="Accents" title="Bold Accented Syllables in Transliteration" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnBoldAccentedSyllables: event.target.checked})} checked={this.state.blnBoldAccentedSyllables} /> }/>											
                {this.state.blnBoldAccentedSyllables && <FormControlLabel label="Final Accents" title="Bold Accented Final Syllables in Transliteration" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowAccentOnLastSyllable: event.target.checked})} checked={this.state.blnShowAccentOnLastSyllable} /> }/>}											
                
                <FormControlLabel label="Print View (press 'p' to return)" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnHideEverything: event.target.checked})} checked={this.state.blnHideEverything} /> }/>								
				<FormControlLabel label="RR" title='EachRepetitionGroupShouldHaveRepeatedRoots' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnEachRepetitionGroupShouldHaveRepeatedRoots: event.target.checked})} checked={this.state.blnEachRepetitionGroupShouldHaveRepeatedRoots} /> }/>								
				
                <FormControlLabel label="Presentation" title='Connections Presentation Mode' control={ <Checkbox style={{marginLeft:"15px"}} 
                onChange={(event) => 
                {
                    this.ChangeLensSticky(this.state.listLenses.find(l => l.LensType === 'handtaggedconnections'), true)
                    this.setState({blnConnectionsPresentationMode: event.target.checked})}
                } 
                checked={this.state.blnConnectionsPresentationMode} /> }/>								
				
                {this.state.blnConnectionsPresentationMode && <FormControlLabel label="Edit Comments" title='ConnectionsPresentationCommentEditMode' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnConnectionsPresentationCommentEditMode: event.target.checked})} checked={this.state.blnConnectionsPresentationCommentEditMode} /> }/>}								
				
                

                {this.GroupByUnitHeatmapIsEnabled() && <FormControlLabel label="Filter By Consecutive" title="FilterSoundGroupsByUnitBySameSoundInConsecutiveLineGroups" control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnFilterSoundGroupsByUnitBySameSoundInConsecutiveLineGroups: event.target.checked})} checked={this.state.blnFilterSoundGroupsByUnitBySameSoundInConsecutiveLineGroups} /> }/>}								
				
                {this.state.sViewBy === 'Line' &&
                <>
                <FormControlLabel label="Restrict To Verse Ranges" title='e.g. type in 1-2,5 to show only verses 1-2 and 5' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnRestrictTextToVerseRangesToHighlight: event.target.checked})} checked={this.state.blnRestrictTextToVerseRangesToHighlight} /> }/>												
                <input size='10' onChange={(event) => this.setState({sVerseRangesToHighlight: event.target.value})}/>
                </>}

                <br />		
                {window.location.hostname.includes("localhost") && <>
                    <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.GetHebrewMirrorTranslationFirstDraft())}>Mirror First Draft</Button>
                    
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.AddConnectionsFromSimilarOppositeTags())}>Generate Inside Verse Connections From Tags</Button> */}
                    
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.AddConnectionsFromSemanticLinks())}>Generate Connections From Semantic Links</Button> */}
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.DeleteConnectionsAddedFromSemanticLinksForCurrentChapter())}>Delete Connections From Semantic Links</Button> */}

                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.AddConnectionsAboveCurrentMaximumConnectionLevelFromConnectionsAtCurrentMaximumConnectionLevel())}>Generate Higher Unit Connections From Current Connections</Button> */}
                    
                    <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.GetEverythingForDB())}>Get Data</Button>
                    
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.GetAllLines())}>Get All Lines</Button>
                    <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.GetAllRepetitionGroups())}>Get All Repetition Groups</Button> */}
                    
                    
                    {/* <Button variant="contained" onClick={() => this.TakePicture()}>Take Picture</Button>
                    <Button variant="contained" onClick={() => this.CalculateConnectionThingsForAllPoeticChapters()}>Connection Calculations</Button>
                    <Button variant="contained" onClick={() => 
                        this.GenerateDevelopmentDiagramForPowerpoint(this.GetFirstCurrentChapter().toString(), 
                        this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())}>Powerpoint</Button> */}

                    

                    {/* <Button variant="contained" onClick={() => this.GenerateListOfChaptersEachThematicStatementOccursIn()}>Generate ListOfChaptersEachThematicStatementOccursIn</Button> */}
                    
                    {/* <Button variant="contained" onClick={() => this.GenerateListOfChaptersEachRootOccursIn()}>Generate ListOfChaptersEachRootOccursIn</Button> */}

                    {/* <FormControlLabel label="Download" title='Show Buttons For Data Download' control={ <Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({blnShowDataDownloadButtons: event.target.checked})} checked={this.state.blnShowDataDownloadButtons} /> }/> */}
                        
                    {/* <Button variant="contained" onClick={() => this.SaveCurrentGraph()}>Graph</Button> */}
                        
                    {/* <Button variant="contained" onClick={() => this.GetRepetitionLinkGroupsForDB()}>Get Temp</Button> */}
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.CalculateAllSimilarityForAllChapters())}>Calc All Sim</Button> */}
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.CalculateAllSimilarityForLinesForAllChapters())}>Calc All Sim Lines</Button> */}
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.GetAllSimilarityAmountScoresForChapterBasedOnRarity())}>Calc All Sim By Rarity</Button> */}
                    
                    {/* <Button variant="contained" onClick={() => this.WipeOutLocalStorageForLinesForAllChapters()}>Delete Locally Stored Lines</Button> */}
                    
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.CalculateRhymeChainsForAllPoeticChapters())}>Calculate Rhyme Chains For All Chapters</Button> */}
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.CalculateCadenceThingsForAllPoeticChapters())}>Calculate Cadence Things For All Chapters</Button>  */}
                    
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.GetGrammaticalDiagramMarkup())}>GrammaticalDiagram</Button> */}
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.GetSDBHAssociationsText("l"))}>Associations</Button> */}
                    {/* {this.UsingAWordTagTool() && <Button variant="contained" onClick={() => this.CreateWordTagsForChapter()}>Create Word Tags</Button>} */}
                    {/* <Button variant="contained" onClick={() => this.CompareVersesLikeLineCharts()}>CV</Button> */}
                    {/* <Button variant="contained" onClick={() => this.CalculateRepetitionLinkGroupStats()}>Calc || Stats</Button> */}             
                    {/* <Button variant="contained" onClick={() => this.AutoAddRepetitionLinkGroups()}>AutoAdd</Button> */}
                    {/* <Button variant="contained" onClick={() => this.RestoreRepetitionLinkGroupsFromBackup()}>!!!WarningL RESET Link Groups!!!!</Button> */}
                    {/* <Button variant="contained" onClick={() => this.RemoveAllAutoAddedRepetitionLinkGroups()}>RemoveAllAutoAdded</Button> */}
                    
                    {/* <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.GetOurTranslationTextForChapter())}>Translation Text</Button> */}

                </>}

                

                {!this.state.blnHideEverything && !this.InSearchAndTagMode() && 
                <>
                <Button variant="text" //color="primary" 
                    style={{ marginLeft:"15px"}}
                    onClick={(event) => { 
                    this.setState({ blnAboutPopoverIsOpen: true}); 
                    this.setState({ anchorForAboutPopover: event.currentTarget}); }}>About</Button>
                <Popover
                    anchorEl={this.state.anchorForAboutPopover}
                    open={this.state.blnAboutPopoverIsOpen}
                    onClose={() => this.setState({ blnAboutPopoverIsOpen: false})}>
                    
                    <span>Portions of the data used include the following:</span>
                    <ul>
                        <li>Cherith Glosses for the Hebrew Old Testament, by Andi Wu, Copyright (C) 2022 by Cherith Analytics, is licensed under a Creative Commons Attribution 4.0 International License ("CC BY 4.0").</li>
                        <li>MACULA Hebrew Linguistic Datasets ©2022-2024 by Biblica, Inc, released under a Creative Commons CC BY 4.0 license.</li>
                        <li>Open Scriptures Hebrew Bible</li>
                        <li>Syntax trees developed by Clear Bible, Inc. together with the Groves Center; Westminster Hebrew Syntax without Morphology under a Creative Commons CC BY 4.0 license.</li>
                        <li>ETCBC database</li>
                        <li>BSB English Translation</li>
                        <li>BSB Alignment by Biblica, Inc. Creative Commons Attribution 4.0</li>
                    </ul>
                </Popover>
                </>}

                
                {this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID && this.state.nCurrentLinkGroupType === 8 && <Button variant="contained" //color="primary" 
				style={{ marginLeft:"15px"}}
				onClick={(event) => this.PrepopulateSemanticChainsForChapter()}>Prepopulate Semantic Chains For Chapter</Button>}
			</Popover>
            
            {this.InSearchAndTagMode() && this.state.blnShowDataDownloadButtons &&
                <div>
                    <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.GetSearchAndTagDataForTagInventory())}>Get Tag Inventory</Button>
                    <Button variant="contained" onClick={() => navigator.clipboard.writeText(this.GetSearchAndTagDataForMatchTags())}>Get Tags</Button>
                </div>
            }
            
			

            

            {this.state.blnShowWordDotChart && this.GetWordDotChart()}

            {this.blnDevView && this.state.blnGlobalDistributionForQueries && this.state.blnShowWordDotChart && this.GetDotChartForAllPsalms()}
            
            {(this.ShowRepetitionGroupTags() &&
            <><br />
            
            {this.state.blnShowRepetitionLinkGroupCommentBox && <input type="text" 
                style ={{margin:"5px"}}
                size={100}
				label="Comments"
				value={this.GetCurrentRepetitionLinkGroup() === undefined ? "" : this.GetCurrentRepetitionLinkGroup().Comment}
				variant="outlined"
				onChange={(event) => {
                    var selectedCurrentRepetitionLinkGroup = this.GetCurrentRepetitionLinkGroup();
                    if(selectedCurrentRepetitionLinkGroup != undefined)
                    {
                        selectedCurrentRepetitionLinkGroup.Comment = event.target.value;
                        this.SaveRepetitionLinkGroupsAndSetState(this.state.listRepetitionLinkGroups); }}} />}

            {this.RelationPairTagsForRepetitionLinkGroup(this.GetCurrentRepetitionLinkGroup()).map(tag =>
                <FormControlLabel label={this.GetTagRelationPairText(tag)} 
                control={ <Checkbox style={{marginLeft:"10px"}} 
                onChange={(event) => this.SetTagRelationPairReversed(tag, event.target.checked)}
                checked={tag.RelationPairReversed} /> }/>)}	

            {/* {!this.state.blnShowHint || this.GetCurrentRepetitionLinkGroup() === undefined ? "" : this.GetCategoryDescListForCurrentRepetitionLinkGroup()}        */}
            <br />
            
			{[...new Set(this.listRepetitionLinkGroupCategories.filter(cat => cat.LinkGroupTypes.includes(this.state.nCurrentLinkGroupType.toString())).map(cat => cat.Group))].
				sort((a,b) => a > b).map(sGroup => 
			//this.listRepetitionLinkGroupCategoryGroups.filter(catgrp => this.listRepetitionLinkGroupCategories.some(cat => cat.Group === catgrp.ID)).map(catgrp => 
			<select multiple style={{marginLeft:"10px", borderColor:this.RepetitionLinkGroupCategoryIDIsCurrentlySelected(sGroup) ? "blue" : "black"}} 
				size={this.state.nCurrentLinkGroupType === 2 ? 3 : this.state.nCurrentLinkGroupType === 15 ? 4 : 5}
				onKeyDown={(e) => {
					if (e.keyCode >= 65 && e.keyCode <= 90) // A to Z
					{
						e.preventDefault();
						return false;
					}
				}}
				onChange={(event) => {
                    var selectedCurrentRepetitionLinkGroup = this.GetCurrentRepetitionLinkGroup();
                    if(selectedCurrentRepetitionLinkGroup != undefined)
                    {
                        [...event.target.options].filter(o => o.selected).forEach(o => {
                            if(!selectedCurrentRepetitionLinkGroup.ListTags.some(t => t.CategoryID === o.value))
                            {
                                selectedCurrentRepetitionLinkGroup.ListTags.push({CategoryID: o.value, RelationPairReversed: false});
                            }});

                        [...event.target.options].filter(o => !o.selected).forEach(o => {
                            if(selectedCurrentRepetitionLinkGroup.ListTags.some(t => t.CategoryID === o.value))
                            {
                                var nIndexToRemove = selectedCurrentRepetitionLinkGroup.ListTags.findIndex(t => t.CategoryID === o.value);
                                selectedCurrentRepetitionLinkGroup.ListTags.splice(nIndexToRemove, 1);
                            }});

                        this.SaveRepetitionLinkGroupsAndSetState(this.state.listRepetitionLinkGroups); 
                    }
                }}>
					
                {this.listRepetitionLinkGroupCategories.filter(cat => cat.Group === sGroup && cat.LinkGroupTypes.includes(this.state.nCurrentLinkGroupType.toString())).map(cat => 
                    <option value={cat.ID} 
                        selected={this.GetCurrentRepetitionLinkGroup() != undefined && this.GetCurrentRepetitionLinkGroup().ListTags.some(t => t.CategoryID === cat.ID)}>{cat.Desc}</option>)}
            </select>)}
            </>)}

            {/* {this.InThematicStatementsMode() && this.GetPsalmsThematicComparisonChart()} */}


            {/* onKeyDown={(e) => {
					if (e.keyCode >= 65 && e.keyCode <= 90) // A to Z
					{
						e.preventDefault();
						return false;
					}
				}} */}

            {this.InSearchTaggedDataMode() && <div align="center" style={{display: "inline-block", verticalAlign:"top"}}>
                <div align="center" style={{display: "inline-block", verticalAlign:"middle"}}>
                    <Autocomplete multiple autoComplete clearOnBlur selectOnFocus freeSolo
                        options={this.state.listTagInventory}
                        value={this.state.listTagsSelectedForSearch}
                        getOptionLabel={(option) => option.Desc}
                        // groupBy={(option) => option.MainType}
                        onChange={(event, listSelected) => {
                            this.setState({listTagsSelectedForSearch: listSelected})
                        }} 
                        style={{width: 500, marginLeft: "10px", marginRight: "10px"}}
                        size="small"
                        onFocus={(e) => this.setState({blnThematicStatementAutocompleteHasFocus: true})}
                        onBlur={(e) => this.setState({blnThematicStatementAutocompleteHasFocus: false})}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                        )}
                    />
                    </div>
                    <div align="center" style={{display: "inline-block", verticalAlign:"middle"}}>
                    <FormControlLabel label="Within (Verses)" labelPlacement="start"  control={ 
                        <Select
                            value={this.state.nMaxDistanceInVersesBetweenMultipleTagsSearched}
                            style ={{marginLeft:"10px"}}
                            onChange={(event) => this.setState({nMaxDistanceInVersesBetweenMultipleTagsSearched: event.target.value})}>
                            <MenuItem value={0}>0</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                            <MenuItem value={4}>4</MenuItem>
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={6}>6</MenuItem>
                            <MenuItem value={7}>7</MenuItem>
                            <MenuItem value={8}>8</MenuItem>
                            <MenuItem value={9}>9</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={15}>15</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={30}>30</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100000}>Same Chapter</MenuItem>
                        </Select>} />
                    </div>
                </div>
            }

            {this.InThematicStatementsMode() && <div align="center" style={{display: "inline-block", verticalAlign:"top"}}>
            <div align="center" style={{display: "inline-block", verticalAlign:"middle"}}>
                <Autocomplete multiple autoComplete clearOnBlur selectOnFocus freeSolo
                    options={this.listThematicStatements}
                    value={this.state.listThematicStatementsSelectedForSearch}
                    getOptionLabel={(option) => option.Name}
                    // groupBy={(option) => option.MainType}
                    onChange={(event, listSelected) => {
                        this.setState({listThematicStatementsSelectedForSearch: listSelected})
                    }} 
                    style={{width: 500, marginLeft: "10px", marginRight: "10px"}}
                    size="small"
                    onFocus={(e) => this.setState({blnThematicStatementAutocompleteHasFocus: true})}
                    onBlur={(e) => this.setState({blnThematicStatementAutocompleteHasFocus: false})}
                    renderInput={(params) => (
                        <TextField {...params} variant="outlined" />
                    )}
                />
                </div>
                <div align="center" style={{display: "inline-block", verticalAlign:"middle"}}>
                <FormControlLabel label="Within (Verses)" labelPlacement="start"  control={ 
                    <Select
                        value={this.state.nMaxDistanceInVersesBetweenMultipleTagsSearched}
                        style ={{marginLeft:"10px"}}
                        onChange={(event) => this.setState({nMaxDistanceInVersesBetweenMultipleTagsSearched: event.target.value})}>
                        <MenuItem value={0}>0</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                        <MenuItem value={4}>4</MenuItem>
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={6}>6</MenuItem>
                        <MenuItem value={7}>7</MenuItem>
                        <MenuItem value={8}>8</MenuItem>
                        <MenuItem value={9}>9</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={15}>15</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={30}>30</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100000}>Same Chapter</MenuItem>
                    </Select>} />
                </div>
            </div>
            }

			{this.InSemanticRoleMode() &&
			<>
			<div style={{marginLeft: "450px", marginTop: "5px"}}>
				<Autocomplete multiple disableCloseOnSelect autoComplete clearOnBlur selectOnFocus
					options={this.listSemanticRoles}
					value={this.state.listSemanticRolesToShowInSemanticRoleMode}
					getOptionLabel={(option) => option.Desc}
					onChange={(event, newValue) => {
						this.setState({listSemanticRolesToShowInSemanticRoleMode: newValue});
					}} 
					style={{ width: 500 }}
					size="small"
					renderOption={(option, { selected }) => (
						<>
							<Checkbox
							icon={icon}
							checkedIcon={checkedIcon}
							style={{ marginRight: 8 }}
							checked={selected}
							/>
							{option.Desc}
						</>
						)}
					renderInput={(params) => (
						<TextField {...params} variant="outlined" autoFocus/>
					)} 
				/> 
			</div>

			{[...new Set(this.listSemanticRoles.map(role => role.Group))].map(sGroup => 
			<select multiple style={{marginLeft:"10px"}} size={4}
				onKeyDown={(e) => {
					if ((e.keyCode >= 65 && e.keyCode <= 90) || e.key === "ArrowRight" || e.key === "ArrowLeft") // A to Z
					{
						e.preventDefault();
						return false;
					}
				}}
				onChange={(event) => {
					var selectedCurrentWordTag = this.GetCurrentWordTag();
					if(selectedCurrentWordTag != undefined)
					{
						[...event.target.options].filter(o => o.selected).forEach(o => {
							if(!selectedCurrentWordTag.SemanticRoles.some(t => t.RoleID === o.value))
							{
								selectedCurrentWordTag.SemanticRoles.push({RoleID: o.value, 
									IsForSuffix: this.IsForSuffixModeForWordTags(this.GetWordWithTextIndexInChapter(selectedCurrentWordTag.TextIndex))});
							}});

						[...event.target.options].filter(o => !o.selected).forEach(o => {
							if(selectedCurrentWordTag.SemanticRoles.some(t => t.RoleID === o.value))
							{
								var nIndexToRemove = selectedCurrentWordTag.SemanticRoles.findIndex(t => t.RoleID === o.value);
								selectedCurrentWordTag.SemanticRoles.splice(nIndexToRemove, 1);
							}});

						this.SaveWordTags(this.state.listWordTags); 
					}
				}}>
					
				{this.listSemanticRoles.filter(r => r.Group === sGroup).map(r => {
					var currentWordTag = this.GetCurrentWordTag();
					var currentWord = currentWordTag === undefined ? undefined : this.GetWordWithTextIndexInChapter(currentWordTag.TextIndex);

					return <option value={r.ID} 
						selected={currentWordTag != undefined && currentWordTag.SemanticRoles.some(t => t.RoleID === r.ID && 
						((!this.IsForSuffixModeForWordTags(currentWord) && !t.IsForSuffix) ||
						 (this.IsForSuffixModeForWordTags(currentWord) && t.IsForSuffix)))}>{r.Desc + (r.Shortcuts.length === 0 ? "" : " " + r.Shortcuts[0])}</option>
					})}
			</select>)} </>}

			{this.ShowSemanticCategoriesAutocomplete() &&
				<div style={{marginLeft: "450px", marginTop: "5px"}}>

				<Autocomplete multiple autoComplete clearOnBlur selectOnFocus autoFocus freeSolo
					options={this.state.listSemanticNodes}
					value={this.GetCurrentWordTag() === undefined ? [] : this.GetCurrentWordTag().SemanticCategoryIDs.map(nID => this.state.listSemanticNodes.find(node => node.ID === nID))}
					getOptionLabel={(option) => option === undefined ? "" : option.Names}
					//groupBy={(option) => option.MainType}
					onChange={(event, listSelectedNodes) => {
						var currentWordTag = this.GetCurrentWordTag();
						if(currentWordTag != undefined)
						{
							//user can can new nodes - add any new ones to the special list
							var listExistingNodes = listSelectedNodes.filter(node => node.ID !== undefined);
							var nodesToAdd = listSelectedNodes.filter(node => node.ID === undefined).
								map((s, nIndexToAdd) => ({ID: 10000 + this.listUserAddedSemanticNodes.length + nIndexToAdd + 1, 
									Names: s, LexicalIDs: []}));

							if(nodesToAdd.length > 0) this.AddSemanticNodesAndSave(nodesToAdd);

							currentWordTag.SemanticCategoryIDs = listExistingNodes.concat(nodesToAdd).map(node => node.ID);
							this.SaveWordTags(this.state.listWordTags);
						}
					}} 
					style={{ width: 500 }}
					size="small"
					renderInput={(params) => (
						<TextField {...params} variant="outlined" autoFocus/>
					)} 
					ListboxProps={
					{
						style:{
							maxHeight: '500px',
							//border: '1px solid red'
						}
					}
					}/> 
				</div>
			}

			{this.ShowSemanticSearchAutocomplete() &&
				<div style={{marginLeft: "300px", marginTop: "5px"}}>

				<Autocomplete multiple autoComplete clearOnBlur selectOnFocus autoFocus
					options={this.GetOptionsForSemanticSearchAutoComplete()}
					value={this.state.listSelectedOptionsForSemanticSearch}
					getOptionLabel={(option) => option.Desc}
					//groupBy={(option) => option.MainType}
					onChange={(event, listNewSelectedOptions) => {
						this.CustomSearchLens(listNewSelectedOptions);
						this.setState({listSelectedOptionsForSemanticSearch: listNewSelectedOptions}); //, this.SetWordGroupsForEnabledLenses()
					}} 
					style={{ width: 800 }}
					size="small"
					renderInput={(params) => (
						<TextField {...params} variant="outlined" autoFocus/>
					)} 
					ListboxProps={
					{
						style:{
							maxHeight: '500px',
							//border: '1px solid red'
						}
					}
					}/> 
				</div>
			}

            {/* <br /> */}
            {/* {[["Stem", "s"], ["Form", "f"], ["Gender", "g"], ["Number", "n"], ["PGN", "pgn"], ["Suffix PGN", "sfxpgn"], 
            ["Word Type", "wordtype"], ["Preposition", "preposition"]].map(r => 
            <span style={{ borderStyle: "solid", borderWidth: "1px", marginLeft:"5px", userSelect: "none"}}    
			onClick={(event) => this.setState({blnColorByItemIsSticky: !this.state.blnColorByItemIsSticky})}
			onMouseEnter={(event) => { if(!this.state.blnColorByItemIsSticky) this.setState({sColorBy: r[1]})}}
            onMouseLeave={(event) => { if(!this.state.blnColorByItemIsSticky) this.setState({sColorBy: undefined})}}>{r[0]}</span>)}  */}
            
            {/* <FormControlLabel label={l.Name} style ={{marginLeft:"5px"}} control={ 
                    <Checkbox style={{marginLeft:"5px"}} onChange={(event) => this.ChangeLensEnabled(l, event.target.checked)} checked={l.Enabled || l.Sticky } /> }/>)}          
            */}

            {this.state.blnConnectionsPresentationMode && 
                <div>
                    {this.state.blnConnectionsPresentationCommentEditMode && window.location.hostname.includes("localhost") ? 

                    <><textarea rows={1} cols="30" style={{verticalAlign:"top", fontFamily: "Calibri", fontSize: "18px"}}
                    value={this.state.sCommentForCurrentConnectionsGroup} 
                    onChange={(e) => {
                        this.setState({sCommentForCurrentConnectionsGroup: e.target.value})
                    }}
                    onKeyDown={(e) => {
                        let key = e.key

                        if(this.state.sCommentForCurrentConnectionsGroup === undefined ||
                            this.state.sCommentForCurrentConnectionsGroup.length === 0)
                        {
                            if(key === '1')
                            {
                                this.setState({sCommentForCurrentConnectionsGroup: this.state.sDefaultCommentForCurrentConnectionsGroup})
                                e.preventDefault()
                            }
                            else if(/^[2-9]$/.test(key))
                            {
                                let nListIndexForKey = parseInt(key) - 2
                                if(nListIndexForKey < this.state.listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroup.length)
                                {
                                    this.setState({sCommentForCurrentConnectionsGroup: 
                                        this.state.listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroup[nListIndexForKey]})
                                }

                                e.preventDefault()
                            }
                        }
                    }} 
                    onFocus={(e) => this.setState({blnConnectionsPresentationCommentEditBoxHasFocus: true})}
                    onBlur={(e) => {
                        this.SetCommentForCurrentConnectionsGroup(e.target.value)
                        this.setState({blnConnectionsPresentationCommentEditBoxHasFocus: false})
                    }} />

                    <span>{this.state.listOtherCommentsWithTheSameWordsAsCurrentConnectionsGroup.length}</span>
                    </>

                    : 
                    <span>{this.state.sCommentForCurrentConnectionsGroup + ' ' + 
                        (this.state.blnConnectionIsContrastForCurrentConnectionsGroup ? ' (contrast)' : '')}</span>}
                </div>
            }

            {!this.state.blnHideEverything && this.state.blnShowRepetitionLinkGroupCommentBox && this.state.nSelectedToolID === this.nRepetitionLinkGroupToolID &&
                <div>
                <textarea rows={1} cols="30" style={{verticalAlign:"top", fontFamily: "Calibri", fontSize: "18px"}}
                onFocus={(e) => this.setState({blnTranslationEditBoxHasFocus: true})}
                onBlur={(e) => {
                    this.setState({sFromRepetitionLinkGroupNotesBox: e.target.value})
                    this.setState({blnTranslationEditBoxHasFocus: false})
                }} 
                />
                </div>
            }

            {!this.state.blnHideEverything && !this.state.blnConnectionsPresentationMode && this.state.sSelectedView === 'composite' && this.ShowingDevelopmentDiagram() && 
            <div>
                <>
                {/* {this.state.listLinkGroupTypesToShowForCompositeView.map(oLinkGroupType => 
                    <span title={oLinkGroupType.Help} style={{marginLeft:"10px", 
                    color: oLinkGroupType.Enabled || oLinkGroupType.Sticky ? 'hsl(0, 0%, 45%)' : 'hsl(0, 0%, 75%)',
                    // borderStyle: oLinkGroupType.Enabled || oLinkGroupType.Sticky ? "solid" : "none",
                    borderWidth: "1px",
                    userSelect: "none"}}
                    onClick={(event) => {
                        oLinkGroupType.Sticky = !oLinkGroupType.Sticky
                        this.setState({listLinkGroupTypesToShowForCompositeView: this.state.listLinkGroupTypesToShowForCompositeView}, () => {
                            if(this.ShowingDevelopmentDiagram())
                            {
                                this.GenerateDevelopmentDiagramForChapter(this.GetFirstCurrentChapter().toString(), this.state.sDevelopmentDiagramLanguage, this.GetLinesToDraw())
                            }
                        })
                    }}
                    onMouseEnter={(event) => this.ChangeEnabledForLinkGroupTypeToShowForCompositeView(oLinkGroupType, true)}
                    onMouseLeave={(event) => this.ChangeEnabledForLinkGroupTypeToShowForCompositeView(oLinkGroupType, false)}
                    >{oLinkGroupType.Abbr}</span>
                )} */}

                {this.state.listLenses.filter(l => l.LockedInComposite).map(l => this.GetSpanForLens(l))}

                {/* <span title='Show sound links'
                style={{marginLeft:"10px", 
                color: this.state.blnShowSoundInComposite ? 'hsl(0, 0%, 45%)' : 'hsl(0, 0%, 75%)',
                userSelect: "none"}}
                
                onClick={(event) => {
                    this.setState({blnShowSoundInComposite: !this.state.blnShowSoundInComposite}, this.GenerateDevelopmentDiagramForChapterIfShowing())
                }}
                >Snd</span> */}

                {this.state.listRecentLenses.map(l => this.GetSpanForLens(l))}
                </>
            </div>
            }

            {!this.state.blnHideEverything && !this.state.blnConnectionsPresentationMode && this.state.blnShowLenses && 
                !(this.listViewsToHideLensesForInDiagramMode.includes(this.state.sSelectedView) && this.ShowingDevelopmentDiagram()) && 
                !this.InSearchAndTagMode() &&
            <>
			<div>
				{this.state.listWordGroupsForEnabledLenses.length === 0 ? "" : ""}
                {this.UseLensVisibilityGroups() && <span onClick={(event) => this.setState({nLensVisibilityGroupShowing: this.state.nLensVisibilityGroupShowing === 0 ? 0 : this.state.nLensVisibilityGroupShowing -= 1})}><ChevronLeftIcon /></span>}
                {this.GetLensesForView().filter(l => { 
                    return (!this.UseLensVisibilityGroups() || l.VisibilityGroup === this.state.nLensVisibilityGroupShowing) && this.LensShouldBeShown(l)
                    }).map(l => this.GetSpanForLens(l))}
                {this.UseLensVisibilityGroups() && <span onClick={(event) => {
                    var nMaxLensVisibilityGroupShowing = Math.ceil(this.GetLensesForView().length / this.state.nLensVisibilityGroupSize) - 1;
                    this.setState({nLensVisibilityGroupShowing: this.state.nLensVisibilityGroupShowing >= nMaxLensVisibilityGroupShowing ? nMaxLensVisibilityGroupShowing : this.state.nLensVisibilityGroupShowing += 1})}}><ChevronRightIcon /></span>}
            </div>
			
			<Popover
				anchorEl={this.state.anchorForCorrespondenceCategorySelectionPopover}
				open={this.state.blnCorrespondenceCategorySelectionPopoverIsOpen}
				onClose={() => this.setState({ blnCorrespondenceCategorySelectionPopoverIsOpen: false})}>

				<Autocomplete multiple disableCloseOnSelect autoComplete clearOnBlur selectOnFocus
					options={this.listRepetitionLinkGroupCategories}
					value={this.state.listCorrespondenceCategoriesToShowInLens}
					getOptionLabel={(option) => option.Desc}
					groupBy={(option) => option.MainType}
					onChange={(event, newValue) => {
						var listToSet = newValue === "" || newValue === null ? undefined : newValue;
						//this.CorrespondenceLens(newValue);
						this.setState({listCorrespondenceCategoriesToShowInLens: listToSet});
					}} 
					style={{ width: 500 }}
					size="small"
					renderOption={(option, { selected }) => (
						<>
						  <Checkbox
							icon={icon}
							checkedIcon={checkedIcon}
							style={{ marginRight: 8 }}
							checked={selected}
						  />
						  {option.Desc}
						</>
					  )}
					renderInput={(params) => (
						<TextField {...params} variant="outlined" autoFocus/>
					)} 
					ListboxProps={
					{
						style:{
							maxHeight: '500px',
							//border: '1px solid red'
						}
					}
					}/> 
			</Popover>
			</>
			}

            {this.state.blnColorLinesByDevelopmentRepetitionGroup && this.state.sViewBy === "Development" && this.DrawDevelopmentDiagramThemeDescs()}
            </div>
            
            {/* {this.PatternLensIsEnabled() && this.state.sForPatternLineChartPopup != '' && 
            <div style={{fontFamily: "SBL Hebrew", fontSize:"20px"}}>
                {this.state.sForPatternLineChartPopup}
            </div>} */}

            {/* <TextField size="small" variant="outlined" label='Verse Ranges'
                value={this.state.sVerseRangesToHighlight} 
				// onChange={(event) => this.setState({sVerseRangesToHighlight: event.target.value})}
            /> */}

            {/* {this.blnDevView && this.blnPopulateAllChaptersAtLoad && this.BMEUnitDistributionChart()} */}
            {/* {this.blnDevView && this.blnPopulateAllChaptersAtLoad && this.MaxDistanceVsMinDifferencesChartForAllPsalms()}  */}
            {/* {this.blnDevView && this.blnPopulateAllChaptersAtLoad && this.NumberOfRepetitionsByPositionInLine()} */}
            

            {this.InSearchAndTagMode() && this.state.blnShowTagEditingControls && this.state.listSemanticGroupsForSearchAndTagSelectedForTagging.length > 0 && this.DrawTagEditingControls()}
            
            {this.state.blnColorLinesByDevelopmentRepetitionGroup && this.state.blnShowLineCharts && this.state.sViewBy === "Development" && this.GetDevelopmentDiagramThemeChart()}
			
            {this.LensTypeIsEnabled("consonantlinechart") && this.GetLetterLineChart(true)}
            {this.LensTypeIsEnabled("soundlinechart") && this.GetSoundLineChart(true)}
            {this.LensTypeIsEnabled("SoundGroupByUnitHeatmap") && this.GetSoundGroupByUnitHeatmap(false)}

            {this.LensTypeIsEnabled("RepeatedRootGroupByUnitHeatmap") && this.GetSemanticGroupByUnitHeatmap(true)}
            {this.LensTypeIsEnabled("SemanticGroupByUnitHeatmap") && this.GetSemanticGroupByUnitHeatmap(false)}
            
            {/* {this.state.blnShowLineCharts && this.LensTypeIsEnabled("letterintransliteration") && this.GetLetterLineChart(false)} */}

            {this.state.blnShowUnitRelationshipCharts && !this.SomeHoverCompareLensIsEnabled() && this.GetUnitRelationshipChart()}
            {this.state.blnShowLineCharts && !this.SomeHoverCompareLensIsEnabled() && !this.CadenceChangesLensIsEnabled() && 
                !this.AverageInterstressLengthPerLineIsEnabled() && !this.LensTypeIsEnabled('NumberOfSyllablesInLine') &&
                !this.SemanticChainsLensIsEnabled() && !this.LensTypeIsEnabled('NumberOfWordsInLine') &&
                !this.ConnectionsLensIsEnabled() &&
                !(this.ShowingDevelopmentDiagram() && this.LensTypeIsEnabled('reproots')) && 
                !this.DistanceForEachWordInAnyLinkGroupFromLastWordInAnyLinkGroupChartIsEnabled() &&
                !this.DistanceForEachWordInALinkGroupFromLastWordInThatLinkGroupChartIsEnabled() &&
                !this.MomentumChartIsEnabled() &&
                !this.LensTypeIsEnabled('FindLineSyllableCountThemes') &&
                !this.LensTypeIsEnabled("SoundGroupByUnitHeatmap") && 
                !this.LensTypeIsEnabled("RepeatedRootGroupByUnitHeatmap") && 
                !this.LensTypeIsEnabled("SemanticGroupByUnitHeatmap") && 
                !this.LensTypeIsEnabled('NumberOfSyllablesInLineIncreaseOrDecreaseChainsAllLines') &&
                !this.LensTypeIsEnabled('NumberOfSyllablesInLineIncreaseOrDecreaseChainsLevel1UnitBoundaries') &&
                (this.state.blnShowLineChartWhenSoundGroupLensIsEnabled || !this.WordsBySoundGroupLensIsEnabled()) &&
                this.GetLensLineChart()}

            {this.state.blnShowLineCharts && this.CadenceChangesLensIsEnabled() && this.GetCadenceChart()}
            {this.state.blnShowLineCharts && this.ShowingDevelopmentDiagram() && this.GetChartForDevelopmentDiagram()}
     
            {this.state.blnShowLineCharts && this.PaceAndRhythmLensCountByWordsIsEnabled() && this.GetPaceChart('words')}
            {this.state.blnShowLineCharts && this.PaceAndRhythmLensIsEnabled() && this.GetPaceChart('syllables')}
            
            {/* {this.state.blnShowLineCharts && this.CadenceChangesLensIsEnabled() && this.GetAverageCadenceValuesByVerseChart()} */}
            {this.state.blnShowLineCharts && this.SyllableRhymeLensIsEnabled() && this.GetSyllableRhymeMaximumAmountByVerseChart()}
            {this.state.blnShowLineCharts && this.WordRhymeLensIsEnabled() && this.GetCombinedRhymeMaximumAmountByVerseChart()}
            {this.state.blnShowLineCharts && this.LensTypeIsEnabled("handtaggedrhymegroups") && this.GetVowelDistributionForRhymeGroupsChart()}

            {/* {this.state.blnShowLineCharts && this.SemanticChainsLensIsEnabled() && this.GetSemanticChainsCharts()} */}

            {/* {this.state.blnShowLineCharts && this.LensTypeIsEnabled("mysemdom") && this.GetLensLineChart('mysem')}
            {this.state.blnShowLineCharts && this.LensTypeIsEnabled("sdbhlex") && this.GetLensLineChart('sdbhlex')}
            {this.state.blnShowLineCharts && this.LensTypeIsEnabled("sdbhcomposite") && this.GetLensLineChart('sdbhcomposite')} */}
            {this.state.blnShowLineCharts && this.PatternLensIsEnabled() && this.GetPatternLineChart()}

			{/* <div style={{
				// position: this.state.blnStickyHeader ? "-webkit-sticky" : "", 
				// position: this.state.blnStickyHeader ? "sticky" : "", 
				backgroundColor:"white", width:"100%", top:"0%", left: "1%"}}>
			{this.state.listGraphDataAndSettings.map(ds => this.ShowGraphFromData(ds))}
			</div> */}
			
			{ this.blnSemanticLinksDebugView &&
				<div>
				{this.listForSemanticDebugging.map(r => <div> {(r.Word1 === undefined ? "" : r.Word1.FullText + " ") + (r.Word2 === undefined ? "" : " " + r.Word2.FullText)  + " " + r.NodeToStartAt.Names + " -> " + r.NodeToFind.Names + ": " + 
					r.LinksTraversed.map(l => this.FindNodeByID(l.node1).Names + "-" + l.type + "-" + this.FindNodeByID(l.node2).Names).join(", ") + " (" + r.CurrentLinkDistance + ")"} </div>) }
				</div>
			}

			{/* {this.ShowYesNoForFindQuery()}
			{this.ShowQueryTextOutput()} */}
			{/* {this.ShowColorChart()} */}

            {this.NetworkShouldBeVisible() && 
			<div>
				<div style={{height:this.state.sNetworkDivHeight }} ref={this.networkDivRef} />
			</div>}

			{/* {this.NetworkShouldBeVisible() && 
			<div>
				<div style={{display: "inline-block"}}>
					<div>

					<FormControlLabel label="Mode" labelPlacement="start" control={
					<select style={{margin:"15px"}}
					onChange={(event) => this.setState({networkMode: event.target.value}, () => this.ShowNetworkGraph())}>
						<option value={'semanticnode'}>Semantic Nodes</option>
						<option value={'clause'}>Clauses</option>
						<option value={'line'}>Lines</option>
						<option value={'pgrp'}>Repetition Groups</option>
						<option value={'cluster'}>Clusters</option>
					</select>} />

					<FormControlLabel label="Connections" labelPlacement="start" control={
					<select multiple style={{margin:"15px"}}
					//defaultValue={initialValue}
					onChange={(event) => this.setState({listNetworkConnectionsToShow: [...event.target.options].filter(o => o.selected).map(o => o.value)}, () => this.ShowNetworkGraph())}>						
						<option value={'syn'}>Same Clause</option>
						<option value={'sameparticipant'}>Same Participant</option>
						<option value={'sem'}>Semantic</option>
						<option value={'phon'}>Phonological</option>
						<option value={'pgrp'}>Parallelism</option>
						<option value={'links'}>Tagged Links</option>
					</select>} />
					</div>
					<div>
						<FormControlLabel label="Minimum Shared Consonants" labelPlacement="start" style ={{marginLeft:"15px"}} control={			
						<input type="number" style ={{margin:"10px"}} defaultValue={4} min="2" max="10" size={1}
						onChange={(event) => this.setState({nMinSameConsonantsForNetworkPhonoLink: parseInt(event.target.value)}, () => this.ShowNetworkGraph())} />} />
						
						<FormControlLabel label="Max Semantic Distance" labelPlacement="start" style ={{marginLeft:"15px"}} control={			
						<input type="number" style ={{marginLeft:"10px"}} defaultValue={2} min="0" max="20" size={2}
						onChange={(event) => this.setState({nMaxLinkDistanceForNetworkSemanticLink: parseInt(event.target.value)}, () => this.ShowNetworkGraph())} />} />

						<FormControlLabel label="Translate" style ={{marginLeft:"15px"}} control={ 
							<Checkbox style={{marginLeft:"15px"}} onChange={(event) => this.setState({ blnTranslateNetworkNodes: event.target.checked}, () => this.ShowNetworkGraph())} checked={this.state.blnTranslateNetworkNodes} /> }/>
					</div>
				</div>

				<div style={{ height:this.state.sNetworkDivHeight }} ref={this.networkDivRef} />
			</div>} */}

			<Popover
				//id="mouse-over-popover"
				// className={classes.popover}
				// classes={{
				// paper: classes.paper,
				// }}
				open={this.state.blnHintPopoverIsOpen}
				onClose={() => this.setState({blnHintPopoverIsOpen: false}) }
				anchorEl={this.state.anchorForWordHintPopover}
				anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
				}}
				transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
				}}
				disableRestoreFocus
			>
				<span style={{margin:"15px", fontFamily: "SBL Hebrew", backgroundColor:"white"}}>{this.state.listInfoShow}</span> 
			</Popover>

            {this.state.sViewBy === "Development" && 
            <>

            <canvas ref={this.canvasRef} width={window.innerWidth - 50} height={window.innerHeight - 100} 
                onMouseMove={(event) => this.CanvasMouseMove(event)}
                onTouchMove={(event) => this.CanvasMouseMove(event)}

                onMouseDown={(event) => this.CanvasMouseDown(event)}
                onTouchStart={(event) => this.CanvasMouseDown(event)}

			    onMouseUp={(event) => this.CanvasMouseUp(event)}
			    onTouchEnd={(event) => this.CanvasMouseUp(event)}
            ></canvas>
            
            {/* {this.state.blnShowTranslationEditBox && this.DrawTranslationEditBox(20)} */}
            </>}

            {this.InThematicStatementsMode() && this.state.listThematicStatementsSelectedForSearch.length > 0 && this.DrawSearchResults()}
            {this.InSearchAndTagMode() && this.state.listSemanticGroupsForSearchAndTagSelectedForTagging.length > 0 && this.DrawSearchAndTagResults()}
            {this.InSearchTaggedDataMode() && this.state.listTagsSelectedForSearch.length > 0 && this.DrawSearchTaggedDataResults()}

			{this.state.sViewBy === "Line" && this.state.blnTextUnitSideBySideMode ? 
                this.GetLinesForSideBySideMode(this.GetLinesToDraw(), this.state.sGroupLinesBy).map(oLineGroup => this.DrawTextLines(oLineGroup)) :
            this.state.sViewBy === "Line" && !this.state.blnTextUnitSideBySideMode ? this.DrawTextLines({AbsoluteIndexOfFirstLineInGroup: 0, Lines: this.GetLinesToDraw()}) :
            this.state.sViewBy === "Verse" ? this.DrawVerses() :
            this.state.sViewBy === "Development" ? this.DrawDevelopmentDiagram() :
            this.state.sViewBy === "Clause" ? this.DrawClauses(this.listClauses) :
			this.state.sViewBy === "Proposition" ? this.DrawPropositionLines() :
            this.state.sViewBy === "Diagram" ? this.DrawAlignedClauses() :
            this.state.sViewBy === "ClausesByParticipant" ? this.DrawClausesByParticipant() :
            this.state.sViewBy === "ParticipantReferenceInteraction" ? this.DrawParticipantReferenceInteraction() :
            this.state.sViewBy === "Participants" ? this.DrawParticipants() :
            // this.state.sViewBy === "SemanticOutline" && this.DrawSemanticOutline() :

			(<div style={this.blnChapterIsHebrew ? {display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px', 
            width: !this.state.blnTextUnitSideBySideMode ? '100%' : this.state.blnShowHebrew && this.state.blnShowInterlinear ? '33%' : '20%'} :
            {display: "inline-block", verticalAlign:"top", textAlign:"center", paddingBottom: '20px'}}>
            	{this.GetSpansForWords(this.listTextWordsForChapter, false, false, false, false)}
			</div>)
			}

            {/* general tags  */}
            {this.state.blnShowGeneralTags && <div style={{display: "inline-block", verticalAlign:"top", textAlign:"left",
                minHeight: "700px", minWidth: "1000px",
                // borderStyle: "solid", borderWidth:"1px", 
                position: this.state.blnStickyHeader ? "-webkit-sticky" : "", 
                position: this.state.blnStickyHeader ? "sticky" : "", 
                top:"120px"}}

                onPaste={(event) => this.GetNodesFromTextData(event.clipboardData.getData('Text'))}
                onClick={(event) => {
                    if(event.shiftKey) this.AddTagInEditMode(this.GetEventCoordinates(event))}}
                
                onMouseUp={(event) => this.state.listTags.filter(o => o.IsMoving).
                    forEach(o => this.UpdateTagFieldValue(o, "IsMoving", false))}

                onMouseMove={(event) => { 
                    this.state.listTags.filter(o => o.IsMoving).
                        forEach(o => this.SetTagPosition(o, this.GetEventCoordinates(event)))}}>
                
                {this.DrawGeneralTags()}
                {this.DrawSemanticOutline()}
            </div>}

			{/* {this.DrawDiscourseUnits()} */}

			{/* {this.GetLinkLinesToShow()} */}
			
			{/* <div style={{display: "inline-block"}} ref={this.svgBoxRef}>
					<svg height={this.state.listLines.length * 33} width="500" style={{border:"1px solid black"}}>
					<defs>
					<linearGradient id="Gradient1">
						<stop class="stop1" offset="0%"/>
						<stop class="stop2" offset="50%"/>
						<stop class="stop3" offset="100%"/>
					</linearGradient>
					<linearGradient id="Gradient2" x1="0" x2="0" y1="0" y2="1">
						<stop offset="0%" stop-color="red"/>
						<stop offset="50%" stop-color="black" stop-opacity="0"/>
						<stop offset="100%" stop-color="blue"/>
					</linearGradient>
					
						</defs>
						<line x1="0" x2="50" y1="0" y2="75" stroke="orange" stroke-width="2"/>
						<line x1="0" x2="50" y1={this.state.hoveredWordRect === null || this.svgBoxRef.current === null ? "75" : this.state.hoveredWordRect.top - this.svgBoxRef.current.getBoundingClientRect().top} y2="75" stroke="orange" stroke-width="2"/>
						<line x1="0" x2="50" y1="150" y2="75" stroke="orange" stroke-width="2"/>
						<rect x="55" y="60" width="60" height="30" stroke="black" fill="transparent" stroke-width="2"/>
						<text x="60" y="80">Test</text>
					</svg>
				</div> */}
		</div>
		)
	}
}

function App() {
  return (
	<Chapter></Chapter>
  );
}

export default App;
	